var e1 = Object.defineProperty;
var $d = (e) => {
  throw TypeError(e);
};
var t1 = (e, t, n) => t in e ? e1(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var O = (e, t, n) => t1(e, typeof t != "symbol" ? t + "" : t, n), Yd = (e, t, n) => t.has(e) || $d("Cannot " + n);
var Ki = (e, t, n) => (Yd(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Qi = (e, t, n) => t.has(e) ? $d("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Xi = (e, t, n, r) => (Yd(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import * as y from "react";
import ct, { useMemo as pe, useReducer as n1, useLayoutEffect as xi, useRef as st, useState as we, useContext as Ct, createContext as Ot, useSyncExternalStore as r1, useDebugValue as i1, useEffect as Le, useCallback as de, memo as Ce, Fragment as Gd, useId as s1, forwardRef as ut, createElement as xc, Component as a1, useImperativeHandle as o1 } from "react";
import "@winnin/ds-modal/styles.css";
import { Modal as Ji } from "@winnin/ds-modal";
import { useTranslate as u1, useLanguage as c1 } from "@winnin/i18n";
import * as vo from "react-dom";
import l1 from "react-dom";
import { featureFlagsClient as qd } from "@winnin/feature-flags";
import { CreatorCard as ii } from "@winnin/ds-creator-card";
import "@winnin/ds-creator-card/styles.css";
import { VideoCard as si } from "@winnin/ds-video-card";
import "@winnin/ds-video-card/styles.css";
import { Icon as d1 } from "@winnin/ds-icon";
import { ColumnsChart as f1, LineChart as h1, SyncMultipleDonut as m1 } from "@winnin/ds-charts";
import { analyticsTracker as Kd } from "@winnin/analytics";
import { useHistory as Ep, useLocation as p1 } from "react-router-dom";
function pr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ca = { exports: {} }, la = {};
var Qd;
function g1() {
  if (Qd) return la;
  Qd = 1;
  var e = /* @__PURE__ */ Symbol.for("react.fragment");
  return la.Fragment = e, la.jsxDEV = void 0, la;
}
var da = {};
var Xd;
function b1() {
  return Xd || (Xd = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = ct, t = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.portal"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = /* @__PURE__ */ Symbol.for("react.strict_mode"), s = /* @__PURE__ */ Symbol.for("react.profiler"), a = /* @__PURE__ */ Symbol.for("react.provider"), o = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), c = /* @__PURE__ */ Symbol.for("react.suspense"), l = /* @__PURE__ */ Symbol.for("react.suspense_list"), d = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), m = /* @__PURE__ */ Symbol.for("react.offscreen"), E = Symbol.iterator, g = "@@iterator";
    function T(P) {
      if (P === null || typeof P != "object")
        return null;
      var te = E && P[E] || P[g];
      return typeof te == "function" ? te : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(P) {
      {
        for (var te = arguments.length, C = new Array(te > 1 ? te - 1 : 0), Y = 1; Y < te; Y++)
          C[Y - 1] = arguments[Y];
        w("error", P, C);
      }
    }
    function w(P, te, C) {
      {
        var Y = _.ReactDebugCurrentFrame, ee = Y.getStackAddendum();
        ee !== "" && (te += "%s", C = C.concat([ee]));
        var ce = C.map(function(ge) {
          return String(ge);
        });
        ce.unshift("Warning: " + te), Function.prototype.apply.call(console[P], console, ce);
      }
    }
    var M = !1, F = !1, k = !1, B = !1, $ = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function U(P) {
      return !!(typeof P == "string" || typeof P == "function" || P === r || P === s || $ || P === i || P === c || P === l || B || P === m || M || F || k || typeof P == "object" && P !== null && (P.$$typeof === h || P.$$typeof === d || P.$$typeof === a || P.$$typeof === o || P.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      P.$$typeof === J || P.getModuleId !== void 0));
    }
    function re(P, te, C) {
      var Y = P.displayName;
      if (Y)
        return Y;
      var ee = te.displayName || te.name || "";
      return ee !== "" ? C + "(" + ee + ")" : C;
    }
    function ae(P) {
      return P.displayName || "Context";
    }
    function j(P) {
      if (P == null)
        return null;
      if (typeof P.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof P == "function")
        return P.displayName || P.name || null;
      if (typeof P == "string")
        return P;
      switch (P) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case o:
            var te = P;
            return ae(te) + ".Consumer";
          case a:
            var C = P;
            return ae(C._context) + ".Provider";
          case u:
            return re(P, P.render, "ForwardRef");
          case d:
            var Y = P.displayName || null;
            return Y !== null ? Y : j(P.type) || "Memo";
          case h: {
            var ee = P, ce = ee._payload, ge = ee._init;
            try {
              return j(ge(ce));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, z = 0, W, X, G, se, N, ye, Re;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function Ie() {
      {
        if (z === 0) {
          W = console.log, X = console.info, G = console.warn, se = console.error, N = console.group, ye = console.groupCollapsed, Re = console.groupEnd;
          var P = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: P,
            log: P,
            warn: P,
            error: P,
            group: P,
            groupCollapsed: P,
            groupEnd: P
          });
        }
        z++;
      }
    }
    function De() {
      {
        if (z--, z === 0) {
          var P = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, P, {
              value: W
            }),
            info: H({}, P, {
              value: X
            }),
            warn: H({}, P, {
              value: G
            }),
            error: H({}, P, {
              value: se
            }),
            group: H({}, P, {
              value: N
            }),
            groupCollapsed: H({}, P, {
              value: ye
            }),
            groupEnd: H({}, P, {
              value: Re
            })
          });
        }
        z < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var He = _.ReactCurrentDispatcher, fe;
    function Te(P, te, C) {
      {
        if (fe === void 0)
          try {
            throw Error();
          } catch (ee) {
            var Y = ee.stack.trim().match(/\n( *(at )?)/);
            fe = Y && Y[1] || "";
          }
        return `
` + fe + P;
      }
    }
    var Ne = !1, _e;
    {
      var Se = typeof WeakMap == "function" ? WeakMap : Map;
      _e = new Se();
    }
    function Me(P, te) {
      if (!P || Ne)
        return "";
      {
        var C = _e.get(P);
        if (C !== void 0)
          return C;
      }
      var Y;
      Ne = !0;
      var ee = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ce;
      ce = He.current, He.current = null, Ie();
      try {
        if (te) {
          var ge = function() {
            throw Error();
          };
          if (Object.defineProperty(ge.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ge, []);
            } catch (lt) {
              Y = lt;
            }
            Reflect.construct(P, [], ge);
          } else {
            try {
              ge.call();
            } catch (lt) {
              Y = lt;
            }
            P.call(ge.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (lt) {
            Y = lt;
          }
          P();
        }
      } catch (lt) {
        if (lt && Y && typeof lt.stack == "string") {
          for (var be = lt.stack.split(`
`), ke = Y.stack.split(`
`), Ae = be.length - 1, We = ke.length - 1; Ae >= 1 && We >= 0 && be[Ae] !== ke[We]; )
            We--;
          for (; Ae >= 1 && We >= 0; Ae--, We--)
            if (be[Ae] !== ke[We]) {
              if (Ae !== 1 || We !== 1)
                do
                  if (Ae--, We--, We < 0 || be[Ae] !== ke[We]) {
                    var Ye = `
` + be[Ae].replace(" at new ", " at ");
                    return P.displayName && Ye.includes("<anonymous>") && (Ye = Ye.replace("<anonymous>", P.displayName)), typeof P == "function" && _e.set(P, Ye), Ye;
                  }
                while (Ae >= 1 && We >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, He.current = ce, De(), Error.prepareStackTrace = ee;
      }
      var nt = P ? P.displayName || P.name : "", ht = nt ? Te(nt) : "";
      return typeof P == "function" && _e.set(P, ht), ht;
    }
    function Ze(P, te, C) {
      return Me(P, !1);
    }
    function Et(P) {
      var te = P.prototype;
      return !!(te && te.isReactComponent);
    }
    function kt(P, te, C) {
      if (P == null)
        return "";
      if (typeof P == "function")
        return Me(P, Et(P));
      if (typeof P == "string")
        return Te(P);
      switch (P) {
        case c:
          return Te("Suspense");
        case l:
          return Te("SuspenseList");
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case u:
            return Ze(P.render);
          case d:
            return kt(P.type, te, C);
          case h: {
            var Y = P, ee = Y._payload, ce = Y._init;
            try {
              return kt(ce(ee), te, C);
            } catch {
            }
          }
        }
      return "";
    }
    var _t = Object.prototype.hasOwnProperty, tn = {}, Nr = _.ReactDebugCurrentFrame;
    function nn(P) {
      if (P) {
        var te = P._owner, C = kt(P.type, P._source, te ? te.type : null);
        Nr.setExtraStackFrame(C);
      } else
        Nr.setExtraStackFrame(null);
    }
    function ti(P, te, C, Y, ee) {
      {
        var ce = Function.call.bind(_t);
        for (var ge in P)
          if (ce(P, ge)) {
            var be = void 0;
            try {
              if (typeof P[ge] != "function") {
                var ke = Error((Y || "React class") + ": " + C + " type `" + ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof P[ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ke.name = "Invariant Violation", ke;
              }
              be = P[ge](te, ge, Y, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ae) {
              be = Ae;
            }
            be && !(be instanceof Error) && (nn(ee), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Y || "React class", C, ge, typeof be), nn(null)), be instanceof Error && !(be.message in tn) && (tn[be.message] = !0, nn(ee), A("Failed %s type: %s", C, be.message), nn(null));
          }
      }
    }
    var Vi = Array.isArray;
    function Mn(P) {
      return Vi(P);
    }
    function Wi(P) {
      {
        var te = typeof Symbol == "function" && Symbol.toStringTag, C = te && P[Symbol.toStringTag] || P.constructor.name || "Object";
        return C;
      }
    }
    function $i(P) {
      try {
        return vr(P), !1;
      } catch {
        return !0;
      }
    }
    function vr(P) {
      return "" + P;
    }
    function Q(P) {
      if ($i(P))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Wi(P)), vr(P);
    }
    var K = _.ReactCurrentOwner, he = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ue, $e, ft;
    ft = {};
    function un(P) {
      if (_t.call(P, "ref")) {
        var te = Object.getOwnPropertyDescriptor(P, "ref").get;
        if (te && te.isReactWarning)
          return !1;
      }
      return P.ref !== void 0;
    }
    function Yt(P) {
      if (_t.call(P, "key")) {
        var te = Object.getOwnPropertyDescriptor(P, "key").get;
        if (te && te.isReactWarning)
          return !1;
      }
      return P.key !== void 0;
    }
    function Un(P, te) {
      if (typeof P.ref == "string" && K.current && te && K.current.stateNode !== te) {
        var C = j(K.current.type);
        ft[C] || (A('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(K.current.type), P.ref), ft[C] = !0);
      }
    }
    function Hn(P, te) {
      {
        var C = function() {
          Ue || (Ue = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
        };
        C.isReactWarning = !0, Object.defineProperty(P, "key", {
          get: C,
          configurable: !0
        });
      }
    }
    function yt(P, te) {
      {
        var C = function() {
          $e || ($e = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
        };
        C.isReactWarning = !0, Object.defineProperty(P, "ref", {
          get: C,
          configurable: !0
        });
      }
    }
    var xn = function(P, te, C, Y, ee, ce, ge) {
      var be = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: P,
        key: te,
        ref: C,
        props: ge,
        // Record the component responsible for creating this element.
        _owner: ce
      };
      return be._store = {}, Object.defineProperty(be._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(be, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.defineProperty(be, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ee
      }), Object.freeze && (Object.freeze(be.props), Object.freeze(be)), be;
    };
    function Ut(P, te, C, Y, ee) {
      {
        var ce, ge = {}, be = null, ke = null;
        C !== void 0 && (Q(C), be = "" + C), Yt(te) && (Q(te.key), be = "" + te.key), un(te) && (ke = te.ref, Un(te, ee));
        for (ce in te)
          _t.call(te, ce) && !he.hasOwnProperty(ce) && (ge[ce] = te[ce]);
        if (P && P.defaultProps) {
          var Ae = P.defaultProps;
          for (ce in Ae)
            ge[ce] === void 0 && (ge[ce] = Ae[ce]);
        }
        if (be || ke) {
          var We = typeof P == "function" ? P.displayName || P.name || "Unknown" : P;
          be && Hn(ge, We), ke && yt(ge, We);
        }
        return xn(P, be, ke, ee, Y, K.current, ge);
      }
    }
    var ni = _.ReactCurrentOwner, jn = _.ReactDebugCurrentFrame;
    function Tn(P) {
      if (P) {
        var te = P._owner, C = kt(P.type, P._source, te ? te.type : null);
        jn.setExtraStackFrame(C);
      } else
        jn.setExtraStackFrame(null);
    }
    var wr;
    wr = !1;
    function ri(P) {
      return typeof P == "object" && P !== null && P.$$typeof === t;
    }
    function ra() {
      {
        if (ni.current) {
          var P = j(ni.current.type);
          if (P)
            return `

Check the render method of \`` + P + "`.";
        }
        return "";
      }
    }
    function ia(P) {
      {
        if (P !== void 0) {
          var te = P.fileName.replace(/^.*[\\\/]/, ""), C = P.lineNumber;
          return `

Check your code at ` + te + ":" + C + ".";
        }
        return "";
      }
    }
    var sa = {};
    function aa(P) {
      {
        var te = ra();
        if (!te) {
          var C = typeof P == "string" ? P : P.displayName || P.name;
          C && (te = `

Check the top-level render call using <` + C + ">.");
        }
        return te;
      }
    }
    function Yi(P, te) {
      {
        if (!P._store || P._store.validated || P.key != null)
          return;
        P._store.validated = !0;
        var C = aa(te);
        if (sa[C])
          return;
        sa[C] = !0;
        var Y = "";
        P && P._owner && P._owner !== ni.current && (Y = " It was passed a child from " + j(P._owner.type) + "."), Tn(P), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', C, Y), Tn(null);
      }
    }
    function oa(P, te) {
      {
        if (typeof P != "object")
          return;
        if (Mn(P))
          for (var C = 0; C < P.length; C++) {
            var Y = P[C];
            ri(Y) && Yi(Y, te);
          }
        else if (ri(P))
          P._store && (P._store.validated = !0);
        else if (P) {
          var ee = T(P);
          if (typeof ee == "function" && ee !== P.entries)
            for (var ce = ee.call(P), ge; !(ge = ce.next()).done; )
              ri(ge.value) && Yi(ge.value, te);
        }
      }
    }
    function gu(P) {
      {
        var te = P.type;
        if (te == null || typeof te == "string")
          return;
        var C;
        if (typeof te == "function")
          C = te.propTypes;
        else if (typeof te == "object" && (te.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        te.$$typeof === d))
          C = te.propTypes;
        else
          return;
        if (C) {
          var Y = j(te);
          ti(C, P.props, "prop", Y, P);
        } else if (te.PropTypes !== void 0 && !wr) {
          wr = !0;
          var ee = j(te);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ee || "Unknown");
        }
        typeof te.getDefaultProps == "function" && !te.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ua(P) {
      {
        for (var te = Object.keys(P.props), C = 0; C < te.length; C++) {
          var Y = te[C];
          if (Y !== "children" && Y !== "key") {
            Tn(P), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Y), Tn(null);
            break;
          }
        }
        P.ref !== null && (Tn(P), A("Invalid attribute `ref` supplied to `React.Fragment`."), Tn(null));
      }
    }
    var Gi = {};
    function bu(P, te, C, Y, ee, ce) {
      {
        var ge = U(P);
        if (!ge) {
          var be = "";
          (P === void 0 || typeof P == "object" && P !== null && Object.keys(P).length === 0) && (be += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ke = ia(ee);
          ke ? be += ke : be += ra();
          var Ae;
          P === null ? Ae = "null" : Mn(P) ? Ae = "array" : P !== void 0 && P.$$typeof === t ? (Ae = "<" + (j(P.type) || "Unknown") + " />", be = " Did you accidentally export a JSX literal instead of a component?") : Ae = typeof P, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ae, be);
        }
        var We = Ut(P, te, C, ee, ce);
        if (We == null)
          return We;
        if (ge) {
          var Ye = te.children;
          if (Ye !== void 0)
            if (Y)
              if (Mn(Ye)) {
                for (var nt = 0; nt < Ye.length; nt++)
                  oa(Ye[nt], P);
                Object.freeze && Object.freeze(Ye);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              oa(Ye, P);
        }
        if (_t.call(te, "key")) {
          var ht = j(P), lt = Object.keys(te).filter(function(qi) {
            return qi !== "key";
          }), cn = lt.length > 0 ? "{key: someKey, " + lt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Gi[ht + cn]) {
            var It = lt.length > 0 ? "{" + lt.join(": ..., ") + ": ...}" : "{}";
            A(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, cn, ht, It, ht), Gi[ht + cn] = !0;
          }
        }
        return P === r ? ua(We) : gu(We), We;
      }
    }
    var Eu = bu;
    da.Fragment = r, da.jsxDEV = Eu;
  })()), da;
}
var Jd;
function E1() {
  return Jd || (Jd = 1, process.env.NODE_ENV === "production" ? ca.exports = g1() : ca.exports = b1()), ca.exports;
}
var p = E1();
function Zd(e) {
  const t = [];
  for (const n of e.effectTasks)
    try {
      n();
    } catch (r) {
      t.push(r);
    }
  if (t.length > 0) {
    if (t.length === 1)
      throw t[0];
    for (const n of t)
      console.error(n);
    throw new AggregateError(t, "Errors during commit");
  }
}
function _p(e) {
  const t = [];
  for (const n of e.cells)
    if (n?.type === "effect" && (n.deps = null, n.cleanup))
      try {
        n.cleanup?.();
      } catch (r) {
        t.push(r);
      } finally {
        n.cleanup = void 0;
      }
  if (t.length > 0) {
    if (t.length === 1)
      throw t[0];
    for (const n of t)
      console.error(n);
    throw new AggregateError(t, "Errors during cleanup");
  }
}
const Yn = typeof process < "u" && (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test");
let Ur = null;
function _1(e, t) {
  e.currentIndex = 0;
  const n = Ur;
  Ur = e;
  try {
    if (t(), e.isFirstRender = !1, e.cells.length !== e.currentIndex)
      throw new Error(`Rendered ${e.currentIndex} hooks but expected ${e.cells.length}. Hooks must be called in the exact same order in every render.`);
  } finally {
    Ur = n;
  }
}
function lr() {
  if (!Ur)
    throw new Error("No resource fiber available");
  return Ur;
}
function x1(e) {
  return Yn ? Ur?.devStrictMode ? Ur.isFirstRender ? "child" : "root" : e ? "root" : null : null;
}
function T1(e, t) {
  const n = e[xp];
  if (!n)
    throw new Error("ResourceElement.type is not a valid Resource");
  return n(t);
}
const xp = /* @__PURE__ */ Symbol("fnSymbol");
function Cs(e, t, n = void 0, r = x1(!1)) {
  return {
    type: e,
    root: t,
    markDirty: n,
    devStrictMode: r,
    cells: [],
    currentIndex: 0,
    renderContext: void 0,
    isFirstRender: !0,
    isMounted: !1,
    isNeverMounted: !0
  };
}
function gi(e) {
  if (!e.isMounted)
    throw new Error("Tried to unmount a fiber that is already unmounted");
  e.isMounted = !1, _p(e);
}
function Wn(e, t) {
  const n = {
    effectTasks: [],
    props: t,
    output: void 0
  };
  return _1(e, () => {
    e.renderContext = n;
    try {
      n.output = T1(e.type, t);
    } finally {
      e.renderContext = void 0;
    }
  }), n;
}
function Ti(e, t) {
  e.isMounted = !0, Yn && e.isNeverMounted && e.devStrictMode === "root" && (e.isNeverMounted = !1, Zd(t), _p(e)), e.isNeverMounted = !1, Zd(t);
}
const Tp = (e) => ({
  version: 0,
  committedVersion: 0,
  dispatchUpdate: e,
  changelog: [],
  dirtyCells: []
}), Za = (e) => {
  for (const t of e.dirtyCells)
    t.dirty = !1, t.queue.clear(), t.current = t.workInProgress;
  e.committedVersion = e.version, e.changelog.length = 0, e.dirtyCells.length = 0;
}, hs = (e, t) => {
  const n = e.version > t;
  if (e.version = t, n) {
    for (const r of e.dirtyCells)
      r.dirty = !1, r.queue.clear(), r.workInProgress = r.current;
    if (e.dirtyCells.length = 0, t === e.committedVersion)
      e.changelog.length = 0;
    else {
      if (e.committedVersion > t)
        throw new Error("Version is less than committed version");
      for (; e.committedVersion + e.changelog.length > t; )
        e.changelog.pop();
      e.changelog.forEach((r) => r()), Za(e);
    }
  }
}, ef = (e, t) => {
  t.dirty || (t.dirty = !0, e.markDirty?.(), e.root.dirtyCells.push(t));
}, A1 = () => {
  if (!Yn)
    return null;
  const e = st(0), t = e.current === 0;
  return we(() => e.current++), e.current !== 2 ? null : t ? "child" : "root";
};
function y1(e) {
  const t = pe(() => Tp((o) => r(o)), []), [n, r] = n1((o, u) => (hs(t, o), o + (u() ? 1 : 0)), 0);
  hs(t, n);
  const i = A1(), s = pe(() => (e.key, Cs(e.type, t, void 0, i)), [e.type, e.key, t, i]), a = Wn(s, e.props);
  return xi(() => () => gi(s), [s]), xi(() => {
    Za(t), Ti(s, a);
  }), a.output;
}
function Xe(e) {
  const t = (n) => ({
    type: t,
    props: n
  });
  return t[xp] = e, t;
}
function Gn(e, t) {
  return { ...t, key: e };
}
const Ap = (e, t) => {
  const n = lr(), r = n.currentIndex++;
  if (!n.isFirstRender && r >= n.cells.length)
    throw new Error("Rendered more hooks than during the previous render. Hooks must be called in the exact same order in every render.");
  let i = n.cells[r];
  if (i || (i = t(), n.cells[r] = i), i.type !== e)
    throw new Error("Hook order changed between renders");
  return i;
}, N1 = (e) => {
  lr().renderContext.effectTasks.push(e);
}, v1 = (e, t) => {
  if (e.renderContext)
    throw new Error("Resource updated during render");
  if (e.isNeverMounted)
    throw new Error("Resource updated before mount");
  e.root.dispatchUpdate(() => {
    const n = t();
    return n ? (n(), e.root.changelog.push(n), !0) : !1;
  });
};
function yp(e, t, n, r) {
  const i = Ap("reducer", () => {
    const o = lr(), u = r ? r(n) : n;
    return Yn && o.devStrictMode && r && r(n), {
      type: "reducer",
      queue: /* @__PURE__ */ new Set(),
      dirty: !1,
      workInProgress: u,
      current: u,
      reducer: e,
      dispatch: (c) => {
        const l = {
          action: c,
          hasEagerState: !1,
          eagerState: void 0
        };
        v1(o, () => o.root.dirtyCells.length === 0 && !l.hasEagerState && (l.eagerState = e(i.workInProgress, c), l.hasEagerState = !0, Object.is(i.current, l.eagerState)) ? null : () => {
          ef(o, i), i.queue.add(l);
        });
      }
    };
  }), s = lr(), a = e === i.reducer;
  i.reducer = e;
  for (const o of i.queue)
    (!o.hasEagerState || !a) && (o.eagerState = e(i.workInProgress, o.action), o.hasEagerState = !0), Yn && s.devStrictMode && e(i.workInProgress, o.action), i.workInProgress = o.eagerState;
  if (i.queue.clear(), t) {
    const o = t(i.workInProgress);
    Object.is(o, i.workInProgress) || (ef(s, i), i.workInProgress = o);
  }
  return [i.workInProgress, i.dispatch];
}
function w1(e, t, n) {
  return yp(e, void 0, t, n);
}
function C1(e, t, n, r) {
  return yp(e, t, n, r);
}
const S1 = (e, t) => typeof t == "function" ? t(e) : t, k1 = (e) => typeof e == "function" ? e() : e;
function In(e) {
  return w1(S1, e, k1);
}
const Np = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!Object.is(e[n], t[n]))
      return !1;
  return !0;
}, I1 = () => ({
  type: "effect",
  cleanup: void 0,
  deps: null
  // null means the effect has never been run
});
function wt(e, t) {
  const n = Ap("effect", I1);
  if (!(t && n.deps && Np(n.deps, t))) {
    if (n.deps !== null && !!t != !!n.deps)
      throw new Error("tapEffect called with and without dependencies across re-renders");
    N1(() => {
      const r = [];
      try {
        n.cleanup?.();
      } catch (i) {
        r.push(i);
      } finally {
        n.cleanup = void 0;
      }
      try {
        const i = e();
        if (i !== void 0 && typeof i != "function")
          throw new Error(`An effect function must either return a cleanup function or nothing. Received: ${typeof i}`);
        n.cleanup = i;
      } catch (i) {
        r.push(i);
      }
      if (n.deps = t, r.length > 0) {
        if (r.length === 1)
          throw r[0];
        for (const i of r)
          console.error(i);
        throw new AggregateError(r, "Errors during commit");
      }
    });
  }
}
function or(e) {
  const [t] = In(() => ({
    current: e
  }));
  return t;
}
function Hr(e, t) {
  const [n] = In(e);
  return n;
}
const D1 = () => {
  throw new Error("Memo reducer should not be called");
}, qe = (e, t) => {
  const n = lr(), [r] = C1(D1, (i) => {
    if (i && Np(i.deps, t))
      return i;
    const s = e();
    return Yn && n.devStrictMode && e(), { value: s, deps: t };
  }, null);
  return r.value;
}, wo = (e, t) => qe(() => e, t);
function fl(e) {
  const t = or(e);
  if (wt(() => {
    t.current = e;
  }), Yn) {
    const n = lr();
    return wo(((...r) => {
      if (n.renderContext)
        throw new Error("tapEffectEvent cannot be called during render");
      return t.current(...r);
    }), [n]);
  }
  return t.current;
}
function Jt(e, t) {
  const n = lr(), r = or(0), i = qe(() => (e.key, Cs(e.type, n.root, () => {
    r.current++, n.markDirty?.();
  })), [e.type, e.key, n]), s = t ? (
    // biome-ignore lint/correctness/useExhaustiveDependencies: user provided deps instead of prop identity
    qe(() => Wn(i, e.props), [i, ...t, r.current])
  ) : Wn(i, e.props);
  return wt(() => () => gi(i), [i]), wt(() => {
    Ti(i, s);
  }, [i, s]), s.output;
}
function hl(e, t) {
  const n = or(0), r = n.current, i = Hr(lr), s = Hr(() => () => {
    n.current++, i.markDirty?.();
  }), a = Hr(() => /* @__PURE__ */ new Map()), o = t ? (
    // biome-ignore lint/correctness/useExhaustiveDependencies: library code
    wo(e, t)
  ) : e, u = qe(() => {
    const c = o(), l = /* @__PURE__ */ new Set(), d = [];
    let h = 0;
    for (let m = 0; m < c.length; m++) {
      const E = c[m], g = E.key;
      if (g === void 0)
        throw new Error(`tapResources did not provide a key for array at index ${m}`);
      if (l.has(g))
        throw new Error(`Duplicate key ${g} in tapResources`);
      l.add(g);
      let T = a.get(g);
      if (T)
        if (T.fiber.type !== E.type) {
          const _ = Cs(E.type, i.root, s), A = Wn(_, E.props);
          T.next = [_, A], d.push(A.output);
        } else
          T.next = Wn(T.fiber, E.props), d.push(T.next.output);
      else {
        const _ = Cs(E.type, i.root, s), A = Wn(_, E.props);
        T = {
          fiber: _,
          next: A
        }, h++, a.set(g, T), d.push(A.output);
      }
    }
    if (a.size > d.length - h)
      for (const m of a.keys())
        l.has(m) || (a.get(m).next = "delete");
    return d;
  }, [o, r]);
  return wt(() => () => {
    for (const c of a.keys()) {
      const l = a.get(c).fiber;
      gi(l);
    }
  }, []), wt(() => {
    for (const [c, l] of a.entries())
      l.next === "delete" ? (l.fiber.isMounted && gi(l.fiber), a.delete(c)) : Array.isArray(l.next) ? (gi(l.fiber), l.fiber = l.next[0], Ti(l.fiber, l.next[1])) : Ti(l.fiber, l.next);
  }, [u]), u;
}
const R1 = 50;
let Cn = {
  schedulers: /* @__PURE__ */ new Set([]),
  isScheduled: !1
};
class P1 {
  constructor(t) {
    O(this, "_task");
    O(this, "_isDirty", !1);
    this._task = t;
  }
  get isDirty() {
    return this._isDirty;
  }
  markDirty() {
    this._isDirty = !0, Cn.schedulers.add(this), O1();
  }
  runTask() {
    this._isDirty = !1, this._task();
  }
}
const O1 = () => {
  Cn.isScheduled || (Cn.isScheduled = !0, L1());
}, Tc = () => {
  try {
    const e = [];
    let t = 0;
    for (const n of Cn.schedulers)
      if (Cn.schedulers.delete(n), !!n.isDirty) {
        if (t++, t > R1)
          throw new Error("Maximum update depth exceeded. This can happen when a resource repeatedly calls setState inside tapEffect.");
        try {
          n.runTask();
        } catch (r) {
          e.push(r);
        }
      }
    if (e.length > 0) {
      if (e.length === 1)
        throw e[0];
      for (const n of e)
        console.error(n);
      throw new AggregateError(e, "Errors occurred during flushSync");
    }
  } finally {
    Cn.schedulers.clear(), Cn.isScheduled = !1;
  }
}, L1 = (() => {
  if (typeof MessageChannel < "u") {
    const e = new MessageChannel();
    return e.port1.onmessage = Tc, () => e.port2.postMessage(null);
  }
  return () => setTimeout(Tc, 0);
})(), M1 = (e) => {
  const t = Cn;
  Cn = {
    schedulers: /* @__PURE__ */ new Set([]),
    isScheduled: !0
  };
  try {
    const n = e();
    return Tc(), n;
  } finally {
    Cn = t;
  }
}, U1 = (e) => {
  const t = Hr(() => new P1(() => c(null))), n = Hr(() => []), r = qe(() => (e.key, Cs(e.type, Tp((l) => {
    !t.isDirty && !l() || (n.push(l), t.markDirty());
  }))), [e.type, e.key]);
  hs(r.root, r.root.committedVersion);
  const i = Wn(r, e.props), s = or(!1), a = or(e.props), o = or(i.output), u = Hr(() => /* @__PURE__ */ new Set()), c = fl((l) => {
    if (l === null && (hs(r.root, 2), hs(r.root, 1), n.forEach((d) => {
      Yn && r.devStrictMode && d(), d();
    }), Yn && r.devStrictMode && Wn(r, a.current), l = Wn(r, a.current)), t.isDirty)
      throw new Error("Scheduler is dirty, this should never happen");
    Za(r.root), n.length = 0, s.current && Ti(r, l), !(t.isDirty || o.current === l.output) && (o.current = l.output, u.forEach((d) => d()));
  });
  return wt(() => (s.current = !0, () => {
    s.current = !1, gi(r);
  }), [r]), wt(() => {
    a.current = i.props, Za(r.root), Ti(r, i), !(t.isDirty || o.current === i.output) && (o.current = i.output, u.forEach((l) => l()));
  }), qe(() => ({
    getValue: () => o.current,
    subscribe: (l) => (u.add(l), () => u.delete(l))
  }), []);
}, ms = /* @__PURE__ */ Symbol("tap.Context"), vp = (e) => ({
  [ms]: e
}), wp = (e, t, n) => {
  const r = e[ms];
  e[ms] = t;
  try {
    return n();
  } finally {
    e[ms] = r;
  }
}, Cp = (e) => e[ms];
var fa = { exports: {} }, Zi = {};
var tf;
function H1() {
  if (tf) return Zi;
  tf = 1;
  var e = ct, t = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, u, c) {
    var l, d = {}, h = null, m = null;
    c !== void 0 && (h = "" + c), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (m = u.ref);
    for (l in u) r.call(u, l) && !s.hasOwnProperty(l) && (d[l] = u[l]);
    if (o && o.defaultProps) for (l in u = o.defaultProps, u) d[l] === void 0 && (d[l] = u[l]);
    return { $$typeof: t, type: o, key: h, ref: m, props: d, _owner: i.current };
  }
  return Zi.Fragment = n, Zi.jsx = a, Zi.jsxs = a, Zi;
}
var es = {};
var nf;
function j1() {
  return nf || (nf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = ct, t = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.portal"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = /* @__PURE__ */ Symbol.for("react.strict_mode"), s = /* @__PURE__ */ Symbol.for("react.profiler"), a = /* @__PURE__ */ Symbol.for("react.provider"), o = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), c = /* @__PURE__ */ Symbol.for("react.suspense"), l = /* @__PURE__ */ Symbol.for("react.suspense_list"), d = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), m = /* @__PURE__ */ Symbol.for("react.offscreen"), E = Symbol.iterator, g = "@@iterator";
    function T(C) {
      if (C === null || typeof C != "object")
        return null;
      var Y = E && C[E] || C[g];
      return typeof Y == "function" ? Y : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(C) {
      {
        for (var Y = arguments.length, ee = new Array(Y > 1 ? Y - 1 : 0), ce = 1; ce < Y; ce++)
          ee[ce - 1] = arguments[ce];
        w("error", C, ee);
      }
    }
    function w(C, Y, ee) {
      {
        var ce = _.ReactDebugCurrentFrame, ge = ce.getStackAddendum();
        ge !== "" && (Y += "%s", ee = ee.concat([ge]));
        var be = ee.map(function(ke) {
          return String(ke);
        });
        be.unshift("Warning: " + Y), Function.prototype.apply.call(console[C], console, be);
      }
    }
    var M = !1, F = !1, k = !1, B = !1, $ = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function U(C) {
      return !!(typeof C == "string" || typeof C == "function" || C === r || C === s || $ || C === i || C === c || C === l || B || C === m || M || F || k || typeof C == "object" && C !== null && (C.$$typeof === h || C.$$typeof === d || C.$$typeof === a || C.$$typeof === o || C.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      C.$$typeof === J || C.getModuleId !== void 0));
    }
    function re(C, Y, ee) {
      var ce = C.displayName;
      if (ce)
        return ce;
      var ge = Y.displayName || Y.name || "";
      return ge !== "" ? ee + "(" + ge + ")" : ee;
    }
    function ae(C) {
      return C.displayName || "Context";
    }
    function j(C) {
      if (C == null)
        return null;
      if (typeof C.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof C == "function")
        return C.displayName || C.name || null;
      if (typeof C == "string")
        return C;
      switch (C) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case o:
            var Y = C;
            return ae(Y) + ".Consumer";
          case a:
            var ee = C;
            return ae(ee._context) + ".Provider";
          case u:
            return re(C, C.render, "ForwardRef");
          case d:
            var ce = C.displayName || null;
            return ce !== null ? ce : j(C.type) || "Memo";
          case h: {
            var ge = C, be = ge._payload, ke = ge._init;
            try {
              return j(ke(be));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, z = 0, W, X, G, se, N, ye, Re;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function Ie() {
      {
        if (z === 0) {
          W = console.log, X = console.info, G = console.warn, se = console.error, N = console.group, ye = console.groupCollapsed, Re = console.groupEnd;
          var C = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: C,
            log: C,
            warn: C,
            error: C,
            group: C,
            groupCollapsed: C,
            groupEnd: C
          });
        }
        z++;
      }
    }
    function De() {
      {
        if (z--, z === 0) {
          var C = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, C, {
              value: W
            }),
            info: H({}, C, {
              value: X
            }),
            warn: H({}, C, {
              value: G
            }),
            error: H({}, C, {
              value: se
            }),
            group: H({}, C, {
              value: N
            }),
            groupCollapsed: H({}, C, {
              value: ye
            }),
            groupEnd: H({}, C, {
              value: Re
            })
          });
        }
        z < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var He = _.ReactCurrentDispatcher, fe;
    function Te(C, Y, ee) {
      {
        if (fe === void 0)
          try {
            throw Error();
          } catch (ge) {
            var ce = ge.stack.trim().match(/\n( *(at )?)/);
            fe = ce && ce[1] || "";
          }
        return `
` + fe + C;
      }
    }
    var Ne = !1, _e;
    {
      var Se = typeof WeakMap == "function" ? WeakMap : Map;
      _e = new Se();
    }
    function Me(C, Y) {
      if (!C || Ne)
        return "";
      {
        var ee = _e.get(C);
        if (ee !== void 0)
          return ee;
      }
      var ce;
      Ne = !0;
      var ge = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var be;
      be = He.current, He.current = null, Ie();
      try {
        if (Y) {
          var ke = function() {
            throw Error();
          };
          if (Object.defineProperty(ke.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ke, []);
            } catch (It) {
              ce = It;
            }
            Reflect.construct(C, [], ke);
          } else {
            try {
              ke.call();
            } catch (It) {
              ce = It;
            }
            C.call(ke.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (It) {
            ce = It;
          }
          C();
        }
      } catch (It) {
        if (It && ce && typeof It.stack == "string") {
          for (var Ae = It.stack.split(`
`), We = ce.stack.split(`
`), Ye = Ae.length - 1, nt = We.length - 1; Ye >= 1 && nt >= 0 && Ae[Ye] !== We[nt]; )
            nt--;
          for (; Ye >= 1 && nt >= 0; Ye--, nt--)
            if (Ae[Ye] !== We[nt]) {
              if (Ye !== 1 || nt !== 1)
                do
                  if (Ye--, nt--, nt < 0 || Ae[Ye] !== We[nt]) {
                    var ht = `
` + Ae[Ye].replace(" at new ", " at ");
                    return C.displayName && ht.includes("<anonymous>") && (ht = ht.replace("<anonymous>", C.displayName)), typeof C == "function" && _e.set(C, ht), ht;
                  }
                while (Ye >= 1 && nt >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, He.current = be, De(), Error.prepareStackTrace = ge;
      }
      var lt = C ? C.displayName || C.name : "", cn = lt ? Te(lt) : "";
      return typeof C == "function" && _e.set(C, cn), cn;
    }
    function Ze(C, Y, ee) {
      return Me(C, !1);
    }
    function Et(C) {
      var Y = C.prototype;
      return !!(Y && Y.isReactComponent);
    }
    function kt(C, Y, ee) {
      if (C == null)
        return "";
      if (typeof C == "function")
        return Me(C, Et(C));
      if (typeof C == "string")
        return Te(C);
      switch (C) {
        case c:
          return Te("Suspense");
        case l:
          return Te("SuspenseList");
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case u:
            return Ze(C.render);
          case d:
            return kt(C.type, Y, ee);
          case h: {
            var ce = C, ge = ce._payload, be = ce._init;
            try {
              return kt(be(ge), Y, ee);
            } catch {
            }
          }
        }
      return "";
    }
    var _t = Object.prototype.hasOwnProperty, tn = {}, Nr = _.ReactDebugCurrentFrame;
    function nn(C) {
      if (C) {
        var Y = C._owner, ee = kt(C.type, C._source, Y ? Y.type : null);
        Nr.setExtraStackFrame(ee);
      } else
        Nr.setExtraStackFrame(null);
    }
    function ti(C, Y, ee, ce, ge) {
      {
        var be = Function.call.bind(_t);
        for (var ke in C)
          if (be(C, ke)) {
            var Ae = void 0;
            try {
              if (typeof C[ke] != "function") {
                var We = Error((ce || "React class") + ": " + ee + " type `" + ke + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof C[ke] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw We.name = "Invariant Violation", We;
              }
              Ae = C[ke](Y, ke, ce, ee, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ye) {
              Ae = Ye;
            }
            Ae && !(Ae instanceof Error) && (nn(ge), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ce || "React class", ee, ke, typeof Ae), nn(null)), Ae instanceof Error && !(Ae.message in tn) && (tn[Ae.message] = !0, nn(ge), A("Failed %s type: %s", ee, Ae.message), nn(null));
          }
      }
    }
    var Vi = Array.isArray;
    function Mn(C) {
      return Vi(C);
    }
    function Wi(C) {
      {
        var Y = typeof Symbol == "function" && Symbol.toStringTag, ee = Y && C[Symbol.toStringTag] || C.constructor.name || "Object";
        return ee;
      }
    }
    function $i(C) {
      try {
        return vr(C), !1;
      } catch {
        return !0;
      }
    }
    function vr(C) {
      return "" + C;
    }
    function Q(C) {
      if ($i(C))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Wi(C)), vr(C);
    }
    var K = _.ReactCurrentOwner, he = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ue, $e;
    function ft(C) {
      if (_t.call(C, "ref")) {
        var Y = Object.getOwnPropertyDescriptor(C, "ref").get;
        if (Y && Y.isReactWarning)
          return !1;
      }
      return C.ref !== void 0;
    }
    function un(C) {
      if (_t.call(C, "key")) {
        var Y = Object.getOwnPropertyDescriptor(C, "key").get;
        if (Y && Y.isReactWarning)
          return !1;
      }
      return C.key !== void 0;
    }
    function Yt(C, Y) {
      typeof C.ref == "string" && K.current;
    }
    function Un(C, Y) {
      {
        var ee = function() {
          Ue || (Ue = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Y));
        };
        ee.isReactWarning = !0, Object.defineProperty(C, "key", {
          get: ee,
          configurable: !0
        });
      }
    }
    function Hn(C, Y) {
      {
        var ee = function() {
          $e || ($e = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Y));
        };
        ee.isReactWarning = !0, Object.defineProperty(C, "ref", {
          get: ee,
          configurable: !0
        });
      }
    }
    var yt = function(C, Y, ee, ce, ge, be, ke) {
      var Ae = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: C,
        key: Y,
        ref: ee,
        props: ke,
        // Record the component responsible for creating this element.
        _owner: be
      };
      return Ae._store = {}, Object.defineProperty(Ae._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ae, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.defineProperty(Ae, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ge
      }), Object.freeze && (Object.freeze(Ae.props), Object.freeze(Ae)), Ae;
    };
    function xn(C, Y, ee, ce, ge) {
      {
        var be, ke = {}, Ae = null, We = null;
        ee !== void 0 && (Q(ee), Ae = "" + ee), un(Y) && (Q(Y.key), Ae = "" + Y.key), ft(Y) && (We = Y.ref, Yt(Y, ge));
        for (be in Y)
          _t.call(Y, be) && !he.hasOwnProperty(be) && (ke[be] = Y[be]);
        if (C && C.defaultProps) {
          var Ye = C.defaultProps;
          for (be in Ye)
            ke[be] === void 0 && (ke[be] = Ye[be]);
        }
        if (Ae || We) {
          var nt = typeof C == "function" ? C.displayName || C.name || "Unknown" : C;
          Ae && Un(ke, nt), We && Hn(ke, nt);
        }
        return yt(C, Ae, We, ge, ce, K.current, ke);
      }
    }
    var Ut = _.ReactCurrentOwner, ni = _.ReactDebugCurrentFrame;
    function jn(C) {
      if (C) {
        var Y = C._owner, ee = kt(C.type, C._source, Y ? Y.type : null);
        ni.setExtraStackFrame(ee);
      } else
        ni.setExtraStackFrame(null);
    }
    var Tn;
    Tn = !1;
    function wr(C) {
      return typeof C == "object" && C !== null && C.$$typeof === t;
    }
    function ri() {
      {
        if (Ut.current) {
          var C = j(Ut.current.type);
          if (C)
            return `

Check the render method of \`` + C + "`.";
        }
        return "";
      }
    }
    function ra(C) {
      return "";
    }
    var ia = {};
    function sa(C) {
      {
        var Y = ri();
        if (!Y) {
          var ee = typeof C == "string" ? C : C.displayName || C.name;
          ee && (Y = `

Check the top-level render call using <` + ee + ">.");
        }
        return Y;
      }
    }
    function aa(C, Y) {
      {
        if (!C._store || C._store.validated || C.key != null)
          return;
        C._store.validated = !0;
        var ee = sa(Y);
        if (ia[ee])
          return;
        ia[ee] = !0;
        var ce = "";
        C && C._owner && C._owner !== Ut.current && (ce = " It was passed a child from " + j(C._owner.type) + "."), jn(C), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ee, ce), jn(null);
      }
    }
    function Yi(C, Y) {
      {
        if (typeof C != "object")
          return;
        if (Mn(C))
          for (var ee = 0; ee < C.length; ee++) {
            var ce = C[ee];
            wr(ce) && aa(ce, Y);
          }
        else if (wr(C))
          C._store && (C._store.validated = !0);
        else if (C) {
          var ge = T(C);
          if (typeof ge == "function" && ge !== C.entries)
            for (var be = ge.call(C), ke; !(ke = be.next()).done; )
              wr(ke.value) && aa(ke.value, Y);
        }
      }
    }
    function oa(C) {
      {
        var Y = C.type;
        if (Y == null || typeof Y == "string")
          return;
        var ee;
        if (typeof Y == "function")
          ee = Y.propTypes;
        else if (typeof Y == "object" && (Y.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Y.$$typeof === d))
          ee = Y.propTypes;
        else
          return;
        if (ee) {
          var ce = j(Y);
          ti(ee, C.props, "prop", ce, C);
        } else if (Y.PropTypes !== void 0 && !Tn) {
          Tn = !0;
          var ge = j(Y);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ge || "Unknown");
        }
        typeof Y.getDefaultProps == "function" && !Y.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function gu(C) {
      {
        for (var Y = Object.keys(C.props), ee = 0; ee < Y.length; ee++) {
          var ce = Y[ee];
          if (ce !== "children" && ce !== "key") {
            jn(C), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ce), jn(null);
            break;
          }
        }
        C.ref !== null && (jn(C), A("Invalid attribute `ref` supplied to `React.Fragment`."), jn(null));
      }
    }
    var ua = {};
    function Gi(C, Y, ee, ce, ge, be) {
      {
        var ke = U(C);
        if (!ke) {
          var Ae = "";
          (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (Ae += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var We = ra();
          We ? Ae += We : Ae += ri();
          var Ye;
          C === null ? Ye = "null" : Mn(C) ? Ye = "array" : C !== void 0 && C.$$typeof === t ? (Ye = "<" + (j(C.type) || "Unknown") + " />", Ae = " Did you accidentally export a JSX literal instead of a component?") : Ye = typeof C, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ye, Ae);
        }
        var nt = xn(C, Y, ee, ge, be);
        if (nt == null)
          return nt;
        if (ke) {
          var ht = Y.children;
          if (ht !== void 0)
            if (ce)
              if (Mn(ht)) {
                for (var lt = 0; lt < ht.length; lt++)
                  Yi(ht[lt], C);
                Object.freeze && Object.freeze(ht);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Yi(ht, C);
        }
        if (_t.call(Y, "key")) {
          var cn = j(C), It = Object.keys(Y).filter(function(Zx) {
            return Zx !== "key";
          }), qi = It.length > 0 ? "{key: someKey, " + It.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ua[cn + qi]) {
            var Jx = It.length > 0 ? "{" + It.join(": ..., ") + ": ...}" : "{}";
            A(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, qi, cn, Jx, cn), ua[cn + qi] = !0;
          }
        }
        return C === r ? gu(nt) : oa(nt), nt;
      }
    }
    function bu(C, Y, ee) {
      return Gi(C, Y, ee, !0);
    }
    function Eu(C, Y, ee) {
      return Gi(C, Y, ee, !1);
    }
    var P = Eu, te = bu;
    es.Fragment = r, es.jsx = P, es.jsxs = te;
  })()), es;
}
var rf;
function B1() {
  return rf || (rf = 1, process.env.NODE_ENV === "production" ? fa.exports = H1() : fa.exports = j1()), fa.exports;
}
var S = B1();
const Ac = /* @__PURE__ */ Symbol("assistant-ui.store.clientIndex"), F1 = (e) => e[Ac], Sp = vp([]), ml = () => Cp(Sp), z1 = (e, t) => {
  const n = ml(), r = qe(() => [...n, e], [n, e]);
  return wp(Sp, r, t);
}, V1 = /* @__PURE__ */ new Set(["$$typeof", "nodeType", "then"]), Co = (e, t) => {
  if (e === Symbol.toStringTag)
    return t;
  if (typeof e != "symbol") {
    if (e === "toJSON")
      return () => t;
    if (!V1.has(e))
      return !1;
  }
};
class pl {
  getOwnPropertyDescriptor(t, n) {
    const r = this.get(t, n);
    if (r !== void 0)
      return {
        value: r,
        writable: !1,
        enumerable: !0,
        configurable: !1
      };
  }
  set() {
    return !1;
  }
  setPrototypeOf() {
    return !1;
  }
  defineProperty() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !1;
  }
}
const kp = (e) => {
  const t = Xe(e);
  return (n) => {
    const r = t(n);
    return n.key === void 0 ? r : Gn(n.key, r);
  };
}, eo = /* @__PURE__ */ Symbol("assistant-ui.store.getValue"), W1 = (e) => {
  const t = e[eo];
  if (!t)
    throw new Error("Client scope contains a non-client resource. Ensure your Derived get() returns a client created with tapClientResource(), not a plain resource.");
  return t.getState?.();
}, sf = /* @__PURE__ */ new Map();
function $1(e) {
  let t = sf.get(e);
  return t || (t = function(...n) {
    if (!this || typeof this != "object")
      throw new Error(`Method "${String(e)}" called without proper context. This may indicate the function was called incorrectly.`);
    const r = this[eo];
    if (!r)
      throw new Error(`Method "${String(e)}" called on invalid client proxy. Ensure you are calling this method on a valid client instance.`);
    const i = r[e];
    if (!i)
      throw new Error(`Method "${String(e)}" is not implemented.`);
    if (typeof i != "function")
      throw new Error(`"${String(e)}" is not a function.`);
    return i(...n);
  }, sf.set(e, t)), t;
}
class Y1 extends pl {
  constructor(n, r) {
    super();
    O(this, "outputRef");
    O(this, "index");
    O(this, "boundFns");
    O(this, "cachedReceiver");
    this.outputRef = n, this.index = r;
  }
  get(n, r, i) {
    if (r === eo)
      return this.outputRef.current;
    if (r === Ac)
      return this.index;
    const s = Co(r, "ClientProxy");
    if (s !== !1)
      return s;
    const a = this.outputRef.current[r];
    if (typeof a == "function") {
      this.cachedReceiver !== i && (this.boundFns = /* @__PURE__ */ new Map(), this.cachedReceiver = i);
      let o = this.boundFns.get(r);
      return o || (o = $1(r).bind(i), this.boundFns.set(r, o)), o;
    }
    return a;
  }
  ownKeys() {
    return Object.keys(this.outputRef.current);
  }
  has(n, r) {
    return r === eo || r === Ac ? !0 : r in this.outputRef.current;
  }
}
const Ip = kp((e) => {
  const t = or(null), n = ml().length, r = qe(() => new Proxy({}, new Y1(t, n)), [n]), i = z1(r, () => Jt(e));
  t.current || (t.current = i), wt(() => {
    t.current = i;
  });
  const s = i.getState?.();
  return { methods: r, state: s, key: e.key };
}), So = (e) => Jt(Ip(e)), ps = /* @__PURE__ */ Symbol("assistant-ui.store.proxiedAssistantState"), _u = (e) => e === "on" || e === "subscribe" || typeof e == "symbol", Dp = (e) => {
  class t extends pl {
    get(r, i) {
      const s = Co(i, "AssistantState");
      if (s !== !1)
        return s;
      const a = i;
      if (!_u(a))
        return W1(e[a]());
    }
    ownKeys() {
      return Object.keys(e).filter((r) => !_u(r));
    }
    has(r, i) {
      return !_u(i) && i in e;
    }
  }
  return new Proxy({}, new t());
}, G1 = (e) => e[ps], af = () => () => {
}, Rp = (e) => {
  const t = (() => {
    throw new Error(e);
  });
  return t.source = null, t.query = null, t;
};
class q1 extends pl {
  get(t, n) {
    if (n === "subscribe" || n === "on")
      return af;
    if (n === ps)
      return K1;
    const r = Co(n, "DefaultAssistantClient");
    return r !== !1 ? r : Rp("You are using a component or hook that requires an AuiProvider. Wrap your component in an <AuiProvider> component.");
  }
  ownKeys() {
    return ["subscribe", "on", ps];
  }
  has(t, n) {
    return n === "subscribe" || n === "on" || n === ps;
  }
}
const ko = new Proxy({}, new q1()), K1 = Dp(ko), Q1 = () => new Proxy({}, {
  get(e, t) {
    const n = Co(t, "AssistantClient");
    return n !== !1 ? n : Rp(`The current scope does not have a "${String(t)}" property.`);
  }
}), Pp = Ot(ko), X1 = () => Ct(Pp), qr = ({ value: e, children: t }) => S.jsx(Pp.Provider, { value: e, children: t }), $n = Xe((e) => null), yc = /* @__PURE__ */ Symbol("assistant-ui.transform-scopes");
function Op(e, t) {
  const n = e;
  if (n[yc])
    throw new Error("transformScopes is already attached to this resource");
  n[yc] = t;
}
function J1(e) {
  return e[yc];
}
function Z1(e, t) {
  const n = { ...e }, r = /* @__PURE__ */ new Set();
  let i = !0;
  for (; i; ) {
    i = !1;
    for (const o of Object.values(n)) {
      if (o.type === $n || r.has(o.type))
        continue;
      r.add(o.type);
      const u = J1(o.type);
      if (u) {
        u(n, t), i = !0;
        break;
      }
    }
  }
  const s = {}, a = {};
  for (const [o, u] of Object.entries(n))
    u.type === $n ? a[o] = u : s[o] = u;
  return { rootClients: s, derivedClients: a };
}
const of = (e) => qe(() => e, [...Object.entries(e).flat()]), eT = (e, t) => {
  const { rootClients: n, derivedClients: r } = Z1(e, t);
  return {
    rootClients: of(n),
    derivedClients: of(r)
  };
}, Lp = (e) => typeof e == "string" ? { scope: e.split(".")[0], event: e } : { scope: e.scope, event: e.event }, tT = Xe(() => Hr(() => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  return {
    on(r, i) {
      const s = i;
      if (r === "*")
        return t.add(s), () => t.delete(s);
      let a = e.get(r);
      return a || (a = /* @__PURE__ */ new Set(), e.set(r, a)), a.add(s), () => {
        a.delete(s), a.size === 0 && e.delete(r);
      };
    },
    emit(r, i, s) {
      const a = e.get(r);
      !a && t.size === 0 || queueMicrotask(() => {
        const o = [];
        if (a)
          for (const u of a)
            try {
              u(i, s);
            } catch (c) {
              o.push(c);
            }
        if (t.size > 0) {
          const u = { event: r, payload: i };
          for (const c of t)
            try {
              c(u, s);
            } catch (l) {
              o.push(l);
            }
        }
        if (o.length > 0) {
          if (o.length === 1)
            throw o[0];
          for (const u of o)
            console.error(u);
          throw new AggregateError(o, "Errors occurred during event emission");
        }
      });
    },
    subscribe(r) {
      return n.add(r), () => n.delete(r);
    },
    notifySubscribers() {
      for (const r of n)
        try {
          r();
        } catch (i) {
          console.error("NotificationManager: subscriber callback error", i);
        }
    }
  };
})), Mp = vp(null), nT = (e, t) => wp(Mp, e, t), Up = () => {
  const e = Cp(Mp);
  if (!e)
    throw new Error("AssistantTapContext is not available");
  return e;
}, Hp = () => Up().clientRef, gl = () => {
  const { emit: e } = Up(), t = ml();
  return fl((n, r) => {
    e(n, r, t);
  });
}, jp = (e) => qe(() => e, e), rT = Xe(({ element: e, emit: t, clientRef: n }) => {
  const { methods: r, state: i } = nT({ clientRef: n, emit: t }, () => So(e));
  return qe(() => ({ state: i, methods: r }), [r, i]);
}), iT = Xe(({ element: e, notifications: t, clientRef: n, name: r }) => {
  const i = U1(rT({ element: e, emit: t.emit, clientRef: n }));
  return wt(() => i.subscribe(t.notifySubscribers), [i, t]), qe(() => {
    const s = () => i.getValue().methods;
    return Object.defineProperties(s, {
      source: {
        value: "root",
        writable: !1
      },
      query: {
        value: {},
        writable: !1
      },
      name: {
        value: r,
        configurable: !0
      }
    }), s;
  }, [i, r]);
}), sT = Xe(() => qe(() => ({
  clients: [],
  subscribe: void 0,
  on: void 0
}), [])), aT = Xe(({ clients: e, clientRef: t }) => {
  const n = Jt(tT());
  wt(() => t.parent.subscribe(n.notifySubscribers), [t, n]);
  const r = jp(hl(() => Object.keys(e).map((i) => Gn(i, iT({
    element: e[i],
    notifications: n,
    clientRef: t,
    name: i
  }))), [e, n, t]));
  return qe(() => ({
    clients: r,
    subscribe: n.subscribe,
    on: function(i, s) {
      if (!this)
        throw new Error("const { on } = useAui() is not supported. Use aui.on() instead.");
      const { scope: a, event: o } = Lp(i);
      if (a !== "*" && this[a].source === null)
        throw new Error(`Scope "${a}" is not available. Use { scope: "*", event: "${o}" } to listen globally.`);
      const u = n.on(o, (l, d) => {
        if (a === "*") {
          s(l);
          return;
        }
        const h = this[a](), m = F1(h);
        h === d[m] && s(l);
      });
      if (a !== "*" && t.parent[a].source === null)
        return u;
      const c = t.parent.on(i, s);
      return () => {
        u(), c();
      };
    }
  }), [r, n, t]);
}), uf = (e, t, n) => {
  if ("source" in e && "query" in e)
    return e;
  if (n.dep === e)
    return n.meta;
  const r = e.getMeta(t.current);
  return n.meta = r, n.dep = e, r;
}, oT = Xe(({ element: e, clientRef: t, name: n }) => {
  const r = fl(() => e.props);
  return qe(() => {
    const i = () => r().get(t.current), s = {};
    return Object.defineProperties(i, {
      source: {
        get: () => uf(r(), t, s).source
      },
      query: {
        get: () => uf(r(), t, s).query
      },
      name: {
        value: n,
        configurable: !0
      }
    }), i;
  }, [t, n]);
}), uT = Xe(({ clients: e, clientRef: t }) => jp(hl(() => Object.keys(e).map((n) => Gn(n, oT({
  element: e[n],
  clientRef: t,
  name: n
}))), [e, t]))), cT = Xe(({ parent: e, clients: t }) => {
  const { rootClients: n, derivedClients: r } = eT(t, e), i = or({
    parent: e,
    current: null
  }).current;
  wt(() => {
    i.current = o;
  });
  const s = Jt(Object.keys(n).length > 0 ? aT({ clients: n, clientRef: i }) : sT()), a = Jt(uT({ clients: r, clientRef: i })), o = qe(() => {
    const u = e === ko ? Q1() : e, c = Object.create(u);
    Object.assign(c, {
      subscribe: s.subscribe ?? e.subscribe,
      on: s.on ?? e.on,
      [ps]: Dp(c)
    });
    for (const l of s.clients)
      c[l.name] = l;
    for (const l of a)
      c[l.name] = l;
    return c;
  }, [e, s, a]);
  return i.current === null && (i.current = o), o;
});
function Ve(e, { parent: t } = {
  parent: X1()
}) {
  if (e)
    return y1(cT({
      parent: t ?? ko,
      clients: e
    }));
  if (t === null)
    throw new Error("received null parent, this usage is not allowed");
  return t;
}
const oe = (e) => {
  const t = Ve(), n = G1(t), r = r1(t.subscribe, () => e(n), () => e(n));
  if (r === n)
    throw new Error("You tried to return the entire AssistantState. This is not supported due to technical limitations.");
  return i1(r), r;
}, lT = ct.createContext(!0);
function cf() {
  throw new Error("A function wrapped in useEffectEvent can't be called during rendering.");
}
const dT = "use" in ct ? () => {
  try {
    return ct.use(lT);
  } catch {
    return !1;
  }
} : () => !1;
function fT(e) {
  const t = ct.useRef(cf);
  return ct.useInsertionEffect(() => {
    t.current = e;
  }, [e]), (...n) => {
    dT() && cf();
    const r = t.current;
    return r(...n);
  };
}
const xu = (e, t) => {
  const n = Ve(), r = fT(t), { scope: i, event: s } = Lp(e);
  Le(() => n.on({ scope: i, event: s }, r), [n, i, s, r]);
}, hT = (e) => {
  const t = Ve(), n = st(void 0);
  return oe(() => (n.current === void 0 && (n.current = e(t)), n.current)), () => (n.current = void 0, e(t));
}, mT = Object.freeze({});
function bl({ getItemState: e, children: t }) {
  const n = hT(e);
  return pT(t(n));
}
const pT = (e) => {
  const t = typeof e == "object" && e != null && "type" in e ? e : null, n = t?.type, r = t?.key, i = typeof t?.props == "object" && t.props != null && Object.entries(t.props).length === 0 ? mT : t?.props;
  return (
    // biome-ignore lint/correctness/useExhaustiveDependencies: optimization
    pe(() => t, [n, r, i]) ?? e
  );
}, gT = kp((e) => {
  if (e.key === void 0)
    throw new Error("tapClientResource: Element has no key");
  return Jt(Ip(e));
});
function Ai(e, t) {
  const n = hl(
    () => e().map((a) => gT(a)),
    // biome-ignore lint/correctness/useExhaustiveDependencies: getElementsDeps is passed through from caller
    t
  ), r = qe(() => Object.keys(n), [n]), i = qe(() => n.reduce((a, o, u) => (a[o.key] = u, a), {}), [n]);
  return {
    state: qe(() => n.map((a) => a.state), [n]),
    get: (a) => {
      if ("index" in a) {
        if (a.index < 0 || a.index >= r.length)
          throw new Error(`tapClientLookup: Index ${a.index} out of bounds (length: ${r.length})`);
        return n[a.index].methods;
      }
      const o = i[a.key];
      if (o === void 0)
        throw new Error(`tapClientLookup: Key "${a.key}" not found`);
      return n[o].methods;
    }
  };
}
const lf = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (c, l) => {
    const d = typeof c == "function" ? c(t) : c;
    if (!Object.is(d, t)) {
      const h = t;
      t = l ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), n.forEach((m) => m(t, h));
    }
  }, i = () => t, o = { setState: r, getState: i, getInitialState: () => u, subscribe: (c) => (n.add(c), () => n.delete(c)) }, u = t = e(r, i, o);
  return o;
}, bT = ((e) => e ? lf(e) : lf), ET = (e) => e;
function _T(e, t = ET) {
  const n = ct.useSyncExternalStore(
    e.subscribe,
    ct.useCallback(() => t(e.getState()), [e, t]),
    ct.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return ct.useDebugValue(n), n;
}
const df = (e) => {
  const t = bT(e), n = (r) => _T(t, r);
  return Object.assign(n, t), n;
}, yi = ((e) => e ? df(e) : df), xT = Xe((e) => ({
  getState: () => e
})), TT = Xe((e) => {
  const [t] = In(() => ({
    suggestions: (e ?? []).map((i) => typeof i == "string" ? {
      title: i,
      label: "",
      prompt: i
    } : {
      title: i.title,
      label: i.label,
      prompt: i.prompt
    })
  })), n = Ai(() => t.suggestions.map((r, i) => Gn(i, xT(r))), [t.suggestions]);
  return {
    getState: () => t,
    suggestion: ({ index: r }) => n.get({ index: r })
  };
}), AT = TT, yT = Object.freeze({
  type: "complete"
}), NT = Xe(({ parts: e, getMessagePart: t }) => {
  const [n, r] = In(!0), i = qe(() => e[e.length - 1]?.status ?? yT, [e]), s = qe(() => ({ parts: e, collapsed: n, status: i }), [e, n, i]);
  return {
    getState: () => s,
    setCollapsed: r,
    part: t
  };
}), vT = (e) => Array.from(e).map((n) => n.getModelContext()).sort((n, r) => (r.priority ?? 0) - (n.priority ?? 0)).reduce((n, r) => {
  if (r.system && (n.system ? n.system += `

${r.system}` : n.system = r.system), r.tools)
    for (const [i, s] of Object.entries(r.tools)) {
      const a = n.tools?.[i];
      if (a && a !== s)
        throw new Error(`You tried to define a tool with the name ${i}, but it already exists.`);
      n.tools || (n.tools = {}), n.tools[i] = s;
    }
  return r.config && (n.config = {
    ...n.config,
    ...r.config
  }), r.callSettings && (n.callSettings = {
    ...n.callSettings,
    ...r.callSettings
  }), n;
}, {});
class El {
  constructor() {
    O(this, "_providers", /* @__PURE__ */ new Set());
    O(this, "_subscribers", /* @__PURE__ */ new Set());
  }
  getModelContext() {
    return vT(this._providers);
  }
  registerModelContextProvider(t) {
    this._providers.add(t);
    const n = t.subscribe?.(() => {
      this.notifySubscribers();
    });
    return this.notifySubscribers(), () => {
      this._providers.delete(t), n?.(), this.notifySubscribers();
    };
  }
  notifySubscribers() {
    for (const t of this._subscribers)
      t();
  }
  subscribe(t) {
    return this._subscribers.add(t), () => this._subscribers.delete(t);
  }
}
const wT = 1, Bp = Xe(() => {
  const [e] = In(() => ({ version: wT + 1 })), t = qe(() => new El(), []);
  return {
    getState: () => e,
    getModelContext: () => t.getModelContext(),
    subscribe: (n) => t.subscribe(n),
    register: (n) => t.registerModelContextProvider(n)
  };
}), Fp = Xe(({ toolkit: e }) => {
  const [t, n] = In(() => ({
    tools: {}
  })), r = Hp(), i = wo((s, a) => (n((o) => ({
    ...o,
    tools: {
      ...o.tools,
      [s]: [...o.tools[s] ?? [], a]
    }
  })), () => {
    n((o) => ({
      ...o,
      tools: {
        ...o.tools,
        [s]: o.tools[s]?.filter((u) => u !== a) ?? []
      }
    }));
  }), []);
  return wt(() => {
    if (!e)
      return;
    const s = [];
    for (const [u, c] of Object.entries(e))
      c.render && s.push(i(u, c.render));
    const a = Object.entries(e).reduce((u, [c, l]) => {
      const { render: d, ...h } = l;
      return u[c] = h, u;
    }, {}), o = {
      getModelContext: () => ({
        tools: a
      })
    };
    return s.push(r.current.modelContext().register(o)), () => {
      s.forEach((u) => u());
    };
  }, [e, i, r]), {
    getState: () => t,
    setToolUI: i
  };
});
Op(Fp, (e, t) => {
  !e.modelContext && t.modelContext.source === null && (e.modelContext = Bp());
});
const CT = Xe(() => {
  const [e, t] = In(() => ({
    renderers: {}
  })), n = wo((r, i) => (t((s) => ({
    ...s,
    renderers: {
      ...s.renderers,
      [r]: [...s.renderers[r] ?? [], i]
    }
  })), () => {
    t((s) => ({
      ...s,
      renderers: {
        ...s.renderers,
        [r]: s.renderers[r]?.filter((a) => a !== i) ?? []
      }
    }));
  }), []);
  return {
    getState: () => e,
    setDataUI: n
  };
}), Nc = {
  toResponse(e, t) {
    return new Response(Nc.toByteStream(e, t), {
      headers: t.headers ?? {}
    });
  },
  fromResponse(e, t) {
    return Nc.fromByteStream(e.body, t);
  },
  toByteStream(e, t) {
    return e.pipeThrough(t);
  },
  fromByteStream(e, t) {
    return e.pipeThrough(t);
  }
}, zp = function() {
  let e, t;
  const n = new Promise((r, i) => {
    e = r, t = i;
  });
  if (!e || !t)
    throw new Error("Failed to create promise");
  return { promise: n, resolve: e, reject: t };
}, ST = () => {
  const e = [];
  let t = !1, n, r;
  const i = (a) => {
    a.promise || (a.promise = a.reader.read().then(({ done: o, value: u }) => {
      a.promise = void 0, o ? (e.splice(e.indexOf(a), 1), t && e.length === 0 && n.close()) : n.enqueue(u), r?.resolve(), r = void 0;
    }).catch((o) => {
      console.error(o), e.forEach((u) => {
        u.reader.cancel();
      }), e.length = 0, n.error(o), r?.reject(o), r = void 0;
    }));
  };
  return {
    readable: new ReadableStream({
      start(a) {
        n = a;
      },
      pull() {
        return r = zp(), e.forEach((a) => {
          i(a);
        }), r.promise;
      },
      cancel() {
        e.forEach((a) => {
          a.reader.cancel();
        }), e.length = 0;
      }
    }),
    isSealed() {
      return t;
    },
    seal() {
      t = !0, e.length === 0 && n.close();
    },
    addStream(a) {
      if (t)
        throw new Error("Cannot add streams after the run callback has settled.");
      const o = { reader: a.getReader() };
      e.push(o), i(o);
    },
    enqueue(a) {
      this.addStream(new ReadableStream({
        start(o) {
          o.enqueue(a), o.close();
        }
      }));
    }
  };
};
class ff {
  constructor(t) {
    O(this, "_controller");
    O(this, "_isClosed", !1);
    this._controller = t;
  }
  append(t) {
    return this._controller.enqueue({
      type: "text-delta",
      path: [],
      textDelta: t
    }), this;
  }
  close() {
    this._isClosed || (this._isClosed = !0, this._controller.enqueue({
      type: "part-finish",
      path: []
    }), this._controller.close());
  }
}
const Vp = (e) => new ReadableStream({
  start(t) {
    return e.start?.(new ff(t));
  },
  pull(t) {
    return e.pull?.(new ff(t));
  },
  cancel(t) {
    return e.cancel?.(t);
  }
}), hf = () => {
  let e;
  return [Vp({
    start(n) {
      e = n;
    }
  }), e];
};
class mf {
  constructor(t) {
    O(this, "_controller");
    O(this, "_isClosed", !1);
    O(this, "_mergeTask");
    O(this, "_argsTextController");
    this._controller = t;
    const n = Vp({
      start: (i) => {
        this._argsTextController = i;
      }
    });
    let r = !1;
    this._mergeTask = n.pipeTo(new WritableStream({
      write: (i) => {
        switch (i.type) {
          case "text-delta":
            r = !0, this._controller.enqueue(i);
            break;
          case "part-finish":
            r || this._controller.enqueue({
              type: "text-delta",
              textDelta: "{}",
              path: []
            }), this._controller.enqueue({
              type: "tool-call-args-text-finish",
              path: []
            });
            break;
          default:
            throw new Error(`Unexpected chunk type: ${i.type}`);
        }
      }
    }));
  }
  get argsText() {
    return this._argsTextController;
  }
  async setResponse(t) {
    this._argsTextController.close(), await Promise.resolve(), this._controller.enqueue({
      type: "result",
      path: [],
      ...t.artifact !== void 0 ? { artifact: t.artifact } : {},
      result: t.result,
      isError: t.isError ?? !1,
      ...t.messages !== void 0 ? { messages: t.messages } : {}
    });
  }
  async close() {
    this._isClosed || (this._isClosed = !0, this._argsTextController.close(), await this._mergeTask, this._controller.enqueue({
      type: "part-finish",
      path: []
    }), this._controller.close());
  }
}
const kT = (e) => new ReadableStream({
  start(t) {
    return e.start?.(new mf(t));
  },
  pull(t) {
    return e.pull?.(new mf(t));
  },
  cancel(t) {
    return e.cancel?.(t);
  }
}), IT = () => {
  let e;
  return [kT({
    start(n) {
      e = n;
    }
  }), e];
};
class Wp {
  constructor() {
    O(this, "value", -1);
  }
  up() {
    return ++this.value;
  }
}
class DT extends TransformStream {
  constructor(t) {
    super({
      transform(n, r) {
        r.enqueue({
          ...n,
          path: [t, ...n.path]
        });
      }
    });
  }
}
class fF extends TransformStream {
  constructor(t) {
    super({
      transform(n, r) {
        const { path: [i, ...s] } = n;
        if (t !== i)
          throw new Error(`Path mismatch: expected ${t}, got ${i}`);
        r.enqueue({
          ...n,
          path: s
        });
      }
    });
  }
}
class RT extends TransformStream {
  constructor(t) {
    const n = new Wp(), r = /* @__PURE__ */ new Map();
    super({
      transform(i, s) {
        i.type === "part-start" && i.path.length === 0 && r.set(n.up(), t.up());
        const [a, ...o] = i.path;
        if (a === void 0) {
          s.enqueue(i);
          return;
        }
        const u = r.get(a);
        if (u === void 0)
          throw new Error("Path not found");
        s.enqueue({
          ...i,
          path: [u, ...o]
        });
      }
    });
  }
}
class PT extends TransformStream {
  constructor(t, n, r) {
    const [i, s] = MT();
    let a;
    super({
      start(o) {
        return a = i.pipeTo(new WritableStream({
          write(u) {
            o.enqueue(u);
          },
          abort(u) {
            o.error(u);
          },
          close() {
            o.terminate();
          }
        })).catch((u) => {
          o.error(u);
        }), t.start?.(s);
      },
      transform(o) {
        return t.transform?.(o, s);
      },
      async flush() {
        await t.flush?.(s), s.close(), await a;
      }
    }, n, r);
  }
}
class OT extends TransformStream {
  constructor(t) {
    super();
    const n = t(super.readable);
    Object.defineProperty(this, "readable", {
      value: n,
      writable: !1
    });
  }
}
let $p = (e, t = 21) => (n = t) => {
  let r = "", i = n | 0;
  for (; i--; )
    r += e[Math.random() * e.length | 0];
  return r;
};
const Yp = $p("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 7);
class _l {
  constructor(t) {
    O(this, "_state");
    O(this, "_parentId");
    this._state = t || {
      merger: ST(),
      contentCounter: new Wp()
    };
  }
  get __internal_isClosed() {
    return this._state.merger.isSealed();
  }
  __internal_getReadable() {
    return this._state.merger.readable;
  }
  __internal_subscribeToClose(t) {
    this._state.closeSubscriber = t;
  }
  _addPart(t, n) {
    this._state.append && (this._state.append.controller.close(), this._state.append = void 0), this.enqueue({
      type: "part-start",
      part: t,
      path: []
    }), this._state.merger.addStream(n.pipeThrough(new DT(this._state.contentCounter.value)));
  }
  merge(t) {
    this._state.merger.addStream(t.pipeThrough(new RT(this._state.contentCounter)));
  }
  appendText(t) {
    this._state.append?.kind !== "text" && (this._state.append = {
      kind: "text",
      controller: this.addTextPart()
    }), this._state.append.controller.append(t);
  }
  appendReasoning(t) {
    this._state.append?.kind !== "reasoning" && (this._state.append = {
      kind: "reasoning",
      controller: this.addReasoningPart()
    }), this._state.append.controller.append(t);
  }
  addTextPart() {
    const [t, n] = hf();
    return this._addPart({ type: "text" }, t), n;
  }
  addReasoningPart() {
    const [t, n] = hf();
    return this._addPart({ type: "reasoning" }, t), n;
  }
  addToolCallPart(t) {
    const n = typeof t == "string" ? { toolName: t } : t, r = n.toolName, i = n.toolCallId ?? Yp(), [s, a] = IT();
    return this._addPart({
      type: "tool-call",
      toolName: r,
      toolCallId: i,
      ...this._parentId && { parentId: this._parentId }
    }, s), n.argsText !== void 0 && (a.argsText.append(n.argsText), a.argsText.close()), n.args !== void 0 && (a.argsText.append(JSON.stringify(n.args)), a.argsText.close()), n.response !== void 0 && a.setResponse(n.response), a;
  }
  appendSource(t) {
    this._addPart({ ...t, ...this._parentId && { parentId: this._parentId } }, new ReadableStream({
      start(n) {
        n.enqueue({
          type: "part-finish",
          path: []
        }), n.close();
      }
    }));
  }
  appendFile(t) {
    this._addPart(t, new ReadableStream({
      start(n) {
        n.enqueue({
          type: "part-finish",
          path: []
        }), n.close();
      }
    }));
  }
  enqueue(t) {
    this._state.merger.enqueue(t), t.type === "part-start" && t.path.length === 0 && this._state.contentCounter.up();
  }
  withParentId(t) {
    const n = new _l(this._state);
    return n._parentId = t, n;
  }
  close() {
    this._state.append?.controller?.close(), this._state.merger.seal(), this._state.closeSubscriber?.();
  }
}
function LT(e) {
  const t = new _l();
  return (async () => {
    try {
      await e(t);
    } catch (r) {
      throw t.__internal_isClosed || t.enqueue({
        type: "error",
        path: [],
        error: String(r)
      }), r;
    } finally {
      t.__internal_isClosed || t.close();
    }
  })(), t.__internal_getReadable();
}
function MT() {
  const { resolve: e, promise: t } = zp();
  let n;
  return [LT((i) => (n = i, n.__internal_subscribeToClose(e), t)), n];
}
var Cr = { exports: {} }, pf;
function UT() {
  if (pf) return Cr.exports;
  pf = 1;
  const e = typeof Buffer < "u", t = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/, n = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
  function r(o, u, c) {
    c == null && u !== null && typeof u == "object" && (c = u, u = void 0), e && Buffer.isBuffer(o) && (o = o.toString()), o && o.charCodeAt(0) === 65279 && (o = o.slice(1));
    const l = JSON.parse(o, u);
    if (l === null || typeof l != "object")
      return l;
    const d = c && c.protoAction || "error", h = c && c.constructorAction || "error";
    if (d === "ignore" && h === "ignore")
      return l;
    if (d !== "ignore" && h !== "ignore") {
      if (t.test(o) === !1 && n.test(o) === !1)
        return l;
    } else if (d !== "ignore" && h === "ignore") {
      if (t.test(o) === !1)
        return l;
    } else if (n.test(o) === !1)
      return l;
    return i(l, { protoAction: d, constructorAction: h, safe: c && c.safe });
  }
  function i(o, { protoAction: u = "error", constructorAction: c = "error", safe: l } = {}) {
    let d = [o];
    for (; d.length; ) {
      const h = d;
      d = [];
      for (const m of h) {
        if (u !== "ignore" && Object.prototype.hasOwnProperty.call(m, "__proto__")) {
          if (l === !0)
            return null;
          if (u === "error")
            throw new SyntaxError("Object contains forbidden prototype property");
          delete m.__proto__;
        }
        if (c !== "ignore" && Object.prototype.hasOwnProperty.call(m, "constructor") && m.constructor !== null && typeof m.constructor == "object" && Object.prototype.hasOwnProperty.call(m.constructor, "prototype")) {
          if (l === !0)
            return null;
          if (c === "error")
            throw new SyntaxError("Object contains forbidden prototype property");
          delete m.constructor;
        }
        for (const E in m) {
          const g = m[E];
          g && typeof g == "object" && d.push(g);
        }
      }
    }
    return o;
  }
  function s(o, u, c) {
    const { stackTraceLimit: l } = Error;
    Error.stackTraceLimit = 0;
    try {
      return r(o, u, c);
    } finally {
      Error.stackTraceLimit = l;
    }
  }
  function a(o, u) {
    const { stackTraceLimit: c } = Error;
    Error.stackTraceLimit = 0;
    try {
      return r(o, u, { safe: !0 });
    } catch {
      return;
    } finally {
      Error.stackTraceLimit = c;
    }
  }
  return Cr.exports = s, Cr.exports.default = s, Cr.exports.parse = s, Cr.exports.safeParse = a, Cr.exports.scan = i, Cr.exports;
}
var HT = UT();
const gf = /* @__PURE__ */ pr(HT);
function jT(e) {
  const t = ["ROOT"];
  let n = -1, r = null;
  const i = [];
  let s;
  function a() {
    s !== void 0 && (i.push(JSON.parse(`"${s}"`)), s = void 0);
  }
  function o(d, h, m) {
    switch (d) {
      case '"': {
        n = h, t.pop(), t.push(m), t.push("INSIDE_STRING"), a();
        break;
      }
      case "f":
      case "t":
      case "n": {
        n = h, r = h, t.pop(), t.push(m), t.push("INSIDE_LITERAL");
        break;
      }
      case "-": {
        t.pop(), t.push(m), t.push("INSIDE_NUMBER"), a();
        break;
      }
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9": {
        n = h, t.pop(), t.push(m), t.push("INSIDE_NUMBER"), a();
        break;
      }
      case "{": {
        n = h, t.pop(), t.push(m), t.push("INSIDE_OBJECT_START"), a();
        break;
      }
      case "[": {
        n = h, t.pop(), t.push(m), t.push("INSIDE_ARRAY_START"), a();
        break;
      }
    }
  }
  function u(d, h) {
    switch (d) {
      case ",": {
        t.pop(), t.push("INSIDE_OBJECT_AFTER_COMMA");
        break;
      }
      case "}": {
        n = h, t.pop(), s = i.pop();
        break;
      }
    }
  }
  function c(d, h) {
    switch (d) {
      case ",": {
        t.pop(), t.push("INSIDE_ARRAY_AFTER_COMMA"), s = (Number(s) + 1).toString();
        break;
      }
      case "]": {
        n = h, t.pop(), s = i.pop();
        break;
      }
    }
  }
  for (let d = 0; d < e.length; d++) {
    const h = e[d];
    switch (t[t.length - 1]) {
      case "ROOT":
        o(h, d, "FINISH");
        break;
      case "INSIDE_OBJECT_START": {
        switch (h) {
          case '"': {
            t.pop(), t.push("INSIDE_OBJECT_KEY"), s = "";
            break;
          }
          case "}": {
            n = d, t.pop(), s = i.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_COMMA": {
        h === '"' && (t.pop(), t.push("INSIDE_OBJECT_KEY"), s = "");
        break;
      }
      case "INSIDE_OBJECT_KEY": {
        switch (h) {
          case '"': {
            t.pop(), t.push("INSIDE_OBJECT_AFTER_KEY");
            break;
          }
          case "\\": {
            t.push("INSIDE_STRING_ESCAPE"), s += h;
            break;
          }
          default: {
            s += h;
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_KEY": {
        h === ":" && (t.pop(), t.push("INSIDE_OBJECT_BEFORE_VALUE"));
        break;
      }
      case "INSIDE_OBJECT_BEFORE_VALUE": {
        o(h, d, "INSIDE_OBJECT_AFTER_VALUE");
        break;
      }
      case "INSIDE_OBJECT_AFTER_VALUE": {
        u(h, d);
        break;
      }
      case "INSIDE_STRING": {
        switch (h) {
          case '"': {
            t.pop(), n = d, s = i.pop();
            break;
          }
          case "\\": {
            t.push("INSIDE_STRING_ESCAPE");
            break;
          }
          default:
            n = d;
        }
        break;
      }
      case "INSIDE_ARRAY_START": {
        h === "]" ? (n = d, t.pop(), s = i.pop()) : (n = d, s = "0", o(h, d, "INSIDE_ARRAY_AFTER_VALUE"));
        break;
      }
      case "INSIDE_ARRAY_AFTER_VALUE": {
        switch (h) {
          case ",": {
            t.pop(), t.push("INSIDE_ARRAY_AFTER_COMMA"), s = (Number(s) + 1).toString();
            break;
          }
          case "]": {
            n = d, t.pop(), s = i.pop();
            break;
          }
          default: {
            n = d;
            break;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_AFTER_COMMA": {
        o(h, d, "INSIDE_ARRAY_AFTER_VALUE");
        break;
      }
      case "INSIDE_STRING_ESCAPE": {
        t.pop(), t[t.length - 1] === "INSIDE_STRING" ? n = d : t[t.length - 1] === "INSIDE_OBJECT_KEY" && (s += h);
        break;
      }
      case "INSIDE_NUMBER": {
        switch (h) {
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9": {
            n = d;
            break;
          }
          case "e":
          case "E":
          case "-":
          case ".":
            break;
          case ",": {
            t.pop(), s = i.pop(), t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(h, d), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" && u(h, d);
            break;
          }
          case "}": {
            t.pop(), s = i.pop(), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" && u(h, d);
            break;
          }
          case "]": {
            t.pop(), s = i.pop(), t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(h, d);
            break;
          }
          default: {
            t.pop(), s = i.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_LITERAL": {
        const E = e.substring(r, d + 1);
        !"false".startsWith(E) && !"true".startsWith(E) && !"null".startsWith(E) ? (t.pop(), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" ? u(h, d) : t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(h, d)) : n = d;
        break;
      }
    }
  }
  let l = e.slice(0, n + 1);
  for (let d = t.length - 1; d >= 0; d--)
    switch (t[d]) {
      case "INSIDE_STRING": {
        l += '"';
        break;
      }
      case "INSIDE_OBJECT_KEY":
      case "INSIDE_OBJECT_AFTER_KEY":
      case "INSIDE_OBJECT_AFTER_COMMA":
      case "INSIDE_OBJECT_START":
      case "INSIDE_OBJECT_BEFORE_VALUE":
      case "INSIDE_OBJECT_AFTER_VALUE": {
        l += "}";
        break;
      }
      case "INSIDE_ARRAY_START":
      case "INSIDE_ARRAY_AFTER_COMMA":
      case "INSIDE_ARRAY_AFTER_VALUE": {
        l += "]";
        break;
      }
      case "INSIDE_LITERAL": {
        const m = e.substring(r, e.length);
        "true".startsWith(m) ? l += "true".slice(m.length) : "false".startsWith(m) ? l += "false".slice(m.length) : "null".startsWith(m) && (l += "null".slice(m.length));
      }
    }
  return [l, i];
}
const Tu = /* @__PURE__ */ Symbol("aui.parse-partial-json-object.meta"), Io = (e) => {
  if (e.length === 0)
    return {
      [Tu]: { state: "partial", partialPath: [] }
    };
  try {
    const t = gf.parse(e);
    if (typeof t != "object" || t === null)
      throw new Error("argsText is expected to be an object");
    return t[Tu] = {
      state: "complete",
      partialPath: []
    }, t;
  } catch {
    try {
      const [t, n] = jT(e), r = gf.parse(t);
      if (typeof r != "object" || r === null)
        throw new Error("argsText is expected to be an object");
      return r[Tu] = {
        state: "partial",
        partialPath: n
      }, r;
    } catch {
      return;
    }
  }
};
class gs {
  constructor(t = null) {
    O(this, "_state");
    this._state = t;
  }
  get state() {
    return this._state;
  }
  append(t) {
    this._state = t.reduce((n, r) => gs.apply(n, r), this._state);
  }
  static apply(t, n) {
    const r = n.type;
    switch (r) {
      case "set":
        return gs.updatePath(t, n.path, () => n.value);
      case "append-text":
        return gs.updatePath(t, n.path, (i) => {
          if (typeof i != "string")
            throw new Error(`Expected string at path [${n.path.join(", ")}]`);
          return i + n.value;
        });
      default: {
        const i = r;
        throw new Error(`Invalid operation type: ${i}`);
      }
    }
  }
  static updatePath(t, n, r) {
    if (n.length === 0)
      return r(t);
    if (t ?? (t = {}), typeof t != "object")
      throw new Error(`Invalid path: [${n.join(", ")}]`);
    const [i, ...s] = n;
    if (Array.isArray(t)) {
      const o = Number(i);
      if (Number.isNaN(o))
        throw new Error(`Expected array index at [${n.join(", ")}]`);
      if (o > t.length || o < 0)
        throw new Error("Insert array index out of bounds");
      const u = [...t];
      return u[o] = this.updatePath(u[o], s, r), u;
    }
    const a = { ...t };
    return a[i] = this.updatePath(a[i], s, r), a;
  }
}
class BT {
  constructor() {
    O(this, "_streamStartTime");
    O(this, "_firstTokenTime");
    O(this, "_totalChunks", 0);
    O(this, "_toolCallIds", /* @__PURE__ */ new Set());
    this._streamStartTime = Date.now();
  }
  recordChunk() {
    this._totalChunks++;
  }
  recordFirstToken() {
    this._firstTokenTime === void 0 && (this._firstTokenTime = Date.now());
  }
  recordToolCallStart(t) {
    this._toolCallIds.add(t);
  }
  getTiming(t, n) {
    const i = Date.now() - this._streamStartTime, s = t && t > 0 ? t : n ? Math.ceil(n.length / 4) : void 0, a = s && i > 0 ? s / i * 1e3 : void 0;
    return {
      streamStartTime: this._streamStartTime,
      ...this._firstTokenTime !== void 0 ? { firstTokenTime: this._firstTokenTime - this._streamStartTime } : void 0,
      totalStreamTime: i,
      ...s !== void 0 ? { tokenCount: s } : void 0,
      ...a !== void 0 ? { tokensPerSecond: a } : void 0,
      totalChunks: this._totalChunks,
      toolCallCount: this._toolCallIds.size
    };
  }
}
const FT = ({ unstable_state: e = null } = {}) => ({
  role: "assistant",
  status: { type: "running" },
  parts: [],
  get content() {
    return this.parts;
  },
  metadata: {
    unstable_state: e,
    unstable_data: [],
    unstable_annotations: [],
    steps: [],
    custom: {}
  }
}), Do = (e, t, n) => {
  if (e.parts.length === 0)
    throw new Error("No parts available to update.");
  if (t.path.length !== 1)
    throw new Error("Nested paths are not supported yet.");
  const r = t.path[0], i = n(e.parts[r]);
  return {
    ...e,
    parts: [
      ...e.parts.slice(0, r),
      i,
      ...e.parts.slice(r + 1)
    ],
    get content() {
      return this.parts;
    }
  };
}, zT = (e, t) => {
  const n = t.part;
  if (n.type === "text" || n.type === "reasoning") {
    const r = {
      type: n.type,
      text: "",
      status: { type: "running" },
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "tool-call") {
    const r = {
      type: "tool-call",
      state: "partial-call",
      status: { type: "running", isArgsComplete: !1 },
      toolCallId: n.toolCallId,
      toolName: n.toolName,
      argsText: "",
      args: {},
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "source") {
    const r = {
      type: "source",
      sourceType: n.sourceType,
      id: n.id,
      url: n.url,
      ...n.title ? { title: n.title } : void 0,
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "file") {
    const r = {
      type: "file",
      mimeType: n.mimeType,
      data: n.data
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else
    throw new Error(`Unsupported part type: ${n.type}`);
}, VT = (e, t) => Do(e, t, (n) => {
  if (n.type !== "tool-call")
    throw new Error("Last is not a tool call");
  return n.state !== "partial-call" ? n : {
    ...n,
    state: "call"
  };
}), WT = (e, t) => Do(e, t, (n) => ({
  ...n,
  status: { type: "complete", reason: "unknown" }
})), $T = (e, t) => Do(e, t, (n) => {
  if (n.type === "text" || n.type === "reasoning")
    return { ...n, text: n.text + t.textDelta };
  if (n.type === "tool-call") {
    const r = n.argsText + t.textDelta, i = Io(r) ?? n.args;
    return { ...n, argsText: r, args: i };
  } else
    throw new Error("text-delta received but part is neither text nor tool-call");
}), YT = (e, t) => Do(e, t, (n) => {
  if (n.type === "tool-call")
    return {
      ...n,
      state: "result",
      ...t.artifact !== void 0 ? { artifact: t.artifact } : {},
      result: t.result,
      isError: t.isError ?? !1,
      ...t.messages !== void 0 ? { messages: t.messages } : {},
      status: { type: "complete", reason: "stop" }
    };
  throw new Error("Result chunk received but part is not a tool-call");
}), bf = (e, t) => {
  if (e.status?.type === "incomplete" && e.status?.reason === "error")
    return e;
  const n = GT(t);
  return { ...e, status: n };
}, GT = (e) => e.finishReason === "tool-calls" ? {
  type: "requires-action",
  reason: "tool-calls"
} : e.finishReason === "stop" || e.finishReason === "unknown" ? {
  type: "complete",
  reason: e.finishReason
} : {
  type: "incomplete",
  reason: e.finishReason
}, qT = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    unstable_annotations: [
      ...e.metadata.unstable_annotations,
      ...t.annotations
    ]
  }
}), KT = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    unstable_data: [...e.metadata.unstable_data, ...t.data]
  }
}), QT = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    steps: [
      ...e.metadata.steps,
      { state: "started", messageId: t.messageId }
    ]
  }
}), XT = (e, t) => {
  const n = e.metadata.steps.slice(), r = n.length - 1;
  return n.length > 0 && n[r]?.state === "started" ? n[r] = {
    ...n[r],
    state: "finished",
    finishReason: t.finishReason,
    usage: t.usage,
    isContinued: t.isContinued
  } : n.push({
    state: "finished",
    messageId: Yp(),
    finishReason: t.finishReason,
    usage: t.usage,
    isContinued: t.isContinued
  }), {
    ...e,
    metadata: {
      ...e.metadata,
      steps: n
    }
  };
}, JT = (e, t) => ({
  ...e,
  status: { type: "incomplete", reason: "error", error: t.error }
}), ZT = (e, t) => {
  const n = new gs(e.metadata.unstable_state);
  return n.append(t.operations), {
    ...e,
    metadata: {
      ...e.metadata,
      unstable_state: n.state
    }
  };
}, Ef = (e, t) => {
  let n = 0;
  for (const i of t.metadata.steps)
    i.state === "finished" && i.usage && (n += i.usage.outputTokens);
  let r = "";
  for (const i of t.parts)
    (i.type === "text" || i.type === "reasoning") && (r += i.text);
  return e.getTiming(n > 0 ? n : void 0, r || void 0);
}, eA = (e) => {
  let t = !1;
  return () => {
    t || (t = !0, queueMicrotask(() => {
      t = !1, e();
    }));
  };
};
class tA extends TransformStream {
  constructor({ initialMessage: t, throttle: n, onError: r } = {}) {
    let i = t ?? FT();
    const s = new BT();
    let a;
    const o = n ? eA(() => {
      a?.enqueue(i);
    }) : () => {
      a?.enqueue(i);
    };
    super({
      start(u) {
        a = u;
      },
      transform(u) {
        s.recordChunk();
        const c = u.type;
        switch (c) {
          case "part-start":
            i = zT(i, u), u.part.type === "tool-call" && s.recordToolCallStart(u.part.toolCallId);
            break;
          case "tool-call-args-text-finish":
            i = VT(i, u);
            break;
          case "part-finish":
            i = WT(i, u);
            break;
          case "text-delta":
            i = $T(i, u), s.recordFirstToken();
            break;
          case "result":
            i = YT(i, u);
            break;
          case "message-finish":
            i = bf(i, u);
            break;
          case "annotations":
            i = qT(i, u);
            break;
          case "data":
            i = KT(i, u);
            break;
          case "step-start":
            i = QT(i, u);
            break;
          case "step-finish":
            i = XT(i, u);
            break;
          case "error":
            i = JT(i, u), r?.(u.error);
            break;
          case "update-state":
            i = ZT(i, u);
            break;
          default: {
            const l = c;
            throw new Error(`Unsupported chunk type: ${l}`);
          }
        }
        i.status.type !== "running" && (i = {
          ...i,
          metadata: {
            ...i.metadata,
            timing: Ef(s, i)
          }
        }), o();
      },
      flush(u) {
        if (i.status?.type === "running") {
          const c = i.parts?.some((l) => l.type === "tool-call" && (l.state === "call" || l.state === "partial-call") && l.result === void 0) ?? !1;
          i = bf(i, {
            finishReason: c ? "tool-calls" : "unknown"
          }), i = {
            ...i,
            metadata: {
              ...i.metadata,
              timing: Ef(s, i)
            }
          }, u.enqueue(i);
        }
      }
    });
  }
}
class nA extends OT {
  constructor() {
    super((t) => {
      const n = new PT({
        transform(r, i) {
          i.appendText(r);
        }
      });
      return t.pipeThrough(new TextDecoderStream()).pipeThrough(n);
    });
  }
}
class bs {
  constructor(t) {
    O(this, "readable");
    this.readable = t, this.readable = t;
  }
  static fromAssistantStream(t) {
    return new bs(t.pipeThrough(new tA()));
  }
  async unstable_result() {
    let t;
    for await (const n of this)
      t = n;
    return t || {
      role: "assistant",
      status: { type: "complete", reason: "unknown" },
      parts: [],
      content: [],
      metadata: {
        unstable_state: null,
        unstable_data: [],
        unstable_annotations: [],
        steps: [],
        custom: {}
      }
    };
  }
  [Symbol.asyncIterator]() {
    const t = this.readable.getReader();
    return {
      async next() {
        const { done: n, value: r } = await t.read();
        return n ? { done: !0, value: void 0 } : { done: !1, value: r };
      }
    };
  }
  tee() {
    const [t, n] = this.readable.tee();
    return [
      new bs(t),
      new bs(n)
    ];
  }
}
const _f = /* @__PURE__ */ Symbol.for("aui.tool-response");
class to {
  constructor(t) {
    O(this, "artifact");
    O(this, "result");
    O(this, "isError");
    O(this, "messages");
    t.artifact !== void 0 && (this.artifact = t.artifact), this.result = t.result, this.isError = t.isError ?? !1, t.messages !== void 0 && (this.messages = t.messages);
  }
  get [_f]() {
    return !0;
  }
  static [Symbol.hasInstance](t) {
    return typeof t == "object" && t !== null && _f in t;
  }
  static toResponse(t) {
    return t instanceof to ? t : new to({
      result: t === void 0 ? "<no result>" : t
    });
  }
}
const Kr = (e) => {
  const [, t] = In(e.getState);
  return wt(() => (t(e.getState()), e.subscribe(() => {
    t(e.getState());
  })), [e]), e.getState();
}, Gp = Xe(({ runtime: e }) => {
  const t = Kr(e);
  return {
    getState: () => t,
    remove: e.remove,
    __internal_getRuntime: () => e
  };
}), rA = Xe(({ runtime: e }) => {
  const t = Kr(e);
  return {
    getState: () => t,
    addToolResult: (n) => e.addToolResult(n),
    resumeToolCall: (n) => e.resumeToolCall(n),
    __internal_getRuntime: () => e
  };
}), iA = Xe(({ runtime: e, index: t }) => {
  const n = qe(() => e.getAttachmentByIndex(t), [e, t]);
  return Jt(Gp({
    runtime: n
  }));
}), qp = Xe(({ threadIdRef: e, messageIdRef: t, runtime: n }) => {
  const r = Kr(n), i = gl();
  wt(() => {
    const o = [];
    for (const u of ["send", "attachmentAdd"]) {
      const c = n.unstable_on(u, () => {
        i(`composer.${u}`, {
          threadId: e.current,
          ...t && { messageId: t.current }
        });
      });
      o.push(c);
    }
    return o.push(n.unstable_on("attachmentAddError", () => {
      const u = n.getState().attachments.findLast((c) => c.status.type === "incomplete" && c.status.reason === "error");
      i("composer.attachmentAddError", {
        threadId: e.current,
        ...t && { messageId: t.current },
        ...u && { attachmentId: u.id }
      });
    })), () => {
      for (const u of o)
        u();
    };
  }, [n, i, e, t]);
  const s = Ai(() => r.attachments.map((o, u) => Gn(o.id, iA({
    runtime: n,
    index: u
  }))), [r.attachments, n]), a = qe(() => ({
    text: r.text,
    role: r.role,
    attachments: s.state,
    runConfig: r.runConfig,
    isEditing: r.isEditing,
    canCancel: r.canCancel,
    attachmentAccept: r.attachmentAccept,
    isEmpty: r.isEmpty,
    type: r.type ?? "thread",
    dictation: r.dictation,
    quote: r.quote,
    queue: []
  }), [r, s.state]);
  return {
    getState: () => a,
    setText: n.setText,
    setRole: n.setRole,
    setRunConfig: n.setRunConfig,
    addAttachment: n.addAttachment,
    reset: n.reset,
    clearAttachments: n.clearAttachments,
    send: n.send,
    cancel: n.cancel,
    beginEdit: n.beginEdit ?? (() => {
      throw new Error("beginEdit is not supported in this runtime");
    }),
    startDictation: n.startDictation,
    stopDictation: n.stopDictation,
    setQuote: n.setQuote,
    attachment: (o) => "id" in o ? s.get({ key: o.id }) : s.get(o),
    queueItem: () => {
      throw new Error("Queue is not supported in this runtime");
    },
    __internal_getRuntime: () => n
  };
}), sA = Xe(({ runtime: e, index: t }) => {
  const n = qe(() => e.getAttachmentByIndex(t), [e, t]);
  return Jt(Gp({ runtime: n }));
}), aA = Xe(({ runtime: e, index: t }) => {
  const n = qe(() => e.getMessagePartByIndex(t), [e, t]);
  return Jt(rA({ runtime: n }));
}), oA = Xe(({ runtime: e, threadIdRef: t }) => {
  const n = Kr(e), [r, i] = In(!1), [s, a] = In(!1), o = qe(() => ({
    get current() {
      return e.getState().id;
    }
  }), [e]), u = So(qp({
    runtime: e.composer,
    threadIdRef: t,
    messageIdRef: o
  })), c = Ai(() => n.content.map((h, m) => Gn("toolCallId" in h && h.toolCallId != null ? `toolCallId-${h.toolCallId}` : `index-${m}`, aA({ runtime: e, index: m }))), [n.content, e]), l = Ai(() => (n.attachments ?? []).map((h, m) => Gn(h.id, sA({ runtime: e, index: m }))), [n.attachments, e]), d = qe(() => ({
    ...n,
    parts: c.state,
    composer: u.state,
    isCopied: r,
    isHovering: s
  }), [
    n,
    c.state,
    u.state,
    r,
    s
  ]);
  return {
    getState: () => d,
    composer: () => u.methods,
    reload: (h) => e.reload(h),
    speak: () => e.speak(),
    stopSpeaking: () => e.stopSpeaking(),
    submitFeedback: (h) => e.submitFeedback(h),
    switchToBranch: (h) => e.switchToBranch(h),
    getCopyText: () => e.unstable_getCopyText(),
    part: (h) => "index" in h ? c.get({ index: h.index }) : c.get({ key: `toolCallId-${h.toolCallId}` }),
    attachment: (h) => "id" in h ? l.get({ key: h.id }) : l.get(h),
    setIsCopied: i,
    setIsHovering: a,
    __internal_getRuntime: () => e
  };
}), uA = Xe(({ runtime: e, id: t, threadIdRef: n }) => {
  const r = qe(() => e.getMessageById(t), [e, t]);
  return Jt(oA({ runtime: r, threadIdRef: n }));
}), cA = Xe(({ runtime: e }) => {
  const t = Kr(e), n = gl();
  wt(() => {
    const o = [], u = [
      "runStart",
      "runEnd",
      "initialize",
      "modelContextUpdate"
    ];
    for (const c of u) {
      const l = e.unstable_on(c, () => {
        const d = e.getState()?.threadId || "unknown";
        n(`thread.${c}`, {
          threadId: d
        });
      });
      o.push(l);
    }
    return () => {
      for (const c of o)
        c();
    };
  }, [e, n]);
  const r = qe(() => ({
    get current() {
      return e.getState().threadId;
    }
  }), [e]), i = So(qp({
    runtime: e.composer,
    threadIdRef: r
  })), s = Ai(() => t.messages.map((o) => Gn(o.id, uA({ runtime: e, id: o.id, threadIdRef: r }))), [t.messages, e, r]), a = qe(() => ({
    isEmpty: s.state.length === 0 && !t.isLoading,
    isDisabled: t.isDisabled,
    isLoading: t.isLoading,
    isRunning: t.isRunning,
    capabilities: t.capabilities,
    state: t.state,
    suggestions: t.suggestions,
    extras: t.extras,
    speech: t.speech,
    composer: i.state,
    messages: s.state
  }), [t, s, i.state]);
  return {
    getState: () => a,
    composer: () => i.methods,
    append: e.append,
    startRun: e.startRun,
    resumeRun: e.resumeRun,
    unstable_resumeRun: e.resumeRun,
    cancelRun: e.cancelRun,
    getModelContext: e.getModelContext,
    export: e.export,
    import: e.import,
    reset: e.reset,
    stopSpeaking: e.stopSpeaking,
    startVoice: async () => {
      throw new Error("startVoice is not supported in this runtime");
    },
    stopVoice: async () => {
      throw new Error("stopVoice is not supported in this runtime");
    },
    message: (o) => "id" in o ? s.get({ key: o.id }) : s.get(o),
    __internal_getRuntime: () => e
  };
}), Kp = Xe(({ runtime: e }) => {
  const t = Kr(e), n = gl();
  return wt(() => {
    const r = [], i = [
      "switchedTo",
      "switchedAway"
    ];
    for (const s of i) {
      const a = e.unstable_on(s, () => {
        n(`threadListItem.${s}`, {
          threadId: e.getState().id
        });
      });
      r.push(a);
    }
    return () => {
      for (const s of r)
        s();
    };
  }, [e, n]), {
    getState: () => t,
    switchTo: e.switchTo,
    rename: e.rename,
    archive: e.archive,
    unarchive: e.unarchive,
    delete: e.delete,
    generateTitle: e.generateTitle,
    initialize: e.initialize,
    detach: e.detach,
    __internal_getRuntime: () => e
  };
}), lA = Xe(({ runtime: e, id: t }) => {
  const n = qe(() => e.getItemById(t), [e, t]);
  return Jt(Kp({
    runtime: n
  }));
}), dA = Xe(({ runtime: e, __internal_assistantRuntime: t }) => {
  const n = Kr(e), r = So(cA({
    runtime: e.main
  })), i = Ai(() => Object.keys(n.threadItems).map((a) => Gn(a, lA({ runtime: e, id: a }))), [n.threadItems, e]), s = qe(() => ({
    mainThreadId: n.mainThreadId,
    newThreadId: n.newThreadId ?? null,
    isLoading: n.isLoading,
    threadIds: n.threadIds,
    archivedThreadIds: n.archivedThreadIds,
    threadItems: i.state,
    main: r.state
  }), [n, i.state, r.state]);
  return {
    getState: () => s,
    thread: () => r.methods,
    item: (a) => {
      if (a === "main")
        return i.get({ key: s.mainThreadId });
      if ("id" in a)
        return i.get({ key: a.id });
      const { index: o, archived: u = !1 } = a, c = u ? s.archivedThreadIds[o] : s.threadIds[o];
      return i.get({ key: c });
    },
    switchToThread: async (a) => {
      await e.switchToThread(a);
    },
    switchToNewThread: async () => {
      await e.switchToNewThread();
    },
    __internal_getAssistantRuntime: () => t
  };
}), fA = Xe((e) => {
  const t = Hp();
  return wt(() => e.registerModelContextProvider(t.current.modelContext()), [e, t]), Jt(dA({
    runtime: e.threads,
    __internal_assistantRuntime: e
  }));
}), hA = (e, t) => {
  e.thread ?? (e.thread = $n({
    source: "threads",
    query: { type: "main" },
    get: (n) => n.threads().thread("main")
  })), e.threadListItem ?? (e.threadListItem = $n({
    source: "threads",
    query: { type: "main" },
    get: (n) => n.threads().item("main")
  })), e.composer ?? (e.composer = $n({
    source: "thread",
    query: {},
    get: (n) => n.threads().thread("main").composer()
  })), !e.modelContext && t.modelContext.source === null && (e.modelContext = Bp()), !e.suggestions && t.suggestions.source === null && (e.suggestions = AT());
}, mA = ({ runtime: e, children: t }) => {
  const n = Ve({
    threadListItem: Kp({ runtime: e })
  });
  return S.jsx(qr, { value: n, children: t });
}, Qp = ({ index: e, children: t }) => {
  const n = Ve({
    message: $n({
      source: "thread",
      query: { type: "index", index: e },
      get: (r) => r.thread().message({ index: e })
    }),
    composer: $n({
      source: "message",
      query: {},
      get: (r) => r.thread().message({ index: e }).composer()
    })
  });
  return S.jsx(qr, { value: n, children: t });
}, Xp = ({ index: e, children: t }) => {
  const n = Ve({
    part: $n({
      source: "message",
      query: { type: "index", index: e },
      get: (r) => r.message().part({ index: e })
    })
  });
  return S.jsx(qr, { value: n, children: t });
}, pA = Xe(({ text: e, isRunning: t }) => {
  const n = qe(() => ({
    type: "text",
    text: e,
    status: t ? { type: "running" } : { type: "complete" }
  }), [e, t]);
  return {
    getState: () => n,
    addToolResult: () => {
      throw new Error("Not supported");
    },
    resumeToolCall: () => {
      throw new Error("Not supported");
    }
  };
}), gA = ({ text: e, isRunning: t = !1, children: n }) => {
  const r = Ve({
    part: pA({ text: e, isRunning: t })
  });
  return S.jsx(qr, { value: r, children: n });
}, bA = ({ startIndex: e, endIndex: t, children: n }) => {
  const r = oe((a) => a.message.parts).slice(e, t + 1), i = Ve(), s = Ve({
    chainOfThought: NT({
      parts: r,
      getMessagePart: ({ index: a }) => {
        if (a < 0 || a >= r.length)
          throw new Error(`ChainOfThought part index ${a} is out of bounds (0..${r.length - 1})`);
        return i.message().part({ index: e + a });
      }
    })
  });
  return S.jsx(qr, { value: s, children: n });
}, Jp = ({ index: e, archived: t, children: n }) => {
  const r = Ve({
    threadListItem: $n({
      source: "threads",
      query: { type: "index", index: e, archived: t },
      get: (i) => i.threads().item({ index: e, archived: t })
    })
  });
  return S.jsx(qr, { value: r, children: n });
}, mn = /* @__PURE__ */ Symbol("skip-update");
function EA(e, t) {
  if (e === void 0 && t === void 0)
    return !0;
  if (e === void 0 || t === void 0)
    return !1;
  for (const n of Object.keys(e)) {
    const r = e[n], i = t[n];
    if (!Object.is(r, i))
      return !1;
  }
  return !0;
}
class zs {
  constructor() {
    O(this, "_subscribers", /* @__PURE__ */ new Set());
  }
  subscribe(t) {
    return this._subscribers.add(t), () => this._subscribers.delete(t);
  }
  waitForUpdate() {
    return new Promise((t) => {
      const n = this.subscribe(() => {
        n(), t();
      });
    });
  }
  _notifySubscribers() {
    const t = [];
    for (const n of this._subscribers)
      try {
        n();
      } catch (r) {
        t.push(r);
      }
    if (t.length > 0) {
      if (t.length === 1)
        throw t[0];
      for (const n of t)
        console.error(n);
      throw new AggregateError(t);
    }
  }
}
class Ro {
  constructor() {
    O(this, "_subscriptions", /* @__PURE__ */ new Set());
    O(this, "_connection");
  }
  get isConnected() {
    return !!this._connection;
  }
  notifySubscribers() {
    for (const t of this._subscriptions)
      t();
  }
  _updateConnection() {
    if (this._subscriptions.size > 0) {
      if (this._connection)
        return;
      this._connection = this._connect();
    } else
      this._connection?.(), this._connection = void 0;
  }
  subscribe(t) {
    return this._subscriptions.add(t), this._updateConnection(), () => {
      this._subscriptions.delete(t), this._updateConnection();
    };
  }
}
class fn extends Ro {
  constructor(n) {
    super();
    O(this, "binding");
    O(this, "_previousState");
    O(this, "getState", () => (this.isConnected || this._syncState(), this._previousState));
    this.binding = n;
    const r = n.getState();
    if (r === mn)
      throw new Error("Entry not available in the store");
    this._previousState = r;
  }
  get path() {
    return this.binding.path;
  }
  _syncState() {
    const n = this.binding.getState();
    return n === mn || EA(n, this._previousState) ? !1 : (this._previousState = n, !0);
  }
  _connect() {
    const n = () => {
      this._syncState() && this.notifySubscribers();
    };
    return this.binding.subscribe(n);
  }
}
class xl extends Ro {
  constructor(n) {
    super();
    O(this, "binding");
    O(this, "_previousStateDirty", !0);
    O(this, "_previousState");
    O(this, "getState", () => {
      if (!this.isConnected || this._previousStateDirty) {
        const n = this.binding.getState();
        n !== mn && (this._previousState = n), this._previousStateDirty = !1;
      }
      if (this._previousState === void 0)
        throw new Error("Entry not available in the store");
      return this._previousState;
    });
    this.binding = n;
  }
  get path() {
    return this.binding.path;
  }
  _connect() {
    const n = () => {
      this._previousStateDirty = !0, this.notifySubscribers();
    };
    return this.binding.subscribe(n);
  }
}
class no extends Ro {
  constructor(n) {
    super();
    O(this, "binding");
    this.binding = n;
  }
  get path() {
    return this.binding.path;
  }
  getState() {
    return this.binding.getState();
  }
  outerSubscribe(n) {
    return this.binding.subscribe(n);
  }
  _connect() {
    const n = () => {
      this.notifySubscribers();
    };
    let r = this.binding.getState(), i = r?.subscribe(n);
    const s = () => {
      const o = this.binding.getState();
      o !== r && (r = o, i?.(), i = o?.subscribe(n), n());
    }, a = this.outerSubscribe(s);
    return () => {
      a?.(), i?.();
    };
  }
}
class Zp extends Ro {
  constructor(n) {
    super();
    O(this, "config");
    this.config = n;
  }
  getState() {
    return this.config.binding.getState();
  }
  outerSubscribe(n) {
    return this.config.binding.subscribe(n);
  }
  _connect() {
    const n = () => {
      this.notifySubscribers();
    };
    let r = this.config.binding.getState(), i = r?.unstable_on(this.config.event, n);
    const s = () => {
      const o = this.config.binding.getState();
      o !== r && (r = o, i?.(), i = o?.unstable_on(this.config.event, n));
    }, a = this.outerSubscribe(s);
    return () => {
      a?.(), i?.();
    };
  }
}
class Tl {
  constructor() {
    O(this, "_contextProvider", new El());
  }
  registerModelContextProvider(t) {
    return this._contextProvider.registerModelContextProvider(t);
  }
  getModelContextProvider() {
    return this._contextProvider;
  }
}
const ro = (e) => e.content.filter((n) => n.type === "text").map((n) => n.text).join(`

`), dr = $p("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 7), _A = "__optimistic__", xA = () => `${_A}${dr()}`, Po = /* @__PURE__ */ Symbol("autoStatus"), TA = Object.freeze(Object.assign({ type: "running" }, { [Po]: !0 })), AA = Object.freeze(Object.assign({
  type: "complete",
  reason: "unknown"
}, { [Po]: !0 })), yA = Object.freeze(Object.assign({
  type: "requires-action",
  reason: "tool-calls"
}, { [Po]: !0 })), NA = Object.freeze(Object.assign({
  type: "requires-action",
  reason: "interrupt"
}, { [Po]: !0 })), eg = (e, t, n, r, i) => e && t ? TA : n ? NA : r ? yA : AA, Au = (e, t) => {
  if (e.startsWith("data-"))
    return { type: "data", name: e.substring(5), data: t };
}, Vs = (e, t, n) => {
  const { role: r, id: i, createdAt: s, attachments: a, status: o, metadata: u } = e, c = {
    id: i ?? t,
    createdAt: s ?? /* @__PURE__ */ new Date()
  }, l = typeof e.content == "string" ? [{ type: "text", text: e.content }] : e.content, d = ({ image: h, ...m }) => h.match(/^data:image\/(png|jpeg|jpg|gif|webp);base64,(.*)$/) ? { ...m, image: h } : (console.warn("Invalid image data format detected"), null);
  if (r !== "user" && a?.length)
    throw new Error("attachments are only supported for user messages");
  if (r !== "assistant" && o)
    throw new Error("status is only supported for assistant messages");
  if (r !== "assistant" && u?.steps)
    throw new Error("metadata.steps is only supported for assistant messages");
  switch (r) {
    case "assistant":
      return {
        ...c,
        role: r,
        content: l.map((h) => {
          const m = h.type;
          switch (m) {
            case "text":
            case "reasoning":
              return h.text.trim().length === 0 ? null : h;
            case "file":
            case "source":
              return h;
            case "image":
              return d(h);
            case "data":
              return h;
            case "tool-call": {
              const { parentId: E, messages: g, ...T } = h, _ = {
                ...T,
                toolCallId: h.toolCallId ?? `tool-${dr()}`,
                ...E !== void 0 && { parentId: E },
                ...g !== void 0 && { messages: g }
              };
              return h.args ? {
                ..._,
                args: h.args,
                argsText: h.argsText ?? JSON.stringify(h.args)
              } : {
                ..._,
                args: Io(h.argsText ?? "") ?? {},
                argsText: h.argsText ?? ""
              };
            }
            default: {
              const E = Au(m, h.data);
              if (E)
                return E;
              throw new Error(`Unsupported assistant message part type: ${m}`);
            }
          }
        }).filter((h) => !!h),
        status: o ?? n,
        metadata: {
          unstable_state: u?.unstable_state ?? null,
          unstable_annotations: u?.unstable_annotations ?? [],
          unstable_data: u?.unstable_data ?? [],
          custom: u?.custom ?? {},
          steps: u?.steps ?? [],
          ...u?.timing && { timing: u.timing },
          ...u?.submittedFeedback && {
            submittedFeedback: u.submittedFeedback
          }
        }
      };
    case "user":
      return {
        ...c,
        role: r,
        content: l.map((h) => {
          const m = h.type;
          switch (m) {
            case "text":
            case "image":
            case "audio":
            case "file":
            case "data":
              return h;
            default: {
              const E = Au(m, h.data);
              if (E)
                return E;
              throw new Error(`Unsupported user message part type: ${m}`);
            }
          }
        }),
        attachments: (a ?? []).map((h) => ({
          ...h,
          content: h.content.map((m) => Au(m.type, m.data) ?? m)
        })),
        metadata: {
          custom: u?.custom ?? {}
        }
      };
    case "system":
      if (l.length !== 1 || l[0].type !== "text")
        throw new Error("System messages must have exactly one text message part.");
      return {
        ...c,
        role: r,
        content: l,
        metadata: {
          custom: u?.custom ?? {}
        }
      };
    default: {
      const h = r;
      throw new Error(`Unknown message role: ${h}`);
    }
  }
}, Al = {
  fromArray: (e) => {
    const t = e.map((n) => Vs(n, dr(), eg(!1, !1, !1, !1)));
    return {
      messages: t.map((n, r) => ({
        parentId: r > 0 ? t[r - 1].id : null,
        message: n
      }))
    };
  }
}, ja = (e) => e.next ? ja(e.next) : "current" in e ? e : null;
class vA {
  constructor(t) {
    O(this, "func");
    O(this, "_value", null);
    this.func = t;
  }
  get value() {
    return this._value === null && (this._value = this.func()), this._value;
  }
  dirty() {
    this._value = null;
  }
}
class tg {
  constructor() {
    O(this, "messages", /* @__PURE__ */ new Map());
    O(this, "head", null);
    O(this, "root", {
      children: [],
      next: null
    });
    O(this, "_messages", new vA(() => {
      const t = new Array((this.head?.level ?? -1) + 1);
      for (let n = this.head; n; n = n.prev)
        t[n.level] = n.current;
      return t;
    }));
  }
  updateLevels(t, n) {
    t.level = n;
    for (const r of t.children) {
      const i = this.messages.get(r);
      i && this.updateLevels(i, n + 1);
    }
  }
  performOp(t, n, r) {
    const i = n.prev ?? this.root, s = t ?? this.root;
    if (!(r === "relink" && i === s)) {
      if (r !== "link" && (i.children = i.children.filter((a) => a !== n.current.id), i.next === n)) {
        const a = i.children.at(-1), o = a ? this.messages.get(a) : null;
        if (o === void 0)
          throw new Error("MessageRepository(performOp/cut): Fallback sibling message not found. This is likely an internal bug in assistant-ui.");
        i.next = o;
      }
      if (r !== "cut") {
        for (let o = t; o; o = o.prev)
          if (o.current.id === n.current.id)
            throw new Error("MessageRepository(performOp/link): A message with the same id already exists in the parent tree. This error occurs if the same message id is found multiple times. This is likely an internal bug in assistant-ui.");
        s.children = [
          ...s.children,
          n.current.id
        ], (ja(n) === this.head || s.next === null) && (s.next = n), n.prev = t;
        const a = t ? t.level + 1 : 0;
        this.updateLevels(n, a);
      }
    }
  }
  get headId() {
    return this.head?.current.id ?? null;
  }
  getMessages(t) {
    if (t === void 0 || t === this.head?.current.id)
      return this._messages.value;
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(getMessages): Head message not found. This is likely an internal bug in assistant-ui.");
    const r = new Array(n.level + 1);
    for (let i = n; i; i = i.prev)
      r[i.level] = i.current;
    return r;
  }
  addOrUpdateMessage(t, n) {
    const r = this.messages.get(n.id), i = t ? this.messages.get(t) : null;
    if (i === void 0)
      throw new Error("MessageRepository(addOrUpdateMessage): Parent message not found. This is likely an internal bug in assistant-ui.");
    if (r) {
      r.current = n, this.performOp(i, r, "relink"), this._messages.dirty();
      return;
    }
    const s = {
      prev: i,
      current: n,
      next: null,
      children: [],
      level: i ? i.level + 1 : 0
    };
    this.messages.set(n.id, s), this.performOp(i, s, "link"), this.head === i && (this.head = s), this._messages.dirty();
  }
  getMessage(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(updateMessage): Message not found. This is likely an internal bug in assistant-ui.");
    return {
      parentId: n.prev?.current.id ?? null,
      message: n.current,
      index: n.level
    };
  }
  appendOptimisticMessage(t, n) {
    let r;
    do
      r = xA();
    while (this.messages.has(r));
    return this.addOrUpdateMessage(t, Vs(n, r, { type: "running" })), r;
  }
  deleteMessage(t, n) {
    const r = this.messages.get(t);
    if (!r)
      throw new Error("MessageRepository(deleteMessage): Message not found. This is likely an internal bug in assistant-ui.");
    const i = n === void 0 ? r.prev : n === null ? null : this.messages.get(n);
    if (i === void 0)
      throw new Error("MessageRepository(deleteMessage): Replacement not found. This is likely an internal bug in assistant-ui.");
    for (const s of r.children) {
      const a = this.messages.get(s);
      if (!a)
        throw new Error("MessageRepository(deleteMessage): Child message not found. This is likely an internal bug in assistant-ui.");
      this.performOp(i, a, "relink");
    }
    this.performOp(null, r, "cut"), this.messages.delete(t), this.head === r && (this.head = ja(i ?? this.root)), this._messages.dirty();
  }
  getBranches(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(getBranches): Message not found. This is likely an internal bug in assistant-ui.");
    const { children: r } = n.prev ?? this.root;
    return r;
  }
  switchToBranch(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(switchToBranch): Branch not found. This is likely an internal bug in assistant-ui.");
    const r = n.prev ?? this.root;
    r.next = n, this.head = ja(n), this._messages.dirty();
  }
  resetHead(t) {
    if (t === null) {
      this.clear();
      return;
    }
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(resetHead): Branch not found. This is likely an internal bug in assistant-ui.");
    if (n.children.length > 0) {
      const r = (i) => {
        for (const s of i.children) {
          const a = this.messages.get(s);
          a && (r(a), this.messages.delete(s));
        }
      };
      r(n), n.children = [], n.next = null;
    }
    this.head = n;
    for (let r = n; r; r = r.prev)
      r.prev ? r.prev.next = r : this.root.next = r;
    this._messages.dirty();
  }
  clear() {
    this.messages.clear(), this.head = null, this.root = {
      children: [],
      next: null
    }, this._messages.dirty();
  }
  export() {
    const t = [];
    for (const [, n] of this.messages)
      t.push({
        message: n.current,
        parentId: n.prev?.current.id ?? null
      });
    return {
      headId: this.head?.current.id ?? null,
      messages: t
    };
  }
  import({ headId: t, messages: n }) {
    for (const { message: r, parentId: i } of n)
      this.addOrUpdateMessage(i, r);
    this.resetHead(t ?? n.at(-1)?.message.id ?? null);
  }
}
function wA(e, t) {
  if (t === "*")
    return !0;
  const n = t.split(",").map((s) => s.trim().toLowerCase()), r = `.${e.name.split(".").pop().toLowerCase()}`, i = e.type.toLowerCase();
  for (const s of n) {
    if (s.startsWith(".") && s === r || s.includes("/") && s === i)
      return !0;
    if (s.endsWith("/*")) {
      const a = s.split("/")[0];
      if (i.startsWith(`${a}/`))
        return !0;
    }
  }
  return !1;
}
const yu = (e) => e.status.type === "complete";
class ng extends zs {
  constructor() {
    super(...arguments);
    O(this, "isEditing", !0);
    O(this, "_attachments", []);
    O(this, "_text", "");
    O(this, "_role", "user");
    O(this, "_runConfig", {});
    O(this, "_quote");
    O(this, "_dictation");
    O(this, "_dictationSession");
    O(this, "_dictationUnsubscribes", []);
    O(this, "_dictationBaseText", "");
    O(this, "_currentInterimText", "");
    O(this, "_dictationSessionIdCounter", 0);
    O(this, "_activeDictationSessionId");
    O(this, "_isCleaningDictation", !1);
    O(this, "_eventSubscribers", /* @__PURE__ */ new Map());
  }
  get attachmentAccept() {
    return this.getAttachmentAdapter()?.accept ?? "*";
  }
  get attachments() {
    return this._attachments;
  }
  setAttachments(n) {
    this._attachments = n, this._notifySubscribers();
  }
  get isEmpty() {
    return !this.text.trim() && !this.attachments.length;
  }
  get text() {
    return this._text;
  }
  get role() {
    return this._role;
  }
  get runConfig() {
    return this._runConfig;
  }
  get quote() {
    return this._quote;
  }
  setQuote(n) {
    this._quote !== n && (this._quote = n, this._notifySubscribers());
  }
  setText(n) {
    if (this._text !== n) {
      if (this._text = n, this._dictation) {
        this._dictationBaseText = n, this._currentInterimText = "";
        const { status: r, inputDisabled: i } = this._dictation;
        this._dictation = i ? { status: r, inputDisabled: i } : { status: r };
      }
      this._notifySubscribers();
    }
  }
  setRole(n) {
    this._role !== n && (this._role = n, this._notifySubscribers());
  }
  setRunConfig(n) {
    this._runConfig !== n && (this._runConfig = n, this._notifySubscribers());
  }
  _emptyTextAndAttachments() {
    this._attachments = [], this._text = "", this._notifySubscribers();
  }
  async _onClearAttachments() {
    const n = this.getAttachmentAdapter();
    if (n) {
      const r = this._attachments.filter((i) => !yu(i));
      await Promise.all(r.map((i) => n.remove(i)));
    }
  }
  async reset() {
    if (this._attachments.length === 0 && this._text === "" && this._role === "user" && Object.keys(this._runConfig).length === 0 && this._quote === void 0)
      return;
    this._role = "user", this._runConfig = {}, this._quote = void 0;
    const n = this._onClearAttachments();
    this._emptyTextAndAttachments(), await n;
  }
  async clearAttachments() {
    const n = this._onClearAttachments();
    this.setAttachments([]), await n;
  }
  async send() {
    if (this.isEmpty)
      return;
    this._dictationSession && (this._dictationSession.cancel(), this._cleanupDictation());
    const n = this.getAttachmentAdapter(), r = this.attachments.length > 0 ? Promise.all(this.attachments.map(async (o) => {
      if (yu(o))
        return o;
      if (!n)
        throw new Error("Attachments are not supported");
      return await n.send(o);
    })) : [], i = this.text, s = this._quote;
    this._quote = void 0, this._emptyTextAndAttachments();
    const a = {
      createdAt: /* @__PURE__ */ new Date(),
      role: this.role,
      content: i ? [{ type: "text", text: i }] : [],
      attachments: await r,
      runConfig: this.runConfig,
      metadata: { custom: { ...s ? { quote: s } : {} } }
    };
    this.handleSend(a), this._notifyEventSubscribers("send");
  }
  cancel() {
    this.handleCancel();
  }
  async addAttachment(n) {
    if (!(n instanceof File)) {
      const o = {
        id: n.id ?? dr(),
        type: n.type ?? "document",
        name: n.name,
        contentType: n.contentType,
        content: n.content,
        status: { type: "complete" }
      };
      this._attachments = [...this._attachments, o], this._notifyEventSubscribers("attachmentAdd"), this._notifySubscribers();
      return;
    }
    const r = this.getAttachmentAdapter();
    if (!r)
      throw new Error("Attachments are not supported");
    if (!wA({ name: n.name, type: n.type }, r.accept))
      throw new Error(`File type ${n.type || "unknown"} is not accepted. Accepted types: ${r.accept}`);
    const i = (o) => {
      const u = this._attachments.findIndex((c) => c.id === o.id);
      u !== -1 ? this._attachments = [
        ...this._attachments.slice(0, u),
        o,
        ...this._attachments.slice(u + 1)
      ] : this._attachments = [...this._attachments, o], this._notifySubscribers();
    };
    let s;
    try {
      const o = r.add({ file: n });
      if (Symbol.asyncIterator in o)
        for await (const u of o)
          s = u, i(u);
      else
        s = await o, i(s);
    } catch (o) {
      s && i({
        ...s,
        status: { type: "incomplete", reason: "error" }
      });
      try {
        this._notifyEventSubscribers("attachmentAddError");
      } catch {
      }
      throw o;
    }
    const a = s?.status.type === "incomplete" && s.status.reason === "error";
    this._notifyEventSubscribers(a ? "attachmentAddError" : "attachmentAdd");
  }
  async removeAttachment(n) {
    const r = this._attachments.findIndex((s) => s.id === n);
    if (r === -1)
      throw new Error("Attachment not found");
    const i = this._attachments[r];
    if (!yu(i)) {
      const s = this.getAttachmentAdapter();
      if (!s)
        throw new Error("Attachments are not supported");
      await s.remove(i);
    }
    this._attachments = this._attachments.filter((s) => s.id !== n), this._notifySubscribers();
  }
  get dictation() {
    return this._dictation;
  }
  _isActiveSession(n, r) {
    return this._activeDictationSessionId === n && this._dictationSession === r;
  }
  startDictation() {
    const n = this.getDictationAdapter();
    if (!n)
      throw new Error("Dictation adapter not configured");
    if (this._dictationSession) {
      for (const d of this._dictationUnsubscribes)
        d();
      this._dictationUnsubscribes = [], this._dictationSession.stop().catch(() => {
      }), this._dictationSession = void 0;
    }
    const r = n.disableInputDuringDictation ?? !1;
    this._dictationBaseText = this._text, this._currentInterimText = "";
    const i = n.listen();
    this._dictationSession = i;
    const s = ++this._dictationSessionIdCounter;
    this._activeDictationSessionId = s, this._dictation = { status: i.status, inputDisabled: r }, this._notifySubscribers();
    const a = i.onSpeech((l) => {
      if (!this._isActiveSession(s, i))
        return;
      const d = l.isFinal !== !1, m = this._dictationBaseText && !this._dictationBaseText.endsWith(" ") && l.transcript ? " " : "";
      if (d) {
        if (this._dictationBaseText = this._dictationBaseText + m + l.transcript, this._currentInterimText = "", this._text = this._dictationBaseText, this._dictation) {
          const { transcript: E, ...g } = this._dictation;
          this._dictation = g;
        }
        this._notifySubscribers();
      } else
        this._currentInterimText = m + l.transcript, this._text = this._dictationBaseText + this._currentInterimText, this._dictation && (this._dictation = {
          ...this._dictation,
          transcript: l.transcript
        }), this._notifySubscribers();
    });
    this._dictationUnsubscribes.push(a);
    const o = i.onSpeechStart(() => {
      this._isActiveSession(s, i) && (this._dictation = {
        status: { type: "running" },
        inputDisabled: r,
        ...this._dictation?.transcript && {
          transcript: this._dictation.transcript
        }
      }, this._notifySubscribers());
    });
    this._dictationUnsubscribes.push(o);
    const u = i.onSpeechEnd(() => {
      this._cleanupDictation({ sessionId: s });
    });
    this._dictationUnsubscribes.push(u);
    const c = setInterval(() => {
      this._isActiveSession(s, i) && i.status.type === "ended" && this._cleanupDictation({ sessionId: s });
    }, 100);
    this._dictationUnsubscribes.push(() => clearInterval(c));
  }
  stopDictation() {
    if (!this._dictationSession)
      return;
    const n = this._dictationSession, r = this._activeDictationSessionId;
    n.stop().finally(() => {
      this._cleanupDictation({ sessionId: r });
    });
  }
  _cleanupDictation(n) {
    if (!(n?.sessionId !== void 0 && n.sessionId !== this._activeDictationSessionId || this._isCleaningDictation)) {
      this._isCleaningDictation = !0;
      try {
        for (const i of this._dictationUnsubscribes)
          i();
        this._dictationUnsubscribes = [], this._dictationSession = void 0, this._activeDictationSessionId = void 0, this._dictation = void 0, this._dictationBaseText = "", this._currentInterimText = "", this._notifySubscribers();
      } finally {
        this._isCleaningDictation = !1;
      }
    }
  }
  _notifyEventSubscribers(n) {
    const r = this._eventSubscribers.get(n);
    if (r)
      for (const i of r)
        i();
  }
  unstable_on(n, r) {
    const i = this._eventSubscribers.get(n);
    return i ? i.add(r) : this._eventSubscribers.set(n, /* @__PURE__ */ new Set([r])), () => {
      const s = this._eventSubscribers.get(n);
      s && s.delete(r);
    };
  }
}
class rg extends ng {
  constructor(n) {
    super();
    O(this, "runtime");
    O(this, "_canCancel", !1);
    this.runtime = n, this.connect();
  }
  get canCancel() {
    return this._canCancel;
  }
  getAttachmentAdapter() {
    return this.runtime.adapters?.attachments;
  }
  getDictationAdapter() {
    return this.runtime.adapters?.dictation;
  }
  connect() {
    return this.runtime.subscribe(() => {
      this.canCancel !== this.runtime.capabilities.cancel && (this._canCancel = this.runtime.capabilities.cancel, this._notifySubscribers());
    });
  }
  async handleSend(n) {
    this.runtime.append({
      ...n,
      parentId: this.runtime.messages.at(-1)?.id ?? null,
      sourceId: null
    });
  }
  async handleCancel() {
    this.runtime.cancelRun();
  }
}
class CA extends ng {
  constructor(n, r, { parentId: i, message: s }) {
    super();
    O(this, "runtime");
    O(this, "endEditCallback");
    O(this, "_nonTextParts");
    O(this, "_previousText");
    O(this, "_parentId");
    O(this, "_sourceId");
    this.runtime = n, this.endEditCallback = r, this._parentId = i, this._sourceId = s.id, this._previousText = ro(s), this.setText(this._previousText), this.setRole(s.role), this.setAttachments(s.attachments ?? []), this._nonTextParts = s.content.filter((a) => a.type !== "text"), this.setRunConfig({ ...n.composer.runConfig });
  }
  get canCancel() {
    return !0;
  }
  getAttachmentAdapter() {
    return this.runtime.adapters?.attachments;
  }
  getDictationAdapter() {
    return this.runtime.adapters?.dictation;
  }
  async handleSend(n) {
    ro(n) !== this._previousText && this.runtime.append({
      ...n,
      content: [...n.content, ...this._nonTextParts],
      parentId: this._parentId,
      sourceId: this._sourceId
    }), this.handleCancel();
  }
  handleCancel() {
    this.endEditCallback(), this._notifySubscribers();
  }
}
class SA {
  constructor(t) {
    O(this, "_contextProvider");
    O(this, "_subscriptions", /* @__PURE__ */ new Set());
    O(this, "_isInitialized", !1);
    O(this, "repository", new tg());
    O(this, "composer", new rg(this));
    O(this, "_editComposers", /* @__PURE__ */ new Map());
    O(this, "_stopSpeaking");
    O(this, "speech");
    O(this, "_eventSubscribers", /* @__PURE__ */ new Map());
    this._contextProvider = t;
  }
  get messages() {
    return this.repository.getMessages();
  }
  get state() {
    let t;
    for (const n of this.messages)
      n.role === "assistant" && (t = n);
    return t?.metadata.unstable_state ?? null;
  }
  getModelContext() {
    return this._contextProvider.getModelContext();
  }
  getEditComposer(t) {
    return this._editComposers.get(t);
  }
  beginEdit(t) {
    if (this._editComposers.has(t))
      throw new Error("Edit already in progress");
    this._editComposers.set(t, new CA(this, () => this._editComposers.delete(t), this.repository.getMessage(t))), this._notifySubscribers();
  }
  getMessageById(t) {
    try {
      return this.repository.getMessage(t);
    } catch {
      return;
    }
  }
  getBranches(t) {
    return this.repository.getBranches(t);
  }
  switchToBranch(t) {
    this.repository.switchToBranch(t), this._notifySubscribers();
  }
  _notifySubscribers() {
    for (const t of this._subscriptions)
      t();
  }
  _notifyEventSubscribers(t) {
    const n = this._eventSubscribers.get(t);
    if (n)
      for (const r of n)
        r();
  }
  subscribe(t) {
    return this._subscriptions.add(t), () => this._subscriptions.delete(t);
  }
  submitFeedback({ messageId: t, type: n }) {
    const r = this.adapters?.feedback;
    if (!r)
      throw new Error("Feedback adapter not configured");
    const { message: i, parentId: s } = this.repository.getMessage(t);
    if (r.submit({ message: i, type: n }), i.role === "assistant") {
      const a = {
        ...i,
        metadata: {
          ...i.metadata,
          submittedFeedback: { type: n }
        }
      };
      this.repository.addOrUpdateMessage(s, a);
    }
    this._notifySubscribers();
  }
  speak(t) {
    const n = this.adapters?.speech;
    if (!n)
      throw new Error("Speech adapter not configured");
    const { message: r } = this.repository.getMessage(t);
    this._stopSpeaking?.();
    const i = n.speak(ro(r)), s = i.subscribe(() => {
      i.status.type === "ended" ? (this._stopSpeaking = void 0, this.speech = void 0) : this.speech = { messageId: t, status: i.status }, this._notifySubscribers();
    });
    this.speech = { messageId: t, status: i.status }, this._notifySubscribers(), this._stopSpeaking = () => {
      i.cancel(), s(), this.speech = void 0, this._stopSpeaking = void 0;
    };
  }
  stopSpeaking() {
    if (!this._stopSpeaking)
      throw new Error("No message is being spoken");
    this._stopSpeaking(), this._notifySubscribers();
  }
  ensureInitialized() {
    this._isInitialized || (this._isInitialized = !0, this._notifyEventSubscribers("initialize"));
  }
  export() {
    return this.repository.export();
  }
  import(t) {
    this.ensureInitialized(), this.repository.clear(), this.repository.import(t), this._notifySubscribers();
  }
  reset(t) {
    this.import(Al.fromArray(t ?? []));
  }
  unstable_on(t, n) {
    if (t === "modelContextUpdate")
      return this._contextProvider.subscribe?.(n) ?? (() => {
      });
    const r = this._eventSubscribers.get(t);
    return r ? r.add(n) : this._eventSubscribers.set(t, /* @__PURE__ */ new Set([n])), () => {
      this._eventSubscribers.get(t).delete(n);
    };
  }
}
class ha {
  constructor(t, n) {
    O(this, "_core");
    O(this, "_threadListBinding");
    this._core = t, this._threadListBinding = n, this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.switchTo = this.switchTo.bind(this), this.rename = this.rename.bind(this), this.archive = this.archive.bind(this), this.unarchive = this.unarchive.bind(this), this.delete = this.delete.bind(this), this.initialize = this.initialize.bind(this), this.generateTitle = this.generateTitle.bind(this), this.subscribe = this.subscribe.bind(this), this.unstable_on = this.unstable_on.bind(this), this.getState = this.getState.bind(this), this.detach = this.detach.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  switchTo() {
    const t = this._core.getState();
    return this._threadListBinding.switchToThread(t.id);
  }
  rename(t) {
    const n = this._core.getState();
    return this._threadListBinding.rename(n.id, t);
  }
  archive() {
    const t = this._core.getState();
    return this._threadListBinding.archive(t.id);
  }
  unarchive() {
    const t = this._core.getState();
    return this._threadListBinding.unarchive(t.id);
  }
  delete() {
    const t = this._core.getState();
    return this._threadListBinding.delete(t.id);
  }
  initialize() {
    const t = this._core.getState();
    return this._threadListBinding.initialize(t.id);
  }
  generateTitle() {
    const t = this._core.getState();
    return this._threadListBinding.generateTitle(t.id);
  }
  unstable_on(t, n) {
    let r = this._core.getState().isMain, i = this._core.getState().id;
    return this.subscribe(() => {
      const s = this._core.getState(), a = s.isMain, o = s.id;
      r === a && i === o || (r = a, i = o, !(t === "switchedTo" && !a) && (t === "switchedAway" && a || n()));
    });
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  detach() {
    const t = this._core.getState();
    this._threadListBinding.detach(t.id);
  }
  __internal_getRuntime() {
    return this;
  }
}
const io = /* @__PURE__ */ Symbol("innerMessage");
class ig {
  constructor(t) {
    O(this, "_core");
    this._core = t, this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.getState = this.getState.bind(this), this.remove = this.remove.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
}
class sg extends ig {
  constructor(n, r) {
    super(n);
    O(this, "_composerApi");
    this._composerApi = r;
  }
  remove() {
    const n = this._composerApi.getState();
    if (!n)
      throw new Error("Composer is not available");
    return n.removeAttachment(this.getState().id);
  }
}
class kA extends sg {
  get source() {
    return "thread-composer";
  }
}
class IA extends sg {
  get source() {
    return "edit-composer";
  }
}
class DA extends ig {
  get source() {
    return "message";
  }
  constructor(t) {
    super(t);
  }
  remove() {
    throw new Error("Message attachments cannot be removed");
  }
}
const ag = Object.freeze([]), og = Object.freeze({}), RA = (e) => Object.freeze({
  type: "thread",
  isEditing: e?.isEditing ?? !1,
  canCancel: e?.canCancel ?? !1,
  isEmpty: e?.isEmpty ?? !0,
  attachments: e?.attachments ?? ag,
  text: e?.text ?? "",
  role: e?.role ?? "user",
  runConfig: e?.runConfig ?? og,
  attachmentAccept: e?.attachmentAccept ?? "",
  dictation: e?.dictation,
  quote: e?.quote,
  value: e?.text ?? ""
}), PA = (e) => Object.freeze({
  type: "edit",
  isEditing: e?.isEditing ?? !1,
  canCancel: e?.canCancel ?? !1,
  isEmpty: e?.isEmpty ?? !0,
  text: e?.text ?? "",
  role: e?.role ?? "user",
  attachments: e?.attachments ?? ag,
  runConfig: e?.runConfig ?? og,
  attachmentAccept: e?.attachmentAccept ?? "",
  dictation: e?.dictation,
  quote: e?.quote,
  value: e?.text ?? ""
});
class ug {
  constructor(t) {
    O(this, "_core");
    O(this, "_eventSubscriptionSubjects", /* @__PURE__ */ new Map());
    this._core = t;
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.setText = this.setText.bind(this), this.setRunConfig = this.setRunConfig.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.addAttachment = this.addAttachment.bind(this), this.reset = this.reset.bind(this), this.clearAttachments = this.clearAttachments.bind(this), this.send = this.send.bind(this), this.cancel = this.cancel.bind(this), this.setRole = this.setRole.bind(this), this.getAttachmentByIndex = this.getAttachmentByIndex.bind(this), this.startDictation = this.startDictation.bind(this), this.stopDictation = this.stopDictation.bind(this), this.setQuote = this.setQuote.bind(this), this.unstable_on = this.unstable_on.bind(this);
  }
  setText(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setText(t);
  }
  setRunConfig(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setRunConfig(t);
  }
  addAttachment(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    return n.addAttachment(t);
  }
  reset() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    return t.reset();
  }
  clearAttachments() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    return t.clearAttachments();
  }
  send() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.send();
  }
  cancel() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.cancel();
  }
  setRole(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setRole(t);
  }
  startDictation() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.startDictation();
  }
  stopDictation() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.stopDictation();
  }
  setQuote(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setQuote(t);
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  unstable_on(t, n) {
    let r = this._eventSubscriptionSubjects.get(t);
    return r || (r = new Zp({
      event: t,
      binding: this._core
    }), this._eventSubscriptionSubjects.set(t, r)), r.subscribe(n);
  }
}
class OA extends ug {
  constructor(n) {
    const r = new xl({
      path: n.path,
      getState: () => RA(n.getState()),
      subscribe: (i) => n.subscribe(i)
    });
    super({
      path: n.path,
      getState: () => n.getState(),
      subscribe: (i) => r.subscribe(i)
    });
    O(this, "_getState");
    this._getState = r.getState.bind(r), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  get type() {
    return "thread";
  }
  getState() {
    return this._getState();
  }
  getAttachmentByIndex(n) {
    return new kA(new fn({
      path: {
        ...this.path,
        attachmentSource: "thread-composer",
        attachmentSelector: { type: "index", index: n },
        ref: `${this.path.ref}.attachments[${n}]`
      },
      getState: () => {
        const i = this.getState().attachments[n];
        return i ? {
          ...i,
          source: "thread-composer"
        } : mn;
      },
      subscribe: (r) => this._core.subscribe(r)
    }), this._core);
  }
}
class LA extends ug {
  constructor(n, r) {
    const i = new xl({
      path: n.path,
      getState: () => PA(n.getState()),
      subscribe: (s) => n.subscribe(s)
    });
    super({
      path: n.path,
      getState: () => n.getState(),
      subscribe: (s) => i.subscribe(s)
    });
    O(this, "_beginEdit");
    O(this, "_getState");
    this._beginEdit = r, this._getState = i.getState.bind(i), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  get type() {
    return "edit";
  }
  __internal_bindMethods() {
    super.__internal_bindMethods(), this.beginEdit = this.beginEdit.bind(this);
  }
  getState() {
    return this._getState();
  }
  beginEdit() {
    this._beginEdit();
  }
  getAttachmentByIndex(n) {
    return new IA(new fn({
      path: {
        ...this.path,
        attachmentSource: "edit-composer",
        attachmentSelector: { type: "index", index: n },
        ref: `${this.path.ref}.attachments[${n}]`
      },
      getState: () => {
        const i = this.getState().attachments[n];
        return i ? {
          ...i,
          source: "edit-composer"
        } : mn;
      },
      subscribe: (r) => this._core.subscribe(r)
    }), this._core);
  }
}
class xf {
  constructor(t, n, r) {
    O(this, "contentBinding");
    O(this, "messageApi");
    O(this, "threadApi");
    this.contentBinding = t, this.messageApi = n, this.threadApi = r, this.__internal_bindMethods();
  }
  get path() {
    return this.contentBinding.path;
  }
  __internal_bindMethods() {
    this.addToolResult = this.addToolResult.bind(this), this.resumeToolCall = this.resumeToolCall.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  getState() {
    return this.contentBinding.getState();
  }
  addToolResult(t) {
    const n = this.contentBinding.getState();
    if (!n)
      throw new Error("Message part is not available");
    if (n.type !== "tool-call")
      throw new Error("Tried to add tool result to non-tool message part");
    if (!this.messageApi)
      throw new Error("Message API is not available. This is likely a bug in assistant-ui.");
    if (!this.threadApi)
      throw new Error("Thread API is not available");
    const r = this.messageApi.getState();
    if (!r)
      throw new Error("Message is not available");
    const i = n.toolName, s = n.toolCallId, a = to.toResponse(t);
    this.threadApi.getState().addToolResult({
      messageId: r.id,
      toolName: i,
      toolCallId: s,
      result: a.result,
      artifact: a.artifact,
      isError: a.isError
    });
  }
  resumeToolCall(t) {
    const n = this.contentBinding.getState();
    if (!n)
      throw new Error("Message part is not available");
    if (n.type !== "tool-call")
      throw new Error("Tried to resume tool call on non-tool message part");
    if (!this.threadApi)
      throw new Error("Thread API is not available");
    const r = n.toolCallId;
    this.threadApi.getState().resumeToolCall({
      toolCallId: r,
      payload: t
    });
  }
  subscribe(t) {
    return this.contentBinding.subscribe(t);
  }
}
const ma = Object.freeze({
  type: "complete"
}), MA = (e, t, n) => {
  if (e.role !== "assistant")
    return ma;
  if (n.type === "tool-call")
    return n.result ? ma : e.status;
  const r = t === Math.max(0, e.content.length - 1);
  return e.status.type === "requires-action" ? ma : r ? e.status : ma;
}, Tf = (e, t) => {
  const n = e.content[t];
  if (!n)
    return mn;
  const r = MA(e, t, n);
  return Object.freeze({
    ...n,
    [io]: n[io],
    status: r
  });
};
class UA {
  constructor(t, n) {
    O(this, "_core");
    O(this, "_threadBinding");
    O(this, "composer");
    O(this, "_getEditComposerRuntimeCore", () => this._threadBinding.getState().getEditComposer(this._core.getState().id));
    this._core = t, this._threadBinding = n, this.composer = new LA(new no({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.composer`,
        composerSource: "edit"
      },
      getState: this._getEditComposerRuntimeCore,
      subscribe: (r) => this._threadBinding.subscribe(r)
    }), () => this._threadBinding.getState().beginEdit(this._core.getState().id)), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.reload = this.reload.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.getMessagePartByIndex = this.getMessagePartByIndex.bind(this), this.getMessagePartByToolCallId = this.getMessagePartByToolCallId.bind(this), this.getAttachmentByIndex = this.getAttachmentByIndex.bind(this), this.unstable_getCopyText = this.unstable_getCopyText.bind(this), this.speak = this.speak.bind(this), this.stopSpeaking = this.stopSpeaking.bind(this), this.submitFeedback = this.submitFeedback.bind(this), this.switchToBranch = this.switchToBranch.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  reload(t = {}) {
    const n = this._getEditComposerRuntimeCore(), r = n ?? this._threadBinding.getState().composer, i = n ?? r, { runConfig: s = i.runConfig } = t, a = this._core.getState();
    if (a.role !== "assistant")
      throw new Error("Can only reload assistant messages");
    this._threadBinding.getState().startRun({
      parentId: a.parentId,
      sourceId: a.id,
      runConfig: s
    });
  }
  speak() {
    const t = this._core.getState();
    return this._threadBinding.getState().speak(t.id);
  }
  stopSpeaking() {
    const t = this._core.getState();
    if (this._threadBinding.getState().speech?.messageId === t.id)
      this._threadBinding.getState().stopSpeaking();
    else
      throw new Error("Message is not being spoken");
  }
  submitFeedback({ type: t }) {
    const n = this._core.getState();
    this._threadBinding.getState().submitFeedback({
      messageId: n.id,
      type: t
    });
  }
  switchToBranch({ position: t, branchId: n }) {
    const r = this._core.getState();
    if (n && t)
      throw new Error("May not specify both branchId and position");
    if (!n && !t)
      throw new Error("Must specify either branchId or position");
    const s = this._threadBinding.getState().getBranches(r.id);
    let a = n;
    if (t === "previous" ? a = s[r.branchNumber - 2] : t === "next" && (a = s[r.branchNumber]), !a)
      throw new Error("Branch not found");
    this._threadBinding.getState().switchToBranch(a);
  }
  unstable_getCopyText() {
    return ro(this.getState());
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  getMessagePartByIndex(t) {
    if (t < 0)
      throw new Error("Message part index must be >= 0");
    return new xf(new fn({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.content[${t}]`,
        messagePartSelector: { type: "index", index: t }
      },
      getState: () => Tf(this.getState(), t),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core, this._threadBinding);
  }
  getMessagePartByToolCallId(t) {
    return new xf(new fn({
      path: {
        ...this.path,
        ref: this.path.ref + `${this.path.ref}.content[toolCallId=${JSON.stringify(t)}]`,
        messagePartSelector: { type: "toolCallId", toolCallId: t }
      },
      getState: () => {
        const n = this._core.getState(), r = n.content.findIndex((i) => i.type === "tool-call" && i.toolCallId === t);
        return r === -1 ? mn : Tf(n, r);
      },
      subscribe: (n) => this._core.subscribe(n)
    }), this._core, this._threadBinding);
  }
  getAttachmentByIndex(t) {
    return new DA(new fn({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.attachments[${t}]`,
        attachmentSource: "message",
        attachmentSelector: { type: "index", index: t }
      },
      getState: () => {
        const r = this.getState().attachments?.[t];
        return r ? {
          ...r,
          source: "message"
        } : mn;
      },
      subscribe: (n) => this._core.subscribe(n)
    }));
  }
}
const HA = (e) => ({
  parentId: e.parentId ?? null,
  sourceId: e.sourceId ?? null,
  runConfig: e.runConfig ?? {},
  ...e.stream ? { stream: e.stream } : {}
}), jA = (e) => ({
  parentId: e.parentId ?? null,
  sourceId: e.sourceId ?? null,
  runConfig: e.runConfig ?? {}
}), BA = (e, t) => typeof t == "string" ? {
  createdAt: /* @__PURE__ */ new Date(),
  parentId: e.at(-1)?.id ?? null,
  sourceId: null,
  runConfig: {},
  role: "user",
  content: [{ type: "text", text: t }],
  attachments: [],
  metadata: { custom: {} }
} : {
  createdAt: t.createdAt ?? /* @__PURE__ */ new Date(),
  parentId: t.parentId ?? e.at(-1)?.id ?? null,
  sourceId: t.sourceId ?? null,
  role: t.role ?? "user",
  content: t.content,
  attachments: t.attachments ?? [],
  metadata: t.metadata ?? { custom: {} },
  runConfig: t.runConfig ?? {},
  startRun: t.startRun
}, FA = (e, t) => {
  const n = e.messages.at(-1);
  return Object.freeze({
    threadId: t.id,
    metadata: t,
    capabilities: e.capabilities,
    isDisabled: e.isDisabled,
    isLoading: e.isLoading,
    isRunning: n?.role !== "assistant" ? !1 : n.status.type === "running",
    messages: e.messages,
    state: e.state,
    suggestions: e.suggestions,
    extras: e.extras,
    speech: e.speech
  });
};
class cg {
  constructor(t, n) {
    O(this, "_threadBinding");
    O(this, "composer");
    O(this, "_eventSubscriptionSubjects", /* @__PURE__ */ new Map());
    const r = new fn({
      path: t.path,
      getState: () => FA(t.getState(), n.getState()),
      subscribe: (i) => {
        const s = t.subscribe(i), a = n.subscribe(i);
        return () => {
          s(), a();
        };
      }
    });
    this._threadBinding = {
      path: t.path,
      getState: () => t.getState(),
      getStateState: () => r.getState(),
      outerSubscribe: (i) => t.outerSubscribe(i),
      subscribe: (i) => t.subscribe(i)
    }, this.composer = new OA(new no({
      path: {
        ...this.path,
        ref: `${this.path.ref}.composer`,
        composerSource: "thread"
      },
      getState: () => this._threadBinding.getState().composer,
      subscribe: (i) => this._threadBinding.subscribe(i)
    })), this.__internal_bindMethods();
  }
  get path() {
    return this._threadBinding.path;
  }
  get __internal_threadBinding() {
    return this._threadBinding;
  }
  __internal_bindMethods() {
    this.append = this.append.bind(this), this.resumeRun = this.resumeRun.bind(this), this.unstable_resumeRun = this.unstable_resumeRun.bind(this), this.unstable_loadExternalState = this.unstable_loadExternalState.bind(this), this.importExternalState = this.importExternalState.bind(this), this.exportExternalState = this.exportExternalState.bind(this), this.startRun = this.startRun.bind(this), this.cancelRun = this.cancelRun.bind(this), this.stopSpeaking = this.stopSpeaking.bind(this), this.export = this.export.bind(this), this.import = this.import.bind(this), this.reset = this.reset.bind(this), this.getMessageByIndex = this.getMessageByIndex.bind(this), this.getMessageById = this.getMessageById.bind(this), this.subscribe = this.subscribe.bind(this), this.unstable_on = this.unstable_on.bind(this), this.getModelContext = this.getModelContext.bind(this), this.getModelConfig = this.getModelConfig.bind(this), this.getState = this.getState.bind(this);
  }
  getState() {
    return this._threadBinding.getStateState();
  }
  append(t) {
    this._threadBinding.getState().append(BA(this._threadBinding.getState().messages, t));
  }
  subscribe(t) {
    return this._threadBinding.subscribe(t);
  }
  getModelContext() {
    return this._threadBinding.getState().getModelContext();
  }
  getModelConfig() {
    return this.getModelContext();
  }
  startRun(t) {
    const n = t === null || typeof t == "string" ? { parentId: t } : t;
    return this._threadBinding.getState().startRun(jA(n));
  }
  resumeRun(t) {
    return this._threadBinding.getState().resumeRun(HA(t));
  }
  /** @deprecated Use `resumeRun` instead. */
  unstable_resumeRun(t) {
    return this.resumeRun(t);
  }
  exportExternalState() {
    return this._threadBinding.getState().exportExternalState();
  }
  importExternalState(t) {
    this._threadBinding.getState().importExternalState(t);
  }
  unstable_loadExternalState(t) {
    this._threadBinding.getState().unstable_loadExternalState(t);
  }
  cancelRun() {
    this._threadBinding.getState().cancelRun();
  }
  stopSpeaking() {
    return this._threadBinding.getState().stopSpeaking();
  }
  export() {
    return this._threadBinding.getState().export();
  }
  import(t) {
    this._threadBinding.getState().import(t);
  }
  reset(t) {
    this._threadBinding.getState().reset(t);
  }
  getMessageByIndex(t) {
    if (t < 0)
      throw new Error("Message index must be >= 0");
    return this._getMessageRuntime({
      ...this.path,
      ref: `${this.path.ref}.messages[${t}]`,
      messageSelector: { type: "index", index: t }
    }, () => {
      const n = this._threadBinding.getState().messages, r = n[t];
      if (r)
        return {
          message: r,
          parentId: n[t - 1]?.id ?? null,
          index: t
        };
    });
  }
  getMessageById(t) {
    return this._getMessageRuntime({
      ...this.path,
      ref: `${this.path.ref}.messages[messageId=${JSON.stringify(t)}]`,
      messageSelector: { type: "messageId", messageId: t }
    }, () => this._threadBinding.getState().getMessageById(t));
  }
  _getMessageRuntime(t, n) {
    return new UA(new fn({
      path: t,
      getState: () => {
        const { message: r, parentId: i, index: s } = n() ?? {}, { messages: a, speech: o } = this._threadBinding.getState();
        if (!r || i === void 0 || s === void 0)
          return mn;
        const c = this._threadBinding.getState().getBranches(r.id), l = r.metadata.submittedFeedback;
        return {
          ...r,
          [io]: r[io],
          index: s,
          isLast: a.at(-1)?.id === r.id,
          parentId: i,
          branchNumber: c.indexOf(r.id) + 1,
          branchCount: c.length,
          speech: o?.messageId === r.id ? o : void 0,
          submittedFeedback: l
        };
      },
      subscribe: (r) => this._threadBinding.subscribe(r)
    }), this._threadBinding);
  }
  unstable_on(t, n) {
    let r = this._eventSubscriptionSubjects.get(t);
    return r || (r = new Zp({
      event: t,
      binding: this._threadBinding
    }), this._eventSubscriptionSubjects.set(t, r)), r.subscribe(n);
  }
}
const zA = (e) => ({
  mainThreadId: e.mainThreadId,
  newThreadId: e.newThreadId,
  threadIds: e.threadIds,
  archivedThreadIds: e.archivedThreadIds,
  isLoading: e.isLoading,
  threadItems: e.threadItems
}), pa = (e, t) => {
  if (t === void 0)
    return mn;
  const n = e.getItemById(t);
  return n ? {
    id: n.id,
    remoteId: n.remoteId,
    externalId: n.externalId,
    title: n.title,
    status: n.status,
    isMain: n.id === e.mainThreadId
  } : mn;
};
class lg {
  constructor(t, n = cg) {
    O(this, "_core");
    O(this, "_runtimeFactory");
    O(this, "_getState");
    O(this, "_mainThreadListItemRuntime");
    O(this, "main");
    this._core = t, this._runtimeFactory = n;
    const r = new xl({
      path: {},
      getState: () => zA(t),
      subscribe: (i) => t.subscribe(i)
    });
    this._getState = r.getState.bind(r), this._mainThreadListItemRuntime = new ha(new fn({
      path: {
        ref: "threadItems[main]",
        threadSelector: { type: "main" }
      },
      getState: () => pa(this._core, this._core.mainThreadId),
      subscribe: (i) => this._core.subscribe(i)
    }), this._core), this.main = new n(new no({
      path: {
        ref: "threads.main",
        threadSelector: { type: "main" }
      },
      getState: () => t.getMainThreadRuntimeCore(),
      subscribe: (i) => t.subscribe(i)
    }), this._mainThreadListItemRuntime), this.__internal_bindMethods();
  }
  __internal_bindMethods() {
    this.switchToThread = this.switchToThread.bind(this), this.switchToNewThread = this.switchToNewThread.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.getById = this.getById.bind(this), this.getItemById = this.getItemById.bind(this), this.getItemByIndex = this.getItemByIndex.bind(this), this.getArchivedItemByIndex = this.getArchivedItemByIndex.bind(this);
  }
  switchToThread(t) {
    return this._core.switchToThread(t);
  }
  switchToNewThread() {
    return this._core.switchToNewThread();
  }
  getState() {
    return this._getState();
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  get mainItem() {
    return this._mainThreadListItemRuntime;
  }
  getById(t) {
    return new this._runtimeFactory(new no({
      path: {
        ref: `threads[threadId=${JSON.stringify(t)}]`,
        threadSelector: { type: "threadId", threadId: t }
      },
      getState: () => this._core.getThreadRuntimeCore(t),
      subscribe: (n) => this._core.subscribe(n)
    }), this.mainItem);
  }
  getItemByIndex(t) {
    return new ha(new fn({
      path: {
        ref: `threadItems[${t}]`,
        threadSelector: { type: "index", index: t }
      },
      getState: () => pa(this._core, this._core.threadIds[t]),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
  getArchivedItemByIndex(t) {
    return new ha(new fn({
      path: {
        ref: `archivedThreadItems[${t}]`,
        threadSelector: { type: "archiveIndex", index: t }
      },
      getState: () => pa(this._core, this._core.archivedThreadIds[t]),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
  getItemById(t) {
    return new ha(new fn({
      path: {
        ref: `threadItems[threadId=${t}]`,
        threadSelector: { type: "threadId", threadId: t }
      },
      getState: () => pa(this._core, t),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
}
class yl {
  constructor(t) {
    O(this, "_core");
    O(this, "threads");
    O(this, "_thread");
    this._core = t, this.threads = new lg(t.threads), this._thread = this.threads.main, this.__internal_bindMethods();
  }
  get threadList() {
    return this.threads;
  }
  __internal_bindMethods() {
    this.switchToNewThread = this.switchToNewThread.bind(this), this.switchToThread = this.switchToThread.bind(this), this.registerModelContextProvider = this.registerModelContextProvider.bind(this), this.registerModelConfigProvider = this.registerModelConfigProvider.bind(this), this.reset = this.reset.bind(this);
  }
  get thread() {
    return this._thread;
  }
  switchToNewThread() {
    return this._core.threads.switchToNewThread();
  }
  switchToThread(t) {
    return this._core.threads.switchToThread(t);
  }
  registerModelContextProvider(t) {
    return this._core.registerModelContextProvider(t);
  }
  registerModelConfigProvider(t) {
    return this.registerModelContextProvider(t);
  }
  reset({ initialMessages: t } = {}) {
    return this._core.threads.getMainThreadRuntimeCore().import(Al.fromArray(t ?? []));
  }
}
const dg = Xe((e) => Jt(fA(e)));
Op(dg, (e, t) => {
  hA(e, t), !e.tools && t.tools.source === null && (e.tools = Fp({})), !e.dataRenderers && t.dataRenderers.source === null && (e.dataRenderers = CT());
});
const vc = Ot(null), Nl = ({ adapters: e, children: t }) => {
  const n = Ct(vc);
  return S.jsx(vc.Provider, { value: {
    ...n,
    ...e
  }, children: t });
}, VA = () => Ct(vc);
function WA(e) {
  return e != null && typeof e == "object" && !Array.isArray(e);
}
function wc(e, t = 0) {
  return t > 100 ? !1 : e === null || typeof e == "string" || typeof e == "boolean" ? !0 : typeof e == "number" ? !Number.isNaN(e) && Number.isFinite(e) : Array.isArray(e) ? e.every((n) => wc(n, t + 1)) : WA(e) ? Object.entries(e).every(([n, r]) => typeof n == "string" && wc(r, t + 1)) : !1;
}
const Af = (e, t) => t === void 0 ? e.status?.type === "requires-action" && e.status.reason === "tool-calls" && e.content.every((n) => n.type !== "tool-call" || !!n.result) : e.status?.type === "requires-action" && e.status.reason === "tool-calls" && e.content.every((n) => n.type !== "tool-call" || !!n.result || !t.includes(n.toolName));
class Nu extends Error {
  constructor(n, r) {
    super(r);
    O(this, "name", "AbortError");
    O(this, "detach");
    this.detach = n;
  }
}
class $A extends SA {
  constructor(n, r) {
    super(n);
    O(this, "capabilities", {
      switchToBranch: !0,
      switchBranchDuringRun: !0,
      edit: !0,
      reload: !0,
      cancel: !0,
      unstable_copy: !0,
      speech: !1,
      dictation: !1,
      attachments: !1,
      feedback: !1,
      queue: !1
    });
    O(this, "abortController", null);
    O(this, "isDisabled", !1);
    O(this, "_isLoading", !1);
    O(this, "_suggestions", []);
    O(this, "_suggestionsController", null);
    O(this, "_options");
    O(this, "_lastRunConfig", {});
    O(this, "_getThreadId");
    O(this, "_getInitializePromise");
    O(this, "_loadPromise");
    this.__internal_setOptions(r);
  }
  get isLoading() {
    return this._isLoading;
  }
  get suggestions() {
    return this._suggestions;
  }
  get adapters() {
    return this._options.adapters;
  }
  __internal_setGetThreadId(n) {
    this._getThreadId = n;
  }
  __internal_setGetInitializePromise(n) {
    this._getInitializePromise = n;
  }
  get extras() {
  }
  __internal_setOptions(n) {
    if (this._options === n)
      return;
    this._options = n;
    let r = !1;
    const i = n.adapters?.speech !== void 0;
    this.capabilities.speech !== i && (this.capabilities.speech = i, r = !0);
    const s = n.adapters?.dictation !== void 0;
    this.capabilities.dictation !== s && (this.capabilities.dictation = s, r = !0);
    const a = n.adapters?.attachments !== void 0;
    this.capabilities.attachments !== a && (this.capabilities.attachments = a, r = !0);
    const o = n.adapters?.feedback !== void 0;
    this.capabilities.feedback !== o && (this.capabilities.feedback = o, r = !0), r && this._notifySubscribers();
  }
  __internal_load() {
    if (this._loadPromise)
      return this._loadPromise;
    const n = this.adapters.history?.load() ?? Promise.resolve(null);
    return this._isLoading = !0, this._notifySubscribers(), this._loadPromise = n.then((r) => {
      if (!r)
        return;
      this.repository.import(r), r.messages.length > 0 && this.ensureInitialized(), this._notifySubscribers();
      const i = this.adapters.history?.resume?.bind(this.adapters.history);
      r.unstable_resume && i && this.startRun({
        parentId: this.repository.headId,
        sourceId: this.repository.headId,
        runConfig: this._lastRunConfig
      }, i).catch(() => {
      });
    }).finally(() => {
      this._isLoading = !1, this._notifySubscribers();
    }), this._loadPromise;
  }
  async append(n) {
    this.ensureInitialized();
    const r = this._getInitializePromise?.();
    r && await r;
    const i = Vs(n, dr(), {
      type: "complete",
      reason: "unknown"
    });
    this.repository.addOrUpdateMessage(n.parentId, i), this._options.adapters.history?.append({
      parentId: n.parentId,
      message: i,
      ...n.runConfig !== void 0 && { runConfig: n.runConfig }
    }), n.startRun ?? n.role === "user" ? await this.startRun({
      parentId: i.id,
      sourceId: n.sourceId,
      runConfig: n.runConfig ?? {}
    }) : (this.repository.resetHead(i.id), this._notifySubscribers());
  }
  resumeRun({ stream: n, ...r }) {
    if (!n)
      throw new Error("You must pass a stream parameter to resume runs.");
    return this.startRun(r, n);
  }
  exportExternalState() {
    throw new Error("Runtime does not support exporting external states.");
  }
  importExternalState() {
    throw new Error("Runtime does not support importing external states.");
  }
  unstable_loadExternalState() {
    throw new Error("Runtime does not support importing external states.");
  }
  async startRun({ parentId: n, runConfig: r }, i) {
    this.ensureInitialized();
    let a = {
      id: dr(),
      role: "assistant",
      status: { type: "running" },
      content: [],
      metadata: {
        unstable_state: this.state,
        unstable_annotations: [],
        unstable_data: [],
        steps: [],
        custom: {}
      },
      createdAt: /* @__PURE__ */ new Date()
    };
    this._notifyEventSubscribers("runStart");
    try {
      this._suggestions = [], this._suggestionsController?.abort(), this._suggestionsController = null, this._notifySubscribers();
      do
        a = await this.performRoundtrip(n, a, r, i), i = void 0;
      while (Af(a, this._options.unstable_humanToolNames));
    } finally {
      this._notifyEventSubscribers("runEnd");
    }
    this._suggestionsController = new AbortController();
    const o = this._suggestionsController.signal;
    if (this.adapters.suggestion && a.status?.type !== "requires-action") {
      const u = this.adapters.suggestion?.generate({
        messages: this.messages
      });
      if (Symbol.asyncIterator in u)
        for await (const c of u) {
          if (o.aborted)
            break;
          this._suggestions = c, this._notifySubscribers();
        }
      else {
        const c = await u;
        if (o.aborted)
          return;
        this._suggestions = c, this._notifySubscribers();
      }
    }
  }
  async performRoundtrip(n, r, i, s) {
    const a = n ? this.repository.getMessages(n) : [];
    this.abortController?.abort(), this.abortController = new AbortController();
    const o = r.content, u = r.metadata?.unstable_annotations, c = r.metadata?.unstable_data, l = r.metadata?.steps, d = r.metadata?.custom, h = (g) => {
      const T = g.metadata?.steps, _ = T ? [...l ?? [], ...T] : void 0, A = g.metadata?.unstable_annotations, w = g.metadata?.unstable_data, M = A ? [...u ?? [], ...A] : void 0, F = w ? [...c ?? [], ...w] : void 0;
      r = {
        ...r,
        ...g.content ? { content: [...o, ...g.content ?? []] } : void 0,
        status: g.status ?? r.status,
        ...g.metadata ? {
          metadata: {
            ...r.metadata,
            ...g.metadata.unstable_state ? { unstable_state: g.metadata.unstable_state } : void 0,
            ...M ? { unstable_annotations: M } : void 0,
            ...F ? { unstable_data: F } : void 0,
            ..._ ? { steps: _ } : void 0,
            ...g.metadata?.timing ? { timing: g.metadata.timing } : void 0,
            ...g.metadata?.custom ? {
              custom: {
                ...d ?? {},
                ...g.metadata.custom
              }
            } : void 0
          }
        } : void 0
      }, this.repository.addOrUpdateMessage(n, r), this._notifySubscribers();
    }, m = this._options.maxSteps ?? 2;
    if ((r.metadata?.steps?.length ?? 0) >= m)
      return h({
        status: {
          type: "incomplete",
          reason: "tool-calls"
        }
      }), r;
    h({
      status: {
        type: "running"
      }
    }), this.repository.resetHead(r.id), this._notifySubscribers();
    try {
      this._lastRunConfig = i ?? {};
      const g = this.getModelContext();
      s = s ?? this.adapters.chatModel.run.bind(this.adapters.chatModel);
      const T = this.abortController.signal, _ = this._getThreadId?.(), A = s({
        messages: a,
        runConfig: this._lastRunConfig,
        abortSignal: T,
        context: g,
        config: g,
        unstable_assistantMessageId: r.id,
        unstable_threadId: _,
        unstable_parentId: n,
        unstable_getMessage() {
          return r;
        }
      });
      if (Symbol.asyncIterator in A)
        for await (const w of A) {
          if (T.aborted) {
            h({
              status: { type: "incomplete", reason: "cancelled" }
            });
            break;
          }
          h(w);
        }
      else
        h(await A);
      r.status.type === "running" && h({
        status: { type: "complete", reason: "unknown" }
      });
    } catch (g) {
      if (g instanceof Nu)
        h({
          status: { type: "incomplete", reason: "cancelled" }
        });
      else if (g instanceof Error && g.name === "AbortError")
        h({
          status: { type: "incomplete", reason: "cancelled" }
        });
      else
        throw h({
          status: {
            type: "incomplete",
            reason: "error",
            error: g instanceof Error ? g.message : `[${typeof g}] ${new String(g).toString()}`
          }
        }), g;
    } finally {
      this.abortController = null, (r.status.type === "complete" || r.status.type === "incomplete") && await this._options.adapters.history?.append({
        parentId: n,
        message: r,
        runConfig: this._lastRunConfig
      });
    }
    return r;
  }
  detach() {
    const n = new Nu(!0);
    this.abortController?.abort(n), this.abortController = null;
  }
  cancelRun() {
    const n = new Nu(!1);
    this.abortController?.abort(n), this.abortController = null;
  }
  addToolResult({ messageId: n, toolCallId: r, result: i, isError: s, artifact: a }) {
    const o = this.repository.getMessage(n), { parentId: u } = o;
    let { message: c } = o;
    if (c.role !== "assistant")
      throw new Error("Tried to add tool result to non-assistant message");
    let l = !1, d = !1;
    const h = c.content.map((m) => m.type !== "tool-call" || m.toolCallId !== r ? m : (d = !0, m.result || (l = !0), {
      ...m,
      result: i,
      artifact: a,
      isError: s
    }));
    if (!d)
      throw new Error("Tried to add tool result to non-existing tool call");
    c = {
      ...c,
      content: h
    }, this.repository.addOrUpdateMessage(u, c), l && Af(c, this._options.unstable_humanToolNames) && this.performRoundtrip(u, c, this._lastRunConfig).catch(() => {
    });
  }
  resumeToolCall(n) {
    throw new Error("Local runtime does not support resuming tool calls.");
  }
}
const yf = Object.freeze([]), Cc = "__DEFAULT_ID__", YA = Object.freeze({
  [Cc]: {
    id: Cc,
    remoteId: void 0,
    externalId: void 0,
    status: "regular",
    title: void 0
  }
});
class GA extends zs {
  constructor(n) {
    super();
    O(this, "_mainThread");
    this._mainThread = n();
  }
  get isLoading() {
    return !1;
  }
  getMainThreadRuntimeCore() {
    return this._mainThread;
  }
  get newThreadId() {
  }
  get threadIds() {
    return yf;
  }
  get archivedThreadIds() {
    return yf;
  }
  get mainThreadId() {
    return Cc;
  }
  get threadItems() {
    return YA;
  }
  getThreadRuntimeCore() {
    throw new Error("Method not implemented.");
  }
  getLoadThreadsPromise() {
    return Promise.resolve();
  }
  getItemById(n) {
    if (n === this.mainThreadId)
      return {
        status: "regular",
        id: this.mainThreadId,
        remoteId: this.mainThreadId,
        externalId: void 0,
        title: void 0,
        isMain: !0
      };
    throw new Error("Method not implemented");
  }
  async switchToThread() {
    throw new Error("Method not implemented.");
  }
  switchToNewThread() {
    throw new Error("Method not implemented.");
  }
  rename() {
    throw new Error("Method not implemented.");
  }
  archive() {
    throw new Error("Method not implemented.");
  }
  detach() {
    throw new Error("Method not implemented.");
  }
  unarchive() {
    throw new Error("Method not implemented.");
  }
  delete() {
    throw new Error("Method not implemented.");
  }
  initialize(n) {
    return Promise.resolve({ remoteId: n, externalId: void 0 });
  }
  generateTitle() {
    throw new Error("Method not implemented.");
  }
}
class qA extends Tl {
  constructor(n, r) {
    super();
    O(this, "threads");
    O(this, "Provider");
    O(this, "_options");
    this._options = n, this.threads = new GA(() => new $A(this._contextProvider, this._options)), r && this.threads.getMainThreadRuntimeCore().import(Al.fromArray(r));
  }
}
const Nf = (e, t, n) => n.reduce((r, i) => i?.(r, t) ?? r, e);
class KA extends zs {
  constructor(n) {
    super();
    O(this, "_pendingTransforms", []);
    /**
     * `optimistic` callbacks from transforms that have already resolved.
     * Re-applied after every `then` callback so that a wholesale state
     * replacement (e.g. list()) cannot erase earlier completed effects
     * (e.g. delete). Cleared when no pending transforms remain.
     *
     * Correctness requirement: `optimistic` callbacks must be idempotent.
     */
    O(this, "_completedOptimistics", []);
    O(this, "_baseValue");
    O(this, "_cachedValue");
    this._baseValue = n, this._cachedValue = n;
  }
  _updateState() {
    this._cachedValue = this._pendingTransforms.reduce((n, r) => Nf(n, r.task, [
      r.loading,
      r.optimistic
    ]), this._baseValue), this._notifySubscribers();
  }
  get baseValue() {
    return this._baseValue;
  }
  get value() {
    return this._cachedValue;
  }
  update(n) {
    this._baseValue = n, this._updateState();
  }
  async optimisticUpdate(n) {
    const r = n.execute(), i = { ...n, task: r };
    try {
      this._pendingTransforms.push(i), this._updateState();
      const s = await r;
      this._baseValue = Nf(this._baseValue, s, [
        n.optimistic,
        n.then
      ]);
      for (const a of this._completedOptimistics)
        this._baseValue = a(this._baseValue);
      return n.optimistic && this._completedOptimistics.push(n.optimistic), s;
    } finally {
      const s = this._pendingTransforms.indexOf(i);
      s > -1 && this._pendingTransforms.splice(s, 1), this._pendingTransforms.length === 0 && (this._completedOptimistics.length = 0), this._updateState();
    }
  }
}
const at = new Error("This is the empty thread, a placeholder for the main thread. You cannot perform any actions on this thread instance. This error is probably because you tried to call a thread method in your render function. Call the method inside a `useEffect` hook instead."), QA = {
  getMessageById() {
  },
  getBranches() {
    return [];
  },
  switchToBranch() {
    throw at;
  },
  append() {
    throw at;
  },
  startRun() {
    throw at;
  },
  resumeRun() {
    throw at;
  },
  cancelRun() {
    throw at;
  },
  addToolResult() {
    throw at;
  },
  resumeToolCall() {
    throw at;
  },
  speak() {
    throw at;
  },
  stopSpeaking() {
    throw at;
  },
  submitFeedback() {
    throw at;
  },
  getModelContext() {
    return {};
  },
  exportExternalState() {
    throw at;
  },
  importExternalState() {
    throw at;
  },
  unstable_loadExternalState() {
    throw at;
  },
  composer: {
    attachments: [],
    attachmentAccept: "*",
    async addAttachment(e) {
      throw at;
    },
    async removeAttachment() {
      throw at;
    },
    isEditing: !0,
    canCancel: !1,
    isEmpty: !0,
    text: "",
    setText() {
      throw at;
    },
    role: "user",
    setRole() {
      throw at;
    },
    runConfig: {},
    setRunConfig() {
      throw at;
    },
    async reset() {
    },
    async clearAttachments() {
    },
    send() {
      throw at;
    },
    cancel() {
    },
    dictation: void 0,
    startDictation() {
      throw at;
    },
    stopDictation() {
    },
    quote: void 0,
    setQuote() {
      throw at;
    },
    subscribe() {
      return () => {
      };
    },
    unstable_on() {
      return () => {
      };
    }
  },
  getEditComposer() {
  },
  beginEdit() {
    throw at;
  },
  speech: void 0,
  capabilities: {
    switchToBranch: !1,
    switchBranchDuringRun: !1,
    edit: !1,
    reload: !1,
    cancel: !1,
    unstable_copy: !1,
    speech: !1,
    dictation: !1,
    attachments: !1,
    feedback: !1,
    queue: !1
  },
  isDisabled: !1,
  isLoading: !1,
  messages: [],
  state: null,
  suggestions: [],
  extras: void 0,
  subscribe() {
    return () => {
    };
  },
  import() {
    throw at;
  },
  export() {
    return { messages: [] };
  },
  reset() {
    throw at;
  },
  unstable_on() {
    return () => {
    };
  }
};
const ls = (e, t) => {
  const n = e.threadIdMap[t];
  if (n !== void 0)
    return e.threadData[n];
}, ga = (e, t, n) => {
  const r = ls(e, t);
  if (!r)
    return e;
  const { id: i, remoteId: s, status: a } = r;
  if (a === n)
    return e;
  const o = { ...e };
  switch (a) {
    case "new":
      o.newThreadId = void 0;
      break;
    case "regular":
      o.threadIds = o.threadIds.filter((u) => u !== i);
      break;
    case "archived":
      o.archivedThreadIds = o.archivedThreadIds.filter((u) => u !== i);
      break;
    default: {
      const u = a;
      throw new Error(`Unsupported state: ${u}`);
    }
  }
  switch (n) {
    case "regular":
      o.threadIds = [i, ...o.threadIds];
      break;
    case "archived":
      o.archivedThreadIds = [i, ...o.archivedThreadIds];
      break;
    case "deleted":
      o.threadData = Object.fromEntries(Object.entries(o.threadData).filter(([u]) => u !== i)), o.threadIdMap = Object.fromEntries(Object.entries(o.threadIdMap).filter(([u]) => u !== i && u !== s));
      break;
    default: {
      const u = n;
      throw new Error(`Unsupported state: ${u}`);
    }
  }
  return n !== "deleted" && (o.threadData = {
    ...o.threadData,
    [i]: {
      ...r,
      status: n
    }
  }), o;
};
class XA extends zs {
  constructor(n, r) {
    super();
    O(this, "useRuntimeHook");
    O(this, "instances", /* @__PURE__ */ new Map());
    O(this, "useAliveThreadsKeysChanged", yi(() => ({})));
    O(this, "parent");
    O(this, "_InnerActiveThreadProvider", ({ threadId: n }) => {
      const { useRuntime: r } = this.useRuntimeHook(), i = r(), s = i.thread.__internal_threadBinding, a = de(() => {
        const l = this.instances.get(n);
        if (!l)
          throw new Error("Thread not found. This is a bug in assistant-ui.");
        l.runtime = s.getState(), this._notifySubscribers();
      }, [n, s]), o = st(!1);
      o.current || a(), Le(() => (o.current = !0, a(), s.outerSubscribe(a)), [s, a]);
      const u = Ve(), c = st(void 0);
      return Le(() => {
        const l = s.getState(), d = l.__internal_setGetInitializePromise;
        typeof d == "function" && d.call(l, () => c.current);
      }, [s]), Le(() => i.threads.main.unstable_on("initialize", () => {
        if (u.threadListItem().getState().status === "new") {
          c.current = u.threadListItem().initialize();
          const d = i.thread.unstable_on("runEnd", () => {
            d(), u.threadListItem().generateTitle();
          });
        }
      }), [i, u]), null;
    });
    O(this, "_OuterActiveThreadProvider", Ce(({ threadId: n, provider: r }) => {
      const i = pe(() => new lg(this.parent).getItemById(n), [n]);
      return S.jsx(mA, { runtime: i, children: S.jsx(r, { children: S.jsx(this._InnerActiveThreadProvider, { threadId: n }) }) });
    }));
    O(this, "__internal_RenderThreadRuntimes", ({ provider: n }) => (this.useAliveThreadsKeysChanged(), Array.from(this.instances.keys()).map((r) => S.jsx(this._OuterActiveThreadProvider, { threadId: r, provider: n }, r))));
    this.parent = r, this.useRuntimeHook = yi(() => ({ useRuntime: n }));
  }
  startThreadRuntime(n) {
    return this.instances.has(n) || (this.instances.set(n, {}), this.useAliveThreadsKeysChanged.setState({}, !0)), new Promise((r, i) => {
      const s = () => {
        const o = this.instances.get(n);
        if (!o)
          a(), i(new Error("Thread was deleted before runtime was started"));
        else if (o.runtime)
          a(), r(o.runtime);
        else
          return;
      }, a = this.subscribe(s);
      s();
    });
  }
  getThreadRuntimeCore(n) {
    const r = this.instances.get(n);
    if (r)
      return r.runtime;
  }
  stopThreadRuntime(n) {
    this.instances.delete(n), this.useAliveThreadsKeysChanged.setState({}, !0);
  }
  setRuntimeHook(n) {
    this.useRuntimeHook.getState().useRuntime !== n && this.useRuntimeHook.setState({ useRuntime: n }, !0);
  }
}
class JA extends zs {
  constructor(n, r) {
    super();
    O(this, "_options");
    O(this, "_hookManager");
    O(this, "_loadThreadsPromise");
    O(this, "_mainThreadId");
    O(this, "_state", new KA({
      isLoading: !1,
      newThreadId: void 0,
      threadIds: [],
      archivedThreadIds: [],
      threadIdMap: {},
      threadData: {}
    }));
    O(this, "contextProvider");
    O(this, "useProvider");
    O(this, "initialize", async (n) => {
      if (this._state.value.newThreadId !== n) {
        const r = this.getItemById(n);
        if (!r)
          throw new Error("Thread not found");
        if (r.status === "new")
          throw new Error("Unexpected new state");
        return r.initializeTask;
      }
      return this._state.optimisticUpdate({
        execute: () => this._options.adapter.initialize(n),
        optimistic: (r) => ga(r, n, "regular"),
        loading: (r, i) => {
          const s = n;
          return {
            ...r,
            threadData: {
              ...r.threadData,
              [s]: {
                ...r.threadData[s],
                initializeTask: i
              }
            }
          };
        },
        then: (r, { remoteId: i, externalId: s }) => {
          const a = ls(r, n);
          if (!a)
            return r;
          const o = n;
          return {
            ...r,
            threadIdMap: {
              ...r.threadIdMap,
              [i]: o
            },
            threadData: {
              ...r.threadData,
              [o]: {
                ...a,
                initializeTask: Promise.resolve({ remoteId: i, externalId: s }),
                remoteId: i,
                externalId: s
              }
            }
          };
        }
      });
    });
    O(this, "generateTitle", async (n) => {
      const r = this.getItemById(n);
      if (!r)
        throw new Error("Thread not found");
      if (r.status === "new")
        throw new Error("Thread is not yet initialized");
      const { remoteId: i } = await r.initializeTask, s = this._hookManager.getThreadRuntimeCore(r.id);
      if (!s)
        return;
      const a = s.messages, o = await this._options.adapter.generateTitle(i, a), u = bs.fromAssistantStream(o);
      for await (const c of u) {
        const l = c.parts.filter((m) => m.type === "text")[0]?.text, d = this._state.baseValue, h = ls(d, r.id);
        h && this._state.update({
          ...d,
          threadData: {
            ...d.threadData,
            [h.id]: {
              ...h,
              title: l
            }
          }
        });
      }
    });
    O(this, "useBoundIds", yi(() => []));
    O(this, "__internal_RenderComponent", () => {
      const n = s1();
      Le(() => (this.useBoundIds.setState((a) => [...a, n], !0), () => {
        this.useBoundIds.setState((a) => a.filter((o) => o !== n), !0);
      }), [n]);
      const r = this.useBoundIds(), { Provider: i } = this.useProvider(), s = {
        modelContext: this.contextProvider
      };
      return (r.length === 0 || r[0] === n) && // only render if the component is the first one mounted
      S.jsx(Nl, { adapters: s, children: S.jsx(this._hookManager.__internal_RenderThreadRuntimes, { provider: i }) });
    });
    this.contextProvider = r, this._state.subscribe(() => this._notifySubscribers()), this._hookManager = new XA(n.runtimeHook, this), this.useProvider = yi(() => ({
      Provider: n.adapter.unstable_Provider ?? Gd
    })), this.__internal_setOptions(n), this.switchToNewThread();
  }
  get threadItems() {
    return this._state.value.threadData;
  }
  getLoadThreadsPromise() {
    return this._loadThreadsPromise || (this._loadThreadsPromise = this._state.optimisticUpdate({
      execute: () => this._options.adapter.list(),
      loading: (n) => ({
        ...n,
        isLoading: !0
      }),
      then: (n, r) => {
        const i = [], s = [], a = {}, o = {};
        for (const u of r.threads) {
          switch (u.status) {
            case "regular":
              i.push(u.remoteId);
              break;
            case "archived":
              s.push(u.remoteId);
              break;
            default: {
              const l = u.status;
              throw new Error(`Unsupported state: ${l}`);
            }
          }
          const c = u.remoteId;
          a[u.remoteId] = c, o[c] = {
            id: u.remoteId,
            remoteId: u.remoteId,
            externalId: u.externalId,
            status: u.status,
            title: u.title,
            initializeTask: Promise.resolve({
              remoteId: u.remoteId,
              externalId: u.externalId
            })
          };
        }
        return {
          ...n,
          threadIds: i,
          archivedThreadIds: s,
          threadIdMap: {
            ...n.threadIdMap,
            ...a
          },
          threadData: {
            ...n.threadData,
            ...o
          }
        };
      }
    }).then(() => {
    })), this._loadThreadsPromise;
  }
  __internal_setOptions(n) {
    if (this._options === n)
      return;
    this._options = n;
    const r = n.adapter.unstable_Provider ?? Gd;
    r !== this.useProvider.getState().Provider && this.useProvider.setState({ Provider: r }, !0), this._hookManager.setRuntimeHook(n.runtimeHook);
  }
  __internal_load() {
    this.getLoadThreadsPromise();
  }
  get isLoading() {
    return this._state.value.isLoading;
  }
  get threadIds() {
    return this._state.value.threadIds;
  }
  get archivedThreadIds() {
    return this._state.value.archivedThreadIds;
  }
  get newThreadId() {
    return this._state.value.newThreadId;
  }
  get mainThreadId() {
    return this._mainThreadId;
  }
  getMainThreadRuntimeCore() {
    const n = this._hookManager.getThreadRuntimeCore(this._mainThreadId);
    return n || QA;
  }
  getThreadRuntimeCore(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    const i = this._hookManager.getThreadRuntimeCore(r.id);
    if (!i)
      throw new Error("Thread not found");
    return i;
  }
  getItemById(n) {
    return ls(this._state.value, n);
  }
  async switchToThread(n) {
    let r = this.getItemById(n);
    if (!r) {
      const s = await this._options.adapter.fetch(n), a = this._state.value, o = s.remoteId, u = {
        ...a.threadData,
        [o]: {
          id: o,
          initializeTask: Promise.resolve({
            remoteId: s.remoteId,
            externalId: s.externalId
          }),
          remoteId: s.remoteId,
          externalId: s.externalId,
          status: s.status,
          title: s.title
        }
      }, c = {
        ...a.threadIdMap,
        [s.remoteId]: o
      }, l = s.status === "regular" ? [...a.threadIds, s.remoteId] : a.threadIds, d = s.status === "archived" ? [...a.archivedThreadIds, s.remoteId] : a.archivedThreadIds;
      this._state.update({
        ...a,
        threadIds: l,
        archivedThreadIds: d,
        threadIdMap: c,
        threadData: u
      }), r = this.getItemById(n);
    }
    if (!r)
      throw new Error("Thread not found");
    if (this._mainThreadId === r.id)
      return;
    const i = this._hookManager.startThreadRuntime(r.id);
    this.mainThreadId !== void 0 ? await i : i.then(() => this._notifySubscribers()), r.status === "archived" && await this.unarchive(r.id), this._mainThreadId = r.id, this._notifySubscribers();
  }
  async switchToNewThread() {
    for (; this._state.baseValue.newThreadId !== void 0 && this._state.value.newThreadId === void 0; )
      await this._state.waitForUpdate();
    const n = this._state.value;
    let r = this._state.value.newThreadId;
    if (r === void 0) {
      do
        r = `__LOCALID_${dr()}`;
      while (n.threadIdMap[r]);
      const i = r;
      this._state.update({
        ...n,
        newThreadId: r,
        threadIdMap: {
          ...n.threadIdMap,
          [r]: i
        },
        threadData: {
          ...n.threadData,
          [i]: {
            status: "new",
            id: r,
            remoteId: void 0,
            externalId: void 0,
            title: void 0
          }
        }
      });
    }
    return this.switchToThread(r);
  }
  rename(n, r) {
    const i = this.getItemById(n);
    if (!i)
      throw new Error("Thread not found");
    if (i.status === "new")
      throw new Error("Thread is not yet initialized");
    return this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: s } = await i.initializeTask;
        return this._options.adapter.rename(s, r);
      },
      optimistic: (s) => {
        const a = ls(s, n);
        return a ? {
          ...s,
          threadData: {
            ...s.threadData,
            [a.id]: {
              ...a,
              title: r
            }
          }
        } : s;
      }
    });
  }
  async _ensureThreadIsNotMain(n) {
    if (n === this.newThreadId)
      throw new Error("Cannot ensure new thread is not main");
    n === this._mainThreadId && await this.switchToNewThread();
  }
  async archive(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular")
      throw new Error("Thread is not yet initialized or already archived");
    return await this._ensureThreadIsNotMain(r.id), this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: i } = await r.initializeTask;
        return this._options.adapter.archive(i);
      },
      optimistic: (i) => ga(i, r.id, "archived")
    });
  }
  unarchive(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "archived")
      throw new Error("Thread is not archived");
    return this._state.optimisticUpdate({
      execute: async () => {
        try {
          const { remoteId: i } = await r.initializeTask;
          return await this._options.adapter.unarchive(i);
        } catch (i) {
          throw await this._ensureThreadIsNotMain(r.id), i;
        }
      },
      optimistic: (i) => ga(i, r.id, "regular")
    });
  }
  async delete(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular" && r.status !== "archived")
      throw new Error("Thread is not yet initialized");
    return await this._ensureThreadIsNotMain(r.id), this._hookManager.stopThreadRuntime(r.id), this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: i } = await r.initializeTask;
        return await this._options.adapter.delete(i);
      },
      optimistic: (i) => ga(i, r.id, "deleted")
    });
  }
  async detach(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular" && r.status !== "archived")
      throw new Error("Thread is not yet initialized");
    await this._ensureThreadIsNotMain(r.id), this._hookManager.stopThreadRuntime(r.id);
  }
}
class ZA extends Tl {
  constructor(n) {
    super();
    O(this, "threads");
    this.threads = new JA(n, this._contextProvider);
  }
  get RenderComponent() {
    return this.threads.__internal_RenderComponent;
  }
}
const ey = (e) => {
  const [t] = we(() => new ZA(e));
  return Le(() => {
    t.threads.__internal_setOptions(e), t.threads.__internal_load();
  }, [t, e]), pe(() => new yl(t), [t]);
}, fg = (e) => {
  const t = st(e.runtimeHook);
  t.current = e.runtimeHook;
  const n = de(() => t.current(), []), r = pe(() => ({
    adapter: e.adapter,
    allowNesting: e.allowNesting,
    runtimeHook: n
  }), [e.adapter, e.allowNesting, n]);
  if (Ve().threadListItem.source !== null) {
    if (!r.allowNesting)
      throw new Error("useRemoteThreadListRuntime cannot be nested inside another RemoteThreadListRuntime. Set allowNesting: true to allow nesting (the inner runtime will become a no-op).");
    return n();
  }
  return ey(r);
}, vf = (e) => {
  try {
    const n = e.split(".")[1];
    if (!n)
      throw new Error("Invalid JWT format");
    let r = n.replace(/-/g, "+").replace(/_/g, "/");
    for (; r.length % 4 !== 0; )
      r += "=";
    const i = atob(r), a = JSON.parse(i).exp;
    if (!a || typeof a != "number")
      throw new Error('JWT does not contain a valid "exp" field');
    return a * 1e3;
  } catch (t) {
    throw new Error(`Unable to determine the token expiry: ${t}`);
  }
};
var Hs;
class hg {
  constructor(t) {
    O(this, "strategy", "jwt");
    O(this, "cachedToken", null);
    O(this, "tokenExpiry", null);
    Qi(this, Hs);
    Xi(this, Hs, t);
  }
  async getAuthHeaders() {
    const t = Date.now();
    if (this.cachedToken && this.tokenExpiry && this.tokenExpiry - t > 30 * 1e3)
      return { Authorization: `Bearer ${this.cachedToken}` };
    const n = await Ki(this, Hs).call(this);
    return n ? (this.cachedToken = n, this.tokenExpiry = vf(n), { Authorization: `Bearer ${n}` }) : !1;
  }
  readAuthHeaders(t) {
    const n = t.get("Authorization");
    if (!n)
      return;
    const [r, i] = n.split(" ");
    if (r !== "Bearer" || !i)
      throw new Error("Invalid auth header received");
    this.cachedToken = i, this.tokenExpiry = vf(i);
  }
}
Hs = new WeakMap();
var js, Bs, Fs;
class ty {
  constructor(t, n, r) {
    O(this, "strategy", "api-key");
    Qi(this, js);
    Qi(this, Bs);
    Qi(this, Fs);
    Xi(this, js, t), Xi(this, Bs, n), Xi(this, Fs, r);
  }
  async getAuthHeaders() {
    return {
      Authorization: `Bearer ${Ki(this, js)}`,
      "Aui-User-Id": Ki(this, Bs),
      "Aui-Workspace-Id": Ki(this, Fs)
    };
  }
  readAuthHeaders() {
  }
}
js = new WeakMap(), Bs = new WeakMap(), Fs = new WeakMap();
const ba = "aui:refresh_token";
class ny {
  constructor(t) {
    O(this, "strategy", "anon");
    O(this, "baseUrl");
    O(this, "jwtStrategy");
    this.baseUrl = t, this.jwtStrategy = new hg(async () => {
      const n = Date.now(), r = localStorage.getItem(ba), i = r ? JSON.parse(r) : void 0;
      if (i)
        if (new Date(i.expires_at).getTime() - n > 30 * 1e3) {
          const l = await fetch(`${this.baseUrl}/v1/auth/tokens/refresh`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refresh_token: i.token })
          });
          if (l.ok) {
            const d = await l.json(), { access_token: h, refresh_token: m } = d;
            return m && localStorage.setItem(ba, JSON.stringify(m)), h;
          }
        } else
          localStorage.removeItem(ba);
      const s = await fetch(`${this.baseUrl}/v1/auth/tokens/anonymous`, {
        method: "POST"
      });
      if (!s.ok)
        return null;
      const a = await s.json(), { access_token: o, refresh_token: u } = a;
      return !o || !u ? null : (localStorage.setItem(ba, JSON.stringify(u)), o);
    });
  }
  async getAuthHeaders() {
    return this.jwtStrategy.getAuthHeaders();
  }
  readAuthHeaders(t) {
    this.jwtStrategy.readAuthHeaders(t);
  }
}
class wf extends Error {
  constructor(t) {
    super(t), this.name = "APIError";
  }
}
class ry {
  constructor(t) {
    O(this, "_auth");
    O(this, "_baseUrl");
    if ("authToken" in t)
      this._baseUrl = t.baseUrl, this._auth = new hg(t.authToken);
    else if ("apiKey" in t)
      this._baseUrl = "https://backend.assistant-api.com", this._auth = new ty(t.apiKey, t.userId, t.workspaceId);
    else if ("anonymous" in t)
      this._baseUrl = t.baseUrl, this._auth = new ny(t.baseUrl);
    else
      throw new Error("Invalid configuration: Must provide authToken, apiKey, or anonymous configuration");
  }
  async initializeAuth() {
    return !!this._auth.getAuthHeaders();
  }
  async makeRawRequest(t, n = {}) {
    const r = await this._auth.getAuthHeaders();
    if (!r)
      throw new Error("Authorization failed");
    const i = {
      ...r,
      ...n.headers,
      "Content-Type": "application/json"
    }, s = new URLSearchParams();
    if (n.query)
      for (const [u, c] of Object.entries(n.query))
        c !== !1 && (c === !0 ? s.set(u, "true") : s.set(u, c.toString()));
    const a = new URL(`${this._baseUrl}/v1${t}`);
    a.search = s.toString();
    const o = await fetch(a, {
      method: n.method ?? "GET",
      headers: i,
      body: n.body ? JSON.stringify(n.body) : null
    });
    if (this._auth.readAuthHeaders(o.headers), !o.ok) {
      const u = await o.text();
      try {
        const c = JSON.parse(u);
        throw new wf(c.message);
      } catch (c) {
        throw c instanceof wf ? c : new Error(`Request failed with status ${o.status}, ${u}`);
      }
    }
    return o;
  }
  async makeRequest(t, n = {}) {
    return (await this.makeRawRequest(t, n)).json();
  }
}
class iy {
  constructor(t) {
    O(this, "cloud");
    this.cloud = t;
  }
  async create() {
    return this.cloud.makeRequest("/auth/tokens", { method: "POST" });
  }
}
class sy {
  constructor(t) {
    O(this, "cloud");
    this.cloud = t;
  }
  __internal_getAssistantOptions(t) {
    return {
      api: `${this.cloud._baseUrl}/v1/runs/stream`,
      headers: async () => {
        const n = await this.cloud._auth.getAuthHeaders();
        if (!n)
          throw new Error("Authorization failed");
        return {
          ...n,
          Accept: "text/plain"
        };
      },
      body: {
        assistant_id: t,
        response_format: "vercel-ai-data-stream/v1",
        thread_id: "unstable_todo"
      }
    };
  }
  async stream(t) {
    const n = await this.cloud.makeRawRequest("/runs/stream", {
      method: "POST",
      headers: {
        Accept: "text/plain"
      },
      body: t
    });
    return Nc.fromResponse(n, new nA());
  }
  async report(t) {
    return this.cloud.makeRequest("/runs", { method: "POST", body: t });
  }
}
class ay {
  constructor(t) {
    O(this, "cloud");
    this.cloud = t;
  }
  async list(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages`, { query: n });
  }
  async create(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages`, { method: "POST", body: n });
  }
  async update(t, n, r) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages/${encodeURIComponent(n)}`, { method: "PUT", body: r });
  }
}
class oy {
  constructor(t) {
    O(this, "cloud");
    O(this, "messages");
    this.cloud = t, this.messages = new ay(t);
  }
  async list(t) {
    return this.cloud.makeRequest("/threads", { query: t });
  }
  async get(t) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`);
  }
  async create(t) {
    return this.cloud.makeRequest("/threads", { method: "POST", body: t });
  }
  async update(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`, {
      method: "PUT",
      body: n
    });
  }
  async delete(t) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`, {
      method: "DELETE"
    });
  }
}
class uy {
  constructor(t) {
    O(this, "cloud");
    this.cloud = t;
  }
  async pdfToImages(t) {
    return this.cloud.makeRequest("/files/pdf-to-images", {
      method: "POST",
      body: t
    });
  }
  async generatePresignedUploadUrl(t) {
    return this.cloud.makeRequest("/files/attachments/generate-presigned-upload-url", {
      method: "POST",
      body: t
    });
  }
}
class cy {
  constructor(t) {
    O(this, "threads");
    O(this, "auth");
    O(this, "runs");
    O(this, "files");
    O(this, "telemetry");
    const n = new ry(t);
    this.threads = new oy(n), this.auth = {
      tokens: new iy(n)
    }, this.runs = new sy(n), this.files = new uy(n);
    const r = t.telemetry;
    this.telemetry = r === !1 ? { enabled: !1 } : r === !0 || r === void 0 ? { enabled: !0 } : { enabled: r.enabled !== !1, ...r };
  }
}
class ly {
  constructor(t) {
    O(this, "cloud");
    O(this, "idMapping", {});
    this.cloud = t;
  }
  /**
   * Persist a message to the cloud.
   *
   * @param threadId - Remote thread ID
   * @param messageId - Local message ID (used for tracking)
   * @param parentId - Local parent message ID (or null for first message)
   * @param format - Message format (e.g., "aui/v0", "ai-sdk/v6")
   * @param content - Message content (format-specific)
   */
  async append(t, n, r, i, s) {
    const a = r ? await this.idMapping[r] ?? r : null, o = this.cloud.threads.messages.create(t, {
      parent_id: a,
      format: i,
      content: s
    }).then(({ message_id: u }) => (this.idMapping[n] = u, u)).catch((u) => {
      throw this.idMapping[n] === o && delete this.idMapping[n], u;
    });
    return this.idMapping[n] = o, o.then(() => {
    });
  }
  /**
   * Update an already-persisted message in the cloud.
   */
  async update(t, n, r, i) {
    const s = await this.getRemoteId(n);
    s && await this.cloud.threads.messages.update(t, s, { content: i });
  }
  /**
   * Check if a message has been persisted (or is currently being persisted).
   */
  isPersisted(t) {
    return t in this.idMapping;
  }
  /**
   * Get the remote ID for a local message ID (resolved).
   * Returns undefined if not persisted.
   */
  async getRemoteId(t) {
    const n = this.idMapping[t];
    if (n)
      return n;
  }
  /**
   * Load messages from the cloud and populate the ID mapping.
   *
   * The ID mapping is populated so that `isPersisted()` returns true for
   * loaded messages, preventing re-persistence of already-stored messages.
   *
   * @param threadId - Remote thread ID
   * @param format - Optional format filter
   * @returns Array of cloud messages
   */
  async load(t, n) {
    const { messages: r } = await this.cloud.threads.messages.list(t, n ? { format: n } : void 0);
    for (const i of r)
      this.idMapping[i.id] = i.id;
    return r;
  }
  /**
   * Reset the ID mapping (call when switching threads).
   */
  reset() {
    this.idMapping = {};
  }
}
const dy = (e, t) => ({
  append: async (n, r) => {
    const i = t.getId(r.message), s = t.encode(r);
    return e.append(n, i, r.parentId, t.format, s);
  },
  update: e.update ? async (n, r, i) => {
    const s = t.encode(r);
    return e.update(n, i, t.format, s);
  } : void 0,
  load: async (n) => ({
    messages: (await e.load(n, t.format)).filter((i) => i.format === t.format).map((i) => t.decode({
      id: i.id,
      parent_id: i.parent_id,
      format: i.format,
      content: i.content
    })).reverse()
  }),
  isPersisted: (n) => e.isPersisted(n)
});
class fy {
  list() {
    return Promise.resolve({
      threads: []
    });
  }
  rename() {
    return Promise.resolve();
  }
  archive() {
    return Promise.resolve();
  }
  unarchive() {
    return Promise.resolve();
  }
  delete() {
    return Promise.resolve();
  }
  initialize(t) {
    return Promise.resolve({ remoteId: t, externalId: void 0 });
  }
  generateTitle() {
    return Promise.resolve(new ReadableStream());
  }
  fetch(t) {
    return Promise.reject(new Error("Thread not found"));
  }
}
function hy(e) {
  const t = e.status?.type === "running" ? { type: "incomplete", reason: "cancelled" } : e.status;
  return {
    role: e.role,
    content: e.content.map((n) => {
      const r = n.type;
      switch (r) {
        case "text":
          return { type: "text", text: n.text };
        case "reasoning":
          return { type: "reasoning", text: n.text };
        case "source":
          return {
            type: "source",
            sourceType: n.sourceType,
            id: n.id,
            url: n.url,
            ...n.title ? { title: n.title } : void 0
          };
        case "tool-call":
          return wc(n.result) || console.warn(`tool-call result is not JSON! ${JSON.stringify(n)}`), {
            type: "tool-call",
            toolCallId: n.toolCallId,
            toolName: n.toolName,
            ...JSON.stringify(n.args) === n.argsText ? { args: n.args } : { argsText: n.argsText },
            ...n.result ? { result: n.result } : void 0,
            ...n.isError ? { isError: !0 } : void 0
          };
        case "image":
          return { type: "image", image: n.image };
        case "file":
          return {
            type: "file",
            data: n.data,
            mimeType: n.mimeType,
            ...n.filename ? { filename: n.filename } : void 0
          };
        default: {
          const i = r;
          throw new Error(`Message part type not supported by aui/v0: ${i}`);
        }
      }
    }),
    metadata: e.metadata,
    ...t ? { status: t } : void 0
  };
}
function my(e) {
  const t = e.content, n = Vs({
    id: e.id,
    createdAt: e.created_at,
    ...t
  }, e.id, { type: "complete", reason: "unknown" });
  return {
    parentId: e.parent_id,
    message: n
  };
}
const vu = /* @__PURE__ */ new WeakMap();
class py {
  constructor(t, n) {
    O(this, "cloudRef");
    O(this, "aui");
    this.cloudRef = t, this.aui = n;
  }
  get _persistence() {
    const t = this.aui.threadListItem();
    return vu.has(t) || vu.set(t, new ly(this.cloudRef.current)), vu.get(t);
  }
  withFormat(t) {
    const n = this, r = dy(this._persistence, t);
    return {
      // Note: callers must also call reportTelemetry() for run tracking
      async append(i) {
        const { remoteId: s } = await n.aui.threadListItem().initialize();
        await r.append(s, i);
      },
      async update(i, s) {
        const a = n.aui.threadListItem().getState().remoteId;
        a && await r.update?.(a, i, s);
      },
      reportTelemetry(i, s) {
        const a = i.map((o) => t.encode(o));
        n._reportRunTelemetry(t.format, a, s);
      },
      async load() {
        const i = n.aui.threadListItem().getState().remoteId;
        return i ? r.load(i) : { messages: [] };
      }
    };
  }
  async append({ parentId: t, message: n }) {
    const { remoteId: r } = await this.aui.threadListItem().initialize(), i = hy(n);
    await this._persistence.append(r, n.id, t, "aui/v0", i), this.cloudRef.current.telemetry.enabled && this._maybeReportRun(r, "aui/v0", i);
  }
  async load() {
    const t = this.aui.threadListItem().getState().remoteId;
    return t ? {
      messages: (await this._persistence.load(t, "aui/v0")).filter((r) => r.format === "aui/v0").map(my).reverse()
    } : { messages: [] };
  }
  _reportRunTelemetry(t, n, r) {
    if (!this.cloudRef.current.telemetry.enabled)
      return;
    const i = this.aui.threadListItem().getState().remoteId;
    if (!i)
      return;
    const s = _y(t, n);
    s && this._sendReport(i, s, r?.durationMs, r?.stepTimestamps);
  }
  _maybeReportRun(t, n, r) {
    const i = pg(n, r);
    i && this._sendReport(t, i);
  }
  _sendReport(t, n, r, i) {
    const s = Ey(n.steps, i), a = {
      thread_id: t,
      status: n.status,
      ...n.totalSteps != null ? { total_steps: n.totalSteps } : void 0,
      ...n.toolCalls ? { tool_calls: n.toolCalls } : void 0,
      ...s ? { steps: s } : void 0,
      ...n.inputTokens != null ? { input_tokens: n.inputTokens } : void 0,
      ...n.outputTokens != null ? { output_tokens: n.outputTokens } : void 0,
      ...n.reasoningTokens != null ? { reasoning_tokens: n.reasoningTokens } : void 0,
      ...n.cachedInputTokens != null ? { cached_input_tokens: n.cachedInputTokens } : void 0,
      ...r != null ? { duration_ms: r } : void 0,
      ...n.outputText != null ? { output_text: n.outputText } : void 0,
      ...n.metadata ? { metadata: n.metadata } : void 0,
      ...n.modelId ? { model_id: n.modelId } : void 0
    }, { beforeReport: o } = this.cloudRef.current.telemetry, u = o ? o(a) : a;
    u && this.cloudRef.current.runs.report(u).catch(() => {
    });
  }
}
const Cf = 5e4;
function Oo(e) {
  return e.length <= Cf ? e : e.slice(0, Cf);
}
function Sc(e) {
  if (e != null)
    try {
      return Oo(JSON.stringify(e));
    } catch {
      return;
    }
}
const gy = /^[A-Za-z0-9+/]{100,}={0,2}$/;
function by(e) {
  if (e != null) {
    try {
      const t = typeof e == "string" ? JSON.parse(e) : e;
      if (Array.isArray(t)) {
        const n = t.map((r) => {
          if (r && typeof r == "object" && r.type && (r.type === "image" || r.type === "audio") && typeof r.data == "string" && gy.test(r.data.slice(0, 200))) {
            const i = (r.data.length * 3 / 4 / 1024).toFixed(1);
            return { ...r, data: `[${r.type}: ${i}KB]` };
          }
          return r;
        });
        return Oo(JSON.stringify(n));
      }
    } catch {
    }
    return Sc(e);
  }
}
function mg(e, t, n, r, i, s) {
  const a = {
    tool_name: e,
    tool_call_id: t
  }, o = i ?? Sc(n);
  o !== void 0 && (a.tool_args = o);
  const u = s === "mcp" ? by(r) : Sc(r);
  return u !== void 0 && (a.tool_result = u), s && (a.tool_source = s), a;
}
function Ey(e, t) {
  if (!t)
    return e;
  if (!e)
    return t.map((r) => ({ ...r }));
  const n = Math.min(e.length, t.length);
  return e.map((r, i) => ({
    ...r,
    ...i < n ? t[i] : void 0
  }));
}
function pg(e, t) {
  switch (e) {
    case "aui/v0":
      return Ty(t);
    case "ai-sdk/v6":
      return wy(t);
    default:
      return null;
  }
}
function _y(e, t) {
  if (e === "ai-sdk/v6")
    return Cy(t);
  for (let n = t.length - 1; n >= 0; n--) {
    const r = pg(e, t[n]);
    if (r)
      return r;
  }
  return null;
}
const xy = {
  error: "error",
  incomplete: "incomplete"
};
function Ty(e) {
  const t = e;
  if (t.role !== "assistant")
    return null;
  const n = t.content?.filter((g) => g.type === "tool-call" && g.toolName && g.toolCallId).map((g) => mg(g.toolName, g.toolCallId, g.args, g.result, g.argsText)), r = t.content?.filter((g) => g.type === "text" && g.text), i = r && r.length > 0 ? Oo(r.map((g) => g.text).join("")) : void 0, s = t.metadata?.steps;
  let a, o, u, c;
  if (s && s.length > 0) {
    let g = 0, T = 0, _ = 0, A = 0, w = !1, M = !1, F = !1, k = !1;
    for (const B of s)
      B.usage?.inputTokens != null && (g += B.usage.inputTokens, w = !0), B.usage?.outputTokens != null && (T += B.usage.outputTokens, M = !0), B.usage?.reasoningTokens != null && (_ += B.usage.reasoningTokens, F = !0), B.usage?.cachedInputTokens != null && (A += B.usage.cachedInputTokens, k = !0);
    a = w ? g : void 0, o = M ? T : void 0, u = F ? _ : void 0, c = k ? A : void 0;
  }
  const l = t.status?.type, d = l && xy[l] || "completed", h = t.metadata?.custom, m = t.metadata?.modelId ?? (typeof t.metadata?.custom?.modelId == "string" ? t.metadata.custom.modelId : void 0), E = s && s.length > 1 ? s.map((g) => ({
    ...g.usage?.inputTokens != null ? { input_tokens: g.usage.inputTokens } : void 0,
    ...g.usage?.outputTokens != null ? { output_tokens: g.usage.outputTokens } : void 0,
    ...g.usage?.reasoningTokens != null ? { reasoning_tokens: g.usage.reasoningTokens } : void 0,
    ...g.usage?.cachedInputTokens != null ? { cached_input_tokens: g.usage.cachedInputTokens } : void 0
  })) : void 0;
  return {
    status: d,
    ...n && n.length > 0 ? { toolCalls: n } : void 0,
    ...s?.length ? { totalSteps: s.length } : void 0,
    ...a != null ? { inputTokens: a } : void 0,
    ...o != null ? { outputTokens: o } : void 0,
    ...u != null ? { reasoningTokens: u } : void 0,
    ...c != null ? { cachedInputTokens: c } : void 0,
    ...i != null ? { outputText: i } : void 0,
    ...h ? { metadata: h } : void 0,
    ...E ? { steps: E } : void 0,
    ...m ? { modelId: m } : void 0
  };
}
function Ay(e) {
  return e.toolCallId ? e.type === "tool-call" || e.type === "dynamic-tool" ? !!e.toolName : e.type.startsWith("tool-") || e.type.startsWith("dynamic-tool-") : !1;
}
function yy(e) {
  return e.type === "dynamic-tool" || e.type.startsWith("dynamic-tool-");
}
function Ny(e) {
  const t = yy(e) ? "mcp" : void 0;
  return mg(e.toolName ?? e.type.slice(5), e.toolCallId, e.args ?? e.input, e.result ?? e.output, void 0, t);
}
function gg(e) {
  const t = [], n = [], r = [];
  let i = null;
  for (const s of e)
    if (s.type === "step-start")
      i !== null && r.push({ tool_calls: i }), i = [];
    else if (s.type === "text" && s.text)
      t.push(s.text);
    else if (Ay(s)) {
      const a = Ny(s);
      n.push(a), i !== null && i.push(a);
    }
  return i !== null && r.push({ tool_calls: i }), { textParts: t, toolCalls: n, stepsData: r };
}
function vy(e) {
  if (!e)
    return;
  if (typeof e.modelId == "string")
    return e.modelId;
  const t = e.custom;
  if (typeof t?.modelId == "string")
    return t.modelId;
}
function bg(e, t, n, r, i, s) {
  const a = e.length > 0, o = a ? Oo(e.join("")) : void 0, u = vy(r), c = i && i.length > 1 ? i.map((l) => ({
    ...l.tool_calls.length > 0 ? { tool_calls: l.tool_calls } : void 0
  })) : void 0;
  return {
    status: a ? "completed" : "incomplete",
    ...t.length > 0 ? { toolCalls: t } : void 0,
    ...n > 0 ? { totalSteps: n } : void 0,
    ...s?.inputTokens != null ? { inputTokens: s.inputTokens } : void 0,
    ...s?.outputTokens != null ? { outputTokens: s.outputTokens } : void 0,
    ...s?.reasoningTokens != null ? { reasoningTokens: s.reasoningTokens } : void 0,
    ...s?.cachedInputTokens != null ? { cachedInputTokens: s.cachedInputTokens } : void 0,
    ...o != null ? { outputText: o } : void 0,
    ...r ? { metadata: r } : void 0,
    ...c ? { steps: c } : void 0,
    ...u ? { modelId: u } : void 0
  };
}
function Sf(e) {
  const t = e.inputTokens ?? e.promptTokens, n = e.outputTokens ?? e.completionTokens;
  if (!(t == null && n == null && e.reasoningTokens == null && e.cachedInputTokens == null))
    return {
      ...t != null ? { inputTokens: t } : void 0,
      ...n != null ? { outputTokens: n } : void 0,
      ...e.reasoningTokens != null ? { reasoningTokens: e.reasoningTokens } : void 0,
      ...e.cachedInputTokens != null ? { cachedInputTokens: e.cachedInputTokens } : void 0
    };
}
function Eg(e) {
  const t = e?.usage;
  if (t) {
    const r = Sf(t);
    if (r)
      return r;
  }
  const n = e?.steps;
  if (n && n.length > 0) {
    let r = 0, i = 0, s = 0, a = 0, o = !1, u = !1, c = !1, l = !1, d = !1;
    for (const h of n) {
      if (!h.usage)
        continue;
      const m = Sf(h.usage);
      m && (m.inputTokens != null && (r += m.inputTokens, o = !0), m.outputTokens != null && (i += m.outputTokens, u = !0), m.reasoningTokens != null && (s += m.reasoningTokens, c = !0), m.cachedInputTokens != null && (a += m.cachedInputTokens, l = !0), d = !0);
    }
    if (d)
      return {
        ...o ? { inputTokens: r } : void 0,
        ...u ? { outputTokens: i } : void 0,
        ...c ? { reasoningTokens: s } : void 0,
        ...l ? { cachedInputTokens: a } : void 0
      };
  }
}
function wy(e) {
  const t = e;
  if (t.role !== "assistant")
    return null;
  const { textParts: n, toolCalls: r, stepsData: i } = gg(t.parts ?? []);
  return bg(n, r, i.length, t.metadata, i, Eg(t.metadata));
}
function Cy(e) {
  const t = [], n = [], r = [];
  let i = !1, s, a = 0, o = 0, u = 0, c = 0, l = !1, d = !1, h = !1, m = !1;
  for (const E of e) {
    const g = E;
    if (g.role !== "assistant")
      continue;
    i = !0;
    const { textParts: T, toolCalls: _, stepsData: A } = gg(g.parts ?? []);
    t.push(...T), n.push(..._), r.push(...A), g.metadata && (s = g.metadata);
    const w = Eg(g.metadata);
    w && (w.inputTokens != null && (a += w.inputTokens, l = !0), w.outputTokens != null && (o += w.outputTokens, d = !0), w.reasoningTokens != null && (u += w.reasoningTokens, h = !0), w.cachedInputTokens != null && (c += w.cachedInputTokens, m = !0));
  }
  return i ? bg(t, n, r.length, s, r, {
    ...l ? { inputTokens: a } : void 0,
    ...d ? { outputTokens: o } : void 0,
    ...h ? { reasoningTokens: u } : void 0,
    ...m ? { cachedInputTokens: c } : void 0
  }) : null;
}
function Sy(e) {
  const t = Ve(), [n] = we(() => new py(e, t));
  return n;
}
const ky = (e) => e.startsWith("image/") ? "image" : e.startsWith("text/") ? "document" : "file";
class Iy {
  constructor(t) {
    O(this, "cloud");
    O(this, "accept", "*");
    O(this, "uploadedUrls", /* @__PURE__ */ new Map());
    this.cloud = t;
  }
  async *add({ file: t }) {
    const n = crypto.randomUUID(), r = ky(t.type);
    let i = {
      id: n,
      type: r,
      name: t.name,
      contentType: t.type,
      file: t,
      status: { type: "running", reason: "uploading", progress: 0 }
    };
    yield i;
    try {
      const { signedUrl: s, publicUrl: a } = await this.cloud.files.generatePresignedUploadUrl({
        filename: t.name
      });
      await fetch(s, {
        method: "PUT",
        body: t,
        headers: {
          "Content-Type": t.type
        },
        mode: "cors"
      }), this.uploadedUrls.set(n, a), i = {
        ...i,
        status: { type: "requires-action", reason: "composer-send" }
      }, yield i;
    } catch {
      i = {
        ...i,
        status: { type: "incomplete", reason: "error" }
      }, yield i;
    }
  }
  async remove(t) {
    this.uploadedUrls.delete(t.id);
  }
  async send(t) {
    const n = this.uploadedUrls.get(t.id);
    if (!n)
      throw new Error("Attachment not uploaded");
    this.uploadedUrls.delete(t.id);
    let r;
    return t.type === "image" ? r = [{ type: "image", image: n, filename: t.name }] : r = [
      {
        type: "file",
        data: n,
        mimeType: t.contentType ?? "",
        filename: t.name
      }
    ], {
      ...t,
      status: { type: "complete" },
      content: r
    };
  }
}
const kf = typeof process < "u" && process?.env?.NEXT_PUBLIC_ASSISTANT_BASE_URL, wu = kf ? new cy({ baseUrl: kf, anonymous: !0 }) : void 0, Dy = (e) => {
  const t = st(e);
  Le(() => {
    t.current = e;
  }, [e]);
  const n = de(function({ children: s }) {
    const a = Sy({
      get current() {
        return t.current.cloud ?? wu;
      }
    }), o = t.current.cloud ?? wu, u = pe(() => new Iy(o), [o]), c = pe(() => ({
      history: a,
      attachments: u
    }), [a, u]);
    return S.jsx(Nl, { adapters: c, children: s });
  }, []), r = e.cloud ?? wu;
  if (!r) {
    const i = t, s = new fy();
    return s.initialize = async (a) => {
      const o = await i.current.create?.();
      return { remoteId: a, externalId: o?.externalId };
    }, s;
  }
  return {
    list: async () => {
      const { threads: i } = await r.threads.list();
      return {
        threads: i.map((s) => ({
          status: s.is_archived ? "archived" : "regular",
          remoteId: s.id,
          title: s.title,
          externalId: s.external_id ?? void 0
        }))
      };
    },
    initialize: async () => {
      const s = await (e.create?.() ?? Promise.resolve()), a = s ? s.externalId : void 0, { thread_id: o } = await r.threads.create({
        last_message_at: /* @__PURE__ */ new Date(),
        external_id: a
      });
      return { externalId: a, remoteId: o };
    },
    rename: async (i, s) => r.threads.update(i, { title: s }),
    archive: async (i) => r.threads.update(i, { is_archived: !0 }),
    unarchive: async (i) => r.threads.update(i, { is_archived: !1 }),
    delete: async (i) => (await e.delete?.(i), r.threads.delete(i)),
    generateTitle: async (i, s) => {
      const a = s.map((o) => ({
        ...o,
        content: o.content.filter((u) => u.type === "text" || u.type === "tool-call")
      }));
      return r.runs.stream({
        thread_id: i,
        assistant_id: "system/thread_title",
        messages: a
      });
    },
    fetch: async (i) => {
      const s = await r.threads.get(i);
      return {
        status: s.is_archived ? "archived" : "regular",
        remoteId: s.id,
        title: s.title,
        externalId: s.external_id ?? void 0
      };
    },
    unstable_Provider: n
  };
}, Ry = (e) => e._core?.RenderComponent, Py = Ce(({ runtime: e, aui: t = null, children: n }) => {
  const r = Ve({ threads: dg(e) }, { parent: t }), i = Ry(e);
  return S.jsxs(qr, { value: r, children: [i && S.jsx(i, {}), n] });
}), _g = (e, t) => e.Message === t.Message && e.EditComposer === t.EditComposer && e.UserEditComposer === t.UserEditComposer && e.AssistantEditComposer === t.AssistantEditComposer && e.SystemEditComposer === t.SystemEditComposer && e.UserMessage === t.UserMessage && e.AssistantMessage === t.AssistantMessage && e.SystemMessage === t.SystemMessage, Oy = () => null, Ly = (e, t, n) => {
  switch (t) {
    case "user":
      return n ? e.UserEditComposer ?? e.EditComposer ?? e.UserMessage ?? e.Message : e.UserMessage ?? e.Message;
    case "assistant":
      return n ? e.AssistantEditComposer ?? e.EditComposer ?? e.AssistantMessage ?? e.Message : e.AssistantMessage ?? e.Message;
    case "system":
      return n ? e.SystemEditComposer ?? e.EditComposer ?? e.SystemMessage ?? e.Message : e.SystemMessage ?? e.Message ?? Oy;
    default:
      const r = t;
      throw new Error(`Unknown message role: ${r}`);
  }
}, xg = ({ components: e }) => {
  const t = oe((i) => i.message.role), n = oe((i) => i.message.composer.isEditing), r = Ly(e, t, n);
  return S.jsx(r, {});
}, vl = Ce(({ index: e, components: t }) => S.jsx(Qp, { index: e, children: S.jsx(xg, { components: t }) }), (e, t) => e.index === t.index && _g(e.components, t.components));
vl.displayName = "ThreadPrimitive.MessageByIndex";
const If = ({ children: e }) => {
  const t = oe((n) => n.thread.messages.length);
  return pe(() => t === 0 ? null : Array.from({ length: t }, (n, r) => S.jsx(Qp, { index: r, children: S.jsx(bl, { getItemState: (i) => i.thread().message({ index: r }).getState(), children: (i) => e({
    get message() {
      return i();
    }
  }) }) }, r)), [t, e]);
}, Tg = ({ components: e, children: t }) => e ? S.jsx(If, { children: () => S.jsx(xg, { components: e }) }) : S.jsx(If, { children: t });
Tg.displayName = "ThreadPrimitive.Messages";
Ce(Tg, (e, t) => e.children || t.children ? e.children === t.children : _g(e.components, t.components));
const My = (e) => {
  const t = e.message.metadata;
  if (!(!t || typeof t != "object"))
    return t.custom?.quote;
}, Df = (e) => Symbol.iterator in e, Rf = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), Pf = (e, t) => {
  const n = e instanceof Map ? e : new Map(e.entries()), r = t instanceof Map ? t : new Map(t.entries());
  if (n.size !== r.size)
    return !1;
  for (const [i, s] of n)
    if (!r.has(i) || !Object.is(s, r.get(i)))
      return !1;
  return !0;
}, Uy = (e, t) => {
  const n = e[Symbol.iterator](), r = t[Symbol.iterator]();
  let i = n.next(), s = r.next();
  for (; !i.done && !s.done; ) {
    if (!Object.is(i.value, s.value))
      return !1;
    i = n.next(), s = r.next();
  }
  return !!i.done && !!s.done;
};
function Hy(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? !1 : Df(e) && Df(t) ? Rf(e) && Rf(t) ? Pf(e, t) : Uy(e, t) : Pf(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  );
}
function jy(e) {
  const t = ct.useRef(void 0);
  return (n) => {
    const r = e(n);
    return Hy(t.current, r) ? t.current : t.current = r;
  };
}
const Cu = (e) => {
  let t = -1;
  return {
    startGroup: (n) => {
      t === -1 && (t = n);
    },
    endGroup: (n, r) => {
      t !== -1 && (r.push({
        type: e,
        startIndex: t,
        endIndex: n
      }), t = -1);
    },
    finalize: (n, r) => {
      t !== -1 && r.push({
        type: e,
        startIndex: t,
        endIndex: n
      });
    }
  };
}, By = (e, t) => {
  const n = [];
  if (t) {
    const r = Cu("chainOfThoughtGroup");
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      s === "tool-call" || s === "reasoning" ? r.startGroup(i) : (r.endGroup(i - 1, n), n.push({ type: "single", index: i }));
    }
    r.finalize(e.length - 1, n);
  } else {
    const r = Cu("toolGroup"), i = Cu("reasoningGroup");
    for (let s = 0; s < e.length; s++) {
      const a = e[s];
      a === "tool-call" ? (i.endGroup(s - 1, n), r.startGroup(s)) : a === "reasoning" ? (r.endGroup(s - 1, n), i.startGroup(s)) : (r.endGroup(s - 1, n), i.endGroup(s - 1, n), n.push({ type: "single", index: s }));
    }
    r.finalize(e.length - 1, n), i.finalize(e.length - 1, n);
  }
  return n;
}, Fy = (e) => {
  const t = oe(jy((n) => n.message.parts.map((r) => r.type)));
  return pe(() => t.length === 0 ? [] : By(t, e), [t, e]);
}, zy = ({ Fallback: e, ...t }) => {
  const n = oe((r) => {
    const i = r.tools.tools[t.toolName] ?? e;
    return Array.isArray(i) ? i[0] ?? e : i;
  });
  return n ? S.jsx(n, { ...t }) : null;
}, Vy = ({ Fallback: e, ...t }) => {
  const n = oe((r) => {
    const i = r.dataRenderers.renderers[t.name] ?? e;
    return Array.isArray(i) ? i[0] ?? e : i;
  });
  return n ? S.jsx(n, { ...t }) : null;
}, Dt = {
  Text: () => null,
  Reasoning: () => null,
  Source: () => null,
  Image: () => null,
  File: () => null,
  Unstable_Audio: () => null,
  ToolGroup: ({ children: e }) => e,
  ReasoningGroup: ({ children: e }) => e
}, Wy = ({ components: { Text: e = Dt.Text, Reasoning: t = Dt.Reasoning, Image: n = Dt.Image, Source: r = Dt.Source, File: i = Dt.File, Unstable_Audio: s = Dt.Unstable_Audio, tools: a = {}, data: o } = {} }) => {
  const u = Ve(), c = oe((d) => d.part), l = c.type;
  if (l === "tool-call") {
    const d = u.part().addToolResult, h = u.part().resumeToolCall;
    if ("Override" in a)
      return S.jsx(a.Override, { ...c, addResult: d, resume: h });
    const m = a.by_name?.[c.toolName] ?? a.Fallback;
    return S.jsx(zy, { ...c, Fallback: m, addResult: d, resume: h });
  }
  if (c.status?.type === "requires-action")
    throw new Error("Encountered unexpected requires-action status");
  switch (l) {
    case "text":
      return S.jsx(e, { ...c });
    case "reasoning":
      return S.jsx(t, { ...c });
    case "source":
      return S.jsx(r, { ...c });
    case "image":
      return S.jsx(n, { ...c });
    case "file":
      return S.jsx(i, { ...c });
    case "audio":
      return S.jsx(s, { ...c });
    case "data": {
      const d = o?.by_name?.[c.name] ?? o?.Fallback;
      return S.jsx(Vy, { ...c, Fallback: d });
    }
    default:
      return console.warn(`Unknown message part type: ${l}`), null;
  }
}, Ba = Ce(({ index: e, components: t }) => S.jsx(Xp, { index: e, children: S.jsx(Wy, { components: t }) }), (e, t) => e.index === t.index && e.components?.Text === t.components?.Text && e.components?.Reasoning === t.components?.Reasoning && e.components?.Source === t.components?.Source && e.components?.Image === t.components?.Image && e.components?.File === t.components?.File && e.components?.Unstable_Audio === t.components?.Unstable_Audio && e.components?.tools === t.components?.tools && e.components?.data === t.components?.data && e.components?.ToolGroup === t.components?.ToolGroup && e.components?.ReasoningGroup === t.components?.ReasoningGroup);
Ba.displayName = "MessagePrimitive.PartByIndex";
const $y = ({ status: e, component: t }) => S.jsx(gA, { text: "", isRunning: e.type === "running", children: S.jsx(t, { type: "text", text: "", status: e }) }), Yy = Object.freeze({
  type: "complete"
}), Gy = ({ components: e }) => {
  const t = oe((n) => n.message.status ?? Yy);
  return e?.Empty ? S.jsx(e.Empty, { status: t }) : t.type !== "running" ? null : S.jsx($y, { status: t, component: e?.Text ?? Dt.Text });
}, Ag = Ce(Gy, (e, t) => e.components?.Empty === t.components?.Empty && e.components?.Text === t.components?.Text), qy = ({ components: e, enabled: t }) => oe((r) => {
  if (!t || r.message.parts.length === 0)
    return !1;
  const i = r.message.parts[r.message.parts.length - 1];
  return i?.type !== "text" && i?.type !== "reasoning";
}) ? S.jsx(Ag, { components: e }) : null, Ky = Ce(qy, (e, t) => e.enabled === t.enabled && e.components?.Empty === t.components?.Empty && e.components?.Text === t.components?.Text), Qy = ({ Quote: e }) => {
  const t = oe(My);
  return t ? S.jsx(e, { text: t.text, messageId: t.messageId }) : null;
}, Xy = Ce(Qy), yg = () => {
  const e = Ve(), t = oe((r) => r.part), n = oe((r) => {
    if (r.part.type !== "tool-call")
      return null;
    const i = r.tools.tools[r.part.toolName];
    return Array.isArray(i) ? i[0] ?? null : i ?? null;
  });
  return !n || t.type !== "tool-call" ? null : S.jsx(n, { ...t, addResult: e.part().addToolResult, resume: e.part().resumeToolCall });
}, Ng = () => {
  const e = oe((n) => n.part), t = oe((n) => {
    if (n.part.type !== "data")
      return null;
    const r = n.dataRenderers.renderers[n.part.name];
    return Array.isArray(r) ? r[0] ?? null : r ?? null;
  });
  return !t || e.type !== "data" ? null : S.jsx(t, { ...e });
}, Jy = () => {
  const e = oe((t) => t.part.type);
  return e === "tool-call" ? S.jsx(yg, {}) : e === "data" ? S.jsx(Ng, {}) : null;
}, Zy = ({ children: e }) => {
  const t = Ve(), n = oe((r) => r.message.parts.length);
  return pe(() => Array.from({ length: n }, (r, i) => S.jsx(Xp, { index: i, children: S.jsx(bl, { getItemState: (s) => s.message().part({ index: i }).getState(), children: (s) => {
    const a = e({
      get part() {
        const o = s();
        if (o.type === "tool-call") {
          const u = t.tools().getState().tools[o.toolName], c = Array.isArray(u) ? !!u[0] : !!u, l = t.message().part({ index: i });
          return {
            ...o,
            toolUI: c ? S.jsx(yg, {}) : null,
            addResult: l.addToolResult,
            resume: l.resumeToolCall
          };
        }
        if (o.type === "data") {
          const u = t.dataRenderers().getState().renderers[o.name], c = Array.isArray(u) ? !!u[0] : !!u;
          return {
            ...o,
            dataRendererUI: c ? S.jsx(Ng, {}) : null
          };
        }
        return o;
      }
    });
    return a !== null ? a : S.jsx(Jy, {});
  } }) }, i)), [n, e]);
}, kc = ({ components: e, unstable_showEmptyOnNonTextEnd: t = !0, children: n }) => n ? S.jsx(Zy, { children: n }) : S.jsx(eN, { components: e, unstable_showEmptyOnNonTextEnd: t });
kc.displayName = "MessagePrimitive.Parts";
const eN = ({ components: e, unstable_showEmptyOnNonTextEnd: t }) => {
  const n = oe((a) => a.message.parts.length), r = !!e?.ChainOfThought, i = Fy(r), s = pe(() => n === 0 ? S.jsx(Ag, { components: e }) : i.map((a) => {
    if (a.type === "single")
      return S.jsx(Ba, { index: a.index, components: e }, a.index);
    if (a.type === "chainOfThoughtGroup") {
      const o = e?.ChainOfThought;
      return o ? S.jsx(bA, { startIndex: a.startIndex, endIndex: a.endIndex, children: S.jsx(o, {}) }, `chainOfThought-${a.startIndex}`) : null;
    } else if (a.type === "toolGroup") {
      const o = e?.ToolGroup ?? Dt.ToolGroup;
      return S.jsx(o, { startIndex: a.startIndex, endIndex: a.endIndex, children: Array.from({ length: a.endIndex - a.startIndex + 1 }, (u, c) => S.jsx(Ba, { index: a.startIndex + c, components: e }, c)) }, `tool-${a.startIndex}`);
    } else {
      const o = e?.ReasoningGroup ?? Dt.ReasoningGroup;
      return S.jsx(o, { startIndex: a.startIndex, endIndex: a.endIndex, children: Array.from({ length: a.endIndex - a.startIndex + 1 }, (u, c) => S.jsx(Ba, { index: a.startIndex + c, components: e }, c)) }, `reasoning-${a.startIndex}`);
    }
  }), [i, e, n]);
  return S.jsxs(S.Fragment, { children: [e?.Quote && S.jsx(Xy, { Quote: e.Quote }), s, S.jsx(Ky, { components: e, enabled: t })] });
}, tN = Ce(({ index: e, archived: t = !1, components: n }) => {
  const r = n.ThreadListItem;
  return S.jsx(Jp, { index: e, archived: t, children: S.jsx(r, {}) });
}, (e, t) => e.index === t.index && e.archived === t.archived && e.components.ThreadListItem === t.components.ThreadListItem);
tN.displayName = "ThreadListPrimitive.ItemByIndex";
const Of = ({ archived: e, children: t }) => {
  const n = oe((r) => e ? r.threads.archivedThreadIds.length : r.threads.threadIds.length);
  return pe(() => Array.from({ length: n }, (r, i) => S.jsx(Jp, { index: i, archived: e, children: S.jsx(bl, { getItemState: (s) => s.threads().item({ index: i, archived: e }).getState(), children: (s) => t({
    get threadListItem() {
      return s();
    }
  }) }) }, i)), [n, e, t]);
}, vg = ({ archived: e = !1, components: t, children: n }) => {
  if (t) {
    const r = t.ThreadListItem;
    return S.jsx(Of, { archived: e, children: () => S.jsx(r, {}) });
  }
  return S.jsx(Of, { archived: e, children: n });
};
vg.displayName = "ThreadListPrimitive.Items";
const wg = ({ fallback: e }) => {
  const t = oe((n) => n.threadListItem.title);
  return S.jsx(S.Fragment, { children: t || e });
};
wg.displayName = "ThreadListItemPrimitive.Title";
const nN = () => {
  const e = Ve(), t = oe((r) => r.thread.isRunning && !r.thread.capabilities.queue || !r.composer.isEditing || r.composer.isEmpty);
  return { send: de((r) => {
    e.composer().send(r);
  }, [e]), disabled: t };
}, rN = () => {
  const e = Ve(), t = oe((r) => !r.composer.canCancel);
  return { cancel: de(() => {
    e.composer().cancel();
  }, [e]), disabled: t };
}, iN = () => {
  const e = Ve(), t = oe((r) => r.composer.isEditing);
  return { edit: de(() => {
    e.composer().beginEdit();
  }, [e]), disabled: t };
}, sN = () => {
  const e = Ve(), t = oe((r) => r.thread.isRunning || r.thread.isDisabled || r.message.role !== "assistant");
  return { reload: de(() => {
    e.message().reload();
  }, [e]), disabled: t };
}, aN = () => {
  const e = Ve(), t = oe((r) => r.message.metadata.submittedFeedback?.type === "positive");
  return { submit: de(() => {
    e.message().submitFeedback({ type: "positive" });
  }, [e]), isSubmitted: t };
}, oN = () => {
  const e = Ve(), t = oe((r) => r.message.metadata.submittedFeedback?.type === "negative");
  return { submit: de(() => {
    e.message().submitFeedback({ type: "negative" });
  }, [e]), isSubmitted: t };
}, uN = () => {
  const e = Ve(), t = oe((r) => !!(r.message.branchNumber >= r.message.branchCount || r.thread.isRunning && !r.thread.capabilities.switchBranchDuringRun));
  return { next: de(() => {
    e.message().switchToBranch({ position: "next" });
  }, [e]), disabled: t };
}, cN = () => {
  const e = Ve(), t = oe((r) => !!(r.message.branchNumber <= 1 || r.thread.isRunning && !r.thread.capabilities.switchBranchDuringRun));
  return { previous: de(() => {
    e.message().switchToBranch({ position: "previous" });
  }, [e]), disabled: t };
}, lN = ({ prompt: e, send: t, clearComposer: n = !0 }) => {
  const r = Ve(), i = oe((o) => o.thread.isDisabled), s = t ?? !1;
  return { trigger: de(() => {
    const o = r.thread().getState().isRunning;
    if (s && !o)
      r.thread().append({
        content: [{ type: "text", text: e }],
        runConfig: r.composer().getState().runConfig
      }), n && r.composer().setText("");
    else if (n)
      r.composer().setText(e);
    else {
      const u = r.composer().getState().text;
      r.composer().setText(u.trim() ? `${u} ${e}` : e);
    }
  }, [r, s, n, e]), disabled: i };
}, dN = () => {
  const e = Ve();
  return { switchTo: de(() => {
    e.threadListItem().switchTo();
  }, [e]) };
}, fN = () => {
  const e = Ve();
  return { switchToNewThread: de(() => {
    e.threads().switchToNewThread();
  }, [e]) };
}, hN = () => oe((e) => e.message.status?.type === "incomplete" && e.message.status.reason === "error" ? e.message.status.error ?? "An error occurred" : void 0), mN = (e, { initialMessages: t, ...n }) => {
  const { modelContext: r, ...i } = VA() ?? {}, s = {
    ...n,
    adapters: {
      ...i,
      ...n.adapters,
      chatModel: e
    }
  }, [a] = we(() => new qA(s, t)), o = st(void 0);
  return o.current = oe((u) => u.threadListItem.remoteId), Le(() => {
    a.threads.getMainThreadRuntimeCore().__internal_setGetThreadId(() => o.current);
  }, [a]), Le(() => () => {
    a.threads.getMainThreadRuntimeCore().detach();
  }, [a]), Le(() => {
    a.threads.getMainThreadRuntimeCore().__internal_setOptions(s), a.threads.getMainThreadRuntimeCore().__internal_load();
  }), Le(() => {
    if (r)
      return a.registerModelContextProvider(r);
  }, [r, a]), pe(() => new yl(a), [a]);
}, pN = (e, { cloud: t, ...n } = {}) => {
  const r = Dy({ cloud: t });
  return fg({
    runtimeHook: function() {
      return mN(e, n);
    },
    adapter: r,
    allowNesting: !0
  });
}, Su = (e) => {
  const t = /* @__PURE__ */ new Map(), n = () => {
    let r = 0;
    for (const i of t.values())
      r += i;
    e(r);
  };
  return {
    register: () => {
      const r = /* @__PURE__ */ Symbol();
      return t.set(r, 0), {
        setHeight: (i) => {
          t.get(r) !== i && (t.set(r, i), n());
        },
        unregister: () => {
          t.delete(r), n();
        }
      };
    }
  };
}, gN = (e = {}) => {
  const t = /* @__PURE__ */ new Set(), n = Su((a) => {
    s.setState({
      height: {
        ...s.getState().height,
        viewport: a
      }
    });
  }), r = Su((a) => {
    s.setState({
      height: {
        ...s.getState().height,
        inset: a
      }
    });
  }), i = Su((a) => {
    s.setState({
      height: {
        ...s.getState().height,
        userMessage: a
      }
    });
  }), s = yi(() => ({
    isAtBottom: !0,
    scrollToBottom: ({ behavior: a = "auto" } = {}) => {
      for (const o of t)
        o({ behavior: a });
    },
    onScrollToBottom: (a) => (t.add(a), () => {
      t.delete(a);
    }),
    turnAnchor: e.turnAnchor ?? "bottom",
    height: {
      viewport: 0,
      inset: 0,
      userMessage: 0
    },
    registerViewport: n.register,
    registerContentInset: r.register,
    registerUserMessageHeight: i.register
  }));
  return s;
};
function bN(e, t) {
  function n(r) {
    const i = Ct(e);
    if (!r?.optional && !i)
      throw new Error(`This component must be used within ${t}.`);
    return i;
  }
  return n;
}
function Cg(e, t) {
  function n(i) {
    const s = e(i);
    return s ? s[t] : null;
  }
  function r(i) {
    let s = !1, a;
    typeof i == "function" ? a = i : i && typeof i == "object" && (s = !!i.optional, a = i.selector);
    const o = n({
      optional: s
    });
    return o ? a ? o(a) : o() : null;
  }
  return {
    [t]: r,
    [`${t}Store`]: n
  };
}
const Sg = Ot(null), EN = bN(Sg, "ThreadPrimitive.Viewport"), { useThreadViewport: Ss, useThreadViewportStore: Lo } = Cg(EN, "useThreadViewport"), ks = (e) => e, _N = (e) => {
  const t = Lo({ optional: !0 }), [n] = we(() => gN(e));
  return Le(() => t?.getState().onScrollToBottom(() => {
    n.getState().scrollToBottom();
  }), [t, n]), Le(() => {
    if (t)
      return n.subscribe((r) => {
        t.getState().isAtBottom !== r.isAtBottom && ks(t).setState({ isAtBottom: r.isAtBottom });
      });
  }, [n, t]), Le(() => {
    const r = {
      turnAnchor: e.turnAnchor ?? "bottom"
    };
    n.getState().turnAnchor !== r.turnAnchor && ks(n).setState(r);
  }, [n, e.turnAnchor]), n;
}, kg = ({ children: e, options: t = {} }) => {
  const n = _N(t), [r] = we(() => ({
    useThreadViewport: n
  }));
  return S.jsx(Sg.Provider, { value: r, children: e });
};
let ai;
const ku = () => {
  if (ai)
    return ai;
  const e = () => ({
    apis: /* @__PURE__ */ new Map(),
    nextId: 0,
    listeners: /* @__PURE__ */ new Set()
  });
  if (typeof window > "u")
    return ai = e(), ai;
  const t = window.__ASSISTANT_UI_DEVTOOLS_HOOK__;
  if (t)
    return ai = t, t;
  const n = e();
  return window.__ASSISTANT_UI_DEVTOOLS_HOOK__ = n, ai = n, n;
}, ir = class ir {
  static register(t) {
    const n = ku();
    for (const o of n.apis.values())
      if (o.api === t)
        return () => {
        };
    const r = n.nextId++, i = {
      api: t,
      logs: []
    }, s = t.on?.("*", (o) => {
      const u = n.apis.get(r);
      u && (u.logs.push({
        time: /* @__PURE__ */ new Date(),
        event: o.event,
        data: o.payload
      }), u.logs.length > ir.MAX_EVENT_LOGS_PER_API && (u.logs = u.logs.slice(-200)), ir.notifyListeners(r));
    }), a = t.subscribe?.(() => {
      ir.notifyListeners(r);
    });
    return n.apis.set(r, i), ir.notifyListeners(r), () => {
      const o = ku();
      o.apis.get(r) && (s?.(), a?.(), o.apis.delete(r), ir.notifyListeners(r));
    };
  }
  static notifyListeners(t) {
    ku().listeners.forEach((r) => r(t));
  }
};
O(ir, "MAX_EVENT_LOGS_PER_API", 200);
let Ic = ir;
const xN = () => {
  const e = Ve();
  return Le(() => {
    if (!(typeof process > "u" || process.env.NODE_ENV === "production"))
      return Ic.register(e);
  }, [e]), null;
}, TN = ({ children: e, aui: t, runtime: n }) => S.jsxs(Py, { runtime: n, aui: t ?? null, children: [S.jsx(xN, {}), S.jsx(kg, { children: e })] }), AN = Ce(TN);
function Lf(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function wl(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const s = Lf(i, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const s = r[i];
          typeof s == "function" ? s() : Lf(e[i], null);
        }
      };
  };
}
function et(...e) {
  return y.useCallback(wl(...e), e);
}
var yN = /* @__PURE__ */ Symbol.for("react.lazy"), so = y[" use ".trim().toString()];
function NN(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function Ig(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === yN && "_payload" in e && NN(e._payload);
}
// @__NO_SIDE_EFFECTS__
function Dg(e) {
  const t = /* @__PURE__ */ wN(e), n = y.forwardRef((r, i) => {
    let { children: s, ...a } = r;
    Ig(s) && typeof so == "function" && (s = so(s._payload));
    const o = y.Children.toArray(s), u = o.find(SN);
    if (u) {
      const c = u.props.children, l = o.map((d) => d === u ? y.Children.count(c) > 1 ? y.Children.only(null) : y.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ S.jsx(t, { ...a, ref: i, children: y.isValidElement(c) ? y.cloneElement(c, void 0, l) : null });
    }
    return /* @__PURE__ */ S.jsx(t, { ...a, ref: i, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
var vN = /* @__PURE__ */ Dg("Slot");
// @__NO_SIDE_EFFECTS__
function wN(e) {
  const t = y.forwardRef((n, r) => {
    let { children: i, ...s } = n;
    if (Ig(i) && typeof so == "function" && (i = so(i._payload)), y.isValidElement(i)) {
      const a = IN(i), o = kN(s, i.props);
      return i.type !== y.Fragment && (o.ref = r ? wl(r, a) : a), y.cloneElement(i, o);
    }
    return y.Children.count(i) > 1 ? y.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var CN = /* @__PURE__ */ Symbol("radix.slottable");
function SN(e) {
  return y.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === CN;
}
function kN(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? i && s ? n[r] = (...o) => {
      const u = s(...o);
      return i(...o), u;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...s } : r === "className" && (n[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function IN(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var DN = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Wt = DN.reduce((e, t) => {
  const n = /* @__PURE__ */ Dg(`Primitive.${t}`), r = y.forwardRef((i, s) => {
    const { asChild: a, ...o } = i, u = a ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ S.jsx(u, { ...o, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), zn;
(function(e) {
  e.Hidden = "hidden", e.Floating = "floating", e.Normal = "normal";
})(zn || (zn = {}));
const RN = ({ hideWhenRunning: e, autohide: t, autohideFloat: n, forceVisible: r }) => oe((i) => {
  if (e && i.thread.isRunning)
    return zn.Hidden;
  const s = t === "always" || t === "not-last" && !i.message.isLast, a = r || i.message.isHovering;
  return s ? a ? n === "always" || n === "single-branch" && i.message.branchCount <= 1 ? zn.Floating : zn.Normal : zn.Hidden : zn.Normal;
}), PN = Ot(null), Mo = ut(({ hideWhenRunning: e, autohide: t, autohideFloat: n, ...r }, i) => {
  const [s, a] = we(0), o = de(() => {
    let l = !1;
    return a((d) => d + 1), () => {
      l || (l = !0, a((d) => Math.max(0, d - 1)));
    };
  }, []), u = pe(() => ({ acquireInteractionLock: o }), [o]), c = RN({
    hideWhenRunning: e,
    autohide: t,
    autohideFloat: n,
    forceVisible: s > 0
  });
  return c === zn.Hidden ? null : S.jsx(PN.Provider, { value: u, children: S.jsx(Wt.div, { ...c === zn.Floating ? { "data-floating": "true" } : null, ...r, ref: i }) });
});
Mo.displayName = "ActionBarPrimitive.Root";
function Oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e?.(i), n === !1 || !i.defaultPrevented)
      return t?.(i);
  };
}
const Qn = (e, t, n = []) => {
  const r = ut((i, s) => {
    const a = {}, o = {};
    Object.keys(i).forEach((c) => {
      n.includes(c) ? a[c] = i[c] : o[c] = i[c];
    });
    const u = t(a) ?? void 0;
    return S.jsx(Wt.button, { ...o, type: "button", ref: s, disabled: o.disabled || !u, onClick: Oe(o.onClick, u) });
  });
  return r.displayName = e, r;
}, ON = () => {
  const { disabled: e, reload: t } = sN();
  return e ? null : t;
}, Rg = Qn("ActionBarPrimitive.Reload", ON), LN = () => {
  const { disabled: e, edit: t } = iN();
  return e ? null : t;
}, MN = Qn("ActionBarPrimitive.Edit", LN);
function Zt(e) {
  const t = y.useRef(e);
  return y.useEffect(() => {
    t.current = e;
  }), y.useMemo(() => (...n) => t.current?.(...n), []);
}
function Pg(e, t = globalThis?.document) {
  const n = Zt(e);
  y.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
const UN = () => {
  const { submit: e } = aN();
  return e;
}, Og = ut(({ onClick: e, disabled: t, ...n }, r) => {
  const i = oe((a) => a.message.metadata.submittedFeedback?.type === "positive"), s = UN();
  return S.jsx(Wt.button, { type: "button", ...i ? { "data-submitted": "true" } : {}, ...n, ref: r, disabled: t || !s, onClick: Oe(e, () => {
    s?.();
  }) });
});
Og.displayName = "ActionBarPrimitive.FeedbackPositive";
const HN = () => {
  const { submit: e } = oN();
  return e;
}, Lg = ut(({ onClick: e, disabled: t, ...n }, r) => {
  const i = oe((a) => a.message.metadata.submittedFeedback?.type === "negative"), s = HN();
  return S.jsx(Wt.button, { type: "button", ...i ? { "data-submitted": "true" } : {}, ...n, ref: r, disabled: t || !s, onClick: Oe(e, () => {
    s?.();
  }) });
});
Lg.displayName = "ActionBarPrimitive.FeedbackNegative";
// @__NO_SIDE_EFFECTS__
function zr(e) {
  const t = /* @__PURE__ */ jN(e), n = y.forwardRef((r, i) => {
    const { children: s, ...a } = r, o = y.Children.toArray(s), u = o.find(FN);
    if (u) {
      const c = u.props.children, l = o.map((d) => d === u ? y.Children.count(c) > 1 ? y.Children.only(null) : y.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ S.jsx(t, { ...a, ref: i, children: y.isValidElement(c) ? y.cloneElement(c, void 0, l) : null });
    }
    return /* @__PURE__ */ S.jsx(t, { ...a, ref: i, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
var Mg = /* @__PURE__ */ zr("Slot");
// @__NO_SIDE_EFFECTS__
function jN(e) {
  const t = y.forwardRef((n, r) => {
    const { children: i, ...s } = n;
    if (y.isValidElement(i)) {
      const a = VN(i), o = zN(s, i.props);
      return i.type !== y.Fragment && (o.ref = r ? wl(r, a) : a), y.cloneElement(i, o);
    }
    return y.Children.count(i) > 1 ? y.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Ug = /* @__PURE__ */ Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function BN(e) {
  const t = ({ children: n }) => /* @__PURE__ */ S.jsx(S.Fragment, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = Ug, t;
}
function FN(e) {
  return y.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ug;
}
function zN(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? i && s ? n[r] = (...o) => {
      const u = s(...o);
      return i(...o), u;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...s } : r === "className" && (n[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function VN(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var WN = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], tt = WN.reduce((e, t) => {
  const n = /* @__PURE__ */ zr(`Primitive.${t}`), r = y.forwardRef((i, s) => {
    const { asChild: a, ...o } = i, u = a ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ S.jsx(u, { ...o, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function $N(e, t) {
  e && vo.flushSync(() => e.dispatchEvent(t));
}
var Hg = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), YN = "VisuallyHidden", jg = y.forwardRef(
  (e, t) => /* @__PURE__ */ S.jsx(
    tt.span,
    {
      ...e,
      ref: t,
      style: { ...Hg, ...e.style }
    }
  )
);
jg.displayName = YN;
var GN = jg;
function qN(e, t) {
  const n = y.createContext(t), r = (s) => {
    const { children: a, ...o } = s, u = y.useMemo(() => o, Object.values(o));
    return /* @__PURE__ */ S.jsx(n.Provider, { value: u, children: a });
  };
  r.displayName = e + "Provider";
  function i(s) {
    const a = y.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function Di(e, t = []) {
  let n = [];
  function r(s, a) {
    const o = y.createContext(a), u = n.length;
    n = [...n, a];
    const c = (d) => {
      const { scope: h, children: m, ...E } = d, g = h?.[e]?.[u] || o, T = y.useMemo(() => E, Object.values(E));
      return /* @__PURE__ */ S.jsx(g.Provider, { value: T, children: m });
    };
    c.displayName = s + "Provider";
    function l(d, h) {
      const m = h?.[e]?.[u] || o, E = y.useContext(m);
      if (E) return E;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${s}\``);
    }
    return [c, l];
  }
  const i = () => {
    const s = n.map((a) => y.createContext(a));
    return function(o) {
      const u = o?.[e] || s;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: u } }),
        [o, u]
      );
    };
  };
  return i.scopeName = e, [r, KN(i, ...t)];
}
function KN(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(s) {
      const a = r.reduce((o, { useScope: u, scopeName: c }) => {
        const d = u(s)[`__scope${c}`];
        return { ...o, ...d };
      }, {});
      return y.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function QN(e) {
  const t = e + "CollectionProvider", [n, r] = Di(t), [i, s] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (g) => {
    const { scope: T, children: _ } = g, A = ct.useRef(null), w = ct.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ S.jsx(i, { scope: T, itemMap: w, collectionRef: A, children: _ });
  };
  a.displayName = t;
  const o = e + "CollectionSlot", u = /* @__PURE__ */ zr(o), c = ct.forwardRef(
    (g, T) => {
      const { scope: _, children: A } = g, w = s(o, _), M = et(T, w.collectionRef);
      return /* @__PURE__ */ S.jsx(u, { ref: M, children: A });
    }
  );
  c.displayName = o;
  const l = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ zr(l), m = ct.forwardRef(
    (g, T) => {
      const { scope: _, children: A, ...w } = g, M = ct.useRef(null), F = et(T, M), k = s(l, _);
      return ct.useEffect(() => (k.itemMap.set(M, { ref: M, ...w }), () => {
        k.itemMap.delete(M);
      })), /* @__PURE__ */ S.jsx(h, { [d]: "", ref: F, children: A });
    }
  );
  m.displayName = l;
  function E(g) {
    const T = s(e + "CollectionConsumer", g);
    return ct.useCallback(() => {
      const A = T.collectionRef.current;
      if (!A) return [];
      const w = Array.from(A.querySelectorAll(`[${d}]`));
      return Array.from(T.itemMap.values()).sort(
        (k, B) => w.indexOf(k.ref.current) - w.indexOf(B.ref.current)
      );
    }, [T.collectionRef, T.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: m },
    E,
    r
  ];
}
var Pt = globalThis?.document ? y.useLayoutEffect : () => {
}, XN = y[" useInsertionEffect ".trim().toString()] || Pt;
function Is({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, s, a] = JN({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, u = o ? e : i;
  {
    const l = y.useRef(e !== void 0);
    y.useEffect(() => {
      const d = l.current;
      d !== o && console.warn(
        `${r} is changing from ${d ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), l.current = o;
    }, [o, r]);
  }
  const c = y.useCallback(
    (l) => {
      if (o) {
        const d = ZN(l) ? l(e) : l;
        d !== e && a.current?.(d);
      } else
        s(l);
    },
    [o, e, s, a]
  );
  return [u, c];
}
function JN({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = y.useState(e), i = y.useRef(n), s = y.useRef(t);
  return XN(() => {
    s.current = t;
  }, [t]), y.useEffect(() => {
    i.current !== n && (s.current?.(n), i.current = n);
  }, [n, i]), [n, r, s];
}
function ZN(e) {
  return typeof e == "function";
}
function ev(e, t) {
  return y.useReducer((n, r) => t[n][r] ?? n, e);
}
var gr = (e) => {
  const { present: t, children: n } = e, r = tv(t), i = typeof n == "function" ? n({ present: r.isPresent }) : y.Children.only(n), s = et(r.ref, nv(i));
  return typeof n == "function" || r.isPresent ? y.cloneElement(i, { ref: s }) : null;
};
gr.displayName = "Presence";
function tv(e) {
  const [t, n] = y.useState(), r = y.useRef(null), i = y.useRef(e), s = y.useRef("none"), a = e ? "mounted" : "unmounted", [o, u] = ev(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return y.useEffect(() => {
    const c = Ea(r.current);
    s.current = o === "mounted" ? c : "none";
  }, [o]), Pt(() => {
    const c = r.current, l = i.current;
    if (l !== e) {
      const h = s.current, m = Ea(c);
      e ? u("MOUNT") : m === "none" || c?.display === "none" ? u("UNMOUNT") : u(l && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, u]), Pt(() => {
    if (t) {
      let c;
      const l = t.ownerDocument.defaultView ?? window, d = (m) => {
        const g = Ea(r.current).includes(CSS.escape(m.animationName));
        if (m.target === t && g && (u("ANIMATION_END"), !i.current)) {
          const T = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = l.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = T);
          });
        }
      }, h = (m) => {
        m.target === t && (s.current = Ea(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        l.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: y.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Ea(e) {
  return e?.animationName || "none";
}
function nv(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var rv = y[" useId ".trim().toString()] || (() => {
}), iv = 0;
function ur(e) {
  const [t, n] = y.useState(rv());
  return Pt(() => {
    n((r) => r ?? String(iv++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var sv = y.createContext(void 0);
function av(e) {
  const t = y.useContext(sv);
  return e || t || "ltr";
}
var ov = "DismissableLayer", Dc = "dismissableLayer.update", uv = "dismissableLayer.pointerDownOutside", cv = "dismissableLayer.focusOutside", Mf, Bg = y.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ws = y.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: s,
      onInteractOutside: a,
      onDismiss: o,
      ...u
    } = e, c = y.useContext(Bg), [l, d] = y.useState(null), h = l?.ownerDocument ?? globalThis?.document, [, m] = y.useState({}), E = et(t, (B) => d(B)), g = Array.from(c.layers), [T] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), _ = g.indexOf(T), A = l ? g.indexOf(l) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, M = A >= _, F = fv((B) => {
      const $ = B.target, J = [...c.branches].some((U) => U.contains($));
      !M || J || (i?.(B), a?.(B), B.defaultPrevented || o?.());
    }, h), k = hv((B) => {
      const $ = B.target;
      [...c.branches].some((U) => U.contains($)) || (s?.(B), a?.(B), B.defaultPrevented || o?.());
    }, h);
    return Pg((B) => {
      A === c.layers.size - 1 && (r?.(B), !B.defaultPrevented && o && (B.preventDefault(), o()));
    }, h), y.useEffect(() => {
      if (l)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Mf = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(l)), c.layers.add(l), Uf(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Mf);
        };
    }, [l, h, n, c]), y.useEffect(() => () => {
      l && (c.layers.delete(l), c.layersWithOutsidePointerEventsDisabled.delete(l), Uf());
    }, [l, c]), y.useEffect(() => {
      const B = () => m({});
      return document.addEventListener(Dc, B), () => document.removeEventListener(Dc, B);
    }, []), /* @__PURE__ */ S.jsx(
      tt.div,
      {
        ...u,
        ref: E,
        style: {
          pointerEvents: w ? M ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Oe(e.onFocusCapture, k.onFocusCapture),
        onBlurCapture: Oe(e.onBlurCapture, k.onBlurCapture),
        onPointerDownCapture: Oe(
          e.onPointerDownCapture,
          F.onPointerDownCapture
        )
      }
    );
  }
);
Ws.displayName = ov;
var lv = "DismissableLayerBranch", dv = y.forwardRef((e, t) => {
  const n = y.useContext(Bg), r = y.useRef(null), i = et(t, r);
  return y.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ S.jsx(tt.div, { ...e, ref: i });
});
dv.displayName = lv;
function fv(e, t = globalThis?.document) {
  const n = Zt(e), r = y.useRef(!1), i = y.useRef(() => {
  });
  return y.useEffect(() => {
    const s = (o) => {
      if (o.target && !r.current) {
        let u = function() {
          Fg(
            uv,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: o };
        o.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = u, t.addEventListener("click", i.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", s), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function hv(e, t = globalThis?.document) {
  const n = Zt(e), r = y.useRef(!1);
  return y.useEffect(() => {
    const i = (s) => {
      s.target && !r.current && Fg(cv, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Uf() {
  const e = new CustomEvent(Dc);
  document.dispatchEvent(e);
}
function Fg(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? $N(i, s) : i.dispatchEvent(s);
}
var Iu = "focusScope.autoFocusOnMount", Du = "focusScope.autoFocusOnUnmount", Hf = { bubbles: !1, cancelable: !0 }, mv = "FocusScope", Uo = y.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: s,
    ...a
  } = e, [o, u] = y.useState(null), c = Zt(i), l = Zt(s), d = y.useRef(null), h = et(t, (g) => u(g)), m = y.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  y.useEffect(() => {
    if (r) {
      let g = function(w) {
        if (m.paused || !o) return;
        const M = w.target;
        o.contains(M) ? d.current = M : tr(d.current, { select: !0 });
      }, T = function(w) {
        if (m.paused || !o) return;
        const M = w.relatedTarget;
        M !== null && (o.contains(M) || tr(d.current, { select: !0 }));
      }, _ = function(w) {
        if (document.activeElement === document.body)
          for (const F of w)
            F.removedNodes.length > 0 && tr(o);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", T);
      const A = new MutationObserver(_);
      return o && A.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", T), A.disconnect();
      };
    }
  }, [r, o, m.paused]), y.useEffect(() => {
    if (o) {
      Bf.add(m);
      const g = document.activeElement;
      if (!o.contains(g)) {
        const _ = new CustomEvent(Iu, Hf);
        o.addEventListener(Iu, c), o.dispatchEvent(_), _.defaultPrevented || (pv(xv(zg(o)), { select: !0 }), document.activeElement === g && tr(o));
      }
      return () => {
        o.removeEventListener(Iu, c), setTimeout(() => {
          const _ = new CustomEvent(Du, Hf);
          o.addEventListener(Du, l), o.dispatchEvent(_), _.defaultPrevented || tr(g ?? document.body, { select: !0 }), o.removeEventListener(Du, l), Bf.remove(m);
        }, 0);
      };
    }
  }, [o, c, l, m]);
  const E = y.useCallback(
    (g) => {
      if (!n && !r || m.paused) return;
      const T = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, _ = document.activeElement;
      if (T && _) {
        const A = g.currentTarget, [w, M] = gv(A);
        w && M ? !g.shiftKey && _ === M ? (g.preventDefault(), n && tr(w, { select: !0 })) : g.shiftKey && _ === w && (g.preventDefault(), n && tr(M, { select: !0 })) : _ === A && g.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ S.jsx(tt.div, { tabIndex: -1, ...a, ref: h, onKeyDown: E });
});
Uo.displayName = mv;
function pv(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (tr(r, { select: t }), document.activeElement !== n) return;
}
function gv(e) {
  const t = zg(e), n = jf(t, e), r = jf(t.reverse(), e);
  return [n, r];
}
function zg(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function jf(e, t) {
  for (const n of e)
    if (!bv(n, { upTo: t })) return n;
}
function bv(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Ev(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function tr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Ev(e) && t && e.select();
  }
}
var Bf = _v();
function _v() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Ff(e, t), e.unshift(t);
    },
    remove(t) {
      e = Ff(e, t), e[0]?.resume();
    }
  };
}
function Ff(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function xv(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Tv = "Portal", $s = y.forwardRef((e, t) => {
  const { container: n, ...r } = e, [i, s] = y.useState(!1);
  Pt(() => s(!0), []);
  const a = n || i && globalThis?.document?.body;
  return a ? l1.createPortal(/* @__PURE__ */ S.jsx(tt.div, { ...r, ref: t }), a) : null;
});
$s.displayName = Tv;
var Ru = 0;
function Cl() {
  y.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? zf()), document.body.insertAdjacentElement("beforeend", e[1] ?? zf()), Ru++, () => {
      Ru === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ru--;
    };
  }, []);
}
function zf() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var wn = function() {
  return wn = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, wn.apply(this, arguments);
};
function Vg(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function Av(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, s; r < i; r++)
    (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var Fa = "right-scroll-bar-position", za = "width-before-scroll-bar", yv = "with-scroll-bars-hidden", Nv = "--removed-body-scroll-bar-size";
function Pu(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function vv(e, t) {
  var n = we(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var wv = typeof window < "u" ? y.useLayoutEffect : y.useEffect, Vf = /* @__PURE__ */ new WeakMap();
function Cv(e, t) {
  var n = vv(null, function(r) {
    return e.forEach(function(i) {
      return Pu(i, r);
    });
  });
  return wv(function() {
    var r = Vf.get(n);
    if (r) {
      var i = new Set(r), s = new Set(e), a = n.current;
      i.forEach(function(o) {
        s.has(o) || Pu(o, null);
      }), s.forEach(function(o) {
        i.has(o) || Pu(o, a);
      });
    }
    Vf.set(n, e);
  }, [e]), n;
}
function Sv(e) {
  return e;
}
function kv(e, t) {
  t === void 0 && (t = Sv);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var a = t(s, r);
      return n.push(a), function() {
        n = n.filter(function(o) {
          return o !== a;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(s);
      }
      n = {
        push: function(o) {
          return s(o);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var a = [];
      if (n.length) {
        var o = n;
        n = [], o.forEach(s), a = n;
      }
      var u = function() {
        var l = a;
        a = [], l.forEach(s);
      }, c = function() {
        return Promise.resolve().then(u);
      };
      c(), n = {
        push: function(l) {
          a.push(l), c();
        },
        filter: function(l) {
          return a = a.filter(l), n;
        }
      };
    }
  };
  return i;
}
function Iv(e) {
  e === void 0 && (e = {});
  var t = kv(null);
  return t.options = wn({ async: !0, ssr: !1 }, e), t;
}
var Wg = function(e) {
  var t = e.sideCar, n = Vg(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return y.createElement(r, wn({}, n));
};
Wg.isSideCarExport = !0;
function Dv(e, t) {
  return e.useMedium(t), Wg;
}
var $g = Iv(), Ou = function() {
}, Ho = y.forwardRef(function(e, t) {
  var n = y.useRef(null), r = y.useState({
    onScrollCapture: Ou,
    onWheelCapture: Ou,
    onTouchMoveCapture: Ou
  }), i = r[0], s = r[1], a = e.forwardProps, o = e.children, u = e.className, c = e.removeScrollBar, l = e.enabled, d = e.shards, h = e.sideCar, m = e.noRelative, E = e.noIsolation, g = e.inert, T = e.allowPinchZoom, _ = e.as, A = _ === void 0 ? "div" : _, w = e.gapMode, M = Vg(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), F = h, k = Cv([n, t]), B = wn(wn({}, M), i);
  return y.createElement(
    y.Fragment,
    null,
    l && y.createElement(F, { sideCar: $g, removeScrollBar: c, shards: d, noRelative: m, noIsolation: E, inert: g, setCallbacks: s, allowPinchZoom: !!T, lockRef: n, gapMode: w }),
    a ? y.cloneElement(y.Children.only(o), wn(wn({}, B), { ref: k })) : y.createElement(A, wn({}, B, { className: u, ref: k }), o)
  );
});
Ho.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ho.classNames = {
  fullWidth: za,
  zeroRight: Fa
};
var Rv = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Pv() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Rv();
  return t && e.setAttribute("nonce", t), e;
}
function Ov(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Lv(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Mv = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Pv()) && (Ov(t, n), Lv(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Uv = function() {
  var e = Mv();
  return function(t, n) {
    y.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Yg = function() {
  var e = Uv(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, Hv = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Lu = function(e) {
  return parseInt(e || "", 10) || 0;
}, jv = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Lu(n), Lu(r), Lu(i)];
}, Bv = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Hv;
  var t = jv(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Fv = Yg(), bi = "data-scroll-locked", zv = function(e, t, n, r) {
  var i = e.left, s = e.top, a = e.right, o = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(yv, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(o, "px ").concat(r, `;
  }
  body[`).concat(bi, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(o, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Fa, ` {
    right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(za, ` {
    margin-right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(Fa, " .").concat(Fa, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(za, " .").concat(za, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(bi, `] {
    `).concat(Nv, ": ").concat(o, `px;
  }
`);
}, Wf = function() {
  var e = parseInt(document.body.getAttribute(bi) || "0", 10);
  return isFinite(e) ? e : 0;
}, Vv = function() {
  y.useEffect(function() {
    return document.body.setAttribute(bi, (Wf() + 1).toString()), function() {
      var e = Wf() - 1;
      e <= 0 ? document.body.removeAttribute(bi) : document.body.setAttribute(bi, e.toString());
    };
  }, []);
}, Wv = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  Vv();
  var s = y.useMemo(function() {
    return Bv(i);
  }, [i]);
  return y.createElement(Fv, { styles: zv(s, !t, i, n ? "" : "!important") });
}, Rc = !1;
if (typeof window < "u")
  try {
    var _a = Object.defineProperty({}, "passive", {
      get: function() {
        return Rc = !0, !0;
      }
    });
    window.addEventListener("test", _a, _a), window.removeEventListener("test", _a, _a);
  } catch {
    Rc = !1;
  }
var oi = Rc ? { passive: !1 } : !1, $v = function(e) {
  return e.tagName === "TEXTAREA";
}, Gg = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !$v(e) && n[t] === "visible")
  );
}, Yv = function(e) {
  return Gg(e, "overflowY");
}, Gv = function(e) {
  return Gg(e, "overflowX");
}, $f = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = qg(e, r);
    if (i) {
      var s = Kg(e, r), a = s[1], o = s[2];
      if (a > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, qv = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Kv = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, qg = function(e, t) {
  return e === "v" ? Yv(t) : Gv(t);
}, Kg = function(e, t) {
  return e === "v" ? qv(t) : Kv(t);
}, Qv = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Xv = function(e, t, n, r, i) {
  var s = Qv(e, window.getComputedStyle(t).direction), a = s * r, o = n.target, u = t.contains(o), c = !1, l = a > 0, d = 0, h = 0;
  do {
    if (!o)
      break;
    var m = Kg(e, o), E = m[0], g = m[1], T = m[2], _ = g - T - s * E;
    (E || _) && qg(e, o) && (d += _, h += E);
    var A = o.parentNode;
    o = A && A.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? A.host : A;
  } while (
    // portaled content
    !u && o !== document.body || // self content
    u && (t.contains(o) || t === o)
  );
  return (l && Math.abs(d) < 1 || !l && Math.abs(h) < 1) && (c = !0), c;
}, xa = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Yf = function(e) {
  return [e.deltaX, e.deltaY];
}, Gf = function(e) {
  return e && "current" in e ? e.current : e;
}, Jv = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Zv = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ew = 0, ui = [];
function tw(e) {
  var t = y.useRef([]), n = y.useRef([0, 0]), r = y.useRef(), i = y.useState(ew++)[0], s = y.useState(Yg)[0], a = y.useRef(e);
  y.useEffect(function() {
    a.current = e;
  }, [e]), y.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = Av([e.lockRef.current], (e.shards || []).map(Gf), !0).filter(Boolean);
      return g.forEach(function(T) {
        return T.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(T) {
          return T.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = y.useCallback(function(g, T) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var _ = xa(g), A = n.current, w = "deltaX" in g ? g.deltaX : A[0] - _[0], M = "deltaY" in g ? g.deltaY : A[1] - _[1], F, k = g.target, B = Math.abs(w) > Math.abs(M) ? "h" : "v";
    if ("touches" in g && B === "h" && k.type === "range")
      return !1;
    var $ = window.getSelection(), J = $ && $.anchorNode, U = J ? J === k || J.contains(k) : !1;
    if (U)
      return !1;
    var re = $f(B, k);
    if (!re)
      return !0;
    if (re ? F = B : (F = B === "v" ? "h" : "v", re = $f(B, k)), !re)
      return !1;
    if (!r.current && "changedTouches" in g && (w || M) && (r.current = F), !F)
      return !0;
    var ae = r.current || F;
    return Xv(ae, T, g, ae === "h" ? w : M);
  }, []), u = y.useCallback(function(g) {
    var T = g;
    if (!(!ui.length || ui[ui.length - 1] !== s)) {
      var _ = "deltaY" in T ? Yf(T) : xa(T), A = t.current.filter(function(F) {
        return F.name === T.type && (F.target === T.target || T.target === F.shadowParent) && Jv(F.delta, _);
      })[0];
      if (A && A.should) {
        T.cancelable && T.preventDefault();
        return;
      }
      if (!A) {
        var w = (a.current.shards || []).map(Gf).filter(Boolean).filter(function(F) {
          return F.contains(T.target);
        }), M = w.length > 0 ? o(T, w[0]) : !a.current.noIsolation;
        M && T.cancelable && T.preventDefault();
      }
    }
  }, []), c = y.useCallback(function(g, T, _, A) {
    var w = { name: g, delta: T, target: _, should: A, shadowParent: nw(_) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(M) {
        return M !== w;
      });
    }, 1);
  }, []), l = y.useCallback(function(g) {
    n.current = xa(g), r.current = void 0;
  }, []), d = y.useCallback(function(g) {
    c(g.type, Yf(g), g.target, o(g, e.lockRef.current));
  }, []), h = y.useCallback(function(g) {
    c(g.type, xa(g), g.target, o(g, e.lockRef.current));
  }, []);
  y.useEffect(function() {
    return ui.push(s), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", u, oi), document.addEventListener("touchmove", u, oi), document.addEventListener("touchstart", l, oi), function() {
      ui = ui.filter(function(g) {
        return g !== s;
      }), document.removeEventListener("wheel", u, oi), document.removeEventListener("touchmove", u, oi), document.removeEventListener("touchstart", l, oi);
    };
  }, []);
  var m = e.removeScrollBar, E = e.inert;
  return y.createElement(
    y.Fragment,
    null,
    E ? y.createElement(s, { styles: Zv(i) }) : null,
    m ? y.createElement(Wv, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function nw(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const rw = Dv($g, tw);
var jo = y.forwardRef(function(e, t) {
  return y.createElement(Ho, wn({}, e, { ref: t, sideCar: rw }));
});
jo.classNames = Ho.classNames;
var iw = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ci = /* @__PURE__ */ new WeakMap(), Ta = /* @__PURE__ */ new WeakMap(), Aa = {}, Mu = 0, Qg = function(e) {
  return e && (e.host || Qg(e.parentNode));
}, sw = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Qg(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, aw = function(e, t, n, r) {
  var i = sw(t, Array.isArray(e) ? e : [e]);
  Aa[n] || (Aa[n] = /* @__PURE__ */ new WeakMap());
  var s = Aa[n], a = [], o = /* @__PURE__ */ new Set(), u = new Set(i), c = function(d) {
    !d || o.has(d) || (o.add(d), c(d.parentNode));
  };
  i.forEach(c);
  var l = function(d) {
    !d || u.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (o.has(h))
        l(h);
      else
        try {
          var m = h.getAttribute(r), E = m !== null && m !== "false", g = (ci.get(h) || 0) + 1, T = (s.get(h) || 0) + 1;
          ci.set(h, g), s.set(h, T), a.push(h), g === 1 && E && Ta.set(h, !0), T === 1 && h.setAttribute(n, "true"), E || h.setAttribute(r, "true");
        } catch (_) {
          console.error("aria-hidden: cannot operate on ", h, _);
        }
    });
  };
  return l(t), o.clear(), Mu++, function() {
    a.forEach(function(d) {
      var h = ci.get(d) - 1, m = s.get(d) - 1;
      ci.set(d, h), s.set(d, m), h || (Ta.has(d) || d.removeAttribute(r), Ta.delete(d)), m || d.removeAttribute(n);
    }), Mu--, Mu || (ci = /* @__PURE__ */ new WeakMap(), ci = /* @__PURE__ */ new WeakMap(), Ta = /* @__PURE__ */ new WeakMap(), Aa = {});
  };
}, Sl = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = iw(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), aw(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, Bo = "Dialog", [Xg] = Di(Bo), [ow, En] = Xg(Bo), Jg = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: s,
    modal: a = !0
  } = e, o = y.useRef(null), u = y.useRef(null), [c, l] = Is({
    prop: r,
    defaultProp: i ?? !1,
    onChange: s,
    caller: Bo
  });
  return /* @__PURE__ */ S.jsx(
    ow,
    {
      scope: t,
      triggerRef: o,
      contentRef: u,
      contentId: ur(),
      titleId: ur(),
      descriptionId: ur(),
      open: c,
      onOpenChange: l,
      onOpenToggle: y.useCallback(() => l((d) => !d), [l]),
      modal: a,
      children: n
    }
  );
};
Jg.displayName = Bo;
var Zg = "DialogTrigger", uw = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = En(Zg, n), s = et(t, i.triggerRef);
    return /* @__PURE__ */ S.jsx(
      tt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Dl(i.open),
        ...r,
        ref: s,
        onClick: Oe(e.onClick, i.onOpenToggle)
      }
    );
  }
);
uw.displayName = Zg;
var kl = "DialogPortal", [cw, e0] = Xg(kl, {
  forceMount: void 0
}), t0 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, s = En(kl, t);
  return /* @__PURE__ */ S.jsx(cw, { scope: t, forceMount: n, children: y.Children.map(r, (a) => /* @__PURE__ */ S.jsx(gr, { present: n || s.open, children: /* @__PURE__ */ S.jsx($s, { asChild: !0, container: i, children: a }) })) });
};
t0.displayName = kl;
var ao = "DialogOverlay", n0 = y.forwardRef(
  (e, t) => {
    const n = e0(ao, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, s = En(ao, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ S.jsx(gr, { present: r || s.open, children: /* @__PURE__ */ S.jsx(dw, { ...i, ref: t }) }) : null;
  }
);
n0.displayName = ao;
var lw = /* @__PURE__ */ zr("DialogOverlay.RemoveScroll"), dw = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = En(ao, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ S.jsx(jo, { as: lw, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ S.jsx(
        tt.div,
        {
          "data-state": Dl(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Vr = "DialogContent", r0 = y.forwardRef(
  (e, t) => {
    const n = e0(Vr, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, s = En(Vr, e.__scopeDialog);
    return /* @__PURE__ */ S.jsx(gr, { present: r || s.open, children: s.modal ? /* @__PURE__ */ S.jsx(fw, { ...i, ref: t }) : /* @__PURE__ */ S.jsx(hw, { ...i, ref: t }) });
  }
);
r0.displayName = Vr;
var fw = y.forwardRef(
  (e, t) => {
    const n = En(Vr, e.__scopeDialog), r = y.useRef(null), i = et(t, n.contentRef, r);
    return y.useEffect(() => {
      const s = r.current;
      if (s) return Sl(s);
    }, []), /* @__PURE__ */ S.jsx(
      i0,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Oe(e.onCloseAutoFocus, (s) => {
          s.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Oe(e.onPointerDownOutside, (s) => {
          const a = s.detail.originalEvent, o = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || o) && s.preventDefault();
        }),
        onFocusOutside: Oe(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), hw = y.forwardRef(
  (e, t) => {
    const n = En(Vr, e.__scopeDialog), r = y.useRef(!1), i = y.useRef(!1);
    return /* @__PURE__ */ S.jsx(
      i0,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          e.onCloseAutoFocus?.(s), s.defaultPrevented || (r.current || n.triggerRef.current?.focus(), s.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (s) => {
          e.onInteractOutside?.(s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = s.target;
          n.triggerRef.current?.contains(a) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && i.current && s.preventDefault();
        }
      }
    );
  }
), i0 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: s, ...a } = e, o = En(Vr, n), u = y.useRef(null), c = et(t, u);
    return Cl(), /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
      /* @__PURE__ */ S.jsx(
        Uo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ S.jsx(
            Ws,
            {
              role: "dialog",
              id: o.contentId,
              "aria-describedby": o.descriptionId,
              "aria-labelledby": o.titleId,
              "data-state": Dl(o.open),
              ...a,
              ref: c,
              onDismiss: () => o.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
        /* @__PURE__ */ S.jsx(mw, { titleId: o.titleId }),
        /* @__PURE__ */ S.jsx(gw, { contentRef: u, descriptionId: o.descriptionId })
      ] })
    ] });
  }
), Il = "DialogTitle", s0 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = En(Il, n);
    return /* @__PURE__ */ S.jsx(tt.h2, { id: i.titleId, ...r, ref: t });
  }
);
s0.displayName = Il;
var a0 = "DialogDescription", o0 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = En(a0, n);
    return /* @__PURE__ */ S.jsx(tt.p, { id: i.descriptionId, ...r, ref: t });
  }
);
o0.displayName = a0;
var u0 = "DialogClose", c0 = y.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = En(u0, n);
    return /* @__PURE__ */ S.jsx(
      tt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Oe(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
c0.displayName = u0;
function Dl(e) {
  return e ? "open" : "closed";
}
var l0 = "DialogTitleWarning", [hF, d0] = qN(l0, {
  contentName: Vr,
  titleName: Il,
  docsSlug: "dialog"
}), mw = ({ titleId: e }) => {
  const t = d0(l0), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return y.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, pw = "DialogDescriptionWarning", gw = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${d0(pw).contentName}}.`;
  return y.useEffect(() => {
    const i = e.current?.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, bw = Jg, Ew = t0, _w = n0, xw = r0, Tw = s0, Aw = o0, yw = c0;
function Nw(e) {
  const t = y.useRef({ value: e, previous: e });
  return y.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function vw(e) {
  const [t, n] = y.useState(void 0);
  return Pt(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const s = i[0];
        let a, o;
        if ("borderBoxSize" in s) {
          const u = s.borderBoxSize, c = Array.isArray(u) ? u[0] : u;
          a = c.inlineSize, o = c.blockSize;
        } else
          a = e.offsetWidth, o = e.offsetHeight;
        n({ width: a, height: o });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
const ww = ["top", "right", "bottom", "left"], fr = Math.min, Kt = Math.max, oo = Math.round, ya = Math.floor, kn = (e) => ({
  x: e,
  y: e
}), Cw = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Sw = {
  start: "end",
  end: "start"
};
function Pc(e, t, n) {
  return Kt(e, fr(t, n));
}
function qn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Kn(e) {
  return e.split("-")[0];
}
function Ri(e) {
  return e.split("-")[1];
}
function Rl(e) {
  return e === "x" ? "y" : "x";
}
function Pl(e) {
  return e === "y" ? "height" : "width";
}
const kw = /* @__PURE__ */ new Set(["top", "bottom"]);
function Sn(e) {
  return kw.has(Kn(e)) ? "y" : "x";
}
function Ol(e) {
  return Rl(Sn(e));
}
function Iw(e, t, n) {
  n === void 0 && (n = !1);
  const r = Ri(e), i = Ol(e), s = Pl(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = uo(a)), [a, uo(a)];
}
function Dw(e) {
  const t = uo(e);
  return [Oc(e), t, Oc(t)];
}
function Oc(e) {
  return e.replace(/start|end/g, (t) => Sw[t]);
}
const qf = ["left", "right"], Kf = ["right", "left"], Rw = ["top", "bottom"], Pw = ["bottom", "top"];
function Ow(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Kf : qf : t ? qf : Kf;
    case "left":
    case "right":
      return t ? Rw : Pw;
    default:
      return [];
  }
}
function Lw(e, t, n, r) {
  const i = Ri(e);
  let s = Ow(Kn(e), n === "start", r);
  return i && (s = s.map((a) => a + "-" + i), t && (s = s.concat(s.map(Oc)))), s;
}
function uo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Cw[t]);
}
function Mw(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function f0(e) {
  return typeof e != "number" ? Mw(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function co(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function Qf(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const s = Sn(t), a = Ol(t), o = Pl(a), u = Kn(t), c = s === "y", l = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, h = r[o] / 2 - i[o] / 2;
  let m;
  switch (u) {
    case "top":
      m = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (Ri(t)) {
    case "start":
      m[a] -= h * (n && c ? -1 : 1);
      break;
    case "end":
      m[a] += h * (n && c ? -1 : 1);
      break;
  }
  return m;
}
async function Uw(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: s,
    rects: a,
    elements: o,
    strategy: u
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: m = 0
  } = qn(t, e), E = f0(m), T = o[h ? d === "floating" ? "reference" : "floating" : d], _ = co(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(T))) == null || n ? T : T.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: l,
    strategy: u
  })), A = d === "floating" ? {
    x: r,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(o.floating)), M = await (s.isElement == null ? void 0 : s.isElement(w)) ? await (s.getScale == null ? void 0 : s.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, F = co(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: A,
    offsetParent: w,
    strategy: u
  }) : A);
  return {
    top: (_.top - F.top + E.top) / M.y,
    bottom: (F.bottom - _.bottom + E.bottom) / M.y,
    left: (_.left - F.left + E.left) / M.x,
    right: (F.right - _.right + E.right) / M.x
  };
}
const Hw = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: s = [],
    platform: a
  } = n, o = s.filter(Boolean), u = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: l,
    y: d
  } = Qf(c, r, u), h = r, m = {}, E = 0;
  for (let T = 0; T < o.length; T++) {
    var g;
    const {
      name: _,
      fn: A
    } = o[T], {
      x: w,
      y: M,
      data: F,
      reset: k
    } = await A({
      x: l,
      y: d,
      initialPlacement: r,
      placement: h,
      strategy: i,
      middlewareData: m,
      rects: c,
      platform: {
        ...a,
        detectOverflow: (g = a.detectOverflow) != null ? g : Uw
      },
      elements: {
        reference: e,
        floating: t
      }
    });
    l = w ?? l, d = M ?? d, m = {
      ...m,
      [_]: {
        ...m[_],
        ...F
      }
    }, k && E <= 50 && (E++, typeof k == "object" && (k.placement && (h = k.placement), k.rects && (c = k.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : k.rects), {
      x: l,
      y: d
    } = Qf(c, h, u)), T = -1);
  }
  return {
    x: l,
    y: d,
    placement: h,
    strategy: i,
    middlewareData: m
  };
}, jw = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: s,
      platform: a,
      elements: o,
      middlewareData: u
    } = t, {
      element: c,
      padding: l = 0
    } = qn(e, t) || {};
    if (c == null)
      return {};
    const d = f0(l), h = {
      x: n,
      y: r
    }, m = Ol(i), E = Pl(m), g = await a.getDimensions(c), T = m === "y", _ = T ? "top" : "left", A = T ? "bottom" : "right", w = T ? "clientHeight" : "clientWidth", M = s.reference[E] + s.reference[m] - h[m] - s.floating[E], F = h[m] - s.reference[m], k = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let B = k ? k[w] : 0;
    (!B || !await (a.isElement == null ? void 0 : a.isElement(k))) && (B = o.floating[w] || s.floating[E]);
    const $ = M / 2 - F / 2, J = B / 2 - g[E] / 2 - 1, U = fr(d[_], J), re = fr(d[A], J), ae = U, j = B - g[E] - re, H = B / 2 - g[E] / 2 + $, z = Pc(ae, H, j), W = !u.arrow && Ri(i) != null && H !== z && s.reference[E] / 2 - (H < ae ? U : re) - g[E] / 2 < 0, X = W ? H < ae ? H - ae : H - j : 0;
    return {
      [m]: h[m] + X,
      data: {
        [m]: z,
        centerOffset: H - z - X,
        ...W && {
          alignmentOffset: X
        }
      },
      reset: W
    };
  }
}), Bw = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: s,
        rects: a,
        initialPlacement: o,
        platform: u,
        elements: c
      } = t, {
        mainAxis: l = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: E = "none",
        flipAlignment: g = !0,
        ...T
      } = qn(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const _ = Kn(i), A = Sn(o), w = Kn(o) === o, M = await (u.isRTL == null ? void 0 : u.isRTL(c.floating)), F = h || (w || !g ? [uo(o)] : Dw(o)), k = E !== "none";
      !h && k && F.push(...Lw(o, g, E, M));
      const B = [o, ...F], $ = await u.detectOverflow(t, T), J = [];
      let U = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (l && J.push($[_]), d) {
        const H = Iw(i, a, M);
        J.push($[H[0]], $[H[1]]);
      }
      if (U = [...U, {
        placement: i,
        overflows: J
      }], !J.every((H) => H <= 0)) {
        var re, ae;
        const H = (((re = s.flip) == null ? void 0 : re.index) || 0) + 1, z = B[H];
        if (z && (!(d === "alignment" ? A !== Sn(z) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        U.every((G) => Sn(G.placement) === A ? G.overflows[0] > 0 : !0)))
          return {
            data: {
              index: H,
              overflows: U
            },
            reset: {
              placement: z
            }
          };
        let W = (ae = U.filter((X) => X.overflows[0] <= 0).sort((X, G) => X.overflows[1] - G.overflows[1])[0]) == null ? void 0 : ae.placement;
        if (!W)
          switch (m) {
            case "bestFit": {
              var j;
              const X = (j = U.filter((G) => {
                if (k) {
                  const se = Sn(G.placement);
                  return se === A || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  se === "y";
                }
                return !0;
              }).map((G) => [G.placement, G.overflows.filter((se) => se > 0).reduce((se, N) => se + N, 0)]).sort((G, se) => G[1] - se[1])[0]) == null ? void 0 : j[0];
              X && (W = X);
              break;
            }
            case "initialPlacement":
              W = o;
              break;
          }
        if (i !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
};
function Xf(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Jf(e) {
  return ww.some((t) => e[t] >= 0);
}
const Fw = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: i = "referenceHidden",
        ...s
      } = qn(e, t);
      switch (i) {
        case "referenceHidden": {
          const a = await r.detectOverflow(t, {
            ...s,
            elementContext: "reference"
          }), o = Xf(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: Jf(o)
            }
          };
        }
        case "escaped": {
          const a = await r.detectOverflow(t, {
            ...s,
            altBoundary: !0
          }), o = Xf(a, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: Jf(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, h0 = /* @__PURE__ */ new Set(["left", "top"]);
async function zw(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = Kn(n), o = Ri(n), u = Sn(n) === "y", c = h0.has(a) ? -1 : 1, l = s && u ? -1 : 1, d = qn(t, e);
  let {
    mainAxis: h,
    crossAxis: m,
    alignmentAxis: E
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return o && typeof E == "number" && (m = o === "end" ? E * -1 : E), u ? {
    x: m * l,
    y: h * c
  } : {
    x: h * c,
    y: m * l
  };
}
const Vw = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: s,
        placement: a,
        middlewareData: o
      } = t, u = await zw(t, e);
      return a === ((n = o.offset) == null ? void 0 : n.placement) && (r = o.arrow) != null && r.alignmentOffset ? {} : {
        x: i + u.x,
        y: s + u.y,
        data: {
          ...u,
          placement: a
        }
      };
    }
  };
}, Ww = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        platform: s
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: u = {
          fn: (_) => {
            let {
              x: A,
              y: w
            } = _;
            return {
              x: A,
              y: w
            };
          }
        },
        ...c
      } = qn(e, t), l = {
        x: n,
        y: r
      }, d = await s.detectOverflow(t, c), h = Sn(Kn(i)), m = Rl(h);
      let E = l[m], g = l[h];
      if (a) {
        const _ = m === "y" ? "top" : "left", A = m === "y" ? "bottom" : "right", w = E + d[_], M = E - d[A];
        E = Pc(w, E, M);
      }
      if (o) {
        const _ = h === "y" ? "top" : "left", A = h === "y" ? "bottom" : "right", w = g + d[_], M = g - d[A];
        g = Pc(w, g, M);
      }
      const T = u.fn({
        ...t,
        [m]: E,
        [h]: g
      });
      return {
        ...T,
        data: {
          x: T.x - n,
          y: T.y - r,
          enabled: {
            [m]: a,
            [h]: o
          }
        }
      };
    }
  };
}, $w = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: s,
        middlewareData: a
      } = t, {
        offset: o = 0,
        mainAxis: u = !0,
        crossAxis: c = !0
      } = qn(e, t), l = {
        x: n,
        y: r
      }, d = Sn(i), h = Rl(d);
      let m = l[h], E = l[d];
      const g = qn(o, t), T = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (u) {
        const w = h === "y" ? "height" : "width", M = s.reference[h] - s.floating[w] + T.mainAxis, F = s.reference[h] + s.reference[w] - T.mainAxis;
        m < M ? m = M : m > F && (m = F);
      }
      if (c) {
        var _, A;
        const w = h === "y" ? "width" : "height", M = h0.has(Kn(i)), F = s.reference[d] - s.floating[w] + (M && ((_ = a.offset) == null ? void 0 : _[d]) || 0) + (M ? 0 : T.crossAxis), k = s.reference[d] + s.reference[w] + (M ? 0 : ((A = a.offset) == null ? void 0 : A[d]) || 0) - (M ? T.crossAxis : 0);
        E < F ? E = F : E > k && (E = k);
      }
      return {
        [h]: m,
        [d]: E
      };
    }
  };
}, Yw = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: s,
        platform: a,
        elements: o
      } = t, {
        apply: u = () => {
        },
        ...c
      } = qn(e, t), l = await a.detectOverflow(t, c), d = Kn(i), h = Ri(i), m = Sn(i) === "y", {
        width: E,
        height: g
      } = s.floating;
      let T, _;
      d === "top" || d === "bottom" ? (T = d, _ = h === (await (a.isRTL == null ? void 0 : a.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, T = h === "end" ? "top" : "bottom");
      const A = g - l.top - l.bottom, w = E - l.left - l.right, M = fr(g - l[T], A), F = fr(E - l[_], w), k = !t.middlewareData.shift;
      let B = M, $ = F;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && ($ = w), (r = t.middlewareData.shift) != null && r.enabled.y && (B = A), k && !h) {
        const U = Kt(l.left, 0), re = Kt(l.right, 0), ae = Kt(l.top, 0), j = Kt(l.bottom, 0);
        m ? $ = E - 2 * (U !== 0 || re !== 0 ? U + re : Kt(l.left, l.right)) : B = g - 2 * (ae !== 0 || j !== 0 ? ae + j : Kt(l.top, l.bottom));
      }
      await u({
        ...t,
        availableWidth: $,
        availableHeight: B
      });
      const J = await a.getDimensions(o.floating);
      return E !== J.width || g !== J.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Fo() {
  return typeof window < "u";
}
function Pi(e) {
  return m0(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Qt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Pn(e) {
  var t;
  return (t = (m0(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function m0(e) {
  return Fo() ? e instanceof Node || e instanceof Qt(e).Node : !1;
}
function pn(e) {
  return Fo() ? e instanceof Element || e instanceof Qt(e).Element : !1;
}
function Dn(e) {
  return Fo() ? e instanceof HTMLElement || e instanceof Qt(e).HTMLElement : !1;
}
function Zf(e) {
  return !Fo() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Qt(e).ShadowRoot;
}
const Gw = /* @__PURE__ */ new Set(["inline", "contents"]);
function Ys(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = gn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Gw.has(i);
}
const qw = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Kw(e) {
  return qw.has(Pi(e));
}
const Qw = [":popover-open", ":modal"];
function zo(e) {
  return Qw.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Xw = ["transform", "translate", "scale", "rotate", "perspective"], Jw = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Zw = ["paint", "layout", "strict", "content"];
function Ll(e) {
  const t = Ml(), n = pn(e) ? gn(e) : e;
  return Xw.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Jw.some((r) => (n.willChange || "").includes(r)) || Zw.some((r) => (n.contain || "").includes(r));
}
function eC(e) {
  let t = hr(e);
  for (; Dn(t) && !Ni(t); ) {
    if (Ll(t))
      return t;
    if (zo(t))
      return null;
    t = hr(t);
  }
  return null;
}
function Ml() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const tC = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Ni(e) {
  return tC.has(Pi(e));
}
function gn(e) {
  return Qt(e).getComputedStyle(e);
}
function Vo(e) {
  return pn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function hr(e) {
  if (Pi(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Zf(e) && e.host || // Fallback.
    Pn(e)
  );
  return Zf(t) ? t.host : t;
}
function p0(e) {
  const t = hr(e);
  return Ni(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Dn(t) && Ys(t) ? t : p0(t);
}
function Ds(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = p0(e), s = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Qt(i);
  if (s) {
    const o = Lc(a);
    return t.concat(a, a.visualViewport || [], Ys(i) ? i : [], o && n ? Ds(o) : []);
  }
  return t.concat(i, Ds(i, [], n));
}
function Lc(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function g0(e) {
  const t = gn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = Dn(e), s = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, o = oo(n) !== s || oo(r) !== a;
  return o && (n = s, r = a), {
    width: n,
    height: r,
    $: o
  };
}
function Ul(e) {
  return pn(e) ? e : e.contextElement;
}
function Ei(e) {
  const t = Ul(e);
  if (!Dn(t))
    return kn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: s
  } = g0(t);
  let a = (s ? oo(n.width) : n.width) / r, o = (s ? oo(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const nC = /* @__PURE__ */ kn(0);
function b0(e) {
  const t = Qt(e);
  return !Ml() || !t.visualViewport ? nC : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function rC(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Qt(e) ? !1 : t;
}
function Wr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), s = Ul(e);
  let a = kn(1);
  t && (r ? pn(r) && (a = Ei(r)) : a = Ei(e));
  const o = rC(s, n, r) ? b0(s) : kn(0);
  let u = (i.left + o.x) / a.x, c = (i.top + o.y) / a.y, l = i.width / a.x, d = i.height / a.y;
  if (s) {
    const h = Qt(s), m = r && pn(r) ? Qt(r) : r;
    let E = h, g = Lc(E);
    for (; g && r && m !== E; ) {
      const T = Ei(g), _ = g.getBoundingClientRect(), A = gn(g), w = _.left + (g.clientLeft + parseFloat(A.paddingLeft)) * T.x, M = _.top + (g.clientTop + parseFloat(A.paddingTop)) * T.y;
      u *= T.x, c *= T.y, l *= T.x, d *= T.y, u += w, c += M, E = Qt(g), g = Lc(E);
    }
  }
  return co({
    width: l,
    height: d,
    x: u,
    y: c
  });
}
function Wo(e, t) {
  const n = Vo(e).scrollLeft;
  return t ? t.left + n : Wr(Pn(e)).left + n;
}
function E0(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Wo(e, n), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function iC(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const s = i === "fixed", a = Pn(r), o = t ? zo(t.floating) : !1;
  if (r === a || o && s)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = kn(1);
  const l = kn(0), d = Dn(r);
  if ((d || !d && !s) && ((Pi(r) !== "body" || Ys(a)) && (u = Vo(r)), Dn(r))) {
    const m = Wr(r);
    c = Ei(r), l.x = m.x + r.clientLeft, l.y = m.y + r.clientTop;
  }
  const h = a && !d && !s ? E0(a, u) : kn(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - u.scrollLeft * c.x + l.x + h.x,
    y: n.y * c.y - u.scrollTop * c.y + l.y + h.y
  };
}
function sC(e) {
  return Array.from(e.getClientRects());
}
function aC(e) {
  const t = Pn(e), n = Vo(e), r = e.ownerDocument.body, i = Kt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = Kt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + Wo(e);
  const o = -n.scrollTop;
  return gn(r).direction === "rtl" && (a += Kt(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: s,
    x: a,
    y: o
  };
}
const eh = 25;
function oC(e, t) {
  const n = Qt(e), r = Pn(e), i = n.visualViewport;
  let s = r.clientWidth, a = r.clientHeight, o = 0, u = 0;
  if (i) {
    s = i.width, a = i.height;
    const l = Ml();
    (!l || l && t === "fixed") && (o = i.offsetLeft, u = i.offsetTop);
  }
  const c = Wo(r);
  if (c <= 0) {
    const l = r.ownerDocument, d = l.body, h = getComputedStyle(d), m = l.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, E = Math.abs(r.clientWidth - d.clientWidth - m);
    E <= eh && (s -= E);
  } else c <= eh && (s += c);
  return {
    width: s,
    height: a,
    x: o,
    y: u
  };
}
const uC = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function cC(e, t) {
  const n = Wr(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, s = Dn(e) ? Ei(e) : kn(1), a = e.clientWidth * s.x, o = e.clientHeight * s.y, u = i * s.x, c = r * s.y;
  return {
    width: a,
    height: o,
    x: u,
    y: c
  };
}
function th(e, t, n) {
  let r;
  if (t === "viewport")
    r = oC(e, n);
  else if (t === "document")
    r = aC(Pn(e));
  else if (pn(t))
    r = cC(t, n);
  else {
    const i = b0(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return co(r);
}
function _0(e, t) {
  const n = hr(e);
  return n === t || !pn(n) || Ni(n) ? !1 : gn(n).position === "fixed" || _0(n, t);
}
function lC(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ds(e, [], !1).filter((o) => pn(o) && Pi(o) !== "body"), i = null;
  const s = gn(e).position === "fixed";
  let a = s ? hr(e) : e;
  for (; pn(a) && !Ni(a); ) {
    const o = gn(a), u = Ll(a);
    !u && o.position === "fixed" && (i = null), (s ? !u && !i : !u && o.position === "static" && !!i && uC.has(i.position) || Ys(a) && !u && _0(e, a)) ? r = r.filter((l) => l !== a) : i = o, a = hr(a);
  }
  return t.set(e, r), r;
}
function dC(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? zo(t) ? [] : lC(t, this._c) : [].concat(n), r], o = a[0], u = a.reduce((c, l) => {
    const d = th(t, l, i);
    return c.top = Kt(d.top, c.top), c.right = fr(d.right, c.right), c.bottom = fr(d.bottom, c.bottom), c.left = Kt(d.left, c.left), c;
  }, th(t, o, i));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function fC(e) {
  const {
    width: t,
    height: n
  } = g0(e);
  return {
    width: t,
    height: n
  };
}
function hC(e, t, n) {
  const r = Dn(t), i = Pn(t), s = n === "fixed", a = Wr(e, !0, s, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = kn(0);
  function c() {
    u.x = Wo(i);
  }
  if (r || !r && !s)
    if ((Pi(t) !== "body" || Ys(i)) && (o = Vo(t)), r) {
      const m = Wr(t, !0, s, t);
      u.x = m.x + t.clientLeft, u.y = m.y + t.clientTop;
    } else i && c();
  s && !r && i && c();
  const l = i && !r && !s ? E0(i, o) : kn(0), d = a.left + o.scrollLeft - u.x - l.x, h = a.top + o.scrollTop - u.y - l.y;
  return {
    x: d,
    y: h,
    width: a.width,
    height: a.height
  };
}
function Uu(e) {
  return gn(e).position === "static";
}
function nh(e, t) {
  if (!Dn(e) || gn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Pn(e) === n && (n = n.ownerDocument.body), n;
}
function x0(e, t) {
  const n = Qt(e);
  if (zo(e))
    return n;
  if (!Dn(e)) {
    let i = hr(e);
    for (; i && !Ni(i); ) {
      if (pn(i) && !Uu(i))
        return i;
      i = hr(i);
    }
    return n;
  }
  let r = nh(e, t);
  for (; r && Kw(r) && Uu(r); )
    r = nh(r, t);
  return r && Ni(r) && Uu(r) && !Ll(r) ? n : r || eC(e) || n;
}
const mC = async function(e) {
  const t = this.getOffsetParent || x0, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: hC(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function pC(e) {
  return gn(e).direction === "rtl";
}
const gC = {
  convertOffsetParentRelativeRectToViewportRelativeRect: iC,
  getDocumentElement: Pn,
  getClippingRect: dC,
  getOffsetParent: x0,
  getElementRects: mC,
  getClientRects: sC,
  getDimensions: fC,
  getScale: Ei,
  isElement: pn,
  isRTL: pC
};
function T0(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function bC(e, t) {
  let n = null, r;
  const i = Pn(e);
  function s() {
    var o;
    clearTimeout(r), (o = n) == null || o.disconnect(), n = null;
  }
  function a(o, u) {
    o === void 0 && (o = !1), u === void 0 && (u = 1), s();
    const c = e.getBoundingClientRect(), {
      left: l,
      top: d,
      width: h,
      height: m
    } = c;
    if (o || t(), !h || !m)
      return;
    const E = ya(d), g = ya(i.clientWidth - (l + h)), T = ya(i.clientHeight - (d + m)), _ = ya(l), w = {
      rootMargin: -E + "px " + -g + "px " + -T + "px " + -_ + "px",
      threshold: Kt(0, fr(1, u)) || 1
    };
    let M = !0;
    function F(k) {
      const B = k[0].intersectionRatio;
      if (B !== u) {
        if (!M)
          return a();
        B ? a(!1, B) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      B === 1 && !T0(c, e.getBoundingClientRect()) && a(), M = !1;
    }
    try {
      n = new IntersectionObserver(F, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(F, w);
    }
    n.observe(e);
  }
  return a(!0), s;
}
function EC(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: s = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, c = Ul(e), l = i || s ? [...c ? Ds(c) : [], ...Ds(t)] : [];
  l.forEach((_) => {
    i && _.addEventListener("scroll", n, {
      passive: !0
    }), s && _.addEventListener("resize", n);
  });
  const d = c && o ? bC(c, n) : null;
  let h = -1, m = null;
  a && (m = new ResizeObserver((_) => {
    let [A] = _;
    A && A.target === c && m && (m.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = m) == null || w.observe(t);
    })), n();
  }), c && !u && m.observe(c), m.observe(t));
  let E, g = u ? Wr(e) : null;
  u && T();
  function T() {
    const _ = Wr(e);
    g && !T0(g, _) && n(), g = _, E = requestAnimationFrame(T);
  }
  return n(), () => {
    var _;
    l.forEach((A) => {
      i && A.removeEventListener("scroll", n), s && A.removeEventListener("resize", n);
    }), d?.(), (_ = m) == null || _.disconnect(), m = null, u && cancelAnimationFrame(E);
  };
}
const _C = Vw, xC = Ww, TC = Bw, AC = Yw, yC = Fw, rh = jw, NC = $w, vC = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: gC,
    ...n
  }, s = {
    ...i.platform,
    _c: r
  };
  return Hw(e, t, {
    ...i,
    platform: s
  });
};
var wC = typeof document < "u", CC = function() {
}, Va = wC ? xi : CC;
function lo(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!lo(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = i[r];
      if (!(s === "_owner" && e.$$typeof) && !lo(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function A0(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ih(e, t) {
  const n = A0(e);
  return Math.round(t * n) / n;
}
function Hu(e) {
  const t = y.useRef(e);
  return Va(() => {
    t.current = e;
  }), t;
}
function SC(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: s,
      floating: a
    } = {},
    transform: o = !0,
    whileElementsMounted: u,
    open: c
  } = e, [l, d] = y.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, m] = y.useState(r);
  lo(h, r) || m(r);
  const [E, g] = y.useState(null), [T, _] = y.useState(null), A = y.useCallback((G) => {
    G !== k.current && (k.current = G, g(G));
  }, []), w = y.useCallback((G) => {
    G !== B.current && (B.current = G, _(G));
  }, []), M = s || E, F = a || T, k = y.useRef(null), B = y.useRef(null), $ = y.useRef(l), J = u != null, U = Hu(u), re = Hu(i), ae = Hu(c), j = y.useCallback(() => {
    if (!k.current || !B.current)
      return;
    const G = {
      placement: t,
      strategy: n,
      middleware: h
    };
    re.current && (G.platform = re.current), vC(k.current, B.current, G).then((se) => {
      const N = {
        ...se,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: ae.current !== !1
      };
      H.current && !lo($.current, N) && ($.current = N, vo.flushSync(() => {
        d(N);
      }));
    });
  }, [h, t, n, re, ae]);
  Va(() => {
    c === !1 && $.current.isPositioned && ($.current.isPositioned = !1, d((G) => ({
      ...G,
      isPositioned: !1
    })));
  }, [c]);
  const H = y.useRef(!1);
  Va(() => (H.current = !0, () => {
    H.current = !1;
  }), []), Va(() => {
    if (M && (k.current = M), F && (B.current = F), M && F) {
      if (U.current)
        return U.current(M, F, j);
      j();
    }
  }, [M, F, j, U, J]);
  const z = y.useMemo(() => ({
    reference: k,
    floating: B,
    setReference: A,
    setFloating: w
  }), [A, w]), W = y.useMemo(() => ({
    reference: M,
    floating: F
  }), [M, F]), X = y.useMemo(() => {
    const G = {
      position: n,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return G;
    const se = ih(W.floating, l.x), N = ih(W.floating, l.y);
    return o ? {
      ...G,
      transform: "translate(" + se + "px, " + N + "px)",
      ...A0(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: se,
      top: N
    };
  }, [n, o, W.floating, l.x, l.y]);
  return y.useMemo(() => ({
    ...l,
    update: j,
    refs: z,
    elements: W,
    floatingStyles: X
  }), [l, j, z, W, X]);
}
const kC = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? rh({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? rh({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, IC = (e, t) => ({
  ..._C(e),
  options: [e, t]
}), DC = (e, t) => ({
  ...xC(e),
  options: [e, t]
}), RC = (e, t) => ({
  ...NC(e),
  options: [e, t]
}), PC = (e, t) => ({
  ...TC(e),
  options: [e, t]
}), OC = (e, t) => ({
  ...AC(e),
  options: [e, t]
}), LC = (e, t) => ({
  ...yC(e),
  options: [e, t]
}), MC = (e, t) => ({
  ...kC(e),
  options: [e, t]
});
var UC = "Arrow", y0 = y.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...s } = e;
  return /* @__PURE__ */ S.jsx(
    tt.svg,
    {
      ...s,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ S.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
y0.displayName = UC;
var HC = y0, Hl = "Popper", [N0, Oi] = Di(Hl), [jC, v0] = N0(Hl), w0 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = y.useState(null);
  return /* @__PURE__ */ S.jsx(jC, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
w0.displayName = Hl;
var C0 = "PopperAnchor", S0 = y.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, s = v0(C0, n), a = y.useRef(null), o = et(t, a), u = y.useRef(null);
    return y.useEffect(() => {
      const c = u.current;
      u.current = r?.current || a.current, c !== u.current && s.onAnchorChange(u.current);
    }), r ? null : /* @__PURE__ */ S.jsx(tt.div, { ...i, ref: o });
  }
);
S0.displayName = C0;
var jl = "PopperContent", [BC, FC] = N0(jl), k0 = y.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: s = "center",
      alignOffset: a = 0,
      arrowPadding: o = 0,
      avoidCollisions: u = !0,
      collisionBoundary: c = [],
      collisionPadding: l = 0,
      sticky: d = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: E,
      ...g
    } = e, T = v0(jl, n), [_, A] = y.useState(null), w = et(t, (fe) => A(fe)), [M, F] = y.useState(null), k = vw(M), B = k?.width ?? 0, $ = k?.height ?? 0, J = r + (s !== "center" ? "-" + s : ""), U = typeof l == "number" ? l : { top: 0, right: 0, bottom: 0, left: 0, ...l }, re = Array.isArray(c) ? c : [c], ae = re.length > 0, j = {
      padding: U,
      boundary: re.filter(VC),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: ae
    }, { refs: H, floatingStyles: z, placement: W, isPositioned: X, middlewareData: G } = SC({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: J,
      whileElementsMounted: (...fe) => EC(...fe, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: T.anchor
      },
      middleware: [
        IC({ mainAxis: i + $, alignmentAxis: a }),
        u && DC({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? RC() : void 0,
          ...j
        }),
        u && PC({ ...j }),
        OC({
          ...j,
          apply: ({ elements: fe, rects: Te, availableWidth: Ne, availableHeight: _e }) => {
            const { width: Se, height: Me } = Te.reference, Ze = fe.floating.style;
            Ze.setProperty("--radix-popper-available-width", `${Ne}px`), Ze.setProperty("--radix-popper-available-height", `${_e}px`), Ze.setProperty("--radix-popper-anchor-width", `${Se}px`), Ze.setProperty("--radix-popper-anchor-height", `${Me}px`);
          }
        }),
        M && MC({ element: M, padding: o }),
        WC({ arrowWidth: B, arrowHeight: $ }),
        h && LC({ strategy: "referenceHidden", ...j })
      ]
    }), [se, N] = R0(W), ye = Zt(E);
    Pt(() => {
      X && ye?.();
    }, [X, ye]);
    const Re = G.arrow?.x, D = G.arrow?.y, Ie = G.arrow?.centerOffset !== 0, [De, He] = y.useState();
    return Pt(() => {
      _ && He(window.getComputedStyle(_).zIndex);
    }, [_]), /* @__PURE__ */ S.jsx(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...z,
          transform: X ? z.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: De,
          "--radix-popper-transform-origin": [
            G.transformOrigin?.x,
            G.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...G.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ S.jsx(
          BC,
          {
            scope: n,
            placedSide: se,
            onArrowChange: F,
            arrowX: Re,
            arrowY: D,
            shouldHideArrow: Ie,
            children: /* @__PURE__ */ S.jsx(
              tt.div,
              {
                "data-side": se,
                "data-align": N,
                ...g,
                ref: w,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: X ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
k0.displayName = jl;
var I0 = "PopperArrow", zC = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, D0 = y.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, s = FC(I0, r), a = zC[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ S.jsx(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ S.jsx(
          HC,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
D0.displayName = I0;
function VC(e) {
  return e !== null;
}
var WC = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: i } = t, a = i.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, u = a ? 0 : e.arrowHeight, [c, l] = R0(n), d = { start: "0%", center: "50%", end: "100%" }[l], h = (i.arrow?.x ?? 0) + o / 2, m = (i.arrow?.y ?? 0) + u / 2;
    let E = "", g = "";
    return c === "bottom" ? (E = a ? d : `${h}px`, g = `${-u}px`) : c === "top" ? (E = a ? d : `${h}px`, g = `${r.floating.height + u}px`) : c === "right" ? (E = `${-u}px`, g = a ? d : `${m}px`) : c === "left" && (E = `${r.floating.width + u}px`, g = a ? d : `${m}px`), { data: { x: E, y: g } };
  }
});
function R0(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Bl = w0, $o = S0, Fl = k0, zl = D0;
function sh(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var Yo = "Popover", [P0] = Di(Yo, [
  Oi
]), Gs = Oi(), [$C, br] = P0(Yo), O0 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: s,
    modal: a = !1
  } = e, o = Gs(t), u = y.useRef(null), [c, l] = y.useState(!1), [d, h] = Is({
    prop: r,
    defaultProp: i ?? !1,
    onChange: s,
    caller: Yo
  });
  return /* @__PURE__ */ S.jsx(Bl, { ...o, children: /* @__PURE__ */ S.jsx(
    $C,
    {
      scope: t,
      contentId: ur(),
      triggerRef: u,
      open: d,
      onOpenChange: h,
      onOpenToggle: y.useCallback(() => h((m) => !m), [h]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: y.useCallback(() => l(!0), []),
      onCustomAnchorRemove: y.useCallback(() => l(!1), []),
      modal: a,
      children: n
    }
  ) });
};
O0.displayName = Yo;
var L0 = "PopoverAnchor", YC = y.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = br(L0, n), s = Gs(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: o } = i;
    return y.useEffect(() => (a(), () => o()), [a, o]), /* @__PURE__ */ S.jsx($o, { ...s, ...r, ref: t });
  }
);
YC.displayName = L0;
var M0 = "PopoverTrigger", U0 = y.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = br(M0, n), s = Gs(n), a = et(t, i.triggerRef), o = /* @__PURE__ */ S.jsx(
      tt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": z0(i.open),
        ...r,
        ref: a,
        onClick: Oe(e.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? o : /* @__PURE__ */ S.jsx($o, { asChild: !0, ...s, children: o });
  }
);
U0.displayName = M0;
var Vl = "PopoverPortal", [GC, qC] = P0(Vl, {
  forceMount: void 0
}), H0 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, s = br(Vl, t);
  return /* @__PURE__ */ S.jsx(GC, { scope: t, forceMount: n, children: /* @__PURE__ */ S.jsx(gr, { present: n || s.open, children: /* @__PURE__ */ S.jsx($s, { asChild: !0, container: i, children: r }) }) });
};
H0.displayName = Vl;
var vi = "PopoverContent", j0 = y.forwardRef(
  (e, t) => {
    const n = qC(vi, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, s = br(vi, e.__scopePopover);
    return /* @__PURE__ */ S.jsx(gr, { present: r || s.open, children: s.modal ? /* @__PURE__ */ S.jsx(QC, { ...i, ref: t }) : /* @__PURE__ */ S.jsx(XC, { ...i, ref: t }) });
  }
);
j0.displayName = vi;
var KC = /* @__PURE__ */ zr("PopoverContent.RemoveScroll"), QC = y.forwardRef(
  (e, t) => {
    const n = br(vi, e.__scopePopover), r = y.useRef(null), i = et(t, r), s = y.useRef(!1);
    return y.useEffect(() => {
      const a = r.current;
      if (a) return Sl(a);
    }, []), /* @__PURE__ */ S.jsx(jo, { as: KC, allowPinchZoom: !0, children: /* @__PURE__ */ S.jsx(
      B0,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Oe(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), s.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Oe(
          e.onPointerDownOutside,
          (a) => {
            const o = a.detail.originalEvent, u = o.button === 0 && o.ctrlKey === !0, c = o.button === 2 || u;
            s.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Oe(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), XC = y.forwardRef(
  (e, t) => {
    const n = br(vi, e.__scopePopover), r = y.useRef(!1), i = y.useRef(!1);
    return /* @__PURE__ */ S.jsx(
      B0,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          e.onCloseAutoFocus?.(s), s.defaultPrevented || (r.current || n.triggerRef.current?.focus(), s.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (s) => {
          e.onInteractOutside?.(s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = s.target;
          n.triggerRef.current?.contains(a) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && i.current && s.preventDefault();
        }
      }
    );
  }
), B0 = y.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: o,
      onPointerDownOutside: u,
      onFocusOutside: c,
      onInteractOutside: l,
      ...d
    } = e, h = br(vi, n), m = Gs(n);
    return Cl(), /* @__PURE__ */ S.jsx(
      Uo,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ S.jsx(
          Ws,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: l,
            onEscapeKeyDown: o,
            onPointerDownOutside: u,
            onFocusOutside: c,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ S.jsx(
              Fl,
              {
                "data-state": z0(h.open),
                role: "dialog",
                id: h.contentId,
                ...m,
                ...d,
                ref: t,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), F0 = "PopoverClose", JC = y.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = br(F0, n);
    return /* @__PURE__ */ S.jsx(
      tt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Oe(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
JC.displayName = F0;
var ZC = "PopoverArrow", eS = y.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = Gs(n);
    return /* @__PURE__ */ S.jsx(zl, { ...i, ...r, ref: t });
  }
);
eS.displayName = ZC;
function z0(e) {
  return e ? "open" : "closed";
}
var tS = O0, nS = U0, rS = H0, iS = j0, sS = [" ", "Enter", "ArrowUp", "ArrowDown"], aS = [" ", "Enter"], $r = "Select", [Go, qo, oS] = QN($r), [Li] = Di($r, [
  oS,
  Oi
]), Ko = Oi(), [uS, Er] = Li($r), [cS, lS] = Li($r), V0 = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: s,
    value: a,
    defaultValue: o,
    onValueChange: u,
    dir: c,
    name: l,
    autoComplete: d,
    disabled: h,
    required: m,
    form: E
  } = e, g = Ko(t), [T, _] = y.useState(null), [A, w] = y.useState(null), [M, F] = y.useState(!1), k = av(c), [B, $] = Is({
    prop: r,
    defaultProp: i ?? !1,
    onChange: s,
    caller: $r
  }), [J, U] = Is({
    prop: a,
    defaultProp: o,
    onChange: u,
    caller: $r
  }), re = y.useRef(null), ae = T ? E || !!T.closest("form") : !0, [j, H] = y.useState(/* @__PURE__ */ new Set()), z = Array.from(j).map((W) => W.props.value).join(";");
  return /* @__PURE__ */ S.jsx(Bl, { ...g, children: /* @__PURE__ */ S.jsxs(
    uS,
    {
      required: m,
      scope: t,
      trigger: T,
      onTriggerChange: _,
      valueNode: A,
      onValueNodeChange: w,
      valueNodeHasChildren: M,
      onValueNodeHasChildrenChange: F,
      contentId: ur(),
      value: J,
      onValueChange: U,
      open: B,
      onOpenChange: $,
      dir: k,
      triggerPointerDownPosRef: re,
      disabled: h,
      children: [
        /* @__PURE__ */ S.jsx(Go.Provider, { scope: t, children: /* @__PURE__ */ S.jsx(
          cS,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: y.useCallback((W) => {
              H((X) => new Set(X).add(W));
            }, []),
            onNativeOptionRemove: y.useCallback((W) => {
              H((X) => {
                const G = new Set(X);
                return G.delete(W), G;
              });
            }, []),
            children: n
          }
        ) }),
        ae ? /* @__PURE__ */ S.jsxs(
          db,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: l,
            autoComplete: d,
            value: J,
            onChange: (W) => U(W.target.value),
            disabled: h,
            form: E,
            children: [
              J === void 0 ? /* @__PURE__ */ S.jsx("option", { value: "" }) : null,
              Array.from(j)
            ]
          },
          z
        ) : null
      ]
    }
  ) });
};
V0.displayName = $r;
var W0 = "SelectTrigger", $0 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...i } = e, s = Ko(n), a = Er(W0, n), o = a.disabled || r, u = et(t, a.onTriggerChange), c = qo(n), l = y.useRef("touch"), [d, h, m] = hb((g) => {
      const T = c().filter((w) => !w.disabled), _ = T.find((w) => w.value === a.value), A = mb(T, g, _);
      A !== void 0 && a.onValueChange(A.value);
    }), E = (g) => {
      o || (a.onOpenChange(!0), m()), g && (a.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ S.jsx($o, { asChild: !0, ...s, children: /* @__PURE__ */ S.jsx(
      tt.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-placeholder": fb(a.value) ? "" : void 0,
        ...i,
        ref: u,
        onClick: Oe(i.onClick, (g) => {
          g.currentTarget.focus(), l.current !== "mouse" && E(g);
        }),
        onPointerDown: Oe(i.onPointerDown, (g) => {
          l.current = g.pointerType;
          const T = g.target;
          T.hasPointerCapture(g.pointerId) && T.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (E(g), g.preventDefault());
        }),
        onKeyDown: Oe(i.onKeyDown, (g) => {
          const T = d.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && h(g.key), !(T && g.key === " ") && sS.includes(g.key) && (E(), g.preventDefault());
        })
      }
    ) });
  }
);
$0.displayName = W0;
var Y0 = "SelectValue", G0 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, children: s, placeholder: a = "", ...o } = e, u = Er(Y0, n), { onValueNodeHasChildrenChange: c } = u, l = s !== void 0, d = et(t, u.onValueNodeChange);
    return Pt(() => {
      c(l);
    }, [c, l]), /* @__PURE__ */ S.jsx(
      tt.span,
      {
        ...o,
        ref: d,
        style: { pointerEvents: "none" },
        children: fb(u.value) ? /* @__PURE__ */ S.jsx(S.Fragment, { children: a }) : s
      }
    );
  }
);
G0.displayName = Y0;
var dS = "SelectIcon", q0 = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...i } = e;
    return /* @__PURE__ */ S.jsx(tt.span, { "aria-hidden": !0, ...i, ref: t, children: r || "▼" });
  }
);
q0.displayName = dS;
var fS = "SelectPortal", K0 = (e) => /* @__PURE__ */ S.jsx($s, { asChild: !0, ...e });
K0.displayName = fS;
var Yr = "SelectContent", Q0 = y.forwardRef(
  (e, t) => {
    const n = Er(Yr, e.__scopeSelect), [r, i] = y.useState();
    if (Pt(() => {
      i(new DocumentFragment());
    }, []), !n.open) {
      const s = r;
      return s ? vo.createPortal(
        /* @__PURE__ */ S.jsx(X0, { scope: e.__scopeSelect, children: /* @__PURE__ */ S.jsx(Go.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ S.jsx("div", { children: e.children }) }) }),
        s
      ) : null;
    }
    return /* @__PURE__ */ S.jsx(J0, { ...e, ref: t });
  }
);
Q0.displayName = Yr;
var ln = 10, [X0, _r] = Li(Yr), hS = "SelectContentImpl", mS = /* @__PURE__ */ zr("SelectContent.RemoveScroll"), J0 = y.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: o,
      sideOffset: u,
      align: c,
      alignOffset: l,
      arrowPadding: d,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: E,
      hideWhenDetached: g,
      avoidCollisions: T,
      //
      ..._
    } = e, A = Er(Yr, n), [w, M] = y.useState(null), [F, k] = y.useState(null), B = et(t, (fe) => M(fe)), [$, J] = y.useState(null), [U, re] = y.useState(
      null
    ), ae = qo(n), [j, H] = y.useState(!1), z = y.useRef(!1);
    y.useEffect(() => {
      if (w) return Sl(w);
    }, [w]), Cl();
    const W = y.useCallback(
      (fe) => {
        const [Te, ...Ne] = ae().map((Me) => Me.ref.current), [_e] = Ne.slice(-1), Se = document.activeElement;
        for (const Me of fe)
          if (Me === Se || (Me?.scrollIntoView({ block: "nearest" }), Me === Te && F && (F.scrollTop = 0), Me === _e && F && (F.scrollTop = F.scrollHeight), Me?.focus(), document.activeElement !== Se)) return;
      },
      [ae, F]
    ), X = y.useCallback(
      () => W([$, w]),
      [W, $, w]
    );
    y.useEffect(() => {
      j && X();
    }, [j, X]);
    const { onOpenChange: G, triggerPointerDownPosRef: se } = A;
    y.useEffect(() => {
      if (w) {
        let fe = { x: 0, y: 0 };
        const Te = (_e) => {
          fe = {
            x: Math.abs(Math.round(_e.pageX) - (se.current?.x ?? 0)),
            y: Math.abs(Math.round(_e.pageY) - (se.current?.y ?? 0))
          };
        }, Ne = (_e) => {
          fe.x <= 10 && fe.y <= 10 ? _e.preventDefault() : w.contains(_e.target) || G(!1), document.removeEventListener("pointermove", Te), se.current = null;
        };
        return se.current !== null && (document.addEventListener("pointermove", Te), document.addEventListener("pointerup", Ne, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Te), document.removeEventListener("pointerup", Ne, { capture: !0 });
        };
      }
    }, [w, G, se]), y.useEffect(() => {
      const fe = () => G(!1);
      return window.addEventListener("blur", fe), window.addEventListener("resize", fe), () => {
        window.removeEventListener("blur", fe), window.removeEventListener("resize", fe);
      };
    }, [G]);
    const [N, ye] = hb((fe) => {
      const Te = ae().filter((Se) => !Se.disabled), Ne = Te.find((Se) => Se.ref.current === document.activeElement), _e = mb(Te, fe, Ne);
      _e && setTimeout(() => _e.ref.current.focus());
    }), Re = y.useCallback(
      (fe, Te, Ne) => {
        const _e = !z.current && !Ne;
        (A.value !== void 0 && A.value === Te || _e) && (J(fe), _e && (z.current = !0));
      },
      [A.value]
    ), D = y.useCallback(() => w?.focus(), [w]), Ie = y.useCallback(
      (fe, Te, Ne) => {
        const _e = !z.current && !Ne;
        (A.value !== void 0 && A.value === Te || _e) && re(fe);
      },
      [A.value]
    ), De = r === "popper" ? Mc : Z0, He = De === Mc ? {
      side: o,
      sideOffset: u,
      align: c,
      alignOffset: l,
      arrowPadding: d,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: E,
      hideWhenDetached: g,
      avoidCollisions: T
    } : {};
    return /* @__PURE__ */ S.jsx(
      X0,
      {
        scope: n,
        content: w,
        viewport: F,
        onViewportChange: k,
        itemRefCallback: Re,
        selectedItem: $,
        onItemLeave: D,
        itemTextRefCallback: Ie,
        focusSelectedItem: X,
        selectedItemText: U,
        position: r,
        isPositioned: j,
        searchRef: N,
        children: /* @__PURE__ */ S.jsx(jo, { as: mS, allowPinchZoom: !0, children: /* @__PURE__ */ S.jsx(
          Uo,
          {
            asChild: !0,
            trapped: A.open,
            onMountAutoFocus: (fe) => {
              fe.preventDefault();
            },
            onUnmountAutoFocus: Oe(i, (fe) => {
              A.trigger?.focus({ preventScroll: !0 }), fe.preventDefault();
            }),
            children: /* @__PURE__ */ S.jsx(
              Ws,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: a,
                onFocusOutside: (fe) => fe.preventDefault(),
                onDismiss: () => A.onOpenChange(!1),
                children: /* @__PURE__ */ S.jsx(
                  De,
                  {
                    role: "listbox",
                    id: A.contentId,
                    "data-state": A.open ? "open" : "closed",
                    dir: A.dir,
                    onContextMenu: (fe) => fe.preventDefault(),
                    ..._,
                    ...He,
                    onPlaced: () => H(!0),
                    ref: B,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ..._.style
                    },
                    onKeyDown: Oe(_.onKeyDown, (fe) => {
                      const Te = fe.ctrlKey || fe.altKey || fe.metaKey;
                      if (fe.key === "Tab" && fe.preventDefault(), !Te && fe.key.length === 1 && ye(fe.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(fe.key)) {
                        let _e = ae().filter((Se) => !Se.disabled).map((Se) => Se.ref.current);
                        if (["ArrowUp", "End"].includes(fe.key) && (_e = _e.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(fe.key)) {
                          const Se = fe.target, Me = _e.indexOf(Se);
                          _e = _e.slice(Me + 1);
                        }
                        setTimeout(() => W(_e)), fe.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
J0.displayName = hS;
var pS = "SelectItemAlignedPosition", Z0 = y.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = e, s = Er(Yr, n), a = _r(Yr, n), [o, u] = y.useState(null), [c, l] = y.useState(null), d = et(t, (B) => l(B)), h = qo(n), m = y.useRef(!1), E = y.useRef(!0), { viewport: g, selectedItem: T, selectedItemText: _, focusSelectedItem: A } = a, w = y.useCallback(() => {
    if (s.trigger && s.valueNode && o && c && g && T && _) {
      const B = s.trigger.getBoundingClientRect(), $ = c.getBoundingClientRect(), J = s.valueNode.getBoundingClientRect(), U = _.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const Se = U.left - $.left, Me = J.left - Se, Ze = B.left - Me, Et = B.width + Ze, kt = Math.max(Et, $.width), _t = window.innerWidth - ln, tn = sh(Me, [
          ln,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(ln, _t - kt)
        ]);
        o.style.minWidth = Et + "px", o.style.left = tn + "px";
      } else {
        const Se = $.right - U.right, Me = window.innerWidth - J.right - Se, Ze = window.innerWidth - B.right - Me, Et = B.width + Ze, kt = Math.max(Et, $.width), _t = window.innerWidth - ln, tn = sh(Me, [
          ln,
          Math.max(ln, _t - kt)
        ]);
        o.style.minWidth = Et + "px", o.style.right = tn + "px";
      }
      const re = h(), ae = window.innerHeight - ln * 2, j = g.scrollHeight, H = window.getComputedStyle(c), z = parseInt(H.borderTopWidth, 10), W = parseInt(H.paddingTop, 10), X = parseInt(H.borderBottomWidth, 10), G = parseInt(H.paddingBottom, 10), se = z + W + j + G + X, N = Math.min(T.offsetHeight * 5, se), ye = window.getComputedStyle(g), Re = parseInt(ye.paddingTop, 10), D = parseInt(ye.paddingBottom, 10), Ie = B.top + B.height / 2 - ln, De = ae - Ie, He = T.offsetHeight / 2, fe = T.offsetTop + He, Te = z + W + fe, Ne = se - Te;
      if (Te <= Ie) {
        const Se = re.length > 0 && T === re[re.length - 1].ref.current;
        o.style.bottom = "0px";
        const Me = c.clientHeight - g.offsetTop - g.offsetHeight, Ze = Math.max(
          De,
          He + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Se ? D : 0) + Me + X
        ), Et = Te + Ze;
        o.style.height = Et + "px";
      } else {
        const Se = re.length > 0 && T === re[0].ref.current;
        o.style.top = "0px";
        const Ze = Math.max(
          Ie,
          z + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Se ? Re : 0) + He
        ) + Ne;
        o.style.height = Ze + "px", g.scrollTop = Te - Ie + g.offsetTop;
      }
      o.style.margin = `${ln}px 0`, o.style.minHeight = N + "px", o.style.maxHeight = ae + "px", r?.(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    h,
    s.trigger,
    s.valueNode,
    o,
    c,
    g,
    T,
    _,
    s.dir,
    r
  ]);
  Pt(() => w(), [w]);
  const [M, F] = y.useState();
  Pt(() => {
    c && F(window.getComputedStyle(c).zIndex);
  }, [c]);
  const k = y.useCallback(
    (B) => {
      B && E.current === !0 && (w(), A?.(), E.current = !1);
    },
    [w, A]
  );
  return /* @__PURE__ */ S.jsx(
    bS,
    {
      scope: n,
      contentWrapper: o,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: k,
      children: /* @__PURE__ */ S.jsx(
        "div",
        {
          ref: u,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: M
          },
          children: /* @__PURE__ */ S.jsx(
            tt.div,
            {
              ...i,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
Z0.displayName = pS;
var gS = "SelectPopperPosition", Mc = y.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: i = ln,
    ...s
  } = e, a = Ko(n);
  return /* @__PURE__ */ S.jsx(
    Fl,
    {
      ...a,
      ...s,
      ref: t,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Mc.displayName = gS;
var [bS, Wl] = Li(Yr, {}), Uc = "SelectViewport", eb = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...i } = e, s = _r(Uc, n), a = Wl(Uc, n), o = et(t, s.onViewportChange), u = y.useRef(0);
    return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
      /* @__PURE__ */ S.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ S.jsx(Go.Slot, { scope: n, children: /* @__PURE__ */ S.jsx(
        tt.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: o,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...i.style
          },
          onScroll: Oe(i.onScroll, (c) => {
            const l = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: h } = a;
            if (h?.current && d) {
              const m = Math.abs(u.current - l.scrollTop);
              if (m > 0) {
                const E = window.innerHeight - ln * 2, g = parseFloat(d.style.minHeight), T = parseFloat(d.style.height), _ = Math.max(g, T);
                if (_ < E) {
                  const A = _ + m, w = Math.min(E, A), M = A - w;
                  d.style.height = w + "px", d.style.bottom === "0px" && (l.scrollTop = M > 0 ? M : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            u.current = l.scrollTop;
          })
        }
      ) })
    ] });
  }
);
eb.displayName = Uc;
var tb = "SelectGroup", [ES, _S] = Li(tb), xS = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = ur();
    return /* @__PURE__ */ S.jsx(ES, { scope: n, id: i, children: /* @__PURE__ */ S.jsx(tt.div, { role: "group", "aria-labelledby": i, ...r, ref: t }) });
  }
);
xS.displayName = tb;
var nb = "SelectLabel", TS = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = _S(nb, n);
    return /* @__PURE__ */ S.jsx(tt.div, { id: i.id, ...r, ref: t });
  }
);
TS.displayName = nb;
var fo = "SelectItem", [AS, rb] = Li(fo), ib = y.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: i = !1,
      textValue: s,
      ...a
    } = e, o = Er(fo, n), u = _r(fo, n), c = o.value === r, [l, d] = y.useState(s ?? ""), [h, m] = y.useState(!1), E = et(
      t,
      (A) => u.itemRefCallback?.(A, r, i)
    ), g = ur(), T = y.useRef("touch"), _ = () => {
      i || (o.onValueChange(r), o.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ S.jsx(
      AS,
      {
        scope: n,
        value: r,
        disabled: i,
        textId: g,
        isSelected: c,
        onItemTextChange: y.useCallback((A) => {
          d((w) => w || (A?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ S.jsx(
          Go.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: i,
            textValue: l,
            children: /* @__PURE__ */ S.jsx(
              tt.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": c && h,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...a,
                ref: E,
                onFocus: Oe(a.onFocus, () => m(!0)),
                onBlur: Oe(a.onBlur, () => m(!1)),
                onClick: Oe(a.onClick, () => {
                  T.current !== "mouse" && _();
                }),
                onPointerUp: Oe(a.onPointerUp, () => {
                  T.current === "mouse" && _();
                }),
                onPointerDown: Oe(a.onPointerDown, (A) => {
                  T.current = A.pointerType;
                }),
                onPointerMove: Oe(a.onPointerMove, (A) => {
                  T.current = A.pointerType, i ? u.onItemLeave?.() : T.current === "mouse" && A.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Oe(a.onPointerLeave, (A) => {
                  A.currentTarget === document.activeElement && u.onItemLeave?.();
                }),
                onKeyDown: Oe(a.onKeyDown, (A) => {
                  u.searchRef?.current !== "" && A.key === " " || (aS.includes(A.key) && _(), A.key === " " && A.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
ib.displayName = fo;
var ds = "SelectItemText", sb = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, ...s } = e, a = Er(ds, n), o = _r(ds, n), u = rb(ds, n), c = lS(ds, n), [l, d] = y.useState(null), h = et(
      t,
      (_) => d(_),
      u.onItemTextChange,
      (_) => o.itemTextRefCallback?.(_, u.value, u.disabled)
    ), m = l?.textContent, E = y.useMemo(
      () => /* @__PURE__ */ S.jsx("option", { value: u.value, disabled: u.disabled, children: m }, u.value),
      [u.disabled, u.value, m]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: T } = c;
    return Pt(() => (g(E), () => T(E)), [g, T, E]), /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
      /* @__PURE__ */ S.jsx(tt.span, { id: u.textId, ...s, ref: h }),
      u.isSelected && a.valueNode && !a.valueNodeHasChildren ? vo.createPortal(s.children, a.valueNode) : null
    ] });
  }
);
sb.displayName = ds;
var ab = "SelectItemIndicator", ob = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return rb(ab, n).isSelected ? /* @__PURE__ */ S.jsx(tt.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
ob.displayName = ab;
var Hc = "SelectScrollUpButton", ub = y.forwardRef((e, t) => {
  const n = _r(Hc, e.__scopeSelect), r = Wl(Hc, e.__scopeSelect), [i, s] = y.useState(!1), a = et(t, r.onScrollButtonChange);
  return Pt(() => {
    if (n.viewport && n.isPositioned) {
      let o = function() {
        const c = u.scrollTop > 0;
        s(c);
      };
      const u = n.viewport;
      return o(), u.addEventListener("scroll", o), () => u.removeEventListener("scroll", o);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ S.jsx(
    lb,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: u } = n;
        o && u && (o.scrollTop = o.scrollTop - u.offsetHeight);
      }
    }
  ) : null;
});
ub.displayName = Hc;
var jc = "SelectScrollDownButton", cb = y.forwardRef((e, t) => {
  const n = _r(jc, e.__scopeSelect), r = Wl(jc, e.__scopeSelect), [i, s] = y.useState(!1), a = et(t, r.onScrollButtonChange);
  return Pt(() => {
    if (n.viewport && n.isPositioned) {
      let o = function() {
        const c = u.scrollHeight - u.clientHeight, l = Math.ceil(u.scrollTop) < c;
        s(l);
      };
      const u = n.viewport;
      return o(), u.addEventListener("scroll", o), () => u.removeEventListener("scroll", o);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ S.jsx(
    lb,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: u } = n;
        o && u && (o.scrollTop = o.scrollTop + u.offsetHeight);
      }
    }
  ) : null;
});
cb.displayName = jc;
var lb = y.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...i } = e, s = _r("SelectScrollButton", n), a = y.useRef(null), o = qo(n), u = y.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return y.useEffect(() => () => u(), [u]), Pt(() => {
    o().find((l) => l.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [o]), /* @__PURE__ */ S.jsx(
    tt.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: t,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: Oe(i.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: Oe(i.onPointerMove, () => {
        s.onItemLeave?.(), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: Oe(i.onPointerLeave, () => {
        u();
      })
    }
  );
}), yS = "SelectSeparator", NS = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ S.jsx(tt.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
NS.displayName = yS;
var Bc = "SelectArrow", vS = y.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = Ko(n), s = Er(Bc, n), a = _r(Bc, n);
    return s.open && a.position === "popper" ? /* @__PURE__ */ S.jsx(zl, { ...i, ...r, ref: t }) : null;
  }
);
vS.displayName = Bc;
var wS = "SelectBubbleInput", db = y.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const i = y.useRef(null), s = et(r, i), a = Nw(t);
    return y.useEffect(() => {
      const o = i.current;
      if (!o) return;
      const u = window.HTMLSelectElement.prototype, l = Object.getOwnPropertyDescriptor(
        u,
        "value"
      ).set;
      if (a !== t && l) {
        const d = new Event("change", { bubbles: !0 });
        l.call(o, t), o.dispatchEvent(d);
      }
    }, [a, t]), /* @__PURE__ */ S.jsx(
      tt.select,
      {
        ...n,
        style: { ...Hg, ...n.style },
        ref: s,
        defaultValue: t
      }
    );
  }
);
db.displayName = wS;
function fb(e) {
  return e === "" || e === void 0;
}
function hb(e) {
  const t = Zt(e), n = y.useRef(""), r = y.useRef(0), i = y.useCallback(
    (a) => {
      const o = n.current + a;
      t(o), (function u(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => u(""), 1e3));
      })(o);
    },
    [t]
  ), s = y.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return y.useEffect(() => () => window.clearTimeout(r.current), []), [n, i, s];
}
function mb(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, s = n ? e.indexOf(n) : -1;
  let a = CS(e, Math.max(s, 0));
  i.length === 1 && (a = a.filter((c) => c !== n));
  const u = a.find(
    (c) => c.textValue.toLowerCase().startsWith(i.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function CS(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var SS = V0, kS = $0, IS = G0, DS = q0, RS = K0, PS = Q0, OS = eb, LS = ib, MS = sb, US = ob, HS = ub, jS = cb, [Qo] = Di("Tooltip", [
  Oi
]), Xo = Oi(), pb = "TooltipProvider", BS = 700, Fc = "tooltip.open", [FS, $l] = Qo(pb), gb = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = BS,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: s
  } = e, a = y.useRef(!0), o = y.useRef(!1), u = y.useRef(0);
  return y.useEffect(() => {
    const c = u.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ S.jsx(
    FS,
    {
      scope: t,
      isOpenDelayedRef: a,
      delayDuration: n,
      onOpen: y.useCallback(() => {
        window.clearTimeout(u.current), a.current = !1;
      }, []),
      onClose: y.useCallback(() => {
        window.clearTimeout(u.current), u.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: o,
      onPointerInTransitChange: y.useCallback((c) => {
        o.current = c;
      }, []),
      disableHoverableContent: i,
      children: s
    }
  );
};
gb.displayName = pb;
var Rs = "Tooltip", [zS, qs] = Qo(Rs), bb = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: s,
    disableHoverableContent: a,
    delayDuration: o
  } = e, u = $l(Rs, e.__scopeTooltip), c = Xo(t), [l, d] = y.useState(null), h = ur(), m = y.useRef(0), E = a ?? u.disableHoverableContent, g = o ?? u.delayDuration, T = y.useRef(!1), [_, A] = Is({
    prop: r,
    defaultProp: i ?? !1,
    onChange: (B) => {
      B ? (u.onOpen(), document.dispatchEvent(new CustomEvent(Fc))) : u.onClose(), s?.(B);
    },
    caller: Rs
  }), w = y.useMemo(() => _ ? T.current ? "delayed-open" : "instant-open" : "closed", [_]), M = y.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, T.current = !1, A(!0);
  }, [A]), F = y.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, A(!1);
  }, [A]), k = y.useCallback(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      T.current = !0, A(!0), m.current = 0;
    }, g);
  }, [g, A]);
  return y.useEffect(() => () => {
    m.current && (window.clearTimeout(m.current), m.current = 0);
  }, []), /* @__PURE__ */ S.jsx(Bl, { ...c, children: /* @__PURE__ */ S.jsx(
    zS,
    {
      scope: t,
      contentId: h,
      open: _,
      stateAttribute: w,
      trigger: l,
      onTriggerChange: d,
      onTriggerEnter: y.useCallback(() => {
        u.isOpenDelayedRef.current ? k() : M();
      }, [u.isOpenDelayedRef, k, M]),
      onTriggerLeave: y.useCallback(() => {
        E ? F() : (window.clearTimeout(m.current), m.current = 0);
      }, [F, E]),
      onOpen: M,
      onClose: F,
      disableHoverableContent: E,
      children: n
    }
  ) });
};
bb.displayName = Rs;
var zc = "TooltipTrigger", Eb = y.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = qs(zc, n), s = $l(zc, n), a = Xo(n), o = y.useRef(null), u = et(t, o, i.onTriggerChange), c = y.useRef(!1), l = y.useRef(!1), d = y.useCallback(() => c.current = !1, []);
    return y.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ S.jsx($o, { asChild: !0, ...a, children: /* @__PURE__ */ S.jsx(
      tt.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: u,
        onPointerMove: Oe(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !l.current && !s.isPointerInTransitRef.current && (i.onTriggerEnter(), l.current = !0);
        }),
        onPointerLeave: Oe(e.onPointerLeave, () => {
          i.onTriggerLeave(), l.current = !1;
        }),
        onPointerDown: Oe(e.onPointerDown, () => {
          i.open && i.onClose(), c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: Oe(e.onFocus, () => {
          c.current || i.onOpen();
        }),
        onBlur: Oe(e.onBlur, i.onClose),
        onClick: Oe(e.onClick, i.onClose)
      }
    ) });
  }
);
Eb.displayName = zc;
var Yl = "TooltipPortal", [VS, WS] = Qo(Yl, {
  forceMount: void 0
}), _b = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, s = qs(Yl, t);
  return /* @__PURE__ */ S.jsx(VS, { scope: t, forceMount: n, children: /* @__PURE__ */ S.jsx(gr, { present: n || s.open, children: /* @__PURE__ */ S.jsx($s, { asChild: !0, container: i, children: r }) }) });
};
_b.displayName = Yl;
var wi = "TooltipContent", xb = y.forwardRef(
  (e, t) => {
    const n = WS(wi, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...s } = e, a = qs(wi, e.__scopeTooltip);
    return /* @__PURE__ */ S.jsx(gr, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ S.jsx(Tb, { side: i, ...s, ref: t }) : /* @__PURE__ */ S.jsx($S, { side: i, ...s, ref: t }) });
  }
), $S = y.forwardRef((e, t) => {
  const n = qs(wi, e.__scopeTooltip), r = $l(wi, e.__scopeTooltip), i = y.useRef(null), s = et(t, i), [a, o] = y.useState(null), { trigger: u, onClose: c } = n, l = i.current, { onPointerInTransitChange: d } = r, h = y.useCallback(() => {
    o(null), d(!1);
  }, [d]), m = y.useCallback(
    (E, g) => {
      const T = E.currentTarget, _ = { x: E.clientX, y: E.clientY }, A = KS(_, T.getBoundingClientRect()), w = QS(_, A), M = XS(g.getBoundingClientRect()), F = ZS([...w, ...M]);
      o(F), d(!0);
    },
    [d]
  );
  return y.useEffect(() => () => h(), [h]), y.useEffect(() => {
    if (u && l) {
      const E = (T) => m(T, l), g = (T) => m(T, u);
      return u.addEventListener("pointerleave", E), l.addEventListener("pointerleave", g), () => {
        u.removeEventListener("pointerleave", E), l.removeEventListener("pointerleave", g);
      };
    }
  }, [u, l, m, h]), y.useEffect(() => {
    if (a) {
      const E = (g) => {
        const T = g.target, _ = { x: g.clientX, y: g.clientY }, A = u?.contains(T) || l?.contains(T), w = !JS(_, a);
        A ? h() : w && (h(), c());
      };
      return document.addEventListener("pointermove", E), () => document.removeEventListener("pointermove", E);
    }
  }, [u, l, a, c, h]), /* @__PURE__ */ S.jsx(Tb, { ...e, ref: s });
}), [YS, GS] = Qo(Rs, { isInside: !1 }), qS = /* @__PURE__ */ BN("TooltipContent"), Tb = y.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      ...o
    } = e, u = qs(wi, n), c = Xo(n), { onClose: l } = u;
    return y.useEffect(() => (document.addEventListener(Fc, l), () => document.removeEventListener(Fc, l)), [l]), y.useEffect(() => {
      if (u.trigger) {
        const d = (h) => {
          h.target?.contains(u.trigger) && l();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [u.trigger, l]), /* @__PURE__ */ S.jsx(
      Ws,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: s,
        onPointerDownOutside: a,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: l,
        children: /* @__PURE__ */ S.jsxs(
          Fl,
          {
            "data-state": u.stateAttribute,
            ...c,
            ...o,
            ref: t,
            style: {
              ...o.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ S.jsx(qS, { children: r }),
              /* @__PURE__ */ S.jsx(YS, { scope: n, isInside: !0, children: /* @__PURE__ */ S.jsx(GN, { id: u.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
xb.displayName = wi;
var Ab = "TooltipArrow", yb = y.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = Xo(n);
    return GS(
      Ab,
      n
    ).isInside ? null : /* @__PURE__ */ S.jsx(zl, { ...i, ...r, ref: t });
  }
);
yb.displayName = Ab;
function KS(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), s = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, s)) {
    case s:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function QS(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function XS(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function JS(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let s = 0, a = t.length - 1; s < t.length; a = s++) {
    const o = t[s], u = t[a], c = o.x, l = o.y, d = u.x, h = u.y;
    l > r != h > r && n < (d - c) * (r - l) / (h - l) + c && (i = !i);
  }
  return i;
}
function ZS(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), ek(t);
}
function ek(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const s = t[t.length - 1], a = t[t.length - 2];
      if ((s.x - a.x) * (i.y - a.y) >= (s.y - a.y) * (i.x - a.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const s = n[n.length - 1], a = n[n.length - 2];
      if ((s.x - a.x) * (i.y - a.y) >= (s.y - a.y) * (i.x - a.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var tk = gb, nk = bb, rk = Eb, ik = _b, sk = xb, ak = yb;
const ok = () => {
  const { disabled: e, next: t } = uN();
  return e ? null : t;
}, uk = Qn("BranchPickerPrimitive.Next", ok), ck = () => {
  const { disabled: e, previous: t } = cN();
  return e ? null : t;
}, lk = Qn("BranchPickerPrimitive.Previous", ck), dk = () => oe((t) => t.message.branchCount), Nb = () => {
  const e = dk();
  return S.jsx(S.Fragment, { children: e });
};
Nb.displayName = "BranchPickerPrimitive.Count";
const fk = () => oe((t) => t.message.branchNumber), vb = () => {
  const e = fk();
  return S.jsx(S.Fragment, { children: e });
};
vb.displayName = "BranchPickerPrimitive.Number";
const hk = (e) => oe((t) => {
  const { role: n, attachments: r, parts: i, branchCount: s, isLast: a, speech: o, isCopied: u, isHovering: c } = t.message;
  return !(e.hasBranches === !0 && s < 2 || e.user && n !== "user" || e.assistant && n !== "assistant" || e.system && n !== "system" || e.lastOrHover === !0 && !c && !a || e.last !== void 0 && e.last !== a || e.copied === !0 && !u || e.copied === !1 && u || e.speaking === !0 && o == null || e.speaking === !1 && o != null || e.hasAttachments === !0 && (n !== "user" || !r?.length) || e.hasAttachments === !1 && n === "user" && r?.length || e.hasContent === !0 && i.length === 0 || e.hasContent === !1 && i.length > 0 || e.submittedFeedback !== void 0 && (t.message.metadata.submittedFeedback?.type ?? null) !== e.submittedFeedback);
}), dn = ({ children: e, ...t }) => hk(t) ? e : null;
dn.displayName = "MessagePrimitive.If";
const wb = ut(({ hideWhenSingleBranch: e, ...t }, n) => S.jsx(dn, { hasBranches: e ? !0 : void 0, children: S.jsx(Wt.div, { ...t, ref: n }) }));
wb.displayName = "BranchPickerPrimitive.Root";
const Cb = () => {
  const { disabled: e, send: t } = nN(), n = de(() => t(), [t]);
  return e ? null : n;
}, Sb = Qn("ComposerPrimitive.Send", Cb), Gl = ut(({ onSubmit: e, ...t }, n) => {
  const r = Cb(), i = (s) => {
    s.preventDefault(), r && r();
  };
  return S.jsx(Wt.form, { ...t, ref: n, onSubmit: Oe(e, i) });
});
Gl.displayName = "ComposerPrimitive.Root";
function Vc() {
  return Vc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vc.apply(null, arguments);
}
function mk(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
var pk = xi, gk = function(t) {
  var n = ct.useRef(t);
  return pk(function() {
    n.current = t;
  }), n;
}, ah = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, bk = function(t, n) {
  var r = ct.useRef();
  return ct.useCallback(function(i) {
    t.current = i, r.current && ah(r.current, null), r.current = n, n && ah(n, i);
  }, [n]);
}, oh = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, Ek = function(t) {
  Object.keys(oh).forEach(function(n) {
    t.style.setProperty(n, oh[n], "important");
  });
}, uh = Ek, Ht = null, ch = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function _k(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), Ht || (Ht = document.createElement("textarea"), Ht.setAttribute("tabindex", "-1"), Ht.setAttribute("aria-hidden", "true"), uh(Ht)), Ht.parentNode === null && document.body.appendChild(Ht);
  var i = e.paddingSize, s = e.borderSize, a = e.sizingStyle, o = a.boxSizing;
  Object.keys(a).forEach(function(h) {
    var m = h;
    Ht.style[m] = a[m];
  }), uh(Ht), Ht.value = t;
  var u = ch(Ht, e);
  Ht.value = t, u = ch(Ht, e), Ht.value = "x";
  var c = Ht.scrollHeight - i, l = c * n;
  o === "border-box" && (l = l + i + s), u = Math.max(l, u);
  var d = c * r;
  return o === "border-box" && (d = d + i + s), u = Math.min(d, u), [u, c];
}
var lh = function() {
}, xk = function(t, n) {
  return t.reduce(function(r, i) {
    return r[i] = n[i], r;
  }, {});
}, Tk = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], Ak = !!document.documentElement.currentStyle, yk = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = xk(Tk, n), i = r.boxSizing;
  if (i === "")
    return null;
  Ak && i === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var s = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), a = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: s,
    borderSize: a
  };
}, Nk = yk;
function ql(e, t, n) {
  var r = gk(n);
  y.useLayoutEffect(function() {
    var i = function(a) {
      return r.current(a);
    };
    if (e)
      return e.addEventListener(t, i), function() {
        return e.removeEventListener(t, i);
      };
  }, []);
}
var vk = function(t, n) {
  ql(document.body, "reset", function(r) {
    t.current.form === r.target && n(r);
  });
}, wk = function(t) {
  ql(window, "resize", t);
}, Ck = function(t) {
  ql(document.fonts, "loadingdone", t);
}, Sk = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], kk = function(t, n) {
  var r = t.cacheMeasurements, i = t.maxRows, s = t.minRows, a = t.onChange, o = a === void 0 ? lh : a, u = t.onHeightChange, c = u === void 0 ? lh : u, l = mk(t, Sk);
  if (l.style) {
    if ("maxHeight" in l.style)
      throw new Error("Using `style.maxHeight` for <TextareaAutosize/> is not supported. Please use `maxRows`.");
    if ("minHeight" in l.style)
      throw new Error("Using `style.minHeight` for <TextareaAutosize/> is not supported. Please use `minRows`.");
  }
  var d = l.value !== void 0, h = y.useRef(null), m = bk(h, n), E = y.useRef(0), g = y.useRef(), T = function() {
    var w = h.current, M = r && g.current ? g.current : Nk(w);
    if (M) {
      g.current = M;
      var F = _k(M, w.value || w.placeholder || "x", s, i), k = F[0], B = F[1];
      E.current !== k && (E.current = k, w.style.setProperty("height", k + "px", "important"), c(k, {
        rowHeight: B
      }));
    }
  }, _ = function(w) {
    d || T(), o(w);
  };
  return y.useLayoutEffect(T), vk(h, function() {
    if (!d) {
      var A = h.current.value;
      requestAnimationFrame(function() {
        var w = h.current;
        w && A !== w.value && T();
      });
    }
  }), wk(T), Ck(T), /* @__PURE__ */ y.createElement("textarea", Vc({}, l, {
    onChange: _,
    ref: m
  }));
}, Ik = /* @__PURE__ */ y.forwardRef(kk);
const kb = (e) => {
  const t = Zt(e), n = Ss((r) => r.onScrollToBottom);
  Le(() => n(t), [n, t]);
}, Dk = Ot(null), Rk = () => Ct(Dk), Pk = Ot(null), Ok = () => Ct(Pk), Kl = ut(({ autoFocus: e = !1, asChild: t, disabled: n, onChange: r, onKeyDown: i, onPaste: s, onSelect: a, submitOnEnter: o, submitMode: u, cancelOnEscape: c = !0, unstable_focusOnRunStart: l = !0, unstable_focusOnScrollToBottom: d = !0, unstable_focusOnThreadSwitched: h = !0, addAttachmentOnPaste: m = !0, ...E }, g) => {
  const T = Ve(), _ = Rk(), A = Ok(), w = u ?? (o === !1 ? "none" : "enter"), M = oe((j) => j.composer.isEditing ? j.composer.text : ""), F = t ? Mg : Ik, k = oe((j) => j.thread.isDisabled || j.composer.dictation?.inputDisabled) || n, B = st(null), $ = et(g, B);
  Pg((j) => {
    if (!B.current?.contains(j.target))
      return;
    if (_?.open) {
      _.handleKeyDown(j);
      return;
    }
    if (!c)
      return;
    const H = T.composer();
    H.getState().canCancel && (H.cancel(), j.preventDefault());
  });
  const J = (j) => {
    if (!k && !j.nativeEvent.isComposing && !_?.handleKeyDown(j) && j.key === "Enter") {
      const H = T.thread().getState(), z = H.capabilities.queue;
      if (j.shiftKey && (j.ctrlKey || j.metaKey) && z && w !== "none" && !T.composer().getState().isEmpty) {
        j.preventDefault(), T.composer().send({ steer: !0 });
        return;
      }
      if (j.shiftKey || H.isRunning && !z)
        return;
      let W = !1;
      w === "ctrlEnter" ? W = j.ctrlKey || j.metaKey : w === "enter" && (W = !0), W && (j.preventDefault(), B.current?.closest("form")?.requestSubmit());
    }
  }, U = async (j) => {
    if (!m)
      return;
    const H = T.thread().getState().capabilities, z = Array.from(j.clipboardData?.files || []);
    if (H.attachments && z.length > 0)
      try {
        j.preventDefault(), await Promise.all(z.map((W) => T.composer().addAttachment(W)));
      } catch (W) {
        console.error("Error adding attachment:", W);
      }
  }, re = e && !k, ae = de(() => {
    const j = B.current;
    !j || !re || (j.focus({ preventScroll: !0 }), j.setSelectionRange(j.value.length, j.value.length));
  }, [re]);
  return Le(() => ae(), [ae]), kb(() => {
    T.composer().getState().type === "thread" && d && ae();
  }), Le(() => {
    if (!(T.composer().getState().type !== "thread" || !l))
      return T.on("thread.runStart", ae);
  }, [l, ae, T]), Le(() => {
    if (!(T.composer().getState().type !== "thread" || !h))
      return T.on("threadListItem.switchedTo", ae);
  }, [h, ae, T]), S.jsx(F, { name: "input", value: M, ...E, ref: $, disabled: k, onChange: Oe(r, (j) => {
    T.composer().getState().isEditing && (M1(() => {
      T.composer().setText(j.target.value);
    }), A?.setCursorPosition(j.target.selectionStart ?? j.target.value.length));
  }), onKeyDown: Oe(i, J), onSelect: Oe(a, (j) => {
    const H = j.target;
    A?.setCursorPosition(H.selectionStart ?? H.value.length);
  }), onPaste: Oe(s, U) });
});
Kl.displayName = "ComposerPrimitive.Input";
const Lk = () => {
  const { disabled: e, cancel: t } = rN();
  return e ? null : t;
}, Ib = Qn("ComposerPrimitive.Cancel", Lk), Db = () => oe((t) => {
  if (t.part.type !== "text" && t.part.type !== "reasoning")
    throw new Error("MessagePartText can only be used inside text or reasoning message parts.");
  return t.part;
}), Rb = Ot(null), Mk = (e) => ({ useSmoothStatus: yi(() => e) }), Uk = ({ children: e }) => {
  const t = Pb({ optional: !0 }), n = Ve(), [r] = we(() => Mk(n.part().getState().status));
  return t ? e : S.jsx(Rb.Provider, { value: r, children: e });
}, Hk = (e) => {
  const t = ut((n, r) => S.jsx(Uk, { children: S.jsx(e, { ...n, ref: r }) }));
  return t.displayName = e.displayName, t;
};
function Pb(e) {
  const t = Ct(Rb);
  if (!e?.optional && !t)
    throw new Error("This component must be used within a SmoothContextProvider.");
  return t;
}
const { useSmoothStatus: jk, useSmoothStatusStore: Bk } = Cg(Pb, "useSmoothStatus");
class Fk {
  constructor(t, n) {
    O(this, "currentText");
    O(this, "setText");
    O(this, "animationFrameId", null);
    O(this, "lastUpdateTime", Date.now());
    O(this, "targetText", "");
    O(this, "animate", () => {
      const t = Date.now();
      let r = t - this.lastUpdateTime;
      const i = this.targetText.length - this.currentText.length, s = Math.min(5, 250 / i);
      let a = 0;
      for (; r >= s && a < i; )
        a++, r -= s;
      a !== i ? this.animationFrameId = requestAnimationFrame(this.animate) : this.animationFrameId = null, a !== 0 && (this.currentText = this.targetText.slice(0, this.currentText.length + a), this.lastUpdateTime = t - r, this.setText(this.currentText));
    });
    this.currentText = t, this.setText = n;
  }
  start() {
    this.animationFrameId === null && (this.lastUpdateTime = Date.now(), this.animate());
  }
  stop() {
    this.animationFrameId !== null && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null);
  }
}
const ju = Object.freeze({
  type: "running"
}), Ob = (e, t = !1) => {
  const { text: n } = e, r = oe((l) => l.message.id), i = st(r), [s, a] = we(e.status.type === "running" ? "" : n), o = Bk({ optional: !0 }), u = Zt((l) => {
    if (a(l), o) {
      const d = s !== l || e.status.type === "running" ? ju : e.status;
      ks(o).setState(d, !0);
    }
  });
  Le(() => {
    if (o) {
      const l = t && (s !== n || e.status.type === "running") ? ju : e.status;
      ks(o).setState(l, !0);
    }
  }, [o, t, n, s, e.status]);
  const [c] = we(new Fk(s, u));
  return Le(() => {
    if (!t) {
      c.stop();
      return;
    }
    if (i.current !== r || !n.startsWith(c.targetText)) {
      i.current = r, e.status.type === "running" ? (u(""), c.currentText = "", c.targetText = n, c.start()) : (u(n), c.currentText = n, c.targetText = n, c.stop());
      return;
    }
    c.targetText = n, c.start();
  }, [u, c, r, t, n, e.status.type]), Le(() => () => {
    c.stop();
  }, [c]), pe(() => t ? {
    type: "text",
    text: s,
    status: n === s ? e.status : ju
  } : e, [t, s, e, n]);
}, Lb = ut(({ smooth: e = !0, component: t = "span", ...n }, r) => {
  const { text: i, status: s } = Ob(Db(), e);
  return S.jsx(t, { "data-status": s.type, ...n, ref: r, children: i });
});
Lb.displayName = "MessagePartPrimitive.Text";
const zk = () => oe((t) => {
  if (t.part.type !== "image")
    throw new Error("MessagePartImage can only be used inside image message parts.");
  return t.part;
}), Mb = ut((e, t) => {
  const { image: n } = zk();
  return S.jsx(Wt.img, { src: n, ...e, ref: t });
});
Mb.displayName = "MessagePartPrimitive.Image";
const Ub = ({ children: e }) => oe((n) => n.part.status.type === "running") ? e : null;
Ub.displayName = "MessagePartPrimitive.InProgress";
const Ks = (e) => {
  const t = st(void 0);
  return de((r) => {
    t.current && t.current(), r && (t.current = e(r));
  }, [e]);
}, Hb = (e, t) => {
  const n = de((r) => {
    if (!e)
      return;
    const i = e(), s = () => {
      const o = t ? t(r) : r.offsetHeight;
      i.setHeight(o);
    }, a = new ResizeObserver(s);
    return a.observe(r), s(), () => {
      a.disconnect(), i.unregister();
    };
  }, [e, t]);
  return Ks(n);
}, dh = Ot(!1), fh = (e, t) => {
  const n = e.match(/^([\d.]+)(em|px|rem)$/);
  if (!n)
    return 0;
  const r = parseFloat(n[1]), i = n[2];
  if (i === "px")
    return r;
  if (i === "em") {
    const s = parseFloat(getComputedStyle(t).fontSize) || 16;
    return r * s;
  }
  if (i === "rem") {
    const s = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return r * s;
  }
  return 0;
}, jb = ({ children: e, fillClampThreshold: t = "10em", fillClampOffset: n = "6em" }) => {
  const r = oe(
    // only add slack to the last assistant message following a user message (valid turn)
    (u) => u.message.isLast && u.message.role === "assistant" && u.message.index >= 1 && u.thread.messages.at(u.message.index - 1)?.role === "user"
  ), i = Lo({ optional: !0 }), s = Ct(dh), a = de((u) => {
    if (!i || s)
      return;
    const c = () => {
      const l = i.getState();
      if (l.turnAnchor === "top" && r) {
        const { viewport: d, inset: h, userMessage: m } = l.height, E = fh(t, u), g = fh(n, u), T = m <= E ? m : g, _ = Math.max(0, d - h - T);
        u.style.minHeight = `${_}px`, u.style.flexShrink = "0", u.style.transition = "min-height 0s";
      } else
        u.style.minHeight = "", u.style.flexShrink = "", u.style.transition = "";
    };
    return c(), i.subscribe(c);
  }, [
    i,
    r,
    s,
    t,
    n
  ]), o = Ks(a);
  return S.jsx(dh.Provider, { value: !0, children: S.jsx(Mg, { ref: o, children: e }) });
};
jb.displayName = "ThreadPrimitive.ViewportSlack";
const Vk = () => {
  const e = Ve(), t = oe(() => e.message()), n = de((r) => {
    const i = () => {
      t.setIsHovering(!0);
    }, s = () => {
      t.setIsHovering(!1);
    };
    return r.addEventListener("mouseenter", i), r.addEventListener("mouseleave", s), r.matches(":hover") && queueMicrotask(() => t.setIsHovering(!0)), () => {
      r.removeEventListener("mouseenter", i), r.removeEventListener("mouseleave", s), t.setIsHovering(!1);
    };
  }, [t]);
  return Ks(n);
}, Wk = () => {
  const e = Ss((i) => i.turnAnchor), t = Ss((i) => i.registerUserMessageHeight), n = oe((i) => e === "top" && i.message.role === "user" && i.message.index === i.thread.messages.length - 2 && i.thread.messages.at(-1)?.role === "assistant"), r = de((i) => i.offsetHeight, []);
  return Hb(n ? t : null, r);
}, Jo = ut((e, t) => {
  const n = Vk(), r = Wk(), i = et(t, n, r), s = oe((a) => a.message.id);
  return S.jsx(jb, { children: S.jsx(Wt.div, { ...e, ref: i, "data-message-id": s }) });
});
Jo.displayName = "MessagePrimitive.Root";
const Bu = {
  ...Dt,
  Text: () => S.jsxs("p", { style: { whiteSpace: "pre-line" }, children: [S.jsx(Lb, {}), S.jsx(Ub, { children: S.jsx("span", { style: { fontFamily: "revert" }, children: " ●" }) })] }),
  Image: () => S.jsx(Mb, {})
}, Zo = (e) => {
  if ("children" in e)
    return S.jsx(kc, { children: e.children });
  const { components: t, ...n } = e, r = t ? {
    Text: t.Text ?? Bu.Text,
    Image: t.Image ?? Bu.Image,
    Reasoning: t.Reasoning ?? Dt.Reasoning,
    Source: t.Source ?? Dt.Source,
    File: t.File ?? Dt.File,
    Unstable_Audio: t.Unstable_Audio ?? Dt.Unstable_Audio,
    ..."ChainOfThought" in t ? { ChainOfThought: t.ChainOfThought } : {
      tools: t.tools,
      data: t.data,
      ToolGroup: t.ToolGroup ?? Dt.ToolGroup,
      ReasoningGroup: t.ReasoningGroup ?? Dt.ReasoningGroup
    },
    Empty: t.Empty,
    Quote: t.Quote
  } : Bu;
  return S.jsx(kc, { components: r, ...n });
};
Zo.displayName = "MessagePrimitive.Parts";
const Ql = ({ children: e }) => hN() !== void 0 ? e : null;
Ql.displayName = "MessagePrimitive.Error";
const Xl = ut((e, t) => S.jsx(Wt.div, { ...e, ref: t }));
Xl.displayName = "ThreadPrimitive.Root";
const Bb = ({ children: e }) => oe((n) => n.thread.isEmpty) ? e : null;
Bb.displayName = "ThreadPrimitive.Empty";
const $k = (e) => oe((t) => !(e.empty === !0 && !t.thread.isEmpty || e.empty === !1 && t.thread.isEmpty || e.running === !0 && !t.thread.isRunning || e.running === !1 && t.thread.isRunning || e.disabled === !0 && !t.thread.isDisabled || e.disabled === !1 && t.thread.isDisabled)), Ps = ({ children: e, ...t }) => $k(t) ? e : null;
Ps.displayName = "ThreadPrimitive.If";
const Yk = (e) => {
  const t = Zt(e), n = de((r) => {
    const i = new ResizeObserver(() => {
      t();
    }), s = new MutationObserver((a) => {
      a.some((u) => u.type !== "attributes" || u.attributeName !== "style") && t();
    });
    return i.observe(r), s.observe(r, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      characterData: !0
    }), () => {
      i.disconnect(), s.disconnect();
    };
  }, [t]);
  return Ks(n);
}, Gk = ({ autoScroll: e, scrollToBottomOnRunStart: t = !0, scrollToBottomOnInitialize: n = !0, scrollToBottomOnThreadSwitch: r = !0 }) => {
  const i = st(null), s = Lo();
  e === void 0 && (e = s.getState().turnAnchor !== "top");
  const a = st(0), o = st(null), u = de((m) => {
    const E = i.current;
    E && (o.current = m, E.scrollTo({ top: E.scrollHeight, behavior: m }));
  }, []), c = () => {
    const m = i.current;
    if (!m)
      return;
    const E = s.getState().isAtBottom, g = Math.abs(m.scrollHeight - m.scrollTop - m.clientHeight) < 1 || m.scrollHeight <= m.clientHeight;
    !g && a.current < m.scrollTop || (g && (o.current = null), (g || o.current === null) && g !== E && ks(s).setState({
      isAtBottom: g
    })), a.current = m.scrollTop;
  }, l = Yk(() => {
    const m = o.current;
    m ? u(m) : e && s.getState().isAtBottom && u("instant"), c();
  }), d = Ks((m) => (m.addEventListener("scroll", c), () => {
    m.removeEventListener("scroll", c);
  }));
  return kb(({ behavior: m }) => {
    u(m);
  }), xu("thread.runStart", () => {
    t && (o.current = "auto", requestAnimationFrame(() => {
      u("auto");
    }));
  }), xu("thread.initialize", () => {
    n && (o.current = "instant", requestAnimationFrame(() => {
      u("instant");
    }));
  }), xu("threadListItem.switchedTo", () => {
    r && (o.current = "instant", requestAnimationFrame(() => {
      u("instant");
    }));
  }), et(l, d, i);
}, qk = () => {
  const e = Ss((n) => n.registerViewport), t = de((n) => n.clientHeight, []);
  return Hb(e, t);
}, Fb = ut(({ autoScroll: e, scrollToBottomOnRunStart: t, scrollToBottomOnInitialize: n, scrollToBottomOnThreadSwitch: r, children: i, ...s }, a) => {
  const o = Gk({
    autoScroll: e,
    scrollToBottomOnRunStart: t,
    scrollToBottomOnInitialize: n,
    scrollToBottomOnThreadSwitch: r
  }), u = qk(), c = et(a, o, u);
  return S.jsx(Wt.div, { ...s, ref: c, children: i });
});
Fb.displayName = "ThreadPrimitive.ViewportScrollable";
const Jl = ut(({ turnAnchor: e, ...t }, n) => S.jsx(kg, { options: { turnAnchor: e }, children: S.jsx(Fb, { ...t, ref: n }) }));
Jl.displayName = "ThreadPrimitive.Viewport";
const Kk = ({ behavior: e } = {}) => {
  const t = Ss((i) => i.isAtBottom), n = Lo(), r = de(() => {
    n.getState().scrollToBottom({ behavior: e });
  }, [n, e]);
  return t ? null : r;
}, zb = Qn("ThreadPrimitive.ScrollToBottom", Kk, ["behavior"]), Qk = ({ prompt: e, send: t, clearComposer: n, autoSend: r, method: i }) => {
  const s = t ?? r ?? !1, { disabled: a, trigger: o } = lN({
    prompt: e,
    send: s,
    clearComposer: n
  });
  return a ? null : o;
}, Xk = Qn("ThreadPrimitive.Suggestion", Qk, ["prompt", "send", "clearComposer", "autoSend", "method"]), Vb = ut(({ onClick: e, disabled: t, ...n }, r) => {
  const i = oe((a) => a.threads.newThreadId === a.threads.mainThreadId), { switchToNewThread: s } = fN();
  return S.jsx(Wt.button, { type: "button", ...i ? { "data-active": "true", "aria-current": "true" } : null, ...n, ref: r, disabled: t, onClick: Oe(e, s) });
});
Vb.displayName = "ThreadListPrimitive.New";
const Wb = ut((e, t) => S.jsx(Wt.div, { ...e, ref: t }));
Wb.displayName = "ThreadListPrimitive.Root";
const $b = ut((e, t) => {
  const n = oe((r) => r.threads.mainThreadId === r.threadListItem.id);
  return S.jsx(Wt.div, { ...n ? { "data-active": "true", "aria-current": "true" } : null, ...e, ref: t });
});
$b.displayName = "ThreadListItemPrimitive.Root";
const Jk = () => {
  const { switchTo: e } = dN();
  return e;
}, Zk = Qn("ThreadListItemPrimitive.Trigger", Jk), e2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AssistantRuntimeImpl: yl,
  BaseAssistantRuntimeCore: Tl,
  CompositeContextProvider: El,
  DefaultThreadComposerRuntimeCore: rg,
  MessageRepository: tg,
  ThreadRuntimeImpl: cg,
  fromThreadMessageLike: Vs,
  generateId: dr,
  getAutoStatus: eg,
  useSmooth: Ob,
  useSmoothStatus: jk,
  withSmoothContextProvider: Hk
}, Symbol.toStringTag, { value: "Module" }));
const t2 = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), n2 = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), hh = (e) => {
  const t = n2(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Yb = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), r2 = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
var i2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const s2 = ut(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: s,
    iconNode: a,
    ...o
  }, u) => xc(
    "svg",
    {
      ref: u,
      ...i2,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Yb("lucide", i),
      ...!s && !r2(o) && { "aria-hidden": "true" },
      ...o
    },
    [
      ...a.map(([c, l]) => xc(c, l)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
const pt = (e, t) => {
  const n = ut(
    ({ className: r, ...i }, s) => xc(s2, {
      ref: s,
      iconNode: t,
      className: Yb(
        `lucide-${t2(hh(e))}`,
        `lucide-${e}`,
        r
      ),
      ...i
    })
  );
  return n.displayName = hh(e), n;
};
const a2 = [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
], o2 = pt("align-justify", a2);
const u2 = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], Gb = pt("arrow-down", u2);
const c2 = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], eu = pt("check", c2);
const l2 = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], qb = pt("chevron-down", l2);
const d2 = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], Kb = pt("chevron-left", d2);
const f2 = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], h2 = pt("chevron-right", f2);
const m2 = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], p2 = pt("chevron-up", m2);
const g2 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], mh = pt("circle-check", g2);
const b2 = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Zl = pt("copy", b2);
const E2 = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], _2 = pt("ellipsis-vertical", E2);
const x2 = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], T2 = pt("external-link", x2);
const A2 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], y2 = pt("globe", A2);
const N2 = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], v2 = pt("link-2", N2);
const w2 = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], C2 = pt("maximize-2", w2);
const S2 = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], k2 = pt("plus", S2);
const I2 = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], Qb = pt("refresh-cw", I2);
const D2 = [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
], R2 = pt("send", D2);
const P2 = [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
], O2 = pt("thumbs-down", P2);
const L2 = [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
], M2 = pt("thumbs-up", L2);
const U2 = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Xb = pt("x", U2), H2 = ({
  isOpen: e,
  isDeleting: t,
  onCancel: n,
  onConfirm: r
}) => {
  const i = de(
    (o) => {
      o.stopPropagation(), n();
    },
    [n]
  ), s = de(
    (o) => {
      o.stopPropagation(), r();
    },
    [r]
  ), a = de((o) => {
    o.stopPropagation();
  }, []);
  return {
    isOpen: e,
    isDeleting: t,
    onOverlayClick: t ? void 0 : i,
    onContentClick: a,
    onCancelClick: i,
    onConfirmClick: s
  };
};
function Jb(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = Jb(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Zb() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Jb(e)) && (r && (r += " "), r += t);
  return r;
}
const ph = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, gh = Zb, j2 = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return gh(e, n?.class, n?.className);
  const { variants: i, defaultVariants: s } = t, a = Object.keys(i).map((c) => {
    const l = n?.[c], d = s?.[c];
    if (l === null) return null;
    const h = ph(l) || ph(d);
    return i[c][h];
  }), o = n && Object.entries(n).reduce((c, l) => {
    let [d, h] = l;
    return h === void 0 || (c[d] = h), c;
  }, {}), u = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, l) => {
    let { class: d, className: h, ...m } = l;
    return Object.entries(m).every((E) => {
      let [g, T] = E;
      return Array.isArray(T) ? T.includes({
        ...s,
        ...o
      }[g]) : {
        ...s,
        ...o
      }[g] === T;
    }) ? [
      ...c,
      d,
      h
    ] : c;
  }, []);
  return gh(e, a, u, n?.class, n?.className);
}, B2 = (e, t) => {
  const n = new Array(e.length + t.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e[r];
  for (let r = 0; r < t.length; r++)
    n[e.length + r] = t[r];
  return n;
}, F2 = (e, t) => ({
  classGroupId: e,
  validator: t
}), eE = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
}), ho = "-", bh = [], z2 = "arbitrary..", V2 = (e) => {
  const t = $2(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      if (a.startsWith("[") && a.endsWith("]"))
        return W2(a);
      const o = a.split(ho), u = o[0] === "" && o.length > 1 ? 1 : 0;
      return tE(o, u, t);
    },
    getConflictingClassGroupIds: (a, o) => {
      if (o) {
        const u = r[a], c = n[a];
        return u ? c ? B2(c, u) : u : c || bh;
      }
      return n[a] || bh;
    }
  };
}, tE = (e, t, n) => {
  if (e.length - t === 0)
    return n.classGroupId;
  const i = e[t], s = n.nextPart.get(i);
  if (s) {
    const c = tE(e, t + 1, s);
    if (c) return c;
  }
  const a = n.validators;
  if (a === null)
    return;
  const o = t === 0 ? e.join(ho) : e.slice(t).join(ho), u = a.length;
  for (let c = 0; c < u; c++) {
    const l = a[c];
    if (l.validator(o))
      return l.classGroupId;
  }
}, W2 = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
  return r ? z2 + r : void 0;
})(), $2 = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e;
  return Y2(n, t);
}, Y2 = (e, t) => {
  const n = eE();
  for (const r in e) {
    const i = e[r];
    ed(i, n, r, t);
  }
  return n;
}, ed = (e, t, n, r) => {
  const i = e.length;
  for (let s = 0; s < i; s++) {
    const a = e[s];
    G2(a, t, n, r);
  }
}, G2 = (e, t, n, r) => {
  if (typeof e == "string") {
    q2(e, t, n);
    return;
  }
  if (typeof e == "function") {
    K2(e, t, n, r);
    return;
  }
  Q2(e, t, n, r);
}, q2 = (e, t, n) => {
  const r = e === "" ? t : nE(t, e);
  r.classGroupId = n;
}, K2 = (e, t, n, r) => {
  if (X2(e)) {
    ed(e(r), t, n, r);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(F2(n, e));
}, Q2 = (e, t, n, r) => {
  const i = Object.entries(e), s = i.length;
  for (let a = 0; a < s; a++) {
    const [o, u] = i[a];
    ed(u, nE(t, o), n, r);
  }
}, nE = (e, t) => {
  let n = e;
  const r = t.split(ho), i = r.length;
  for (let s = 0; s < i; s++) {
    const a = r[s];
    let o = n.nextPart.get(a);
    o || (o = eE(), n.nextPart.set(a, o)), n = o;
  }
  return n;
}, X2 = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, J2 = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const i = (s, a) => {
    n[s] = a, t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(s) {
      let a = n[s];
      if (a !== void 0)
        return a;
      if ((a = r[s]) !== void 0)
        return i(s, a), a;
    },
    set(s, a) {
      s in n ? n[s] = a : i(s, a);
    }
  };
}, Wc = "!", Eh = ":", Z2 = [], _h = (e, t, n, r, i) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: r,
  isExternal: i
}), eI = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (i) => {
    const s = [];
    let a = 0, o = 0, u = 0, c;
    const l = i.length;
    for (let g = 0; g < l; g++) {
      const T = i[g];
      if (a === 0 && o === 0) {
        if (T === Eh) {
          s.push(i.slice(u, g)), u = g + 1;
          continue;
        }
        if (T === "/") {
          c = g;
          continue;
        }
      }
      T === "[" ? a++ : T === "]" ? a-- : T === "(" ? o++ : T === ")" && o--;
    }
    const d = s.length === 0 ? i : i.slice(u);
    let h = d, m = !1;
    d.endsWith(Wc) ? (h = d.slice(0, -1), m = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      d.startsWith(Wc) && (h = d.slice(1), m = !0)
    );
    const E = c && c > u ? c - u : void 0;
    return _h(s, m, h, E);
  };
  if (t) {
    const i = t + Eh, s = r;
    r = (a) => a.startsWith(i) ? s(a.slice(i.length)) : _h(Z2, !1, a, void 0, !0);
  }
  if (n) {
    const i = r;
    r = (s) => n({
      className: s,
      parseClassName: i
    });
  }
  return r;
}, tI = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((n, r) => {
    t.set(n, 1e6 + r);
  }), (n) => {
    const r = [];
    let i = [];
    for (let s = 0; s < n.length; s++) {
      const a = n[s], o = a[0] === "[", u = t.has(a);
      o || u ? (i.length > 0 && (i.sort(), r.push(...i), i = []), r.push(a)) : i.push(a);
    }
    return i.length > 0 && (i.sort(), r.push(...i)), r;
  };
}, nI = (e) => ({
  cache: J2(e.cacheSize),
  parseClassName: eI(e),
  sortModifiers: tI(e),
  ...V2(e)
}), rI = /\s+/, iI = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i,
    sortModifiers: s
  } = t, a = [], o = e.trim().split(rI);
  let u = "";
  for (let c = o.length - 1; c >= 0; c -= 1) {
    const l = o[c], {
      isExternal: d,
      modifiers: h,
      hasImportantModifier: m,
      baseClassName: E,
      maybePostfixModifierPosition: g
    } = n(l);
    if (d) {
      u = l + (u.length > 0 ? " " + u : u);
      continue;
    }
    let T = !!g, _ = r(T ? E.substring(0, g) : E);
    if (!_) {
      if (!T) {
        u = l + (u.length > 0 ? " " + u : u);
        continue;
      }
      if (_ = r(E), !_) {
        u = l + (u.length > 0 ? " " + u : u);
        continue;
      }
      T = !1;
    }
    const A = h.length === 0 ? "" : h.length === 1 ? h[0] : s(h).join(":"), w = m ? A + Wc : A, M = w + _;
    if (a.indexOf(M) > -1)
      continue;
    a.push(M);
    const F = i(_, T);
    for (let k = 0; k < F.length; ++k) {
      const B = F[k];
      a.push(w + B);
    }
    u = l + (u.length > 0 ? " " + u : u);
  }
  return u;
}, sI = (...e) => {
  let t = 0, n, r, i = "";
  for (; t < e.length; )
    (n = e[t++]) && (r = rE(n)) && (i && (i += " "), i += r);
  return i;
}, rE = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = rE(e[r])) && (n && (n += " "), n += t);
  return n;
}, aI = (e, ...t) => {
  let n, r, i, s;
  const a = (u) => {
    const c = t.reduce((l, d) => d(l), e());
    return n = nI(c), r = n.cache.get, i = n.cache.set, s = o, o(u);
  }, o = (u) => {
    const c = r(u);
    if (c)
      return c;
    const l = iI(u, n);
    return i(u, l), l;
  };
  return s = a, (...u) => s(sI(...u));
}, oI = [], gt = (e) => {
  const t = (n) => n[e] || oI;
  return t.isThemeGetter = !0, t;
}, iE = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, sE = /^\((?:(\w[\w-]*):)?(.+)\)$/i, uI = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, cI = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, lI = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, dI = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, fI = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, hI = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Jn = (e) => uI.test(e), Be = (e) => !!e && !Number.isNaN(Number(e)), Zn = (e) => !!e && Number.isInteger(Number(e)), Fu = (e) => e.endsWith("%") && Be(e.slice(0, -1)), Bn = (e) => cI.test(e), aE = () => !0, mI = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lI.test(e) && !dI.test(e)
), td = () => !1, pI = (e) => fI.test(e), gI = (e) => hI.test(e), bI = (e) => !Ee(e) && !xe(e), EI = (e) => xr(e, cE, td), Ee = (e) => iE.test(e), Sr = (e) => xr(e, lE, mI), xh = (e) => xr(e, wI, Be), _I = (e) => xr(e, fE, aE), xI = (e) => xr(e, dE, td), Th = (e) => xr(e, oE, td), TI = (e) => xr(e, uE, gI), Na = (e) => xr(e, hE, pI), xe = (e) => sE.test(e), ts = (e) => Qr(e, lE), AI = (e) => Qr(e, dE), Ah = (e) => Qr(e, oE), yI = (e) => Qr(e, cE), NI = (e) => Qr(e, uE), va = (e) => Qr(e, hE, !0), vI = (e) => Qr(e, fE, !0), xr = (e, t, n) => {
  const r = iE.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Qr = (e, t, n = !1) => {
  const r = sE.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, oE = (e) => e === "position" || e === "percentage", uE = (e) => e === "image" || e === "url", cE = (e) => e === "length" || e === "size" || e === "bg-size", lE = (e) => e === "length", wI = (e) => e === "number", dE = (e) => e === "family-name", fE = (e) => e === "number" || e === "weight", hE = (e) => e === "shadow", CI = () => {
  const e = gt("color"), t = gt("font"), n = gt("text"), r = gt("font-weight"), i = gt("tracking"), s = gt("leading"), a = gt("breakpoint"), o = gt("container"), u = gt("spacing"), c = gt("radius"), l = gt("shadow"), d = gt("inset-shadow"), h = gt("text-shadow"), m = gt("drop-shadow"), E = gt("blur"), g = gt("perspective"), T = gt("aspect"), _ = gt("ease"), A = gt("animate"), w = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], M = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], F = () => [...M(), xe, Ee], k = () => ["auto", "hidden", "clip", "visible", "scroll"], B = () => ["auto", "contain", "none"], $ = () => [xe, Ee, u], J = () => [Jn, "full", "auto", ...$()], U = () => [Zn, "none", "subgrid", xe, Ee], re = () => ["auto", {
    span: ["full", Zn, xe, Ee]
  }, Zn, xe, Ee], ae = () => [Zn, "auto", xe, Ee], j = () => ["auto", "min", "max", "fr", xe, Ee], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], z = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], W = () => ["auto", ...$()], X = () => [Jn, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...$()], G = () => [Jn, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...$()], se = () => [Jn, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...$()], N = () => [e, xe, Ee], ye = () => [...M(), Ah, Th, {
    position: [xe, Ee]
  }], Re = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], D = () => ["auto", "cover", "contain", yI, EI, {
    size: [xe, Ee]
  }], Ie = () => [Fu, ts, Sr], De = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    xe,
    Ee
  ], He = () => ["", Be, ts, Sr], fe = () => ["solid", "dashed", "dotted", "double"], Te = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Ne = () => [Be, Fu, Ah, Th], _e = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    E,
    xe,
    Ee
  ], Se = () => ["none", Be, xe, Ee], Me = () => ["none", Be, xe, Ee], Ze = () => [Be, xe, Ee], Et = () => [Jn, "full", ...$()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Bn],
      breakpoint: [Bn],
      color: [aE],
      container: [Bn],
      "drop-shadow": [Bn],
      ease: ["in", "out", "in-out"],
      font: [bI],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Bn],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Bn],
      shadow: [Bn],
      spacing: ["px", Be],
      text: [Bn],
      "text-shadow": [Bn],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Jn, Ee, xe, T]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Be, Ee, xe, o]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": w()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": w()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: F()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: k()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": k()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": k()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: J()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": J()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": J()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": J(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: J()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": J(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: J()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": J()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": J()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: J()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: J()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: J()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: J()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Zn, "auto", xe, Ee]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Jn, "full", "auto", o, ...$()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Be, Jn, "auto", "initial", "none", Ee]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Be, xe, Ee]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Be, xe, Ee]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Zn, "first", "last", "none", xe, Ee]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": U()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: re()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ae()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ae()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": U()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: re()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ae()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ae()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": j()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": j()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: $()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": $()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": $()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...H(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...z(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...z()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...z(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...z(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": H()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...z(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...z()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: $()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: $()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: $()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: $()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: $()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: $()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: $()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: $()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: $()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: $()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: $()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: W()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: W()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: W()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: W()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: W()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: W()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: W()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: W()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: W()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: W()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: W()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": $()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": $()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: X()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...G()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...G()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...G()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...se()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...se()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...se()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [o, "screen", ...X()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          o,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...X()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          o,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [a]
          },
          ...X()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...X()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...X()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...X()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, ts, Sr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, vI, _I]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Fu, Ee]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [AI, xI, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [Ee]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [i, xe, Ee]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Be, "none", xe, xh]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          s,
          ...$()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", xe, Ee]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", xe, Ee]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: N()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: N()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...fe(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Be, "from-font", "auto", xe, Sr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: N()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Be, "auto", xe, Ee]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: $()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", xe, Ee]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", xe, Ee]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: ye()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: Re()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: D()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Zn, xe, Ee],
          radial: ["", xe, Ee],
          conic: [Zn, xe, Ee]
        }, NI, TI]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: N()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: Ie()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: Ie()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: Ie()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: N()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: N()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: N()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: De()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": De()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": De()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": De()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": De()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": De()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": De()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": De()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": De()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": De()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": De()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": De()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": De()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": De()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": De()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: He()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": He()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": He()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": He()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": He()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": He()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": He()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": He()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": He()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": He()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": He()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": He()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": He()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...fe(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...fe(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: N()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": N()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": N()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": N()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": N()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": N()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": N()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": N()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": N()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": N()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": N()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: N()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...fe(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Be, xe, Ee]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Be, ts, Sr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: N()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          l,
          va,
          Na
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: N()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", d, va, Na]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": N()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: He()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: N()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Be, Sr]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": N()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": He()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": N()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", h, va, Na]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": N()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Be, xe, Ee]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Te(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Te()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Be]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": Ne()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": Ne()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": N()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": N()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": Ne()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": Ne()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": N()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": N()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": Ne()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": Ne()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": N()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": N()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": Ne()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": Ne()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": N()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": N()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": Ne()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": Ne()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": N()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": N()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": Ne()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": Ne()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": N()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": N()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": Ne()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": Ne()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": N()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": N()
      }],
      "mask-image-radial": [{
        "mask-radial": [xe, Ee]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": Ne()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": Ne()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": N()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": N()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": M()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Be]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": Ne()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": Ne()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": N()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": N()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: ye()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: Re()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: D()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", xe, Ee]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          xe,
          Ee
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: _e()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Be, xe, Ee]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Be, xe, Ee]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          m,
          va,
          Na
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": N()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Be, xe, Ee]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Be, xe, Ee]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Be, xe, Ee]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Be, xe, Ee]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Be, xe, Ee]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          xe,
          Ee
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": _e()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Be, xe, Ee]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Be, xe, Ee]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Be, xe, Ee]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Be, xe, Ee]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Be, xe, Ee]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Be, xe, Ee]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Be, xe, Ee]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Be, xe, Ee]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": $()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": $()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": $()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", xe, Ee]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Be, "initial", xe, Ee]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", _, xe, Ee]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Be, xe, Ee]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", A, xe, Ee]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, xe, Ee]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": F()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: Se()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": Se()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": Se()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": Se()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Me()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Me()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Me()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Me()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: Ze()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": Ze()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": Ze()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [xe, Ee, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: F()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: Et()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": Et()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": Et()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": Et()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: N()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: N()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", xe, Ee]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": $()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": $()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": $()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": $()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": $()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": $()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": $()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": $()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": $()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": $()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": $()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": $()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": $()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": $()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": $()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": $()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": $()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": $()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": $()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": $()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": $()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": $()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", xe, Ee]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...N()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Be, ts, Sr, xh]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...N()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, SI = /* @__PURE__ */ aI(CI);
function ve(...e) {
  return SI(Zb(e));
}
const kI = j2(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive cursor-pointer",
  {
    variants: {
      variant: {
        "purple-gradient": `
          text-white
          overflow-hidden
          border
          border-white/20
          bg-gradient-to-r
          from-[rgba(98,36,198,0.8)]
          from-10.17%
          to-[rgba(66,24,133,0.8)]
          to-86.14%
          backdrop-blur-xl
          shadow-[inset_-2px_-2px_20px_0px_#f6f0ff33]
          before:content-['']
          before:absolute
          before:inset-0
          before:-z-10
          before:bg-gradient-to-r
          before:from-[#6224c6]
          before:from-10.17%
          before:to-[#421885]
          before:to-86.14%
          before:opacity-0
          before:transition-opacity
          before:duration-300
          before:ease-in-out
          disabled:bg-neutral-200
          disabled:text-neutral-500
          disabled:shadow-none
          disabled:cursor-not-allowed
          disabled:[&_svg]:fill-neutral-500
          hover:enabled:border-[#6b27d8]
          hover:enabled:shadow-[0px_2px_4px_0px_#6224c680]
          hover:enabled:before:opacity-100
        `,
        "highlight-border": `
          bg-secondary
          text-secondary-foreground
          shadow-sm
          border
          border-violet-300
          w-fit
          hover:bg-secondary/80
        `,
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive: "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
        purple: `
          shadow-xs
          border
          border-[#5F3D85]
          bg-[#4A276F]
          data-[active]:bg-[#5F3D85]
          hover:bg-[#5F3D85]
        `
      },
      size: {
        default: "h-9 px-4 py-3 has-[>svg]:pl-2 has-[>svg]:pr-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Bt = y.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    asChild: r = !1,
    ...i
  }, s) => {
    const a = r ? vN : "button";
    return /* @__PURE__ */ p.jsxDEV(a, { "data-slot": "button", className: ve(kI({ variant: t, size: n, className: e })), ...i, ref: s }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/button.tsx",
      lineNumber: 105,
      columnNumber: 12
    }, void 0);
  }
), Je = u1, Qs = c1, II = ["pt-BR", "en", "es"];
function yh(e) {
  return II.includes(e);
}
const wa = {
  title: {
    key: "zai.delete-thread-modal.title",
    defaultValue: "Excluir chat"
  },
  description: {
    key: "zai.delete-thread-modal.description",
    defaultValue: "Tem certeza de que deseja excluir este chat?"
  },
  cancel: {
    key: "zai.delete-thread-modal.cancel",
    defaultValue: "Cancelar"
  },
  confirm: {
    key: "zai.delete-thread-modal.confirm",
    defaultValue: "Excluir"
  }
}, DI = ({
  isOpen: e,
  isDeleting: t,
  onOverlayClick: n,
  onContentClick: r,
  onCancelClick: i,
  onConfirmClick: s
}) => {
  const { t: a } = Je();
  return /* @__PURE__ */ p.jsxDEV("div", { onClick: r, children: /* @__PURE__ */ p.jsxDEV(Ji, { show: e, animate: !1, classes: ["w-[90%]!", "max-w-[500px]!"], children: [
    /* @__PURE__ */ p.jsxDEV(Ji.Overlay, { onClick: n }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
      lineNumber: 23,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(Ji.Header, { children: /* @__PURE__ */ p.jsxDEV("h2", { className: "text-2xl font-semibold text-[#2b2b2b]", children: a(wa.title) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
      lineNumber: 26,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
      lineNumber: 25,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(Ji.Body, { classes: ["py-4"], children: /* @__PURE__ */ p.jsxDEV("p", { className: "text-sm font-normal text-[#4c5567]", children: a(wa.description) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
      lineNumber: 30,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
      lineNumber: 29,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("div", { className: "h-px bg-black/10" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
      lineNumber: 33,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(Ji.Footer, { classes: ["gap-4", "pt-4"], children: [
      /* @__PURE__ */ p.jsxDEV(
        Bt,
        {
          variant: "ghost",
          onClick: i,
          disabled: t,
          className: "h-9 rounded-[4px] px-4 font-normal text-[#4c5567] hover:bg-transparent hover:text-[#4c5567] dark:hover:bg-transparent",
          children: a(wa.cancel)
        },
        void 0,
        !1,
        {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
          lineNumber: 36,
          columnNumber: 11
        },
        void 0
      ),
      /* @__PURE__ */ p.jsxDEV(
        Bt,
        {
          variant: "default",
          onClick: s,
          disabled: t,
          className: "relative h-9 rounded-[4px] bg-[#6224c6] px-4 font-normal text-white hover:bg-[#6224c6]",
          children: [
            /* @__PURE__ */ p.jsxDEV("span", { className: t ? "invisible" : void 0, children: a(wa.confirm) }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
              lineNumber: 50,
              columnNumber: 13
            }, void 0),
            t && /* @__PURE__ */ p.jsxDEV("span", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ p.jsxDEV("span", { className: "size-4 animate-spin rounded-full border-2 border-white border-t-transparent" }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
              lineNumber: 53,
              columnNumber: 17
            }, void 0) }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
              lineNumber: 52,
              columnNumber: 15
            }, void 0)
          ]
        },
        void 0,
        !0,
        {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
          lineNumber: 44,
          columnNumber: 11
        },
        void 0
      )
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
      lineNumber: 35,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
    lineNumber: 22,
    columnNumber: 7
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/delete-thread-modal.view.tsx",
    lineNumber: 21,
    columnNumber: 5
  }, void 0);
}, RI = Ce(DI), PI = (e) => {
  const t = H2(e);
  return /* @__PURE__ */ p.jsxDEV(RI, { ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/delete-thread-modal/index.tsx",
    lineNumber: 8,
    columnNumber: 10
  }, void 0);
}, OI = ({ onDeleteClick: e }) => {
  const [t, n] = we(!1), r = de((s) => {
    s.stopPropagation();
  }, []), i = de(
    (s) => {
      s.stopPropagation(), n(!1), e();
    },
    [e]
  );
  return {
    isOpen: t,
    onOpenChange: n,
    onTriggerClick: r,
    onDeleteClick: i
  };
}, mE = Ot({
  container: null
});
function tu() {
  return Ct(mE).container;
}
const li = {
  dark: null,
  light: null
}, zu = {
  dark: 0,
  light: 0
};
function nd({
  children: e,
  theme: t = "dark"
}) {
  const [n, r] = we(null);
  return Le(() => {
    if (zu[t]++, !li[t]) {
      const i = document.createElement("div");
      i.id = `zai-chat-portal-container-${t}`, i.className = `zai-chat-package ${t}`, i.style.cssText = "position:fixed;z-index:99999999991;", document.body.appendChild(i), li[t] = i;
    }
    return r(li[t]), () => {
      zu[t]--, zu[t] === 0 && li[t] && (document.body.removeChild(li[t]), li[t] = null);
    };
  }, [t]), /* @__PURE__ */ p.jsxDEV(mE.Provider, { value: { container: n }, children: e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/portal-container/portal-container.provider.tsx",
    lineNumber: 49,
    columnNumber: 10
  }, this);
}
function rd({ ...e }) {
  return /* @__PURE__ */ p.jsxDEV(tS, { "data-slot": "popover", ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/popover.tsx",
    lineNumber: 8,
    columnNumber: 10
  }, this);
}
function id({ ...e }) {
  return /* @__PURE__ */ p.jsxDEV(nS, { "data-slot": "popover-trigger", ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/popover.tsx",
    lineNumber: 12,
    columnNumber: 10
  }, this);
}
function sd({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...r
}) {
  const i = tu();
  return /* @__PURE__ */ p.jsxDEV(rS, { container: i ?? void 0, children: /* @__PURE__ */ p.jsxDEV(
    iS,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: ve(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
        e
      ),
      ...r
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/popover.tsx",
      lineNumber: 24,
      columnNumber: 7
    },
    this
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/popover.tsx",
    lineNumber: 23,
    columnNumber: 5
  }, this);
}
const Nh = {
  delete: {
    key: "zai.thread-list-item-menu.delete",
    defaultValue: "Excluir"
  },
  actionsLabel: {
    key: "zai.thread-list-item-menu.actions-label",
    defaultValue: "Ações da conversa"
  }
}, LI = ({ isOpen: e, onOpenChange: t, onTriggerClick: n, onDeleteClick: r }) => {
  const { t: i } = Je();
  return /* @__PURE__ */ p.jsxDEV(rd, { open: e, onOpenChange: t, children: [
    /* @__PURE__ */ p.jsxDEV(
      id,
      {
        onClick: n,
        "aria-label": i(Nh.actionsLabel),
        className: `
          flex
          items-center
          justify-center
          size-5
          rounded-full
          bg-[#6f6f6f]
          shrink-0
          opacity-0
          group-hover:opacity-100
          focus-visible:opacity-100
          data-[state=open]:opacity-100
          outline-none
        `,
        children: /* @__PURE__ */ p.jsxDEV(_2, { className: "size-3 text-[#f7f9fc]" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list-item-menu/thread-list-item-menu.view.tsx",
          lineNumber: 33,
          columnNumber: 9
        }, void 0)
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list-item-menu/thread-list-item-menu.view.tsx",
        lineNumber: 15,
        columnNumber: 7
      },
      void 0
    ),
    /* @__PURE__ */ p.jsxDEV(
      sd,
      {
        align: "end",
        onClick: n,
        className: "w-[180px] p-0 rounded shadow-[0px_2px_10px_1px_rgba(0,0,0,0.08)] bg-white border-none",
        children: /* @__PURE__ */ p.jsxDEV(
          "button",
          {
            type: "button",
            onClick: r,
            className: "w-full h-9 pl-6 pr-2 py-2 rounded text-start text-sm text-[#4c5567] hover:bg-neutral-100",
            children: i(Nh.delete)
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list-item-menu/thread-list-item-menu.view.tsx",
            lineNumber: 40,
            columnNumber: 9
          },
          void 0
        )
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list-item-menu/thread-list-item-menu.view.tsx",
        lineNumber: 35,
        columnNumber: 7
      },
      void 0
    )
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list-item-menu/thread-list-item-menu.view.tsx",
    lineNumber: 14,
    columnNumber: 5
  }, void 0);
}, MI = Ce(LI), UI = (e) => {
  const t = OI(e);
  return /* @__PURE__ */ p.jsxDEV(MI, { ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list-item-menu/index.tsx",
    lineNumber: 8,
    columnNumber: 10
  }, void 0);
};
class nu extends a1 {
  constructor() {
    super(...arguments), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t) {
    (t?.message?.includes("tapClientLookup") || t?.message?.includes("out of bounds")) && setTimeout(() => this.setState({ hasError: !1 }), 0);
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
const pE = Ot(void 0), gE = () => {
  const e = Ct(pE);
  if (!e)
    throw new Error("useThreadRunningState must be used within a ThreadRunningStateProvider");
  return e;
}, bE = Ot(void 0), EE = () => {
  const e = Ct(bE);
  if (!e)
    throw new Error("useZaiChatSectionStates must be used within a ZaiChatSectionStatesProvider");
  return e;
}, HI = ({ children: e }) => {
  const [t, n] = we({}), r = de(
    (c) => t[c]?.threadId,
    [t]
  ), i = de(({ contextKey: c, id: l }) => {
    n((d) => ({
      ...d,
      [c]: {
        ...d[c] || {},
        threadId: l
      }
    }));
  }, []), s = de(
    (c) => t[c]?.lastPrompt,
    [t]
  ), a = de(({ contextKey: c, prompt: l }) => {
    n((d) => ({
      ...d,
      [c]: {
        ...d[c] || {},
        lastPrompt: l
      }
    }));
  }, []), o = de(
    (c) => Object.values(t).some((l) => l.threadId === c),
    [t]
  ), u = pe(
    () => ({
      getCurrentThreadId: r,
      setCurrentThreadId: i,
      getLastPrompt: s,
      setLastPrompt: a,
      isSectionThreadId: o
    }),
    [r, i, s, a, o]
  );
  return /* @__PURE__ */ p.jsxDEV(bE.Provider, { value: u, children: e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/zai-chat-section-states/zai-chat-section-states.provider.tsx",
    lineNumber: 56,
    columnNumber: 10
  }, void 0);
}, jI = ({
  children: e,
  onBackgroundThreadComplete: t,
  isChatVisible: n
}) => {
  const [r, i] = we({}), { isSectionThreadId: s } = EE(), a = de(({ threadId: l, isRunning: d }) => {
    i((h) => {
      if (!!h[l] === d) return h;
      if (!d) {
        const { [l]: m, ...E } = h;
        return E;
      }
      return { ...h, [l]: !0 };
    });
  }, []), o = de(
    ({ threadId: l, isActiveThread: d, title: h }) => {
      if (!t || s(l)) return;
      (!d || !n?.()) && t(l, h);
    },
    [t, n, s]
  ), u = de(
    (l) => !!(l && r[l]),
    [r]
  ), c = pe(
    () => ({ isThreadRunning: u, setThreadRunning: a, notifyIfBackground: o }),
    [u, a, o]
  );
  return /* @__PURE__ */ p.jsxDEV(pE.Provider, { value: c, children: e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/thread-running-state/thread-running-state.provider.tsx",
    lineNumber: 52,
    columnNumber: 10
  }, void 0);
}, ru = {
  isEnabled: (e) => qd.isEnabled(e),
  getValue: (e) => qd.getValue(e)
}, en = {
  loading: {
    key: "zai.loading",
    defaultValue: "Carregando..."
  },
  loadingThreads: {
    key: "zai.loading-threads",
    defaultValue: "Carregando conversas"
  },
  copy: {
    key: "zai.copy",
    defaultValue: "Copiar"
  },
  newThread: {
    key: "zai.new-thread",
    defaultValue: "Nova conversa"
  },
  scrollToBottom: {
    key: "zai.thread.scroll-to-bottom",
    defaultValue: "Role para baixo"
  },
  welcomeMessage: {
    key: "zai.thread.welcome-message",
    defaultValue: "Como posso ajudar você hoje?"
  },
  placeholder: {
    key: "zai.thread.placeholder",
    defaultValue: "Escreva sua mensagem para ZAI"
  },
  somethingWentWrong: {
    key: "zai.thread.something-went-wrong",
    defaultValue: "Parece que algo deu errado. Tente novamente."
  }
}, _E = ({ handleItemClick: e }) => {
  const t = oe((r) => r?.threads?.isLoading), { t: n } = Je();
  return /* @__PURE__ */ p.jsxDEV(Wb, { className: "flex flex-col items-stretch gap-1.5", children: [
    /* @__PURE__ */ p.jsxDEV(BI, { handleItemClick: e }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 26,
      columnNumber: 7
    }, void 0),
    t ? /* @__PURE__ */ p.jsxDEV("div", { className: "flex items-center justify-center p-4 gap-2.5", children: [
      /* @__PURE__ */ p.jsxDEV("span", { className: "animate-spin size-5 border-2 border-purple-300 rounded-full border-t-transparent" }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
        lineNumber: 29,
        columnNumber: 11
      }, void 0),
      /* @__PURE__ */ p.jsxDEV("p", { className: "text-white font-medium", children: n(en.loadingThreads) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
        lineNumber: 30,
        columnNumber: 11
      }, void 0)
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 28,
      columnNumber: 9
    }, void 0) : /* @__PURE__ */ p.jsxDEV(FI, { handleItemClick: e }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 33,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
    lineNumber: 25,
    columnNumber: 5
  }, void 0);
}, BI = ({ handleItemClick: e }) => {
  const { t } = Je();
  return /* @__PURE__ */ p.jsxDEV(Vb, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(
    Bt,
    {
      onClick: e,
      variant: "purple",
      size: "default",
      className: `
          justify-start
          rounded-lg
          h-11
        `,
      children: [
        /* @__PURE__ */ p.jsxDEV(k2, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
          lineNumber: 54,
          columnNumber: 9
        }, void 0),
        t(en.newThread)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 44,
      columnNumber: 7
    },
    void 0
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
    lineNumber: 43,
    columnNumber: 5
  }, void 0);
}, FI = ({ handleItemClick: e }) => /* @__PURE__ */ p.jsxDEV(nu, { children: /* @__PURE__ */ p.jsxDEV(
  vg,
  {
    components: { ThreadListItem: () => /* @__PURE__ */ p.jsxDEV(zI, { handleItemClick: e }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 65,
      columnNumber: 45
    }, void 0) }
  },
  void 0,
  !1,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
    lineNumber: 64,
    columnNumber: 7
  },
  void 0
) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
  lineNumber: 63,
  columnNumber: 5
}, void 0), zI = ({ handleItemClick: e }) => {
  const [t, n] = we(!1), [r, i] = we(!1), a = Ve().threadListItem(), o = ru.isEnabled("isZaiA2AOrchestratorEnabled"), u = async () => {
    i(!0);
    try {
      await a.delete(), n(!1);
    } finally {
      i(!1);
    }
  };
  return /* @__PURE__ */ p.jsxDEV(
    $b,
    {
      onClick: e,
      className: "group data-[active]:bg-neutral-700 hover:bg-neutral-700 focus-visible:bg-neutral-700 focus-visible:ring-ring flex items-center gap-2 rounded-lg transition-all focus-visible:outline-none focus-visible:ring-2",
      children: [
        /* @__PURE__ */ p.jsxDEV(Zk, { className: "flex-grow px-3 py-2 text-start w-full min-w-0", children: /* @__PURE__ */ p.jsxDEV(VI, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
          lineNumber: 96,
          columnNumber: 9
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
          lineNumber: 95,
          columnNumber: 7
        }, void 0),
        o && /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: [
          /* @__PURE__ */ p.jsxDEV(UI, { onDeleteClick: () => n(!0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
            lineNumber: 101,
            columnNumber: 11
          }, void 0),
          /* @__PURE__ */ p.jsxDEV(
            PI,
            {
              isOpen: t,
              isDeleting: r,
              onCancel: () => n(!1),
              onConfirm: u
            },
            void 0,
            !1,
            {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
              lineNumber: 103,
              columnNumber: 11
            },
            void 0
          )
        ] }, void 0, !0, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
          lineNumber: 100,
          columnNumber: 9
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 91,
      columnNumber: 5
    },
    void 0
  );
}, VI = () => {
  const e = oe((r) => r?.threadListItem?.id), { isThreadRunning: t } = gE(), { t: n } = Je();
  return /* @__PURE__ */ p.jsxDEV("p", { className: "text-sm font-medium flex items-center gap-1.5 min-w-0", children: [
    t(e) && /* @__PURE__ */ p.jsxDEV("span", { "data-status": "running", role: "status", "aria-label": n(en.loading), className: "aui-md shrink-0" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 123,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("span", { className: "truncate", children: /* @__PURE__ */ p.jsxDEV(wg, { fallback: "New Chat" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 126,
      columnNumber: 9
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
      lineNumber: 125,
      columnNumber: 7
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread-list.tsx",
    lineNumber: 121,
    columnNumber: 5
  }, void 0);
};
function WI({ ...e }) {
  return /* @__PURE__ */ p.jsxDEV(bw, { "data-slot": "sheet", ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
    lineNumber: 9,
    columnNumber: 10
  }, this);
}
function $I({ ...e }) {
  const t = tu();
  return /* @__PURE__ */ p.jsxDEV(Ew, { "data-slot": "sheet-portal", container: t ?? void 0, ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
    lineNumber: 22,
    columnNumber: 10
  }, this);
}
function YI({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    _w,
    {
      "data-slot": "sheet-overlay",
      className: ve(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
      lineNumber: 27,
      columnNumber: 5
    },
    this
  );
}
function GI({
  className: e,
  children: t,
  side: n = "right",
  ...r
}) {
  return /* @__PURE__ */ p.jsxDEV($I, { children: [
    /* @__PURE__ */ p.jsxDEV(YI, {}, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
      lineNumber: 48,
      columnNumber: 7
    }, this),
    /* @__PURE__ */ p.jsxDEV(
      xw,
      {
        "data-slot": "sheet-content",
        className: ve(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
          n === "right" && "data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm",
          n === "left" && "data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm",
          n === "top" && "data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-0 top-0 h-auto border-b",
          n === "bottom" && "data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-0 bottom-0 h-auto border-t",
          e
        ),
        ...r,
        children: [
          t,
          /* @__PURE__ */ p.jsxDEV(yw, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none", children: [
            /* @__PURE__ */ p.jsxDEV(Xb, { className: "size-4" }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
              lineNumber: 67,
              columnNumber: 11
            }, this),
            /* @__PURE__ */ p.jsxDEV("span", { className: "sr-only", children: "Close" }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
              lineNumber: 68,
              columnNumber: 11
            }, this)
          ] }, void 0, !0, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
            lineNumber: 66,
            columnNumber: 9
          }, this)
        ]
      },
      void 0,
      !0,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
        lineNumber: 49,
        columnNumber: 7
      },
      this
    )
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
    lineNumber: 47,
    columnNumber: 5
  }, this);
}
function qI({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV("div", { "data-slot": "sheet-header", className: ve("flex flex-col gap-1.5 p-4", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
    lineNumber: 76,
    columnNumber: 10
  }, this);
}
function KI({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    Tw,
    {
      "data-slot": "sheet-title",
      className: ve("text-foreground font-semibold", e),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
      lineNumber: 85,
      columnNumber: 5
    },
    this
  );
}
function QI({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    Aw,
    {
      "data-slot": "sheet-description",
      className: ve("text-muted-foreground text-sm", e),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sheet.tsx",
      lineNumber: 95,
      columnNumber: 5
    },
    this
  );
}
function Vt({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV("div", { "data-slot": "skeleton", className: ve("bg-accent animate-pulse rounded-md", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/skeleton.tsx",
    lineNumber: 4,
    columnNumber: 10
  }, this);
}
function xE({ delayDuration: e = 0, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(tk, { "data-slot": "tooltip-provider", delayDuration: e, ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/tooltip.tsx",
    lineNumber: 8,
    columnNumber: 10
  }, this);
}
function XI({ ...e }) {
  return /* @__PURE__ */ p.jsxDEV(xE, { children: /* @__PURE__ */ p.jsxDEV(nk, { "data-slot": "tooltip", ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/tooltip.tsx",
    lineNumber: 14,
    columnNumber: 7
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/tooltip.tsx",
    lineNumber: 13,
    columnNumber: 5
  }, this);
}
function JI({ ...e }) {
  return /* @__PURE__ */ p.jsxDEV(rk, { "data-slot": "tooltip-trigger", ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/tooltip.tsx",
    lineNumber: 20,
    columnNumber: 10
  }, this);
}
function ZI({
  className: e,
  sideOffset: t = 0,
  children: n,
  ...r
}) {
  const i = tu();
  return /* @__PURE__ */ p.jsxDEV(ik, { container: i ?? void 0, children: /* @__PURE__ */ p.jsxDEV(
    sk,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: ve(
        "bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ p.jsxDEV(ak, { className: "bg-primary fill-primary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/tooltip.tsx",
          lineNumber: 42,
          columnNumber: 9
        }, this)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/tooltip.tsx",
      lineNumber: 32,
      columnNumber: 7
    },
    this
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/tooltip.tsx",
    lineNumber: 31,
    columnNumber: 5
  }, this);
}
const Vu = 768;
function eD() {
  const [e, t] = y.useState(void 0);
  return y.useEffect(() => {
    const n = window.matchMedia(`(max-width: ${Vu - 1}px)`), r = () => {
      t(window.innerWidth < Vu);
    };
    return n.addEventListener("change", r), t(window.innerWidth < Vu), () => n.removeEventListener("change", r);
  }, []), !!e;
}
const tD = "sidebar_state", nD = 3600 * 24 * 7, rD = "16rem", iD = "18rem", sD = "3rem", aD = "b", TE = y.createContext(null);
function oD() {
  const e = y.useContext(TE);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
function uD({
  defaultOpen: e = !0,
  open: t,
  onOpenChange: n,
  className: r,
  style: i,
  children: s,
  ...a
}) {
  const o = eD(), [u, c] = y.useState(!1), [l, d] = y.useState(e), h = t ?? l, m = y.useCallback(
    (_) => {
      const A = typeof _ == "function" ? _(h) : _;
      n ? n(A) : d(A), document.cookie = `${tD}=${A}; path=/; max-age=${nD}`;
    },
    [n, h]
  ), E = y.useCallback(() => o ? c((_) => !_) : m((_) => !_), [o, m, c]);
  y.useEffect(() => {
    const _ = (A) => {
      A.key === aD && (A.metaKey || A.ctrlKey) && (A.preventDefault(), E());
    };
    return window.addEventListener("keydown", _), () => window.removeEventListener("keydown", _);
  }, [E]);
  const g = h ? "expanded" : "collapsed", T = y.useMemo(
    () => ({
      state: g,
      open: h,
      setOpen: m,
      isMobile: o,
      openMobile: u,
      setOpenMobile: c,
      toggleSidebar: E
    }),
    [g, h, m, o, u, c, E]
  );
  return /* @__PURE__ */ p.jsxDEV(TE.Provider, { value: T, children: /* @__PURE__ */ p.jsxDEV(xE, { delayDuration: 0, children: /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      "data-slot": "sidebar-wrapper",
      style: {
        "--sidebar-width": rD,
        "--sidebar-width-icon": sD,
        ...i
      },
      className: ve("group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full", r),
      ...a,
      children: s
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 118,
      columnNumber: 9
    },
    this
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
    lineNumber: 117,
    columnNumber: 7
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
    lineNumber: 116,
    columnNumber: 5
  }, this);
}
function cD({
  side: e = "left",
  variant: t = "sidebar",
  collapsible: n = "offcanvas",
  className: r,
  children: i,
  ...s
}) {
  const { isMobile: a, state: o, openMobile: u, setOpenMobile: c } = oD();
  return n === "none" ? /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      "data-slot": "sidebar",
      className: ve("bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col", r),
      ...s,
      children: i
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 153,
      columnNumber: 7
    },
    this
  ) : a ? /* @__PURE__ */ p.jsxDEV(WI, { open: u, onOpenChange: c, ...s, children: /* @__PURE__ */ p.jsxDEV(
    GI,
    {
      "data-sidebar": "sidebar",
      "data-slot": "sidebar",
      "data-mobile": "true",
      className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
      style: {
        "--sidebar-width": iD
      },
      side: e,
      children: [
        /* @__PURE__ */ p.jsxDEV(qI, { className: "sr-only", children: [
          /* @__PURE__ */ p.jsxDEV(KI, { children: "Sidebar" }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
            lineNumber: 179,
            columnNumber: 13
          }, this),
          /* @__PURE__ */ p.jsxDEV(QI, { children: "Displays the mobile sidebar." }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
            lineNumber: 180,
            columnNumber: 13
          }, this)
        ] }, void 0, !0, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
          lineNumber: 178,
          columnNumber: 11
        }, this),
        /* @__PURE__ */ p.jsxDEV("div", { className: "flex h-full w-full flex-col", children: i }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
          lineNumber: 182,
          columnNumber: 11
        }, this)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 166,
      columnNumber: 9
    },
    this
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
    lineNumber: 165,
    columnNumber: 7
  }, this) : /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      className: "group peer text-sidebar-foreground hidden md:block",
      "data-state": o,
      "data-collapsible": o === "collapsed" ? n : "",
      "data-variant": t,
      "data-side": e,
      "data-slot": "sidebar",
      children: [
        /* @__PURE__ */ p.jsxDEV(
          "div",
          {
            "data-slot": "sidebar-gap",
            className: ve(
              "relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
              "group-data-[collapsible=offcanvas]:w-0",
              "group-data-[side=right]:rotate-180",
              t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
            )
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
            lineNumber: 198,
            columnNumber: 7
          },
          this
        ),
        /* @__PURE__ */ p.jsxDEV(
          "div",
          {
            "data-slot": "sidebar-container",
            className: ve(
              "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
              e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
              // Adjust the padding for floating and inset variants.
              t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
              r
            ),
            ...s,
            children: /* @__PURE__ */ p.jsxDEV(
              "div",
              {
                "data-sidebar": "sidebar",
                "data-slot": "sidebar-inner",
                className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-xl group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm",
                children: i
              },
              void 0,
              !1,
              {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
                lineNumber: 224,
                columnNumber: 9
              },
              this
            )
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
            lineNumber: 209,
            columnNumber: 7
          },
          this
        )
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 189,
      columnNumber: 5
    },
    this
  );
}
function lD({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    "main",
    {
      "data-slot": "sidebar-inset",
      className: ve(
        "bg-background relative flex w-full flex-1 flex-col",
        "md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-2",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 285,
      columnNumber: 5
    },
    this
  );
}
function dD({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      "data-slot": "sidebar-header",
      "data-sidebar": "header",
      className: ve("flex flex-col gap-2 p-2", e),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 310,
      columnNumber: 5
    },
    this
  );
}
function fD({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      "data-slot": "sidebar-content",
      "data-sidebar": "content",
      className: ve(
        "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 343,
      columnNumber: 5
    },
    this
  );
}
function hD({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      "data-slot": "sidebar-group",
      "data-sidebar": "group",
      className: ve("relative flex w-full min-w-0 flex-col p-2", e),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 357,
      columnNumber: 5
    },
    this
  );
}
function mD({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: ve("flex w-full min-w-0 flex-col gap-1", e),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 423,
      columnNumber: 5
    },
    this
  );
}
function pD({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: ve("group/menu-item relative", e),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/sidebar.tsx",
      lineNumber: 434,
      columnNumber: 5
    },
    this
  );
}
const gD = (e) => /* @__PURE__ */ p.jsxDEV("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M7.433.91a3.25 3.25 0 0 1 3.317 3.257v10.834a4.086 4.086 0 0 1-4.348 4.07 4.084 4.084 0 0 1-3.817-4.113A4.08 4.08 0 0 1 .93 12.01 4.08 4.08 0 0 1 1.998 8.9a4.08 4.08 0 0 1 1.189-4.511 4.1 4.1 0 0 1 1.093-.665A3.25 3.25 0 0 1 7.432.91m.03 1.5a1.75 1.75 0 0 0-1.711 1.827.75.75 0 0 1-.563.76A2.586 2.586 0 0 0 3.25 7.604c.016.391.12.775.307 1.12a.75.75 0 0 1-.188.937 2.585 2.585 0 0 0 .36 4.255.75.75 0 0 1 .374.75 2.59 2.59 0 0 0 1.385 2.63A2.583 2.583 0 0 0 9.25 15V4.164A1.75 1.75 0 0 0 7.464 2.41",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/analyze.tsx",
      lineNumber: 6,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M12.567.91a3.25 3.25 0 0 1 3.152 2.814 4.085 4.085 0 0 1 2.528 3.941 4.1 4.1 0 0 1-.246 1.234 4.082 4.082 0 0 1-.586 6.06 4.08 4.08 0 0 1-.929 2.633 4.085 4.085 0 0 1-7.236-2.59V4.166A3.25 3.25 0 0 1 12.567.91m-.03 1.5a1.75 1.75 0 0 0-1.787 1.754V15a2.585 2.585 0 0 0 2.751 2.575 2.583 2.583 0 0 0 2.395-2.909.75.75 0 0 1 .374-.749 2.583 2.583 0 0 0 .36-4.255.75.75 0 0 1-.188-.937 2.59 2.59 0 0 0-.6-3.193 2.6 2.6 0 0 0-1.032-.534.75.75 0 0 1-.562-.76 1.75 1.75 0 0 0-1.712-1.828",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/analyze.tsx",
      lineNumber: 10,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M10 6.75a.75.75 0 0 1 .749.709 3 3 0 0 0 2 2.667.75.75 0 0 1-.498 1.415 4.5 4.5 0 0 1-2.106-1.545q-.076-.103-.145-.209-.07.106-.145.21A4.5 4.5 0 0 1 7.75 11.54a.75.75 0 0 1-.498-1.415 3 3 0 0 0 2-2.667l.022-.145A.75.75 0 0 1 10 6.75m5.03-3.228a.75.75 0 0 1 .718.78 3.25 3.25 0 0 1-.433 1.49.75.75 0 1 1-1.299-.75c.141-.245.221-.52.233-.802a.75.75 0 0 1 .78-.718m-10.057 0a.75.75 0 0 1 .78.719c.011.282.091.557.232.801a.75.75 0 0 1-1.3.75 3.25 3.25 0 0 1-.43-1.49.75.75 0 0 1 .718-.78M2.98 8.021a.833.833 0 1 1 .81 1.458q-.195.107-.366.248A.834.834 0 0 1 2.37 8.434q.286-.233.61-.413m12.907.325a.833.833 0 0 1 1.132-.325q.324.18.61.413a.834.834 0 0 1-1.053 1.293 2.5 2.5 0 0 0-.365-.248.833.833 0 0 1-.324-1.133M2.708 14.202a.75.75 0 0 1 1.021-.285c.388.218.825.333 1.27.333A.75.75 0 0 1 5 15.75a4.1 4.1 0 0 1-2.007-.527.75.75 0 0 1-.285-1.021m13.562-.285a.75.75 0 0 1 .738 1.306A4.1 4.1 0 0 1 15 15.75a.75.75 0 0 1 0-1.5 2.6 2.6 0 0 0 1.27-.333",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/analyze.tsx",
      lineNumber: 14,
      columnNumber: 7
    },
    void 0
  )
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/analyze.tsx",
  lineNumber: 5,
  columnNumber: 5
}, void 0), bD = ({ index: e, ...t }) => /* @__PURE__ */ p.jsxDEV("svg", { width: "192", height: "192", viewBox: "0 0 192 192", className: "w-48 h-48", ...t, children: [
  /* @__PURE__ */ p.jsxDEV("defs", { children: /* @__PURE__ */ p.jsxDEV("clipPath", { id: `donut-clip-${e}`, children: /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M 96 96 m -96 0 a 96 96 0 1 0 192 0 a 96 96 0 1 0 -192 0 Z M 96 96 m -72 0 a 72 72 0 0 1 144 0 a 72 72 0 0 1 -144 0 Z",
      fillRule: "evenodd"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/donut-skeleton.tsx",
      lineNumber: 11,
      columnNumber: 9
    },
    void 0
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/donut-skeleton.tsx",
    lineNumber: 10,
    columnNumber: 7
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/donut-skeleton.tsx",
    lineNumber: 9,
    columnNumber: 5
  }, void 0),
  /* @__PURE__ */ p.jsxDEV(
    "rect",
    {
      width: "192",
      height: "192",
      fill: "rgb(75, 85, 99)",
      clipPath: `url(#donut-clip-${e})`,
      className: "animate-pulse"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/donut-skeleton.tsx",
      lineNumber: 17,
      columnNumber: 5
    },
    void 0
  )
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/donut-skeleton.tsx",
  lineNumber: 8,
  columnNumber: 3
}, void 0), ED = (e) => /* @__PURE__ */ p.jsxDEV("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ p.jsxDEV("g", { clipPath: "url(#a)", fill: "currentColor", children: [
    /* @__PURE__ */ p.jsxDEV("path", { d: "M10.637 2.387a.888.888 0 0 0-1.774 0v.141A2.1 2.1 0 0 1 7.637 4.43a1 1 0 0 1-.238.069 2.1 2.1 0 0 1-2.182-.472l-.056-.055a.89.89 0 0 0-1.254 0 .886.886 0 0 0 0 1.255l.055.055a2.1 2.1 0 0 1 .436 2.272 2.1 2.1 0 0 1-1.92 1.375h-.091a.888.888 0 0 0 0 1.773h.141a2.1 2.1 0 0 1 1.918 1.265 2.1 2.1 0 0 1-.419 2.316l-.055.056a.89.89 0 0 0 0 1.254.886.886 0 0 0 1.255 0l.055-.055a2.1 2.1 0 0 1 2.272-.437l.045.017h-.001a2.1 2.1 0 0 1 1.33 1.905v.09a.887.887 0 0 0 1.774 0v-.141a2.1 2.1 0 0 1 1.265-1.92 2.1 2.1 0 0 1 2.316.42l.056.056.064.059a.89.89 0 0 0 1.383-.347.89.89 0 0 0-.192-.967l-.056-.055a2.1 2.1 0 0 1-.42-2.317 2.1 2.1 0 0 1 1.92-1.264h.075a.887.887 0 0 0 0-1.774h-.141a2.1 2.1 0 0 1-1.902-1.226 1 1 0 0 1-.07-.238 2.1 2.1 0 0 1 .473-2.182l.055-.056.059-.064a.89.89 0 0 0-.059-1.19.886.886 0 0 0-1.255 0l-.055.055a2.1 2.1 0 0 1-2.317.42V4.38a2.1 2.1 0 0 1-1.264-1.918zm1.5.07.006.087a.6.6 0 0 0 .28.422l.077.04.008.003a.6.6 0 0 0 .66-.12l.044-.043a2.388 2.388 0 0 1 3.377 3.376l-.044.044-.058.068a.6.6 0 0 0-.067.58q.03.076.049.163a.6.6 0 0 0 .508.286h.136a2.387 2.387 0 0 1 0 4.774h-.07l-.087.006a.6.6 0 0 0-.462.357l-.003.008a.6.6 0 0 0 .116.658l.047.046a2.39 2.39 0 0 1 .518 2.603 2.388 2.388 0 0 1-3.894.774l-.044-.044a.6.6 0 0 0-.66-.12l-.009.004a.6.6 0 0 0-.363.549v.135a2.387 2.387 0 0 1-4.773 0v-.066a.6.6 0 0 0-.393-.538l-.044-.019a.6.6 0 0 0-.66.12l-.044.044a2.39 2.39 0 0 1-2.602.518 2.385 2.385 0 0 1-.773-3.895l.042-.043a.6.6 0 0 0 .12-.66l-.004-.009a.6.6 0 0 0-.462-.356l-.087-.007h-.135a2.387 2.387 0 0 1 0-4.773h.065a.6.6 0 0 0 .54-.393q.008-.023.018-.044a.6.6 0 0 0-.12-.66h-.001l-.043-.044A2.387 2.387 0 1 1 6.222 2.91l.044.044.068.058a.6.6 0 0 0 .58.067l.08-.028.083-.022a.6.6 0 0 0 .286-.505v-.138a2.387 2.387 0 0 1 4.774 0z" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/execute.tsx",
      lineNumber: 7,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("path", { d: "M11 9.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/execute.tsx",
      lineNumber: 8,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/execute.tsx",
    lineNumber: 6,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV("defs", { children: /* @__PURE__ */ p.jsxDEV("clipPath", { id: "a", children: /* @__PURE__ */ p.jsxDEV("path", { d: "M0 0h20v20H0z" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/execute.tsx",
    lineNumber: 12,
    columnNumber: 11
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/execute.tsx",
    lineNumber: 11,
    columnNumber: 9
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/execute.tsx",
    lineNumber: 10,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/execute.tsx",
  lineNumber: 5,
  columnNumber: 5
}, void 0), _D = (e) => /* @__PURE__ */ p.jsxDEV("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M6.75 15.833a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/plan.tsx",
      lineNumber: 6,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M16.75 12.917a2.167 2.167 0 0 0-2.167-2.167H5.417a3.667 3.667 0 1 1 0-7.333H12.5a.75.75 0 0 1 0 1.5H5.417a2.167 2.167 0 0 0 0 4.333h9.166a3.668 3.668 0 0 1 0 7.334H7.5a.75.75 0 0 1 0-1.5h7.083a2.17 2.17 0 0 0 2.167-2.167",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/plan.tsx",
      lineNumber: 10,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M16.75 4.167a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/plan.tsx",
      lineNumber: 14,
      columnNumber: 7
    },
    void 0
  )
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/plan.tsx",
  lineNumber: 5,
  columnNumber: 5
}, void 0), xD = (e) => /* @__PURE__ */ p.jsxDEV("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ p.jsxDEV("g", { clipPath: "url(#clip0_318_263)", children: [
    /* @__PURE__ */ p.jsxDEV(
      "path",
      {
        d: "M11.1694 6.01412C11.2759 5.6973 11.7241 5.6973 11.8306 6.01412L11.8596 6.1003C12.4887 7.97035 13.9013 9.4735 15.7288 10.2173C16.0103 10.3319 16.0103 10.7306 15.7288 10.8452C13.9013 11.589 12.4887 13.0921 11.8596 14.9622L11.8306 15.0484C11.7241 15.3652 11.2759 15.3652 11.1694 15.0484L11.1404 14.9622C10.5113 13.0921 9.09865 11.589 7.27121 10.8452C6.98968 10.7306 6.98968 10.3319 7.27121 10.2173C9.09865 9.4735 10.5113 7.97035 11.1404 6.1003L11.1694 6.01412Z",
        fill: "currentColor"
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/sparkles.tsx",
        lineNumber: 7,
        columnNumber: 9
      },
      void 0
    ),
    /* @__PURE__ */ p.jsxDEV(
      "path",
      {
        opacity: "0.4",
        d: "M4.25463 2.66311C4.33892 2.43533 4.66109 2.43533 4.74537 2.66311C5.27536 4.09538 6.40462 5.22464 7.83689 5.75463C8.06467 5.83892 8.06467 6.16109 7.83689 6.24537C6.40462 6.77536 5.27536 7.90462 4.74537 9.33689C4.66109 9.56467 4.33892 9.56467 4.25463 9.33689C3.72464 7.90462 2.59538 6.77536 1.16311 6.24537C0.935326 6.16109 0.935326 5.83892 1.16311 5.75463C2.59538 5.22464 3.72464 4.09538 4.25463 2.66311Z",
        fill: "currentColor"
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/sparkles.tsx",
        lineNumber: 11,
        columnNumber: 9
      },
      void 0
    ),
    /* @__PURE__ */ p.jsxDEV(
      "path",
      {
        opacity: "0.4",
        d: "M9.37731 0.300304C9.41946 0.186413 9.58054 0.186413 9.62269 0.300304C9.88768 1.01644 10.4523 1.58107 11.1684 1.84606C11.2823 1.88821 11.2823 2.04929 11.1684 2.09144C10.4523 2.35643 9.88768 2.92106 9.62269 3.6372C9.58054 3.75109 9.41946 3.75109 9.37731 3.6372C9.11232 2.92106 8.54769 2.35643 7.83155 2.09144C7.71766 2.04929 7.71766 1.88821 7.83155 1.84606C8.54769 1.58107 9.11232 1.01644 9.37731 0.300304Z",
        fill: "currentColor"
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/sparkles.tsx",
        lineNumber: 16,
        columnNumber: 9
      },
      void 0
    )
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/sparkles.tsx",
    lineNumber: 6,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV("defs", { children: /* @__PURE__ */ p.jsxDEV("clipPath", { id: "clip0_318_263", children: /* @__PURE__ */ p.jsxDEV("rect", { width: "16", height: "16", fill: "currentColor", transform: "translate(0.5)" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/sparkles.tsx",
    lineNumber: 24,
    columnNumber: 11
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/sparkles.tsx",
    lineNumber: 23,
    columnNumber: 9
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/sparkles.tsx",
    lineNumber: 22,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/sparkles.tsx",
  lineNumber: 5,
  columnNumber: 5
}, void 0), vh = (e) => /* @__PURE__ */ p.jsxDEV("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M10 .916a1.17 1.17 0 0 1 1.095.762l.029.091.004.015 1.317 5.112a.92.92 0 0 0 .66.658h-.002l5.114 1.319.012.002c.215.06.409.18.557.344l.06.074.055.079a1.167 1.167 0 0 1-.672 1.752l-.012.004-5.113 1.317a.92.92 0 0 0-.62.543l-.039.116-1.318 5.112-.004.015a1.168 1.168 0 0 1-2.251-.015l-1.317-5.112a.92.92 0 0 0-.659-.658l-5.113-1.319-.017-.005a1.17 1.17 0 0 1-.844-1.027L.918 10l.004-.095a1.17 1.17 0 0 1 .844-1.028l.017-.004 5.112-1.319h.001a.92.92 0 0 0 .659-.658l1.318-5.112.004-.015A1.17 1.17 0 0 1 10 .916m-.993 6.355A2.42 2.42 0 0 1 7.27 9.006L3.42 10l3.85.994a2.42 2.42 0 0 1 1.737 1.736l.992 3.854.994-3.854a2.42 2.42 0 0 1 1.736-1.736L16.581 10l-3.851-.992a2.42 2.42 0 0 1-1.737-1.736L10 3.417zm6.91-1.438V2.5a.75.75 0 1 1 1.5 0v3.333a.75.75 0 0 1-1.5 0",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/synthesize.tsx",
      lineNumber: 6,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M18.333 3.417a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1 0-1.5zM2.583 15.834v-1.667a.75.75 0 1 1 1.5 0v1.667a.75.75 0 0 1-1.5 0",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/synthesize.tsx",
      lineNumber: 10,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV("path", { d: "M4.167 14.25a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1 0-1.5z", fill: "currentColor" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/synthesize.tsx",
    lineNumber: 14,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/synthesize.tsx",
  lineNumber: 5,
  columnNumber: 5
}, void 0), TD = (e) => /* @__PURE__ */ p.jsxDEV("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M17.584 10a7.584 7.584 0 1 0-15.168 0 7.584 7.584 0 0 0 15.168 0m1.5 0A9.084 9.084 0 1 1 .915 9.999a9.084 9.084 0 0 1 18.169 0",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/validate.tsx",
      lineNumber: 6,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M11.97 7.803a.75.75 0 1 1 1.06 1.06l-3.333 3.334a.75.75 0 0 1-1.06 0L6.97 10.53a.75.75 0 0 1 1.06-1.06l1.136 1.135z",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/validate.tsx",
      lineNumber: 10,
      columnNumber: 7
    },
    void 0
  )
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/validate.tsx",
  lineNumber: 5,
  columnNumber: 5
}, void 0), AE = (e) => /* @__PURE__ */ p.jsxDEV("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      d: "M19.5606 13.3584C19.7026 12.9378 20.2975 12.9378 20.4395 13.3584L20.4767 13.4685C21.3173 15.9574 23.2009 17.9566 25.6355 18.9438C26.011 19.096 26.011 19.6277 25.6355 19.78C23.2009 20.7672 21.3173 22.7662 20.4767 25.2553L20.4395 25.3654C20.2975 25.786 19.7026 25.786 19.5606 25.3654L19.5234 25.2553C18.6829 22.7662 16.7993 20.7672 14.3646 19.78C13.9891 19.6277 13.9891 19.096 14.3646 18.9438C16.7993 17.9566 18.6829 15.9574 19.5234 13.4685L19.5606 13.3584Z",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/zai-strategist.tsx",
      lineNumber: 6,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      opacity: "0.4",
      d: "M10.3406 8.90916C10.4529 8.60678 10.8806 8.60678 10.9929 8.90916C11.7002 10.8131 13.2067 12.3141 15.1125 13.0165C15.4164 13.1285 15.4164 13.5588 15.1125 13.6708C13.2067 14.3734 11.7002 15.8743 10.9929 17.7782C10.8806 18.0806 10.4529 18.0806 10.3406 17.7782C9.63331 15.8743 8.12679 14.3734 6.22105 13.6708C5.9172 13.5588 5.9172 13.1285 6.22105 13.0165C8.12679 12.3141 9.63331 10.8131 10.3406 8.90916Z",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/zai-strategist.tsx",
      lineNumber: 10,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV(
    "path",
    {
      opacity: "0.4",
      d: "M17.1703 5.77233C17.2264 5.62114 17.4403 5.62114 17.4964 5.77233C17.85 6.7243 18.6034 7.47478 19.5562 7.82601C19.7082 7.88201 19.7082 8.09718 19.5562 8.15318C18.6034 8.50439 17.85 9.25487 17.4964 10.2069C17.4403 10.358 17.2264 10.358 17.1703 10.2069C16.8167 9.25487 16.0634 8.50439 15.1106 8.15318C14.9586 8.09718 14.9586 7.88201 15.1106 7.82601C16.0634 7.47478 16.8167 6.7243 17.1703 5.77233Z",
      fill: "currentColor"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/zai-strategist.tsx",
      lineNumber: 15,
      columnNumber: 7
    },
    void 0
  )
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/assets/icons/zai-strategist.tsx",
  lineNumber: 5,
  columnNumber: 5
}, void 0), yE = () => /* @__PURE__ */ p.jsxDEV("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ p.jsxDEV(AE, { width: 32, height: 32, color: "#FFFFFF" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-with-text.tsx",
    lineNumber: 6,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV("span", { className: "text-2xl font-medium", children: "ZAI" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-with-text.tsx",
    lineNumber: 7,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-with-text.tsx",
  lineNumber: 5,
  columnNumber: 5
}, void 0);
function AD({
  isZaiRagEnabled: e,
  ...t
}) {
  const n = e ? "h-[calc(100%_-_98px)]" : "";
  return /* @__PURE__ */ p.jsxDEV(cD, { ...t, variant: "floating", collapsible: "none", className: `p-4 bg-transparent ${n}`, children: /* @__PURE__ */ p.jsxDEV(hD, { className: "p-0 bg-sidebar h-full rounded-xl", children: [
    /* @__PURE__ */ p.jsxDEV(dD, { className: "p-6", children: /* @__PURE__ */ p.jsxDEV(mD, { children: /* @__PURE__ */ p.jsxDEV(pD, { children: /* @__PURE__ */ p.jsxDEV(yE, {}, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/sidebar.tsx",
      lineNumber: 26,
      columnNumber: 15
    }, this) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/sidebar.tsx",
      lineNumber: 25,
      columnNumber: 13
    }, this) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/sidebar.tsx",
      lineNumber: 24,
      columnNumber: 11
    }, this) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/sidebar.tsx",
      lineNumber: 23,
      columnNumber: 9
    }, this),
    /* @__PURE__ */ p.jsxDEV(fD, { className: "p-6 pt-0", children: /* @__PURE__ */ p.jsxDEV(_E, {}, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/sidebar.tsx",
      lineNumber: 32,
      columnNumber: 11
    }, this) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/sidebar.tsx",
      lineNumber: 31,
      columnNumber: 9
    }, this)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/sidebar.tsx",
    lineNumber: 22,
    columnNumber: 7
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/sidebar.tsx",
    lineNumber: 21,
    columnNumber: 5
  }, this);
}
const NE = Ot(null), St = () => {
  const e = Ct(NE);
  if (!e)
    throw new Error("useAccessContext must be used within an AccessContextProvider");
  return e;
}, yD = {
  "center-stage": "Center Stage",
  "side-chat": "Side Chat",
  "soa-chat": "SOA Chat",
  "demand-intelligence": "Demand Intelligence"
}, vE = Ot(null), Mi = () => {
  const e = Ct(vE);
  if (!e)
    throw new Error("useMixpanelSendMessageSettings must be used within a MixpanelSendMessageSettingsProvider");
  return e;
}, ND = ({ children: e }) => {
  const t = st(null), n = st(null), r = st(null), i = st(null), s = de(({ origin: g }) => {
    t.current = yD[g] || null;
  }, []), a = de(({ page: g }) => {
    n.current = g;
  }, []), o = de((g) => {
    r.current = g;
  }, []), u = de(() => t.current, []), c = de(() => n.current, []), l = de(() => !!r.current, []), d = de(() => {
    r.current = null, n.current = null, i.current = null;
  }, []), h = de((g) => {
    i.current = g;
  }, []), m = de(() => !!i.current, []), E = {
    setOrigin: s,
    getOrigin: u,
    setPage: a,
    getPage: c,
    setIsPrePrompt: o,
    checkIsPrePrompt: l,
    resetIsPrePrompt: d,
    setIsProactiveMessage: h,
    checkIsProactiveMessage: m
  };
  return /* @__PURE__ */ p.jsxDEV(vE.Provider, { value: E, children: e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/mixpanel-send-message-settings/mixpanel-send-message-settings.provider.tsx",
    lineNumber: 57,
    columnNumber: 5
  }, void 0);
}, wE = Ot(void 0), ad = () => {
  const e = Ct(wE);
  if (!e)
    throw new Error("usePrePromptParams must be used within a PrePromptParamsProvider");
  return e;
}, vD = ({ children: e }) => {
  const t = st(null), n = de((a) => {
    t.current = a;
  }, []), r = de(() => t.current, []), i = de(() => {
    t.current = null;
  }, []), s = pe(
    () => ({
      setQuickPromptId: n,
      getQuickPromptId: r,
      resetPrePromptParams: i
    }),
    [r, i, n]
  );
  return /* @__PURE__ */ p.jsxDEV(wE.Provider, { value: s, children: e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/pre-prompt-params/pre-prompt-params.provider.tsx",
    lineNumber: 28,
    columnNumber: 10
  }, void 0);
}, Nt = [];
for (let e = 0; e < 256; ++e)
  Nt.push((e + 256).toString(16).slice(1));
function wD(e, t = 0) {
  return (Nt[e[t + 0]] + Nt[e[t + 1]] + Nt[e[t + 2]] + Nt[e[t + 3]] + "-" + Nt[e[t + 4]] + Nt[e[t + 5]] + "-" + Nt[e[t + 6]] + Nt[e[t + 7]] + "-" + Nt[e[t + 8]] + Nt[e[t + 9]] + "-" + Nt[e[t + 10]] + Nt[e[t + 11]] + Nt[e[t + 12]] + Nt[e[t + 13]] + Nt[e[t + 14]] + Nt[e[t + 15]]).toLowerCase();
}
let Wu;
const CD = new Uint8Array(16);
function SD() {
  if (!Wu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Wu = crypto.getRandomValues.bind(crypto);
  }
  return Wu(CD);
}
const kD = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), wh = { randomUUID: kD };
function ID(e, t, n) {
  if (wh.randomUUID && !e)
    return wh.randomUUID();
  e = e || {};
  const r = e.random ?? e.rng?.() ?? SD();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, wD(r);
}
const CE = {
  // Brand Resources
  get_my_brand: "winnin://brands/me",
  get_my_competitors: "winnin://brands/competitors",
  share_of_engagement_content_and_views: "winnin://brands/share_of_engagement_content_and_views/:provider/:territoryType/:timeRangeInDays",
  get_key_findings: "winnin://brands/me/key_findings/:language",
  get_brand_engagement_histogram: "winnin://brands/engagement/histogram/:provider/:territoryType/:timeRangeInDays",
  get_brand_views_histogram: "winnin://brands/views/histogram/:provider/:territoryType/:timeRangeInDays",
  get_brand_posts_histogram: "winnin://brands/posts/histogram/:provider/:territoryType/:timeRangeInDays",
  // Brand V2 Resources
  get_my_brand_v2: "winnin://brands-v2/me",
  get_my_competitors_v2: "winnin://brands-v2/competitors",
  share_of_engagement_content_and_views_v2: "winnin://brands-v2/share_of_engagement_content_and_views/:provider/:timeRangeInDays",
  get_brand_engagement_histogram_v2: "winnin://brands-v2/engagement/histogram/:provider/:timeRangeInDays",
  get_brand_posts_histogram_v2: "winnin://brands-v2/posts/histogram/:provider/:timeRangeInDays",
  get_brand_views_histogram_v2: "winnin://brands-v2/views/histogram/:provider/:timeRangeInDays",
  // Category Resources
  share_of_attention: "winnin://category/share_of_attention/:year/:period",
  share_of_attention_v2: "winnin://category/share_of_attention/v2/:year/:period",
  get_trending_territories: "winnin://category/trending_territories",
  get_category: "winnin://category",
  // Category V2 Resources
  share_of_attention_v3: "winnin://category-v2/share_of_attention/v3/:industryId/:year/:period",
  get_share_of_attention_industries: "winnin://category-v2/share_of_attention/v3/industries",
  get_share_of_attention_reasoning: "winnin://category-v2/share_of_attention/v3/reasoning/:industryId/:year/:period",
  // Territory Resources
  get_territory_resource: "winnin://territory/:territoryId",
  get_territory_tags_resource: "winnin://territory/:territoryId/:timeRange/tags",
  get_territory_niches_resource: "winnin://territory/:territoryId/:timeRange/niches/:context",
  get_territory_formats_resource: "winnin://territory/:territoryId/:timeRange/formats",
  get_territory_creators_resource: "winnin://territory/:territoryId/:timeRange/creators",
  get_territory_videos_resource: "winnin://territory/:territoryId/:timeRange/videos/:sortBy",
  get_territory_performance_resource: "winnin://territory/:territoryId/:timeRange/metrics",
  get_territory_affinities_resource: "winnin://territory/:territoryId/:timeRange/affinity",
  get_territory_audience_resource: "winnin://territory/:territoryId/:timeRange/audience",
  deep_territory_analysis: "winnin://territory/:territoryId/:timeRange/deep_analysis",
  get_territory_relevance_resource: "winnin://territory/:territoryId/:timeRange/relevance",
  // Winnin Documentation Resources
  about_winnin: "winnin://winnin/about",
  about_relevance_index: "winnin://metrics/relevance_index",
  about_avg_engagement: "winnin://metrics/avg_engagement",
  about_avg_views: "winnin://metrics/avg_views",
  about_total_videos: "winnin://metrics/total_videos",
  metrics_vs_retention: "winnin://metrics/retention",
  about_affinity: "winnin://metrics/affinity_calculation",
  about_relationship_metric: "winnin://metrics/relationship_calculation",
  about_audience: "winnin://audience/data_collection",
  what_are_trending_topics_in_territories: "winnin://trending/topics_in_territories",
  what_are_trending_tags_in_sidebar: "winnin://trending/tags_sidebar",
  what_does_trending_creator_or_subtopic_mean: "winnin://trending/creator_subtopic_meaning",
  why_do_some_creators_appear_without_subscriber_count: "winnin://creators/missing_subscriber_count"
}, an = (e, t = 1) => {
  const n = Math.abs(e), r = e < 0 ? "-" : "";
  let i;
  if (n >= 1e12)
    i = (n / 1e12).toFixed(t) + "T";
  else if (n >= 1e9)
    i = (n / 1e9).toFixed(t) + "B";
  else if (n >= 1e6)
    i = (n / 1e6).toFixed(t) + "M";
  else if (n >= 1e3)
    i = (n / 1e3).toFixed(t) + "K";
  else
    return Number.isInteger(n) ? n : n.toFixed(t);
  return r + i;
};
function DD(e) {
  return e.match(/:(\w+)/g)?.map((t) => t.substring(1)) || [];
}
function Rn(e, t) {
  return Object.entries(t).reduce((n, [r, i]) => n?.replace(new RegExp(`:${r}\\b`, "g"), String(i)), e);
}
const Ci = {
  earned: "earned",
  paid: "paid",
  selfContent: "proprietary-channels",
  owned: "proprietary-channels",
  // 'owned' is the same as 'selfContent'
  grouped: "overview",
  overview: "overview"
  // 'overview' is the same as 'grouped'
}, Ch = {
  earned: {
    skipEarned: !1,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !0
  },
  paid: {
    skipEarned: !0,
    skipPaid: !1,
    skipGrouped: !0,
    skipSelfContent: !0
  },
  grouped: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !1,
    skipSelfContent: !0
  },
  selfContent: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !1
  },
  // 'overview' is the same as 'grouped'
  overview: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !1,
    skipSelfContent: !0
  },
  // 'owned' is the same as 'selfContent'
  owned: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !1
  }
}, RD = "#755CFF", Qe = {
  // Charts
  graph_item_1: "#F7CA00",
  graph_item_2: "#F76D3E",
  graph_item_3: "#3BBA18",
  graph_item_4: "#005DFF",
  graph_item_5: "#EF377A",
  graph_item_6: "#C519F0",
  graph_item_7: "#0EC9F2",
  graph_item_8: "#FD3636",
  graph_item_9: "#A9DC1A",
  graph_item_10: "#FF9B21",
  graph_item_11: "#FA6FA2",
  graph_item_12: "#238508",
  graph_item_13: "#DC5BFC",
  graph_item_14: "#0443B1",
  graph_item_15: "#B5350A",
  graph_item_16: "#00A3FF",
  graph_item_17: "#1ECF8F",
  graph_item_18: "#C4A000",
  graph_item_19: "#D94411",
  graph_item_20: "#780404",
  graph_item_21: "#A2BBCD",
  graph_item_22: "#795E00",
  graph_item_23: "#9570FF",
  graph_item_24: "#0086A4",
  graph_item_25: "#510090",
  graph_item_26: "#9F007C",
  graph_item_27: "#1B654A",
  graph_item_28: "#474747",
  graph_item_29: "#909C00",
  graph_item_30: "#24FF00",
  winnin: RD
}, Sh = [
  Qe.graph_item_1,
  Qe.graph_item_2,
  Qe.graph_item_3,
  Qe.graph_item_4,
  Qe.graph_item_5,
  Qe.graph_item_6,
  Qe.graph_item_7,
  Qe.graph_item_8,
  Qe.graph_item_9,
  Qe.graph_item_10,
  Qe.graph_item_11,
  Qe.graph_item_12,
  Qe.graph_item_13,
  Qe.graph_item_14,
  Qe.graph_item_15,
  Qe.graph_item_16,
  Qe.graph_item_17,
  Qe.graph_item_18,
  Qe.graph_item_19,
  Qe.graph_item_20,
  Qe.graph_item_21,
  Qe.graph_item_22,
  Qe.graph_item_23,
  Qe.graph_item_24,
  Qe.graph_item_25,
  Qe.graph_item_26,
  Qe.graph_item_27,
  Qe.graph_item_28,
  Qe.graph_item_29,
  Qe.graph_item_30
];
class PD {
  constructor() {
    this.baseUrl = "";
  }
}
const od = new PD(), An = (e) => e.replace(/\//g, "\\/").replace(/:\w+/g, `[^\\/\\s)"'\\],.;:><!?|#]+(?:\\.[^\\/\\s)"'\\],.;:><!?|#]+)*`) + `(?=[\\s)"'\\],;:><!?|#]|\\.(?:[^\\w]|$)|$)`, Pe = "winnin://", le = {
  // Brand Resources
  GET_KEY_FINDINGS: `${Pe}brands/me/key_findings/:language`,
  GET_MY_BRAND: `${Pe}brands/me`,
  GET_MY_COMPETITORS: `${Pe}brands/competitors`,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS: `${Pe}brands/share_of_engagement_content_and_views/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE: `${Pe}brands/engagement/histogram/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_VIEWS_HISTOGRAM: `${Pe}brands/views/histogram/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_POSTS_HISTOGRAM: `${Pe}brands/posts/histogram/:provider/:territoryType/:timeRangeInDays`,
  // Brand V2 Resources
  GET_MY_BRAND_V2: `${Pe}brands-v2/me`,
  GET_MY_COMPETITORS_V2: `${Pe}brands-v2/competitors`,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2: `${Pe}brands-v2/share_of_engagement_content_and_views/:provider/:timeRangeInDays`,
  GET_BRAND_ENGAGEMENT_HISTOGRAM_V2: `${Pe}brands-v2/engagement/histogram/:provider/:timeRangeInDays`,
  GET_BRAND_POSTS_HISTOGRAM_V2: `${Pe}brands-v2/posts/histogram/:provider/:timeRangeInDays`,
  GET_BRAND_VIEWS_HISTOGRAM_V2: `${Pe}brands-v2/views/histogram/:provider/:timeRangeInDays`,
  // Category Resources
  SHARE_OF_ATTENTION_V2: `${Pe}category/share_of_attention/v2/:year/:period`,
  SHARE_OF_ATTENTION: `${Pe}category/share_of_attention/:year/:period`,
  GET_TRENDING_TERRITORIES: `${Pe}category/trending_territories`,
  GET_CATEGORY: `${Pe}category`,
  // Category V2 Resources
  GET_SHARE_OF_ATTENTION_REASONING: `${Pe}category-v2/share_of_attention/v3/reasoning/:industryId/:year/:period`,
  SHARE_OF_ATTENTION_V3: `${Pe}category-v2/share_of_attention/v3/:industryId/:year/:period`,
  GET_SHARE_OF_ATTENTION_INDUSTRIES: `${Pe}category-v2/share_of_attention/v3/industries`,
  // Territory Resources
  GET_TERRITORY_NICHES_RESOURCE: `${Pe}territory/:territoryId/:timeRange/niches/:context`,
  GET_TERRITORY_VIDEOS_RESOURCE: `${Pe}territory/:territoryId/:timeRange/videos/:sortBy`,
  GET_TERRITORY_TAGS_RESOURCE: `${Pe}territory/:territoryId/:timeRange/tags`,
  GET_TERRITORY_FORMATS_RESOURCE: `${Pe}territory/:territoryId/:timeRange/formats`,
  GET_TERRITORY_CREATORS_RESOURCE: `${Pe}territory/:territoryId/:timeRange/creators`,
  GET_TERRITORY_PERFORMANCE_RESOURCE: `${Pe}territory/:territoryId/:timeRange/metrics`,
  GET_TERRITORY_AFFINITIES_RESOURCE: `${Pe}territory/:territoryId/:timeRange/affinity`,
  GET_TERRITORY_AUDIENCE_RESOURCE: `${Pe}territory/:territoryId/:timeRange/audience`,
  DEEP_ANALYSIS_RESOURCE: `${Pe}territory/:territoryId/:timeRange/deep_analysis`,
  GET_TERRITORY_RELEVANCE_RESOURCE: `${Pe}territory/:territoryId/:timeRange/relevance`,
  GET_TERRITORY_RESOURCE: `${Pe}territory/:territoryId`,
  // Other
  POST: `${Pe}post/:provider/:id`,
  CREATOR: `${Pe}creator/:provider/:id`,
  // Winnin Documentation Resources
  ABOUT_WINNIN: `${Pe}winnin/about`,
  ABOUT_RELEVANCE_INDEX: `${Pe}metrics/relevance_index`,
  ABOUT_AVG_ENGAGEMENT: `${Pe}metrics/avg_engagement`,
  ABOUT_AVG_VIEWS: `${Pe}metrics/avg_views`,
  ABOUT_TOTAL_VIDEOS: `${Pe}metrics/total_videos`,
  METRICS_VS_RETENTION: `${Pe}metrics/retention`,
  ABOUT_AFFINITY: `${Pe}metrics/affinity_calculation`,
  ABOUT_RELATIONSHIP_METRIC: `${Pe}metrics/relationship_calculation`,
  ABOUT_AUDIENCE: `${Pe}audience/data_collection`,
  WHAT_ARE_TRENDING_TOPICS_IN_TERRITORIES: `${Pe}trending/topics_in_territories`,
  WHAT_ARE_TRENDING_TAGS_IN_SIDEBAR: `${Pe}trending/tags_sidebar`,
  WHAT_DOES_TRENDING_CREATOR_OR_SUBTOPIC_MEAN: `${Pe}trending/creator_subtopic_meaning`,
  WHY_DO_SOME_CREATORS_APPEAR_WITHOUT_SUBSCRIBER_COUNT: `${Pe}creators/missing_subscriber_count`
}, Ca = {
  SHARE_OF_ATTENTION: [le.SHARE_OF_ATTENTION, le.GET_TRENDING_TERRITORIES],
  BRAND: [le.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]
}, Ke = od.baseUrl, mr = {
  [le.GET_MY_BRAND]: `${Ke}/workspace/:panelId/brands/overview`,
  [le.GET_MY_COMPETITORS]: `${Ke}/workspace/:panelId/brands/overview`,
  [le.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]: `${Ke}/workspace/:panelId/brands/:tab`,
  [le.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2]: `${Ke}/workspace/:panelId/brands/overview`,
  [le.GET_KEY_FINDINGS]: `${Ke}/workspace/:panelId/brands/overview`,
  [le.SHARE_OF_ATTENTION]: `${Ke}/workspace/:panelId/share-of-attention`,
  [le.SHARE_OF_ATTENTION_V2]: `${Ke}/workspace/:panelId/share-of-attention`,
  [le.SHARE_OF_ATTENTION_V3]: `${Ke}/workspace/:panelId/share-of-attention`,
  [le.GET_TRENDING_TERRITORIES]: `${Ke}/workspace/:panelId`,
  [le.GET_TERRITORY_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/overview`,
  [le.GET_TERRITORY_TAGS_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/hashtags`,
  [le.GET_TERRITORY_NICHES_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/niches`,
  [le.GET_TERRITORY_FORMATS_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/formats`,
  [le.GET_TERRITORY_CREATORS_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/creators`,
  [le.GET_TERRITORY_VIDEOS_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/videos`,
  [le.GET_TERRITORY_PERFORMANCE_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/performance`,
  [le.GET_TERRITORY_AFFINITIES_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/people-also-watch`,
  [le.GET_TERRITORY_AUDIENCE_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/audience`,
  [le.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE]: `${Ke}/workspace/:panelId/brands/:tab`,
  [le.GET_BRAND_VIEWS_HISTOGRAM]: `${Ke}/workspace/:panelId/brands/:tab`,
  [le.GET_BRAND_POSTS_HISTOGRAM]: `${Ke}/workspace/:panelId/brands/:tab`,
  [le.GET_MY_BRAND_V2]: `${Ke}/workspace/:panelId/brands/overview`,
  [le.GET_MY_COMPETITORS_V2]: `${Ke}/workspace/:panelId/brands/overview`,
  [le.GET_BRAND_ENGAGEMENT_HISTOGRAM_V2]: `${Ke}/workspace/:panelId/brands/:tab`,
  [le.GET_BRAND_POSTS_HISTOGRAM_V2]: `${Ke}/workspace/:panelId/brands/:tab`,
  [le.GET_BRAND_VIEWS_HISTOGRAM_V2]: `${Ke}/workspace/:panelId/brands/:tab`,
  [le.GET_CATEGORY]: `${Ke}/workspace/:panelId/share-of-attention`,
  [le.GET_SHARE_OF_ATTENTION_INDUSTRIES]: `${Ke}/workspace/:panelId/share-of-attention`,
  [le.GET_SHARE_OF_ATTENTION_REASONING]: `${Ke}/workspace/:panelId/share-of-attention`,
  [le.GET_TERRITORY_RELEVANCE_RESOURCE]: `${Ke}/workspace/:panelId/:territoryType/:entityId/performance`,
  [le.POST]: `${Ke}/workspace/:panelId/post/:provider/:id`,
  [le.CREATOR]: `${Ke}/creator/:id/:provider`
}, bt = {
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS: le.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2: le.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2,
  SHARE_OF_ATTENTION: le.SHARE_OF_ATTENTION,
  SHARE_OF_ATTENTION_V2: le.SHARE_OF_ATTENTION_V2,
  SHARE_OF_ATTENTION_V3: le.SHARE_OF_ATTENTION_V3,
  GET_TERRITORY_PERFORMANCE_RESOURCE: le.GET_TERRITORY_PERFORMANCE_RESOURCE,
  GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE: le.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE,
  POST: le.POST,
  CREATOR: le.CREATOR
}, OD = [
  {
    pattern: new RegExp(
      An(bt.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS),
      "g"
    ),
    replacement: (e) => `<embed data-type="shares" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(
      An(bt.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2),
      "g"
    ),
    replacement: (e) => `<embed data-type="shares" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(An(bt.SHARE_OF_ATTENTION_V3), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(An(bt.SHARE_OF_ATTENTION_V2), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(An(bt.SHARE_OF_ATTENTION), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(An(bt.GET_TERRITORY_PERFORMANCE_RESOURCE), "g"),
    replacement: (e) => `<embed data-type="territory-performance" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(
      An(bt.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE),
      "g"
    ),
    replacement: (e) => `<embed data-type="brand-engagement-over-time" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(An(bt.POST), "g"),
    replacement: (e) => `<embed data-type="post" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(An(bt.CREATOR), "g"),
    replacement: (e) => `<embed data-type="creator" data-uri="${e}"></embed>`
  }
], ud = {
  yt: "YouTube",
  fb: "Facebook",
  in: "Instagram",
  tt: "TikTok",
  tw: "Twitter",
  all: "All Providers"
}, Sa = { fb: !0, tt: !0, yt: !0, in: !0, tw: !0 }, cd = {
  topic: "topic",
  subtopic: "subtopic",
  global_topic: "global-topic",
  niche: "niche",
  saved_search: "saved-search",
  brand_territory: "brand",
  trending_subject: "trending-tag",
  trending: "trending",
  brand_group: "brand-group",
  tag: "tag",
  industry_topic: "industry-category"
};
class LD {
  /**
   * @param customSettings string in the format: `{ color: string }` or just the color string
   */
  parseColorFromSettings(t, n) {
    const r = t?.trim();
    try {
      const s = JSON.parse(r ?? "");
      if (s?.color)
        return s.color;
    } catch {
      if (r?.startsWith("#") || r?.startsWith("rgba") || r?.startsWith("rgb"))
        return r;
    }
    return Sh[n % Sh.length];
  }
  /**
   * Get color from brand, checking brand.color, brand.brandColor, then customSettings, then default
   */
  getBrandColor(t, n) {
    return t.color ? t.color : t.brandColor ? t.brandColor : this.parseColorFromSettings(t.customSettings, n);
  }
  getMetricKeyByTerritoryType(t) {
    const n = {
      earned: "earnedTerritory",
      paid: "paidTerritory",
      selfContent: "selfContentTerritory",
      owned: "selfContentTerritory",
      // 'owned' is the same as 'selfContent'
      grouped: "groupedTerritory",
      overview: "groupedTerritory"
      // 'overview' is the same as 'grouped'
    };
    return n[t] || n.grouped;
  }
}
const di = new LD(), kh = (e) => {
  const n = [3, 6, 12, 24, 36, 61], r = Math.floor(e / 30);
  return n.includes(r) ? {
    timeUnit: "month",
    timeValue: r
  } : {
    timeUnit: "day",
    timeValue: e
  };
}, MD = (e) => {
  const t = e.split(":");
  if (t.length === 2) {
    const n = new Date(t[0]), r = new Date(t[1]);
    if (!isNaN(n.getTime()) && !isNaN(r.getTime()))
      return {
        gte: Math.floor(n.getTime()),
        lte: Math.floor(r.getTime())
      };
  }
}, $u = (e) => typeof e == "string" && e.includes(":") ? { publishedAt: MD(e), timeRange: null } : typeof e == "number" ? { timeRange: kh(e), publishedAt: null } : typeof e == "string" && !isNaN(Number(e)) ? { timeRange: kh(Number(e)), publishedAt: null } : {}, UD = function() {
  if (window.location.hostname === "localhost")
    return "local";
  const t = window.location.href, n = /^([^.]+\/)(\b((?!insights\b)[\s\S])+)/;
  if (n.test(t)) {
    const i = n.exec(t);
    if (!i)
      return "production";
    switch (i[2]) {
      // temporary production environment for testing
      case "production.":
        return "production";
      case "staging.":
        return "staging";
      case "local.":
        return "local";
      case "dev.":
        return "development";
      default:
        return i[2].includes("testprod") ? "staging" : "development";
    }
  }
  return "production";
}, HD = Object.values(bt), jD = Object.values(le).filter((e) => !HD.includes(e)).map(An), BD = (e) => jD.reduce((t, n) => {
  const r = new RegExp(
    // Negative lookbehind to avoid matching URIs preceded by quotes
    `(?<!")(?<!')(${n})(?!")(?!')`,
    "g"
  );
  return t.replace(r, "");
}, e), Ih = (e, t) => {
  const n = "yt|fb|in|tt|tw", r = new RegExp(
    `(?<!\\]\\([^\\)]*?)(?:winnin://)?(${t}):(${n}):([a-zA-Z0-9_-]+)(?=\\s|$|\\.|,|\\))`,
    "g"
  ), i = new RegExp(
    `\\[([^\\]]+)\\]\\((?:winnin://)?(${t}):(${n}):([a-zA-Z0-9_-]+)\\)`,
    "g"
  );
  let s = e;
  return s = s.replace(
    i,
    (a, o, u, c, l) => `winnin://${u}/${c}/${l}`
  ), s = s.replace(
    r,
    (a, o, u, c) => `winnin://${o}/${u}/${c}`
  ), s;
}, SE = (e, t, n = "overview") => {
  const [r, i] = t.split("."), s = cd[r];
  return s ? `${od.baseUrl}/workspace/${e}/${s}/${i}/${n}` : "";
}, FD = (e, t) => {
  const n = "global_topic|industry_topic|topic|subtopic|niche|saved_search|brand_territory|trending_subject|trending|brand_group", r = new RegExp(
    // 1) In markdown link format with and without "winnin://" [text](winnin://brand_territory.abc-123) or [text](brand_territory.abc-123)
    `\\[(?<text>[^\\]]+)\\]\\((?:winnin://)?(?<fullMatch>(${n})\\.([a-zA-Z0-9_-]+))\\)|\\[(?<onlyBrackets>(${n})\\.([a-zA-Z0-9_-]+))\\]|(?<!\\]\\([^\\)]*?)(?<!/)(?<!winnin://)(?<loose>(${n})\\.([a-zA-Z0-9_-]+))(?!/|\\?)(?=\\s|$|\\.|,|\\)|\\])`,
    "g"
  );
  return t.replace(r, (s, ...a) => {
    const o = a.at(-1), u = o.fullMatch || o.onlyBrackets || o.loose;
    if (!u) return s;
    const c = SE(e, u);
    return `[${o.text || u}](${c})`;
  });
}, zD = (e) => OD.reduce((t, { pattern: n, replacement: r }) => t.replace(n, r), e);
function Tt(e, t = {}) {
  const n = typeof t == "string" ? { path: t, exact: !1, strict: !1, sensitive: !1 } : {
    path: t.path,
    exact: t.exact ?? !1,
    strict: t.strict ?? !1,
    sensitive: t.sensitive ?? !1
  }, { path: r, exact: i, strict: s, sensitive: a } = n;
  if (!r) return null;
  const o = [], u = r.replace(/\/$/, s ? "/" : "/?").replace(/:(\w+)/g, (g, T) => (o.push({ name: T }), "([^\\/]+)")).replace(/\*/g, "(.*)"), c = a ? "" : "i", d = new RegExp("^" + u + (i ? "$" : ""), c).exec(e);
  if (!d) return null;
  const h = d[0], m = e === h;
  if (i && !m) return null;
  const E = o.reduce(
    (g, T, _) => (g[T.name] = d[_ + 1] || "", g),
    {}
  );
  return { path: r, url: h, isExact: m, params: E };
}
const VD = (e, t) => t.replace(
  /<embed data-type="(shares|share-of-attention)" data-uri="([^"]+)"><\/embed>/g,
  (n, r, i) => {
    if (!Object.values(le).find(
      (o) => Tt(i, { path: o, exact: !0 })
    )) return n;
    const a = Rn(mr[le.SHARE_OF_ATTENTION_V2], {
      panelId: e
    });
    return `[${a}](${a})`;
  }
);
class ld {
  constructor(t, n) {
    this.workspaceId = t, this.text = n;
  }
  replaceText(t) {
    return this.text = t, this;
  }
  /**
   * Replaces territory IDs in the text with markdown links.
   */
  replaceTerritoryIds() {
    const t = FD(this.workspaceId, this.text);
    return this.replaceText(t);
  }
  /**
   * Replaces post IDs in the text with markdown links.
   */
  replacePostIds() {
    const t = Ih(this.text, "post");
    return this.replaceText(t);
  }
  /**
   * Replaces creator IDs in the text with markdown links.
   */
  replaceCreatorIds() {
    const t = Ih(this.text, "creator");
    return this.replaceText(t);
  }
  /**
   * Replaces specific URI patterns in the text with corresponding widget embed tags.
   */
  replaceWidgets() {
    const t = zD(this.text);
    return this.replaceText(t);
  }
  cleanUnusedURIs() {
    const t = BD(this.text);
    return this.replaceText(t);
  }
  /**
   * Replaces widget embed tags with macroarea links.
   */
  replaceWidgetTagWithLink() {
    const t = VD(this.workspaceId, this.text);
    return this.replaceText(t);
  }
  /**
   * @returns The final text with all replacements made.
   */
  build() {
    return this.text;
  }
}
const WD = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, $D = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, YD = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function GD(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    qD(e);
    return;
  }
  return t;
}
function qD(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function kE(e, t = {}) {
  if (typeof e != "string")
    return e;
  if (e[0] === '"' && e[e.length - 1] === '"' && e.indexOf("\\") === -1)
    return e.slice(1, -1);
  const n = e.trim();
  if (n.length <= 9)
    switch (n.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!YD.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (WD.test(e) || $D.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, GD);
    }
    return JSON.parse(e);
  } catch (r) {
    if (t.strict)
      throw r;
    return e;
  }
}
function Dh(e) {
  if (!e)
    return {
      id: null,
      metadata: null,
      data: null,
      mimetype: null,
      encoding: null,
      path: null
    };
  if (typeof e.data == "string")
    try {
      e.data = kE(e.data);
    } catch (t) {
      console.error("Failed to parse tool result data:", t), e.data = null;
    }
  return e;
}
function IE(e) {
  if (!e) return [];
  if (typeof e == "string")
    try {
      return e = kE(e), Array.isArray(e) ? e.map(Dh) : [Dh(e)];
    } catch (t) {
      return console.error("Failed to parse tool result:", t), [];
    }
  return e;
}
const Rh = {
  local: "http://localhost:3000",
  development: "https://zai-chat.dev.insights.winnin.com",
  staging: "https://zai-chat-staging.insights.winnin.com",
  production: "https://chat.insights.winnin.com"
};
class KD {
  constructor(t) {
    this.workspaceId = t.workspaceId, this.getValidToken = t.getValidToken, this.userId = t.userId, this.userEmail = t.userEmail, this.abortSignal = t.abortSignal, this.baseUrl = this.getBaseURLByEnvironment();
  }
  getBaseURLByEnvironment() {
    const t = UD();
    return Rh[t] || Rh.development;
  }
  async getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await this.getValidToken()}`
    };
  }
  async getPrePrompts(t) {
    const n = new URLSearchParams({ language: t }), r = `${this.baseUrl}/api/workspace/${this.workspaceId}/prompt?${n.toString()}`;
    try {
      const i = await this.getHeaders(), s = await fetch(r, {
        method: "GET",
        headers: i
      });
      if (!s.ok)
        throw new Error(`Failed to fetch prompts: ${s.statusText}`);
      return await s.json() ?? [];
    } catch (i) {
      throw console.error({
        log: "Zai Chat - Error to fetch pre prompts from backend",
        query: { name: r },
        error: i
      }), i;
    }
  }
  async getThreads() {
    const t = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads`;
    try {
      const n = await this.getHeaders(), r = await fetch(t, {
        method: "GET",
        headers: n
      });
      if (!r.ok)
        throw new Error(`Failed to fetch threads: ${r.statusText}`);
      return await r.json();
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch threads from backend",
        query: { name: t },
        error: n
      }), n;
    }
  }
  async getMessagesByThreadId(t) {
    const n = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads/${t}`;
    try {
      const r = await this.getHeaders(), i = await fetch(n, {
        method: "GET",
        headers: r
      });
      if (!i.ok)
        throw new Error(`Failed to fetch thread: ${i.statusText}`);
      return await i.json();
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch messages by thread ID from backend",
        query: { name: n },
        error: r
      }), r;
    }
  }
  async deleteThread(t) {
    const n = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads/${t}`;
    try {
      const r = await this.getHeaders(), i = await fetch(n, {
        method: "DELETE",
        headers: r
      });
      if (!i.ok)
        throw new Error(`Failed to delete thread: ${i.statusText}`);
      return await i.json();
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error deleting thread in backend",
        query: { name: n, variables: { threadId: t, workspaceId: this.workspaceId } },
        error: r
      }), r;
    }
  }
  async postMessageToThread(t, n, r = {}) {
    const i = `${this.baseUrl}/api/workspace/${this.workspaceId}/chat`, s = JSON.stringify({
      thread: t,
      ...n
    });
    try {
      const a = await this.getHeaders(), o = await fetch(i, {
        method: "POST",
        headers: a,
        body: s,
        signal: r?.abortSignal || this.abortSignal
      });
      if (!o.ok)
        throw new Error(`Failed to post message: ${o.statusText}`);
      return o.body?.getReader();
    } catch (a) {
      throw console.error({
        log: "Zai Chat - Error to post message to thread in backend",
        query: { name: i, variables: { body: s } },
        error: a
      }), a;
    }
  }
  // This method is not currently being used, but it will be useful in the future when we migrate message processing to the frontend.
  static processThreadMessages(t, n) {
    const r = t.filter((a) => a.role === "tool").reduce((a, o) => {
      const u = o;
      return a[u.content.kwargs.tool_call_id] = {
        content: u.content.kwargs.content,
        status: u.content.kwargs.status
      }, a;
    }, {});
    return t.filter((a) => a.role !== "tool").map((a) => {
      switch (a.role) {
        case "user":
          return {
            id: crypto.randomUUID(),
            metadata: {},
            role: "user",
            attachments: [],
            content: [{ type: "text", text: a.content }],
            createdAt: new Date(a.created_at),
            status: { type: "complete", reason: "stop" }
          };
        case "assistant": {
          if (typeof a.content == "string") {
            const h = new ld(n, a.content).replaceTerritoryIds().replacePostIds().replaceCreatorIds().replaceWidgets().cleanUnusedURIs().build();
            return {
              id: crypto.randomUUID(),
              metadata: {},
              role: "assistant",
              content: [{ type: "text", text: h }],
              createdAt: new Date(a.created_at),
              status: { type: "complete", reason: "stop" }
            };
          }
          const o = a.content;
          let u;
          try {
            u = JSON.parse(o.arguments);
          } catch {
            console.log("Failed to parse arguments:", o.arguments);
          }
          const c = u?.resource_uri;
          let l = CE[o.name];
          l && (l = Rn(l, u));
          const d = r[o.id];
          return {
            id: crypto.randomUUID(),
            metadata: {},
            createdAt: new Date(a.created_at),
            role: "assistant",
            content: [
              {
                type: "tool-call",
                toolCallId: o.id,
                toolName: o.name,
                args: u,
                argsText: c || l,
                result: IE(d?.content) || null
              }
            ],
            status: d ? { type: "complete", reason: "stop" } : { type: "requires-action", reason: "tool-calls" }
          };
        }
        default:
          return {};
      }
    }).reduce(
      (a, o) => {
        const u = a.messages[a.messages.length - 1] || null;
        if (u?.message.role === o.role && u.message.id === a.lastId) {
          const c = a.messages[a.messages.length - 1].message.content;
          a.messages[a.messages.length - 1].message.content = [...c, ...o.content], a.messages[a.messages.length - 1].message.status = o.status;
        } else {
          const c = o.id;
          a.messages.push({ message: o, parentId: a.lastId }), a.lastId = c;
        }
        return a;
      },
      { messages: [], lastId: null }
    ).messages;
  }
}
const dd = (e) => {
  const { workspaceId: t, userId: n, userEmail: r, getValidToken: i } = St();
  return pe(
    () => new KD({
      workspaceId: t,
      getValidToken: i,
      userId: n,
      userEmail: r,
      abortSignal: e?.abortSignal
    }),
    [t, n, r, i, e?.abortSignal]
  );
}, DE = Ce(
  ({ children: e, currentThread: t }) => {
    const n = dd(), r = oe((u) => u?.threadListItem?.remoteId), i = oe((u) => u?.threadListItem?.id), s = oe((u) => u?.threads?.mainThreadId);
    i === s && (t.current = r ?? null);
    const a = pe(
      () => ({
        async load() {
          return r ? { messages: await n.getMessagesByThreadId(r) } : { messages: [] };
        },
        async append() {
        }
      }),
      [r, n]
    ), o = pe(() => ({ history: a }), [a]);
    return /* @__PURE__ */ p.jsxDEV(Nl, { adapters: o, children: e }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/adapter-provider.tsx",
      lineNumber: 46,
      columnNumber: 12
    }, void 0);
  }
);
DE.displayName = "ThreadAdapterProvider";
const QD = ({ currentThread: e }) => (t) => /* @__PURE__ */ p.jsxDEV(DE, { currentThread: e, ...t }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/adapter-provider.tsx",
  lineNumber: 53,
  columnNumber: 53
}, void 0);
new TextEncoder();
const XD = 4096;
function RE(e, t, n) {
  let r = t;
  const i = r + n, s = [];
  let a = "";
  for (; r < i; ) {
    const o = e[r++];
    if ((o & 128) === 0)
      s.push(o);
    else if ((o & 224) === 192) {
      const u = e[r++] & 63;
      s.push((o & 31) << 6 | u);
    } else if ((o & 240) === 224) {
      const u = e[r++] & 63, c = e[r++] & 63;
      s.push((o & 31) << 12 | u << 6 | c);
    } else if ((o & 248) === 240) {
      const u = e[r++] & 63, c = e[r++] & 63, l = e[r++] & 63;
      let d = (o & 7) << 18 | u << 12 | c << 6 | l;
      d > 65535 && (d -= 65536, s.push(d >>> 10 & 1023 | 55296), d = 56320 | d & 1023), s.push(d);
    } else
      s.push(o);
    s.length >= XD && (a += String.fromCharCode(...s), s.length = 0);
  }
  return s.length > 0 && (a += String.fromCharCode(...s)), a;
}
const JD = new TextDecoder(), ZD = 200;
function eR(e, t, n) {
  const r = e.subarray(t, t + n);
  return JD.decode(r);
}
function tR(e, t, n) {
  return n > ZD ? eR(e, t, n) : RE(e, t, n);
}
class ka {
  constructor(t, n) {
    O(this, "type");
    O(this, "data");
    this.type = t, this.data = n;
  }
}
class qt extends Error {
  constructor(t) {
    super(t);
    const n = Object.create(qt.prototype);
    Object.setPrototypeOf(this, n), Object.defineProperty(this, "name", {
      configurable: !0,
      enumerable: !1,
      value: qt.name
    });
  }
}
const ns = 4294967295;
function nR(e, t, n) {
  const r = Math.floor(n / 4294967296), i = n;
  e.setUint32(t, r), e.setUint32(t + 4, i);
}
function PE(e, t) {
  const n = e.getInt32(t), r = e.getUint32(t + 4);
  return n * 4294967296 + r;
}
function rR(e, t) {
  const n = e.getUint32(t), r = e.getUint32(t + 4);
  return n * 4294967296 + r;
}
const iR = -1, sR = 4294967296 - 1, aR = 17179869184 - 1;
function oR({ sec: e, nsec: t }) {
  if (e >= 0 && t >= 0 && e <= aR)
    if (t === 0 && e <= sR) {
      const n = new Uint8Array(4);
      return new DataView(n.buffer).setUint32(0, e), n;
    } else {
      const n = e / 4294967296, r = e & 4294967295, i = new Uint8Array(8), s = new DataView(i.buffer);
      return s.setUint32(0, t << 2 | n & 3), s.setUint32(4, r), i;
    }
  else {
    const n = new Uint8Array(12), r = new DataView(n.buffer);
    return r.setUint32(0, t), nR(r, 4, e), n;
  }
}
function uR(e) {
  const t = e.getTime(), n = Math.floor(t / 1e3), r = (t - n * 1e3) * 1e6, i = Math.floor(r / 1e9);
  return {
    sec: n + i,
    nsec: r - i * 1e9
  };
}
function cR(e) {
  if (e instanceof Date) {
    const t = uR(e);
    return oR(t);
  } else
    return null;
}
function lR(e) {
  const t = new DataView(e.buffer, e.byteOffset, e.byteLength);
  switch (e.byteLength) {
    case 4:
      return { sec: t.getUint32(0), nsec: 0 };
    case 8: {
      const n = t.getUint32(0), r = t.getUint32(4), i = (n & 3) * 4294967296 + r, s = n >>> 2;
      return { sec: i, nsec: s };
    }
    case 12: {
      const n = PE(t, 4), r = t.getUint32(0);
      return { sec: n, nsec: r };
    }
    default:
      throw new qt(`Unrecognized data size for timestamp (expected 4, 8, or 12): ${e.length}`);
  }
}
function dR(e) {
  const t = lR(e);
  return new Date(t.sec * 1e3 + t.nsec / 1e6);
}
const fR = {
  type: iR,
  encode: cR,
  decode: dR
}, yo = class yo {
  constructor() {
    // ensures ExtensionCodecType<X> matches ExtensionCodec<X>
    // this will make type errors a lot more clear
    // eslint-disable-next-line @typescript-eslint/naming-convention
    O(this, "__brand");
    // built-in extensions
    O(this, "builtInEncoders", []);
    O(this, "builtInDecoders", []);
    // custom extensions
    O(this, "encoders", []);
    O(this, "decoders", []);
    this.register(fR);
  }
  register({ type: t, encode: n, decode: r }) {
    if (t >= 0)
      this.encoders[t] = n, this.decoders[t] = r;
    else {
      const i = -1 - t;
      this.builtInEncoders[i] = n, this.builtInDecoders[i] = r;
    }
  }
  tryToEncode(t, n) {
    for (let r = 0; r < this.builtInEncoders.length; r++) {
      const i = this.builtInEncoders[r];
      if (i != null) {
        const s = i(t, n);
        if (s != null) {
          const a = -1 - r;
          return new ka(a, s);
        }
      }
    }
    for (let r = 0; r < this.encoders.length; r++) {
      const i = this.encoders[r];
      if (i != null) {
        const s = i(t, n);
        if (s != null) {
          const a = r;
          return new ka(a, s);
        }
      }
    }
    return t instanceof ka ? t : null;
  }
  decode(t, n, r) {
    const i = n < 0 ? this.builtInDecoders[-1 - n] : this.decoders[n];
    return i ? i(t, n, r) : new ka(n, t);
  }
};
O(yo, "defaultCodec", new yo());
let $c = yo;
function hR(e) {
  return e instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && e instanceof SharedArrayBuffer;
}
function Ph(e) {
  return e instanceof Uint8Array ? e : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : hR(e) ? new Uint8Array(e) : Uint8Array.from(e);
}
function Yu(e) {
  return `${e < 0 ? "-" : ""}0x${Math.abs(e).toString(16).padStart(2, "0")}`;
}
const mR = 16, pR = 16;
class gR {
  constructor(t = mR, n = pR) {
    O(this, "hit", 0);
    O(this, "miss", 0);
    O(this, "caches");
    O(this, "maxKeyLength");
    O(this, "maxLengthPerKey");
    this.maxKeyLength = t, this.maxLengthPerKey = n, this.caches = [];
    for (let r = 0; r < this.maxKeyLength; r++)
      this.caches.push([]);
  }
  canBeCached(t) {
    return t > 0 && t <= this.maxKeyLength;
  }
  find(t, n, r) {
    const i = this.caches[r - 1];
    e: for (const s of i) {
      const a = s.bytes;
      for (let o = 0; o < r; o++)
        if (a[o] !== t[n + o])
          continue e;
      return s.str;
    }
    return null;
  }
  store(t, n) {
    const r = this.caches[t.length - 1], i = { bytes: t, str: n };
    r.length >= this.maxLengthPerKey ? r[Math.random() * r.length | 0] = i : r.push(i);
  }
  decode(t, n, r) {
    const i = this.find(t, n, r);
    if (i != null)
      return this.hit++, i;
    this.miss++;
    const s = RE(t, n, r), a = Uint8Array.prototype.slice.call(t, n, n + r);
    return this.store(a, s), s;
  }
}
const Yc = "array", Es = "map_key", OE = "map_value", bR = (e) => {
  if (typeof e == "string" || typeof e == "number")
    return e;
  throw new qt("The type of key must be string or number but " + typeof e);
};
class ER {
  constructor() {
    O(this, "stack", []);
    O(this, "stackHeadPosition", -1);
  }
  get length() {
    return this.stackHeadPosition + 1;
  }
  top() {
    return this.stack[this.stackHeadPosition];
  }
  pushArrayState(t) {
    const n = this.getUninitializedStateFromPool();
    n.type = Yc, n.position = 0, n.size = t, n.array = new Array(t);
  }
  pushMapState(t) {
    const n = this.getUninitializedStateFromPool();
    n.type = Es, n.readCount = 0, n.size = t, n.map = {};
  }
  getUninitializedStateFromPool() {
    if (this.stackHeadPosition++, this.stackHeadPosition === this.stack.length) {
      const t = {
        type: void 0,
        size: 0,
        array: void 0,
        position: 0,
        readCount: 0,
        map: void 0,
        key: null
      };
      this.stack.push(t);
    }
    return this.stack[this.stackHeadPosition];
  }
  release(t) {
    if (this.stack[this.stackHeadPosition] !== t)
      throw new Error("Invalid stack state. Released state is not on top of the stack.");
    if (t.type === Yc) {
      const r = t;
      r.size = 0, r.array = void 0, r.position = 0, r.type = void 0;
    }
    if (t.type === Es || t.type === OE) {
      const r = t;
      r.size = 0, r.map = void 0, r.readCount = 0, r.type = void 0;
    }
    this.stackHeadPosition--;
  }
  reset() {
    this.stack.length = 0, this.stackHeadPosition = -1;
  }
}
const rs = -1, fd = new DataView(new ArrayBuffer(0)), _R = new Uint8Array(fd.buffer);
try {
  fd.getInt8(0);
} catch (e) {
  if (!(e instanceof RangeError))
    throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
}
const Oh = new RangeError("Insufficient data"), xR = new gR();
class hd {
  constructor(t) {
    O(this, "extensionCodec");
    O(this, "context");
    O(this, "useBigInt64");
    O(this, "rawStrings");
    O(this, "maxStrLength");
    O(this, "maxBinLength");
    O(this, "maxArrayLength");
    O(this, "maxMapLength");
    O(this, "maxExtLength");
    O(this, "keyDecoder");
    O(this, "mapKeyConverter");
    O(this, "totalPos", 0);
    O(this, "pos", 0);
    O(this, "view", fd);
    O(this, "bytes", _R);
    O(this, "headByte", rs);
    O(this, "stack", new ER());
    O(this, "entered", !1);
    this.extensionCodec = t?.extensionCodec ?? $c.defaultCodec, this.context = t?.context, this.useBigInt64 = t?.useBigInt64 ?? !1, this.rawStrings = t?.rawStrings ?? !1, this.maxStrLength = t?.maxStrLength ?? ns, this.maxBinLength = t?.maxBinLength ?? ns, this.maxArrayLength = t?.maxArrayLength ?? ns, this.maxMapLength = t?.maxMapLength ?? ns, this.maxExtLength = t?.maxExtLength ?? ns, this.keyDecoder = t?.keyDecoder !== void 0 ? t.keyDecoder : xR, this.mapKeyConverter = t?.mapKeyConverter ?? bR;
  }
  clone() {
    return new hd({
      extensionCodec: this.extensionCodec,
      context: this.context,
      useBigInt64: this.useBigInt64,
      rawStrings: this.rawStrings,
      maxStrLength: this.maxStrLength,
      maxBinLength: this.maxBinLength,
      maxArrayLength: this.maxArrayLength,
      maxMapLength: this.maxMapLength,
      maxExtLength: this.maxExtLength,
      keyDecoder: this.keyDecoder
    });
  }
  reinitializeState() {
    this.totalPos = 0, this.headByte = rs, this.stack.reset();
  }
  setBuffer(t) {
    const n = Ph(t);
    this.bytes = n, this.view = new DataView(n.buffer, n.byteOffset, n.byteLength), this.pos = 0;
  }
  appendBuffer(t) {
    if (this.headByte === rs && !this.hasRemaining(1))
      this.setBuffer(t);
    else {
      const n = this.bytes.subarray(this.pos), r = Ph(t), i = new Uint8Array(n.length + r.length);
      i.set(n), i.set(r, n.length), this.setBuffer(i);
    }
  }
  hasRemaining(t) {
    return this.view.byteLength - this.pos >= t;
  }
  createExtraByteError(t) {
    const { view: n, pos: r } = this;
    return new RangeError(`Extra ${n.byteLength - r} of ${n.byteLength} byte(s) found at buffer[${t}]`);
  }
  /**
   * @throws {@link DecodeError}
   * @throws {@link RangeError}
   */
  decode(t) {
    if (this.entered)
      return this.clone().decode(t);
    try {
      this.entered = !0, this.reinitializeState(), this.setBuffer(t);
      const n = this.doDecodeSync();
      if (this.hasRemaining(1))
        throw this.createExtraByteError(this.pos);
      return n;
    } finally {
      this.entered = !1;
    }
  }
  *decodeMulti(t) {
    if (this.entered) {
      yield* this.clone().decodeMulti(t);
      return;
    }
    try {
      for (this.entered = !0, this.reinitializeState(), this.setBuffer(t); this.hasRemaining(1); )
        yield this.doDecodeSync();
    } finally {
      this.entered = !1;
    }
  }
  async decodeAsync(t) {
    if (this.entered)
      return this.clone().decodeAsync(t);
    try {
      this.entered = !0;
      let n = !1, r;
      for await (const o of t) {
        if (n)
          throw this.entered = !1, this.createExtraByteError(this.totalPos);
        this.appendBuffer(o);
        try {
          r = this.doDecodeSync(), n = !0;
        } catch (u) {
          if (!(u instanceof RangeError))
            throw u;
        }
        this.totalPos += this.pos;
      }
      if (n) {
        if (this.hasRemaining(1))
          throw this.createExtraByteError(this.totalPos);
        return r;
      }
      const { headByte: i, pos: s, totalPos: a } = this;
      throw new RangeError(`Insufficient data in parsing ${Yu(i)} at ${a} (${s} in the current buffer)`);
    } finally {
      this.entered = !1;
    }
  }
  decodeArrayStream(t) {
    return this.decodeMultiAsync(t, !0);
  }
  decodeStream(t) {
    return this.decodeMultiAsync(t, !1);
  }
  async *decodeMultiAsync(t, n) {
    if (this.entered) {
      yield* this.clone().decodeMultiAsync(t, n);
      return;
    }
    try {
      this.entered = !0;
      let r = n, i = -1;
      for await (const s of t) {
        if (n && i === 0)
          throw this.createExtraByteError(this.totalPos);
        this.appendBuffer(s), r && (i = this.readArraySize(), r = !1, this.complete());
        try {
          for (; yield this.doDecodeSync(), --i !== 0; )
            ;
        } catch (a) {
          if (!(a instanceof RangeError))
            throw a;
        }
        this.totalPos += this.pos;
      }
    } finally {
      this.entered = !1;
    }
  }
  doDecodeSync() {
    e: for (; ; ) {
      const t = this.readHeadByte();
      let n;
      if (t >= 224)
        n = t - 256;
      else if (t < 192)
        if (t < 128)
          n = t;
        else if (t < 144) {
          const i = t - 128;
          if (i !== 0) {
            this.pushMapState(i), this.complete();
            continue e;
          } else
            n = {};
        } else if (t < 160) {
          const i = t - 144;
          if (i !== 0) {
            this.pushArrayState(i), this.complete();
            continue e;
          } else
            n = [];
        } else {
          const i = t - 160;
          n = this.decodeString(i, 0);
        }
      else if (t === 192)
        n = null;
      else if (t === 194)
        n = !1;
      else if (t === 195)
        n = !0;
      else if (t === 202)
        n = this.readF32();
      else if (t === 203)
        n = this.readF64();
      else if (t === 204)
        n = this.readU8();
      else if (t === 205)
        n = this.readU16();
      else if (t === 206)
        n = this.readU32();
      else if (t === 207)
        this.useBigInt64 ? n = this.readU64AsBigInt() : n = this.readU64();
      else if (t === 208)
        n = this.readI8();
      else if (t === 209)
        n = this.readI16();
      else if (t === 210)
        n = this.readI32();
      else if (t === 211)
        this.useBigInt64 ? n = this.readI64AsBigInt() : n = this.readI64();
      else if (t === 217) {
        const i = this.lookU8();
        n = this.decodeString(i, 1);
      } else if (t === 218) {
        const i = this.lookU16();
        n = this.decodeString(i, 2);
      } else if (t === 219) {
        const i = this.lookU32();
        n = this.decodeString(i, 4);
      } else if (t === 220) {
        const i = this.readU16();
        if (i !== 0) {
          this.pushArrayState(i), this.complete();
          continue e;
        } else
          n = [];
      } else if (t === 221) {
        const i = this.readU32();
        if (i !== 0) {
          this.pushArrayState(i), this.complete();
          continue e;
        } else
          n = [];
      } else if (t === 222) {
        const i = this.readU16();
        if (i !== 0) {
          this.pushMapState(i), this.complete();
          continue e;
        } else
          n = {};
      } else if (t === 223) {
        const i = this.readU32();
        if (i !== 0) {
          this.pushMapState(i), this.complete();
          continue e;
        } else
          n = {};
      } else if (t === 196) {
        const i = this.lookU8();
        n = this.decodeBinary(i, 1);
      } else if (t === 197) {
        const i = this.lookU16();
        n = this.decodeBinary(i, 2);
      } else if (t === 198) {
        const i = this.lookU32();
        n = this.decodeBinary(i, 4);
      } else if (t === 212)
        n = this.decodeExtension(1, 0);
      else if (t === 213)
        n = this.decodeExtension(2, 0);
      else if (t === 214)
        n = this.decodeExtension(4, 0);
      else if (t === 215)
        n = this.decodeExtension(8, 0);
      else if (t === 216)
        n = this.decodeExtension(16, 0);
      else if (t === 199) {
        const i = this.lookU8();
        n = this.decodeExtension(i, 1);
      } else if (t === 200) {
        const i = this.lookU16();
        n = this.decodeExtension(i, 2);
      } else if (t === 201) {
        const i = this.lookU32();
        n = this.decodeExtension(i, 4);
      } else
        throw new qt(`Unrecognized type byte: ${Yu(t)}`);
      this.complete();
      const r = this.stack;
      for (; r.length > 0; ) {
        const i = r.top();
        if (i.type === Yc)
          if (i.array[i.position] = n, i.position++, i.position === i.size)
            n = i.array, r.release(i);
          else
            continue e;
        else if (i.type === Es) {
          if (n === "__proto__")
            throw new qt("The key __proto__ is not allowed");
          i.key = this.mapKeyConverter(n), i.type = OE;
          continue e;
        } else if (i.map[i.key] = n, i.readCount++, i.readCount === i.size)
          n = i.map, r.release(i);
        else {
          i.key = null, i.type = Es;
          continue e;
        }
      }
      return n;
    }
  }
  readHeadByte() {
    return this.headByte === rs && (this.headByte = this.readU8()), this.headByte;
  }
  complete() {
    this.headByte = rs;
  }
  readArraySize() {
    const t = this.readHeadByte();
    switch (t) {
      case 220:
        return this.readU16();
      case 221:
        return this.readU32();
      default: {
        if (t < 160)
          return t - 144;
        throw new qt(`Unrecognized array type byte: ${Yu(t)}`);
      }
    }
  }
  pushMapState(t) {
    if (t > this.maxMapLength)
      throw new qt(`Max length exceeded: map length (${t}) > maxMapLengthLength (${this.maxMapLength})`);
    this.stack.pushMapState(t);
  }
  pushArrayState(t) {
    if (t > this.maxArrayLength)
      throw new qt(`Max length exceeded: array length (${t}) > maxArrayLength (${this.maxArrayLength})`);
    this.stack.pushArrayState(t);
  }
  decodeString(t, n) {
    return !this.rawStrings || this.stateIsMapKey() ? this.decodeUtf8String(t, n) : this.decodeBinary(t, n);
  }
  /**
   * @throws {@link RangeError}
   */
  decodeUtf8String(t, n) {
    if (t > this.maxStrLength)
      throw new qt(`Max length exceeded: UTF-8 byte length (${t}) > maxStrLength (${this.maxStrLength})`);
    if (this.bytes.byteLength < this.pos + n + t)
      throw Oh;
    const r = this.pos + n;
    let i;
    return this.stateIsMapKey() && this.keyDecoder?.canBeCached(t) ? i = this.keyDecoder.decode(this.bytes, r, t) : i = tR(this.bytes, r, t), this.pos += n + t, i;
  }
  stateIsMapKey() {
    return this.stack.length > 0 ? this.stack.top().type === Es : !1;
  }
  /**
   * @throws {@link RangeError}
   */
  decodeBinary(t, n) {
    if (t > this.maxBinLength)
      throw new qt(`Max length exceeded: bin length (${t}) > maxBinLength (${this.maxBinLength})`);
    if (!this.hasRemaining(t + n))
      throw Oh;
    const r = this.pos + n, i = this.bytes.subarray(r, r + t);
    return this.pos += n + t, i;
  }
  decodeExtension(t, n) {
    if (t > this.maxExtLength)
      throw new qt(`Max length exceeded: ext length (${t}) > maxExtLength (${this.maxExtLength})`);
    const r = this.view.getInt8(this.pos + n), i = this.decodeBinary(
      t,
      n + 1
      /* extType */
    );
    return this.extensionCodec.decode(i, r, this.context);
  }
  lookU8() {
    return this.view.getUint8(this.pos);
  }
  lookU16() {
    return this.view.getUint16(this.pos);
  }
  lookU32() {
    return this.view.getUint32(this.pos);
  }
  readU8() {
    const t = this.view.getUint8(this.pos);
    return this.pos++, t;
  }
  readI8() {
    const t = this.view.getInt8(this.pos);
    return this.pos++, t;
  }
  readU16() {
    const t = this.view.getUint16(this.pos);
    return this.pos += 2, t;
  }
  readI16() {
    const t = this.view.getInt16(this.pos);
    return this.pos += 2, t;
  }
  readU32() {
    const t = this.view.getUint32(this.pos);
    return this.pos += 4, t;
  }
  readI32() {
    const t = this.view.getInt32(this.pos);
    return this.pos += 4, t;
  }
  readU64() {
    const t = rR(this.view, this.pos);
    return this.pos += 8, t;
  }
  readI64() {
    const t = PE(this.view, this.pos);
    return this.pos += 8, t;
  }
  readU64AsBigInt() {
    const t = this.view.getBigUint64(this.pos);
    return this.pos += 8, t;
  }
  readI64AsBigInt() {
    const t = this.view.getBigInt64(this.pos);
    return this.pos += 8, t;
  }
  readF32() {
    const t = this.view.getFloat32(this.pos);
    return this.pos += 4, t;
  }
  readF64() {
    const t = this.view.getFloat64(this.pos);
    return this.pos += 8, t;
  }
}
function TR(e, t) {
  return new hd(t).decode(e);
}
const kr = "ZAI", Ir = {
  click: "Click",
  select: "Select",
  view: "View",
  start: "Start"
}, Or = {
  prePrompts: `${kr}_${Ir.click} Quick prompts`,
  sendMessage: `${kr}_${Ir.click} Send message`,
  sendMessageError: `${kr}_${Ir.view} Error`,
  feedback: `${kr}_${Ir.select} Feedback`,
  sideChatOpen: `${kr}_${Ir.click} Side chat`,
  sideChatClose: `${kr}_${Ir.click} Side chat close`,
  demandIntelligenceSendMessage: "CAT_Click DI ZAI Send Message",
  startProactiveMessage: `${kr}_${Ir.start} Proactive message`
};
class AR {
  constructor() {
  }
  track(t, n) {
    const i = {
      "Macro Area": "ZAI",
      ...n
    };
    Kd.track(t, i);
  }
  identify(t) {
    t && Kd.identify(t);
  }
}
const Lr = new AR(), yR = (e, t) => Object.prototype.hasOwnProperty.call(e, t), mo = (e, t, n) => {
  if (Array.isArray(e))
    return e.map((r, i) => mo(r, `${t}[${i}]`, n));
  if (e && typeof e == "object") {
    const r = e, i = Object.keys(r), s = n.get(t) ?? [], a = new Set(s), o = [
      ...s.filter((u) => yR(r, u)),
      ...i.filter((u) => !a.has(u))
    ];
    return n.set(t, o), Object.fromEntries(o.map((u) => [
      u,
      mo(r[u], `${t}.${u}`, n)
    ]));
  }
  return e;
}, LE = (e, t) => {
  const n = e?.get(t) ?? /* @__PURE__ */ new Map();
  return e?.set(t, n), n;
}, NR = (e, t, n) => {
  const r = LE(e, t);
  mo(n, "$", r);
}, ME = (e, t, n) => {
  const r = LE(e, t), i = mo(n, "$", r);
  return JSON.stringify(i);
}, UE = (e, t, n) => `${e ?? "unknown"}:${t}:${n}`, vR = ({ chunk: e, matchingToolCallChunk: t, messageId: n, toolArgsKeyOrderCache: r }) => {
  const i = UE(n, "tool", e.id), s = e.partial_json ?? t?.args ?? t?.args_json, a = s ?? ME(r, i, e.args), o = a ? Io(a) : null, u = a ? o ?? {} : e.args;
  return NR(r, i, o ?? e.args), s == null && r?.delete(i), { args: u, argsText: a };
}, Gu = (e) => e?.metadata ?? {}, Lh = /* @__PURE__ */ new Set(), wR = (e) => {
  typeof process > "u" || process?.env?.NODE_ENV !== "development" || Lh.has(e) || (Lh.add(e), console.warn(`Unknown message part type: ${e}`));
}, Mh = /* @__PURE__ */ new Set(), CR = (e) => {
  if (typeof process > "u" || process?.env?.NODE_ENV !== "development")
    return;
  const t = Object.keys(e).sort().join(",");
  Mh.has(t) || (Mh.add(t), console.warn(`Unsupported file content block shape: ${t}`));
}, SR = (e) => "file" in e ? {
  type: "file",
  filename: e.file.filename,
  data: e.file.file_data,
  mimeType: e.file.mime_type
} : "data" in e && typeof e.data == "string" ? {
  type: "file",
  filename: e.metadata?.filename ?? "file",
  data: e.data,
  mimeType: e.mime_type
} : "base64" in e && typeof e.base64 == "string" ? {
  type: "file",
  filename: e.filename ?? "file",
  data: e.base64,
  mimeType: e.mime_type
} : (CR(e), null), Uh = (e, t, n) => typeof e == "string" ? [{ type: "text", text: e }] : e.map((r) => {
  const i = r.type;
  switch (i) {
    case "text":
      return { type: "text", text: r.text };
    case "text_delta":
      return { type: "text", text: r.text };
    case "image_url":
      return typeof r.image_url == "string" ? { type: "image", image: r.image_url } : {
        type: "image",
        image: r.image_url.url
      };
    case "file":
      return SR(r);
    case "thinking":
      return { type: "reasoning", text: r.thinking };
    case "reasoning":
      return {
        type: "reasoning",
        text: r.summary.map((o) => o.text).join(`


`)
      };
    case "tool_use":
      return null;
    case "input_json_delta":
      return null;
    case "computer_call":
      const s = r.action;
      return {
        type: "tool-call",
        toolCallId: r.call_id,
        toolName: "computer_call",
        args: s,
        argsText: ME(t.toolArgsKeyOrderCache, UE(n, "computer", r.call_id), s)
      };
    default:
      return wR(i), null;
  }
}).filter((r) => r !== null), kR = (e, t = {}) => {
  switch (e.type) {
    case "system":
      return {
        role: "system",
        id: e.id,
        content: [{ type: "text", text: e.content }],
        metadata: { custom: Gu(e.additional_kwargs) }
      };
    case "human":
      return {
        role: "user",
        id: e.id,
        content: Uh(e.content, t, e.id),
        metadata: { custom: Gu(e.additional_kwargs) }
      };
    case "ai":
      const n = e.tool_calls?.map((s) => {
        const a = e.tool_call_chunks?.find((c) => c.id === s.id), { args: o, argsText: u } = vR({
          chunk: s,
          matchingToolCallChunk: a,
          messageId: e.id,
          toolArgsKeyOrderCache: t.toolArgsKeyOrderCache
        });
        return {
          type: "tool-call",
          toolCallId: s.id,
          toolName: s.name,
          args: o,
          argsText: u
        };
      }) ?? [], r = typeof e.content == "string" ? [{ type: "text", text: e.content }] : e.content, i = [
        e.additional_kwargs?.reasoning,
        ...r,
        ...e.additional_kwargs?.tool_outputs ?? []
      ].filter((s) => s !== void 0);
      return {
        role: "assistant",
        id: e.id,
        content: [
          ...Uh(i, t, e.id),
          ...n
        ],
        metadata: { custom: Gu(e.additional_kwargs) },
        ...e.status && { status: e.status }
      };
    case "tool":
      return {
        role: "tool",
        toolName: e.name,
        toolCallId: e.tool_call_id,
        result: e.content,
        artifact: e.artifact,
        isError: e.status === "error"
      };
  }
}, vt = [];
for (let e = 0; e < 256; ++e)
  vt.push((e + 256).toString(16).slice(1));
function IR(e, t = 0) {
  return (vt[e[t + 0]] + vt[e[t + 1]] + vt[e[t + 2]] + vt[e[t + 3]] + "-" + vt[e[t + 4]] + vt[e[t + 5]] + "-" + vt[e[t + 6]] + vt[e[t + 7]] + "-" + vt[e[t + 8]] + vt[e[t + 9]] + "-" + vt[e[t + 10]] + vt[e[t + 11]] + vt[e[t + 12]] + vt[e[t + 13]] + vt[e[t + 14]] + vt[e[t + 15]]).toLowerCase();
}
let qu;
const DR = new Uint8Array(16);
function RR() {
  if (!qu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    qu = crypto.getRandomValues.bind(crypto);
  }
  return qu(DR);
}
const PR = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Hh = { randomUUID: PR };
function OR(e, t, n) {
  e = e || {};
  const r = e.random ?? e.rng?.() ?? RR();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, IR(r);
}
function LR(e, t, n) {
  return Hh.randomUUID && !e ? Hh.randomUUID() : OR(e);
}
class MR {
  constructor({ initialMessages: t = [], appendMessage: n = ((r, i) => i) } = {}) {
    O(this, "messagesMap", /* @__PURE__ */ new Map());
    O(this, "metadataMap", /* @__PURE__ */ new Map());
    O(this, "appendMessage");
    this.appendMessage = n, this.addMessages(t);
  }
  ensureMessageId(t) {
    return t.id ? t : { ...t, id: LR() };
  }
  addMessages(t) {
    if (t.length === 0)
      return this.getMessages();
    for (const n of t.map(this.ensureMessageId)) {
      const r = n.id, i = this.messagesMap.get(r);
      this.messagesMap.set(r, this.appendMessage(i, n));
    }
    return this.getMessages();
  }
  addMessageWithMetadata(t, n) {
    const r = this.ensureMessageId(t), i = r.id, s = this.messagesMap.get(i);
    this.messagesMap.set(i, this.appendMessage(s, r));
    const a = this.metadataMap.get(i);
    return this.metadataMap.set(i, { ...a, ...n }), this.getMessages();
  }
  getMessages() {
    return [...this.messagesMap.values()];
  }
  getMetadataMap() {
    return this.metadataMap;
  }
  replaceMessages(t) {
    this.messagesMap.clear(), this.metadataMap.clear();
    for (const n of t.map(this.ensureMessageId))
      this.messagesMap.set(n.id, n);
    return this.getMessages();
  }
  clear() {
    this.messagesMap.clear(), this.metadataMap.clear();
  }
}
const UR = (e, t) => {
  if (t.type !== "AIMessageChunk")
    return t;
  if (e?.type !== "ai")
    return {
      ...t,
      type: t.type.replace("MessageChunk", "").toLowerCase()
    };
  const n = typeof e.content == "string" ? [{ type: "text", text: e.content }] : [...e.content];
  if (typeof t?.content == "string") {
    const i = n.length - 1;
    n[i]?.type === "text" ? n[i].text = n[i].text + t.content : n.push({ type: "text", text: t.content });
  } else if (Array.isArray(t.content)) {
    const i = n.length - 1;
    for (const s of t.content)
      "type" in s && (s.type === "text" ? n[i]?.type === "text" ? n[i].text = n[i].text + s.text : n.push({ type: "text", text: s.text }) : s.type === "image_url" && n.push(s));
  }
  const r = [...e.tool_calls ?? []];
  for (const i of t.tool_call_chunks ?? []) {
    const s = r[i.index] ?? { argsText: "" }, a = (s.argsText || "") + i.args;
    r[i.index] = {
      ...i,
      ...s,
      argsText: a,
      args: Io(a) ?? ("args" in s ? s.args : {})
    };
  }
  return {
    ...e,
    content: n,
    tool_calls: r
  };
}, HR = /* @__PURE__ */ new Set([
  "analyze",
  "plan",
  "execute_step",
  "validate_step",
  "synthesize",
  "clarify"
]), jR = /* @__PURE__ */ new Set(["execute_step", "validate_step"]);
class BR {
  constructor() {
    this.accumulator = new MR({
      initialMessages: [],
      appendMessage: UR
    });
  }
  addChunk(t) {
    this.accumulator.addMessages([t]);
  }
  addProgress(t) {
    if (!HR.has(t.node) || t.node === "clarify")
      return;
    const n = this.progress?.entries ?? [], r = this.getEntryKey(t, n), i = t.message ?? t.step_description ?? "", a = n.some((o) => o.key === r) ? n.map((o) => o.key === r ? { ...o, node: t.node, text: i } : o) : [...n, { key: r, node: t.node, text: i }];
    this.progress = { entries: a, activeKey: r, activeNode: t.node };
  }
  getEntryKey(t, n) {
    if (!jR.has(t.node))
      return t.node;
    if (t.step_id) return `${t.node}#id:${t.step_id}`;
    if (typeof t.current_step == "number") return `${t.node}#step:${t.current_step}`;
    const r = n.filter((i) => i.node === t.node).length;
    return `${t.node}#idx:${r}`;
  }
  getCompletedResponse(t) {
    const n = this.accumulator.getMessages().flatMap((s) => kR(s, {})), r = n.filter((s) => s?.role === "tool").reduce((s, a) => (s[a.toolCallId] = {
      result: a.result,
      toolName: a.toolName,
      isError: a.isError
    }, s), {});
    return {
      content: n.filter((s) => s && s.role === "assistant").map((s) => s.content.map((a) => {
        if (a.toolCallId) {
          const o = a.args?.resource_uri;
          let u = CE[a.toolName];
          u && (u = Rn(u, a.args));
          const c = r[a.toolCallId];
          if (a.argsText = o || u, c)
            return {
              ...a,
              type: "tool-call",
              toolName: c.toolName,
              result: IE(c.result),
              isError: c.isError
            };
        } else if (a.type === "text")
          return {
            type: "text",
            text: new ld(t, a.text).replaceTerritoryIds().replacePostIds().replaceCreatorIds().replaceWidgets().cleanUnusedURIs().build()
          };
        return a;
      })).flat(),
      ...this.progress ? { metadata: { custom: { zaiProgress: this.progress } } } : {}
    };
  }
}
const FR = {
  "pt-BR": "por",
  en: "eng",
  es: "spa"
}, zR = (e) => FR[e];
function VR(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e, 0), n.set(t, e.length), n;
}
const WR = ({
  workspaceId: e,
  thread: t,
  langRef: n,
  getOrigin: r,
  getPromptPage: i,
  checkIsPrePrompt: s,
  resetIsPrePrompt: a,
  checkIsProactiveMessage: o,
  getQuickPromptId: u,
  service: c
}) => ({
  async *run({ messages: d, abortSignal: h, context: m, runConfig: E }) {
    const g = d?.length ? d[d.length - 1]?.content[0]?.text : null, T = s(), _ = o(), A = r(), w = i(), M = T ? u() : null, F = T || !!E?.custom?.skipResponseInteraction, k = {
      workspaceId: e,
      thread: t.current
    };
    if (g && (k.message = g), A && (k.origin = A), T && w && (k.page = w), _)
      Lr.track(Or.startProactiveMessage, k);
    else {
      const U = Or[T ? "prePrompts" : "sendMessage"];
      Lr.track(U, k), !T && A === "Demand Intelligence" && k.message && Lr.track(Or.demandIntelligenceSendMessage, { "Message Text": k.message });
    }
    a();
    const B = await c.postMessageToThread(
      t.current || "",
      {
        messages: d,
        context: m,
        language: zR(n.current || "en"),
        ...M ? { quick_prompt_id: M } : {},
        skip_response_interaction: F
      },
      {
        abortSignal: h
      }
    );
    if (!B)
      return;
    const $ = new BR();
    let J = new Uint8Array(0);
    for (; ; ) {
      const { done: U, value: re } = await B.read();
      if (U)
        break;
      for (J = VR(J, re); !(J.length < 4); ) {
        const j = new DataView(J.buffer, J.byteOffset, 4).getUint32(0, !1);
        if (J.length < 4 + j) break;
        const H = J.subarray(4, 4 + j);
        J = J.subarray(4 + j);
        try {
          const z = TR(H);
          if (z.type === "ping")
            continue;
          if (z.type === "progress") {
            $.addProgress(z), yield $.getCompletedResponse(e);
            continue;
          }
          $.addChunk(z), yield $.getCompletedResponse(e);
        } catch (z) {
          Lr.track(Or.sendMessageError, k), console.error("Failed to decode msgpack chunk:", z);
        }
      }
    }
  }
}), $R = (e) => () => {
  const t = WR(e), n = pN(t, {}), r = oe((l) => l?.threadListItem?.remoteId), i = oe((l) => l?.threadListItem?.id), s = oe((l) => l?.threads?.mainThreadId), a = oe((l) => l?.threadListItem?.title), { setThreadRunning: o, notifyIfBackground: u } = gE(), c = st({
    remoteId: r,
    threadListItemId: i,
    mainThreadId: s,
    title: a,
    setThreadRunning: o,
    notifyIfBackground: u
  });
  return c.current = { remoteId: r, threadListItemId: i, mainThreadId: s, title: a, setThreadRunning: o, notifyIfBackground: u }, Le(() => {
    const l = n.thread.unstable_on("runStart", () => {
      const { threadListItemId: h, setThreadRunning: m } = c.current;
      h && m({ threadId: h, isRunning: !0 });
    }), d = n.thread.unstable_on("runEnd", () => {
      const { threadListItemId: h, setThreadRunning: m } = c.current;
      h && m({ threadId: h, isRunning: !1 }), setTimeout(() => {
        const { remoteId: E, threadListItemId: g, mainThreadId: T, title: _, notifyIfBackground: A } = c.current;
        !E || !_ || A({ threadId: E, isActiveThread: g === T, title: _ });
      }, 100);
    });
    return () => {
      l(), d();
    };
  }, [n]), n;
}, YR = ({ workspaceId: e }) => {
  const t = dd(), { getOrigin: n, getPage: r, checkIsPrePrompt: i, resetIsPrePrompt: s, checkIsProactiveMessage: a } = Mi(), { getQuickPromptId: o, resetPrePromptParams: u } = ad(), c = de(() => {
    s(), u();
  }, [s, u]), { language: l } = Qs(), d = yh(l) ? l : "pt-BR", h = st(d), m = st(null), E = pe(
    () => $R({
      workspaceId: e,
      thread: m,
      langRef: h,
      getOrigin: n,
      getPromptPage: r,
      checkIsPrePrompt: i,
      resetIsPrePrompt: c,
      checkIsProactiveMessage: a,
      getQuickPromptId: o,
      service: t
    }),
    [
      e,
      n,
      r,
      i,
      c,
      a,
      o,
      t
    ]
  ), g = pe(() => QD({ currentThread: m }), []), T = fg({
    runtimeHook: E,
    adapter: {
      unstable_Provider: g,
      async list() {
        return {
          threads: await t.getThreads()
        };
      },
      async fetch(_) {
        return (await t.getThreads()).find((w) => w.remoteId === _) ?? { status: "regular", remoteId: _ };
      },
      async initialize() {
        const _ = ID();
        return m.current = _, { remoteId: _, externalId: _ };
      },
      async rename() {
      },
      async delete(_) {
        await t.deleteThread(_);
      },
      async archive() {
      },
      async generateTitle(_, A) {
        let w = "New Thread";
        return A?.[0]?.content[0]?.type === "text" && (w = A[0].content[0]?.text), new ReadableStream({
          start(F) {
            F.enqueue({
              type: "part-start",
              part: { type: "text" },
              path: [0]
            }), F.enqueue({
              type: "text-delta",
              textDelta: w,
              path: [0]
            }), F.enqueue({
              type: "part-finish",
              path: [0]
            }), F.close();
          }
        });
      },
      async unarchive() {
      }
    }
  });
  return Le(() => {
    yh(l) && (h.current = l);
  }, [l]), {
    threadRuntime: T
  };
}, GR = ({
  children: e,
  workspaceId: t,
  setAssistantUiIsReady: n,
  setAssistantUiControl: r
}) => {
  const { threadRuntime: i } = YR({ workspaceId: t });
  return Le(() => n(!!i), [n, i]), Le(() => {
    i && r?.((s) => i.threads.switchToThread(s));
  }, [i, r]), /* @__PURE__ */ p.jsxDEV(AN, { runtime: i, children: e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/thread-runtime.tsx",
    lineNumber: 29,
    columnNumber: 10
  }, void 0);
}, qR = Ce(GR), mF = ({
  workspaceId: e,
  userId: t,
  userEmail: n,
  getValidToken: r,
  children: i,
  onBackgroundThreadComplete: s,
  setAssistantUiControl: a,
  isChatVisible: o
}) => {
  const [u, c] = we(!1);
  return /* @__PURE__ */ p.jsxDEV(NE.Provider, { value: { workspaceId: e, userId: t, userEmail: n, getValidToken: r, assistantUiIsReady: u }, children: /* @__PURE__ */ p.jsxDEV(ND, { children: /* @__PURE__ */ p.jsxDEV(vD, { children: /* @__PURE__ */ p.jsxDEV(HI, { children: e ? /* @__PURE__ */ p.jsxDEV(
    jI,
    {
      onBackgroundThreadComplete: s,
      isChatVisible: o,
      children: /* @__PURE__ */ p.jsxDEV(
        qR,
        {
          workspaceId: e,
          setAssistantUiIsReady: c,
          setAssistantUiControl: a,
          children: i
        },
        void 0,
        !1,
        {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/access-provider/access-provider.provider.tsx",
          lineNumber: 34,
          columnNumber: 17
        },
        void 0
      )
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/access-provider/access-provider.provider.tsx",
      lineNumber: 30,
      columnNumber: 15
    },
    void 0
  ) : i }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/access-provider/access-provider.provider.tsx",
    lineNumber: 28,
    columnNumber: 11
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/access-provider/access-provider.provider.tsx",
    lineNumber: 27,
    columnNumber: 9
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/access-provider/access-provider.provider.tsx",
    lineNumber: 26,
    columnNumber: 7
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/access-provider/access-provider.provider.tsx",
    lineNumber: 25,
    columnNumber: 5
  }, void 0);
}, KR = {
  7: "0",
  30: "1",
  90: "3",
  180: "6",
  365: "12",
  730: "24",
  1095: "36"
}, jh = {
  0: "day",
  1: "week",
  3: "week",
  6: "month",
  12: "month",
  24: "quarter",
  36: "quarter",
  61: "quarter"
}, md = (e) => KR[String(e)], Gc = (e) => {
  const t = md(e);
  return t && jh[t] || jh[1];
}, HE = (e) => {
  const t = new URLSearchParams();
  if (e.timeRangeInDays !== void 0) {
    const n = md(e.timeRangeInDays);
    n && t.set("uploadDate", n);
  }
  return e.provider && e.provider !== "all" && t.set("providers", e.provider), t;
};
function QR(e, t, n) {
  const r = e.getUTCDate().toString().padStart(2, "0"), i = (e.getUTCMonth() + 1).toString().padStart(2, "0"), s = e.getUTCFullYear().toString();
  if (n) {
    if (t === "DD/MM/YYYY")
      return `${r}/${i}/${s}`;
    const o = new Intl.DateTimeFormat(n, {
      timeZone: "UTC",
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).formatToParts(e), u = o.find((d) => d.type === "day")?.value || r, c = o.find((d) => d.type === "month")?.value || i, l = o.find((d) => d.type === "year")?.value || s;
    return `${u}/${c}/${l}`;
  }
  return t.replace("DD", r).replace("MM", i).replace("YYYY", s);
}
function Bh(e, t, n) {
  const r = new Date(e);
  switch (n) {
    case "day":
      r.setUTCDate(r.getUTCDate() + t);
      break;
    case "week":
      r.setUTCDate(r.getUTCDate() + t * 7);
      break;
    case "month":
      r.setUTCMonth(r.getUTCMonth() + t);
      break;
    case "quarter":
      r.setUTCMonth(r.getUTCMonth() + t * 3);
      break;
    case "year":
      r.setUTCFullYear(r.getUTCFullYear() + t);
      break;
    default:
      throw new Error(`Unsupported unit: ${n}`);
  }
  return r;
}
function XR(e, t, n) {
  switch (n) {
    case "day":
      return Math.floor((t.getTime() - e.getTime()) / (1e3 * 60 * 60 * 24));
    case "week":
      return Math.floor((t.getTime() - e.getTime()) / (1e3 * 60 * 60 * 24 * 7));
    case "month":
      return (t.getUTCFullYear() - e.getUTCFullYear()) * 12 + (t.getUTCMonth() - e.getUTCMonth());
    case "quarter": {
      const r = (t.getUTCFullYear() - e.getUTCFullYear()) * 12 + (t.getUTCMonth() - e.getUTCMonth());
      return Math.floor(r / 3);
    }
    case "year":
      return t.getUTCFullYear() - e.getUTCFullYear();
    default:
      throw new Error(`Unsupported unit: ${n}`);
  }
}
function JR(e, t, n = "DD/MM/YYYY", r = "day", i = null) {
  const s = (E) => {
    if (E instanceof Date)
      return new Date(Date.UTC(E.getUTCFullYear(), E.getUTCMonth(), E.getUTCDate()));
    const g = /* @__PURE__ */ new Date(E + "T00:00:00.000");
    if (isNaN(g.getTime())) {
      const T = new Date(E);
      return isNaN(T.getTime()) ? /* @__PURE__ */ new Date(NaN) : new Date(Date.UTC(T.getUTCFullYear(), T.getUTCMonth(), T.getUTCDate()));
    }
    return new Date(Date.UTC(g.getFullYear(), g.getMonth(), g.getDate()));
  }, a = s(e), o = s(t);
  if (isNaN(a.getTime()) || isNaN(o.getTime()))
    return [];
  const u = XR(a, o, r), c = Math.abs(u) + 1, d = c > 0 ? c : 0, h = u < 0;
  return Array.from(Array(d)).map((E, g) => {
    const T = h ? Bh(a, -g, r) : Bh(a, g, r);
    return QR(T, n, i || void 0);
  });
}
const ZR = `
  query Creator($creatorId: ID!, $filter: AnalyticsFilterInput!) {
    creator(_id: $creatorId) {
      ... on Creator {
        id: creatorId
        subscribers
        title
        provider
        country
        thumbnail
        isTrending
        performance {
          analytics(filter: $filter) {
            avgEngagement
            avgEngagementVariation
          }
        }
      }
      ... on CreatorIncompleteIN {
        title
      }
      ... on CreatorIncompleteTT {
        title
      }
      ... on CreatorIncompleteYT {
        title
      }
      ... on CreatorIncompleteFB {
        title
      }
      ... on CreatorIncompleteTW {
        title
      }
      ... on CreatorPublic {
        id: creatorId
        subscribers
        title
        provider
        country
        thumbnail
        isTrending
      }
    }
  }
`, e3 = `
  query Post($postId: ID!) {
    post(_id: $postId) {
      id: postId
      thumbnail
      publishedAt
      provider
      views
      likes
      title
      creator {
        ... on Creator {
          id: creatorId
          title
          thumbnail
          provider
        }
        ... on CreatorIncompleteTW {
          title
        }
        ... on CreatorIncompleteFB {
          title
        }
        ... on CreatorIncompleteYT {
          title
        }
        ... on CreatorIncompleteTT {
          title
        }
        ... on CreatorIncompleteIN {
          title
        }
        ... on CreatorPublic {
          title
          thumbnail
        }
      }
    }
  }
`, t3 = `
  query getDocumentsList($take: Int!, $cursor: String, $status: [FileStorageStatus!]) {
    getWorkspace {
      fileStorage {
        filesPaginated(take: $take, cursor: $cursor, status: $status) {
          cursor
          totalCount
          data {
            fileName
            id
            size
          }
        }
      }
    }
  }
`, n3 = `
  fragment TerritoryEngagementOverTime on TerritoryInterface {
    territoryId
    territoryPerformance {
      metricsPerMonth(
        timeRange: $timeRange
        publishedAt: $publishedAt
        providers: $providers
        interval: $interval
      ) {
        date
        totalEngagement
      }
    }
  }

  fragment EngagementOverTimeBrandItem on WorkspaceBrand {
    id
    name
    customSettings
    workspaceBrandTerritories {
      selfContentTerritory @skip(if: $skipSelfContent) {
        ...TerritoryEngagementOverTime
      }
      earnedTerritory @skip(if: $skipEarned) {
        ...TerritoryEngagementOverTime
      }
      paidTerritory @skip(if: $skipPaid) {
        ...TerritoryEngagementOverTime
      }
      groupedTerritory @skip(if: $skipGrouped) {
        ...TerritoryEngagementOverTime
      }
    }
  }

  query getBrandEngagementOverTime(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $interval: SparklineIntervalInput
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand {
        ...EngagementOverTimeBrandItem
      }
      workspaceBrandCompetitorsPaginated {
        data {
          ...EngagementOverTimeBrandItem
        }
      }
    }
  }
`, r3 = `
  fragment TerritoryEngagementOverTime on TerritoryInterface {
    territoryId
    territoryPerformance {
      metricsPerMonth(
        timeRange: $timeRange
        publishedAt: $publishedAt
        providers: $providers
        interval: $interval
      ) {
        date
        totalEngagement
      }
    }
  }

  fragment EngagementOverTimeBrandItem on WorkspaceBrandV2 {
    id
    name
    customSettings # <- "{ color: string }"
    workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
      selfContentTerritory @skip(if: $skipSelfContent) {
        ...TerritoryEngagementOverTime
      }
      earnedTerritory @skip(if: $skipEarned) {
        ...TerritoryEngagementOverTime
      }
      paidTerritory @skip(if: $skipPaid) {
        ...TerritoryEngagementOverTime
      }
      groupedTerritory @skip(if: $skipGrouped) {
        ...TerritoryEngagementOverTime
      }
    }
  }

  query getBrandEngagementOverTime(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $interval: SparklineIntervalInput
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        ...EngagementOverTimeBrandItem
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          ...EngagementOverTimeBrandItem
        }
      }
    }
  }
`, i3 = `
  fragment TerritoryPerformanceFields on TerritoryPerformance {
    metrics(
      timeRange: $timeRange
      publishedAt: $publishedAt
      providers: $providers
    ) {
      totalEngagement
      totalViews
    }
    totalPosts(
      timeRange: $timeRange
      providers: $providers
      publishedAt: $publishedAt
    )
  }

  query BrandCharts_AttentionMetrics(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand {
        id
        name
        customSettings
        workspaceBrandTerritories {
          selfContentTerritory @skip(if: $skipSelfContent) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          earnedTerritory @skip(if: $skipEarned) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          paidTerritory @skip(if: $skipPaid) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          groupedTerritory @skip(if: $skipGrouped) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
        }
      }
      workspaceBrandCompetitorsPaginated {
        data {
          id
          name
          customSettings
          workspaceBrandTerritories {
            selfContentTerritory @skip(if: $skipSelfContent) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            earnedTerritory @skip(if: $skipEarned) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            paidTerritory @skip(if: $skipPaid) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            groupedTerritory @skip(if: $skipGrouped) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
          }
        }
      }
    }
  }
`, s3 = `
  fragment TerritoryPerformanceFields on TerritoryPerformance {
    metrics(
      timeRange: $timeRange
      publishedAt: $publishedAt
      providers: $providers
    ) {
      totalEngagement
      totalViews
    }
    totalPosts(
      timeRange: $timeRange
      providers: $providers
      publishedAt: $publishedAt
    )
  }

  query BrandCharts_AttentionMetrics(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        id
        name
        customSettings # <- "{ color: string }"
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          selfContentTerritory @skip(if: $skipSelfContent) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          earnedTerritory @skip(if: $skipEarned) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          paidTerritory @skip(if: $skipPaid) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          groupedTerritory @skip(if: $skipGrouped) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
        }
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          id
          name
          customSettings # <- "{ color: string }"
          workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
            selfContentTerritory @skip(if: $skipSelfContent) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            earnedTerritory @skip(if: $skipEarned) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            paidTerritory @skip(if: $skipPaid) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            groupedTerritory @skip(if: $skipGrouped) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
          }
        }
      }
    }
  }
`, a3 = `
  query getShareOfAttentionV2($input: ShareOfAttentionV2Input!) {
    getWorkspace {
      listShareOfAttentionV2(input: $input) {
        data {
          current {
            donut {
              brand {
                id
                name
                brandColor
              }
              rankPosition
              rankVariation
              value
              valueVariation
            }
            histogram {
              brand {
                id
                name
                brandColor
              }
              date
              rankPosition
              rankVariation
              value
              valueVariation
            }
          }
        }
      }
      selfBrandSOA {
        brand {
          id
          name
        }
        category {
          id
          name
          country
        }
      }
    }
  }
`, o3 = `
  query SHARE_OF_ATTENTION_V3($input: ShareOfAttentionV3MetricsInput!) {
    shareOfAttentionV3 {
      metrics(input: $input) {

        histogram {
          brand {
            id
            color
            name
            thumbnailUrl
          }

          date
          value
          valueVariation
          rankPosition
          rankVariation
          isPartial
        }

      }

      myBrand {
        id
        name
        color
        thumbnailUrl
        isVerified
        country
      }

      listMySoas {
        id
        name
      }
    }
  }
`, u3 = `
  query getTerritoryRelevance(
    $territoryId: ID!
    $interval: SparklineIntervalInput
    $publishedAt: RangeQuery
    $timeRange: TimeRange
  ) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      territoryPerformance {
        totalPosts(timeRange: $timeRange, publishedAt: $publishedAt)
        relevancev2(
          filters: { timeRange: $timeRange, interval: $interval, publishedAt: $publishedAt }
        ) {
          sparkline
          endDate
          startDate
        }
      }
    }
  }
`;
class mi {
  constructor({ workspaceId: t, getValidToken: n, userId: r, userEmail: i = "" }) {
    this.workspaceId = t, this.getValidToken = n, this.userId = r, this.userEmail = i;
  }
  async getInsightsHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: await this.getValidToken(),
      "x-insights-workspace": this.workspaceId
    };
  }
  async fetchInsightsGraphQL(t, n) {
    const r = await this.getInsightsHeaders(), i = await fetch(`${od.baseUrl}/graphql`, {
      method: "POST",
      headers: r,
      body: JSON.stringify({ query: t, variables: n })
    });
    if (!i.ok) {
      const s = await i.text();
      throw new Error(`Insights GraphQL error: ${i.status} ${s}`);
    }
    return i.json();
  }
  static formatBrandEngagementData(t, n) {
    const r = di.getMetricKeyByTerritoryType(n), i = t?.workspaceBrand, s = t?.workspaceBrandCompetitorsPaginated?.data || [];
    return [i, ...s].map((o, u) => {
      const c = o.workspaceBrandTerritories?.[r]?.territoryPerformance?.metricsPerMonth || [];
      return {
        id: o.id,
        name: o.name,
        color: di.parseColorFromSettings(o.customSettings, u),
        metrics: c.map((l) => ({ date: l.date, totalEngagement: l.totalEngagement }))
      };
    });
  }
  static formatSharesData(t, n) {
    const r = di.getMetricKeyByTerritoryType(n), i = t?.workspaceBrand, s = t?.workspaceBrandCompetitorsPaginated?.data || [];
    return [i, ...s].map((o, u) => {
      const c = o.workspaceBrandTerritories?.[r]?.territoryPerformance;
      return {
        id: o.id,
        name: o.name,
        color: di.parseColorFromSettings(o.customSettings, u),
        totalEngagement: c?.metrics?.totalEngagement || 0,
        totalViews: c?.metrics?.totalViews || 0,
        totalPosts: c?.totalPosts || 0
      };
    });
  }
  static formatSoAData(t) {
    const n = {
      category: t.selfBrandSOA?.brand?.category || null,
      brands: []
    }, r = {}, i = t.selfBrandSOA?.brand?.id;
    return t.listShareOfAttentionV2.data.current.histogram.forEach((s, a) => {
      const o = s.brand.id;
      r[o] || (r[o] = {
        id: o,
        name: s.brand.name,
        color: di.getBrandColor(s.brand, a),
        isSelf: o === i,
        dateMap: /* @__PURE__ */ new Map()
      }), r[o].dateMap.set(s.date, parseFloat(Number(s.value * 100).toFixed(2)));
    }), n.brands = Object.values(r).map((s) => ({
      id: s.id,
      name: s.name,
      color: s.color,
      isSelf: s.isSelf,
      scores: Array.from(s.dateMap.entries()).sort(([a], [o]) => a.localeCompare(o)).map(([a, o]) => ({ date: a, value: o }))
    })), n;
  }
  static formatSoAV3Data({ histogram: t, industry: n, myBrand: r }) {
    const s = {
      category: n ? { id: n.id, name: n.name, country: r.country ?? "" } : null,
      brands: []
    }, a = {};
    return t.forEach((o, u) => {
      const c = o.brand.id;
      a[c] || (a[c] = {
        id: c,
        name: o.brand.name,
        color: di.getBrandColor(o.brand, u),
        isSelf: c === r.id,
        dateMap: /* @__PURE__ */ new Map()
      }), a[c].dateMap.set(o.date, parseFloat(Number(o.value * 100).toFixed(2)));
    }), s.brands = Object.values(a).map((o) => ({
      id: o.id,
      name: o.name,
      color: o.color,
      isSelf: o.isSelf,
      scores: Array.from(o.dateMap.entries()).sort(([u], [c]) => u.localeCompare(c)).map(([u, c]) => ({ date: u, value: c }))
    })), s;
  }
  async getBrandEngagementOverTimeData(t, n = {}) {
    try {
      const r = t.territoryType || "grouped", i = t.provider || "all", s = i in Sa ? [i] : Object.keys(Sa), a = Number.parseInt(t.timeRangeInDays || "30", 10), { publishedAt: o, timeRange: u } = $u(a), c = Ch[r], l = { type: "calendar", timeUnit: Gc(a) }, d = n?.isNewPageBrandOverviewEnabled ? r3 : n3, h = await this.fetchInsightsGraphQL(d, {
        ...c,
        providers: s,
        publishedAt: o,
        timeRange: u,
        interval: l
      });
      return mi.formatBrandEngagementData(h.data.getWorkspace, r);
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch brand engagement over time from backend",
        error: r
      }), r;
    }
  }
  async getShareOfAttentionData(t, n = {}) {
    try {
      const r = t.period || "monthly", i = Number.parseInt(t.year || String((/* @__PURE__ */ new Date()).getFullYear()), 10);
      if (n?.isSOAV3WithZaiEnabled) {
        const a = await this.fetchInsightsGraphQL(o3, { input: { aggregate: r, year: i } }), o = a.data.shareOfAttentionV3?.metrics?.histogram, u = a.data.shareOfAttentionV3?.listMySoas, c = a.data.shareOfAttentionV3?.myBrand;
        return mi.formatSoAV3Data({
          histogram: o,
          industry: u,
          myBrand: c
        });
      }
      const s = await this.fetchInsightsGraphQL(a3, { input: { aggregate: r, year: i } });
      return mi.formatSoAData(s.data.getWorkspace);
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch share of attention data from backend",
        error: r
      }), r;
    }
  }
  async getSharesData(t, n = {}) {
    const r = t.territoryType || "grouped", i = t.provider || "all", s = i in Sa ? [i] : Object.keys(Sa), a = Number.parseInt(t.timeRangeInDays || "30", 10), { publishedAt: o, timeRange: u } = $u(a), c = n?.isNewPageBrandOverviewEnabled ? s3 : i3;
    try {
      const l = await this.fetchInsightsGraphQL(c, {
        ...Ch[r],
        providers: s,
        publishedAt: o,
        timeRange: u
      });
      return mi.formatSharesData(l.data.getWorkspace, r);
    } catch (l) {
      throw console.error({
        log: "Zai Chat - Error to fetch shares data from backend",
        error: l
      }), l;
    }
  }
  async getTerritoryRelevanceData(t) {
    const n = t.territoryId, r = t.timeRange || "30", i = $u(r), s = { type: "calendar", timeUnit: Gc(r) };
    try {
      const a = await this.fetchInsightsGraphQL(u3, {
        territoryId: n,
        interval: s,
        publishedAt: i.publishedAt,
        timeRange: i.timeRange
      }), o = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.sparkline || [], u = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.startDate, c = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.endDate, l = JR(u, c, "YYYY-MM-DD", s.timeUnit);
      return { sparkline: Array.from({ length: Math.min(o.length, l.length) }, (h, m) => ({
        date: l[m],
        value: o[m]
      })), startDate: u, endDate: c };
    } catch (a) {
      throw console.error({
        log: "Zai Chat - Error to fetch territory relevance data from backend",
        error: a
      }), a;
    }
  }
  async getFiles(t) {
    try {
      return (await this.fetchInsightsGraphQL(t3, {
        take: t.limit,
        cursor: t.cursor,
        status: ["REQUESTED", "PROCESSING", "PROCESSED"]
      })).data.getWorkspace.fileStorage.filesPaginated;
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch files from backend",
        error: n
      }), n;
    }
  }
  async getCreatorData(t, n) {
    try {
      return (await this.fetchInsightsGraphQL(ZR, {
        creatorId: t,
        filter: { periodInMonths: n.performanceInMonths }
      })).data.creator;
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch creator data from backend",
        query: { variables: { creatorId: t } },
        error: r
      }), r;
    }
  }
  async getPostData(t) {
    try {
      return (await this.fetchInsightsGraphQL(e3, { postId: t })).data.post;
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch post data from backend",
        query: { variables: { postId: t } },
        error: n
      }), n;
    }
  }
}
const Xr = () => {
  const { workspaceId: e, userId: t, userEmail: n, getValidToken: r } = St();
  return pe(
    () => new mi({ workspaceId: e, getValidToken: r, userId: t, userEmail: n }),
    [e, t, n, r]
  );
}, c3 = ({ limit: e = 100 }) => {
  const { workspaceId: t } = St(), n = Xr(), [r, i] = we(!1), [s, a] = we(!1), [o, u] = we(!1), [c, l] = we(null), d = de(async () => {
    if (t)
      try {
        i(!0), u(!1);
        const m = await n.getFiles({ limit: e });
        l(m);
      } catch {
        u(!0);
      } finally {
        i(!1);
      }
  }, [t, e, n]), h = de(async () => {
    if (!(!t || !c?.cursor))
      try {
        a(!0), u(!1);
        const m = await n.getFiles({ limit: e, cursor: c.cursor });
        l((E) => ({
          cursor: m.cursor,
          data: [...E?.data || [], ...m.data],
          totalCount: m.totalCount
        }));
      } catch {
        u(!0);
      } finally {
        a(!1);
      }
  }, [t, c?.cursor, e, n]);
  return Le(() => {
    d();
  }, []), {
    isLoading: r,
    isLoadingMore: s,
    isError: o,
    data: c,
    refetch: d,
    fetchMore: h
  };
}, l3 = 1, jE = "h-[82px]", d3 = ({
  data: e,
  isLoading: t,
  isError: n,
  refetch: r,
  onButtonClick: i = () => {
  },
  onInfoClick: s = () => {
  }
}) => {
  const a = pe(() => e?.totalCount || 0, [e?.totalCount]), o = pe(() => a === 0, [a]), u = de(() => {
    i();
  }, [i]), c = de(
    (l) => {
      l.stopPropagation(), s();
    },
    [s]
  );
  return {
    isEmpty: o,
    totalCount: a,
    showLoading: t,
    showError: n,
    handleButtonClick: u,
    handleInfoClick: c,
    refetch: r
  };
}, Fh = {
  0: "gap-0",
  26: "gap-[26px]"
}, f3 = (e) => {
  const t = !e.description && !e.hasTrendTag ? Fh[26] : Fh[0];
  return /* @__PURE__ */ p.jsxDEV("a", { href: e.creatorUrl, target: "_blank", rel: "noopener noreferrer", className: "flex w-full h-full no-underline", children: /* @__PURE__ */ p.jsxDEV(ii, { theme: e.theme || "dark", children: /* @__PURE__ */ p.jsxDEV("div", { className: "flex gap-3", children: [
    e.thumbnail && /* @__PURE__ */ p.jsxDEV("div", { className: "w-[100px] shrink-0", children: /* @__PURE__ */ p.jsxDEV(ii.Thumbnail, { ...e.thumbnail }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
      lineNumber: 18,
      columnNumber: 15
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
      lineNumber: 17,
      columnNumber: 13
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("div", { className: `flex flex-col ${t}`, children: [
      e.title && /* @__PURE__ */ p.jsxDEV(ii.Title, { children: e.title }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
        lineNumber: 23,
        columnNumber: 29
      }, void 0),
      (e.description || e.hasTrendTag) && /* @__PURE__ */ p.jsxDEV("div", { className: "flex gap-[10px] pb-[10px]", children: [
        e.description && /* @__PURE__ */ p.jsxDEV(ii.Description, { children: e.description }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
          lineNumber: 27,
          columnNumber: 39
        }, void 0),
        e.hasTrendTag && /* @__PURE__ */ p.jsxDEV(ii.TrendTag, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
          lineNumber: 28,
          columnNumber: 39
        }, void 0)
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
        lineNumber: 26,
        columnNumber: 15
      }, void 0),
      e.metrics && /* @__PURE__ */ p.jsxDEV(ii.Metrics, { ...e.metrics }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
        lineNumber: 32,
        columnNumber: 31
      }, void 0)
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
      lineNumber: 22,
      columnNumber: 11
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
    lineNumber: 15,
    columnNumber: 9
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
    lineNumber: 14,
    columnNumber: 7
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/creator-card-default/index.tsx",
    lineNumber: 13,
    columnNumber: 5
  }, void 0);
}, h3 = Ce(f3), qc = {
  fb: "facebook",
  in: "instagram",
  tt: "tiktok",
  tw: "twitch",
  yt: "youtube"
}, m3 = (e) => /* @__PURE__ */ p.jsxDEV(si, { theme: e.theme || "dark", classes: ["ds-video-card-default"], children: [
  /* @__PURE__ */ p.jsxDEV("a", { href: e.videoUrl, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ p.jsxDEV(si.Thumbnail, { ...e.thumbnail }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
    lineNumber: 11,
    columnNumber: 7
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
    lineNumber: 10,
    columnNumber: 5
  }, void 0),
  /* @__PURE__ */ p.jsxDEV(si.Description, { classes: ["px-2"], children: e.description }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
    lineNumber: 13,
    columnNumber: 5
  }, void 0),
  /* @__PURE__ */ p.jsxDEV("div", { className: "flex px-2 justify-between items-center", children: [
    e.creatorUrl ? /* @__PURE__ */ p.jsxDEV("a", { href: e.creatorUrl, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ p.jsxDEV(si.Creator, { ...e.creator }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
      lineNumber: 17,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
      lineNumber: 16,
      columnNumber: 9
    }, void 0) : /* @__PURE__ */ p.jsxDEV(si.Creator, { ...e.creator }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
      lineNumber: 20,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(si.Metrics, { ...e.metrics }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
      lineNumber: 22,
      columnNumber: 7
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
    lineNumber: 14,
    columnNumber: 5
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/lib/ds/video-card-default/index.tsx",
  lineNumber: 9,
  columnNumber: 3
}, void 0), p3 = Ce(m3), bn = {
  VideoCardDefault: p3,
  // IIconProps is not exported from @winnin/ds-icon, so we widen the name type via cast
  Icon: d1,
  CreatorCardDefault: h3,
  LineChart: h1,
  SyncMultipleDonut: m1,
  ColumnsChart: f1
}, g3 = Ce(({ children: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
  "button",
  {
    ...t,
    type: "button",
    className: "flex justify-between items-center w-full gap-5 p-5 bg-black rounded-xl cursor-pointer h-[82px]",
    children: [
      /* @__PURE__ */ p.jsxDEV("div", { className: "text-sm text-white text-left leading-[21px]", children: e }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-upload/index.tsx",
        lineNumber: 13,
        columnNumber: 5
      }, void 0),
      /* @__PURE__ */ p.jsxDEV(bn.Icon, { name: "upload", width: 24, height: 24, className: "shrink-0 text-purple-300" }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-upload/index.tsx",
        lineNumber: 14,
        columnNumber: 5
      }, void 0)
    ]
  },
  void 0,
  !0,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-upload/index.tsx",
    lineNumber: 8,
    columnNumber: 3
  },
  void 0
)), Jr = ({
  isLoading: e,
  isError: t,
  isEmpty: n,
  emptyComponent: r,
  errorComponent: i,
  loadingComponent: s,
  children: a
}) => e ? /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: s }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/loading-error-wrapper/index.tsx",
  lineNumber: 21,
  columnNumber: 12
}, void 0) : t ? /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: i }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/loading-error-wrapper/index.tsx",
  lineNumber: 25,
  columnNumber: 12
}, void 0) : n && r ? /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: r }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/loading-error-wrapper/index.tsx",
  lineNumber: 29,
  columnNumber: 12
}, void 0) : /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: a }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/loading-error-wrapper/index.tsx",
  lineNumber: 32,
  columnNumber: 10
}, void 0), po = {
  error: {
    key: "file-upload.error.title",
    defaultValue: "Falha ao carregar arquivos"
  },
  tryAgain: {
    key: "file-upload.try-again",
    defaultValue: "Tentar novamente"
  },
  emptyMessage: {
    key: "file-upload.empty-message",
    defaultValue: "Expanda o conhecimento da Zai com documentos da sua marca"
  },
  filesCount: (e) => ({
    key: "file-upload.files-count",
    defaultValue: "{count, plural, one {# arquivo adicionado} other {# arquivos adicionados}}",
    parameters: { count: e }
  })
}, b3 = ({ refetch: e, t }) => /* @__PURE__ */ p.jsxDEV(
  "div",
  {
    className: `w-full p-4 bg-black rounded-xl flex flex-col items-center justify-center gap-1 ${jE}`,
    children: [
      /* @__PURE__ */ p.jsxDEV("strong", { className: "text-white text-sm", children: t(po.error) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.error.tsx",
        lineNumber: 13,
        columnNumber: 5
      }, void 0),
      /* @__PURE__ */ p.jsxDEV(Bt, { variant: "highlight-border", onClick: e, children: t(po.tryAgain) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.error.tsx",
        lineNumber: 14,
        columnNumber: 5
      }, void 0)
    ]
  },
  void 0,
  !0,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.error.tsx",
    lineNumber: 10,
    columnNumber: 3
  },
  void 0
), E3 = Ce(b3), _3 = () => /* @__PURE__ */ p.jsxDEV("div", { className: "w-full", children: /* @__PURE__ */ p.jsxDEV(Vt, { className: `bg-gray-600 rounded-xl w-full ${jE}` }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.skeleton.tsx",
  lineNumber: 10,
  columnNumber: 7
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.skeleton.tsx",
  lineNumber: 9,
  columnNumber: 5
}, void 0), x3 = Ce(_3), T3 = ({
  isEmpty: e,
  totalCount: t,
  showLoading: n,
  showError: r,
  handleButtonClick: i,
  handleInfoClick: s,
  refetch: a,
  t: o
}) => /* @__PURE__ */ p.jsxDEV("div", { className: "w-full", children: /* @__PURE__ */ p.jsxDEV(
  Jr,
  {
    isLoading: n,
    isError: r,
    loadingComponent: /* @__PURE__ */ p.jsxDEV(x3, {}, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.view.tsx",
      lineNumber: 26,
      columnNumber: 25
    }, void 0),
    errorComponent: /* @__PURE__ */ p.jsxDEV(E3, { refetch: a, t: o }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.view.tsx",
      lineNumber: 27,
      columnNumber: 23
    }, void 0),
    children: /* @__PURE__ */ p.jsxDEV(g3, { onClick: i, children: [
      o(e ? po.emptyMessage : po.filesCount(t)),
      e && /* @__PURE__ */ p.jsxDEV(
        "span",
        {
          role: "button",
          tabIndex: 0,
          className: "inline-block align-middle pl-2 cursor-pointer",
          onClick: s,
          children: /* @__PURE__ */ p.jsxDEV(bn.Icon, { name: "info", width: 16, height: 16, className: "text-white" }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.view.tsx",
            lineNumber: 38,
            columnNumber: 13
          }, void 0)
        },
        void 0,
        !1,
        {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.view.tsx",
          lineNumber: 32,
          columnNumber: 11
        },
        void 0
      )
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.view.tsx",
      lineNumber: 29,
      columnNumber: 7
    }, void 0)
  },
  void 0,
  !1,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.view.tsx",
    lineNumber: 23,
    columnNumber: 5
  },
  void 0
) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/file-upload.view.tsx",
  lineNumber: 22,
  columnNumber: 3
}, void 0), A3 = Ce(T3), BE = ut(({ onButtonClick: e, onInfoClick: t }, n) => {
  const { t: r } = Je(), { data: i, isLoading: s, isError: a, refetch: o } = c3({
    limit: l3
  });
  o1(
    n,
    () => ({
      refetch: o
    }),
    [o]
  );
  const u = d3({
    data: i,
    isLoading: s,
    isError: a,
    refetch: o,
    onButtonClick: e,
    onInfoClick: t
  });
  return /* @__PURE__ */ p.jsxDEV(A3, { ...u, t: r }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/file-upload/index.tsx",
    lineNumber: 35,
    columnNumber: 10
  }, void 0);
});
BE.displayName = "FileUpload";
const y3 = ({ copiedDuration: e = 3e3 } = {}) => {
  const { workspaceId: t } = St(), n = Ve(), r = n.message(), i = n.composer(), s = Ve(), a = oe((u) => {
    const c = u?.message;
    return c ? (c.role !== "assistant" || c.status.type !== "running") && c.content.some((l) => l.type === "text" && l.text?.length > 0) : !1;
  }), o = de(() => {
    const { isEditing: u, text: c } = i.getState(), l = u ? c : r.getCopyText(), d = new ld(t, l).replaceWidgetTagWithLink().build();
    navigator.clipboard.writeText(d).then(() => {
      s.message().setIsCopied(!0), setTimeout(() => s.message().setIsCopied(!1), e);
    });
  }, [i, r, t, s, e]);
  return a ? o : null;
}, pd = ut(({ copiedDuration: e, onClick: t, disabled: n, ...r }, i) => {
  const s = oe((o) => o.message.isCopied), a = y3({ copiedDuration: e });
  return /* @__PURE__ */ p.jsxDEV(
    Wt.button,
    {
      type: "button",
      ...s ? { "data-copied": "true" } : {},
      ...r,
      ref: i,
      disabled: n || !a,
      onClick: Oe(t, () => {
        a?.();
      })
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/custom-action-bar-copy.tsx",
      lineNumber: 91,
      columnNumber: 5
    },
    void 0
  );
});
pd.displayName = "ActionBarPrimitive.Copy";
class N3 extends Error {
  /**
   * Create an assertion error.
   *
   * @param {string} message
   *   Message explaining error.
   * @param {unknown} actual
   *   Value.
   * @param {unknown} expected
   *   Baseline.
   * @param {string} operator
   *   Name of equality operation.
   * @param {boolean} generated
   *   Whether `message` is a custom message or not
   * @returns
   *   Instance.
   */
  // eslint-disable-next-line max-params
  constructor(n, r, i, s, a) {
    super(n);
    O(
      this,
      "name",
      /** @type {const} */
      "Assertion"
    );
    O(
      this,
      "code",
      /** @type {const} */
      "ERR_ASSERTION"
    );
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.actual = r, this.expected = i, this.generated = a, this.operator = s;
  }
}
function L(e, t) {
  FE(
    !!e,
    !1,
    !0,
    "ok",
    "Expected value to be truthy",
    t
  );
}
function Kc(e) {
  FE(!1, !1, !0, "ok", "Unreachable", e);
}
function FE(e, t, n, r, i, s) {
  if (!e)
    throw s instanceof Error ? s : new N3(
      s || i,
      t,
      n,
      r,
      !s
    );
}
function zh(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), i = 0, s = !1;
  for (; !s; ) {
    r === -1 && (r = n.length, s = !0);
    const a = n.slice(i, r).trim();
    (a || !s) && t.push(a), i = r + 1, r = n.indexOf(",", i);
  }
  return t;
}
function zE(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const v3 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, w3 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, C3 = {};
function Vh(e, t) {
  return (C3.jsx ? w3 : v3).test(e);
}
const S3 = /[ \t\n\f\r]/g;
function k3(e) {
  return typeof e == "object" ? e.type === "text" ? Wh(e.value) : !1 : Wh(e);
}
function Wh(e) {
  return e.replace(S3, "") === "";
}
class Xs {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
Xs.prototype.normal = {};
Xs.prototype.property = {};
Xs.prototype.space = void 0;
function VE(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new Xs(n, r, t);
}
function Os(e) {
  return e.toLowerCase();
}
class $t {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
$t.prototype.attribute = "";
$t.prototype.booleanish = !1;
$t.prototype.boolean = !1;
$t.prototype.commaOrSpaceSeparated = !1;
$t.prototype.commaSeparated = !1;
$t.prototype.defined = !1;
$t.prototype.mustUseProperty = !1;
$t.prototype.number = !1;
$t.prototype.overloadedBoolean = !1;
$t.prototype.property = "";
$t.prototype.spaceSeparated = !1;
$t.prototype.space = void 0;
let I3 = 0;
const je = Zr(), mt = Zr(), Qc = Zr(), ie = Zr(), it = Zr(), _i = Zr(), Gt = Zr();
function Zr() {
  return 2 ** ++I3;
}
const Xc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: je,
  booleanish: mt,
  commaOrSpaceSeparated: Gt,
  commaSeparated: _i,
  number: ie,
  overloadedBoolean: Qc,
  spaceSeparated: it
}, Symbol.toStringTag, { value: "Module" })), Ku = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Xc)
);
class gd extends $t {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let s = -1;
    if (super(t, n), $h(this, "space", i), typeof r == "number")
      for (; ++s < Ku.length; ) {
        const a = Ku[s];
        $h(this, Ku[s], (r & Xc[a]) === Xc[a]);
      }
  }
}
gd.prototype.defined = !0;
function $h(e, t, n) {
  n && (e[t] = n);
}
function Ui(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const s = new gd(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (s.mustUseProperty = !0), t[r] = s, n[Os(r)] = r, n[Os(s.attribute)] = r;
  }
  return new Xs(t, n, e.space);
}
const WE = Ui({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: mt,
    ariaAutoComplete: null,
    ariaBusy: mt,
    ariaChecked: mt,
    ariaColCount: ie,
    ariaColIndex: ie,
    ariaColSpan: ie,
    ariaControls: it,
    ariaCurrent: null,
    ariaDescribedBy: it,
    ariaDetails: null,
    ariaDisabled: mt,
    ariaDropEffect: it,
    ariaErrorMessage: null,
    ariaExpanded: mt,
    ariaFlowTo: it,
    ariaGrabbed: mt,
    ariaHasPopup: null,
    ariaHidden: mt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: it,
    ariaLevel: ie,
    ariaLive: null,
    ariaModal: mt,
    ariaMultiLine: mt,
    ariaMultiSelectable: mt,
    ariaOrientation: null,
    ariaOwns: it,
    ariaPlaceholder: null,
    ariaPosInSet: ie,
    ariaPressed: mt,
    ariaReadOnly: mt,
    ariaRelevant: null,
    ariaRequired: mt,
    ariaRoleDescription: it,
    ariaRowCount: ie,
    ariaRowIndex: ie,
    ariaRowSpan: ie,
    ariaSelected: mt,
    ariaSetSize: ie,
    ariaSort: null,
    ariaValueMax: ie,
    ariaValueMin: ie,
    ariaValueNow: ie,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function $E(e, t) {
  return t in e ? e[t] : t;
}
function YE(e, t) {
  return $E(e, t.toLowerCase());
}
const D3 = Ui({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: _i,
    acceptCharset: it,
    accessKey: it,
    action: null,
    allow: null,
    allowFullScreen: je,
    allowPaymentRequest: je,
    allowUserMedia: je,
    alt: null,
    as: null,
    async: je,
    autoCapitalize: null,
    autoComplete: it,
    autoFocus: je,
    autoPlay: je,
    blocking: it,
    capture: null,
    charSet: null,
    checked: je,
    cite: null,
    className: it,
    cols: ie,
    colSpan: null,
    content: null,
    contentEditable: mt,
    controls: je,
    controlsList: it,
    coords: ie | _i,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: je,
    defer: je,
    dir: null,
    dirName: null,
    disabled: je,
    download: Qc,
    draggable: mt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: je,
    formTarget: null,
    headers: it,
    height: ie,
    hidden: Qc,
    high: ie,
    href: null,
    hrefLang: null,
    htmlFor: it,
    httpEquiv: it,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: je,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: je,
    itemId: null,
    itemProp: it,
    itemRef: it,
    itemScope: je,
    itemType: it,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: je,
    low: ie,
    manifest: null,
    max: null,
    maxLength: ie,
    media: null,
    method: null,
    min: null,
    minLength: ie,
    multiple: je,
    muted: je,
    name: null,
    nonce: null,
    noModule: je,
    noValidate: je,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: je,
    optimum: ie,
    pattern: null,
    ping: it,
    placeholder: null,
    playsInline: je,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: je,
    referrerPolicy: null,
    rel: it,
    required: je,
    reversed: je,
    rows: ie,
    rowSpan: ie,
    sandbox: it,
    scope: null,
    scoped: je,
    seamless: je,
    selected: je,
    shadowRootClonable: je,
    shadowRootDelegatesFocus: je,
    shadowRootMode: null,
    shape: null,
    size: ie,
    sizes: null,
    slot: null,
    span: ie,
    spellCheck: mt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: ie,
    step: null,
    style: null,
    tabIndex: ie,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: je,
    useMap: null,
    value: mt,
    width: ie,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: it,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: ie,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: ie,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: je,
    // Lists. Use CSS to reduce space between items instead
    declare: je,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: ie,
    // `<img>` and `<object>`
    leftMargin: ie,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: ie,
    // `<body>`
    marginWidth: ie,
    // `<body>`
    noResize: je,
    // `<frame>`
    noHref: je,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: je,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: je,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: ie,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: mt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: ie,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: ie,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: je,
    disableRemotePlayback: je,
    prefix: null,
    property: null,
    results: ie,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: YE
}), R3 = Ui({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Gt,
    accentHeight: ie,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: ie,
    amplitude: ie,
    arabicForm: null,
    ascent: ie,
    attributeName: null,
    attributeType: null,
    azimuth: ie,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: ie,
    by: null,
    calcMode: null,
    capHeight: ie,
    className: it,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: ie,
    diffuseConstant: ie,
    direction: null,
    display: null,
    dur: null,
    divisor: ie,
    dominantBaseline: null,
    download: je,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: ie,
    enableBackground: null,
    end: null,
    event: null,
    exponent: ie,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: ie,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: _i,
    g2: _i,
    glyphName: _i,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: ie,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: ie,
    horizOriginX: ie,
    horizOriginY: ie,
    id: null,
    ideographic: ie,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: ie,
    k: ie,
    k1: ie,
    k2: ie,
    k3: ie,
    k4: ie,
    kernelMatrix: Gt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: ie,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: ie,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: ie,
    overlineThickness: ie,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: ie,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: it,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: ie,
    pointsAtY: ie,
    pointsAtZ: ie,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Gt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Gt,
    rev: Gt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Gt,
    requiredFeatures: Gt,
    requiredFonts: Gt,
    requiredFormats: Gt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: ie,
    specularExponent: ie,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: ie,
    strikethroughThickness: ie,
    string: null,
    stroke: null,
    strokeDashArray: Gt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: ie,
    strokeOpacity: ie,
    strokeWidth: null,
    style: null,
    surfaceScale: ie,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Gt,
    tabIndex: ie,
    tableValues: null,
    target: null,
    targetX: ie,
    targetY: ie,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Gt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: ie,
    underlineThickness: ie,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: ie,
    values: null,
    vAlphabetic: ie,
    vMathematical: ie,
    vectorEffect: null,
    vHanging: ie,
    vIdeographic: ie,
    version: null,
    vertAdvY: ie,
    vertOriginX: ie,
    vertOriginY: ie,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: ie,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: $E
}), GE = Ui({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), qE = Ui({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: YE
}), KE = Ui({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), P3 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, O3 = /[A-Z]/g, Yh = /-[a-z]/g, L3 = /^data[-\w.:]+$/i;
function iu(e, t) {
  const n = Os(t);
  let r = t, i = $t;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && L3.test(t)) {
    if (t.charAt(4) === "-") {
      const s = t.slice(5).replace(Yh, U3);
      r = "data" + s.charAt(0).toUpperCase() + s.slice(1);
    } else {
      const s = t.slice(4);
      if (!Yh.test(s)) {
        let a = s.replace(O3, M3);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    i = gd;
  }
  return new i(r, t);
}
function M3(e) {
  return "-" + e.toLowerCase();
}
function U3(e) {
  return e.charAt(1).toUpperCase();
}
const Js = VE([WE, D3, GE, qE, KE], "html"), Tr = VE([WE, R3, GE, qE, KE], "svg");
function Gh(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function QE(e) {
  return e.join(" ").trim();
}
var is = {}, Ia = { exports: {} }, Qu, qh;
function H3() {
  if (qh) return Qu;
  qh = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, i = /^:\s*/, s = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, a = /^[;\s]*/, o = /^\s+|\s+$/g, u = `
`, c = "/", l = "*", d = "", h = "comment", m = "declaration";
  Qu = function(g, T) {
    if (typeof g != "string")
      throw new TypeError("First argument must be a string");
    if (!g) return [];
    T = T || {};
    var _ = 1, A = 1;
    function w(j) {
      var H = j.match(t);
      H && (_ += H.length);
      var z = j.lastIndexOf(u);
      A = ~z ? j.length - z : A + j.length;
    }
    function M() {
      var j = { line: _, column: A };
      return function(H) {
        return H.position = new F(j), $(), H;
      };
    }
    function F(j) {
      this.start = j, this.end = { line: _, column: A }, this.source = T.source;
    }
    F.prototype.content = g;
    function k(j) {
      var H = new Error(
        T.source + ":" + _ + ":" + A + ": " + j
      );
      if (H.reason = j, H.filename = T.source, H.line = _, H.column = A, H.source = g, !T.silent) throw H;
    }
    function B(j) {
      var H = j.exec(g);
      if (H) {
        var z = H[0];
        return w(z), g = g.slice(z.length), H;
      }
    }
    function $() {
      B(n);
    }
    function J(j) {
      var H;
      for (j = j || []; H = U(); )
        H !== !1 && j.push(H);
      return j;
    }
    function U() {
      var j = M();
      if (!(c != g.charAt(0) || l != g.charAt(1))) {
        for (var H = 2; d != g.charAt(H) && (l != g.charAt(H) || c != g.charAt(H + 1)); )
          ++H;
        if (H += 2, d === g.charAt(H - 1))
          return k("End of comment missing");
        var z = g.slice(2, H - 2);
        return A += 2, w(z), g = g.slice(H), A += 2, j({
          type: h,
          comment: z
        });
      }
    }
    function re() {
      var j = M(), H = B(r);
      if (H) {
        if (U(), !B(i)) return k("property missing ':'");
        var z = B(s), W = j({
          type: m,
          property: E(H[0].replace(e, d)),
          value: z ? E(z[0].replace(e, d)) : d
        });
        return B(a), W;
      }
    }
    function ae() {
      var j = [];
      J(j);
      for (var H; H = re(); )
        H !== !1 && (j.push(H), J(j));
      return j;
    }
    return $(), ae();
  };
  function E(g) {
    return g ? g.replace(o, d) : d;
  }
  return Qu;
}
var Kh;
function j3() {
  if (Kh) return Ia.exports;
  Kh = 1;
  var e = H3();
  function t(n, r) {
    var i = null;
    if (!n || typeof n != "string")
      return i;
    for (var s, a = e(n), o = typeof r == "function", u, c, l = 0, d = a.length; l < d; l++)
      s = a[l], u = s.property, c = s.value, o ? r(u, c, s) : c && (i || (i = {}), i[u] = c);
    return i;
  }
  return Ia.exports = t, Ia.exports.default = t, Ia.exports;
}
var ss = {}, Qh;
function B3() {
  if (Qh) return ss;
  Qh = 1, ss.__esModule = !0, ss.camelCase = void 0;
  var e = /^--[a-zA-Z0-9-]+$/, t = /-([a-z])/g, n = /^[^-]+$/, r = /^-(webkit|moz|ms|o|khtml)-/, i = /^-(ms)-/, s = function(c) {
    return !c || n.test(c) || e.test(c);
  }, a = function(c, l) {
    return l.toUpperCase();
  }, o = function(c, l) {
    return "".concat(l, "-");
  }, u = function(c, l) {
    return l === void 0 && (l = {}), s(c) ? c : (c = c.toLowerCase(), l.reactCompat ? c = c.replace(i, o) : c = c.replace(r, o), c.replace(t, a));
  };
  return ss.camelCase = u, ss;
}
var Xh;
function F3() {
  return Xh || (Xh = 1, (function(e) {
    var t = is && is.__importDefault || function(s) {
      return s && s.__esModule ? s : { default: s };
    };
    e.__esModule = !0;
    var n = t(j3()), r = B3();
    function i(s, a) {
      var o = {};
      return !s || typeof s != "string" || (0, n.default)(s, function(u, c) {
        u && c && (o[(0, r.camelCase)(u, a)] = c);
      }), o;
    }
    e.default = i;
  })(is)), is;
}
var z3 = F3();
const V3 = /* @__PURE__ */ pr(z3), su = XE("end"), On = XE("start");
function XE(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function W3(e) {
  const t = On(e), n = su(e);
  if (t && n)
    return { start: t, end: n };
}
function _s(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Jh(e.position) : "start" in e || "end" in e ? Jh(e) : "line" in e || "column" in e ? Jc(e) : "";
}
function Jc(e) {
  return Zh(e && e.line) + ":" + Zh(e && e.column);
}
function Jh(e) {
  return Jc(e && e.start) + "-" + Jc(e && e.end);
}
function Zh(e) {
  return e && typeof e == "number" ? e : 1;
}
class Lt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", s = {}, a = !1;
    if (n && ("line" in n && "column" in n ? s = { place: n } : "start" in n && "end" in n ? s = { place: n } : "type" in n ? s = {
      ancestors: [n],
      place: n.position
    } : s = { ...n }), typeof t == "string" ? i = t : !s.cause && t && (a = !0, i = t.message, s.cause = t), !s.ruleId && !s.source && typeof r == "string") {
      const u = r.indexOf(":");
      u === -1 ? s.ruleId = r : (s.source = r.slice(0, u), s.ruleId = r.slice(u + 1));
    }
    if (!s.place && s.ancestors && s.ancestors) {
      const u = s.ancestors[s.ancestors.length - 1];
      u && (s.place = u.position);
    }
    const o = s.place && "start" in s.place ? s.place.start : s.place;
    this.ancestors = s.ancestors || void 0, this.cause = s.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file = "", this.message = i, this.line = o ? o.line : void 0, this.name = _s(s.place) || "1:1", this.place = s.place || void 0, this.reason = this.message, this.ruleId = s.ruleId || void 0, this.source = s.source || void 0, this.stack = a && s.cause && typeof s.cause.stack == "string" ? s.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
Lt.prototype.file = "";
Lt.prototype.name = "";
Lt.prototype.reason = "";
Lt.prototype.message = "";
Lt.prototype.stack = "";
Lt.prototype.column = void 0;
Lt.prototype.line = void 0;
Lt.prototype.ancestors = void 0;
Lt.prototype.cause = void 0;
Lt.prototype.fatal = void 0;
Lt.prototype.place = void 0;
Lt.prototype.ruleId = void 0;
Lt.prototype.source = void 0;
const bd = {}.hasOwnProperty, $3 = /* @__PURE__ */ new Map(), Y3 = /[A-Z]/g, G3 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), q3 = /* @__PURE__ */ new Set(["td", "th"]), JE = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function K3(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = rP(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = nP(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? Tr : Js,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, s = ZE(i, e, void 0);
  return s && typeof s != "string" ? s : i.create(
    e,
    i.Fragment,
    { children: s || void 0 },
    void 0
  );
}
function ZE(e, t, n) {
  if (t.type === "element")
    return Q3(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return X3(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return Z3(e, t, n);
  if (t.type === "mdxjsEsm")
    return J3(e, t);
  if (t.type === "root")
    return eP(e, t, n);
  if (t.type === "text")
    return tP(e, t);
}
function Q3(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = Tr, e.schema = i), e.ancestors.push(t);
  const s = t_(e, t.tagName, !1), a = iP(e, t);
  let o = _d(e, t);
  return G3.has(t.tagName) && (o = o.filter(function(u) {
    return typeof u == "string" ? !k3(u) : !0;
  })), e_(e, a, s, t), Ed(a, o), e.ancestors.pop(), e.schema = r, e.create(t, s, a, n);
}
function X3(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return L(r.type === "ExpressionStatement"), /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  Ls(e, t.position);
}
function J3(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  Ls(e, t.position);
}
function Z3(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = Tr, e.schema = i), e.ancestors.push(t);
  const s = t.name === null ? e.Fragment : t_(e, t.name, !0), a = sP(e, t), o = _d(e, t);
  return e_(e, a, s, t), Ed(a, o), e.ancestors.pop(), e.schema = r, e.create(t, s, a, n);
}
function eP(e, t, n) {
  const r = {};
  return Ed(r, _d(e, t)), e.create(t, e.Fragment, r, n);
}
function tP(e, t) {
  return t.value;
}
function e_(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function Ed(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function nP(e, t, n) {
  return r;
  function r(i, s, a, o) {
    const c = Array.isArray(a.children) ? n : t;
    return o ? c(s, a, o) : c(s, a);
  }
}
function rP(e, t) {
  return n;
  function n(r, i, s, a) {
    const o = Array.isArray(s.children), u = On(r);
    return t(
      i,
      s,
      a,
      o,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function iP(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && bd.call(t.properties, i)) {
      const s = aP(e, i, t.properties[i]);
      if (s) {
        const [a, o] = s;
        e.tableCellAlignToStyle && a === "align" && typeof o == "string" && q3.has(t.tagName) ? r = o : n[a] = o;
      }
    }
  if (r) {
    const s = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    s[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function sP(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const s = r.data.estree.body[0];
        L(s.type === "ExpressionStatement");
        const a = s.expression;
        L(a.type === "ObjectExpression");
        const o = a.properties[0];
        L(o.type === "SpreadElement"), Object.assign(
          n,
          e.evaluater.evaluateExpression(o.argument)
        );
      } else
        Ls(e, t.position);
    else {
      const i = r.name;
      let s;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const o = r.value.data.estree.body[0];
          L(o.type === "ExpressionStatement"), s = e.evaluater.evaluateExpression(o.expression);
        } else
          Ls(e, t.position);
      else
        s = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      s;
    }
  return n;
}
function _d(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : $3;
  for (; ++r < t.children.length; ) {
    const s = t.children[r];
    let a;
    if (e.passKeys) {
      const u = s.type === "element" ? s.tagName : s.type === "mdxJsxFlowElement" || s.type === "mdxJsxTextElement" ? s.name : void 0;
      if (u) {
        const c = i.get(u) || 0;
        a = u + "-" + c, i.set(u, c + 1);
      }
    }
    const o = ZE(e, s, a);
    o !== void 0 && n.push(o);
  }
  return n;
}
function aP(e, t, n) {
  const r = iu(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? zE(n) : QE(n)), r.property === "style") {
      let i = typeof n == "object" ? n : oP(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = uP(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? P3[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function oP(e, t) {
  try {
    return V3(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new Lt("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = JE + "#cannot-parse-style-attribute", i;
  }
}
function t_(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let s = -1, a;
    for (; ++s < i.length; ) {
      const o = Vh(i[s]) ? { type: "Identifier", name: i[s] } : { type: "Literal", value: i[s] };
      a = a ? {
        type: "MemberExpression",
        object: a,
        property: o,
        computed: !!(s && o.type === "Literal"),
        optional: !1
      } : o;
    }
    L(a, "always a result"), r = a;
  } else
    r = Vh(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return bd.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  Ls(e);
}
function Ls(e, t) {
  const n = new Lt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = JE + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function uP(e) {
  const t = {};
  let n;
  for (n in e)
    bd.call(e, n) && (t[cP(n)] = e[n]);
  return t;
}
function cP(e) {
  let t = e.replace(Y3, lP);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function lP(e) {
  return "-" + e.toLowerCase();
}
const Xu = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, dP = {};
function xd(e, t) {
  const n = dP, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return n_(e, r, i);
}
function n_(e, t, n) {
  if (fP(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return em(e.children, t, n);
  }
  return Array.isArray(e) ? em(e, t, n) : "";
}
function em(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = n_(e[i], t, n);
  return r.join("");
}
function fP(e) {
  return !!(e && typeof e == "object");
}
const tm = document.createElement("i");
function Td(e) {
  const t = "&" + e + ";";
  tm.innerHTML = t;
  const n = tm.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
const b = (
  /** @type {const} */
  {
    carriageReturn: -5,
    lineFeed: -4,
    carriageReturnLineFeed: -3,
    horizontalTab: -2,
    virtualSpace: -1,
    eof: null,
    nul: 0,
    ht: 9,
    // `\t`
    lf: 10,
    // `\n`
    vt: 11,
    // `\v`
    cr: 13,
    // `\r`
    space: 32,
    exclamationMark: 33,
    // `!`
    quotationMark: 34,
    // `"`
    numberSign: 35,
    // `#`
    percentSign: 37,
    // `%`
    ampersand: 38,
    // `&`
    apostrophe: 39,
    // `'`
    leftParenthesis: 40,
    // `(`
    rightParenthesis: 41,
    // `)`
    asterisk: 42,
    // `*`
    plusSign: 43,
    // `+`
    comma: 44,
    // `,`
    dash: 45,
    // `-`
    dot: 46,
    // `.`
    slash: 47,
    // `/`
    digit0: 48,
    // `0`
    digit1: 49,
    // `1`
    digit2: 50,
    // `2`
    digit3: 51,
    // `3`
    digit4: 52,
    // `4`
    digit5: 53,
    // `5`
    digit6: 54,
    // `6`
    digit7: 55,
    // `7`
    digit8: 56,
    // `8`
    digit9: 57,
    // `9`
    colon: 58,
    // `:`
    semicolon: 59,
    // `;`
    lessThan: 60,
    // `<`
    equalsTo: 61,
    // `=`
    greaterThan: 62,
    // `>`
    questionMark: 63,
    // `?`
    atSign: 64,
    // `@`
    uppercaseA: 65,
    // `A`
    uppercaseH: 72,
    // `H`
    uppercaseW: 87,
    // `W`
    uppercaseX: 88,
    // `X`
    leftSquareBracket: 91,
    // `[`
    backslash: 92,
    // `\`
    rightSquareBracket: 93,
    // `]`
    caret: 94,
    // `^`
    underscore: 95,
    // `_`
    graveAccent: 96,
    // `` ` ``
    lowercaseA: 97,
    // `a`
    lowercaseH: 104,
    // `h`
    lowercaseW: 119,
    // `w`
    lowercaseX: 120,
    // `x`
    leftCurlyBrace: 123,
    // `{`
    verticalBar: 124,
    // `|`
    tilde: 126,
    // `~`
    del: 127,
    // Unicode Specials block.
    byteOrderMarker: 65279,
    // Unicode Specials block.
    replacementCharacter: 65533
    // `�`
  }
), ue = (
  /** @type {const} */
  {
    attentionSideAfter: 2,
    // Symbol to mark an attention sequence as after content: `a*`
    atxHeadingOpeningFenceSizeMax: 6,
    // 6 number signs is fine, 7 isn’t.
    autolinkDomainSizeMax: 63,
    // 63 characters is fine, 64 is too many.
    autolinkSchemeSizeMax: 32,
    // 32 characters is fine, 33 is too many.
    cdataOpeningString: "CDATA[",
    // And preceded by `<![`.
    characterGroupPunctuation: 2,
    // Symbol used to indicate a character is punctuation
    characterGroupWhitespace: 1,
    // Symbol used to indicate a character is whitespace
    characterReferenceDecimalSizeMax: 7,
    // `&#9999999;`.
    characterReferenceHexadecimalSizeMax: 6,
    // `&#xff9999;`.
    characterReferenceNamedSizeMax: 31,
    // `&CounterClockwiseContourIntegral;`.
    codeFencedSequenceSizeMin: 3,
    // At least 3 ticks or tildes are needed.
    contentTypeContent: "content",
    contentTypeFlow: "flow",
    contentTypeString: "string",
    contentTypeText: "text",
    hardBreakPrefixSizeMin: 2,
    // At least 2 trailing spaces are needed.
    htmlBasic: 6,
    // Symbol for `<div`
    htmlCdata: 5,
    // Symbol for `<![CDATA[]]>`
    htmlComment: 2,
    // Symbol for `<!---->`
    htmlComplete: 7,
    // Symbol for `<x>`
    htmlDeclaration: 4,
    // Symbol for `<!doctype>`
    htmlInstruction: 3,
    // Symbol for `<?php?>`
    htmlRawSizeMax: 8,
    // Length of `textarea`.
    htmlRaw: 1,
    // Symbol for `<script>`
    linkResourceDestinationBalanceMax: 32,
    // See: <https://spec.commonmark.org/0.30/#link-destination>, <https://github.com/remarkjs/react-markdown/issues/658#issuecomment-984345577>
    linkReferenceSizeMax: 999,
    // See: <https://spec.commonmark.org/0.30/#link-label>
    listItemValueSizeMax: 10,
    // See: <https://spec.commonmark.org/0.30/#ordered-list-marker>
    numericBaseDecimal: 10,
    numericBaseHexadecimal: 16,
    tabSize: 4,
    // Tabs have a hard-coded size of 4, per CommonMark.
    thematicBreakMarkerCountMin: 3,
    // At least 3 asterisks, dashes, or underscores are needed.
    v8MaxSafeChunkSize: 1e4
    // V8 (and potentially others) have problems injecting giant arrays into other arrays, hence we operate in chunks.
  }
), x = (
  /** @type {const} */
  {
    // Generic type for data, such as in a title, a destination, etc.
    data: "data",
    // Generic type for syntactic whitespace (tabs, virtual spaces, spaces).
    // Such as, between a fenced code fence and an info string.
    whitespace: "whitespace",
    // Generic type for line endings (line feed, carriage return, carriage return +
    // line feed).
    lineEnding: "lineEnding",
    // A line ending, but ending a blank line.
    lineEndingBlank: "lineEndingBlank",
    // Generic type for whitespace (tabs, virtual spaces, spaces) at the start of a
    // line.
    linePrefix: "linePrefix",
    // Generic type for whitespace (tabs, virtual spaces, spaces) at the end of a
    // line.
    lineSuffix: "lineSuffix",
    // Whole ATX heading:
    //
    // ```markdown
    // #
    // ## Alpha
    // ### Bravo ###
    // ```
    //
    // Includes `atxHeadingSequence`, `whitespace`, `atxHeadingText`.
    atxHeading: "atxHeading",
    // Sequence of number signs in an ATX heading (`###`).
    atxHeadingSequence: "atxHeadingSequence",
    // Content in an ATX heading (`alpha`).
    // Includes text.
    atxHeadingText: "atxHeadingText",
    // Whole autolink (`<https://example.com>` or `<admin@example.com>`)
    // Includes `autolinkMarker` and `autolinkProtocol` or `autolinkEmail`.
    autolink: "autolink",
    // Email autolink w/o markers (`admin@example.com`)
    autolinkEmail: "autolinkEmail",
    // Marker around an `autolinkProtocol` or `autolinkEmail` (`<` or `>`).
    autolinkMarker: "autolinkMarker",
    // Protocol autolink w/o markers (`https://example.com`)
    autolinkProtocol: "autolinkProtocol",
    // A whole character escape (`\-`).
    // Includes `escapeMarker` and `characterEscapeValue`.
    characterEscape: "characterEscape",
    // The escaped character (`-`).
    characterEscapeValue: "characterEscapeValue",
    // A whole character reference (`&amp;`, `&#8800;`, or `&#x1D306;`).
    // Includes `characterReferenceMarker`, an optional
    // `characterReferenceMarkerNumeric`, in which case an optional
    // `characterReferenceMarkerHexadecimal`, and a `characterReferenceValue`.
    characterReference: "characterReference",
    // The start or end marker (`&` or `;`).
    characterReferenceMarker: "characterReferenceMarker",
    // Mark reference as numeric (`#`).
    characterReferenceMarkerNumeric: "characterReferenceMarkerNumeric",
    // Mark reference as numeric (`x` or `X`).
    characterReferenceMarkerHexadecimal: "characterReferenceMarkerHexadecimal",
    // Value of character reference w/o markers (`amp`, `8800`, or `1D306`).
    characterReferenceValue: "characterReferenceValue",
    // Whole fenced code:
    //
    // ````markdown
    // ```js
    // alert(1)
    // ```
    // ````
    codeFenced: "codeFenced",
    // A fenced code fence, including whitespace, sequence, info, and meta
    // (` ```js `).
    codeFencedFence: "codeFencedFence",
    // Sequence of grave accent or tilde characters (` ``` `) in a fence.
    codeFencedFenceSequence: "codeFencedFenceSequence",
    // Info word (`js`) in a fence.
    // Includes string.
    codeFencedFenceInfo: "codeFencedFenceInfo",
    // Meta words (`highlight="1"`) in a fence.
    // Includes string.
    codeFencedFenceMeta: "codeFencedFenceMeta",
    // A line of code.
    codeFlowValue: "codeFlowValue",
    // Whole indented code:
    //
    // ```markdown
    //     alert(1)
    // ```
    //
    // Includes `lineEnding`, `linePrefix`, and `codeFlowValue`.
    codeIndented: "codeIndented",
    // A text code (``` `alpha` ```).
    // Includes `codeTextSequence`, `codeTextData`, `lineEnding`, and can include
    // `codeTextPadding`.
    codeText: "codeText",
    codeTextData: "codeTextData",
    // A space or line ending right after or before a tick.
    codeTextPadding: "codeTextPadding",
    // A text code fence (` `` `).
    codeTextSequence: "codeTextSequence",
    // Whole content:
    //
    // ```markdown
    // [a]: b
    // c
    // =
    // d
    // ```
    //
    // Includes `paragraph` and `definition`.
    content: "content",
    // Whole definition:
    //
    // ```markdown
    // [micromark]: https://github.com/micromark/micromark
    // ```
    //
    // Includes `definitionLabel`, `definitionMarker`, `whitespace`,
    // `definitionDestination`, and optionally `lineEnding` and `definitionTitle`.
    definition: "definition",
    // Destination of a definition (`https://github.com/micromark/micromark` or
    // `<https://github.com/micromark/micromark>`).
    // Includes `definitionDestinationLiteral` or `definitionDestinationRaw`.
    definitionDestination: "definitionDestination",
    // Enclosed destination of a definition
    // (`<https://github.com/micromark/micromark>`).
    // Includes `definitionDestinationLiteralMarker` and optionally
    // `definitionDestinationString`.
    definitionDestinationLiteral: "definitionDestinationLiteral",
    // Markers of an enclosed definition destination (`<` or `>`).
    definitionDestinationLiteralMarker: "definitionDestinationLiteralMarker",
    // Unenclosed destination of a definition
    // (`https://github.com/micromark/micromark`).
    // Includes `definitionDestinationString`.
    definitionDestinationRaw: "definitionDestinationRaw",
    // Text in an destination (`https://github.com/micromark/micromark`).
    // Includes string.
    definitionDestinationString: "definitionDestinationString",
    // Label of a definition (`[micromark]`).
    // Includes `definitionLabelMarker` and `definitionLabelString`.
    definitionLabel: "definitionLabel",
    // Markers of a definition label (`[` or `]`).
    definitionLabelMarker: "definitionLabelMarker",
    // Value of a definition label (`micromark`).
    // Includes string.
    definitionLabelString: "definitionLabelString",
    // Marker between a label and a destination (`:`).
    definitionMarker: "definitionMarker",
    // Title of a definition (`"x"`, `'y'`, or `(z)`).
    // Includes `definitionTitleMarker` and optionally `definitionTitleString`.
    definitionTitle: "definitionTitle",
    // Marker around a title of a definition (`"`, `'`, `(`, or `)`).
    definitionTitleMarker: "definitionTitleMarker",
    // Data without markers in a title (`z`).
    // Includes string.
    definitionTitleString: "definitionTitleString",
    // Emphasis (`*alpha*`).
    // Includes `emphasisSequence` and `emphasisText`.
    emphasis: "emphasis",
    // Sequence of emphasis markers (`*` or `_`).
    emphasisSequence: "emphasisSequence",
    // Emphasis text (`alpha`).
    // Includes text.
    emphasisText: "emphasisText",
    // The character escape marker (`\`).
    escapeMarker: "escapeMarker",
    // A hard break created with a backslash (`\\n`).
    // Note: does not include the line ending.
    hardBreakEscape: "hardBreakEscape",
    // A hard break created with trailing spaces (`  \n`).
    // Does not include the line ending.
    hardBreakTrailing: "hardBreakTrailing",
    // Flow HTML:
    //
    // ```markdown
    // <div
    // ```
    //
    // Inlcudes `lineEnding`, `htmlFlowData`.
    htmlFlow: "htmlFlow",
    htmlFlowData: "htmlFlowData",
    // HTML in text (the tag in `a <i> b`).
    // Includes `lineEnding`, `htmlTextData`.
    htmlText: "htmlText",
    htmlTextData: "htmlTextData",
    // Whole image (`![alpha](bravo)`, `![alpha][bravo]`, `![alpha][]`, or
    // `![alpha]`).
    // Includes `label` and an optional `resource` or `reference`.
    image: "image",
    // Whole link label (`[*alpha*]`).
    // Includes `labelLink` or `labelImage`, `labelText`, and `labelEnd`.
    label: "label",
    // Text in an label (`*alpha*`).
    // Includes text.
    labelText: "labelText",
    // Start a link label (`[`).
    // Includes a `labelMarker`.
    labelLink: "labelLink",
    // Start an image label (`![`).
    // Includes `labelImageMarker` and `labelMarker`.
    labelImage: "labelImage",
    // Marker of a label (`[` or `]`).
    labelMarker: "labelMarker",
    // Marker to start an image (`!`).
    labelImageMarker: "labelImageMarker",
    // End a label (`]`).
    // Includes `labelMarker`.
    labelEnd: "labelEnd",
    // Whole link (`[alpha](bravo)`, `[alpha][bravo]`, `[alpha][]`, or `[alpha]`).
    // Includes `label` and an optional `resource` or `reference`.
    link: "link",
    // Whole paragraph:
    //
    // ```markdown
    // alpha
    // bravo.
    // ```
    //
    // Includes text.
    paragraph: "paragraph",
    // A reference (`[alpha]` or `[]`).
    // Includes `referenceMarker` and an optional `referenceString`.
    reference: "reference",
    // A reference marker (`[` or `]`).
    referenceMarker: "referenceMarker",
    // Reference text (`alpha`).
    // Includes string.
    referenceString: "referenceString",
    // A resource (`(https://example.com "alpha")`).
    // Includes `resourceMarker`, an optional `resourceDestination` with an optional
    // `whitespace` and `resourceTitle`.
    resource: "resource",
    // A resource destination (`https://example.com`).
    // Includes `resourceDestinationLiteral` or `resourceDestinationRaw`.
    resourceDestination: "resourceDestination",
    // A literal resource destination (`<https://example.com>`).
    // Includes `resourceDestinationLiteralMarker` and optionally
    // `resourceDestinationString`.
    resourceDestinationLiteral: "resourceDestinationLiteral",
    // A resource destination marker (`<` or `>`).
    resourceDestinationLiteralMarker: "resourceDestinationLiteralMarker",
    // A raw resource destination (`https://example.com`).
    // Includes `resourceDestinationString`.
    resourceDestinationRaw: "resourceDestinationRaw",
    // Resource destination text (`https://example.com`).
    // Includes string.
    resourceDestinationString: "resourceDestinationString",
    // A resource marker (`(` or `)`).
    resourceMarker: "resourceMarker",
    // A resource title (`"alpha"`, `'alpha'`, or `(alpha)`).
    // Includes `resourceTitleMarker` and optionally `resourceTitleString`.
    resourceTitle: "resourceTitle",
    // A resource title marker (`"`, `'`, `(`, or `)`).
    resourceTitleMarker: "resourceTitleMarker",
    // Resource destination title (`alpha`).
    // Includes string.
    resourceTitleString: "resourceTitleString",
    // Whole setext heading:
    //
    // ```markdown
    // alpha
    // bravo
    // =====
    // ```
    //
    // Includes `setextHeadingText`, `lineEnding`, `linePrefix`, and
    // `setextHeadingLine`.
    setextHeading: "setextHeading",
    // Content in a setext heading (`alpha\nbravo`).
    // Includes text.
    setextHeadingText: "setextHeadingText",
    // Underline in a setext heading, including whitespace suffix (`==`).
    // Includes `setextHeadingLineSequence`.
    setextHeadingLine: "setextHeadingLine",
    // Sequence of equals or dash characters in underline in a setext heading (`-`).
    setextHeadingLineSequence: "setextHeadingLineSequence",
    // Strong (`**alpha**`).
    // Includes `strongSequence` and `strongText`.
    strong: "strong",
    // Sequence of strong markers (`**` or `__`).
    strongSequence: "strongSequence",
    // Strong text (`alpha`).
    // Includes text.
    strongText: "strongText",
    // Whole thematic break:
    //
    // ```markdown
    // * * *
    // ```
    //
    // Includes `thematicBreakSequence` and `whitespace`.
    thematicBreak: "thematicBreak",
    // A sequence of one or more thematic break markers (`***`).
    thematicBreakSequence: "thematicBreakSequence",
    // Whole block quote:
    //
    // ```markdown
    // > a
    // >
    // > b
    // ```
    //
    // Includes `blockQuotePrefix` and flow.
    blockQuote: "blockQuote",
    // The `>` or `> ` of a block quote.
    blockQuotePrefix: "blockQuotePrefix",
    // The `>` of a block quote prefix.
    blockQuoteMarker: "blockQuoteMarker",
    // The optional ` ` of a block quote prefix.
    blockQuotePrefixWhitespace: "blockQuotePrefixWhitespace",
    // Whole ordered list:
    //
    // ```markdown
    // 1. a
    //    b
    // ```
    //
    // Includes `listItemPrefix`, flow, and optionally  `listItemIndent` on further
    // lines.
    listOrdered: "listOrdered",
    // Whole unordered list:
    //
    // ```markdown
    // - a
    //   b
    // ```
    //
    // Includes `listItemPrefix`, flow, and optionally  `listItemIndent` on further
    // lines.
    listUnordered: "listUnordered",
    // The indent of further list item lines.
    listItemIndent: "listItemIndent",
    // A marker, as in, `*`, `+`, `-`, `.`, or `)`.
    listItemMarker: "listItemMarker",
    // The thing that starts a list item, such as `1. `.
    // Includes `listItemValue` if ordered, `listItemMarker`, and
    // `listItemPrefixWhitespace` (unless followed by a line ending).
    listItemPrefix: "listItemPrefix",
    // The whitespace after a marker.
    listItemPrefixWhitespace: "listItemPrefixWhitespace",
    // The numerical value of an ordered item.
    listItemValue: "listItemValue",
    chunkContent: "chunkContent",
    chunkFlow: "chunkFlow",
    chunkText: "chunkText",
    chunkString: "chunkString"
  }
), Nn = (
  /** @type {const} */
  {
    ht: "	",
    lf: `
`,
    cr: "\r",
    space: " ",
    replacementCharacter: "�"
  }
);
function Xt(e, t, n, r) {
  const i = e.length;
  let s = 0, a;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < ue.v8MaxSafeChunkSize)
    a = Array.from(r), a.unshift(t, n), e.splice(...a);
  else
    for (n && e.splice(t, n); s < r.length; )
      a = r.slice(
        s,
        s + ue.v8MaxSafeChunkSize
      ), a.unshift(t, 0), e.splice(...a), s += ue.v8MaxSafeChunkSize, t += ue.v8MaxSafeChunkSize;
}
function rn(e, t) {
  return e.length > 0 ? (Xt(e, e.length, 0, t), e) : t;
}
const nm = {}.hasOwnProperty;
function r_(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    hP(t, e[n]);
  return t;
}
function hP(e, t) {
  let n;
  for (n in t) {
    const i = (nm.call(e, n) ? e[n] : void 0) || (e[n] = {}), s = t[n];
    let a;
    if (s)
      for (a in s) {
        nm.call(i, a) || (i[a] = []);
        const o = s[a];
        mP(
          // @ts-expect-error Looks like a list.
          i[a],
          Array.isArray(o) ? o : o ? [o] : []
        );
      }
  }
}
function mP(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Xt(e, 0, 0, r);
}
function i_(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < b.ht || n === b.vt || n > b.cr && n < b.space || // Control character (DEL) of C0, and C1 controls.
    n > b.tilde && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? Nn.replacementCharacter : String.fromCodePoint(n)
  );
}
function hn(e) {
  return e.replace(/[\t\n\r ]+/g, Nn.space).replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const jt = Ar(/[A-Za-z]/), Rt = Ar(/[\dA-Za-z]/), pP = Ar(/[#-'*+\--9=?A-Z^-~]/);
function go(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < b.space || e === b.del)
  );
}
const Zc = Ar(/\d/), gP = Ar(/[\dA-Fa-f]/), bP = Ar(/[!-/:-@[-`{-~]/);
function me(e) {
  return e !== null && e < b.horizontalTab;
}
function rt(e) {
  return e !== null && (e < b.nul || e === b.space);
}
function ze(e) {
  return e === b.horizontalTab || e === b.virtualSpace || e === b.space;
}
const au = Ar(/\p{P}|\p{S}/u), Gr = Ar(/\s/);
function Ar(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Hi(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const s = e.charCodeAt(n);
    let a = "";
    if (s === b.percentSign && Rt(e.charCodeAt(n + 1)) && Rt(e.charCodeAt(n + 2)))
      i = 2;
    else if (s < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(s)) || (a = String.fromCharCode(s));
    else if (s > 55295 && s < 57344) {
      const o = e.charCodeAt(n + 1);
      s < 56320 && o > 56319 && o < 57344 ? (a = String.fromCharCode(s, o), i = 1) : a = Nn.replacementCharacter;
    } else
      a = String.fromCharCode(s);
    a && (t.push(e.slice(r, n), encodeURIComponent(a)), r = n + i + 1, a = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function Ge(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let s = 0;
  return a;
  function a(u) {
    return ze(u) ? (e.enter(n), o(u)) : t(u);
  }
  function o(u) {
    return ze(u) && s++ < i ? (e.consume(u), o) : (e.exit(n), t(u));
  }
}
const EP = { tokenize: _P };
function _P(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(o) {
    if (L(
      o === b.eof || me(o),
      "expected eol or eof"
    ), o === b.eof) {
      e.consume(o);
      return;
    }
    return e.enter(x.lineEnding), e.consume(o), e.exit(x.lineEnding), Ge(e, t, x.linePrefix);
  }
  function i(o) {
    return L(
      o !== b.eof && !me(o),
      "expected anything other than a line ending or EOF"
    ), e.enter(x.paragraph), s(o);
  }
  function s(o) {
    const u = e.enter(x.chunkText, {
      contentType: ue.contentTypeText,
      previous: n
    });
    return n && (n.next = u), n = u, a(o);
  }
  function a(o) {
    if (o === b.eof) {
      e.exit(x.chunkText), e.exit(x.paragraph), e.consume(o);
      return;
    }
    return me(o) ? (e.consume(o), e.exit(x.chunkText), s) : (e.consume(o), a);
  }
}
const xP = { tokenize: TP }, rm = { tokenize: AP };
function TP(e) {
  const t = this, n = [];
  let r = 0, i, s, a;
  return o;
  function o(w) {
    if (r < n.length) {
      const M = n[r];
      return t.containerState = M[1], L(
        M[0].continuation,
        "expected `continuation` to be defined on container construct"
      ), e.attempt(
        M[0].continuation,
        u,
        c
      )(w);
    }
    return c(w);
  }
  function u(w) {
    if (L(
      t.containerState,
      "expected `containerState` to be defined after continuation"
    ), r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && A();
      const M = t.events.length;
      let F = M, k;
      for (; F--; )
        if (t.events[F][0] === "exit" && t.events[F][1].type === x.chunkFlow) {
          k = t.events[F][1].end;
          break;
        }
      L(k, "could not find previous flow chunk"), _(r);
      let B = M;
      for (; B < t.events.length; )
        t.events[B][1].end = { ...k }, B++;
      return Xt(
        t.events,
        F + 1,
        0,
        t.events.slice(M)
      ), t.events.length = B, c(w);
    }
    return o(w);
  }
  function c(w) {
    if (r === n.length) {
      if (!i)
        return h(w);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return E(w);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      rm,
      l,
      d
    )(w);
  }
  function l(w) {
    return i && A(), _(r), h(w);
  }
  function d(w) {
    return t.parser.lazy[t.now().line] = r !== n.length, a = t.now().offset, E(w);
  }
  function h(w) {
    return t.containerState = {}, e.attempt(
      rm,
      m,
      E
    )(w);
  }
  function m(w) {
    return L(
      t.currentConstruct,
      "expected `currentConstruct` to be defined on tokenizer"
    ), L(
      t.containerState,
      "expected `containerState` to be defined on tokenizer"
    ), r++, n.push([t.currentConstruct, t.containerState]), h(w);
  }
  function E(w) {
    if (w === b.eof) {
      i && A(), _(0), e.consume(w);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter(x.chunkFlow, {
      _tokenizer: i,
      contentType: ue.contentTypeFlow,
      previous: s
    }), g(w);
  }
  function g(w) {
    if (w === b.eof) {
      T(e.exit(x.chunkFlow), !0), _(0), e.consume(w);
      return;
    }
    return me(w) ? (e.consume(w), T(e.exit(x.chunkFlow)), r = 0, t.interrupt = void 0, o) : (e.consume(w), g);
  }
  function T(w, M) {
    L(i, "expected `childFlow` to be defined when continuing");
    const F = t.sliceStream(w);
    if (M && F.push(null), w.previous = s, s && (s.next = w), s = w, i.defineSkip(w.start), i.write(F), t.parser.lazy[w.start.line]) {
      let k = i.events.length;
      for (; k--; )
        if (
          // The token starts before the line ending…
          i.events[k][1].start.offset < a && // …and either is not ended yet…
          (!i.events[k][1].end || // …or ends after it.
          i.events[k][1].end.offset > a)
        )
          return;
      const B = t.events.length;
      let $ = B, J, U;
      for (; $--; )
        if (t.events[$][0] === "exit" && t.events[$][1].type === x.chunkFlow) {
          if (J) {
            U = t.events[$][1].end;
            break;
          }
          J = !0;
        }
      for (L(U, "could not find previous flow chunk"), _(r), k = B; k < t.events.length; )
        t.events[k][1].end = { ...U }, k++;
      Xt(
        t.events,
        $ + 1,
        0,
        t.events.slice(B)
      ), t.events.length = k;
    }
  }
  function _(w) {
    let M = n.length;
    for (; M-- > w; ) {
      const F = n[M];
      t.containerState = F[1], L(
        F[0].exit,
        "expected `exit` to be defined on container construct"
      ), F[0].exit.call(t, e);
    }
    n.length = w;
  }
  function A() {
    L(
      t.containerState,
      "expected `containerState` to be defined when closing flow"
    ), L(i, "expected `childFlow` to be defined when closing it"), i.write([b.eof]), s = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function AP(e, t, n) {
  return L(
    this.parser.constructs.disable.null,
    "expected `disable.null` to be populated"
  ), Ge(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    x.linePrefix,
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : ue.tabSize
  );
}
function Si(e) {
  if (e === b.eof || rt(e) || Gr(e))
    return ue.characterGroupWhitespace;
  if (au(e))
    return ue.characterGroupPunctuation;
}
function ou(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const s = e[i].resolveAll;
    s && !r.includes(s) && (t = s(t, n), r.push(s));
  }
  return t;
}
const el = {
  name: "attention",
  resolveAll: yP,
  tokenize: NP
};
function yP(e, t) {
  let n = -1, r, i, s, a, o, u, c, l;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = { ...e[r][1].end }, h = { ...e[n][1].start };
          im(d, -u), im(h, u), a = {
            type: u > 1 ? x.strongSequence : x.emphasisSequence,
            start: d,
            end: { ...e[r][1].end }
          }, o = {
            type: u > 1 ? x.strongSequence : x.emphasisSequence,
            start: { ...e[n][1].start },
            end: h
          }, s = {
            type: u > 1 ? x.strongText : x.emphasisText,
            start: { ...e[r][1].end },
            end: { ...e[n][1].start }
          }, i = {
            type: u > 1 ? x.strong : x.emphasis,
            start: { ...a.start },
            end: { ...o.end }
          }, e[r][1].end = { ...a.start }, e[n][1].start = { ...o.end }, c = [], e[r][1].end.offset - e[r][1].start.offset && (c = rn(c, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), c = rn(c, [
            ["enter", i, t],
            ["enter", a, t],
            ["exit", a, t],
            ["enter", s, t]
          ]), L(
            t.parser.constructs.insideSpan.null,
            "expected `insideSpan` to be populated"
          ), c = rn(
            c,
            ou(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), c = rn(c, [
            ["exit", s, t],
            ["enter", o, t],
            ["exit", o, t],
            ["exit", i, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (l = 2, c = rn(c, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : l = 0, Xt(e, r - 1, n - r + 3, c), n = r + c.length - l - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function NP(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Si(r);
  let s;
  return a;
  function a(u) {
    return L(
      u === b.asterisk || u === b.underscore,
      "expected asterisk or underscore"
    ), s = u, e.enter("attentionSequence"), o(u);
  }
  function o(u) {
    if (u === s)
      return e.consume(u), o;
    const c = e.exit("attentionSequence"), l = Si(u);
    L(n, "expected `attentionMarkers` to be populated");
    const d = !l || l === ue.characterGroupPunctuation && i || n.includes(u), h = !i || i === ue.characterGroupPunctuation && l || n.includes(r);
    return c._open = !!(s === b.asterisk ? d : d && (i || !h)), c._close = !!(s === b.asterisk ? h : h && (l || !d)), t(u);
  }
}
function im(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const vP = { name: "autolink", tokenize: wP };
function wP(e, t, n) {
  let r = 0;
  return i;
  function i(m) {
    return L(m === b.lessThan, "expected `<`"), e.enter(x.autolink), e.enter(x.autolinkMarker), e.consume(m), e.exit(x.autolinkMarker), e.enter(x.autolinkProtocol), s;
  }
  function s(m) {
    return jt(m) ? (e.consume(m), a) : m === b.atSign ? n(m) : c(m);
  }
  function a(m) {
    return m === b.plusSign || m === b.dash || m === b.dot || Rt(m) ? (r = 1, o(m)) : c(m);
  }
  function o(m) {
    return m === b.colon ? (e.consume(m), r = 0, u) : (m === b.plusSign || m === b.dash || m === b.dot || Rt(m)) && r++ < ue.autolinkSchemeSizeMax ? (e.consume(m), o) : (r = 0, c(m));
  }
  function u(m) {
    return m === b.greaterThan ? (e.exit(x.autolinkProtocol), e.enter(x.autolinkMarker), e.consume(m), e.exit(x.autolinkMarker), e.exit(x.autolink), t) : m === b.eof || m === b.space || m === b.lessThan || go(m) ? n(m) : (e.consume(m), u);
  }
  function c(m) {
    return m === b.atSign ? (e.consume(m), l) : pP(m) ? (e.consume(m), c) : n(m);
  }
  function l(m) {
    return Rt(m) ? d(m) : n(m);
  }
  function d(m) {
    return m === b.dot ? (e.consume(m), r = 0, l) : m === b.greaterThan ? (e.exit(x.autolinkProtocol).type = x.autolinkEmail, e.enter(x.autolinkMarker), e.consume(m), e.exit(x.autolinkMarker), e.exit(x.autolink), t) : h(m);
  }
  function h(m) {
    if ((m === b.dash || Rt(m)) && r++ < ue.autolinkDomainSizeMax) {
      const E = m === b.dash ? h : d;
      return e.consume(m), E;
    }
    return n(m);
  }
}
const Zs = { partial: !0, tokenize: CP };
function CP(e, t, n) {
  return r;
  function r(s) {
    return ze(s) ? Ge(e, i, x.linePrefix)(s) : i(s);
  }
  function i(s) {
    return s === b.eof || me(s) ? t(s) : n(s);
  }
}
const s_ = {
  continuation: { tokenize: kP },
  exit: IP,
  name: "blockQuote",
  tokenize: SP
};
function SP(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    if (a === b.greaterThan) {
      const o = r.containerState;
      return L(o, "expected `containerState` to be defined in container"), o.open || (e.enter(x.blockQuote, { _container: !0 }), o.open = !0), e.enter(x.blockQuotePrefix), e.enter(x.blockQuoteMarker), e.consume(a), e.exit(x.blockQuoteMarker), s;
    }
    return n(a);
  }
  function s(a) {
    return ze(a) ? (e.enter(x.blockQuotePrefixWhitespace), e.consume(a), e.exit(x.blockQuotePrefixWhitespace), e.exit(x.blockQuotePrefix), t) : (e.exit(x.blockQuotePrefix), t(a));
  }
}
function kP(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return ze(a) ? (L(
      r.parser.constructs.disable.null,
      "expected `disable.null` to be populated"
    ), Ge(
      e,
      s,
      x.linePrefix,
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : ue.tabSize
    )(a)) : s(a);
  }
  function s(a) {
    return e.attempt(s_, t, n)(a);
  }
}
function IP(e) {
  e.exit(x.blockQuote);
}
const a_ = {
  name: "characterEscape",
  tokenize: DP
};
function DP(e, t, n) {
  return r;
  function r(s) {
    return L(s === b.backslash, "expected `\\`"), e.enter(x.characterEscape), e.enter(x.escapeMarker), e.consume(s), e.exit(x.escapeMarker), i;
  }
  function i(s) {
    return bP(s) ? (e.enter(x.characterEscapeValue), e.consume(s), e.exit(x.characterEscapeValue), e.exit(x.characterEscape), t) : n(s);
  }
}
const o_ = {
  name: "characterReference",
  tokenize: RP
};
function RP(e, t, n) {
  const r = this;
  let i = 0, s, a;
  return o;
  function o(d) {
    return L(d === b.ampersand, "expected `&`"), e.enter(x.characterReference), e.enter(x.characterReferenceMarker), e.consume(d), e.exit(x.characterReferenceMarker), u;
  }
  function u(d) {
    return d === b.numberSign ? (e.enter(x.characterReferenceMarkerNumeric), e.consume(d), e.exit(x.characterReferenceMarkerNumeric), c) : (e.enter(x.characterReferenceValue), s = ue.characterReferenceNamedSizeMax, a = Rt, l(d));
  }
  function c(d) {
    return d === b.uppercaseX || d === b.lowercaseX ? (e.enter(x.characterReferenceMarkerHexadecimal), e.consume(d), e.exit(x.characterReferenceMarkerHexadecimal), e.enter(x.characterReferenceValue), s = ue.characterReferenceHexadecimalSizeMax, a = gP, l) : (e.enter(x.characterReferenceValue), s = ue.characterReferenceDecimalSizeMax, a = Zc, l(d));
  }
  function l(d) {
    if (d === b.semicolon && i) {
      const h = e.exit(x.characterReferenceValue);
      return a === Rt && !Td(r.sliceSerialize(h)) ? n(d) : (e.enter(x.characterReferenceMarker), e.consume(d), e.exit(x.characterReferenceMarker), e.exit(x.characterReference), t);
    }
    return a(d) && i++ < s ? (e.consume(d), l) : n(d);
  }
}
const sm = {
  partial: !0,
  tokenize: OP
}, am = {
  concrete: !0,
  name: "codeFenced",
  tokenize: PP
};
function PP(e, t, n) {
  const r = this, i = { partial: !0, tokenize: F };
  let s = 0, a = 0, o;
  return u;
  function u(k) {
    return c(k);
  }
  function c(k) {
    L(
      k === b.graveAccent || k === b.tilde,
      "expected `` ` `` or `~`"
    );
    const B = r.events[r.events.length - 1];
    return s = B && B[1].type === x.linePrefix ? B[2].sliceSerialize(B[1], !0).length : 0, o = k, e.enter(x.codeFenced), e.enter(x.codeFencedFence), e.enter(x.codeFencedFenceSequence), l(k);
  }
  function l(k) {
    return k === o ? (a++, e.consume(k), l) : a < ue.codeFencedSequenceSizeMin ? n(k) : (e.exit(x.codeFencedFenceSequence), ze(k) ? Ge(e, d, x.whitespace)(k) : d(k));
  }
  function d(k) {
    return k === b.eof || me(k) ? (e.exit(x.codeFencedFence), r.interrupt ? t(k) : e.check(sm, g, M)(k)) : (e.enter(x.codeFencedFenceInfo), e.enter(x.chunkString, { contentType: ue.contentTypeString }), h(k));
  }
  function h(k) {
    return k === b.eof || me(k) ? (e.exit(x.chunkString), e.exit(x.codeFencedFenceInfo), d(k)) : ze(k) ? (e.exit(x.chunkString), e.exit(x.codeFencedFenceInfo), Ge(e, m, x.whitespace)(k)) : k === b.graveAccent && k === o ? n(k) : (e.consume(k), h);
  }
  function m(k) {
    return k === b.eof || me(k) ? d(k) : (e.enter(x.codeFencedFenceMeta), e.enter(x.chunkString, { contentType: ue.contentTypeString }), E(k));
  }
  function E(k) {
    return k === b.eof || me(k) ? (e.exit(x.chunkString), e.exit(x.codeFencedFenceMeta), d(k)) : k === b.graveAccent && k === o ? n(k) : (e.consume(k), E);
  }
  function g(k) {
    return L(me(k), "expected eol"), e.attempt(i, M, T)(k);
  }
  function T(k) {
    return L(me(k), "expected eol"), e.enter(x.lineEnding), e.consume(k), e.exit(x.lineEnding), _;
  }
  function _(k) {
    return s > 0 && ze(k) ? Ge(
      e,
      A,
      x.linePrefix,
      s + 1
    )(k) : A(k);
  }
  function A(k) {
    return k === b.eof || me(k) ? e.check(sm, g, M)(k) : (e.enter(x.codeFlowValue), w(k));
  }
  function w(k) {
    return k === b.eof || me(k) ? (e.exit(x.codeFlowValue), A(k)) : (e.consume(k), w);
  }
  function M(k) {
    return e.exit(x.codeFenced), t(k);
  }
  function F(k, B, $) {
    let J = 0;
    return U;
    function U(z) {
      return L(me(z), "expected eol"), k.enter(x.lineEnding), k.consume(z), k.exit(x.lineEnding), re;
    }
    function re(z) {
      return L(
        r.parser.constructs.disable.null,
        "expected `disable.null` to be populated"
      ), k.enter(x.codeFencedFence), ze(z) ? Ge(
        k,
        ae,
        x.linePrefix,
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : ue.tabSize
      )(z) : ae(z);
    }
    function ae(z) {
      return z === o ? (k.enter(x.codeFencedFenceSequence), j(z)) : $(z);
    }
    function j(z) {
      return z === o ? (J++, k.consume(z), j) : J >= a ? (k.exit(x.codeFencedFenceSequence), ze(z) ? Ge(k, H, x.whitespace)(z) : H(z)) : $(z);
    }
    function H(z) {
      return z === b.eof || me(z) ? (k.exit(x.codeFencedFence), B(z)) : $(z);
    }
  }
}
function OP(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return a === b.eof ? n(a) : (L(me(a), "expected eol"), e.enter(x.lineEnding), e.consume(a), e.exit(x.lineEnding), s);
  }
  function s(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
const Ju = {
  name: "codeIndented",
  tokenize: MP
}, LP = { partial: !0, tokenize: UP };
function MP(e, t, n) {
  const r = this;
  return i;
  function i(c) {
    return L(ze(c)), e.enter(x.codeIndented), Ge(
      e,
      s,
      x.linePrefix,
      ue.tabSize + 1
    )(c);
  }
  function s(c) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === x.linePrefix && l[2].sliceSerialize(l[1], !0).length >= ue.tabSize ? a(c) : n(c);
  }
  function a(c) {
    return c === b.eof ? u(c) : me(c) ? e.attempt(LP, a, u)(c) : (e.enter(x.codeFlowValue), o(c));
  }
  function o(c) {
    return c === b.eof || me(c) ? (e.exit(x.codeFlowValue), a(c)) : (e.consume(c), o);
  }
  function u(c) {
    return e.exit(x.codeIndented), t(c);
  }
}
function UP(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : me(a) ? (e.enter(x.lineEnding), e.consume(a), e.exit(x.lineEnding), i) : Ge(
      e,
      s,
      x.linePrefix,
      ue.tabSize + 1
    )(a);
  }
  function s(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === x.linePrefix && o[2].sliceSerialize(o[1], !0).length >= ue.tabSize ? t(a) : me(a) ? i(a) : n(a);
  }
}
const HP = {
  name: "codeText",
  previous: u_,
  resolve: jP,
  tokenize: BP
};
function jP(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === x.lineEnding || e[n][1].type === "space") && (e[t][1].type === x.lineEnding || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === x.codeTextData) {
        e[n][1].type = x.codeTextPadding, e[t][1].type = x.codeTextPadding, n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== x.lineEnding && (i = r) : (r === t || e[r][1].type === x.lineEnding) && (e[i][1].type = x.codeTextData, r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function u_(e) {
  return e !== b.graveAccent || this.events[this.events.length - 1][1].type === x.characterEscape;
}
function BP(e, t, n) {
  const r = this;
  let i = 0, s, a;
  return o;
  function o(h) {
    return L(h === b.graveAccent, "expected `` ` ``"), L(u_.call(r, r.previous), "expected correct previous"), e.enter(x.codeText), e.enter(x.codeTextSequence), u(h);
  }
  function u(h) {
    return h === b.graveAccent ? (e.consume(h), i++, u) : (e.exit(x.codeTextSequence), c(h));
  }
  function c(h) {
    return h === b.eof ? n(h) : h === b.space ? (e.enter("space"), e.consume(h), e.exit("space"), c) : h === b.graveAccent ? (a = e.enter(x.codeTextSequence), s = 0, d(h)) : me(h) ? (e.enter(x.lineEnding), e.consume(h), e.exit(x.lineEnding), c) : (e.enter(x.codeTextData), l(h));
  }
  function l(h) {
    return h === b.eof || h === b.space || h === b.graveAccent || me(h) ? (e.exit(x.codeTextData), c(h)) : (e.consume(h), l);
  }
  function d(h) {
    return h === b.graveAccent ? (e.consume(h), s++, d) : s === i ? (e.exit(x.codeTextSequence), e.exit(x.codeText), t(h)) : (a.type = x.codeTextData, l(h));
  }
}
class FP {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError(
        "Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`"
      );
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(
      this.right.length - r + this.left.length,
      this.right.length - t + this.left.length
    ).reverse() : this.left.slice(t).concat(
      this.right.slice(this.right.length - r + this.left.length).reverse()
    );
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const s = this.right.splice(
      this.right.length - i,
      Number.POSITIVE_INFINITY
    );
    return r && as(this.left, r), s.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), as(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), as(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        as(this.right, n.reverse());
      } else {
        const n = this.right.splice(
          this.left.length + this.right.length - t,
          Number.POSITIVE_INFINITY
        );
        as(this.left, n.reverse());
      }
  }
}
function as(e, t) {
  let n = 0;
  if (t.length < ue.v8MaxSafeChunkSize)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(
        ...t.slice(n, n + ue.v8MaxSafeChunkSize)
      ), n += ue.v8MaxSafeChunkSize;
}
function c_(e) {
  const t = {};
  let n = -1, r, i, s, a, o, u, c;
  const l = new FP(e);
  for (; ++n < l.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = l.get(n), n && r[1].type === x.chunkFlow && l.get(n - 1)[1].type === x.listItemPrefix && (L(r[1]._tokenizer, "expected `_tokenizer` on subtokens"), u = r[1]._tokenizer.events, s = 0, s < u.length && u[s][1].type === x.lineEndingBlank && (s += 2), s < u.length && u[s][1].type === x.content))
      for (; ++s < u.length && u[s][1].type !== x.content; )
        u[s][1].type === x.chunkText && (u[s][1]._isInFirstContentOfListItem = !0, s++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, zP(l, n)), n = t[n], c = !0);
    else if (r[1]._container) {
      for (s = n, i = void 0; s--; )
        if (a = l.get(s), a[1].type === x.lineEnding || a[1].type === x.lineEndingBlank)
          a[0] === "enter" && (i && (l.get(i)[1].type = x.lineEndingBlank), a[1].type = x.lineEnding, i = s);
        else if (!(a[1].type === x.linePrefix || a[1].type === x.listItemIndent)) break;
      i && (r[1].end = { ...l.get(i)[1].start }, o = l.slice(i, n), o.unshift(r), l.splice(i, n - i + 1, o));
    }
  }
  return Xt(e, 0, Number.POSITIVE_INFINITY, l.slice(0)), !c;
}
function zP(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const s = [];
  L(n.contentType, "expected `contentType` on subtokens");
  let a = n._tokenizer;
  a || (a = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (a._contentTypeTextTrailing = !0));
  const o = a.events, u = [], c = {};
  let l, d, h = -1, m = n, E = 0, g = 0;
  const T = [g];
  for (; m; ) {
    for (; e.get(++i)[1] !== m; )
      ;
    L(
      !d || m.previous === d,
      "expected previous to match"
    ), L(!d || d.next === m, "expected next to match"), s.push(i), m._tokenizer || (l = r.sliceStream(m), m.next || l.push(b.eof), d && a.defineSkip(m.start), m._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(l), m._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), d = m, m = m.next;
  }
  for (m = n; ++h < o.length; )
    // Find a void token that includes a break.
    o[h][0] === "exit" && o[h - 1][0] === "enter" && o[h][1].type === o[h - 1][1].type && o[h][1].start.line !== o[h][1].end.line && (L(m, "expected a current token"), g = h + 1, T.push(g), m._tokenizer = void 0, m.previous = void 0, m = m.next);
  for (a.events = [], m ? (m._tokenizer = void 0, m.previous = void 0, L(!m.next, "expected no next token")) : T.pop(), h = T.length; h--; ) {
    const _ = o.slice(T[h], T[h + 1]), A = s.pop();
    L(A !== void 0, "expected a start position when splicing"), u.push([A, A + _.length - 1]), e.splice(A, 2, _);
  }
  for (u.reverse(), h = -1; ++h < u.length; )
    c[E + u[h][0]] = E + u[h][1], E += u[h][1] - u[h][0] - 1;
  return c;
}
const VP = { resolve: $P, tokenize: YP }, WP = { partial: !0, tokenize: GP };
function $P(e) {
  return c_(e), e;
}
function YP(e, t) {
  let n;
  return r;
  function r(o) {
    return L(
      o !== b.eof && !me(o),
      "expected no eof or eol"
    ), e.enter(x.content), n = e.enter(x.chunkContent, {
      contentType: ue.contentTypeContent
    }), i(o);
  }
  function i(o) {
    return o === b.eof ? s(o) : me(o) ? e.check(
      WP,
      a,
      s
    )(o) : (e.consume(o), i);
  }
  function s(o) {
    return e.exit(x.chunkContent), e.exit(x.content), t(o);
  }
  function a(o) {
    return L(me(o), "expected eol"), e.consume(o), e.exit(x.chunkContent), L(n, "expected previous token"), n.next = e.enter(x.chunkContent, {
      contentType: ue.contentTypeContent,
      previous: n
    }), n = n.next, i;
  }
}
function GP(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return L(me(a), "expected a line ending"), e.exit(x.chunkContent), e.enter(x.lineEnding), e.consume(a), e.exit(x.lineEnding), Ge(e, s, x.linePrefix);
  }
  function s(a) {
    if (a === b.eof || me(a))
      return n(a);
    L(
      r.parser.constructs.disable.null,
      "expected `disable.null` to be populated"
    );
    const o = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && o && o[1].type === x.linePrefix && o[2].sliceSerialize(o[1], !0).length >= ue.tabSize ? t(a) : e.interrupt(r.parser.constructs.flow, n, t)(a);
  }
}
function l_(e, t, n, r, i, s, a, o, u) {
  const c = u || Number.POSITIVE_INFINITY;
  let l = 0;
  return d;
  function d(_) {
    return _ === b.lessThan ? (e.enter(r), e.enter(i), e.enter(s), e.consume(_), e.exit(s), h) : _ === b.eof || _ === b.space || _ === b.rightParenthesis || go(_) ? n(_) : (e.enter(r), e.enter(a), e.enter(o), e.enter(x.chunkString, { contentType: ue.contentTypeString }), g(_));
  }
  function h(_) {
    return _ === b.greaterThan ? (e.enter(s), e.consume(_), e.exit(s), e.exit(i), e.exit(r), t) : (e.enter(o), e.enter(x.chunkString, { contentType: ue.contentTypeString }), m(_));
  }
  function m(_) {
    return _ === b.greaterThan ? (e.exit(x.chunkString), e.exit(o), h(_)) : _ === b.eof || _ === b.lessThan || me(_) ? n(_) : (e.consume(_), _ === b.backslash ? E : m);
  }
  function E(_) {
    return _ === b.lessThan || _ === b.greaterThan || _ === b.backslash ? (e.consume(_), m) : m(_);
  }
  function g(_) {
    return !l && (_ === b.eof || _ === b.rightParenthesis || rt(_)) ? (e.exit(x.chunkString), e.exit(o), e.exit(a), e.exit(r), t(_)) : l < c && _ === b.leftParenthesis ? (e.consume(_), l++, g) : _ === b.rightParenthesis ? (e.consume(_), l--, g) : _ === b.eof || _ === b.space || _ === b.leftParenthesis || go(_) ? n(_) : (e.consume(_), _ === b.backslash ? T : g);
  }
  function T(_) {
    return _ === b.leftParenthesis || _ === b.rightParenthesis || _ === b.backslash ? (e.consume(_), g) : g(_);
  }
}
function d_(e, t, n, r, i, s) {
  const a = this;
  let o = 0, u;
  return c;
  function c(m) {
    return L(m === b.leftSquareBracket, "expected `[`"), e.enter(r), e.enter(i), e.consume(m), e.exit(i), e.enter(s), l;
  }
  function l(m) {
    return o > ue.linkReferenceSizeMax || m === b.eof || m === b.leftSquareBracket || m === b.rightSquareBracket && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    m === b.caret && !o && "_hiddenFootnoteSupport" in a.parser.constructs ? n(m) : m === b.rightSquareBracket ? (e.exit(s), e.enter(i), e.consume(m), e.exit(i), e.exit(r), t) : me(m) ? (e.enter(x.lineEnding), e.consume(m), e.exit(x.lineEnding), l) : (e.enter(x.chunkString, { contentType: ue.contentTypeString }), d(m));
  }
  function d(m) {
    return m === b.eof || m === b.leftSquareBracket || m === b.rightSquareBracket || me(m) || o++ > ue.linkReferenceSizeMax ? (e.exit(x.chunkString), l(m)) : (e.consume(m), u || (u = !ze(m)), m === b.backslash ? h : d);
  }
  function h(m) {
    return m === b.leftSquareBracket || m === b.backslash || m === b.rightSquareBracket ? (e.consume(m), o++, d) : d(m);
  }
}
function f_(e, t, n, r, i, s) {
  let a;
  return o;
  function o(h) {
    return h === b.quotationMark || h === b.apostrophe || h === b.leftParenthesis ? (e.enter(r), e.enter(i), e.consume(h), e.exit(i), a = h === b.leftParenthesis ? b.rightParenthesis : h, u) : n(h);
  }
  function u(h) {
    return h === a ? (e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : (e.enter(s), c(h));
  }
  function c(h) {
    return h === a ? (e.exit(s), u(a)) : h === b.eof ? n(h) : me(h) ? (e.enter(x.lineEnding), e.consume(h), e.exit(x.lineEnding), Ge(e, c, x.linePrefix)) : (e.enter(x.chunkString, { contentType: ue.contentTypeString }), l(h));
  }
  function l(h) {
    return h === a || h === b.eof || me(h) ? (e.exit(x.chunkString), c(h)) : (e.consume(h), h === b.backslash ? d : l);
  }
  function d(h) {
    return h === a || h === b.backslash ? (e.consume(h), l) : l(h);
  }
}
function xs(e, t) {
  let n;
  return r;
  function r(i) {
    return me(i) ? (e.enter(x.lineEnding), e.consume(i), e.exit(x.lineEnding), n = !0, r) : ze(i) ? Ge(
      e,
      r,
      n ? x.linePrefix : x.lineSuffix
    )(i) : t(i);
  }
}
const qP = { name: "definition", tokenize: QP }, KP = { partial: !0, tokenize: XP };
function QP(e, t, n) {
  const r = this;
  let i;
  return s;
  function s(m) {
    return e.enter(x.definition), a(m);
  }
  function a(m) {
    return L(m === b.leftSquareBracket, "expected `[`"), d_.call(
      r,
      e,
      o,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      x.definitionLabel,
      x.definitionLabelMarker,
      x.definitionLabelString
    )(m);
  }
  function o(m) {
    return i = hn(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), m === b.colon ? (e.enter(x.definitionMarker), e.consume(m), e.exit(x.definitionMarker), u) : n(m);
  }
  function u(m) {
    return rt(m) ? xs(e, c)(m) : c(m);
  }
  function c(m) {
    return l_(
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      x.definitionDestination,
      x.definitionDestinationLiteral,
      x.definitionDestinationLiteralMarker,
      x.definitionDestinationRaw,
      x.definitionDestinationString
    )(m);
  }
  function l(m) {
    return e.attempt(KP, d, d)(m);
  }
  function d(m) {
    return ze(m) ? Ge(e, h, x.whitespace)(m) : h(m);
  }
  function h(m) {
    return m === b.eof || me(m) ? (e.exit(x.definition), r.parser.defined.push(i), t(m)) : n(m);
  }
}
function XP(e, t, n) {
  return r;
  function r(o) {
    return rt(o) ? xs(e, i)(o) : n(o);
  }
  function i(o) {
    return f_(
      e,
      s,
      n,
      x.definitionTitle,
      x.definitionTitleMarker,
      x.definitionTitleString
    )(o);
  }
  function s(o) {
    return ze(o) ? Ge(
      e,
      a,
      x.whitespace
    )(o) : a(o);
  }
  function a(o) {
    return o === b.eof || me(o) ? t(o) : n(o);
  }
}
const JP = {
  name: "hardBreakEscape",
  tokenize: ZP
};
function ZP(e, t, n) {
  return r;
  function r(s) {
    return L(s === b.backslash, "expected `\\`"), e.enter(x.hardBreakEscape), e.consume(s), i;
  }
  function i(s) {
    return me(s) ? (e.exit(x.hardBreakEscape), t(s)) : n(s);
  }
}
const eO = {
  name: "headingAtx",
  resolve: tO,
  tokenize: nO
};
function tO(e, t) {
  let n = e.length - 2, r = 3, i, s;
  return e[r][1].type === x.whitespace && (r += 2), n - 2 > r && e[n][1].type === x.whitespace && (n -= 2), e[n][1].type === x.atxHeadingSequence && (r === n - 1 || n - 4 > r && e[n - 2][1].type === x.whitespace) && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: x.atxHeadingText,
    start: e[r][1].start,
    end: e[n][1].end
  }, s = {
    type: x.chunkText,
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: ue.contentTypeText
  }, Xt(e, r, n - r + 1, [
    ["enter", i, t],
    ["enter", s, t],
    ["exit", s, t],
    ["exit", i, t]
  ])), e;
}
function nO(e, t, n) {
  let r = 0;
  return i;
  function i(l) {
    return e.enter(x.atxHeading), s(l);
  }
  function s(l) {
    return L(l === b.numberSign, "expected `#`"), e.enter(x.atxHeadingSequence), a(l);
  }
  function a(l) {
    return l === b.numberSign && r++ < ue.atxHeadingOpeningFenceSizeMax ? (e.consume(l), a) : l === b.eof || rt(l) ? (e.exit(x.atxHeadingSequence), o(l)) : n(l);
  }
  function o(l) {
    return l === b.numberSign ? (e.enter(x.atxHeadingSequence), u(l)) : l === b.eof || me(l) ? (e.exit(x.atxHeading), t(l)) : ze(l) ? Ge(e, o, x.whitespace)(l) : (e.enter(x.atxHeadingText), c(l));
  }
  function u(l) {
    return l === b.numberSign ? (e.consume(l), u) : (e.exit(x.atxHeadingSequence), o(l));
  }
  function c(l) {
    return l === b.eof || l === b.numberSign || rt(l) ? (e.exit(x.atxHeadingText), o(l)) : (e.consume(l), c);
  }
}
const rO = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], om = ["pre", "script", "style", "textarea"], iO = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: oO,
  tokenize: uO
}, sO = { partial: !0, tokenize: lO }, aO = {
  partial: !0,
  tokenize: cO
};
function oO(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === x.htmlFlow); )
    ;
  return t > 1 && e[t - 2][1].type === x.linePrefix && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function uO(e, t, n) {
  const r = this;
  let i, s, a, o, u;
  return c;
  function c(D) {
    return l(D);
  }
  function l(D) {
    return L(D === b.lessThan, "expected `<`"), e.enter(x.htmlFlow), e.enter(x.htmlFlowData), e.consume(D), d;
  }
  function d(D) {
    return D === b.exclamationMark ? (e.consume(D), h) : D === b.slash ? (e.consume(D), s = !0, g) : D === b.questionMark ? (e.consume(D), i = ue.htmlInstruction, r.interrupt ? t : N) : jt(D) ? (L(D !== null), e.consume(D), a = String.fromCharCode(D), T) : n(D);
  }
  function h(D) {
    return D === b.dash ? (e.consume(D), i = ue.htmlComment, m) : D === b.leftSquareBracket ? (e.consume(D), i = ue.htmlCdata, o = 0, E) : jt(D) ? (e.consume(D), i = ue.htmlDeclaration, r.interrupt ? t : N) : n(D);
  }
  function m(D) {
    return D === b.dash ? (e.consume(D), r.interrupt ? t : N) : n(D);
  }
  function E(D) {
    const Ie = ue.cdataOpeningString;
    return D === Ie.charCodeAt(o++) ? (e.consume(D), o === Ie.length ? r.interrupt ? t : ae : E) : n(D);
  }
  function g(D) {
    return jt(D) ? (L(D !== null), e.consume(D), a = String.fromCharCode(D), T) : n(D);
  }
  function T(D) {
    if (D === b.eof || D === b.slash || D === b.greaterThan || rt(D)) {
      const Ie = D === b.slash, De = a.toLowerCase();
      return !Ie && !s && om.includes(De) ? (i = ue.htmlRaw, r.interrupt ? t(D) : ae(D)) : rO.includes(a.toLowerCase()) ? (i = ue.htmlBasic, Ie ? (e.consume(D), _) : r.interrupt ? t(D) : ae(D)) : (i = ue.htmlComplete, r.interrupt && !r.parser.lazy[r.now().line] ? n(D) : s ? A(D) : w(D));
    }
    return D === b.dash || Rt(D) ? (e.consume(D), a += String.fromCharCode(D), T) : n(D);
  }
  function _(D) {
    return D === b.greaterThan ? (e.consume(D), r.interrupt ? t : ae) : n(D);
  }
  function A(D) {
    return ze(D) ? (e.consume(D), A) : U(D);
  }
  function w(D) {
    return D === b.slash ? (e.consume(D), U) : D === b.colon || D === b.underscore || jt(D) ? (e.consume(D), M) : ze(D) ? (e.consume(D), w) : U(D);
  }
  function M(D) {
    return D === b.dash || D === b.dot || D === b.colon || D === b.underscore || Rt(D) ? (e.consume(D), M) : F(D);
  }
  function F(D) {
    return D === b.equalsTo ? (e.consume(D), k) : ze(D) ? (e.consume(D), F) : w(D);
  }
  function k(D) {
    return D === b.eof || D === b.lessThan || D === b.equalsTo || D === b.greaterThan || D === b.graveAccent ? n(D) : D === b.quotationMark || D === b.apostrophe ? (e.consume(D), u = D, B) : ze(D) ? (e.consume(D), k) : $(D);
  }
  function B(D) {
    return D === u ? (e.consume(D), u = null, J) : D === b.eof || me(D) ? n(D) : (e.consume(D), B);
  }
  function $(D) {
    return D === b.eof || D === b.quotationMark || D === b.apostrophe || D === b.slash || D === b.lessThan || D === b.equalsTo || D === b.greaterThan || D === b.graveAccent || rt(D) ? F(D) : (e.consume(D), $);
  }
  function J(D) {
    return D === b.slash || D === b.greaterThan || ze(D) ? w(D) : n(D);
  }
  function U(D) {
    return D === b.greaterThan ? (e.consume(D), re) : n(D);
  }
  function re(D) {
    return D === b.eof || me(D) ? ae(D) : ze(D) ? (e.consume(D), re) : n(D);
  }
  function ae(D) {
    return D === b.dash && i === ue.htmlComment ? (e.consume(D), W) : D === b.lessThan && i === ue.htmlRaw ? (e.consume(D), X) : D === b.greaterThan && i === ue.htmlDeclaration ? (e.consume(D), ye) : D === b.questionMark && i === ue.htmlInstruction ? (e.consume(D), N) : D === b.rightSquareBracket && i === ue.htmlCdata ? (e.consume(D), se) : me(D) && (i === ue.htmlBasic || i === ue.htmlComplete) ? (e.exit(x.htmlFlowData), e.check(
      sO,
      Re,
      j
    )(D)) : D === b.eof || me(D) ? (e.exit(x.htmlFlowData), j(D)) : (e.consume(D), ae);
  }
  function j(D) {
    return e.check(
      aO,
      H,
      Re
    )(D);
  }
  function H(D) {
    return L(me(D)), e.enter(x.lineEnding), e.consume(D), e.exit(x.lineEnding), z;
  }
  function z(D) {
    return D === b.eof || me(D) ? j(D) : (e.enter(x.htmlFlowData), ae(D));
  }
  function W(D) {
    return D === b.dash ? (e.consume(D), N) : ae(D);
  }
  function X(D) {
    return D === b.slash ? (e.consume(D), a = "", G) : ae(D);
  }
  function G(D) {
    if (D === b.greaterThan) {
      const Ie = a.toLowerCase();
      return om.includes(Ie) ? (e.consume(D), ye) : ae(D);
    }
    return jt(D) && a.length < ue.htmlRawSizeMax ? (L(D !== null), e.consume(D), a += String.fromCharCode(D), G) : ae(D);
  }
  function se(D) {
    return D === b.rightSquareBracket ? (e.consume(D), N) : ae(D);
  }
  function N(D) {
    return D === b.greaterThan ? (e.consume(D), ye) : D === b.dash && i === ue.htmlComment ? (e.consume(D), N) : ae(D);
  }
  function ye(D) {
    return D === b.eof || me(D) ? (e.exit(x.htmlFlowData), Re(D)) : (e.consume(D), ye);
  }
  function Re(D) {
    return e.exit(x.htmlFlow), t(D);
  }
}
function cO(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return me(a) ? (e.enter(x.lineEnding), e.consume(a), e.exit(x.lineEnding), s) : n(a);
  }
  function s(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function lO(e, t, n) {
  return r;
  function r(i) {
    return L(me(i), "expected a line ending"), e.enter(x.lineEnding), e.consume(i), e.exit(x.lineEnding), e.attempt(Zs, t, n);
  }
}
const dO = { name: "htmlText", tokenize: fO };
function fO(e, t, n) {
  const r = this;
  let i, s, a;
  return o;
  function o(N) {
    return L(N === b.lessThan, "expected `<`"), e.enter(x.htmlText), e.enter(x.htmlTextData), e.consume(N), u;
  }
  function u(N) {
    return N === b.exclamationMark ? (e.consume(N), c) : N === b.slash ? (e.consume(N), F) : N === b.questionMark ? (e.consume(N), w) : jt(N) ? (e.consume(N), $) : n(N);
  }
  function c(N) {
    return N === b.dash ? (e.consume(N), l) : N === b.leftSquareBracket ? (e.consume(N), s = 0, E) : jt(N) ? (e.consume(N), A) : n(N);
  }
  function l(N) {
    return N === b.dash ? (e.consume(N), m) : n(N);
  }
  function d(N) {
    return N === b.eof ? n(N) : N === b.dash ? (e.consume(N), h) : me(N) ? (a = d, X(N)) : (e.consume(N), d);
  }
  function h(N) {
    return N === b.dash ? (e.consume(N), m) : d(N);
  }
  function m(N) {
    return N === b.greaterThan ? W(N) : N === b.dash ? h(N) : d(N);
  }
  function E(N) {
    const ye = ue.cdataOpeningString;
    return N === ye.charCodeAt(s++) ? (e.consume(N), s === ye.length ? g : E) : n(N);
  }
  function g(N) {
    return N === b.eof ? n(N) : N === b.rightSquareBracket ? (e.consume(N), T) : me(N) ? (a = g, X(N)) : (e.consume(N), g);
  }
  function T(N) {
    return N === b.rightSquareBracket ? (e.consume(N), _) : g(N);
  }
  function _(N) {
    return N === b.greaterThan ? W(N) : N === b.rightSquareBracket ? (e.consume(N), _) : g(N);
  }
  function A(N) {
    return N === b.eof || N === b.greaterThan ? W(N) : me(N) ? (a = A, X(N)) : (e.consume(N), A);
  }
  function w(N) {
    return N === b.eof ? n(N) : N === b.questionMark ? (e.consume(N), M) : me(N) ? (a = w, X(N)) : (e.consume(N), w);
  }
  function M(N) {
    return N === b.greaterThan ? W(N) : w(N);
  }
  function F(N) {
    return jt(N) ? (e.consume(N), k) : n(N);
  }
  function k(N) {
    return N === b.dash || Rt(N) ? (e.consume(N), k) : B(N);
  }
  function B(N) {
    return me(N) ? (a = B, X(N)) : ze(N) ? (e.consume(N), B) : W(N);
  }
  function $(N) {
    return N === b.dash || Rt(N) ? (e.consume(N), $) : N === b.slash || N === b.greaterThan || rt(N) ? J(N) : n(N);
  }
  function J(N) {
    return N === b.slash ? (e.consume(N), W) : N === b.colon || N === b.underscore || jt(N) ? (e.consume(N), U) : me(N) ? (a = J, X(N)) : ze(N) ? (e.consume(N), J) : W(N);
  }
  function U(N) {
    return N === b.dash || N === b.dot || N === b.colon || N === b.underscore || Rt(N) ? (e.consume(N), U) : re(N);
  }
  function re(N) {
    return N === b.equalsTo ? (e.consume(N), ae) : me(N) ? (a = re, X(N)) : ze(N) ? (e.consume(N), re) : J(N);
  }
  function ae(N) {
    return N === b.eof || N === b.lessThan || N === b.equalsTo || N === b.greaterThan || N === b.graveAccent ? n(N) : N === b.quotationMark || N === b.apostrophe ? (e.consume(N), i = N, j) : me(N) ? (a = ae, X(N)) : ze(N) ? (e.consume(N), ae) : (e.consume(N), H);
  }
  function j(N) {
    return N === i ? (e.consume(N), i = void 0, z) : N === b.eof ? n(N) : me(N) ? (a = j, X(N)) : (e.consume(N), j);
  }
  function H(N) {
    return N === b.eof || N === b.quotationMark || N === b.apostrophe || N === b.lessThan || N === b.equalsTo || N === b.graveAccent ? n(N) : N === b.slash || N === b.greaterThan || rt(N) ? J(N) : (e.consume(N), H);
  }
  function z(N) {
    return N === b.slash || N === b.greaterThan || rt(N) ? J(N) : n(N);
  }
  function W(N) {
    return N === b.greaterThan ? (e.consume(N), e.exit(x.htmlTextData), e.exit(x.htmlText), t) : n(N);
  }
  function X(N) {
    return L(a, "expected return state"), L(me(N), "expected eol"), e.exit(x.htmlTextData), e.enter(x.lineEnding), e.consume(N), e.exit(x.lineEnding), G;
  }
  function G(N) {
    return L(
      r.parser.constructs.disable.null,
      "expected `disable.null` to be populated"
    ), ze(N) ? Ge(
      e,
      se,
      x.linePrefix,
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : ue.tabSize
    )(N) : se(N);
  }
  function se(N) {
    return e.enter(x.htmlTextData), a(N);
  }
}
const Ad = {
  name: "labelEnd",
  resolveAll: gO,
  resolveTo: bO,
  tokenize: EO
}, hO = { tokenize: _O }, mO = { tokenize: xO }, pO = { tokenize: TO };
function gO(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === x.labelImage || r.type === x.labelLink || r.type === x.labelEnd) {
      const i = r.type === x.labelImage ? 4 : 2;
      r.type = x.data, t += i;
    }
  }
  return e.length !== n.length && Xt(e, 0, e.length, n), e;
}
function bO(e, t) {
  let n = e.length, r = 0, i, s, a, o;
  for (; n--; )
    if (i = e[n][1], s) {
      if (i.type === x.link || i.type === x.labelLink && i._inactive)
        break;
      e[n][0] === "enter" && i.type === x.labelLink && (i._inactive = !0);
    } else if (a) {
      if (e[n][0] === "enter" && (i.type === x.labelImage || i.type === x.labelLink) && !i._balanced && (s = n, i.type !== x.labelLink)) {
        r = 2;
        break;
      }
    } else i.type === x.labelEnd && (a = n);
  L(s !== void 0, "`open` is supposed to be found"), L(a !== void 0, "`close` is supposed to be found");
  const u = {
    type: e[s][1].type === x.labelLink ? x.link : x.image,
    start: { ...e[s][1].start },
    end: { ...e[e.length - 1][1].end }
  }, c = {
    type: x.label,
    start: { ...e[s][1].start },
    end: { ...e[a][1].end }
  }, l = {
    type: x.labelText,
    start: { ...e[s + r + 2][1].end },
    end: { ...e[a - 2][1].start }
  };
  return o = [
    ["enter", u, t],
    ["enter", c, t]
  ], o = rn(o, e.slice(s + 1, s + r + 3)), o = rn(o, [["enter", l, t]]), L(
    t.parser.constructs.insideSpan.null,
    "expected `insideSpan.null` to be populated"
  ), o = rn(
    o,
    ou(
      t.parser.constructs.insideSpan.null,
      e.slice(s + r + 4, a - 3),
      t
    )
  ), o = rn(o, [
    ["exit", l, t],
    e[a - 2],
    e[a - 1],
    ["exit", c, t]
  ]), o = rn(o, e.slice(a + 1)), o = rn(o, [["exit", u, t]]), Xt(e, s, e.length, o), e;
}
function EO(e, t, n) {
  const r = this;
  let i = r.events.length, s, a;
  for (; i--; )
    if ((r.events[i][1].type === x.labelImage || r.events[i][1].type === x.labelLink) && !r.events[i][1]._balanced) {
      s = r.events[i][1];
      break;
    }
  return o;
  function o(h) {
    return L(h === b.rightSquareBracket, "expected `]`"), s ? s._inactive ? d(h) : (a = r.parser.defined.includes(
      hn(
        r.sliceSerialize({ start: s.end, end: r.now() })
      )
    ), e.enter(x.labelEnd), e.enter(x.labelMarker), e.consume(h), e.exit(x.labelMarker), e.exit(x.labelEnd), u) : n(h);
  }
  function u(h) {
    return h === b.leftParenthesis ? e.attempt(
      hO,
      l,
      a ? l : d
    )(h) : h === b.leftSquareBracket ? e.attempt(
      mO,
      l,
      a ? c : d
    )(h) : a ? l(h) : d(h);
  }
  function c(h) {
    return e.attempt(
      pO,
      l,
      d
    )(h);
  }
  function l(h) {
    return t(h);
  }
  function d(h) {
    return s._balanced = !0, n(h);
  }
}
function _O(e, t, n) {
  return r;
  function r(d) {
    return L(d === b.leftParenthesis, "expected left paren"), e.enter(x.resource), e.enter(x.resourceMarker), e.consume(d), e.exit(x.resourceMarker), i;
  }
  function i(d) {
    return rt(d) ? xs(e, s)(d) : s(d);
  }
  function s(d) {
    return d === b.rightParenthesis ? l(d) : l_(
      e,
      a,
      o,
      x.resourceDestination,
      x.resourceDestinationLiteral,
      x.resourceDestinationLiteralMarker,
      x.resourceDestinationRaw,
      x.resourceDestinationString,
      ue.linkResourceDestinationBalanceMax
    )(d);
  }
  function a(d) {
    return rt(d) ? xs(e, u)(d) : l(d);
  }
  function o(d) {
    return n(d);
  }
  function u(d) {
    return d === b.quotationMark || d === b.apostrophe || d === b.leftParenthesis ? f_(
      e,
      c,
      n,
      x.resourceTitle,
      x.resourceTitleMarker,
      x.resourceTitleString
    )(d) : l(d);
  }
  function c(d) {
    return rt(d) ? xs(e, l)(d) : l(d);
  }
  function l(d) {
    return d === b.rightParenthesis ? (e.enter(x.resourceMarker), e.consume(d), e.exit(x.resourceMarker), e.exit(x.resource), t) : n(d);
  }
}
function xO(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return L(o === b.leftSquareBracket, "expected left bracket"), d_.call(
      r,
      e,
      s,
      a,
      x.reference,
      x.referenceMarker,
      x.referenceString
    )(o);
  }
  function s(o) {
    return r.parser.defined.includes(
      hn(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(o) : n(o);
  }
  function a(o) {
    return n(o);
  }
}
function TO(e, t, n) {
  return r;
  function r(s) {
    return L(s === b.leftSquareBracket, "expected left bracket"), e.enter(x.reference), e.enter(x.referenceMarker), e.consume(s), e.exit(x.referenceMarker), i;
  }
  function i(s) {
    return s === b.rightSquareBracket ? (e.enter(x.referenceMarker), e.consume(s), e.exit(x.referenceMarker), e.exit(x.reference), t) : n(s);
  }
}
const AO = {
  name: "labelStartImage",
  resolveAll: Ad.resolveAll,
  tokenize: yO
};
function yO(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return L(o === b.exclamationMark, "expected `!`"), e.enter(x.labelImage), e.enter(x.labelImageMarker), e.consume(o), e.exit(x.labelImageMarker), s;
  }
  function s(o) {
    return o === b.leftSquareBracket ? (e.enter(x.labelMarker), e.consume(o), e.exit(x.labelMarker), e.exit(x.labelImage), a) : n(o);
  }
  function a(o) {
    return o === b.caret && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const NO = {
  name: "labelStartLink",
  resolveAll: Ad.resolveAll,
  tokenize: vO
};
function vO(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return L(a === b.leftSquareBracket, "expected `[`"), e.enter(x.labelLink), e.enter(x.labelMarker), e.consume(a), e.exit(x.labelMarker), e.exit(x.labelLink), s;
  }
  function s(a) {
    return a === b.caret && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const Zu = { name: "lineEnding", tokenize: wO };
function wO(e, t) {
  return n;
  function n(r) {
    return L(me(r), "expected eol"), e.enter(x.lineEnding), e.consume(r), e.exit(x.lineEnding), Ge(e, t, x.linePrefix);
  }
}
const Wa = {
  name: "thematicBreak",
  tokenize: CO
};
function CO(e, t, n) {
  let r = 0, i;
  return s;
  function s(c) {
    return e.enter(x.thematicBreak), a(c);
  }
  function a(c) {
    return L(
      c === b.asterisk || c === b.dash || c === b.underscore,
      "expected `*`, `-`, or `_`"
    ), i = c, o(c);
  }
  function o(c) {
    return c === i ? (e.enter(x.thematicBreakSequence), u(c)) : r >= ue.thematicBreakMarkerCountMin && (c === b.eof || me(c)) ? (e.exit(x.thematicBreak), t(c)) : n(c);
  }
  function u(c) {
    return c === i ? (e.consume(c), r++, u) : (e.exit(x.thematicBreakSequence), ze(c) ? Ge(e, o, x.whitespace)(c) : o(c));
  }
}
const zt = {
  continuation: { tokenize: DO },
  exit: PO,
  name: "list",
  tokenize: IO
}, SO = {
  partial: !0,
  tokenize: OO
}, kO = { partial: !0, tokenize: RO };
function IO(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let s = i && i[1].type === x.linePrefix ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return o;
  function o(m) {
    L(r.containerState, "expected state");
    const E = r.containerState.type || (m === b.asterisk || m === b.plusSign || m === b.dash ? x.listUnordered : x.listOrdered);
    if (E === x.listUnordered ? !r.containerState.marker || m === r.containerState.marker : Zc(m)) {
      if (r.containerState.type || (r.containerState.type = E, e.enter(E, { _container: !0 })), E === x.listUnordered)
        return e.enter(x.listItemPrefix), m === b.asterisk || m === b.dash ? e.check(Wa, n, c)(m) : c(m);
      if (!r.interrupt || m === b.digit1)
        return e.enter(x.listItemPrefix), e.enter(x.listItemValue), u(m);
    }
    return n(m);
  }
  function u(m) {
    return L(r.containerState, "expected state"), Zc(m) && ++a < ue.listItemValueSizeMax ? (e.consume(m), u) : (!r.interrupt || a < 2) && (r.containerState.marker ? m === r.containerState.marker : m === b.rightParenthesis || m === b.dot) ? (e.exit(x.listItemValue), c(m)) : n(m);
  }
  function c(m) {
    return L(r.containerState, "expected state"), L(m !== b.eof, "eof (`null`) is not a marker"), e.enter(x.listItemMarker), e.consume(m), e.exit(x.listItemMarker), r.containerState.marker = r.containerState.marker || m, e.check(
      Zs,
      // Can’t be empty when interrupting.
      r.interrupt ? n : l,
      e.attempt(
        SO,
        h,
        d
      )
    );
  }
  function l(m) {
    return L(r.containerState, "expected state"), r.containerState.initialBlankLine = !0, s++, h(m);
  }
  function d(m) {
    return ze(m) ? (e.enter(x.listItemPrefixWhitespace), e.consume(m), e.exit(x.listItemPrefixWhitespace), h) : n(m);
  }
  function h(m) {
    return L(r.containerState, "expected state"), r.containerState.size = s + r.sliceSerialize(e.exit(x.listItemPrefix), !0).length, t(m);
  }
}
function DO(e, t, n) {
  const r = this;
  return L(r.containerState, "expected state"), r.containerState._closeFlow = void 0, e.check(Zs, i, s);
  function i(o) {
    return L(r.containerState, "expected state"), L(typeof r.containerState.size == "number", "expected size"), r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Ge(
      e,
      t,
      x.listItemIndent,
      r.containerState.size + 1
    )(o);
  }
  function s(o) {
    return L(r.containerState, "expected state"), r.containerState.furtherBlankLines || !ze(o) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(o)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(kO, t, a)(o));
  }
  function a(o) {
    return L(r.containerState, "expected state"), r.containerState._closeFlow = !0, r.interrupt = void 0, L(
      r.parser.constructs.disable.null,
      "expected `disable.null` to be populated"
    ), Ge(
      e,
      e.attempt(zt, t, n),
      x.linePrefix,
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : ue.tabSize
    )(o);
  }
}
function RO(e, t, n) {
  const r = this;
  return L(r.containerState, "expected state"), L(typeof r.containerState.size == "number", "expected size"), Ge(
    e,
    i,
    x.listItemIndent,
    r.containerState.size + 1
  );
  function i(s) {
    L(r.containerState, "expected state");
    const a = r.events[r.events.length - 1];
    return a && a[1].type === x.listItemIndent && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? t(s) : n(s);
  }
}
function PO(e) {
  L(this.containerState, "expected state"), L(typeof this.containerState.type == "string", "expected type"), e.exit(this.containerState.type);
}
function OO(e, t, n) {
  const r = this;
  return L(
    r.parser.constructs.disable.null,
    "expected `disable.null` to be populated"
  ), Ge(
    e,
    i,
    x.listItemPrefixWhitespace,
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : ue.tabSize + 1
  );
  function i(s) {
    const a = r.events[r.events.length - 1];
    return !ze(s) && a && a[1].type === x.listItemPrefixWhitespace ? t(s) : n(s);
  }
}
const um = {
  name: "setextUnderline",
  resolveTo: LO,
  tokenize: MO
};
function LO(e, t) {
  let n = e.length, r, i, s;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === x.content) {
        r = n;
        break;
      }
      e[n][1].type === x.paragraph && (i = n);
    } else
      e[n][1].type === x.content && e.splice(n, 1), !s && e[n][1].type === x.definition && (s = n);
  L(i !== void 0, "expected a `text` index to be found"), L(r !== void 0, "expected a `text` index to be found"), L(e[r][2] === t, "enter context should be same"), L(
    e[e.length - 1][2] === t,
    "enter context should be same"
  );
  const a = {
    type: x.setextHeading,
    start: { ...e[r][1].start },
    end: { ...e[e.length - 1][1].end }
  };
  return e[i][1].type = x.setextHeadingText, s ? (e.splice(i, 0, ["enter", a, t]), e.splice(s + 1, 0, ["exit", e[r][1], t]), e[r][1].end = { ...e[s][1].end }) : e[r][1] = a, e.push(["exit", a, t]), e;
}
function MO(e, t, n) {
  const r = this;
  let i;
  return s;
  function s(c) {
    let l = r.events.length, d;
    for (L(
      c === b.dash || c === b.equalsTo,
      "expected `=` or `-`"
    ); l--; )
      if (r.events[l][1].type !== x.lineEnding && r.events[l][1].type !== x.linePrefix && r.events[l][1].type !== x.content) {
        d = r.events[l][1].type === x.paragraph;
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter(x.setextHeadingLine), i = c, a(c)) : n(c);
  }
  function a(c) {
    return e.enter(x.setextHeadingLineSequence), o(c);
  }
  function o(c) {
    return c === i ? (e.consume(c), o) : (e.exit(x.setextHeadingLineSequence), ze(c) ? Ge(e, u, x.lineSuffix)(c) : u(c));
  }
  function u(c) {
    return c === b.eof || me(c) ? (e.exit(x.setextHeadingLine), t(c)) : n(c);
  }
}
const UO = { tokenize: HO };
function HO(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Zs,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      Ge(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(VP, i)
        ),
        x.linePrefix
      )
    )
  );
  return n;
  function r(s) {
    if (L(
      s === b.eof || me(s),
      "expected eol or eof"
    ), s === b.eof) {
      e.consume(s);
      return;
    }
    return e.enter(x.lineEndingBlank), e.consume(s), e.exit(x.lineEndingBlank), t.currentConstruct = void 0, n;
  }
  function i(s) {
    if (L(
      s === b.eof || me(s),
      "expected eol or eof"
    ), s === b.eof) {
      e.consume(s);
      return;
    }
    return e.enter(x.lineEnding), e.consume(s), e.exit(x.lineEnding), t.currentConstruct = void 0, n;
  }
}
const jO = { resolveAll: m_() }, BO = h_("string"), FO = h_("text");
function h_(e) {
  return {
    resolveAll: m_(
      e === "text" ? zO : void 0
    ),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], s = n.attempt(i, a, o);
    return a;
    function a(l) {
      return c(l) ? s(l) : o(l);
    }
    function o(l) {
      if (l === b.eof) {
        n.consume(l);
        return;
      }
      return n.enter(x.data), n.consume(l), u;
    }
    function u(l) {
      return c(l) ? (n.exit(x.data), s(l)) : (n.consume(l), u);
    }
    function c(l) {
      if (l === b.eof)
        return !0;
      const d = i[l];
      let h = -1;
      if (d)
        for (L(Array.isArray(d), "expected `disable.null` to be populated"); ++h < d.length; ) {
          const m = d[h];
          if (!m.previous || m.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function m_(e) {
  return t;
  function t(n, r) {
    let i = -1, s;
    for (; ++i <= n.length; )
      s === void 0 ? n[i] && n[i][1].type === x.data && (s = i, i++) : (!n[i] || n[i][1].type !== x.data) && (i !== s + 2 && (n[s][1].end = n[i - 1][1].end, n.splice(s + 2, i - s - 2), i = s + 2), s = void 0);
    return e ? e(n, r) : n;
  }
}
function zO(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === x.lineEnding) && e[n - 1][1].type === x.data) {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let s = i.length, a = -1, o = 0, u;
      for (; s--; ) {
        const c = i[s];
        if (typeof c == "string") {
          for (a = c.length; c.charCodeAt(a - 1) === b.space; )
            o++, a--;
          if (a) break;
          a = -1;
        } else if (c === b.horizontalTab)
          u = !0, o++;
        else if (c !== b.virtualSpace) {
          s++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (o = 0), o) {
        const c = {
          type: n === e.length || u || o < ue.hardBreakPrefixSizeMin ? x.lineSuffix : x.hardBreakTrailing,
          start: {
            _bufferIndex: s ? a : r.start._bufferIndex + a,
            _index: r.start._index + s,
            line: r.end.line,
            column: r.end.column - o,
            offset: r.end.offset - o
          },
          end: { ...r.end }
        };
        r.end = { ...c.start }, r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(
          n,
          0,
          ["enter", c, t],
          ["exit", c, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
const VO = {
  [b.asterisk]: zt,
  [b.plusSign]: zt,
  [b.dash]: zt,
  [b.digit0]: zt,
  [b.digit1]: zt,
  [b.digit2]: zt,
  [b.digit3]: zt,
  [b.digit4]: zt,
  [b.digit5]: zt,
  [b.digit6]: zt,
  [b.digit7]: zt,
  [b.digit8]: zt,
  [b.digit9]: zt,
  [b.greaterThan]: s_
}, WO = {
  [b.leftSquareBracket]: qP
}, $O = {
  [b.horizontalTab]: Ju,
  [b.virtualSpace]: Ju,
  [b.space]: Ju
}, YO = {
  [b.numberSign]: eO,
  [b.asterisk]: Wa,
  [b.dash]: [um, Wa],
  [b.lessThan]: iO,
  [b.equalsTo]: um,
  [b.underscore]: Wa,
  [b.graveAccent]: am,
  [b.tilde]: am
}, GO = {
  [b.ampersand]: o_,
  [b.backslash]: a_
}, qO = {
  [b.carriageReturn]: Zu,
  [b.lineFeed]: Zu,
  [b.carriageReturnLineFeed]: Zu,
  [b.exclamationMark]: AO,
  [b.ampersand]: o_,
  [b.asterisk]: el,
  [b.lessThan]: [vP, dO],
  [b.leftSquareBracket]: NO,
  [b.backslash]: [JP, a_],
  [b.rightSquareBracket]: Ad,
  [b.underscore]: el,
  [b.graveAccent]: HP
}, KO = { null: [el, jO] }, QO = { null: [b.asterisk, b.underscore] }, XO = { null: [] }, JO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: QO,
  contentInitial: WO,
  disable: XO,
  document: VO,
  flow: YO,
  flowInitial: $O,
  insideSpan: KO,
  string: GO,
  text: qO
}, Symbol.toStringTag, { value: "Module" }));
var Da = { exports: {} }, ec, cm;
function ZO() {
  if (cm) return ec;
  cm = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, i = r * 7, s = r * 365.25;
  ec = function(l, d) {
    d = d || {};
    var h = typeof l;
    if (h === "string" && l.length > 0)
      return a(l);
    if (h === "number" && isFinite(l))
      return d.long ? u(l) : o(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function a(l) {
    if (l = String(l), !(l.length > 100)) {
      var d = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        l
      );
      if (d) {
        var h = parseFloat(d[1]), m = (d[2] || "ms").toLowerCase();
        switch (m) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return h * s;
          case "weeks":
          case "week":
          case "w":
            return h * i;
          case "days":
          case "day":
          case "d":
            return h * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return h * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return h * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return h * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return h;
          default:
            return;
        }
      }
    }
  }
  function o(l) {
    var d = Math.abs(l);
    return d >= r ? Math.round(l / r) + "d" : d >= n ? Math.round(l / n) + "h" : d >= t ? Math.round(l / t) + "m" : d >= e ? Math.round(l / e) + "s" : l + "ms";
  }
  function u(l) {
    var d = Math.abs(l);
    return d >= r ? c(l, d, r, "day") : d >= n ? c(l, d, n, "hour") : d >= t ? c(l, d, t, "minute") : d >= e ? c(l, d, e, "second") : l + " ms";
  }
  function c(l, d, h, m) {
    var E = d >= h * 1.5;
    return Math.round(l / h) + " " + m + (E ? "s" : "");
  }
  return ec;
}
var tc, lm;
function eL() {
  if (lm) return tc;
  lm = 1;
  function e(t) {
    r.debug = r, r.default = r, r.coerce = c, r.disable = o, r.enable = s, r.enabled = u, r.humanize = ZO(), r.destroy = l, Object.keys(t).forEach((d) => {
      r[d] = t[d];
    }), r.names = [], r.skips = [], r.formatters = {};
    function n(d) {
      let h = 0;
      for (let m = 0; m < d.length; m++)
        h = (h << 5) - h + d.charCodeAt(m), h |= 0;
      return r.colors[Math.abs(h) % r.colors.length];
    }
    r.selectColor = n;
    function r(d) {
      let h, m = null, E, g;
      function T(..._) {
        if (!T.enabled)
          return;
        const A = T, w = Number(/* @__PURE__ */ new Date()), M = w - (h || w);
        A.diff = M, A.prev = h, A.curr = w, h = w, _[0] = r.coerce(_[0]), typeof _[0] != "string" && _.unshift("%O");
        let F = 0;
        _[0] = _[0].replace(/%([a-zA-Z%])/g, (B, $) => {
          if (B === "%%")
            return "%";
          F++;
          const J = r.formatters[$];
          if (typeof J == "function") {
            const U = _[F];
            B = J.call(A, U), _.splice(F, 1), F--;
          }
          return B;
        }), r.formatArgs.call(A, _), (A.log || r.log).apply(A, _);
      }
      return T.namespace = d, T.useColors = r.useColors(), T.color = r.selectColor(d), T.extend = i, T.destroy = r.destroy, Object.defineProperty(T, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: () => m !== null ? m : (E !== r.namespaces && (E = r.namespaces, g = r.enabled(d)), g),
        set: (_) => {
          m = _;
        }
      }), typeof r.init == "function" && r.init(T), T;
    }
    function i(d, h) {
      const m = r(this.namespace + (typeof h > "u" ? ":" : h) + d);
      return m.log = this.log, m;
    }
    function s(d) {
      r.save(d), r.namespaces = d, r.names = [], r.skips = [];
      const h = (typeof d == "string" ? d : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
      for (const m of h)
        m[0] === "-" ? r.skips.push(m.slice(1)) : r.names.push(m);
    }
    function a(d, h) {
      let m = 0, E = 0, g = -1, T = 0;
      for (; m < d.length; )
        if (E < h.length && (h[E] === d[m] || h[E] === "*"))
          h[E] === "*" ? (g = E, T = m, E++) : (m++, E++);
        else if (g !== -1)
          E = g + 1, T++, m = T;
        else
          return !1;
      for (; E < h.length && h[E] === "*"; )
        E++;
      return E === h.length;
    }
    function o() {
      const d = [
        ...r.names,
        ...r.skips.map((h) => "-" + h)
      ].join(",");
      return r.enable(""), d;
    }
    function u(d) {
      for (const h of r.skips)
        if (a(d, h))
          return !1;
      for (const h of r.names)
        if (a(d, h))
          return !0;
      return !1;
    }
    function c(d) {
      return d instanceof Error ? d.stack || d.message : d;
    }
    function l() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    return r.enable(r.load()), r;
  }
  return tc = e, tc;
}
var dm;
function tL() {
  return dm || (dm = 1, (function(e, t) {
    t.formatArgs = r, t.save = i, t.load = s, t.useColors = n, t.storage = a(), t.destroy = /* @__PURE__ */ (() => {
      let u = !1;
      return () => {
        u || (u = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      };
    })(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs))
        return !0;
      if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))
        return !1;
      let u;
      return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && (u = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(u[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function r(u) {
      if (u[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + u[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors)
        return;
      const c = "color: " + this.color;
      u.splice(1, 0, c, "color: inherit");
      let l = 0, d = 0;
      u[0].replace(/%[a-zA-Z%]/g, (h) => {
        h !== "%%" && (l++, h === "%c" && (d = l));
      }), u.splice(d, 0, c);
    }
    t.log = console.debug || console.log || (() => {
    });
    function i(u) {
      try {
        u ? t.storage.setItem("debug", u) : t.storage.removeItem("debug");
      } catch {
      }
    }
    function s() {
      let u;
      try {
        u = t.storage.getItem("debug") || t.storage.getItem("DEBUG");
      } catch {
      }
      return !u && typeof process < "u" && "env" in process && (u = process.env.DEBUG), u;
    }
    function a() {
      try {
        return localStorage;
      } catch {
      }
    }
    e.exports = eL()(t);
    const { formatters: o } = e.exports;
    o.j = function(u) {
      try {
        return JSON.stringify(u);
      } catch (c) {
        return "[UnexpectedJSONParseError]: " + c.message;
      }
    };
  })(Da, Da.exports)), Da.exports;
}
var nL = tL();
const rL = /* @__PURE__ */ pr(nL), Dr = rL("micromark");
function iL(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, s = [];
  let a = [], o = [], u = !0;
  const c = {
    attempt: J(B),
    check: J($),
    consume: M,
    enter: F,
    exit: k,
    interrupt: J($, { interrupt: !0 })
  }, l = {
    code: b.eof,
    containerState: {},
    defineSkip: _,
    events: [],
    now: T,
    parser: e,
    previous: b.eof,
    sliceSerialize: E,
    sliceStream: g,
    write: m
  };
  let d = t.tokenize.call(l, c), h;
  return t.resolveAll && s.push(t), l;
  function m(j) {
    return a = rn(a, j), A(), a[a.length - 1] !== b.eof ? [] : (U(t, 0), l.events = ou(s, l.events, l), l.events);
  }
  function E(j, H) {
    return aL(g(j), H);
  }
  function g(j) {
    return sL(a, j);
  }
  function T() {
    const { _bufferIndex: j, _index: H, line: z, column: W, offset: X } = r;
    return { _bufferIndex: j, _index: H, line: z, column: W, offset: X };
  }
  function _(j) {
    i[j.line] = j.column, ae(), Dr("position: define skip: `%j`", r);
  }
  function A() {
    let j;
    for (; r._index < a.length; ) {
      const H = a[r._index];
      if (typeof H == "string")
        for (j = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === j && r._bufferIndex < H.length; )
          w(H.charCodeAt(r._bufferIndex));
      else
        w(H);
    }
  }
  function w(j) {
    L(u === !0, "expected character to be consumed"), u = void 0, Dr("main: passing `%s` to %s", j, d && d.name), h = j, L(typeof d == "function", "expected state"), d = d(j);
  }
  function M(j) {
    L(j === h, "expected given code to equal expected code"), Dr("consume: `%s`", j), L(
      u === void 0,
      "expected code to not have been consumed: this might be because `return x(code)` instead of `return x` was used"
    ), L(
      j === null ? l.events.length === 0 || l.events[l.events.length - 1][0] === "exit" : l.events[l.events.length - 1][0] === "enter",
      "expected last token to be open"
    ), me(j) ? (r.line++, r.column = 1, r.offset += j === b.carriageReturnLineFeed ? 2 : 1, ae(), Dr("position: after eol: `%j`", r)) : j !== b.virtualSpace && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    a[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = j, u = !0;
  }
  function F(j, H) {
    const z = H || {};
    return z.type = j, z.start = T(), L(typeof j == "string", "expected string type"), L(j.length > 0, "expected non-empty string"), Dr("enter: `%s`", j), l.events.push(["enter", z, l]), o.push(z), z;
  }
  function k(j) {
    L(typeof j == "string", "expected string type"), L(j.length > 0, "expected non-empty string");
    const H = o.pop();
    return L(H, "cannot close w/o open tokens"), H.end = T(), L(j === H.type, "expected exit token to match current token"), L(
      !(H.start._index === H.end._index && H.start._bufferIndex === H.end._bufferIndex),
      "expected non-empty token (`" + j + "`)"
    ), Dr("exit: `%s`", H.type), l.events.push(["exit", H, l]), H;
  }
  function B(j, H) {
    U(j, H.from);
  }
  function $(j, H) {
    H.restore();
  }
  function J(j, H) {
    return z;
    function z(W, X, G) {
      let se, N, ye, Re;
      return Array.isArray(W) ? (
        /* c8 ignore next 1 */
        Ie(W)
      ) : "tokenize" in W ? (
        // Looks like a construct.
        Ie([
          /** @type {Construct} */
          W
        ])
      ) : D(W);
      function D(Te) {
        return Ne;
        function Ne(_e) {
          const Se = _e !== null && Te[_e], Me = _e !== null && Te.null, Ze = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Se) ? Se : Se ? [Se] : [],
            ...Array.isArray(Me) ? Me : Me ? [Me] : []
          ];
          return Ie(Ze)(_e);
        }
      }
      function Ie(Te) {
        return se = Te, N = 0, Te.length === 0 ? (L(G, "expected `bogusState` to be given"), G) : De(Te[N]);
      }
      function De(Te) {
        return Ne;
        function Ne(_e) {
          return Re = re(), ye = Te, Te.partial || (l.currentConstruct = Te), L(
            l.parser.constructs.disable.null,
            "expected `disable.null` to be populated"
          ), Te.name && l.parser.constructs.disable.null.includes(Te.name) ? fe(_e) : Te.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            H ? Object.assign(Object.create(l), H) : l,
            c,
            He,
            fe
          )(_e);
        }
      }
      function He(Te) {
        return L(Te === h, "expected code"), u = !0, j(ye, Re), X;
      }
      function fe(Te) {
        return L(Te === h, "expected code"), u = !0, Re.restore(), ++N < se.length ? De(se[N]) : G;
      }
    }
  }
  function U(j, H) {
    j.resolveAll && !s.includes(j) && s.push(j), j.resolve && Xt(
      l.events,
      H,
      l.events.length - H,
      j.resolve(l.events.slice(H), l)
    ), j.resolveTo && (l.events = j.resolveTo(l.events, l)), L(
      j.partial || l.events.length === 0 || l.events[l.events.length - 1][0] === "exit",
      "expected last token to end"
    );
  }
  function re() {
    const j = T(), H = l.previous, z = l.currentConstruct, W = l.events.length, X = Array.from(o);
    return { from: W, restore: G };
    function G() {
      r = j, l.previous = H, l.currentConstruct = z, l.events.length = W, o = X, ae(), Dr("position: restore: `%j`", r);
    }
  }
  function ae() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function sL(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, s = t.end._bufferIndex;
  let a;
  if (n === i)
    L(s > -1, "expected non-negative end buffer index"), L(r > -1, "expected non-negative start buffer index"), a = [e[n].slice(r, s)];
  else {
    if (a = e.slice(n, i), r > -1) {
      const o = a[0];
      typeof o == "string" ? a[0] = o.slice(r) : (L(r === 0, "expected `startBufferIndex` to be `0`"), a.shift());
    }
    s > 0 && a.push(e[i].slice(0, s));
  }
  return a;
}
function aL(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const s = e[n];
    let a;
    if (typeof s == "string")
      a = s;
    else
      switch (s) {
        case b.carriageReturn: {
          a = Nn.cr;
          break;
        }
        case b.lineFeed: {
          a = Nn.lf;
          break;
        }
        case b.carriageReturnLineFeed: {
          a = Nn.cr + Nn.lf;
          break;
        }
        case b.horizontalTab: {
          a = t ? Nn.space : Nn.ht;
          break;
        }
        case b.virtualSpace: {
          if (!t && i) continue;
          a = Nn.space;
          break;
        }
        default:
          L(typeof s == "number", "expected number"), a = String.fromCharCode(s);
      }
    i = s === b.horizontalTab, r.push(a);
  }
  return r.join("");
}
function oL(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      r_([JO, ...(e || {}).extensions || []])
    ),
    content: i(EP),
    defined: [],
    document: i(xP),
    flow: i(UO),
    lazy: {},
    string: i(BO),
    text: i(FO)
  };
  return r;
  function i(s) {
    return a;
    function a(o) {
      return iL(r, s, o);
    }
  }
}
function uL(e) {
  for (; !c_(e); )
    ;
  return e;
}
const fm = /[\0\t\n\r]/g;
function cL() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(s, a, o) {
    const u = [];
    let c, l, d, h, m;
    for (s = t + (typeof s == "string" ? s.toString() : new TextDecoder(a || void 0).decode(s)), d = 0, t = "", n && (s.charCodeAt(0) === b.byteOrderMarker && d++, n = void 0); d < s.length; ) {
      if (fm.lastIndex = d, c = fm.exec(s), h = c && c.index !== void 0 ? c.index : s.length, m = s.charCodeAt(h), !c) {
        t = s.slice(d);
        break;
      }
      if (m === b.lf && d === h && r)
        u.push(b.carriageReturnLineFeed), r = void 0;
      else
        switch (r && (u.push(b.carriageReturn), r = void 0), d < h && (u.push(s.slice(d, h)), e += h - d), m) {
          case b.nul: {
            u.push(b.replacementCharacter), e++;
            break;
          }
          case b.ht: {
            for (l = Math.ceil(e / ue.tabSize) * ue.tabSize, u.push(b.horizontalTab); e++ < l; ) u.push(b.virtualSpace);
            break;
          }
          case b.lf: {
            u.push(b.lineFeed), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = h + 1;
    }
    return o && (r && u.push(b.carriageReturn), t && u.push(t), u.push(b.eof)), u;
  }
}
const lL = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function dL(e) {
  return e.replace(lL, fL);
}
function fL(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === b.numberSign) {
    const i = n.charCodeAt(1), s = i === b.lowercaseX || i === b.uppercaseX;
    return i_(
      n.slice(s ? 2 : 1),
      s ? ue.numericBaseHexadecimal : ue.numericBaseDecimal
    );
  }
  return Td(n) || e;
}
const p_ = {}.hasOwnProperty;
function hL(e, t, n) {
  return t && typeof t == "object" && (n = t, t = void 0), mL(n)(
    uL(
      oL(n).document().write(cL()(e, t, !0))
    )
  );
}
function mL(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: s(nn),
      autolinkProtocol: J,
      autolinkEmail: J,
      atxHeading: s(kt),
      blockQuote: s(_e),
      characterEscape: J,
      characterReference: J,
      codeFenced: s(Se),
      codeFencedFenceInfo: a,
      codeFencedFenceMeta: a,
      codeIndented: s(Se, a),
      codeText: s(Me, a),
      codeTextData: J,
      data: J,
      codeFlowValue: J,
      definition: s(Ze),
      definitionDestinationString: a,
      definitionLabelString: a,
      definitionTitleString: a,
      emphasis: s(Et),
      hardBreakEscape: s(_t),
      hardBreakTrailing: s(_t),
      htmlFlow: s(tn, a),
      htmlFlowData: J,
      htmlText: s(tn, a),
      htmlTextData: J,
      image: s(Nr),
      label: a,
      link: s(nn),
      listItem: s(Vi),
      listItemValue: h,
      listOrdered: s(ti, d),
      listUnordered: s(ti),
      paragraph: s(Mn),
      reference: D,
      referenceString: a,
      resourceDestinationString: a,
      resourceTitleString: a,
      setextHeading: s(kt),
      strong: s(Wi),
      thematicBreak: s(vr)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: F,
      autolink: u(),
      autolinkEmail: Ne,
      autolinkProtocol: Te,
      blockQuote: u(),
      characterEscapeValue: U,
      characterReferenceMarkerHexadecimal: De,
      characterReferenceMarkerNumeric: De,
      characterReferenceValue: He,
      characterReference: fe,
      codeFenced: u(T),
      codeFencedFence: g,
      codeFencedFenceInfo: m,
      codeFencedFenceMeta: E,
      codeFlowValue: U,
      codeIndented: u(_),
      codeText: u(z),
      codeTextData: U,
      data: U,
      definition: u(),
      definitionDestinationString: M,
      definitionLabelString: A,
      definitionTitleString: w,
      emphasis: u(),
      hardBreakEscape: u(ae),
      hardBreakTrailing: u(ae),
      htmlFlow: u(j),
      htmlFlowData: U,
      htmlText: u(H),
      htmlTextData: U,
      image: u(X),
      label: se,
      labelText: G,
      lineEnding: re,
      link: u(W),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Ie,
      resourceDestinationString: N,
      resourceTitleString: ye,
      resource: Re,
      setextHeading: u($),
      setextHeadingLineSequence: B,
      setextHeadingText: k,
      strong: u(),
      thematicBreak: u()
    }
  };
  g_(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(Q) {
    let K = { type: "root", children: [] };
    const he = {
      stack: [K],
      tokenStack: [],
      config: t,
      enter: o,
      exit: c,
      buffer: a,
      resume: l,
      data: n
    }, Ue = [];
    let $e = -1;
    for (; ++$e < Q.length; )
      if (Q[$e][1].type === x.listOrdered || Q[$e][1].type === x.listUnordered)
        if (Q[$e][0] === "enter")
          Ue.push($e);
        else {
          const ft = Ue.pop();
          L(typeof ft == "number", "expected list to be open"), $e = i(Q, ft, $e);
        }
    for ($e = -1; ++$e < Q.length; ) {
      const ft = t[Q[$e][0]];
      p_.call(ft, Q[$e][1].type) && ft[Q[$e][1].type].call(
        Object.assign(
          { sliceSerialize: Q[$e][2].sliceSerialize },
          he
        ),
        Q[$e][1]
      );
    }
    if (he.tokenStack.length > 0) {
      const ft = he.tokenStack[he.tokenStack.length - 1];
      (ft[1] || hm).call(he, void 0, ft[0]);
    }
    for (K.position = {
      start: er(
        Q.length > 0 ? Q[0][1].start : { line: 1, column: 1, offset: 0 }
      ),
      end: er(
        Q.length > 0 ? Q[Q.length - 2][1].end : { line: 1, column: 1, offset: 0 }
      )
    }, $e = -1; ++$e < t.transforms.length; )
      K = t.transforms[$e](K) || K;
    return K;
  }
  function i(Q, K, he) {
    let Ue = K - 1, $e = -1, ft = !1, un, Yt, Un, Hn;
    for (; ++Ue <= he; ) {
      const yt = Q[Ue];
      switch (yt[1].type) {
        case x.listUnordered:
        case x.listOrdered:
        case x.blockQuote: {
          yt[0] === "enter" ? $e++ : $e--, Hn = void 0;
          break;
        }
        case x.lineEndingBlank: {
          yt[0] === "enter" && (un && !Hn && !$e && !Un && (Un = Ue), Hn = void 0);
          break;
        }
        case x.linePrefix:
        case x.listItemValue:
        case x.listItemMarker:
        case x.listItemPrefix:
        case x.listItemPrefixWhitespace:
          break;
        default:
          Hn = void 0;
      }
      if (!$e && yt[0] === "enter" && yt[1].type === x.listItemPrefix || $e === -1 && yt[0] === "exit" && (yt[1].type === x.listUnordered || yt[1].type === x.listOrdered)) {
        if (un) {
          let xn = Ue;
          for (Yt = void 0; xn--; ) {
            const Ut = Q[xn];
            if (Ut[1].type === x.lineEnding || Ut[1].type === x.lineEndingBlank) {
              if (Ut[0] === "exit") continue;
              Yt && (Q[Yt][1].type = x.lineEndingBlank, ft = !0), Ut[1].type = x.lineEnding, Yt = xn;
            } else if (!(Ut[1].type === x.linePrefix || Ut[1].type === x.blockQuotePrefix || Ut[1].type === x.blockQuotePrefixWhitespace || Ut[1].type === x.blockQuoteMarker || Ut[1].type === x.listItemIndent)) break;
          }
          Un && (!Yt || Un < Yt) && (un._spread = !0), un.end = Object.assign(
            {},
            Yt ? Q[Yt][1].start : yt[1].end
          ), Q.splice(Yt || Ue, 0, ["exit", un, yt[2]]), Ue++, he++;
        }
        if (yt[1].type === x.listItemPrefix) {
          const xn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, yt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          un = xn, Q.splice(Ue, 0, ["enter", xn, yt[2]]), Ue++, he++, Un = void 0, Hn = !0;
        }
      }
    }
    return Q[K][1]._spread = ft, he;
  }
  function s(Q, K) {
    return he;
    function he(Ue) {
      o.call(this, Q(Ue), Ue), K && K.call(this, Ue);
    }
  }
  function a() {
    this.stack.push({ type: "fragment", children: [] });
  }
  function o(Q, K, he) {
    const Ue = this.stack[this.stack.length - 1];
    L(Ue, "expected `parent`"), L("children" in Ue, "expected `parent`"), Ue.children.push(Q), this.stack.push(Q), this.tokenStack.push([K, he || void 0]), Q.position = {
      start: er(K.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(Q) {
    return K;
    function K(he) {
      Q && Q.call(this, he), c.call(this, he);
    }
  }
  function c(Q, K) {
    const he = this.stack.pop();
    L(he, "expected `node`");
    const Ue = this.tokenStack.pop();
    if (Ue)
      Ue[0].type !== Q.type && (K ? K.call(this, Q, Ue[0]) : (Ue[1] || hm).call(this, Q, Ue[0]));
    else throw new Error(
      "Cannot close `" + Q.type + "` (" + _s({ start: Q.start, end: Q.end }) + "): it’s not open"
    );
    L(he.type !== "fragment", "unexpected fragment `exit`ed"), L(he.position, "expected `position` to be defined"), he.position.end = er(Q.end);
  }
  function l() {
    return xd(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(Q) {
    if (this.data.expectingFirstListItemValue) {
      const K = this.stack[this.stack.length - 2];
      L(K, "expected nodes on stack"), L(K.type === "list", "expected list on stack"), K.start = Number.parseInt(
        this.sliceSerialize(Q),
        ue.numericBaseDecimal
      ), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function m() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "code", "expected code on stack"), K.lang = Q;
  }
  function E() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "code", "expected code on stack"), K.meta = Q;
  }
  function g() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function T() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "code", "expected code on stack"), K.value = Q.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function _() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "code", "expected code on stack"), K.value = Q.replace(/(\r?\n|\r)$/g, "");
  }
  function A(Q) {
    const K = this.resume(), he = this.stack[this.stack.length - 1];
    L(he, "expected node on stack"), L(he.type === "definition", "expected definition on stack"), he.label = K, he.identifier = hn(
      this.sliceSerialize(Q)
    ).toLowerCase();
  }
  function w() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "definition", "expected definition on stack"), K.title = Q;
  }
  function M() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "definition", "expected definition on stack"), K.url = Q;
  }
  function F(Q) {
    const K = this.stack[this.stack.length - 1];
    if (L(K, "expected node on stack"), L(K.type === "heading", "expected heading on stack"), !K.depth) {
      const he = this.sliceSerialize(Q).length;
      L(
        he === 1 || he === 2 || he === 3 || he === 4 || he === 5 || he === 6,
        "expected `depth` between `1` and `6`"
      ), K.depth = he;
    }
  }
  function k() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function B(Q) {
    const K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "heading", "expected heading on stack"), K.depth = this.sliceSerialize(Q).codePointAt(0) === b.equalsTo ? 1 : 2;
  }
  function $() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function J(Q) {
    const K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L("children" in K, "expected parent on stack");
    const he = K.children;
    let Ue = he[he.length - 1];
    (!Ue || Ue.type !== "text") && (Ue = $i(), Ue.position = {
      start: er(Q.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, he.push(Ue)), this.stack.push(Ue);
  }
  function U(Q) {
    const K = this.stack.pop();
    L(K, "expected a `node` to be on the stack"), L("value" in K, "expected a `literal` to be on the stack"), L(K.position, "expected `node` to have an open position"), K.value += this.sliceSerialize(Q), K.position.end = er(Q.end);
  }
  function re(Q) {
    const K = this.stack[this.stack.length - 1];
    if (L(K, "expected `node`"), this.data.atHardBreak) {
      L("children" in K, "expected `parent`");
      const he = K.children[K.children.length - 1];
      L(he.position, "expected tail to have a starting position"), he.position.end = er(Q.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(K.type) && (J.call(this, Q), U.call(this, Q));
  }
  function ae() {
    this.data.atHardBreak = !0;
  }
  function j() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "html", "expected html on stack"), K.value = Q;
  }
  function H() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "html", "expected html on stack"), K.value = Q;
  }
  function z() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "inlineCode", "expected inline code on stack"), K.value = Q;
  }
  function W() {
    const Q = this.stack[this.stack.length - 1];
    if (L(Q, "expected node on stack"), L(Q.type === "link", "expected link on stack"), this.data.inReference) {
      const K = this.data.referenceType || "shortcut";
      Q.type += "Reference", Q.referenceType = K, delete Q.url, delete Q.title;
    } else
      delete Q.identifier, delete Q.label;
    this.data.referenceType = void 0;
  }
  function X() {
    const Q = this.stack[this.stack.length - 1];
    if (L(Q, "expected node on stack"), L(Q.type === "image", "expected image on stack"), this.data.inReference) {
      const K = this.data.referenceType || "shortcut";
      Q.type += "Reference", Q.referenceType = K, delete Q.url, delete Q.title;
    } else
      delete Q.identifier, delete Q.label;
    this.data.referenceType = void 0;
  }
  function G(Q) {
    const K = this.sliceSerialize(Q), he = this.stack[this.stack.length - 2];
    L(he, "expected ancestor on stack"), L(
      he.type === "image" || he.type === "link",
      "expected image or link on stack"
    ), he.label = dL(K), he.identifier = hn(K).toLowerCase();
  }
  function se() {
    const Q = this.stack[this.stack.length - 1];
    L(Q, "expected node on stack"), L(Q.type === "fragment", "expected fragment on stack");
    const K = this.resume(), he = this.stack[this.stack.length - 1];
    if (L(he, "expected node on stack"), L(
      he.type === "image" || he.type === "link",
      "expected image or link on stack"
    ), this.data.inReference = !0, he.type === "link") {
      const Ue = Q.children;
      he.children = Ue;
    } else
      he.alt = K;
  }
  function N() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(
      K.type === "image" || K.type === "link",
      "expected image or link on stack"
    ), K.url = Q;
  }
  function ye() {
    const Q = this.resume(), K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(
      K.type === "image" || K.type === "link",
      "expected image or link on stack"
    ), K.title = Q;
  }
  function Re() {
    this.data.inReference = void 0;
  }
  function D() {
    this.data.referenceType = "collapsed";
  }
  function Ie(Q) {
    const K = this.resume(), he = this.stack[this.stack.length - 1];
    L(he, "expected node on stack"), L(
      he.type === "image" || he.type === "link",
      "expected image reference or link reference on stack"
    ), he.label = K, he.identifier = hn(
      this.sliceSerialize(Q)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function De(Q) {
    L(
      Q.type === "characterReferenceMarkerNumeric" || Q.type === "characterReferenceMarkerHexadecimal"
    ), this.data.characterReferenceType = Q.type;
  }
  function He(Q) {
    const K = this.sliceSerialize(Q), he = this.data.characterReferenceType;
    let Ue;
    if (he)
      Ue = i_(
        K,
        he === x.characterReferenceMarkerNumeric ? ue.numericBaseDecimal : ue.numericBaseHexadecimal
      ), this.data.characterReferenceType = void 0;
    else {
      const ft = Td(K);
      L(ft !== !1, "expected reference to decode"), Ue = ft;
    }
    const $e = this.stack[this.stack.length - 1];
    L($e, "expected `node`"), L("value" in $e, "expected `node.value`"), $e.value += Ue;
  }
  function fe(Q) {
    const K = this.stack.pop();
    L(K, "expected `node`"), L(K.position, "expected `node.position`"), K.position.end = er(Q.end);
  }
  function Te(Q) {
    U.call(this, Q);
    const K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "link", "expected link on stack"), K.url = this.sliceSerialize(Q);
  }
  function Ne(Q) {
    U.call(this, Q);
    const K = this.stack[this.stack.length - 1];
    L(K, "expected node on stack"), L(K.type === "link", "expected link on stack"), K.url = "mailto:" + this.sliceSerialize(Q);
  }
  function _e() {
    return { type: "blockquote", children: [] };
  }
  function Se() {
    return { type: "code", lang: null, meta: null, value: "" };
  }
  function Me() {
    return { type: "inlineCode", value: "" };
  }
  function Ze() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Et() {
    return { type: "emphasis", children: [] };
  }
  function kt() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function _t() {
    return { type: "break" };
  }
  function tn() {
    return { type: "html", value: "" };
  }
  function Nr() {
    return { type: "image", title: null, url: "", alt: null };
  }
  function nn() {
    return { type: "link", title: null, url: "", children: [] };
  }
  function ti(Q) {
    return {
      type: "list",
      ordered: Q.type === "listOrdered",
      start: null,
      spread: Q._spread,
      children: []
    };
  }
  function Vi(Q) {
    return {
      type: "listItem",
      spread: Q._spread,
      checked: null,
      children: []
    };
  }
  function Mn() {
    return { type: "paragraph", children: [] };
  }
  function Wi() {
    return { type: "strong", children: [] };
  }
  function $i() {
    return { type: "text", value: "" };
  }
  function vr() {
    return { type: "thematicBreak" };
  }
}
function er(e) {
  return { line: e.line, column: e.column, offset: e.offset };
}
function g_(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? g_(e, r) : pL(e, r);
  }
}
function pL(e, t) {
  let n;
  for (n in t)
    if (p_.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function hm(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + _s({ start: e.start, end: e.end }) + "): a different token (`" + t.type + "`, " + _s({ start: t.start, end: t.end }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + _s({ start: t.start, end: t.end }) + ") is still open"
  );
}
function gL(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return hL(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function bL(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function EL(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function _L(e, t) {
  const n = t.value ? t.value + `
` : "", r = {}, i = t.lang ? t.lang.split(/\s+/) : [];
  i.length > 0 && (r.className = ["language-" + i[0]]);
  let s = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (s.data = { meta: t.meta }), e.patch(t, s), s = e.applyData(t, s), s = { type: "element", tagName: "pre", properties: {}, children: [s] }, e.patch(t, s), s;
}
function xL(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function TL(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function AL(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Hi(r.toLowerCase()), s = e.footnoteOrder.indexOf(r);
  let a, o = e.footnoteCounts.get(r);
  o === void 0 ? (o = 0, e.footnoteOrder.push(r), a = e.footnoteOrder.length) : a = s + 1, o += 1, e.footnoteCounts.set(r, o);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (o > 1 ? "-" + o : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(a) }]
  };
  e.patch(t, u);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function yL(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function NL(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function b_(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), s = i[0];
  s && s.type === "text" ? s.value = "[" + s.value : i.unshift({ type: "text", value: "[" });
  const a = i[i.length - 1];
  return a && a.type === "text" ? a.value += r : i.push({ type: "text", value: r }), i;
}
function vL(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return b_(e, t);
  const i = { src: Hi(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const s = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, s), e.applyData(t, s);
}
function wL(e, t) {
  const n = { src: Hi(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function CL(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function SL(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return b_(e, t);
  const i = { href: Hi(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const s = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, s), e.applyData(t, s);
}
function kL(e, t) {
  const n = { href: Hi(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function IL(e, t, n) {
  const r = e.all(t), i = n ? DL(n) : E_(t), s = {}, a = [];
  if (typeof t.checked == "boolean") {
    const l = r[0];
    let d;
    l && l.type === "element" && l.tagName === "p" ? d = l : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), s.className = ["task-list-item"];
  }
  let o = -1;
  for (; ++o < r.length; ) {
    const l = r[o];
    (i || o !== 0 || l.type !== "element" || l.tagName !== "p") && a.push({ type: "text", value: `
` }), l.type === "element" && l.tagName === "p" && !i ? a.push(...l.children) : a.push(l);
  }
  const u = r[r.length - 1];
  u && (i || u.type !== "element" || u.tagName !== "p") && a.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: s, children: a };
  return e.patch(t, c), e.applyData(t, c);
}
function DL(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = E_(n[r]);
  }
  return t;
}
function E_(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function RL(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const a = r[i];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const s = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, s), e.applyData(t, s);
}
function PL(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function OL(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function LL(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ML(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], a), i.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, o = On(t.children[1]), u = su(t.children[t.children.length - 1]);
    o && u && (a.position = { start: o, end: u }), i.push(a);
  }
  const s = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, s), e.applyData(t, s);
}
function UL(e, t, n) {
  const r = n ? n.children : void 0, s = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, o = a ? a.length : t.children.length;
  let u = -1;
  const c = [];
  for (; ++u < o; ) {
    const d = t.children[u], h = {}, m = a ? a[u] : void 0;
    m && (h.align = m);
    let E = { type: "element", tagName: s, properties: h, children: [] };
    d && (E.children = e.all(d), e.patch(d, E), E = e.applyData(d, E)), c.push(E);
  }
  const l = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, l), e.applyData(t, l);
}
function HL(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const mm = 9, pm = 32;
function jL(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const s = [];
  for (; r; )
    s.push(
      gm(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return s.push(gm(t.slice(i), i > 0, !1)), s.join("");
}
function gm(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let s = e.codePointAt(r);
    for (; s === mm || s === pm; )
      r++, s = e.codePointAt(r);
  }
  if (n) {
    let s = e.codePointAt(i - 1);
    for (; s === mm || s === pm; )
      i--, s = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function BL(e, t) {
  const n = { type: "text", value: jL(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function FL(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const zL = {
  blockquote: bL,
  break: EL,
  code: _L,
  delete: xL,
  emphasis: TL,
  footnoteReference: AL,
  heading: yL,
  html: NL,
  imageReference: vL,
  image: wL,
  inlineCode: CL,
  linkReference: SL,
  link: kL,
  listItem: IL,
  list: RL,
  paragraph: PL,
  // @ts-expect-error: root is different, but hard to type.
  root: OL,
  strong: LL,
  table: ML,
  tableCell: HL,
  tableRow: UL,
  text: BL,
  thematicBreak: FL,
  toml: Ra,
  yaml: Ra,
  definition: Ra,
  footnoteDefinition: Ra
};
function Ra() {
}
const __ = -1, uu = 0, Ts = 1, bo = 2, yd = 3, Nd = 4, vd = 5, wd = 6, x_ = 7, T_ = 8, bm = typeof self == "object" ? self : globalThis, VL = (e, t) => {
  const n = (i, s) => (e.set(s, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [s, a] = t[i];
    switch (s) {
      case uu:
      case __:
        return n(a, i);
      case Ts: {
        const o = n([], i);
        for (const u of a)
          o.push(r(u));
        return o;
      }
      case bo: {
        const o = n({}, i);
        for (const [u, c] of a)
          o[r(u)] = r(c);
        return o;
      }
      case yd:
        return n(new Date(a), i);
      case Nd: {
        const { source: o, flags: u } = a;
        return n(new RegExp(o, u), i);
      }
      case vd: {
        const o = n(/* @__PURE__ */ new Map(), i);
        for (const [u, c] of a)
          o.set(r(u), r(c));
        return o;
      }
      case wd: {
        const o = n(/* @__PURE__ */ new Set(), i);
        for (const u of a)
          o.add(r(u));
        return o;
      }
      case x_: {
        const { name: o, message: u } = a;
        return n(new bm[o](u), i);
      }
      case T_:
        return n(BigInt(a), i);
      case "BigInt":
        return n(Object(BigInt(a)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(a).buffer, a);
      case "DataView": {
        const { buffer: o } = new Uint8Array(a);
        return n(new DataView(o), a);
      }
    }
    return n(new bm[s](a), i);
  };
  return r;
}, Em = (e) => VL(/* @__PURE__ */ new Map(), e)(0), fi = "", { toString: WL } = {}, { keys: $L } = Object, os = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [uu, t];
  const n = WL.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Ts, fi];
    case "Object":
      return [bo, fi];
    case "Date":
      return [yd, fi];
    case "RegExp":
      return [Nd, fi];
    case "Map":
      return [vd, fi];
    case "Set":
      return [wd, fi];
    case "DataView":
      return [Ts, n];
  }
  return n.includes("Array") ? [Ts, n] : n.includes("Error") ? [x_, n] : [bo, n];
}, Pa = ([e, t]) => e === uu && (t === "function" || t === "symbol"), YL = (e, t, n, r) => {
  const i = (a, o) => {
    const u = r.push(a) - 1;
    return n.set(o, u), u;
  }, s = (a) => {
    if (n.has(a))
      return n.get(a);
    let [o, u] = os(a);
    switch (o) {
      case uu: {
        let l = a;
        switch (u) {
          case "bigint":
            o = T_, l = a.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            l = null;
            break;
          case "undefined":
            return i([__], a);
        }
        return i([o, l], a);
      }
      case Ts: {
        if (u) {
          let h = a;
          return u === "DataView" ? h = new Uint8Array(a.buffer) : u === "ArrayBuffer" && (h = new Uint8Array(a)), i([u, [...h]], a);
        }
        const l = [], d = i([o, l], a);
        for (const h of a)
          l.push(s(h));
        return d;
      }
      case bo: {
        if (u)
          switch (u) {
            case "BigInt":
              return i([u, a.toString()], a);
            case "Boolean":
            case "Number":
            case "String":
              return i([u, a.valueOf()], a);
          }
        if (t && "toJSON" in a)
          return s(a.toJSON());
        const l = [], d = i([o, l], a);
        for (const h of $L(a))
          (e || !Pa(os(a[h]))) && l.push([s(h), s(a[h])]);
        return d;
      }
      case yd:
        return i([o, a.toISOString()], a);
      case Nd: {
        const { source: l, flags: d } = a;
        return i([o, { source: l, flags: d }], a);
      }
      case vd: {
        const l = [], d = i([o, l], a);
        for (const [h, m] of a)
          (e || !(Pa(os(h)) || Pa(os(m)))) && l.push([s(h), s(m)]);
        return d;
      }
      case wd: {
        const l = [], d = i([o, l], a);
        for (const h of a)
          (e || !Pa(os(h))) && l.push(s(h));
        return d;
      }
    }
    const { message: c } = a;
    return i([o, { name: u, message: c }], a);
  };
  return s;
}, _m = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return YL(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, ki = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? Em(_m(e, t)) : structuredClone(e)
) : (e, t) => Em(_m(e, t));
function GL(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function qL(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function KL(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || GL, r = e.options.footnoteBackLabel || qL, i = e.options.footnoteLabel || "Footnotes", s = e.options.footnoteLabelTagName || "h2", a = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, o = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!c)
      continue;
    const l = e.all(c), d = String(c.identifier).toUpperCase(), h = Hi(d.toLowerCase());
    let m = 0;
    const E = [], g = e.footnoteCounts.get(d);
    for (; g !== void 0 && ++m <= g; ) {
      E.length > 0 && E.push({ type: "text", value: " " });
      let A = typeof n == "string" ? n : n(u, m);
      typeof A == "string" && (A = { type: "text", value: A }), E.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + h + (m > 1 ? "-" + m : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(u, m),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(A) ? A : [A]
      });
    }
    const T = l[l.length - 1];
    if (T && T.type === "element" && T.tagName === "p") {
      const A = T.children[T.children.length - 1];
      A && A.type === "text" ? A.value += " " : T.children.push({ type: "text", value: " " }), T.children.push(...E);
    } else
      l.push(...E);
    const _ = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + h },
      children: e.wrap(l, !0)
    };
    e.patch(c, _), o.push(_);
  }
  if (o.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: s,
          properties: {
            ...ki(a),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(o, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const cu = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return ZL;
    if (typeof e == "function")
      return lu(e);
    if (typeof e == "object")
      return Array.isArray(e) ? QL(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        XL(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return JL(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function QL(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = cu(e[n]);
  return lu(r);
  function r(...i) {
    let s = -1;
    for (; ++s < t.length; )
      if (t[s].apply(this, i)) return !0;
    return !1;
  }
}
function XL(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return lu(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let s;
    for (s in e)
      if (i[s] !== t[s]) return !1;
    return !0;
  }
}
function JL(e) {
  return lu(t);
  function t(n) {
    return n && n.type === e;
  }
}
function lu(e) {
  return t;
  function t(n, r, i) {
    return !!(eM(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function ZL() {
  return !0;
}
function eM(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const A_ = [], tM = !0, tl = !1, nM = "skip";
function y_(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const s = cu(i), a = r ? -1 : 1;
  o(e, void 0, [])();
  function o(u, c, l) {
    const d = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof d.type == "string") {
      const m = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (u.type + (m ? "<" + m + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let m = A_, E, g, T;
      if ((!t || s(u, c, l[l.length - 1] || void 0)) && (m = rM(n(u, l)), m[0] === tl))
        return m;
      if ("children" in u && u.children) {
        const _ = (
          /** @type {UnistParent} */
          u
        );
        if (_.children && m[0] !== nM)
          for (g = (r ? _.children.length : -1) + a, T = l.concat(_); g > -1 && g < _.children.length; ) {
            const A = _.children[g];
            if (E = o(A, g, T)(), E[0] === tl)
              return E;
            g = typeof E[1] == "number" ? E[1] : g + a;
          }
      }
      return m;
    }
  }
}
function rM(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [tM, e] : e == null ? A_ : [e];
}
function du(e, t, n, r) {
  let i, s, a;
  typeof t == "function" && typeof n != "function" ? (s = void 0, a = t, i = n) : (s = t, a = n, i = r), y_(e, s, o, i);
  function o(u, c) {
    const l = c[c.length - 1], d = l ? l.children.indexOf(u) : void 0;
    return a(u, d, l);
  }
}
const nl = {}.hasOwnProperty, iM = {};
function sM(e, t) {
  const n = t || iM, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), a = { ...zL, ...n.handlers }, o = {
    all: c,
    applyData: oM,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: s,
    footnoteOrder: [],
    handlers: a,
    one: u,
    options: n,
    patch: aM,
    wrap: cM
  };
  return du(e, function(l) {
    if (l.type === "definition" || l.type === "footnoteDefinition") {
      const d = l.type === "definition" ? r : i, h = String(l.identifier).toUpperCase();
      d.has(h) || d.set(h, l);
    }
  }), o;
  function u(l, d) {
    const h = l.type, m = o.handlers[h];
    if (nl.call(o.handlers, h) && m)
      return m(o, l, d);
    if (o.options.passThrough && o.options.passThrough.includes(h)) {
      if ("children" in l) {
        const { children: g, ...T } = l, _ = ki(T);
        return _.children = o.all(l), _;
      }
      return ki(l);
    }
    return (o.options.unknownHandler || uM)(o, l, d);
  }
  function c(l) {
    const d = [];
    if ("children" in l) {
      const h = l.children;
      let m = -1;
      for (; ++m < h.length; ) {
        const E = o.one(h[m], l);
        if (E) {
          if (m && h[m - 1].type === "break" && (!Array.isArray(E) && E.type === "text" && (E.value = xm(E.value)), !Array.isArray(E) && E.type === "element")) {
            const g = E.children[0];
            g && g.type === "text" && (g.value = xm(g.value));
          }
          Array.isArray(E) ? d.push(...E) : d.push(E);
        }
      }
    }
    return d;
  }
}
function aM(e, t) {
  e.position && (t.position = W3(e));
}
function oM(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, s = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const a = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: a };
      }
    n.type === "element" && s && Object.assign(n.properties, ki(s)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function uM(e, t) {
  const n = t.data || {}, r = "value" in t && !(nl.call(n, "hProperties") || nl.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function cM(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function xm(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function Tm(e, t) {
  const n = sM(e, t), r = n.one(e, void 0), i = KL(n), s = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && (L("children" in s), s.children.push({ type: "text", value: `
` }, i)), s;
}
function lM(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      Tm(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      Tm(n, { file: r, ...e || t })
    );
  };
}
function Am(e) {
  if (e)
    throw e;
}
var nc, ym;
function dM() {
  if (ym) return nc;
  ym = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, i = function(c) {
    return typeof Array.isArray == "function" ? Array.isArray(c) : t.call(c) === "[object Array]";
  }, s = function(c) {
    if (!c || t.call(c) !== "[object Object]")
      return !1;
    var l = e.call(c, "constructor"), d = c.constructor && c.constructor.prototype && e.call(c.constructor.prototype, "isPrototypeOf");
    if (c.constructor && !l && !d)
      return !1;
    var h;
    for (h in c)
      ;
    return typeof h > "u" || e.call(c, h);
  }, a = function(c, l) {
    n && l.name === "__proto__" ? n(c, l.name, {
      enumerable: !0,
      configurable: !0,
      value: l.newValue,
      writable: !0
    }) : c[l.name] = l.newValue;
  }, o = function(c, l) {
    if (l === "__proto__")
      if (e.call(c, l)) {
        if (r)
          return r(c, l).value;
      } else return;
    return c[l];
  };
  return nc = function u() {
    var c, l, d, h, m, E, g = arguments[0], T = 1, _ = arguments.length, A = !1;
    for (typeof g == "boolean" && (A = g, g = arguments[1] || {}, T = 2), (g == null || typeof g != "object" && typeof g != "function") && (g = {}); T < _; ++T)
      if (c = arguments[T], c != null)
        for (l in c)
          d = o(g, l), h = o(c, l), g !== h && (A && h && (s(h) || (m = i(h))) ? (m ? (m = !1, E = d && i(d) ? d : []) : E = d && s(d) ? d : {}, a(g, { name: l, newValue: u(A, E, h) })) : typeof h < "u" && a(g, { name: l, newValue: h }));
    return g;
  }, nc;
}
var fM = dM();
const rc = /* @__PURE__ */ pr(fM);
function rl(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function hM() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let s = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    o(null, ...i);
    function o(u, ...c) {
      const l = e[++s];
      let d = -1;
      if (u) {
        a(u);
        return;
      }
      for (; ++d < i.length; )
        (c[d] === null || c[d] === void 0) && (c[d] = i[d]);
      i = c, l ? mM(l, o)(...c) : a(null, ...c);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function mM(e, t) {
  let n;
  return r;
  function r(...a) {
    const o = e.length > a.length;
    let u;
    o && a.push(i);
    try {
      u = e.apply(this, a);
    } catch (c) {
      const l = (
        /** @type {Error} */
        c
      );
      if (o && n)
        throw l;
      return i(l);
    }
    o || (u && u.then && typeof u.then == "function" ? u.then(s, i) : u instanceof Error ? i(u) : s(u));
  }
  function i(a, ...o) {
    n || (n = !0, t(a, ...o));
  }
  function s(a) {
    i(null, a);
  }
}
const yn = { basename: pM, dirname: gM, extname: bM, join: EM, sep: "/" };
function pM(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  ea(e);
  let n = 0, r = -1, i = e.length, s;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (s) {
          n = i + 1;
          break;
        }
      } else r < 0 && (s = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, o = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (s) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (s = !0, a = i + 1), o > -1 && (e.codePointAt(i) === t.codePointAt(o--) ? o < 0 && (r = i) : (o = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function gM(e) {
  if (ea(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function bM(e) {
  ea(e);
  let t = e.length, n = -1, r = 0, i = -1, s = 0, a;
  for (; t--; ) {
    const o = e.codePointAt(t);
    if (o === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), o === 46 ? i < 0 ? i = t : s !== 1 && (s = 1) : i > -1 && (s = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  s === 0 || // The (right-most) trimmed path component is exactly `..`.
  s === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function EM(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    ea(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : _M(n);
}
function _M(e) {
  ea(e);
  const t = e.codePointAt(0) === 47;
  let n = xM(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function xM(e, t) {
  let n = "", r = 0, i = -1, s = 0, a = -1, o, u;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      o = e.codePointAt(a);
    else {
      if (o === 47)
        break;
      o = 47;
    }
    if (o === 47) {
      if (!(i === a - 1 || s === 1)) if (i !== a - 1 && s === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), i = a, s = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = a, s = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), r = a - i - 1;
      i = a, s = 0;
    } else o === 46 && s > -1 ? s++ : s = -1;
  }
  return n;
}
function ea(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const TM = { cwd: AM };
function AM() {
  return "/";
}
function il(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function yM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!il(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return NM(e);
}
function NM(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const ic = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class N_ {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? il(t) ? n = { path: t } : typeof t == "string" || vM(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : TM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < ic.length; ) {
      const s = ic[r];
      s in n && n[s] !== void 0 && n[s] !== null && (this[s] = s === "history" ? [...n[s]] : n[s]);
    }
    let i;
    for (i in n)
      ic.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? yn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    ac(t, "basename"), sc(t, "basename"), this.path = yn.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? yn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Nm(this.basename, "dirname"), this.path = yn.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? yn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (sc(t, "extname"), Nm(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = yn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    il(t) && (t = yM(t)), ac(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? yn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    ac(t, "stem"), sc(t, "stem"), this.path = yn.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Lt(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function sc(e, t) {
  if (e && e.includes(yn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + yn.sep + "`"
    );
}
function ac(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Nm(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function vM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const wM = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], s = function() {
      return i.apply(s, arguments);
    };
    return Object.setPrototypeOf(s, r), s;
  })
), CM = {}.hasOwnProperty;
class Cd extends wM {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = hM();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Cd()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(rc(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (cc("data", this.frozen), this.namespace[t] = n, this) : CM.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (cc("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Oa(t), r = this.parser || this.Parser;
    return oc("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), oc("process", this.parser || this.Parser), uc("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(s, a) {
      const o = Oa(t), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(o)
      );
      r.run(u, o, function(l, d, h) {
        if (l || !d || !h)
          return c(l);
        const m = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), E = r.stringify(m, h);
        IM(E) ? h.value = E : h.result = E, c(
          l,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function c(l, d) {
        l || !d ? a(l) : s ? s(d) : (L(n, "`done` is defined if `resolve` is not"), n(void 0, d));
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), oc("processSync", this.parser || this.Parser), uc("processSync", this.compiler || this.Compiler), this.process(t, i), wm("processSync", "process", n), L(r, "we either bailed on an error or have a tree"), r;
    function i(s, a) {
      n = !0, Am(s), r = a;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    vm(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? s(void 0, r) : new Promise(s);
    function s(a, o) {
      L(
        typeof n != "function",
        "`file` can’t be a `done` anymore, we checked"
      );
      const u = Oa(n);
      i.run(t, u, c);
      function c(l, d, h) {
        const m = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || t
        );
        l ? o(l) : a ? a(m) : (L(r, "`done` is defined if `resolve` is not"), r(void 0, m, h));
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, s), wm("runSync", "run", r), L(i, "we either bailed on an error or have a tree"), i;
    function s(a, o) {
      Am(a), i = o, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = Oa(n), i = this.compiler || this.Compiler;
    return uc("stringify", i), vm(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (cc("use", this.frozen), t != null) if (typeof t == "function")
      u(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? o(t) : a(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function s(c) {
      if (typeof c == "function")
        u(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [l, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          u(l, d);
        } else
          a(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function a(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      o(c.plugins), c.settings && (i.settings = rc(!0, i.settings, c.settings));
    }
    function o(c) {
      let l = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++l < c.length; ) {
          const d = c[l];
          s(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function u(c, l) {
      let d = -1, h = -1;
      for (; ++d < r.length; )
        if (r[d][0] === c) {
          h = d;
          break;
        }
      if (h === -1)
        r.push([c, ...l]);
      else if (l.length > 0) {
        let [m, ...E] = l;
        const g = r[h][1];
        rl(g) && rl(m) && (m = rc(!0, g, m)), r[h] = [c, m, ...E];
      }
    }
  }
}
const SM = new Cd().freeze();
function oc(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function uc(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function cc(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function vm(e) {
  if (!rl(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function wm(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Oa(e) {
  return kM(e) ? e : new N_(e);
}
function kM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function IM(e) {
  return typeof e == "string" || DM(e);
}
function DM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const RM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Cm = [], Sm = { allowDangerousHtml: !0 }, PM = /^(https?|ircs?|mailto|xmpp)$/i, OM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function v_(e) {
  const t = LM(e), n = MM(e);
  return UM(t.runSync(t.parse(n), n), e);
}
function LM(e) {
  const t = e.rehypePlugins || Cm, n = e.remarkPlugins || Cm, r = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Sm } : Sm;
  return SM().use(gL).use(n).use(lM, r).use(t);
}
function MM(e) {
  const t = e.children || "", n = new N_();
  return typeof t == "string" ? n.value = t : Kc(
    "Unexpected value `" + t + "` for `children` prop, expected `string`"
  ), n;
}
function UM(e, t) {
  const n = t.allowedElements, r = t.allowElement, i = t.components, s = t.disallowedElements, a = t.skipHtml, o = t.unwrapDisallowed, u = t.urlTransform || HM;
  for (const l of OM)
    Object.hasOwn(t, l.from) && Kc(
      "Unexpected `" + l.from + "` prop, " + (l.to ? "use `" + l.to + "` instead" : "remove it") + " (see <" + RM + "#" + l.id + "> for more info)"
    );
  return n && s && Kc(
    "Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other"
  ), du(e, c), K3(e, {
    Fragment: S.Fragment,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: S.jsx,
    jsxs: S.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function c(l, d, h) {
    if (l.type === "raw" && h && typeof d == "number")
      return a ? h.children.splice(d, 1) : h.children[d] = { type: "text", value: l.value }, d;
    if (l.type === "element") {
      let m;
      for (m in Xu)
        if (Object.hasOwn(Xu, m) && Object.hasOwn(l.properties, m)) {
          const E = l.properties[m], g = Xu[m];
          (g === null || g.includes(l.tagName)) && (l.properties[m] = u(String(E || ""), m, l));
        }
    }
    if (l.type === "element") {
      let m = n ? !n.includes(l.tagName) : s ? s.includes(l.tagName) : !1;
      if (!m && r && typeof d == "number" && (m = !r(l, d, h)), m && h && typeof d == "number")
        return o && l.children ? h.children.splice(d, 1, ...l.children) : h.children.splice(d, 1), d;
    }
  }
}
function HM(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && t > i || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    PM.test(e.slice(0, t)) ? e : ""
  );
}
const jM = (e, t) => typeof e == "string" ? e === t : JSON.stringify(e) === JSON.stringify(t), BM = (e, t) => {
  if (!e || !t)
    return !1;
  const n = (r) => {
    const { position: i, data: s, ...a } = r || {};
    return a;
  };
  return JSON.stringify(n(e.properties)) === JSON.stringify(n(t.properties)) && jM(e.children, t.children);
}, Sd = (e, t) => BM(e.node, t.node), FM = (e = {}) => Object.fromEntries(Object.entries(e ?? {}).map(([t, n]) => {
  if (!n)
    return [t, n];
  const r = n;
  return [t, Ce(({ node: s, ...a }) => S.jsx(r, { ...a }), Sd)];
})), kd = Ot(null), w_ = () => Ct(kd) !== null, zM = ({ children: e, ...t }) => S.jsx(kd.Provider, { value: t, children: e }), VM = Ce(zM, Sd), WM = ({ node: e, ...t }) => S.jsx("pre", { ...t }), $M = ({ node: e, ...t }) => S.jsx("code", { ...t }), Id = ({ node: e, components: { Pre: t, Code: n }, code: r }) => S.jsx(t, { children: S.jsx(n, { node: e, children: r }) }), YM = () => null, GM = ({ node: e, components: { Pre: t, Code: n, SyntaxHighlighter: r, CodeHeader: i }, language: s, code: a }) => {
  const o = pe(() => ({ Pre: t, Code: n }), [t, n]), u = s ? r : Id;
  return S.jsxs(S.Fragment, { children: [S.jsx(i, { node: e, language: s, code: a }), S.jsx(u, { node: e, components: o, language: s ?? "unknown", code: a })] });
};
var lc = { exports: {} };
var km;
function qM() {
  return km || (km = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var s = "", a = 0; a < arguments.length; a++) {
          var o = arguments[a];
          o && (s = i(s, r(o)));
        }
        return s;
      }
      function r(s) {
        if (typeof s == "string" || typeof s == "number")
          return s;
        if (typeof s != "object")
          return "";
        if (Array.isArray(s))
          return n.apply(null, s);
        if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
          return s.toString();
        var a = "";
        for (var o in s)
          t.call(s, o) && s[o] && (a = i(a, o));
        return a;
      }
      function i(s, a) {
        return a ? s ? s + " " + a : s + a : s;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  })(lc)), lc.exports;
}
var KM = qM();
const C_ = /* @__PURE__ */ pr(KM), Im = ({ className: e, ...t }) => ({ className: n, ...r }) => ({
  className: C_(e, n),
  ...t,
  ...r
}), QM = ({ node: e, components: { Pre: t, Code: n, SyntaxHighlighter: r, CodeHeader: i }, componentsByLanguage: s = {}, children: a, ...o }) => {
  const u = Ct(kd), c = Im(u), l = Zt((T) => S.jsx(t, { ...c(T) })), d = Im(o), h = Zt((T) => S.jsx(n, { ...d(T) })), m = /language-(\w+)/.exec(o.className || "")?.[1] ?? "";
  if (typeof a != "string")
    return S.jsx(Id, { node: e, components: { Pre: l, Code: h }, code: a });
  const E = s[m]?.SyntaxHighlighter ?? r, g = s[m]?.CodeHeader ?? i;
  return S.jsx(GM, { node: e, components: {
    Pre: l,
    Code: h,
    SyntaxHighlighter: E,
    CodeHeader: g
  }, language: m || "unknown", code: a });
}, XM = ({ node: e, components: t, componentsByLanguage: n, ...r }) => w_() ? S.jsx(QM, { node: e, components: t, componentsByLanguage: n, ...r }) : S.jsx(t.Code, { ...r }), JM = Ce(XM, (e, t) => e.components === t.components && e.componentsByLanguage === t.componentsByLanguage && Sd(e, t)), { useSmooth: ZM, useSmoothStatus: e6, withSmoothContextProvider: t6 } = e2, n6 = ({ components: e, componentsByLanguage: t, smooth: n = !0, preprocess: r, ...i }) => {
  const s = Db(), a = pe(() => r ? {
    ...s,
    text: r(s.text)
  } : s, [s, r]), { text: o } = ZM(a, n), { pre: u = WM, code: c = $M, SyntaxHighlighter: l = Id, CodeHeader: d = YM } = e ?? {}, h = pe(() => ({
    Pre: u,
    Code: c,
    SyntaxHighlighter: l,
    CodeHeader: d
  }), [u, c, l, d]), m = Zt((g) => S.jsx(JM, { components: h, componentsByLanguage: t, ...g })), E = pe(() => {
    const { pre: g, code: T, SyntaxHighlighter: _, CodeHeader: A, ...w } = e ?? {};
    return {
      ...w,
      pre: VM,
      code: m
    };
  }, [m, e]);
  return S.jsx(v_, { components: E, ...i, children: o });
}, S_ = ut(({ className: e, containerProps: t, containerComponent: n = "div", ...r }, i) => {
  const s = e6();
  return S.jsx(n, { "data-status": s.type, ...t, className: C_(e, t?.className), ref: i, children: S.jsx(n6, { ...r }) });
});
S_.displayName = "MarkdownTextPrimitive";
const r6 = t6(S_), Dm = /[#.]/g;
function i6(e, t) {
  const n = e || "", r = {};
  let i = 0, s, a;
  for (; i < n.length; ) {
    Dm.lastIndex = i;
    const o = Dm.exec(n), u = n.slice(i, o ? o.index : n.length);
    u && (s ? s === "#" ? r.id = u : Array.isArray(r.className) ? r.className.push(u) : r.className = [u] : a = u, i += u.length), o && (s = o[0], i++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: a || t || "div",
    properties: r,
    children: []
  };
}
function k_(e, t, n) {
  const r = n ? u6(n) : void 0;
  function i(s, a, ...o) {
    let u;
    if (s == null) {
      u = { type: "root", children: [] };
      const c = (
        /** @type {Child} */
        a
      );
      o.unshift(c);
    } else {
      u = i6(s, t);
      const c = u.tagName.toLowerCase(), l = r ? r.get(c) : void 0;
      if (u.tagName = l || c, s6(a))
        o.unshift(a);
      else
        for (const [d, h] of Object.entries(a))
          a6(e, u.properties, d, h);
    }
    for (const c of o)
      sl(u.children, c);
    return u.type === "element" && u.tagName === "template" && (u.content = { type: "root", children: u.children }, u.children = []), u;
  }
  return i;
}
function s6(e) {
  if (e === null || typeof e != "object" || Array.isArray(e))
    return !0;
  if (typeof e.type != "string") return !1;
  const t = (
    /** @type {Record<string, unknown>} */
    e
  ), n = Object.keys(e);
  for (const r of n) {
    const i = t[r];
    if (i && typeof i == "object") {
      if (!Array.isArray(i)) return !0;
      const s = (
        /** @type {ReadonlyArray<unknown>} */
        i
      );
      for (const a of s)
        if (typeof a != "number" && typeof a != "string")
          return !0;
    }
  }
  return !!("children" in e && Array.isArray(e.children));
}
function a6(e, t, n, r) {
  const i = iu(e, n);
  let s;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r)) return;
      s = r;
    } else typeof r == "boolean" ? s = r : typeof r == "string" ? i.spaceSeparated ? s = Gh(r) : i.commaSeparated ? s = zh(r) : i.commaOrSpaceSeparated ? s = Gh(zh(r).join(" ")) : s = Rm(i, i.property, r) : Array.isArray(r) ? s = [...r] : s = i.property === "style" ? o6(r) : String(r);
    if (Array.isArray(s)) {
      const a = [];
      for (const o of s)
        a.push(
          /** @type {number | string} */
          Rm(i, i.property, o)
        );
      s = a;
    }
    i.property === "className" && Array.isArray(t.className) && (s = t.className.concat(
      /** @type {Array<number | string> | number | string} */
      s
    )), t[i.property] = s;
  }
}
function sl(e, t) {
  if (t != null) if (typeof t == "number" || typeof t == "string")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (const n of t)
      sl(e, n);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? sl(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function Rm(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || Os(n) === Os(t)))
      return !0;
  }
  return n;
}
function o6(e) {
  const t = [];
  for (const [n, r] of Object.entries(e))
    t.push([n, r].join(": "));
  return t.join("; ");
}
function u6(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e)
    t.set(n.toLowerCase(), n);
  return t;
}
const c6 = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], l6 = k_(Js, "div"), d6 = k_(Tr, "g", c6);
function f6(e) {
  const t = String(e), n = [];
  return { toOffset: i, toPoint: r };
  function r(s) {
    if (typeof s == "number" && s > -1 && s <= t.length) {
      let a = 0;
      for (; ; ) {
        let o = n[a];
        if (o === void 0) {
          const u = Pm(t, n[a - 1]);
          o = u === -1 ? t.length + 1 : u + 1, n[a] = o;
        }
        if (o > s)
          return {
            line: a + 1,
            column: s - (a > 0 ? n[a - 1] : 0) + 1,
            offset: s
          };
        a++;
      }
    }
  }
  function i(s) {
    if (s && typeof s.line == "number" && typeof s.column == "number" && !Number.isNaN(s.line) && !Number.isNaN(s.column)) {
      for (; n.length < s.line; ) {
        const o = n[n.length - 1], u = Pm(t, o), c = u === -1 ? t.length + 1 : u + 1;
        if (o === c) break;
        n.push(c);
      }
      const a = (s.line > 1 ? n[s.line - 2] : 0) + s.column - 1;
      if (a < n[s.line - 1]) return a;
    }
  }
}
function Pm(e, t) {
  const n = e.indexOf("\r", t), r = e.indexOf(`
`, t);
  return r === -1 ? n : n === -1 || n + 1 === r ? r : n < r ? n : r;
}
const Mr = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, I_ = {}.hasOwnProperty, h6 = Object.prototype;
function m6(e, t) {
  const n = t || {};
  return Dd(
    {
      file: n.file || void 0,
      location: !1,
      schema: n.space === "svg" ? Tr : Js,
      verbose: n.verbose || !1
    },
    e
  );
}
function Dd(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = (
        /** @type {DefaultTreeAdapterMap['commentNode']} */
        t
      );
      return n = { type: "comment", value: r.data }, $a(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        t
      ), i = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: D_(e, t.childNodes),
        data: { quirksMode: i }
      }, e.file && e.location) {
        const s = String(e.file), a = f6(s), o = a.toPoint(0), u = a.toPoint(s.length);
        L(o, "expected `start`"), L(u, "expected `end`"), n.position = { start: o, end: u };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {DefaultTreeAdapterMap['documentType']} */
        t
      );
      return n = { type: "doctype" }, $a(e, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {DefaultTreeAdapterMap['textNode']} */
        t
      );
      return n = { type: "text", value: r.value }, $a(e, r, n), n;
    }
    // Element.
    default:
      return n = p6(
        e,
        /** @type {DefaultTreeAdapterMap['element']} */
        t
      ), n;
  }
}
function D_(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; ) {
    const i = (
      /** @type {RootContent} */
      Dd(e, t[n])
    );
    r.push(i);
  }
  return r;
}
function p6(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === Mr.svg ? Tr : Js;
  let r = -1;
  const i = {};
  for (; ++r < t.attrs.length; ) {
    const o = t.attrs[r], u = (o.prefix ? o.prefix + ":" : "") + o.name;
    I_.call(h6, u) || (i[u] = o.value);
  }
  const a = (e.schema.space === "svg" ? d6 : l6)(t.tagName, i, D_(e, t.childNodes));
  if ($a(e, t, a), a.tagName === "template") {
    const o = (
      /** @type {DefaultTreeAdapterMap['template']} */
      t
    ), u = o.sourceCodeLocation, c = u && u.startTag && pi(u.startTag), l = u && u.endTag && pi(u.endTag), d = (
      /** @type {Root} */
      Dd(e, o.content)
    );
    c && l && e.file && (d.position = { start: c.end, end: l.start }), a.content = d;
  }
  return e.schema = n, a;
}
function $a(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = g6(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function g6(e, t, n) {
  const r = pi(n);
  if (t.type === "element") {
    const i = t.children[t.children.length - 1];
    if (r && !n.endTag && i && i.position && i.position.end && (r.end = Object.assign({}, i.position.end)), e.verbose) {
      const s = {};
      let a;
      if (n.attrs)
        for (a in n.attrs)
          I_.call(n.attrs, a) && (s[iu(e.schema, a).property] = pi(
            n.attrs[a]
          ));
      L(n.startTag, "a start tag should exist");
      const o = pi(n.startTag), u = n.endTag ? pi(n.endTag) : void 0, c = { opening: o };
      u && (c.closing = u), c.properties = s, t.data = { position: c };
    }
  }
  return r;
}
function pi(e) {
  const t = Om({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = Om({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function Om(e) {
  return e.line && e.column ? e : void 0;
}
const Lm = {}.hasOwnProperty;
function R_(e, t) {
  const n = t || {};
  function r(i, ...s) {
    let a = r.invalid;
    const o = r.handlers;
    if (i && Lm.call(i, e)) {
      const u = String(i[e]);
      a = Lm.call(o, u) ? o[u] : r.unknown;
    }
    if (a)
      return a.call(this, i, ...s);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const b6 = {}, E6 = {}.hasOwnProperty, P_ = R_("type", { handlers: { root: x6, element: v6, text: y6, comment: N6, doctype: A6 } });
function _6(e, t) {
  const r = (t || b6).space;
  return P_(e, r === "svg" ? Tr : Js);
}
function x6(e, t) {
  const n = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = Rd(e.children, n, t), ji(e, n), n;
}
function T6(e, t) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = Rd(e.children, n, t), ji(e, n), n;
}
function A6(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return ji(e, t), t;
}
function y6(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    parentNode: null
  };
  return ji(e, t), t;
}
function N6(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    parentNode: null
  };
  return ji(e, t), t;
}
function v6(e, t) {
  const n = t;
  let r = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (r = Tr);
  const i = [];
  let s;
  if (e.properties) {
    for (s in e.properties)
      if (s !== "children" && E6.call(e.properties, s)) {
        const u = w6(
          r,
          s,
          e.properties[s]
        );
        u && i.push(u);
      }
  }
  const a = r.space;
  L(a);
  const o = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: i,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: Mr[a],
    childNodes: [],
    parentNode: null
  };
  return o.childNodes = Rd(e.children, o, r), ji(e, o), e.tagName === "template" && e.content && (o.content = T6(e.content, r)), o;
}
function w6(e, t, n) {
  const r = iu(e, t);
  if (n === !1 || n === null || n === void 0 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean)
    return;
  Array.isArray(n) && (n = r.commaSeparated ? zE(n) : QE(n));
  const i = {
    name: r.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const s = i.name.indexOf(":");
    s < 0 ? i.prefix = "" : (i.name = i.name.slice(s + 1), i.prefix = r.attribute.slice(0, s)), i.namespace = Mr[r.space];
  }
  return i;
}
function Rd(e, t, n) {
  let r = -1;
  const i = [];
  if (e)
    for (; ++r < e.length; ) {
      const s = P_(e[r], n);
      s.parentNode = t, i.push(s);
    }
  return i;
}
function ji(e, t) {
  const n = e.position;
  n && n.start && n.end && (L(typeof n.start.offset == "number"), L(typeof n.end.offset == "number"), t.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    endOffset: n.end.offset
  });
}
const C6 = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], S6 = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), ot = "�";
var v;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(v || (v = {}));
const Ft = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function O_(e) {
  return e >= 55296 && e <= 57343;
}
function k6(e) {
  return e >= 56320 && e <= 57343;
}
function I6(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function L_(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function M_(e) {
  return e >= 64976 && e <= 65007 || S6.has(e);
}
var q;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(q || (q = {}));
const D6 = 65536;
class R6 {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = D6, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, n) {
    const { line: r, col: i, offset: s } = this, a = i + n, o = s + n;
    return {
      code: t,
      startLine: r,
      endLine: r,
      startCol: a,
      endCol: a,
      startOffset: o,
      endOffset: o
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (k6(n))
        return this.pos++, this._addGap(), I6(t, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, v.EOF;
    return this._err(q.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, n) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, n) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (n)
      return this.html.startsWith(t, this.pos);
    for (let r = 0; r < t.length; r++)
      if ((this.html.charCodeAt(this.pos + r) | 32) !== t.charCodeAt(r))
        return !1;
    return !0;
  }
  peek(t) {
    const n = this.pos + t;
    if (n >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, v.EOF;
    const r = this.html.charCodeAt(n);
    return r === v.CARRIAGE_RETURN ? v.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, v.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === v.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, v.LINE_FEED) : t === v.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, O_(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === v.LINE_FEED || t === v.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    L_(t) ? this._err(q.controlCharacterInInputStream) : M_(t) && this._err(q.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var Fe;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(Fe || (Fe = {}));
function U_(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
}
const P6 = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), O6 = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function L6(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = O6.get(e)) !== null && t !== void 0 ? t : e;
}
var At;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(At || (At = {}));
const M6 = 32;
var sr;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(sr || (sr = {}));
function al(e) {
  return e >= At.ZERO && e <= At.NINE;
}
function U6(e) {
  return e >= At.UPPER_A && e <= At.UPPER_F || e >= At.LOWER_A && e <= At.LOWER_F;
}
function H6(e) {
  return e >= At.UPPER_A && e <= At.UPPER_Z || e >= At.LOWER_A && e <= At.LOWER_Z || al(e);
}
function j6(e) {
  return e === At.EQUALS || H6(e);
}
var xt;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(xt || (xt = {}));
var Vn;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Vn || (Vn = {}));
class B6 {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = xt.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Vn.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = xt.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case xt.EntityStart:
        return t.charCodeAt(n) === At.NUM ? (this.state = xt.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = xt.NamedEntity, this.stateNamedEntity(t, n));
      case xt.NumericStart:
        return this.stateNumericStart(t, n);
      case xt.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case xt.NumericHex:
        return this.stateNumericHex(t, n);
      case xt.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | M6) === At.LOWER_X ? (this.state = xt.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = xt.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, i) {
    if (n !== r) {
      const s = r - n;
      this.result = this.result * Math.pow(i, s) + Number.parseInt(t.substr(n, s), i), this.consumed += s;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const i = t.charCodeAt(n);
      if (al(i) || U6(i))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(i, 3);
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const i = t.charCodeAt(n);
      if (al(i))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(i, 2);
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === At.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Vn.Strict)
      return 0;
    return this.emitCodePoint(L6(this.result), this.consumed), this.errors && (t !== At.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], s = (i & sr.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const a = t.charCodeAt(n);
      if (this.treeIndex = F6(r, i, this.treeIndex + Math.max(1, s), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Vn.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        j6(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], s = (i & sr.VALUE_LENGTH) >> 14, s !== 0) {
        if (a === At.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== Vn.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: r } = this, i = (r[n] & sr.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(n === 1 ? i[t] & ~sr.VALUE_LENGTH : i[t + 1], r), n === 3 && this.emitCodePoint(i[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case xt.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Vn.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case xt.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case xt.NumericHex:
        return this.emitNumericEntity(0, 3);
      case xt.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case xt.EntityStart:
        return 0;
    }
  }
}
function F6(e, t, n, r) {
  const i = (t & sr.BRANCH_LENGTH) >> 7, s = t & sr.JUMP_TABLE;
  if (i === 0)
    return s !== 0 && r === s ? n : -1;
  if (s) {
    const u = r - s;
    return u < 0 || u >= i ? -1 : e[n + u] - 1;
  }
  let a = n, o = a + i - 1;
  for (; a <= o; ) {
    const u = a + o >>> 1, c = e[u];
    if (c < r)
      a = u + 1;
    else if (c > r)
      o = u - 1;
    else
      return e[u + i];
  }
  return -1;
}
var Z;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(Z || (Z = {}));
var jr;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(jr || (jr = {}));
var sn;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(sn || (sn = {}));
var V;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(V || (V = {}));
var f;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(f || (f = {}));
const z6 = /* @__PURE__ */ new Map([
  [V.A, f.A],
  [V.ADDRESS, f.ADDRESS],
  [V.ANNOTATION_XML, f.ANNOTATION_XML],
  [V.APPLET, f.APPLET],
  [V.AREA, f.AREA],
  [V.ARTICLE, f.ARTICLE],
  [V.ASIDE, f.ASIDE],
  [V.B, f.B],
  [V.BASE, f.BASE],
  [V.BASEFONT, f.BASEFONT],
  [V.BGSOUND, f.BGSOUND],
  [V.BIG, f.BIG],
  [V.BLOCKQUOTE, f.BLOCKQUOTE],
  [V.BODY, f.BODY],
  [V.BR, f.BR],
  [V.BUTTON, f.BUTTON],
  [V.CAPTION, f.CAPTION],
  [V.CENTER, f.CENTER],
  [V.CODE, f.CODE],
  [V.COL, f.COL],
  [V.COLGROUP, f.COLGROUP],
  [V.DD, f.DD],
  [V.DESC, f.DESC],
  [V.DETAILS, f.DETAILS],
  [V.DIALOG, f.DIALOG],
  [V.DIR, f.DIR],
  [V.DIV, f.DIV],
  [V.DL, f.DL],
  [V.DT, f.DT],
  [V.EM, f.EM],
  [V.EMBED, f.EMBED],
  [V.FIELDSET, f.FIELDSET],
  [V.FIGCAPTION, f.FIGCAPTION],
  [V.FIGURE, f.FIGURE],
  [V.FONT, f.FONT],
  [V.FOOTER, f.FOOTER],
  [V.FOREIGN_OBJECT, f.FOREIGN_OBJECT],
  [V.FORM, f.FORM],
  [V.FRAME, f.FRAME],
  [V.FRAMESET, f.FRAMESET],
  [V.H1, f.H1],
  [V.H2, f.H2],
  [V.H3, f.H3],
  [V.H4, f.H4],
  [V.H5, f.H5],
  [V.H6, f.H6],
  [V.HEAD, f.HEAD],
  [V.HEADER, f.HEADER],
  [V.HGROUP, f.HGROUP],
  [V.HR, f.HR],
  [V.HTML, f.HTML],
  [V.I, f.I],
  [V.IMG, f.IMG],
  [V.IMAGE, f.IMAGE],
  [V.INPUT, f.INPUT],
  [V.IFRAME, f.IFRAME],
  [V.KEYGEN, f.KEYGEN],
  [V.LABEL, f.LABEL],
  [V.LI, f.LI],
  [V.LINK, f.LINK],
  [V.LISTING, f.LISTING],
  [V.MAIN, f.MAIN],
  [V.MALIGNMARK, f.MALIGNMARK],
  [V.MARQUEE, f.MARQUEE],
  [V.MATH, f.MATH],
  [V.MENU, f.MENU],
  [V.META, f.META],
  [V.MGLYPH, f.MGLYPH],
  [V.MI, f.MI],
  [V.MO, f.MO],
  [V.MN, f.MN],
  [V.MS, f.MS],
  [V.MTEXT, f.MTEXT],
  [V.NAV, f.NAV],
  [V.NOBR, f.NOBR],
  [V.NOFRAMES, f.NOFRAMES],
  [V.NOEMBED, f.NOEMBED],
  [V.NOSCRIPT, f.NOSCRIPT],
  [V.OBJECT, f.OBJECT],
  [V.OL, f.OL],
  [V.OPTGROUP, f.OPTGROUP],
  [V.OPTION, f.OPTION],
  [V.P, f.P],
  [V.PARAM, f.PARAM],
  [V.PLAINTEXT, f.PLAINTEXT],
  [V.PRE, f.PRE],
  [V.RB, f.RB],
  [V.RP, f.RP],
  [V.RT, f.RT],
  [V.RTC, f.RTC],
  [V.RUBY, f.RUBY],
  [V.S, f.S],
  [V.SCRIPT, f.SCRIPT],
  [V.SEARCH, f.SEARCH],
  [V.SECTION, f.SECTION],
  [V.SELECT, f.SELECT],
  [V.SOURCE, f.SOURCE],
  [V.SMALL, f.SMALL],
  [V.SPAN, f.SPAN],
  [V.STRIKE, f.STRIKE],
  [V.STRONG, f.STRONG],
  [V.STYLE, f.STYLE],
  [V.SUB, f.SUB],
  [V.SUMMARY, f.SUMMARY],
  [V.SUP, f.SUP],
  [V.TABLE, f.TABLE],
  [V.TBODY, f.TBODY],
  [V.TEMPLATE, f.TEMPLATE],
  [V.TEXTAREA, f.TEXTAREA],
  [V.TFOOT, f.TFOOT],
  [V.TD, f.TD],
  [V.TH, f.TH],
  [V.THEAD, f.THEAD],
  [V.TITLE, f.TITLE],
  [V.TR, f.TR],
  [V.TRACK, f.TRACK],
  [V.TT, f.TT],
  [V.U, f.U],
  [V.UL, f.UL],
  [V.SVG, f.SVG],
  [V.VAR, f.VAR],
  [V.WBR, f.WBR],
  [V.XMP, f.XMP]
]);
function Bi(e) {
  var t;
  return (t = z6.get(e)) !== null && t !== void 0 ? t : f.UNKNOWN;
}
const ne = f, V6 = {
  [Z.HTML]: /* @__PURE__ */ new Set([
    ne.ADDRESS,
    ne.APPLET,
    ne.AREA,
    ne.ARTICLE,
    ne.ASIDE,
    ne.BASE,
    ne.BASEFONT,
    ne.BGSOUND,
    ne.BLOCKQUOTE,
    ne.BODY,
    ne.BR,
    ne.BUTTON,
    ne.CAPTION,
    ne.CENTER,
    ne.COL,
    ne.COLGROUP,
    ne.DD,
    ne.DETAILS,
    ne.DIR,
    ne.DIV,
    ne.DL,
    ne.DT,
    ne.EMBED,
    ne.FIELDSET,
    ne.FIGCAPTION,
    ne.FIGURE,
    ne.FOOTER,
    ne.FORM,
    ne.FRAME,
    ne.FRAMESET,
    ne.H1,
    ne.H2,
    ne.H3,
    ne.H4,
    ne.H5,
    ne.H6,
    ne.HEAD,
    ne.HEADER,
    ne.HGROUP,
    ne.HR,
    ne.HTML,
    ne.IFRAME,
    ne.IMG,
    ne.INPUT,
    ne.LI,
    ne.LINK,
    ne.LISTING,
    ne.MAIN,
    ne.MARQUEE,
    ne.MENU,
    ne.META,
    ne.NAV,
    ne.NOEMBED,
    ne.NOFRAMES,
    ne.NOSCRIPT,
    ne.OBJECT,
    ne.OL,
    ne.P,
    ne.PARAM,
    ne.PLAINTEXT,
    ne.PRE,
    ne.SCRIPT,
    ne.SECTION,
    ne.SELECT,
    ne.SOURCE,
    ne.STYLE,
    ne.SUMMARY,
    ne.TABLE,
    ne.TBODY,
    ne.TD,
    ne.TEMPLATE,
    ne.TEXTAREA,
    ne.TFOOT,
    ne.TH,
    ne.THEAD,
    ne.TITLE,
    ne.TR,
    ne.TRACK,
    ne.UL,
    ne.WBR,
    ne.XMP
  ]),
  [Z.MATHML]: /* @__PURE__ */ new Set([ne.MI, ne.MO, ne.MN, ne.MS, ne.MTEXT, ne.ANNOTATION_XML]),
  [Z.SVG]: /* @__PURE__ */ new Set([ne.TITLE, ne.FOREIGN_OBJECT, ne.DESC]),
  [Z.XLINK]: /* @__PURE__ */ new Set(),
  [Z.XML]: /* @__PURE__ */ new Set(),
  [Z.XMLNS]: /* @__PURE__ */ new Set()
}, ol = /* @__PURE__ */ new Set([ne.H1, ne.H2, ne.H3, ne.H4, ne.H5, ne.H6]);
V.STYLE, V.SCRIPT, V.XMP, V.IFRAME, V.NOEMBED, V.NOFRAMES, V.PLAINTEXT;
var I;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(I || (I = {}));
const dt = {
  DATA: I.DATA,
  RCDATA: I.RCDATA,
  RAWTEXT: I.RAWTEXT,
  SCRIPT_DATA: I.SCRIPT_DATA,
  PLAINTEXT: I.PLAINTEXT,
  CDATA_SECTION: I.CDATA_SECTION
};
function W6(e) {
  return e >= v.DIGIT_0 && e <= v.DIGIT_9;
}
function fs(e) {
  return e >= v.LATIN_CAPITAL_A && e <= v.LATIN_CAPITAL_Z;
}
function $6(e) {
  return e >= v.LATIN_SMALL_A && e <= v.LATIN_SMALL_Z;
}
function nr(e) {
  return $6(e) || fs(e);
}
function Mm(e) {
  return nr(e) || W6(e);
}
function La(e) {
  return e + 32;
}
function H_(e) {
  return e === v.SPACE || e === v.LINE_FEED || e === v.TABULATION || e === v.FORM_FEED;
}
function Um(e) {
  return H_(e) || e === v.SOLIDUS || e === v.GREATER_THAN_SIGN;
}
function Y6(e) {
  return e === v.NULL ? q.nullCharacterReference : e > 1114111 ? q.characterReferenceOutsideUnicodeRange : O_(e) ? q.surrogateCharacterReference : M_(e) ? q.noncharacterCharacterReference : L_(e) || e === v.CARRIAGE_RETURN ? q.controlCharacterReference : null;
}
class G6 {
  constructor(t, n) {
    this.options = t, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = I.DATA, this.returnState = I.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new R6(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new B6(P6, (r, i) => {
      this.preprocessor.pos = this.entityStartPos + i - 1, this._flushCodePointConsumedAsCharacterReference(r);
    }, n.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(q.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (r) => {
        this._err(q.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + r);
      },
      validateNumericCharacterReference: (r) => {
        const i = Y6(r);
        i && this._err(i, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, n = 0) {
    var r, i;
    (i = (r = this.handler).onParseError) === null || i === void 0 || i.call(r, this.preprocessor.getError(t, n));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t?.());
  }
  write(t, n, r) {
    this.active = !0, this.preprocessor.write(t, n), this._runParsingLoop(), this.paused || r?.();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let n = 0; n < t; n++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, n) {
    return this.preprocessor.startsWith(t, n) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: Fe.START_TAG,
      tagName: "",
      tagID: f.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Fe.END_TAG,
      tagName: "",
      tagID: f.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: Fe.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: Fe.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, n;
    const r = this.currentToken;
    if (U_(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const i = (t = (n = r.location).attrs) !== null && t !== void 0 ? t : n.attrs = /* @__PURE__ */ Object.create(null);
        i[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(q.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = Bi(t.tagName), t.type === Fe.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(q.endTagWithAttributes), t.selfClosing && this._err(q.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case Fe.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case Fe.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case Fe.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: Fe.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += n;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    const n = H_(t) ? Fe.WHITESPACE_CHARACTER : t === v.NULL ? Fe.NULL_CHARACTER : Fe.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(Fe.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = I.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Vn.Attribute : Vn.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === I.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === I.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === I.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case I.DATA: {
        this._stateData(t);
        break;
      }
      case I.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case I.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case I.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case I.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case I.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case I.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case I.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case I.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case I.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case I.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case I.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case I.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case I.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case I.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case I.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case I.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case I.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case I.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case I.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case I.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case I.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case I.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case I.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case I.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case I.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case I.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case I.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case I.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case I.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case I.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case I.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case I.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case I.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case I.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case I.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case I.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case I.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case I.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case I.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case I.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case I.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case I.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case I.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case I.COMMENT: {
        this._stateComment(t);
        break;
      }
      case I.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case I.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case I.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case I.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case I.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case I.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case I.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case I.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case I.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case I.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case I.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case I.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case I.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case I.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case I.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case I.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case I.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case I.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case I.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case I.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case I.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case I.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case I.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case I.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case I.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case I.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case I.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case I.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case v.LESS_THAN_SIGN: {
        this.state = I.TAG_OPEN;
        break;
      }
      case v.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case v.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case v.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case v.LESS_THAN_SIGN: {
        this.state = I.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case v.LESS_THAN_SIGN: {
        this.state = I.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case v.LESS_THAN_SIGN: {
        this.state = I.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (nr(t))
      this._createStartTagToken(), this.state = I.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case v.EXCLAMATION_MARK: {
          this.state = I.MARKUP_DECLARATION_OPEN;
          break;
        }
        case v.SOLIDUS: {
          this.state = I.END_TAG_OPEN;
          break;
        }
        case v.QUESTION_MARK: {
          this._err(q.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = I.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case v.EOF: {
          this._err(q.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(q.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = I.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (nr(t))
      this._createEndTagToken(), this.state = I.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case v.GREATER_THAN_SIGN: {
          this._err(q.missingEndTagName), this.state = I.DATA;
          break;
        }
        case v.EOF: {
          this._err(q.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(q.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = I.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED: {
        this.state = I.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case v.SOLIDUS: {
        this.state = I.SELF_CLOSING_START_TAG;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this.state = I.DATA, this.emitCurrentTagToken();
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), n.tagName += ot;
        break;
      }
      case v.EOF: {
        this._err(q.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        n.tagName += String.fromCodePoint(fs(t) ? La(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === v.SOLIDUS ? this.state = I.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = I.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    nr(t) ? (this.state = I.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = I.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const n = this.currentToken;
    switch (n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = I.BEFORE_ATTRIBUTE_NAME, !1;
      case v.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = I.SELF_CLOSING_START_TAG, !1;
      case v.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = I.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = I.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === v.SOLIDUS ? this.state = I.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = I.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    nr(t) ? (this.state = I.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = I.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = I.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case v.SOLIDUS: {
        this.state = I.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case v.EXCLAMATION_MARK: {
        this.state = I.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = I.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    nr(t) ? (this.state = I.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = I.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = I.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === v.HYPHEN_MINUS ? (this.state = I.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = I.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === v.HYPHEN_MINUS ? (this.state = I.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = I.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case v.HYPHEN_MINUS: {
        this.state = I.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case v.LESS_THAN_SIGN: {
        this.state = I.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._err(q.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case v.HYPHEN_MINUS: {
        this.state = I.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case v.LESS_THAN_SIGN: {
        this.state = I.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this.state = I.SCRIPT_DATA_ESCAPED, this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._err(q.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = I.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case v.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case v.LESS_THAN_SIGN: {
        this.state = I.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this.state = I.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this.state = I.SCRIPT_DATA_ESCAPED, this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._err(q.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = I.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === v.SOLIDUS ? this.state = I.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : nr(t) ? (this._emitChars("<"), this.state = I.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = I.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    nr(t) ? (this.state = I.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = I.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = I.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(Ft.SCRIPT, !1) && Um(this.preprocessor.peek(Ft.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < Ft.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = I.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case v.HYPHEN_MINUS: {
        this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case v.LESS_THAN_SIGN: {
        this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._err(q.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case v.HYPHEN_MINUS: {
        this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case v.LESS_THAN_SIGN: {
        this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._err(q.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case v.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case v.LESS_THAN_SIGN: {
        this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this.state = I.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(ot);
        break;
      }
      case v.EOF: {
        this._err(q.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === v.SOLIDUS ? (this.state = I.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(Ft.SCRIPT, !1) && Um(this.preprocessor.peek(Ft.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < Ft.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = I.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = I.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        break;
      case v.SOLIDUS:
      case v.GREATER_THAN_SIGN:
      case v.EOF: {
        this.state = I.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case v.EQUALS_SIGN: {
        this._err(q.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = I.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = I.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
      case v.SOLIDUS:
      case v.GREATER_THAN_SIGN:
      case v.EOF: {
        this._leaveAttrName(), this.state = I.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case v.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = I.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case v.QUOTATION_MARK:
      case v.APOSTROPHE:
      case v.LESS_THAN_SIGN: {
        this._err(q.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this.currentAttr.name += ot;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(fs(t) ? La(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        break;
      case v.SOLIDUS: {
        this.state = I.SELF_CLOSING_START_TAG;
        break;
      }
      case v.EQUALS_SIGN: {
        this.state = I.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this.state = I.DATA, this.emitCurrentTagToken();
        break;
      }
      case v.EOF: {
        this._err(q.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = I.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        break;
      case v.QUOTATION_MARK: {
        this.state = I.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case v.APOSTROPHE: {
        this.state = I.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.missingAttributeValue), this.state = I.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = I.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case v.QUOTATION_MARK: {
        this.state = I.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case v.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this.currentAttr.value += ot;
        break;
      }
      case v.EOF: {
        this._err(q.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case v.APOSTROPHE: {
        this.state = I.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case v.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this.currentAttr.value += ot;
        break;
      }
      case v.EOF: {
        this._err(q.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED: {
        this._leaveAttrValue(), this.state = I.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case v.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = I.DATA, this.emitCurrentTagToken();
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), this.currentAttr.value += ot;
        break;
      }
      case v.QUOTATION_MARK:
      case v.APOSTROPHE:
      case v.LESS_THAN_SIGN:
      case v.EQUALS_SIGN:
      case v.GRAVE_ACCENT: {
        this._err(q.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case v.EOF: {
        this._err(q.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED: {
        this._leaveAttrValue(), this.state = I.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case v.SOLIDUS: {
        this._leaveAttrValue(), this.state = I.SELF_CLOSING_START_TAG;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = I.DATA, this.emitCurrentTagToken();
        break;
      }
      case v.EOF: {
        this._err(q.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.missingWhitespaceBetweenAttributes), this.state = I.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case v.GREATER_THAN_SIGN: {
        const n = this.currentToken;
        n.selfClosing = !0, this.state = I.DATA, this.emitCurrentTagToken();
        break;
      }
      case v.EOF: {
        this._err(q.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.unexpectedSolidusInTag), this.state = I.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const n = this.currentToken;
    switch (t) {
      case v.GREATER_THAN_SIGN: {
        this.state = I.DATA, this.emitCurrentComment(n);
        break;
      }
      case v.EOF: {
        this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), n.data += ot;
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(Ft.DASH_DASH, !0) ? (this._createCommentToken(Ft.DASH_DASH.length + 1), this.state = I.COMMENT_START) : this._consumeSequenceIfMatch(Ft.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(Ft.DOCTYPE.length + 1), this.state = I.DOCTYPE) : this._consumeSequenceIfMatch(Ft.CDATA_START, !0) ? this.inForeignNode ? this.state = I.CDATA_SECTION : (this._err(q.cdataInHtmlContent), this._createCommentToken(Ft.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = I.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(q.incorrectlyOpenedComment), this._createCommentToken(2), this.state = I.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case v.HYPHEN_MINUS: {
        this.state = I.COMMENT_START_DASH;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.abruptClosingOfEmptyComment), this.state = I.DATA;
        const n = this.currentToken;
        this.emitCurrentComment(n);
        break;
      }
      default:
        this.state = I.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const n = this.currentToken;
    switch (t) {
      case v.HYPHEN_MINUS: {
        this.state = I.COMMENT_END;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.abruptClosingOfEmptyComment), this.state = I.DATA, this.emitCurrentComment(n);
        break;
      }
      case v.EOF: {
        this._err(q.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = I.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const n = this.currentToken;
    switch (t) {
      case v.HYPHEN_MINUS: {
        this.state = I.COMMENT_END_DASH;
        break;
      }
      case v.LESS_THAN_SIGN: {
        n.data += "<", this.state = I.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), n.data += ot;
        break;
      }
      case v.EOF: {
        this._err(q.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const n = this.currentToken;
    switch (t) {
      case v.EXCLAMATION_MARK: {
        n.data += "!", this.state = I.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case v.LESS_THAN_SIGN: {
        n.data += "<";
        break;
      }
      default:
        this.state = I.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === v.HYPHEN_MINUS ? this.state = I.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = I.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === v.HYPHEN_MINUS ? this.state = I.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = I.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== v.GREATER_THAN_SIGN && t !== v.EOF && this._err(q.nestedComment), this.state = I.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const n = this.currentToken;
    switch (t) {
      case v.HYPHEN_MINUS: {
        this.state = I.COMMENT_END;
        break;
      }
      case v.EOF: {
        this._err(q.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = I.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const n = this.currentToken;
    switch (t) {
      case v.GREATER_THAN_SIGN: {
        this.state = I.DATA, this.emitCurrentComment(n);
        break;
      }
      case v.EXCLAMATION_MARK: {
        this.state = I.COMMENT_END_BANG;
        break;
      }
      case v.HYPHEN_MINUS: {
        n.data += "-";
        break;
      }
      case v.EOF: {
        this._err(q.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--", this.state = I.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const n = this.currentToken;
    switch (t) {
      case v.HYPHEN_MINUS: {
        n.data += "--!", this.state = I.COMMENT_END_DASH;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.incorrectlyClosedComment), this.state = I.DATA, this.emitCurrentComment(n);
        break;
      }
      case v.EOF: {
        this._err(q.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--!", this.state = I.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED: {
        this.state = I.BEFORE_DOCTYPE_NAME;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this.state = I.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), this._createDoctypeToken(null);
        const n = this.currentToken;
        n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.missingWhitespaceBeforeDoctypeName), this.state = I.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (fs(t))
      this._createDoctypeToken(String.fromCharCode(La(t))), this.state = I.DOCTYPE_NAME;
    else
      switch (t) {
        case v.SPACE:
        case v.LINE_FEED:
        case v.TABULATION:
        case v.FORM_FEED:
          break;
        case v.NULL: {
          this._err(q.unexpectedNullCharacter), this._createDoctypeToken(ot), this.state = I.DOCTYPE_NAME;
          break;
        }
        case v.GREATER_THAN_SIGN: {
          this._err(q.missingDoctypeName), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = I.DATA;
          break;
        }
        case v.EOF: {
          this._err(q.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = I.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED: {
        this.state = I.AFTER_DOCTYPE_NAME;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this.state = I.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), n.name += ot;
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.name += String.fromCodePoint(fs(t) ? La(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        break;
      case v.GREATER_THAN_SIGN: {
        this.state = I.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(Ft.PUBLIC, !1) ? this.state = I.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(Ft.SYSTEM, !1) ? this.state = I.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(q.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = I.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED: {
        this.state = I.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case v.QUOTATION_MARK: {
        this._err(q.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = I.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case v.APOSTROPHE: {
        this._err(q.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = I.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = I.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = I.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        break;
      case v.QUOTATION_MARK: {
        n.publicId = "", this.state = I.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case v.APOSTROPHE: {
        n.publicId = "", this.state = I.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = I.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = I.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case v.QUOTATION_MARK: {
        this.state = I.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), n.publicId += ot;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = I.DATA;
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case v.APOSTROPHE: {
        this.state = I.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), n.publicId += ot;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = I.DATA;
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED: {
        this.state = I.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this.state = I.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case v.QUOTATION_MARK: {
        this._err(q.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = I.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case v.APOSTROPHE: {
        this._err(q.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = I.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = I.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        break;
      case v.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = I.DATA;
        break;
      }
      case v.QUOTATION_MARK: {
        n.systemId = "", this.state = I.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case v.APOSTROPHE: {
        n.systemId = "", this.state = I.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = I.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED: {
        this.state = I.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case v.QUOTATION_MARK: {
        this._err(q.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = I.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case v.APOSTROPHE: {
        this._err(q.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = I.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = I.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = I.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        break;
      case v.QUOTATION_MARK: {
        n.systemId = "", this.state = I.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case v.APOSTROPHE: {
        n.systemId = "", this.state = I.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = I.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = I.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case v.QUOTATION_MARK: {
        this.state = I.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), n.systemId += ot;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = I.DATA;
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case v.APOSTROPHE: {
        this.state = I.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter), n.systemId += ot;
        break;
      }
      case v.GREATER_THAN_SIGN: {
        this._err(q.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = I.DATA;
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case v.SPACE:
      case v.LINE_FEED:
      case v.TABULATION:
      case v.FORM_FEED:
        break;
      case v.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = I.DATA;
        break;
      }
      case v.EOF: {
        this._err(q.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(q.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = I.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const n = this.currentToken;
    switch (t) {
      case v.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = I.DATA;
        break;
      }
      case v.NULL: {
        this._err(q.unexpectedNullCharacter);
        break;
      }
      case v.EOF: {
        this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case v.RIGHT_SQUARE_BRACKET: {
        this.state = I.CDATA_SECTION_BRACKET;
        break;
      }
      case v.EOF: {
        this._err(q.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === v.RIGHT_SQUARE_BRACKET ? this.state = I.CDATA_SECTION_END : (this._emitChars("]"), this.state = I.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case v.GREATER_THAN_SIGN: {
        this.state = I.DATA;
        break;
      }
      case v.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = I.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(v.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && Mm(this.preprocessor.peek(1)) ? I.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    Mm(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === v.SEMICOLON && this._err(q.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const j_ = /* @__PURE__ */ new Set([f.DD, f.DT, f.LI, f.OPTGROUP, f.OPTION, f.P, f.RB, f.RP, f.RT, f.RTC]), Hm = /* @__PURE__ */ new Set([
  ...j_,
  f.CAPTION,
  f.COLGROUP,
  f.TBODY,
  f.TD,
  f.TFOOT,
  f.TH,
  f.THEAD,
  f.TR
]), Eo = /* @__PURE__ */ new Set([
  f.APPLET,
  f.CAPTION,
  f.HTML,
  f.MARQUEE,
  f.OBJECT,
  f.TABLE,
  f.TD,
  f.TEMPLATE,
  f.TH
]), q6 = /* @__PURE__ */ new Set([...Eo, f.OL, f.UL]), K6 = /* @__PURE__ */ new Set([...Eo, f.BUTTON]), jm = /* @__PURE__ */ new Set([f.ANNOTATION_XML, f.MI, f.MN, f.MO, f.MS, f.MTEXT]), Bm = /* @__PURE__ */ new Set([f.DESC, f.FOREIGN_OBJECT, f.TITLE]), Q6 = /* @__PURE__ */ new Set([f.TR, f.TEMPLATE, f.HTML]), X6 = /* @__PURE__ */ new Set([f.TBODY, f.TFOOT, f.THEAD, f.TEMPLATE, f.HTML]), J6 = /* @__PURE__ */ new Set([f.TABLE, f.TEMPLATE, f.HTML]), Z6 = /* @__PURE__ */ new Set([f.TD, f.TH]);
class e4 {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, n, r) {
    this.treeAdapter = n, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = f.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === f.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Z.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, n) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, n, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, n) {
    const r = this._indexOf(t);
    this.items[r] = n, r === this.stackTop && (this.current = n);
  }
  insertAfter(t, n, r) {
    const i = this._indexOf(t) + 1;
    this.items.splice(i, 0, n), this.tagIDs.splice(i, 0, r), this.stackTop++, i === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, i === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let n = this.stackTop + 1;
    do
      n = this.tagIDs.lastIndexOf(t, n - 1);
    while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== Z.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const n = this._indexOf(t);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(Math.max(r, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(ol, Z.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(Z6, Z.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, n) {
    for (let r = this.stackTop; r >= 0; r--)
      if (t.has(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === n)
        return r;
    return -1;
  }
  clearBackTo(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(J6, Z.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(X6, Z.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(Q6, Z.HTML);
  }
  remove(t) {
    const n = this._indexOf(t);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === f.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const n = this._indexOf(t) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === f.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      const i = this.tagIDs[r];
      switch (this.treeAdapter.getNamespaceURI(this.items[r])) {
        case Z.HTML: {
          if (i === t)
            return !0;
          if (n.has(i))
            return !1;
          break;
        }
        case Z.SVG: {
          if (Bm.has(i))
            return !1;
          break;
        }
        case Z.MATHML: {
          if (jm.has(i))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, Eo);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, q6);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, K6);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case Z.HTML: {
          if (ol.has(n))
            return !0;
          if (Eo.has(n))
            return !1;
          break;
        }
        case Z.SVG: {
          if (Bm.has(n))
            return !1;
          break;
        }
        case Z.MATHML: {
          if (jm.has(n))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Z.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case f.TABLE:
          case f.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === Z.HTML)
        switch (this.tagIDs[t]) {
          case f.TBODY:
          case f.THEAD:
          case f.TFOOT:
            return !0;
          case f.TABLE:
          case f.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Z.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case f.OPTION:
          case f.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && j_.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && Hm.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== t && Hm.has(this.currentTagId); )
      this.pop();
  }
}
const dc = 3;
var vn;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(vn || (vn = {}));
const Fm = { type: vn.Marker };
class t4 {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, n) {
    const r = [], i = n.length, s = this.treeAdapter.getTagName(t), a = this.treeAdapter.getNamespaceURI(t);
    for (let o = 0; o < this.entries.length; o++) {
      const u = this.entries[o];
      if (u.type === vn.Marker)
        break;
      const { element: c } = u;
      if (this.treeAdapter.getTagName(c) === s && this.treeAdapter.getNamespaceURI(c) === a) {
        const l = this.treeAdapter.getAttrList(c);
        l.length === i && r.push({ idx: o, attrs: l });
      }
    }
    return r;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < dc)
      return;
    const n = this.treeAdapter.getAttrList(t), r = this._getNoahArkConditionCandidates(t, n);
    if (r.length < dc)
      return;
    const i = new Map(n.map((a) => [a.name, a.value]));
    let s = 0;
    for (let a = 0; a < r.length; a++) {
      const o = r[a];
      o.attrs.every((u) => i.get(u.name) === u.value) && (s += 1, s >= dc && this.entries.splice(o.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(Fm);
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: vn.Element,
      element: t,
      token: n
    });
  }
  insertElementAfterBookmark(t, n) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {
      type: vn.Element,
      element: t,
      token: n
    });
  }
  removeEntry(t) {
    const n = this.entries.indexOf(t);
    n !== -1 && this.entries.splice(n, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(Fm);
    t === -1 ? this.entries.length = 0 : this.entries.splice(0, t + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const n = this.entries.find((r) => r.type === vn.Marker || this.treeAdapter.getTagName(r.element) === t);
    return n && n.type === vn.Element ? n : null;
  }
  getElementEntry(t) {
    return this.entries.find((n) => n.type === vn.Element && n.element === t);
  }
}
const rr = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: sn.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, n) {
    return {
      nodeName: e,
      tagName: e,
      attrs: n,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, n) {
    const r = e.childNodes.indexOf(n);
    e.childNodes.splice(r, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, n, r) {
    const i = e.childNodes.find((s) => s.nodeName === "#documentType");
    if (i)
      i.name = t, i.publicId = n, i.systemId = r;
    else {
      const s = {
        nodeName: "#documentType",
        name: t,
        publicId: n,
        systemId: r,
        parentNode: null
      };
      rr.appendChild(e, s);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const n = e.childNodes[e.childNodes.length - 1];
      if (rr.isTextNode(n)) {
        n.value += t;
        return;
      }
    }
    rr.appendChild(e, rr.createTextNode(t));
  },
  insertTextBefore(e, t, n) {
    const r = e.childNodes[e.childNodes.indexOf(n) - 1];
    r && rr.isTextNode(r) ? r.value += t : rr.insertBefore(e, rr.createTextNode(t), n);
  },
  adoptAttributes(e, t) {
    const n = new Set(e.attrs.map((r) => r.name));
    for (let r = 0; r < t.length; r++)
      n.has(t[r].name) || e.attrs.push(t[r]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
  }
}, B_ = "html", n4 = "about:legacy-compat", r4 = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", F_ = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], i4 = [
  ...F_,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], s4 = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), z_ = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], a4 = [
  ...z_,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function zm(e, t) {
  return t.some((n) => e.startsWith(n));
}
function o4(e) {
  return e.name === B_ && e.publicId === null && (e.systemId === null || e.systemId === n4);
}
function u4(e) {
  if (e.name !== B_)
    return sn.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === r4)
    return sn.QUIRKS;
  let { publicId: n } = e;
  if (n !== null) {
    if (n = n.toLowerCase(), s4.has(n))
      return sn.QUIRKS;
    let r = t === null ? i4 : F_;
    if (zm(n, r))
      return sn.QUIRKS;
    if (r = t === null ? z_ : a4, zm(n, r))
      return sn.LIMITED_QUIRKS;
  }
  return sn.NO_QUIRKS;
}
const Vm = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, c4 = "definitionurl", l4 = "definitionURL", d4 = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), f4 = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: Z.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: Z.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: Z.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: Z.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: Z.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: Z.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: Z.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: Z.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: Z.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: Z.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: Z.XMLNS }]
]), h4 = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), m4 = /* @__PURE__ */ new Set([
  f.B,
  f.BIG,
  f.BLOCKQUOTE,
  f.BODY,
  f.BR,
  f.CENTER,
  f.CODE,
  f.DD,
  f.DIV,
  f.DL,
  f.DT,
  f.EM,
  f.EMBED,
  f.H1,
  f.H2,
  f.H3,
  f.H4,
  f.H5,
  f.H6,
  f.HEAD,
  f.HR,
  f.I,
  f.IMG,
  f.LI,
  f.LISTING,
  f.MENU,
  f.META,
  f.NOBR,
  f.OL,
  f.P,
  f.PRE,
  f.RUBY,
  f.S,
  f.SMALL,
  f.SPAN,
  f.STRONG,
  f.STRIKE,
  f.SUB,
  f.SUP,
  f.TABLE,
  f.TT,
  f.U,
  f.UL,
  f.VAR
]);
function p4(e) {
  const t = e.tagID;
  return t === f.FONT && e.attrs.some(({ name: r }) => r === jr.COLOR || r === jr.SIZE || r === jr.FACE) || m4.has(t);
}
function V_(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === c4) {
      e.attrs[t].name = l4;
      break;
    }
}
function W_(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = d4.get(e.attrs[t].name);
    n != null && (e.attrs[t].name = n);
  }
}
function Pd(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = f4.get(e.attrs[t].name);
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
}
function g4(e) {
  const t = h4.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = Bi(e.tagName));
}
function b4(e, t) {
  return t === Z.MATHML && (e === f.MI || e === f.MO || e === f.MN || e === f.MS || e === f.MTEXT);
}
function E4(e, t, n) {
  if (t === Z.MATHML && e === f.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === jr.ENCODING) {
        const i = n[r].value.toLowerCase();
        return i === Vm.TEXT_HTML || i === Vm.APPLICATION_XML;
      }
  }
  return t === Z.SVG && (e === f.FOREIGN_OBJECT || e === f.DESC || e === f.TITLE);
}
function _4(e, t, n, r) {
  return (!r || r === Z.HTML) && E4(e, t, n) || (!r || r === Z.MATHML) && b4(e, t);
}
const x4 = "hidden", T4 = 8, A4 = 3;
var R;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(R || (R = {}));
const y4 = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, $_ = /* @__PURE__ */ new Set([f.TABLE, f.TBODY, f.TFOOT, f.THEAD, f.TR]), Wm = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: rr,
  onParseError: null
};
class $m {
  constructor(t, n, r = null, i = null) {
    this.fragmentContext = r, this.scriptHandler = i, this.currentToken = null, this.stopped = !1, this.insertionMode = R.INITIAL, this.originalInsertionMode = R.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...Wm,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new G6(this.options, this), this.activeFormattingElements = new t4(this.treeAdapter), this.fragmentContextID = r ? Bi(this.treeAdapter.getTagName(r)) : f.UNKNOWN, this._setContextModes(r ?? this.document, this.fragmentContextID), this.openElements = new e4(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, n) {
    const r = new this(n);
    return r.tokenizer.write(t, !0), r.document;
  }
  static getFragmentParser(t, n) {
    const r = {
      ...Wm,
      ...n
    };
    t ?? (t = r.treeAdapter.createElement(V.TEMPLATE, Z.HTML, []));
    const i = r.treeAdapter.createElement("documentmock", Z.HTML, []), s = new this(r, i, t);
    return s.fragmentContextID === f.TEMPLATE && s.tmplInsertionModeStack.unshift(R.IN_TEMPLATE), s._initTokenizerForFragmentParsing(), s._insertFakeRootElement(), s._resetInsertionMode(), s._findFormInFragmentContext(), s;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, n), n;
  }
  //Errors
  /** @internal */
  _err(t, n, r) {
    var i;
    if (!this.onParseError)
      return;
    const s = (i = t.location) !== null && i !== void 0 ? i : y4, a = {
      code: n,
      startLine: s.startLine,
      startCol: s.startCol,
      startOffset: s.startOffset,
      endLine: r ? s.startLine : s.endLine,
      endCol: r ? s.startCol : s.endCol,
      endOffset: r ? s.startOffset : s.endOffset
    };
    this.onParseError(a);
  }
  //Stack events
  /** @internal */
  onItemPush(t, n, r) {
    var i, s;
    (s = (i = this.treeAdapter).onItemPush) === null || s === void 0 || s.call(i, t), r && this.openElements.stackTop > 0 && this._setContextModes(t, n);
  }
  /** @internal */
  onItemPop(t, n) {
    var r, i;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (i = (r = this.treeAdapter).onItemPop) === null || i === void 0 || i.call(r, t, this.openElements.current), n) {
      let s, a;
      this.openElements.stackTop === 0 && this.fragmentContext ? (s = this.fragmentContext, a = this.fragmentContextID) : { current: s, currentTagId: a } = this.openElements, this._setContextModes(s, a);
    }
  }
  _setContextModes(t, n) {
    const r = t === this.document || t && this.treeAdapter.getNamespaceURI(t) === Z.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && t !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, t);
  }
  /** @protected */
  _switchToTextParsing(t, n) {
    this._insertElement(t, Z.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = R.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = R.TEXT, this.originalInsertionMode = R.IN_BODY, this.tokenizer.state = dt.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === V.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== Z.HTML))
      switch (this.fragmentContextID) {
        case f.TITLE:
        case f.TEXTAREA: {
          this.tokenizer.state = dt.RCDATA;
          break;
        }
        case f.STYLE:
        case f.XMP:
        case f.IFRAME:
        case f.NOEMBED:
        case f.NOFRAMES:
        case f.NOSCRIPT: {
          this.tokenizer.state = dt.RAWTEXT;
          break;
        }
        case f.SCRIPT: {
          this.tokenizer.state = dt.SCRIPT_DATA;
          break;
        }
        case f.PLAINTEXT: {
          this.tokenizer.state = dt.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const n = t.name || "", r = t.publicId || "", i = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, r, i), t.location) {
      const a = this.treeAdapter.getChildNodes(this.document).find((o) => this.treeAdapter.isDocumentTypeNode(o));
      a && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, n) {
    if (this.options.sourceCodeLocationInfo) {
      const r = n && {
        ...n,
        startTag: n
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, r);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r ?? this.document, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location);
  }
  /** @protected */
  _insertElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location), this.openElements.push(r, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, n) {
    const r = this.treeAdapter.createElement(t, Z.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, n);
  }
  /** @protected */
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, Z.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n, t.location), this.openElements.push(n, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(V.HTML, Z.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, f.HTML);
  }
  /** @protected */
  _appendCommentNode(t, n) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let n, r;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: n, beforeElement: r } = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(n, t.chars, r) : this.treeAdapter.insertText(n, t.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, t.chars)), !t.location)
      return;
    const i = this.treeAdapter.getChildNodes(n), s = r ? i.lastIndexOf(r) : i.length, a = i[s - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(a)) {
      const { endLine: u, endCol: c, endOffset: l } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(a, { endLine: u, endCol: c, endOffset: l });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
  }
  /** @protected */
  _adoptNodes(t, n) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  /** @protected */
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const r = n.location, i = this.treeAdapter.getTagName(t), s = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        n.type === Fe.END_TAG && i === n.tagName ? {
          endTag: { ...r },
          endLine: r.endLine,
          endCol: r.endCol,
          endOffset: r.endOffset
        } : {
          endLine: r.startLine,
          endCol: r.startCol,
          endOffset: r.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, s);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let n, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, r = this.fragmentContextID) : { current: n, currentTagId: r } = this.openElements, t.tagID === f.SVG && this.treeAdapter.getTagName(n) === V.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === Z.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === f.MGLYPH || t.tagID === f.MALIGNMARK) && r !== void 0 && !this._isIntegrationPoint(r, n, Z.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case Fe.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case Fe.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case Fe.COMMENT: {
        this.onComment(t);
        break;
      }
      case Fe.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case Fe.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case Fe.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case Fe.EOF: {
        this.onEof(t);
        break;
      }
      case Fe.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, n, r) {
    const i = this.treeAdapter.getNamespaceURI(n), s = this.treeAdapter.getAttrList(n);
    return _4(t, i, s, r);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const n = this.activeFormattingElements.entries.findIndex((i) => i.type === vn.Marker || this.openElements.contains(i.element)), r = n === -1 ? t - 1 : n - 1;
      for (let i = r; i >= 0; i--) {
        const s = this.activeFormattingElements.entries[i];
        this._insertElement(s.token, this.treeAdapter.getNamespaceURI(s.element)), s.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = R.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(f.P), this.openElements.popUntilTagNamePopped(f.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case f.TR: {
          this.insertionMode = R.IN_ROW;
          return;
        }
        case f.TBODY:
        case f.THEAD:
        case f.TFOOT: {
          this.insertionMode = R.IN_TABLE_BODY;
          return;
        }
        case f.CAPTION: {
          this.insertionMode = R.IN_CAPTION;
          return;
        }
        case f.COLGROUP: {
          this.insertionMode = R.IN_COLUMN_GROUP;
          return;
        }
        case f.TABLE: {
          this.insertionMode = R.IN_TABLE;
          return;
        }
        case f.BODY: {
          this.insertionMode = R.IN_BODY;
          return;
        }
        case f.FRAMESET: {
          this.insertionMode = R.IN_FRAMESET;
          return;
        }
        case f.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case f.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case f.HTML: {
          this.insertionMode = this.headElement ? R.AFTER_HEAD : R.BEFORE_HEAD;
          return;
        }
        case f.TD:
        case f.TH: {
          if (t > 0) {
            this.insertionMode = R.IN_CELL;
            return;
          }
          break;
        }
        case f.HEAD: {
          if (t > 0) {
            this.insertionMode = R.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = R.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const r = this.openElements.tagIDs[n];
        if (r === f.TEMPLATE)
          break;
        if (r === f.TABLE) {
          this.insertionMode = R.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = R.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return $_.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const n = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case f.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(n) === Z.HTML)
            return { parent: this.treeAdapter.getTemplateContent(n), beforeElement: null };
          break;
        }
        case f.TABLE: {
          const r = this.treeAdapter.getParentNode(n);
          return r ? { parent: r, beforeElement: n } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, n) {
    const r = this.treeAdapter.getNamespaceURI(t);
    return V6[r].has(n);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      ZU(this, t);
      return;
    }
    switch (this.insertionMode) {
      case R.INITIAL: {
        us(this, t);
        break;
      }
      case R.BEFORE_HTML: {
        As(this, t);
        break;
      }
      case R.BEFORE_HEAD: {
        ys(this, t);
        break;
      }
      case R.IN_HEAD: {
        Ns(this, t);
        break;
      }
      case R.IN_HEAD_NO_SCRIPT: {
        vs(this, t);
        break;
      }
      case R.AFTER_HEAD: {
        ws(this, t);
        break;
      }
      case R.IN_BODY:
      case R.IN_CAPTION:
      case R.IN_CELL:
      case R.IN_TEMPLATE: {
        G_(this, t);
        break;
      }
      case R.TEXT:
      case R.IN_SELECT:
      case R.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case R.IN_TABLE:
      case R.IN_TABLE_BODY:
      case R.IN_ROW: {
        fc(this, t);
        break;
      }
      case R.IN_TABLE_TEXT: {
        Z_(this, t);
        break;
      }
      case R.IN_COLUMN_GROUP: {
        _o(this, t);
        break;
      }
      case R.AFTER_BODY: {
        xo(this, t);
        break;
      }
      case R.AFTER_AFTER_BODY: {
        Ya(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      JU(this, t);
      return;
    }
    switch (this.insertionMode) {
      case R.INITIAL: {
        us(this, t);
        break;
      }
      case R.BEFORE_HTML: {
        As(this, t);
        break;
      }
      case R.BEFORE_HEAD: {
        ys(this, t);
        break;
      }
      case R.IN_HEAD: {
        Ns(this, t);
        break;
      }
      case R.IN_HEAD_NO_SCRIPT: {
        vs(this, t);
        break;
      }
      case R.AFTER_HEAD: {
        ws(this, t);
        break;
      }
      case R.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case R.IN_TABLE:
      case R.IN_TABLE_BODY:
      case R.IN_ROW: {
        fc(this, t);
        break;
      }
      case R.IN_COLUMN_GROUP: {
        _o(this, t);
        break;
      }
      case R.AFTER_BODY: {
        xo(this, t);
        break;
      }
      case R.AFTER_AFTER_BODY: {
        Ya(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      ul(this, t);
      return;
    }
    switch (this.insertionMode) {
      case R.INITIAL:
      case R.BEFORE_HTML:
      case R.BEFORE_HEAD:
      case R.IN_HEAD:
      case R.IN_HEAD_NO_SCRIPT:
      case R.AFTER_HEAD:
      case R.IN_BODY:
      case R.IN_TABLE:
      case R.IN_CAPTION:
      case R.IN_COLUMN_GROUP:
      case R.IN_TABLE_BODY:
      case R.IN_ROW:
      case R.IN_CELL:
      case R.IN_SELECT:
      case R.IN_SELECT_IN_TABLE:
      case R.IN_TEMPLATE:
      case R.IN_FRAMESET:
      case R.AFTER_FRAMESET: {
        ul(this, t);
        break;
      }
      case R.IN_TABLE_TEXT: {
        cs(this, t);
        break;
      }
      case R.AFTER_BODY: {
        I4(this, t);
        break;
      }
      case R.AFTER_AFTER_BODY:
      case R.AFTER_AFTER_FRAMESET: {
        D4(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case R.INITIAL: {
        R4(this, t);
        break;
      }
      case R.BEFORE_HEAD:
      case R.IN_HEAD:
      case R.IN_HEAD_NO_SCRIPT:
      case R.AFTER_HEAD: {
        this._err(t, q.misplacedDoctype);
        break;
      }
      case R.IN_TABLE_TEXT: {
        cs(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, q.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? e5(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case R.INITIAL: {
        us(this, t);
        break;
      }
      case R.BEFORE_HTML: {
        P4(this, t);
        break;
      }
      case R.BEFORE_HEAD: {
        L4(this, t);
        break;
      }
      case R.IN_HEAD: {
        _n(this, t);
        break;
      }
      case R.IN_HEAD_NO_SCRIPT: {
        H4(this, t);
        break;
      }
      case R.AFTER_HEAD: {
        B4(this, t);
        break;
      }
      case R.IN_BODY: {
        Mt(this, t);
        break;
      }
      case R.IN_TABLE: {
        Ii(this, t);
        break;
      }
      case R.IN_TABLE_TEXT: {
        cs(this, t);
        break;
      }
      case R.IN_CAPTION: {
        MU(this, t);
        break;
      }
      case R.IN_COLUMN_GROUP: {
        Md(this, t);
        break;
      }
      case R.IN_TABLE_BODY: {
        mu(this, t);
        break;
      }
      case R.IN_ROW: {
        pu(this, t);
        break;
      }
      case R.IN_CELL: {
        jU(this, t);
        break;
      }
      case R.IN_SELECT: {
        nx(this, t);
        break;
      }
      case R.IN_SELECT_IN_TABLE: {
        FU(this, t);
        break;
      }
      case R.IN_TEMPLATE: {
        VU(this, t);
        break;
      }
      case R.AFTER_BODY: {
        $U(this, t);
        break;
      }
      case R.IN_FRAMESET: {
        YU(this, t);
        break;
      }
      case R.AFTER_FRAMESET: {
        qU(this, t);
        break;
      }
      case R.AFTER_AFTER_BODY: {
        QU(this, t);
        break;
      }
      case R.AFTER_AFTER_FRAMESET: {
        XU(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? t5(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case R.INITIAL: {
        us(this, t);
        break;
      }
      case R.BEFORE_HTML: {
        O4(this, t);
        break;
      }
      case R.BEFORE_HEAD: {
        M4(this, t);
        break;
      }
      case R.IN_HEAD: {
        U4(this, t);
        break;
      }
      case R.IN_HEAD_NO_SCRIPT: {
        j4(this, t);
        break;
      }
      case R.AFTER_HEAD: {
        F4(this, t);
        break;
      }
      case R.IN_BODY: {
        hu(this, t);
        break;
      }
      case R.TEXT: {
        wU(this, t);
        break;
      }
      case R.IN_TABLE: {
        Ms(this, t);
        break;
      }
      case R.IN_TABLE_TEXT: {
        cs(this, t);
        break;
      }
      case R.IN_CAPTION: {
        UU(this, t);
        break;
      }
      case R.IN_COLUMN_GROUP: {
        HU(this, t);
        break;
      }
      case R.IN_TABLE_BODY: {
        cl(this, t);
        break;
      }
      case R.IN_ROW: {
        tx(this, t);
        break;
      }
      case R.IN_CELL: {
        BU(this, t);
        break;
      }
      case R.IN_SELECT: {
        rx(this, t);
        break;
      }
      case R.IN_SELECT_IN_TABLE: {
        zU(this, t);
        break;
      }
      case R.IN_TEMPLATE: {
        WU(this, t);
        break;
      }
      case R.AFTER_BODY: {
        sx(this, t);
        break;
      }
      case R.IN_FRAMESET: {
        GU(this, t);
        break;
      }
      case R.AFTER_FRAMESET: {
        KU(this, t);
        break;
      }
      case R.AFTER_AFTER_BODY: {
        Ya(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case R.INITIAL: {
        us(this, t);
        break;
      }
      case R.BEFORE_HTML: {
        As(this, t);
        break;
      }
      case R.BEFORE_HEAD: {
        ys(this, t);
        break;
      }
      case R.IN_HEAD: {
        Ns(this, t);
        break;
      }
      case R.IN_HEAD_NO_SCRIPT: {
        vs(this, t);
        break;
      }
      case R.AFTER_HEAD: {
        ws(this, t);
        break;
      }
      case R.IN_BODY:
      case R.IN_TABLE:
      case R.IN_CAPTION:
      case R.IN_COLUMN_GROUP:
      case R.IN_TABLE_BODY:
      case R.IN_ROW:
      case R.IN_CELL:
      case R.IN_SELECT:
      case R.IN_SELECT_IN_TABLE: {
        X_(this, t);
        break;
      }
      case R.TEXT: {
        CU(this, t);
        break;
      }
      case R.IN_TABLE_TEXT: {
        cs(this, t);
        break;
      }
      case R.IN_TEMPLATE: {
        ix(this, t);
        break;
      }
      case R.AFTER_BODY:
      case R.IN_FRAMESET:
      case R.AFTER_FRAMESET:
      case R.AFTER_AFTER_BODY:
      case R.AFTER_AFTER_FRAMESET: {
        Ld(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === v.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case R.IN_HEAD:
      case R.IN_HEAD_NO_SCRIPT:
      case R.AFTER_HEAD:
      case R.TEXT:
      case R.IN_COLUMN_GROUP:
      case R.IN_SELECT:
      case R.IN_SELECT_IN_TABLE:
      case R.IN_FRAMESET:
      case R.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case R.IN_BODY:
      case R.IN_CAPTION:
      case R.IN_CELL:
      case R.IN_TEMPLATE:
      case R.AFTER_BODY:
      case R.AFTER_AFTER_BODY:
      case R.AFTER_AFTER_FRAMESET: {
        Y_(this, t);
        break;
      }
      case R.IN_TABLE:
      case R.IN_TABLE_BODY:
      case R.IN_ROW: {
        fc(this, t);
        break;
      }
      case R.IN_TABLE_TEXT: {
        J_(this, t);
        break;
      }
    }
  }
}
function N4(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagID) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : Q_(e, t), n;
}
function v4(e, t) {
  let n = null, r = e.openElements.stackTop;
  for (; r >= 0; r--) {
    const i = e.openElements.items[r];
    if (i === t.element)
      break;
    e._isSpecialElement(i, e.openElements.tagIDs[r]) && (n = i);
  }
  return n || (e.openElements.shortenToLength(Math.max(r, 0)), e.activeFormattingElements.removeEntry(t)), n;
}
function w4(e, t, n) {
  let r = t, i = e.openElements.getCommonAncestor(t);
  for (let s = 0, a = i; a !== n; s++, a = i) {
    i = e.openElements.getCommonAncestor(a);
    const o = e.activeFormattingElements.getElementEntry(a), u = o && s >= A4;
    !o || u ? (u && e.activeFormattingElements.removeEntry(o), e.openElements.remove(a)) : (a = C4(e, o), r === t && (e.activeFormattingElements.bookmark = o), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(a, r), r = a);
  }
  return r;
}
function C4(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function S4(e, t, n) {
  const r = e.treeAdapter.getTagName(t), i = Bi(r);
  if (e._isElementCausesFosterParenting(i))
    e._fosterParentElement(n);
  else {
    const s = e.treeAdapter.getNamespaceURI(t);
    i === f.TEMPLATE && s === Z.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function k4(e, t, n) {
  const r = e.treeAdapter.getNamespaceURI(n.element), { token: i } = n, s = e.treeAdapter.createElement(i.tagName, r, i.attrs);
  e._adoptNodes(t, s), e.treeAdapter.appendChild(t, s), e.activeFormattingElements.insertElementAfterBookmark(s, i), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, s, i.tagID);
}
function Od(e, t) {
  for (let n = 0; n < T4; n++) {
    const r = N4(e, t);
    if (!r)
      break;
    const i = v4(e, r);
    if (!i)
      break;
    e.activeFormattingElements.bookmark = r;
    const s = w4(e, i, r.element), a = e.openElements.getCommonAncestor(r.element);
    e.treeAdapter.detachNode(s), a && S4(e, a, s), k4(e, i, r);
  }
}
function ul(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function I4(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function D4(e, t) {
  e._appendCommentNode(t, e.document);
}
function Ld(e, t) {
  if (e.stopped = !0, t.location) {
    const n = e.fragmentContext ? 0 : 2;
    for (let r = e.openElements.stackTop; r >= n; r--)
      e._setEndLocation(e.openElements.items[r], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const r = e.openElements.items[0], i = e.treeAdapter.getNodeSourceCodeLocation(r);
      if (i && !i.endTag && (e._setEndLocation(r, t), e.openElements.stackTop >= 1)) {
        const s = e.openElements.items[1], a = e.treeAdapter.getNodeSourceCodeLocation(s);
        a && !a.endTag && e._setEndLocation(s, t);
      }
    }
  }
}
function R4(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? sn.QUIRKS : u4(t);
  o4(t) || e._err(t, q.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = R.BEFORE_HTML;
}
function us(e, t) {
  e._err(t, q.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, sn.QUIRKS), e.insertionMode = R.BEFORE_HTML, e._processToken(t);
}
function P4(e, t) {
  t.tagID === f.HTML ? (e._insertElement(t, Z.HTML), e.insertionMode = R.BEFORE_HEAD) : As(e, t);
}
function O4(e, t) {
  const n = t.tagID;
  (n === f.HTML || n === f.HEAD || n === f.BODY || n === f.BR) && As(e, t);
}
function As(e, t) {
  e._insertFakeRootElement(), e.insertionMode = R.BEFORE_HEAD, e._processToken(t);
}
function L4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.HEAD: {
      e._insertElement(t, Z.HTML), e.headElement = e.openElements.current, e.insertionMode = R.IN_HEAD;
      break;
    }
    default:
      ys(e, t);
  }
}
function M4(e, t) {
  const n = t.tagID;
  n === f.HEAD || n === f.BODY || n === f.HTML || n === f.BR ? ys(e, t) : e._err(t, q.endTagWithoutMatchingOpenElement);
}
function ys(e, t) {
  e._insertFakeElement(V.HEAD, f.HEAD), e.headElement = e.openElements.current, e.insertionMode = R.IN_HEAD, e._processToken(t);
}
function _n(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META: {
      e._appendElement(t, Z.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.TITLE: {
      e._switchToTextParsing(t, dt.RCDATA);
      break;
    }
    case f.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, dt.RAWTEXT) : (e._insertElement(t, Z.HTML), e.insertionMode = R.IN_HEAD_NO_SCRIPT);
      break;
    }
    case f.NOFRAMES:
    case f.STYLE: {
      e._switchToTextParsing(t, dt.RAWTEXT);
      break;
    }
    case f.SCRIPT: {
      e._switchToTextParsing(t, dt.SCRIPT_DATA);
      break;
    }
    case f.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = R.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(R.IN_TEMPLATE);
      break;
    }
    case f.HEAD: {
      e._err(t, q.misplacedStartTagForHeadElement);
      break;
    }
    default:
      Ns(e, t);
  }
}
function U4(e, t) {
  switch (t.tagID) {
    case f.HEAD: {
      e.openElements.pop(), e.insertionMode = R.AFTER_HEAD;
      break;
    }
    case f.BODY:
    case f.BR:
    case f.HTML: {
      Ns(e, t);
      break;
    }
    case f.TEMPLATE: {
      ei(e, t);
      break;
    }
    default:
      e._err(t, q.endTagWithoutMatchingOpenElement);
  }
}
function ei(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== f.TEMPLATE && e._err(t, q.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, q.endTagWithoutMatchingOpenElement);
}
function Ns(e, t) {
  e.openElements.pop(), e.insertionMode = R.AFTER_HEAD, e._processToken(t);
}
function H4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.BASEFONT:
    case f.BGSOUND:
    case f.HEAD:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.STYLE: {
      _n(e, t);
      break;
    }
    case f.NOSCRIPT: {
      e._err(t, q.nestedNoscriptInHead);
      break;
    }
    default:
      vs(e, t);
  }
}
function j4(e, t) {
  switch (t.tagID) {
    case f.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = R.IN_HEAD;
      break;
    }
    case f.BR: {
      vs(e, t);
      break;
    }
    default:
      e._err(t, q.endTagWithoutMatchingOpenElement);
  }
}
function vs(e, t) {
  const n = t.type === Fe.EOF ? q.openElementsLeftAfterEof : q.disallowedContentInNoscriptInHead;
  e._err(t, n), e.openElements.pop(), e.insertionMode = R.IN_HEAD, e._processToken(t);
}
function B4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.BODY: {
      e._insertElement(t, Z.HTML), e.framesetOk = !1, e.insertionMode = R.IN_BODY;
      break;
    }
    case f.FRAMESET: {
      e._insertElement(t, Z.HTML), e.insertionMode = R.IN_FRAMESET;
      break;
    }
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.SCRIPT:
    case f.STYLE:
    case f.TEMPLATE:
    case f.TITLE: {
      e._err(t, q.abandonedHeadElementChild), e.openElements.push(e.headElement, f.HEAD), _n(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case f.HEAD: {
      e._err(t, q.misplacedStartTagForHeadElement);
      break;
    }
    default:
      ws(e, t);
  }
}
function F4(e, t) {
  switch (t.tagID) {
    case f.BODY:
    case f.HTML:
    case f.BR: {
      ws(e, t);
      break;
    }
    case f.TEMPLATE: {
      ei(e, t);
      break;
    }
    default:
      e._err(t, q.endTagWithoutMatchingOpenElement);
  }
}
function ws(e, t) {
  e._insertFakeElement(V.BODY, f.BODY), e.insertionMode = R.IN_BODY, fu(e, t);
}
function fu(e, t) {
  switch (t.type) {
    case Fe.CHARACTER: {
      G_(e, t);
      break;
    }
    case Fe.WHITESPACE_CHARACTER: {
      Y_(e, t);
      break;
    }
    case Fe.COMMENT: {
      ul(e, t);
      break;
    }
    case Fe.START_TAG: {
      Mt(e, t);
      break;
    }
    case Fe.END_TAG: {
      hu(e, t);
      break;
    }
    case Fe.EOF: {
      X_(e, t);
      break;
    }
  }
}
function Y_(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function G_(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function z4(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function V4(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function W4(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, Z.HTML), e.insertionMode = R.IN_FRAMESET);
}
function $4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, Z.HTML);
}
function Y4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && ol.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, Z.HTML);
}
function G4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, Z.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function q4(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, Z.HTML), n || (e.formElement = e.openElements.current));
}
function K4(e, t) {
  e.framesetOk = !1;
  const n = t.tagID;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const i = e.openElements.tagIDs[r];
    if (n === f.LI && i === f.LI || (n === f.DD || n === f.DT) && (i === f.DD || i === f.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(i), e.openElements.popUntilTagNamePopped(i);
      break;
    }
    if (i !== f.ADDRESS && i !== f.DIV && i !== f.P && e._isSpecialElement(e.openElements.items[r], i))
      break;
  }
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, Z.HTML);
}
function Q4(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, Z.HTML), e.tokenizer.state = dt.PLAINTEXT;
}
function X4(e, t) {
  e.openElements.hasInScope(f.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, Z.HTML), e.framesetOk = !1;
}
function J4(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(V.A);
  n && (Od(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, Z.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Z4(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Z.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function eU(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(f.NOBR) && (Od(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, Z.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function tU(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Z.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function nU(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== sn.QUIRKS && e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, Z.HTML), e.framesetOk = !1, e.insertionMode = R.IN_TABLE;
}
function q_(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, Z.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function K_(e) {
  const t = U_(e, jr.TYPE);
  return t != null && t.toLowerCase() === x4;
}
function rU(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, Z.HTML), K_(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function iU(e, t) {
  e._appendElement(t, Z.HTML), t.ackSelfClosing = !0;
}
function sU(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._appendElement(t, Z.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function aU(e, t) {
  t.tagName = V.IMG, t.tagID = f.IMG, q_(e, t);
}
function oU(e, t) {
  e._insertElement(t, Z.HTML), e.skipNextNewLine = !0, e.tokenizer.state = dt.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = R.TEXT;
}
function uU(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, dt.RAWTEXT);
}
function cU(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, dt.RAWTEXT);
}
function Ym(e, t) {
  e._switchToTextParsing(t, dt.RAWTEXT);
}
function lU(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Z.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === R.IN_TABLE || e.insertionMode === R.IN_CAPTION || e.insertionMode === R.IN_TABLE_BODY || e.insertionMode === R.IN_ROW || e.insertionMode === R.IN_CELL ? R.IN_SELECT_IN_TABLE : R.IN_SELECT;
}
function dU(e, t) {
  e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, Z.HTML);
}
function fU(e, t) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, Z.HTML);
}
function hU(e, t) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(f.RTC), e._insertElement(t, Z.HTML);
}
function mU(e, t) {
  e._reconstructActiveFormattingElements(), V_(t), Pd(t), t.selfClosing ? e._appendElement(t, Z.MATHML) : e._insertElement(t, Z.MATHML), t.ackSelfClosing = !0;
}
function pU(e, t) {
  e._reconstructActiveFormattingElements(), W_(t), Pd(t), t.selfClosing ? e._appendElement(t, Z.SVG) : e._insertElement(t, Z.SVG), t.ackSelfClosing = !0;
}
function Gm(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Z.HTML);
}
function Mt(e, t) {
  switch (t.tagID) {
    case f.I:
    case f.S:
    case f.B:
    case f.U:
    case f.EM:
    case f.TT:
    case f.BIG:
    case f.CODE:
    case f.FONT:
    case f.SMALL:
    case f.STRIKE:
    case f.STRONG: {
      Z4(e, t);
      break;
    }
    case f.A: {
      J4(e, t);
      break;
    }
    case f.H1:
    case f.H2:
    case f.H3:
    case f.H4:
    case f.H5:
    case f.H6: {
      Y4(e, t);
      break;
    }
    case f.P:
    case f.DL:
    case f.OL:
    case f.UL:
    case f.DIV:
    case f.DIR:
    case f.NAV:
    case f.MAIN:
    case f.MENU:
    case f.ASIDE:
    case f.CENTER:
    case f.FIGURE:
    case f.FOOTER:
    case f.HEADER:
    case f.HGROUP:
    case f.DIALOG:
    case f.DETAILS:
    case f.ADDRESS:
    case f.ARTICLE:
    case f.SEARCH:
    case f.SECTION:
    case f.SUMMARY:
    case f.FIELDSET:
    case f.BLOCKQUOTE:
    case f.FIGCAPTION: {
      $4(e, t);
      break;
    }
    case f.LI:
    case f.DD:
    case f.DT: {
      K4(e, t);
      break;
    }
    case f.BR:
    case f.IMG:
    case f.WBR:
    case f.AREA:
    case f.EMBED:
    case f.KEYGEN: {
      q_(e, t);
      break;
    }
    case f.HR: {
      sU(e, t);
      break;
    }
    case f.RB:
    case f.RTC: {
      fU(e, t);
      break;
    }
    case f.RT:
    case f.RP: {
      hU(e, t);
      break;
    }
    case f.PRE:
    case f.LISTING: {
      G4(e, t);
      break;
    }
    case f.XMP: {
      uU(e, t);
      break;
    }
    case f.SVG: {
      pU(e, t);
      break;
    }
    case f.HTML: {
      z4(e, t);
      break;
    }
    case f.BASE:
    case f.LINK:
    case f.META:
    case f.STYLE:
    case f.TITLE:
    case f.SCRIPT:
    case f.BGSOUND:
    case f.BASEFONT:
    case f.TEMPLATE: {
      _n(e, t);
      break;
    }
    case f.BODY: {
      V4(e, t);
      break;
    }
    case f.FORM: {
      q4(e, t);
      break;
    }
    case f.NOBR: {
      eU(e, t);
      break;
    }
    case f.MATH: {
      mU(e, t);
      break;
    }
    case f.TABLE: {
      nU(e, t);
      break;
    }
    case f.INPUT: {
      rU(e, t);
      break;
    }
    case f.PARAM:
    case f.TRACK:
    case f.SOURCE: {
      iU(e, t);
      break;
    }
    case f.IMAGE: {
      aU(e, t);
      break;
    }
    case f.BUTTON: {
      X4(e, t);
      break;
    }
    case f.APPLET:
    case f.OBJECT:
    case f.MARQUEE: {
      tU(e, t);
      break;
    }
    case f.IFRAME: {
      cU(e, t);
      break;
    }
    case f.SELECT: {
      lU(e, t);
      break;
    }
    case f.OPTION:
    case f.OPTGROUP: {
      dU(e, t);
      break;
    }
    case f.NOEMBED:
    case f.NOFRAMES: {
      Ym(e, t);
      break;
    }
    case f.FRAMESET: {
      W4(e, t);
      break;
    }
    case f.TEXTAREA: {
      oU(e, t);
      break;
    }
    case f.NOSCRIPT: {
      e.options.scriptingEnabled ? Ym(e, t) : Gm(e, t);
      break;
    }
    case f.PLAINTEXT: {
      Q4(e, t);
      break;
    }
    case f.COL:
    case f.TH:
    case f.TD:
    case f.TR:
    case f.HEAD:
    case f.FRAME:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.CAPTION:
    case f.COLGROUP:
      break;
    default:
      Gm(e, t);
  }
}
function gU(e, t) {
  if (e.openElements.hasInScope(f.BODY) && (e.insertionMode = R.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const n = e.openElements.tryPeekProperlyNestedBodyElement();
    n && e._setEndLocation(n, t);
  }
}
function bU(e, t) {
  e.openElements.hasInScope(f.BODY) && (e.insertionMode = R.AFTER_BODY, sx(e, t));
}
function EU(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function _U(e) {
  const t = e.openElements.tmplCount > 0, { formElement: n } = e;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(f.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(f.FORM) : n && e.openElements.remove(n));
}
function xU(e) {
  e.openElements.hasInButtonScope(f.P) || e._insertFakeElement(V.P, f.P), e._closePElement();
}
function TU(e) {
  e.openElements.hasInListItemScope(f.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(f.LI), e.openElements.popUntilTagNamePopped(f.LI));
}
function AU(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function yU(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function NU(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function vU(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(V.BR, f.BR), e.openElements.pop(), e.framesetOk = !1;
}
function Q_(e, t) {
  const n = t.tagName, r = t.tagID;
  for (let i = e.openElements.stackTop; i > 0; i--) {
    const s = e.openElements.items[i], a = e.openElements.tagIDs[i];
    if (r === a && (r !== f.UNKNOWN || e.treeAdapter.getTagName(s) === n)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.stackTop >= i && e.openElements.shortenToLength(i);
      break;
    }
    if (e._isSpecialElement(s, a))
      break;
  }
}
function hu(e, t) {
  switch (t.tagID) {
    case f.A:
    case f.B:
    case f.I:
    case f.S:
    case f.U:
    case f.EM:
    case f.TT:
    case f.BIG:
    case f.CODE:
    case f.FONT:
    case f.NOBR:
    case f.SMALL:
    case f.STRIKE:
    case f.STRONG: {
      Od(e, t);
      break;
    }
    case f.P: {
      xU(e);
      break;
    }
    case f.DL:
    case f.UL:
    case f.OL:
    case f.DIR:
    case f.DIV:
    case f.NAV:
    case f.PRE:
    case f.MAIN:
    case f.MENU:
    case f.ASIDE:
    case f.BUTTON:
    case f.CENTER:
    case f.FIGURE:
    case f.FOOTER:
    case f.HEADER:
    case f.HGROUP:
    case f.DIALOG:
    case f.ADDRESS:
    case f.ARTICLE:
    case f.DETAILS:
    case f.SEARCH:
    case f.SECTION:
    case f.SUMMARY:
    case f.LISTING:
    case f.FIELDSET:
    case f.BLOCKQUOTE:
    case f.FIGCAPTION: {
      EU(e, t);
      break;
    }
    case f.LI: {
      TU(e);
      break;
    }
    case f.DD:
    case f.DT: {
      AU(e, t);
      break;
    }
    case f.H1:
    case f.H2:
    case f.H3:
    case f.H4:
    case f.H5:
    case f.H6: {
      yU(e);
      break;
    }
    case f.BR: {
      vU(e);
      break;
    }
    case f.BODY: {
      gU(e, t);
      break;
    }
    case f.HTML: {
      bU(e, t);
      break;
    }
    case f.FORM: {
      _U(e);
      break;
    }
    case f.APPLET:
    case f.OBJECT:
    case f.MARQUEE: {
      NU(e, t);
      break;
    }
    case f.TEMPLATE: {
      ei(e, t);
      break;
    }
    default:
      Q_(e, t);
  }
}
function X_(e, t) {
  e.tmplInsertionModeStack.length > 0 ? ix(e, t) : Ld(e, t);
}
function wU(e, t) {
  var n;
  t.tagID === f.SCRIPT && ((n = e.scriptHandler) === null || n === void 0 || n.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function CU(e, t) {
  e._err(t, q.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function fc(e, t) {
  if (e.openElements.currentTagId !== void 0 && $_.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = R.IN_TABLE_TEXT, t.type) {
      case Fe.CHARACTER: {
        Z_(e, t);
        break;
      }
      case Fe.WHITESPACE_CHARACTER: {
        J_(e, t);
        break;
      }
    }
  else
    ta(e, t);
}
function SU(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, Z.HTML), e.insertionMode = R.IN_CAPTION;
}
function kU(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, Z.HTML), e.insertionMode = R.IN_COLUMN_GROUP;
}
function IU(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(V.COLGROUP, f.COLGROUP), e.insertionMode = R.IN_COLUMN_GROUP, Md(e, t);
}
function DU(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, Z.HTML), e.insertionMode = R.IN_TABLE_BODY;
}
function RU(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(V.TBODY, f.TBODY), e.insertionMode = R.IN_TABLE_BODY, mu(e, t);
}
function PU(e, t) {
  e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function OU(e, t) {
  K_(t) ? e._appendElement(t, Z.HTML) : ta(e, t), t.ackSelfClosing = !0;
}
function LU(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, Z.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function Ii(e, t) {
  switch (t.tagID) {
    case f.TD:
    case f.TH:
    case f.TR: {
      RU(e, t);
      break;
    }
    case f.STYLE:
    case f.SCRIPT:
    case f.TEMPLATE: {
      _n(e, t);
      break;
    }
    case f.COL: {
      IU(e, t);
      break;
    }
    case f.FORM: {
      LU(e, t);
      break;
    }
    case f.TABLE: {
      PU(e, t);
      break;
    }
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      DU(e, t);
      break;
    }
    case f.INPUT: {
      OU(e, t);
      break;
    }
    case f.CAPTION: {
      SU(e, t);
      break;
    }
    case f.COLGROUP: {
      kU(e, t);
      break;
    }
    default:
      ta(e, t);
  }
}
function Ms(e, t) {
  switch (t.tagID) {
    case f.TABLE: {
      e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode());
      break;
    }
    case f.TEMPLATE: {
      ei(e, t);
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TBODY:
    case f.TD:
    case f.TFOOT:
    case f.TH:
    case f.THEAD:
    case f.TR:
      break;
    default:
      ta(e, t);
  }
}
function ta(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, fu(e, t), e.fosterParentingEnabled = n;
}
function J_(e, t) {
  e.pendingCharacterTokens.push(t);
}
function Z_(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function cs(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      ta(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const ex = /* @__PURE__ */ new Set([f.CAPTION, f.COL, f.COLGROUP, f.TBODY, f.TD, f.TFOOT, f.TH, f.THEAD, f.TR]);
function MU(e, t) {
  const n = t.tagID;
  ex.has(n) ? e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = R.IN_TABLE, Ii(e, t)) : Mt(e, t);
}
function UU(e, t) {
  const n = t.tagID;
  switch (n) {
    case f.CAPTION:
    case f.TABLE: {
      e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = R.IN_TABLE, n === f.TABLE && Ms(e, t));
      break;
    }
    case f.BODY:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TBODY:
    case f.TD:
    case f.TFOOT:
    case f.TH:
    case f.THEAD:
    case f.TR:
      break;
    default:
      hu(e, t);
  }
}
function Md(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.COL: {
      e._appendElement(t, Z.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.TEMPLATE: {
      _n(e, t);
      break;
    }
    default:
      _o(e, t);
  }
}
function HU(e, t) {
  switch (t.tagID) {
    case f.COLGROUP: {
      e.openElements.currentTagId === f.COLGROUP && (e.openElements.pop(), e.insertionMode = R.IN_TABLE);
      break;
    }
    case f.TEMPLATE: {
      ei(e, t);
      break;
    }
    case f.COL:
      break;
    default:
      _o(e, t);
  }
}
function _o(e, t) {
  e.openElements.currentTagId === f.COLGROUP && (e.openElements.pop(), e.insertionMode = R.IN_TABLE, e._processToken(t));
}
function mu(e, t) {
  switch (t.tagID) {
    case f.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, Z.HTML), e.insertionMode = R.IN_ROW;
      break;
    }
    case f.TH:
    case f.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(V.TR, f.TR), e.insertionMode = R.IN_ROW, pu(e, t);
      break;
    }
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = R.IN_TABLE, Ii(e, t));
      break;
    }
    default:
      Ii(e, t);
  }
}
function cl(e, t) {
  const n = t.tagID;
  switch (t.tagID) {
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = R.IN_TABLE);
      break;
    }
    case f.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = R.IN_TABLE, Ms(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TD:
    case f.TH:
    case f.TR:
      break;
    default:
      Ms(e, t);
  }
}
function pu(e, t) {
  switch (t.tagID) {
    case f.TH:
    case f.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, Z.HTML), e.insertionMode = R.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.TR: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = R.IN_TABLE_BODY, mu(e, t));
      break;
    }
    default:
      Ii(e, t);
  }
}
function tx(e, t) {
  switch (t.tagID) {
    case f.TR: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = R.IN_TABLE_BODY);
      break;
    }
    case f.TABLE: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = R.IN_TABLE_BODY, cl(e, t));
      break;
    }
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(f.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = R.IN_TABLE_BODY, cl(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TD:
    case f.TH:
      break;
    default:
      Ms(e, t);
  }
}
function jU(e, t) {
  const n = t.tagID;
  ex.has(n) ? (e.openElements.hasInTableScope(f.TD) || e.openElements.hasInTableScope(f.TH)) && (e._closeTableCell(), pu(e, t)) : Mt(e, t);
}
function BU(e, t) {
  const n = t.tagID;
  switch (n) {
    case f.TD:
    case f.TH: {
      e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = R.IN_ROW);
      break;
    }
    case f.TABLE:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.TR: {
      e.openElements.hasInTableScope(n) && (e._closeTableCell(), tx(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
      break;
    default:
      hu(e, t);
  }
}
function nx(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.OPTION: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e._insertElement(t, Z.HTML);
      break;
    }
    case f.OPTGROUP: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop(), e._insertElement(t, Z.HTML);
      break;
    }
    case f.HR: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop(), e._appendElement(t, Z.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.INPUT:
    case f.KEYGEN:
    case f.TEXTAREA:
    case f.SELECT: {
      e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), t.tagID !== f.SELECT && e._processStartTag(t));
      break;
    }
    case f.SCRIPT:
    case f.TEMPLATE: {
      _n(e, t);
      break;
    }
  }
}
function rx(e, t) {
  switch (t.tagID) {
    case f.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === f.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === f.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop();
      break;
    }
    case f.OPTION: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop();
      break;
    }
    case f.SELECT: {
      e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode());
      break;
    }
    case f.TEMPLATE: {
      ei(e, t);
      break;
    }
  }
}
function FU(e, t) {
  const n = t.tagID;
  n === f.CAPTION || n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR || n === f.TD || n === f.TH ? (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : nx(e, t);
}
function zU(e, t) {
  const n = t.tagID;
  n === f.CAPTION || n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR || n === f.TD || n === f.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : rx(e, t);
}
function VU(e, t) {
  switch (t.tagID) {
    // First, handle tags that can start without a mode change
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.SCRIPT:
    case f.STYLE:
    case f.TEMPLATE:
    case f.TITLE: {
      _n(e, t);
      break;
    }
    // Re-process the token in the appropriate mode
    case f.CAPTION:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.tmplInsertionModeStack[0] = R.IN_TABLE, e.insertionMode = R.IN_TABLE, Ii(e, t);
      break;
    }
    case f.COL: {
      e.tmplInsertionModeStack[0] = R.IN_COLUMN_GROUP, e.insertionMode = R.IN_COLUMN_GROUP, Md(e, t);
      break;
    }
    case f.TR: {
      e.tmplInsertionModeStack[0] = R.IN_TABLE_BODY, e.insertionMode = R.IN_TABLE_BODY, mu(e, t);
      break;
    }
    case f.TD:
    case f.TH: {
      e.tmplInsertionModeStack[0] = R.IN_ROW, e.insertionMode = R.IN_ROW, pu(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = R.IN_BODY, e.insertionMode = R.IN_BODY, Mt(e, t);
  }
}
function WU(e, t) {
  t.tagID === f.TEMPLATE && ei(e, t);
}
function ix(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : Ld(e, t);
}
function $U(e, t) {
  t.tagID === f.HTML ? Mt(e, t) : xo(e, t);
}
function sx(e, t) {
  var n;
  if (t.tagID === f.HTML) {
    if (e.fragmentContext || (e.insertionMode = R.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === f.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const r = e.openElements.items[1];
      r && !(!((n = e.treeAdapter.getNodeSourceCodeLocation(r)) === null || n === void 0) && n.endTag) && e._setEndLocation(r, t);
    }
  } else
    xo(e, t);
}
function xo(e, t) {
  e.insertionMode = R.IN_BODY, fu(e, t);
}
function YU(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.FRAMESET: {
      e._insertElement(t, Z.HTML);
      break;
    }
    case f.FRAME: {
      e._appendElement(t, Z.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.NOFRAMES: {
      _n(e, t);
      break;
    }
  }
}
function GU(e, t) {
  t.tagID === f.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== f.FRAMESET && (e.insertionMode = R.AFTER_FRAMESET));
}
function qU(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.NOFRAMES: {
      _n(e, t);
      break;
    }
  }
}
function KU(e, t) {
  t.tagID === f.HTML && (e.insertionMode = R.AFTER_AFTER_FRAMESET);
}
function QU(e, t) {
  t.tagID === f.HTML ? Mt(e, t) : Ya(e, t);
}
function Ya(e, t) {
  e.insertionMode = R.IN_BODY, fu(e, t);
}
function XU(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      Mt(e, t);
      break;
    }
    case f.NOFRAMES: {
      _n(e, t);
      break;
    }
  }
}
function JU(e, t) {
  t.chars = ot, e._insertCharacters(t);
}
function ZU(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function ax(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== Z.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function e5(e, t) {
  if (p4(t))
    ax(e), e._startTagOutsideForeignContent(t);
  else {
    const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
    r === Z.MATHML ? V_(t) : r === Z.SVG && (g4(t), W_(t)), Pd(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function t5(e, t) {
  if (t.tagID === f.P || t.tagID === f.BR) {
    ax(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const r = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(r) === Z.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const i = e.treeAdapter.getTagName(r);
    if (i.toLowerCase() === t.tagName) {
      t.tagName = i, e.openElements.shortenToLength(n);
      break;
    }
  }
}
V.AREA, V.BASE, V.BASEFONT, V.BGSOUND, V.BR, V.COL, V.EMBED, V.FRAME, V.HR, V.IMG, V.INPUT, V.KEYGEN, V.LINK, V.META, V.PARAM, V.SOURCE, V.TRACK, V.WBR;
const n5 = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, r5 = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), qm = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function ox(e, t) {
  const n = h5(e), r = R_("type", {
    handlers: { root: i5, element: s5, text: a5, comment: cx, doctype: o5, raw: c5 },
    unknown: l5
  }), i = {
    parser: n ? new $m(qm) : $m.getFragmentParser(void 0, qm),
    handle(o) {
      r(o, i);
    },
    stitches: !1,
    options: t || {}
  };
  r(e, i), Fi(i, On());
  const s = n ? i.parser.document : i.parser.getFragment(), a = m6(s, {
    // To do: support `space`?
    file: i.options.file
  });
  return i.stitches && du(a, "comment", function(o, u, c) {
    const l = (
      /** @type {Stitch} */
      /** @type {unknown} */
      o
    );
    if (l.value.stitch && c && u !== void 0) {
      const d = c.children;
      return d[u] = l.value.stitch, u;
    }
  }), a.type === "root" && a.children.length === 1 && a.children[0].type === e.type ? a.children[0] : a;
}
function ux(e, t) {
  let n = -1;
  if (e)
    for (; ++n < e.length; )
      t.handle(e[n]);
}
function i5(e, t) {
  ux(e.children, t);
}
function s5(e, t) {
  d5(e, t), ux(e.children, t), f5(e, t);
}
function a5(e, t) {
  t.parser.tokenizer.state > 4 && (t.parser.tokenizer.state = 0);
  const n = {
    type: Fe.CHARACTER,
    chars: e.value,
    location: na(e)
  };
  Fi(t, On(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function o5(e, t) {
  const n = {
    type: Fe.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: na(e)
  };
  Fi(t, On(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function u5(e, t) {
  t.stitches = !0;
  const n = m5(e);
  if ("children" in e && "children" in n) {
    const r = (
      /** @type {Root} */
      ox({ type: "root", children: e.children }, t.options)
    );
    n.children = r.children;
  }
  cx({ type: "comment", value: { stitch: n } }, t);
}
function cx(e, t) {
  const n = e.value, r = {
    type: Fe.COMMENT,
    data: n,
    location: na(e)
  };
  Fi(t, On(e)), t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken);
}
function c5(e, t) {
  if (t.parser.tokenizer.preprocessor.html = "", t.parser.tokenizer.preprocessor.pos = -1, t.parser.tokenizer.preprocessor.lastGapPos = -2, t.parser.tokenizer.preprocessor.gapStack = [], t.parser.tokenizer.preprocessor.skipNextNewLine = !1, t.parser.tokenizer.preprocessor.lastChunkWritten = !1, t.parser.tokenizer.preprocessor.endOfChunkHit = !1, t.parser.tokenizer.preprocessor.isEol = !1, lx(t, On(e)), t.parser.tokenizer.write(
    t.options.tagfilter ? e.value.replace(n5, "&lt;$1$2") : e.value,
    !1
  ), t.parser.tokenizer._runParsingLoop(), t.parser.tokenizer.state === 72 || // @ts-expect-error: removed.
  t.parser.tokenizer.state === 78) {
    t.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const n = t.parser.tokenizer._consume();
    t.parser.tokenizer._callState(n);
  }
}
function l5(e, t) {
  const n = (
    /** @type {Nodes} */
    e
  );
  if (t.options.passThrough && t.options.passThrough.includes(n.type))
    u5(n, t);
  else {
    let r = "";
    throw r5.has(n.type) && (r = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + n.type + "` node" + r);
  }
}
function Fi(e, t) {
  lx(e, t);
  const n = e.parser.tokenizer.currentCharacterToken;
  n && n.location && (n.location.endLine = e.parser.tokenizer.preprocessor.line, n.location.endCol = e.parser.tokenizer.preprocessor.col + 1, n.location.endOffset = e.parser.tokenizer.preprocessor.offset + 1, e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken)), e.parser.tokenizer.paused = !1, e.parser.tokenizer.inLoop = !1, e.parser.tokenizer.active = !1, e.parser.tokenizer.returnState = dt.DATA, e.parser.tokenizer.charRefCode = -1, e.parser.tokenizer.consumedAfterSnapshot = -1, e.parser.tokenizer.currentLocation = null, e.parser.tokenizer.currentCharacterToken = null, e.parser.tokenizer.currentToken = null, e.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function lx(e, t) {
  if (t && t.offset !== void 0) {
    const n = {
      startLine: t.line,
      startCol: t.column,
      startOffset: t.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    e.parser.tokenizer.preprocessor.lineStartPos = -t.column + 1, e.parser.tokenizer.preprocessor.droppedBufferSize = t.offset, e.parser.tokenizer.preprocessor.line = t.line, e.parser.tokenizer.currentLocation = n;
  }
}
function d5(e, t) {
  const n = e.tagName.toLowerCase();
  if (t.parser.tokenizer.state === dt.PLAINTEXT) return;
  Fi(t, On(e));
  const r = t.parser.openElements.current;
  let i = "namespaceURI" in r ? r.namespaceURI : Mr.html;
  i === Mr.html && n === "svg" && (i = Mr.svg);
  const s = _6(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...e, children: [] },
    { space: i === Mr.svg ? "svg" : "html" }
  ), a = {
    type: Fe.START_TAG,
    tagName: n,
    tagID: Bi(n),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in s ? s.attrs : [],
    location: na(e)
  };
  t.parser.currentToken = a, t.parser._processToken(t.parser.currentToken), t.parser.tokenizer.lastStartTagName = n;
}
function f5(e, t) {
  const n = e.tagName.toLowerCase();
  if (!t.parser.tokenizer.inForeignNode && C6.includes(n) || t.parser.tokenizer.state === dt.PLAINTEXT) return;
  Fi(t, su(e));
  const r = {
    type: Fe.END_TAG,
    tagName: n,
    tagID: Bi(n),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: na(e)
  };
  t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken), // Current element is closed.
  n === t.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (t.parser.tokenizer.state === dt.RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  t.parser.tokenizer.state === dt.RAWTEXT || // `<script>`
  t.parser.tokenizer.state === dt.SCRIPT_DATA) && (t.parser.tokenizer.state = dt.DATA);
}
function h5(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName.toLowerCase() === "html"));
}
function na(e) {
  const t = On(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, n = su(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function m5(e) {
  return "children" in e ? ki({ ...e, children: [] }) : ki(e);
}
function dx(e) {
  return function(t, n) {
    return (
      /** @type {Root} */
      ox(t, { ...e, file: n })
    );
  };
}
function Km(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function p5(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function g5(e, t, n) {
  const i = cu((n || {}).ignore || []), s = b5(t);
  let a = -1;
  for (; ++a < s.length; )
    y_(e, "text", o);
  function o(c, l) {
    let d = -1, h;
    for (; ++d < l.length; ) {
      const m = l[d], E = h ? h.children : void 0;
      if (i(
        m,
        E ? E.indexOf(m) : void 0,
        h
      ))
        return;
      h = m;
    }
    if (h)
      return u(c, l);
  }
  function u(c, l) {
    const d = l[l.length - 1], h = s[a][0], m = s[a][1];
    let E = 0;
    const T = d.children.indexOf(c);
    let _ = !1, A = [];
    h.lastIndex = 0;
    let w = h.exec(c.value);
    for (; w; ) {
      const M = w.index, F = {
        index: w.index,
        input: w.input,
        stack: [...l, c]
      };
      let k = m(...w, F);
      if (typeof k == "string" && (k = k.length > 0 ? { type: "text", value: k } : void 0), k === !1 ? h.lastIndex = M + 1 : (E !== M && A.push({
        type: "text",
        value: c.value.slice(E, M)
      }), Array.isArray(k) ? A.push(...k) : k && A.push(k), E = M + w[0].length, _ = !0), !h.global)
        break;
      w = h.exec(c.value);
    }
    return _ ? (E < c.value.length && A.push({ type: "text", value: c.value.slice(E) }), d.children.splice(T, 1, ...A)) : A = [c], T + A.length;
  }
}
function b5(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    t.push([E5(i[0]), _5(i[1])]);
  }
  return t;
}
function E5(e) {
  return typeof e == "string" ? new RegExp(p5(e), "g") : e;
}
function _5(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const hc = "phrasing", mc = ["autolink", "link", "image", "label"];
function x5() {
  return {
    transforms: [C5],
    enter: {
      literalAutolink: A5,
      literalAutolinkEmail: pc,
      literalAutolinkHttp: pc,
      literalAutolinkWww: pc
    },
    exit: {
      literalAutolink: w5,
      literalAutolinkEmail: v5,
      literalAutolinkHttp: y5,
      literalAutolinkWww: N5
    }
  };
}
function T5() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: hc,
        notInConstruct: mc
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: hc,
        notInConstruct: mc
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: hc,
        notInConstruct: mc
      }
    ]
  };
}
function A5(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function pc(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function y5(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function N5(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  L(t.type === "link"), t.url = "http://" + this.sliceSerialize(e);
}
function v5(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function w5(e) {
  this.exit(e);
}
function C5(e) {
  g5(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, S5],
      [/(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu, k5]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function S5(e, t, n, r, i) {
  let s = "";
  if (!fx(i) || (/^w/i.test(t) && (n = t + n, t = "", s = "http://"), !I5(n)))
    return !1;
  const a = D5(n + r);
  if (!a[0]) return !1;
  const o = {
    type: "link",
    title: null,
    url: s + t + a[0],
    children: [{ type: "text", value: t + a[0] }]
  };
  return a[1] ? [o, { type: "text", value: a[1] }] : o;
}
function k5(e, t, n, r) {
  return (
    // Not an expected previous character.
    !fx(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function I5(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function D5(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const i = Km(e, "(");
  let s = Km(e, ")");
  for (; r !== -1 && i > s; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), s++;
  return [e, n];
}
function fx(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Gr(n) || au(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
hx.peek = B5;
function R5() {
  this.buffer();
}
function P5(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function O5() {
  this.buffer();
}
function L5(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function M5(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  L(n.type === "footnoteReference"), n.identifier = hn(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function U5(e) {
  this.exit(e);
}
function H5(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  L(n.type === "footnoteDefinition"), n.identifier = hn(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function j5(e) {
  this.exit(e);
}
function B5() {
  return "[";
}
function hx(e, t, n, r) {
  const i = n.createTracker(r);
  let s = i.move("[^");
  const a = n.enter("footnoteReference"), o = n.enter("reference");
  return s += i.move(
    n.safe(n.associationId(e), { after: "]", before: s })
  ), o(), a(), s += i.move("]"), s;
}
function F5() {
  return {
    enter: {
      gfmFootnoteCallString: R5,
      gfmFootnoteCall: P5,
      gfmFootnoteDefinitionLabelString: O5,
      gfmFootnoteDefinition: L5
    },
    exit: {
      gfmFootnoteCallString: M5,
      gfmFootnoteCall: U5,
      gfmFootnoteDefinitionLabelString: H5,
      gfmFootnoteDefinition: j5
    }
  };
}
function z5(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: n, footnoteReference: hx },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function n(r, i, s, a) {
    const o = s.createTracker(a);
    let u = o.move("[^");
    const c = s.enter("footnoteDefinition"), l = s.enter("label");
    return u += o.move(
      s.safe(s.associationId(r), { before: u, after: "]" })
    ), l(), u += o.move("]:"), r.children && r.children.length > 0 && (o.shift(4), u += o.move(
      (t ? `
` : " ") + s.indentLines(
        s.containerFlow(r, o.current()),
        t ? mx : V5
      )
    )), c(), u;
  }
}
function V5(e, t, n) {
  return t === 0 ? e : mx(e, t, n);
}
function mx(e, t, n) {
  return (n ? "" : "    ") + e;
}
const W5 = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
px.peek = K5;
function $5() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: G5 },
    exit: { strikethrough: q5 }
  };
}
function Y5() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: W5
      }
    ],
    handlers: { delete: px }
  };
}
function G5(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function q5(e) {
  this.exit(e);
}
function px(e, t, n, r) {
  const i = n.createTracker(r), s = n.enter("strikethrough");
  let a = i.move("~~");
  return a += n.containerPhrasing(e, {
    ...i.current(),
    before: a,
    after: "~"
  }), a += i.move("~~"), s(), a;
}
function K5() {
  return "~";
}
function Q5(e) {
  return e.length;
}
function X5(e, t) {
  const n = t || {}, r = (n.align || []).concat(), i = n.stringLength || Q5, s = [], a = [], o = [], u = [];
  let c = 0, l = -1;
  for (; ++l < e.length; ) {
    const g = [], T = [];
    let _ = -1;
    for (e[l].length > c && (c = e[l].length); ++_ < e[l].length; ) {
      const A = J5(e[l][_]);
      if (n.alignDelimiters !== !1) {
        const w = i(A);
        T[_] = w, (u[_] === void 0 || w > u[_]) && (u[_] = w);
      }
      g.push(A);
    }
    a[l] = g, o[l] = T;
  }
  let d = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++d < c; )
      s[d] = Qm(r[d]);
  else {
    const g = Qm(r);
    for (; ++d < c; )
      s[d] = g;
  }
  d = -1;
  const h = [], m = [];
  for (; ++d < c; ) {
    const g = s[d];
    let T = "", _ = "";
    g === 99 ? (T = ":", _ = ":") : g === 108 ? T = ":" : g === 114 && (_ = ":");
    let A = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      u[d] - T.length - _.length
    );
    const w = T + "-".repeat(A) + _;
    n.alignDelimiters !== !1 && (A = T.length + A + _.length, A > u[d] && (u[d] = A), m[d] = A), h[d] = w;
  }
  a.splice(1, 0, h), o.splice(1, 0, m), l = -1;
  const E = [];
  for (; ++l < a.length; ) {
    const g = a[l], T = o[l];
    d = -1;
    const _ = [];
    for (; ++d < c; ) {
      const A = g[d] || "";
      let w = "", M = "";
      if (n.alignDelimiters !== !1) {
        const F = u[d] - (T[d] || 0), k = s[d];
        k === 114 ? w = " ".repeat(F) : k === 99 ? F % 2 ? (w = " ".repeat(F / 2 + 0.5), M = " ".repeat(F / 2 - 0.5)) : (w = " ".repeat(F / 2), M = w) : M = " ".repeat(F);
      }
      n.delimiterStart !== !1 && !d && _.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && A === "") && (n.delimiterStart !== !1 || d) && _.push(" "), n.alignDelimiters !== !1 && _.push(w), _.push(A), n.alignDelimiters !== !1 && _.push(M), n.padding !== !1 && _.push(" "), (n.delimiterEnd !== !1 || d !== c - 1) && _.push("|");
    }
    E.push(
      n.delimiterEnd === !1 ? _.join("").replace(/ +$/, "") : _.join("")
    );
  }
  return E.join(`
`);
}
function J5(e) {
  return e == null ? "" : String(e);
}
function Qm(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function Z5(e, t, n, r) {
  const i = n.enter("blockquote"), s = n.createTracker(r);
  s.move("> "), s.shift(2);
  const a = n.indentLines(
    n.containerFlow(e, s.current()),
    e8
  );
  return i(), a;
}
function e8(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function t8(e, t) {
  return Xm(e, t.inConstruct, !0) && !Xm(e, t.notInConstruct, !1);
}
function Xm(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function Jm(e, t, n, r) {
  let i = -1;
  for (; ++i < n.unsafe.length; )
    if (n.unsafe[i].character === `
` && t8(n.stack, n.unsafe[i]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function n8(e, t) {
  const n = String(e);
  let r = n.indexOf(t), i = r, s = 0, a = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === i ? ++s > a && (a = s) : s = 1, i = r + t.length, r = n.indexOf(t, i);
  return a;
}
function r8(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function i8(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function s8(e, t, n, r) {
  const i = i8(n), s = e.value || "", a = i === "`" ? "GraveAccent" : "Tilde";
  if (r8(e, n)) {
    const d = n.enter("codeIndented"), h = n.indentLines(s, a8);
    return d(), h;
  }
  const o = n.createTracker(r), u = i.repeat(Math.max(n8(s, i) + 1, 3)), c = n.enter("codeFenced");
  let l = o.move(u);
  if (e.lang) {
    const d = n.enter(`codeFencedLang${a}`);
    l += o.move(
      n.safe(e.lang, {
        before: l,
        after: " ",
        encode: ["`"],
        ...o.current()
      })
    ), d();
  }
  if (e.lang && e.meta) {
    const d = n.enter(`codeFencedMeta${a}`);
    l += o.move(" "), l += o.move(
      n.safe(e.meta, {
        before: l,
        after: `
`,
        encode: ["`"],
        ...o.current()
      })
    ), d();
  }
  return l += o.move(`
`), s && (l += o.move(s + `
`)), l += o.move(u), c(), l;
}
function a8(e, t, n) {
  return (n ? "" : "    ") + e;
}
function Ud(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function o8(e, t, n, r) {
  const i = Ud(n), s = i === '"' ? "Quote" : "Apostrophe", a = n.enter("definition");
  let o = n.enter("label");
  const u = n.createTracker(r);
  let c = u.move("[");
  return c += u.move(
    n.safe(n.associationId(e), {
      before: c,
      after: "]",
      ...u.current()
    })
  ), c += u.move("]: "), o(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (o = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), o(), e.title && (o = n.enter(`title${s}`), c += u.move(" " + i), c += u.move(
    n.safe(e.title, {
      before: c,
      after: i,
      ...u.current()
    })
  ), c += u.move(i), o()), a(), c;
}
function u8(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function Us(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function To(e, t, n) {
  const r = Si(e), i = Si(t);
  return r === void 0 ? i === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    n === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : r === 1 ? i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
gx.peek = c8;
function gx(e, t, n, r) {
  const i = u8(n), s = n.enter("emphasis"), a = n.createTracker(r), o = a.move(i);
  let u = a.move(
    n.containerPhrasing(e, {
      after: i,
      before: o,
      ...a.current()
    })
  );
  const c = u.charCodeAt(0), l = To(
    r.before.charCodeAt(r.before.length - 1),
    c,
    i
  );
  l.inside && (u = Us(c) + u.slice(1));
  const d = u.charCodeAt(u.length - 1), h = To(r.after.charCodeAt(0), d, i);
  h.inside && (u = u.slice(0, -1) + Us(d));
  const m = a.move(i);
  return s(), n.attentionEncodeSurroundingInfo = {
    after: h.outside,
    before: l.outside
  }, o + u + m;
}
function c8(e, t, n) {
  return n.options.emphasis || "*";
}
function l8(e, t) {
  let n = !1;
  return du(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, tl;
  }), !!((!e.depth || e.depth < 3) && xd(e) && (t.options.setext || n));
}
function d8(e, t, n, r) {
  const i = Math.max(Math.min(6, e.depth || 1), 1), s = n.createTracker(r);
  if (l8(e, n)) {
    const l = n.enter("headingSetext"), d = n.enter("phrasing"), h = n.containerPhrasing(e, {
      ...s.current(),
      before: `
`,
      after: `
`
    });
    return d(), l(), h + `
` + (i === 1 ? "=" : "-").repeat(
      // The whole size…
      h.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(h.lastIndexOf("\r"), h.lastIndexOf(`
`)) + 1)
    );
  }
  const a = "#".repeat(i), o = n.enter("headingAtx"), u = n.enter("phrasing");
  s.move(a + " ");
  let c = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...s.current()
  });
  return /^[\t ]/.test(c) && (c = Us(c.charCodeAt(0)) + c.slice(1)), c = c ? a + " " + c : a, n.options.closeAtx && (c += " " + a), u(), o(), c;
}
bx.peek = f8;
function bx(e) {
  return e.value || "";
}
function f8() {
  return "<";
}
Ex.peek = h8;
function Ex(e, t, n, r) {
  const i = Ud(n), s = i === '"' ? "Quote" : "Apostrophe", a = n.enter("image");
  let o = n.enter("label");
  const u = n.createTracker(r);
  let c = u.move("![");
  return c += u.move(
    n.safe(e.alt, { before: c, after: "]", ...u.current() })
  ), c += u.move("]("), o(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (o = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), o(), e.title && (o = n.enter(`title${s}`), c += u.move(" " + i), c += u.move(
    n.safe(e.title, {
      before: c,
      after: i,
      ...u.current()
    })
  ), c += u.move(i), o()), c += u.move(")"), a(), c;
}
function h8() {
  return "!";
}
_x.peek = m8;
function _x(e, t, n, r) {
  const i = e.referenceType, s = n.enter("imageReference");
  let a = n.enter("label");
  const o = n.createTracker(r);
  let u = o.move("![");
  const c = n.safe(e.alt, {
    before: u,
    after: "]",
    ...o.current()
  });
  u += o.move(c + "]["), a();
  const l = n.stack;
  n.stack = [], a = n.enter("reference");
  const d = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...o.current()
  });
  return a(), n.stack = l, s(), i === "full" || !c || c !== d ? u += o.move(d + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += o.move("]"), u;
}
function m8() {
  return "!";
}
xx.peek = p8;
function xx(e, t, n) {
  let r = e.value || "", i = "`", s = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++s < n.unsafe.length; ) {
    const a = n.unsafe[s], o = n.compilePattern(a);
    let u;
    if (a.atBreak)
      for (; u = o.exec(r); ) {
        let c = u.index;
        r.charCodeAt(c) === 10 && r.charCodeAt(c - 1) === 13 && c--, r = r.slice(0, c) + " " + r.slice(u.index + 1);
      }
  }
  return i + r + i;
}
function p8() {
  return "`";
}
function Tx(e, t) {
  const n = xd(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
Ax.peek = g8;
function Ax(e, t, n, r) {
  const i = Ud(n), s = i === '"' ? "Quote" : "Apostrophe", a = n.createTracker(r);
  let o, u;
  if (Tx(e, n)) {
    const l = n.stack;
    n.stack = [], o = n.enter("autolink");
    let d = a.move("<");
    return d += a.move(
      n.containerPhrasing(e, {
        before: d,
        after: ">",
        ...a.current()
      })
    ), d += a.move(">"), o(), n.stack = l, d;
  }
  o = n.enter("link"), u = n.enter("label");
  let c = a.move("[");
  return c += a.move(
    n.containerPhrasing(e, {
      before: c,
      after: "](",
      ...a.current()
    })
  ), c += a.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = n.enter("destinationLiteral"), c += a.move("<"), c += a.move(
    n.safe(e.url, { before: c, after: ">", ...a.current() })
  ), c += a.move(">")) : (u = n.enter("destinationRaw"), c += a.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...a.current()
    })
  )), u(), e.title && (u = n.enter(`title${s}`), c += a.move(" " + i), c += a.move(
    n.safe(e.title, {
      before: c,
      after: i,
      ...a.current()
    })
  ), c += a.move(i), u()), c += a.move(")"), o(), c;
}
function g8(e, t, n) {
  return Tx(e, n) ? "<" : "[";
}
yx.peek = b8;
function yx(e, t, n, r) {
  const i = e.referenceType, s = n.enter("linkReference");
  let a = n.enter("label");
  const o = n.createTracker(r);
  let u = o.move("[");
  const c = n.containerPhrasing(e, {
    before: u,
    after: "]",
    ...o.current()
  });
  u += o.move(c + "]["), a();
  const l = n.stack;
  n.stack = [], a = n.enter("reference");
  const d = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...o.current()
  });
  return a(), n.stack = l, s(), i === "full" || !c || c !== d ? u += o.move(d + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += o.move("]"), u;
}
function b8() {
  return "[";
}
function Hd(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function E8(e) {
  const t = Hd(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function _8(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function Nx(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function x8(e, t, n, r) {
  const i = n.enter("list"), s = n.bulletCurrent;
  let a = e.ordered ? _8(n) : Hd(n);
  const o = e.ordered ? a === "." ? ")" : "." : E8(n);
  let u = t && n.bulletLastUsed ? a === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const l = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (a === "*" || a === "-") && // Empty first list item:
      l && (!l.children || !l.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), Nx(n) === a && l
    ) {
      let d = -1;
      for (; ++d < e.children.length; ) {
        const h = e.children[d];
        if (h && h.type === "listItem" && h.children && h.children[0] && h.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (a = o), n.bulletCurrent = a;
  const c = n.containerFlow(e, r);
  return n.bulletLastUsed = a, n.bulletCurrent = s, i(), c;
}
function T8(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function A8(e, t, n, r) {
  const i = T8(n);
  let s = n.bulletCurrent || Hd(n);
  t && t.type === "list" && t.ordered && (s = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + s);
  let a = s.length + 1;
  (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (a = Math.ceil(a / 4) * 4);
  const o = n.createTracker(r);
  o.move(s + " ".repeat(a - s.length)), o.shift(a);
  const u = n.enter("listItem"), c = n.indentLines(
    n.containerFlow(e, o.current()),
    l
  );
  return u(), c;
  function l(d, h, m) {
    return h ? (m ? "" : " ".repeat(a)) + d : (m ? s : s + " ".repeat(a - s.length)) + d;
  }
}
function y8(e, t, n, r) {
  const i = n.enter("paragraph"), s = n.enter("phrasing"), a = n.containerPhrasing(e, r);
  return s(), i(), a;
}
const N8 = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  cu([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function v8(e, t, n, r) {
  return (e.children.some(function(a) {
    return N8(a);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function w8(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
vx.peek = C8;
function vx(e, t, n, r) {
  const i = w8(n), s = n.enter("strong"), a = n.createTracker(r), o = a.move(i + i);
  let u = a.move(
    n.containerPhrasing(e, {
      after: i,
      before: o,
      ...a.current()
    })
  );
  const c = u.charCodeAt(0), l = To(
    r.before.charCodeAt(r.before.length - 1),
    c,
    i
  );
  l.inside && (u = Us(c) + u.slice(1));
  const d = u.charCodeAt(u.length - 1), h = To(r.after.charCodeAt(0), d, i);
  h.inside && (u = u.slice(0, -1) + Us(d));
  const m = a.move(i + i);
  return s(), n.attentionEncodeSurroundingInfo = {
    after: h.outside,
    before: l.outside
  }, o + u + m;
}
function C8(e, t, n) {
  return n.options.strong || "*";
}
function S8(e, t, n, r) {
  return n.safe(e.value, r);
}
function k8(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function I8(e, t, n) {
  const r = (Nx(n) + (n.options.ruleSpaces ? " " : "")).repeat(k8(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const wx = {
  blockquote: Z5,
  break: Jm,
  code: s8,
  definition: o8,
  emphasis: gx,
  hardBreak: Jm,
  heading: d8,
  html: bx,
  image: Ex,
  imageReference: _x,
  inlineCode: xx,
  link: Ax,
  linkReference: yx,
  list: x8,
  listItem: A8,
  paragraph: y8,
  root: v8,
  strong: vx,
  text: S8,
  thematicBreak: I8
};
function D8() {
  return {
    enter: {
      table: R8,
      tableData: Zm,
      tableHeader: Zm,
      tableRow: O8
    },
    exit: {
      codeText: L8,
      table: P8,
      tableData: gc,
      tableHeader: gc,
      tableRow: gc
    }
  };
}
function R8(e) {
  const t = e._align;
  L(t, "expected `_align` on table"), this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function P8(e) {
  this.exit(e), this.data.inTable = void 0;
}
function O8(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function gc(e) {
  this.exit(e);
}
function Zm(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function L8(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, M8));
  const n = this.stack[this.stack.length - 1];
  L(n.type === "inlineCode"), n.value = t, this.exit(e);
}
function M8(e, t) {
  return t === "|" ? t : e;
}
function U8(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, s = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: h,
      table: a,
      tableCell: u,
      tableRow: o
    }
  };
  function a(m, E, g, T) {
    return c(l(m, g, T), m.align);
  }
  function o(m, E, g, T) {
    const _ = d(m, g, T), A = c([_]);
    return A.slice(0, A.indexOf(`
`));
  }
  function u(m, E, g, T) {
    const _ = g.enter("tableCell"), A = g.enter("phrasing"), w = g.containerPhrasing(m, {
      ...T,
      before: s,
      after: s
    });
    return A(), _(), w;
  }
  function c(m, E) {
    return X5(m, {
      align: E,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function l(m, E, g) {
    const T = m.children;
    let _ = -1;
    const A = [], w = E.enter("table");
    for (; ++_ < T.length; )
      A[_] = d(T[_], E, g);
    return w(), A;
  }
  function d(m, E, g) {
    const T = m.children;
    let _ = -1;
    const A = [], w = E.enter("tableRow");
    for (; ++_ < T.length; )
      A[_] = u(T[_], m, E, g);
    return w(), A;
  }
  function h(m, E, g) {
    let T = wx.inlineCode(m, E, g);
    return g.stack.includes("tableCell") && (T = T.replace(/\|/g, "\\$&")), T;
  }
}
function H8() {
  return {
    exit: {
      taskListCheckValueChecked: ep,
      taskListCheckValueUnchecked: ep,
      paragraph: B8
    }
  };
}
function j8() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: F8 }
  };
}
function ep(e) {
  const t = this.stack[this.stack.length - 2];
  L(t.type === "listItem"), t.checked = e.type === "taskListCheckValueChecked";
}
function B8(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    L(n.type === "paragraph");
    const r = n.children[0];
    if (r && r.type === "text") {
      const i = t.children;
      let s = -1, a;
      for (; ++s < i.length; ) {
        const o = i[s];
        if (o.type === "paragraph") {
          a = o;
          break;
        }
      }
      a === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function F8(e, t, n, r) {
  const i = e.children[0], s = typeof e.checked == "boolean" && i && i.type === "paragraph", a = "[" + (e.checked ? "x" : " ") + "] ", o = n.createTracker(r);
  s && o.move(a);
  let u = wx.listItem(e, t, n, {
    ...r,
    ...o.current()
  });
  return s && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, c)), u;
  function c(l) {
    return l + a;
  }
}
function z8() {
  return [
    x5(),
    F5(),
    $5(),
    D8(),
    H8()
  ];
}
function V8(e) {
  return {
    extensions: [
      T5(),
      z5(e),
      Y5(),
      U8(e),
      j8()
    ]
  };
}
const W8 = { tokenize: Q8, partial: !0 }, Cx = { tokenize: X8, partial: !0 }, Sx = { tokenize: J8, partial: !0 }, kx = { tokenize: Z8, partial: !0 }, $8 = {
  tokenize: eH,
  partial: !0
}, Ix = {
  name: "wwwAutolink",
  tokenize: q8,
  previous: Rx
}, Dx = {
  name: "protocolAutolink",
  tokenize: K8,
  previous: Px
}, Xn = {
  name: "emailAutolink",
  tokenize: G8,
  previous: Ox
}, Ln = {};
function Y8() {
  return { text: Ln };
}
let Rr = b.digit0;
for (; Rr < b.leftCurlyBrace; )
  Ln[Rr] = Xn, Rr++, Rr === b.colon ? Rr = b.uppercaseA : Rr === b.leftSquareBracket && (Rr = b.lowercaseA);
Ln[b.plusSign] = Xn;
Ln[b.dash] = Xn;
Ln[b.dot] = Xn;
Ln[b.underscore] = Xn;
Ln[b.uppercaseH] = [Xn, Dx];
Ln[b.lowercaseH] = [Xn, Dx];
Ln[b.uppercaseW] = [Xn, Ix];
Ln[b.lowercaseW] = [Xn, Ix];
function G8(e, t, n) {
  const r = this;
  let i, s;
  return a;
  function a(d) {
    return !ll(d) || !Ox.call(r, r.previous) || jd(r.events) ? n(d) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), o(d));
  }
  function o(d) {
    return ll(d) ? (e.consume(d), o) : d === b.atSign ? (e.consume(d), u) : n(d);
  }
  function u(d) {
    return d === b.dot ? e.check(
      $8,
      l,
      c
    )(d) : d === b.dash || d === b.underscore || Rt(d) ? (s = !0, e.consume(d), u) : l(d);
  }
  function c(d) {
    return e.consume(d), i = !0, u;
  }
  function l(d) {
    return s && i && jt(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(d)) : n(d);
  }
}
function q8(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return a !== b.uppercaseW && a !== b.lowercaseW || !Rx.call(r, r.previous) || jd(r.events) ? n(a) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(
      W8,
      e.attempt(Cx, e.attempt(Sx, s), n),
      n
    )(a));
  }
  function s(a) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(a);
  }
}
function K8(e, t, n) {
  const r = this;
  let i = "", s = !1;
  return a;
  function a(d) {
    return (d === b.uppercaseH || d === b.lowercaseH) && Px.call(r, r.previous) && !jd(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(d), e.consume(d), o) : n(d);
  }
  function o(d) {
    if (jt(d) && i.length < 5)
      return i += String.fromCodePoint(d), e.consume(d), o;
    if (d === b.colon) {
      const h = i.toLowerCase();
      if (h === "http" || h === "https")
        return e.consume(d), u;
    }
    return n(d);
  }
  function u(d) {
    return d === b.slash ? (e.consume(d), s ? c : (s = !0, u)) : n(d);
  }
  function c(d) {
    return d === b.eof || go(d) || rt(d) || Gr(d) || au(d) ? n(d) : e.attempt(Cx, e.attempt(Sx, l), n)(d);
  }
  function l(d) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(d);
  }
}
function Q8(e, t, n) {
  let r = 0;
  return i;
  function i(a) {
    return (a === b.uppercaseW || a === b.lowercaseW) && r < 3 ? (r++, e.consume(a), i) : a === b.dot && r === 3 ? (e.consume(a), s) : n(a);
  }
  function s(a) {
    return a === b.eof ? n(a) : t(a);
  }
}
function X8(e, t, n) {
  let r, i, s;
  return a;
  function a(c) {
    return c === b.dot || c === b.underscore ? e.check(kx, u, o)(c) : c === b.eof || rt(c) || Gr(c) || c !== b.dash && au(c) ? u(c) : (s = !0, e.consume(c), a);
  }
  function o(c) {
    return c === b.underscore ? r = !0 : (i = r, r = void 0), e.consume(c), a;
  }
  function u(c) {
    return i || r || !s ? n(c) : t(c);
  }
}
function J8(e, t) {
  let n = 0, r = 0;
  return i;
  function i(a) {
    return a === b.leftParenthesis ? (n++, e.consume(a), i) : a === b.rightParenthesis && r < n ? s(a) : a === b.exclamationMark || a === b.quotationMark || a === b.ampersand || a === b.apostrophe || a === b.rightParenthesis || a === b.asterisk || a === b.comma || a === b.dot || a === b.colon || a === b.semicolon || a === b.lessThan || a === b.questionMark || a === b.rightSquareBracket || a === b.underscore || a === b.tilde ? e.check(kx, t, s)(a) : a === b.eof || rt(a) || Gr(a) ? t(a) : (e.consume(a), i);
  }
  function s(a) {
    return a === b.rightParenthesis && r++, e.consume(a), i;
  }
}
function Z8(e, t, n) {
  return r;
  function r(o) {
    return o === b.exclamationMark || o === b.quotationMark || o === b.apostrophe || o === b.rightParenthesis || o === b.asterisk || o === b.comma || o === b.dot || o === b.colon || o === b.semicolon || o === b.questionMark || o === b.underscore || o === b.tilde ? (e.consume(o), r) : o === b.ampersand ? (e.consume(o), s) : o === b.rightSquareBracket ? (e.consume(o), i) : (
      // `<` is an end.
      o === b.lessThan || // So is whitespace.
      o === b.eof || rt(o) || Gr(o) ? t(o) : n(o)
    );
  }
  function i(o) {
    return o === b.eof || o === b.leftParenthesis || o === b.leftSquareBracket || rt(o) || Gr(o) ? t(o) : r(o);
  }
  function s(o) {
    return jt(o) ? a(o) : n(o);
  }
  function a(o) {
    return o === b.semicolon ? (e.consume(o), r) : jt(o) ? (e.consume(o), a) : n(o);
  }
}
function eH(e, t, n) {
  return r;
  function r(s) {
    return e.consume(s), i;
  }
  function i(s) {
    return Rt(s) ? n(s) : t(s);
  }
}
function Rx(e) {
  return e === b.eof || e === b.leftParenthesis || e === b.asterisk || e === b.underscore || e === b.leftSquareBracket || e === b.rightSquareBracket || e === b.tilde || rt(e);
}
function Px(e) {
  return !jt(e);
}
function Ox(e) {
  return !(e === b.slash || ll(e));
}
function ll(e) {
  return e === b.plusSign || e === b.dash || e === b.dot || e === b.underscore || Rt(e);
}
function jd(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const tH = { tokenize: cH, partial: !0 };
function nH() {
  return {
    document: {
      [b.leftSquareBracket]: {
        name: "gfmFootnoteDefinition",
        tokenize: aH,
        continuation: { tokenize: oH },
        exit: uH
      }
    },
    text: {
      [b.leftSquareBracket]: {
        name: "gfmFootnoteCall",
        tokenize: sH
      },
      [b.rightSquareBracket]: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: rH,
        resolveTo: iH
      }
    }
  };
}
function rH(e, t, n) {
  const r = this;
  let i = r.events.length;
  const s = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a;
  for (; i--; ) {
    const u = r.events[i][1];
    if (u.type === x.labelImage) {
      a = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === x.labelLink || u.type === x.label || u.type === x.image || u.type === x.link)
      break;
  }
  return o;
  function o(u) {
    if (L(u === b.rightSquareBracket, "expected `]`"), !a || !a._balanced)
      return n(u);
    const c = hn(
      r.sliceSerialize({ start: a.end, end: r.now() })
    );
    return c.codePointAt(0) !== b.caret || !s.includes(c.slice(1)) ? n(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), t(u));
  }
}
function iH(e, t) {
  let n = e.length, r;
  for (; n--; )
    if (e[n][1].type === x.labelImage && e[n][0] === "enter") {
      r = e[n][1];
      break;
    }
  L(r, "expected `labelStart` to resolve"), e[n + 1][1].type = x.data, e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const i = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, s = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  s.end.column++, s.end.offset++, s.end._bufferIndex++;
  const a = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, s.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, o = {
    type: x.chunkString,
    contentType: "string",
    start: Object.assign({}, a.start),
    end: Object.assign({}, a.end)
  }, u = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", i, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", s, t],
    ["exit", s, t],
    // Everything in between.
    ["enter", a, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", a, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", i, t]
  ];
  return e.splice(n, e.length - n + 1, ...u), e;
}
function sH(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let s = 0, a;
  return o;
  function o(d) {
    return L(d === b.leftSquareBracket, "expected `[`"), e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(d), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(d) {
    return d !== b.caret ? n(d) : (e.enter("gfmFootnoteCallMarker"), e.consume(d), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", c);
  }
  function c(d) {
    if (
      // Too long.
      s > ue.linkReferenceSizeMax || // Closing brace with nothing.
      d === b.rightSquareBracket && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      d === b.eof || d === b.leftSquareBracket || rt(d)
    )
      return n(d);
    if (d === b.rightSquareBracket) {
      e.exit("chunkString");
      const h = e.exit("gfmFootnoteCallString");
      return i.includes(hn(r.sliceSerialize(h))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(d), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(d);
    }
    return rt(d) || (a = !0), s++, e.consume(d), d === b.backslash ? l : c;
  }
  function l(d) {
    return d === b.leftSquareBracket || d === b.backslash || d === b.rightSquareBracket ? (e.consume(d), s++, c) : c(d);
  }
}
function aH(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let s, a = 0, o;
  return u;
  function u(E) {
    return L(E === b.leftSquareBracket, "expected `[`"), e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionLabelMarker"), c;
  }
  function c(E) {
    return E === b.caret ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", l) : n(E);
  }
  function l(E) {
    if (
      // Too long.
      a > ue.linkReferenceSizeMax || // Closing brace with nothing.
      E === b.rightSquareBracket && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      E === b.eof || E === b.leftSquareBracket || rt(E)
    )
      return n(E);
    if (E === b.rightSquareBracket) {
      e.exit("chunkString");
      const g = e.exit("gfmFootnoteDefinitionLabelString");
      return s = hn(r.sliceSerialize(g)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), h;
    }
    return rt(E) || (o = !0), a++, e.consume(E), E === b.backslash ? d : l;
  }
  function d(E) {
    return E === b.leftSquareBracket || E === b.backslash || E === b.rightSquareBracket ? (e.consume(E), a++, l) : l(E);
  }
  function h(E) {
    return E === b.colon ? (e.enter("definitionMarker"), e.consume(E), e.exit("definitionMarker"), i.includes(s) || i.push(s), Ge(
      e,
      m,
      "gfmFootnoteDefinitionWhitespace"
    )) : n(E);
  }
  function m(E) {
    return t(E);
  }
}
function oH(e, t, n) {
  return e.check(Zs, t, e.attempt(tH, t, n));
}
function uH(e) {
  e.exit("gfmFootnoteDefinition");
}
function cH(e, t, n) {
  const r = this;
  return Ge(
    e,
    i,
    "gfmFootnoteDefinitionIndent",
    ue.tabSize + 1
  );
  function i(s) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "gfmFootnoteDefinitionIndent" && a[2].sliceSerialize(a[1], !0).length === ue.tabSize ? t(s) : n(s);
  }
}
function lH(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: s,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: { [b.tilde]: r },
    insideSpan: { null: [r] },
    attentionMarkers: { null: [b.tilde] }
  };
  function i(a, o) {
    let u = -1;
    for (; ++u < a.length; )
      if (a[u][0] === "enter" && a[u][1].type === "strikethroughSequenceTemporary" && a[u][1]._close) {
        let c = u;
        for (; c--; )
          if (a[c][0] === "exit" && a[c][1].type === "strikethroughSequenceTemporary" && a[c][1]._open && // If the sizes are the same:
          a[u][1].end.offset - a[u][1].start.offset === a[c][1].end.offset - a[c][1].start.offset) {
            a[u][1].type = "strikethroughSequence", a[c][1].type = "strikethroughSequence";
            const l = {
              type: "strikethrough",
              start: Object.assign({}, a[c][1].start),
              end: Object.assign({}, a[u][1].end)
            }, d = {
              type: "strikethroughText",
              start: Object.assign({}, a[c][1].end),
              end: Object.assign({}, a[u][1].start)
            }, h = [
              ["enter", l, o],
              ["enter", a[c][1], o],
              ["exit", a[c][1], o],
              ["enter", d, o]
            ], m = o.parser.constructs.insideSpan.null;
            m && Xt(
              h,
              h.length,
              0,
              ou(m, a.slice(c + 1, u), o)
            ), Xt(h, h.length, 0, [
              ["exit", d, o],
              ["enter", a[u][1], o],
              ["exit", a[u][1], o],
              ["exit", l, o]
            ]), Xt(a, c - 1, u - c + 3, h), u = c + h.length - 2;
            break;
          }
      }
    for (u = -1; ++u < a.length; )
      a[u][1].type === "strikethroughSequenceTemporary" && (a[u][1].type = x.data);
    return a;
  }
  function s(a, o, u) {
    const c = this.previous, l = this.events;
    let d = 0;
    return h;
    function h(E) {
      return L(E === b.tilde, "expected `~`"), c === b.tilde && l[l.length - 1][1].type !== x.characterEscape ? u(E) : (a.enter("strikethroughSequenceTemporary"), m(E));
    }
    function m(E) {
      const g = Si(c);
      if (E === b.tilde)
        return d > 1 ? u(E) : (a.consume(E), d++, m);
      if (d < 2 && !n) return u(E);
      const T = a.exit("strikethroughSequenceTemporary"), _ = Si(E);
      return T._open = !_ || _ === ue.attentionSideAfter && !!g, T._close = !g || g === ue.attentionSideAfter && !!_, o(E);
    }
  }
}
class dH {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    fH(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(s, a) {
      return s[0] - a[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(
        t.slice(this.map[n][0] + this.map[n][1]),
        this.map[n][2]
      ), t.length = this.map[n][0];
    r.push(t.slice()), t.length = 0;
    let i = r.pop();
    for (; i; ) {
      for (const s of i)
        t.push(s);
      i = r.pop();
    }
    this.map.length = 0;
  }
}
function fH(e, t, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === t) {
        e.map[i][1] += n, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([t, n, r]);
  }
}
function hH(e, t) {
  L(e[t][1].type === "table", "expected table");
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const i = e[t];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(
          e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
        );
      else if (i[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const s = r.length - 1;
          r[s] = r[s] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function mH() {
  return {
    flow: {
      null: { name: "table", tokenize: pH, resolveAll: gH }
    }
  };
}
function pH(e, t, n) {
  const r = this;
  let i = 0, s = 0, a;
  return o;
  function o(U) {
    let re = r.events.length - 1;
    for (; re > -1; ) {
      const H = r.events[re][1].type;
      if (H === x.lineEnding || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      H === x.linePrefix)
        re--;
      else break;
    }
    const ae = re > -1 ? r.events[re][1].type : null, j = ae === "tableHead" || ae === "tableRow" ? k : u;
    return j === k && r.parser.lazy[r.now().line] ? n(U) : j(U);
  }
  function u(U) {
    return e.enter("tableHead"), e.enter("tableRow"), c(U);
  }
  function c(U) {
    return U === b.verticalBar || (a = !0, s += 1), l(U);
  }
  function l(U) {
    return U === b.eof ? n(U) : me(U) ? s > 1 ? (s = 0, r.interrupt = !0, e.exit("tableRow"), e.enter(x.lineEnding), e.consume(U), e.exit(x.lineEnding), m) : n(U) : ze(U) ? Ge(e, l, x.whitespace)(U) : (s += 1, a && (a = !1, i += 1), U === b.verticalBar ? (e.enter("tableCellDivider"), e.consume(U), e.exit("tableCellDivider"), a = !0, l) : (e.enter(x.data), d(U)));
  }
  function d(U) {
    return U === b.eof || U === b.verticalBar || rt(U) ? (e.exit(x.data), l(U)) : (e.consume(U), U === b.backslash ? h : d);
  }
  function h(U) {
    return U === b.backslash || U === b.verticalBar ? (e.consume(U), d) : d(U);
  }
  function m(U) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(U) : (e.enter("tableDelimiterRow"), a = !1, ze(U) ? (L(r.parser.constructs.disable.null, "expected `disabled.null`"), Ge(
      e,
      E,
      x.linePrefix,
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : ue.tabSize
    )(U)) : E(U));
  }
  function E(U) {
    return U === b.dash || U === b.colon ? T(U) : U === b.verticalBar ? (a = !0, e.enter("tableCellDivider"), e.consume(U), e.exit("tableCellDivider"), g) : F(U);
  }
  function g(U) {
    return ze(U) ? Ge(
      e,
      T,
      x.whitespace
    )(U) : T(U);
  }
  function T(U) {
    return U === b.colon ? (s += 1, a = !0, e.enter("tableDelimiterMarker"), e.consume(U), e.exit("tableDelimiterMarker"), _) : U === b.dash ? (s += 1, _(U)) : U === b.eof || me(U) ? M(U) : F(U);
  }
  function _(U) {
    return U === b.dash ? (e.enter("tableDelimiterFiller"), A(U)) : F(U);
  }
  function A(U) {
    return U === b.dash ? (e.consume(U), A) : U === b.colon ? (a = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(U), e.exit("tableDelimiterMarker"), w) : (e.exit("tableDelimiterFiller"), w(U));
  }
  function w(U) {
    return ze(U) ? Ge(
      e,
      M,
      x.whitespace
    )(U) : M(U);
  }
  function M(U) {
    return U === b.verticalBar ? E(U) : U === b.eof || me(U) ? !a || i !== s ? F(U) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(U)) : F(U);
  }
  function F(U) {
    return n(U);
  }
  function k(U) {
    return e.enter("tableRow"), B(U);
  }
  function B(U) {
    return U === b.verticalBar ? (e.enter("tableCellDivider"), e.consume(U), e.exit("tableCellDivider"), B) : U === b.eof || me(U) ? (e.exit("tableRow"), t(U)) : ze(U) ? Ge(e, B, x.whitespace)(U) : (e.enter(x.data), $(U));
  }
  function $(U) {
    return U === b.eof || U === b.verticalBar || rt(U) ? (e.exit(x.data), B(U)) : (e.consume(U), U === b.backslash ? J : $);
  }
  function J(U) {
    return U === b.backslash || U === b.verticalBar ? (e.consume(U), $) : $(U);
  }
}
function gH(e, t) {
  let n = -1, r = !0, i = 0, s = [0, 0, 0, 0], a = [0, 0, 0, 0], o = !1, u = 0, c, l, d;
  const h = new dH();
  for (; ++n < e.length; ) {
    const m = e[n], E = m[1];
    m[0] === "enter" ? E.type === "tableHead" ? (o = !1, u !== 0 && (L(c, "there should be a table opening"), tp(h, t, u, c, l), l = void 0, u = 0), c = {
      type: "table",
      start: Object.assign({}, E.start),
      // Note: correct end is set later.
      end: Object.assign({}, E.end)
    }, h.add(n, 0, [["enter", c, t]])) : E.type === "tableRow" || E.type === "tableDelimiterRow" ? (r = !0, d = void 0, s = [0, 0, 0, 0], a = [0, n + 1, 0, 0], o && (o = !1, l = {
      type: "tableBody",
      start: Object.assign({}, E.start),
      // Note: correct end is set later.
      end: Object.assign({}, E.end)
    }, h.add(n, 0, [["enter", l, t]])), i = E.type === "tableDelimiterRow" ? 2 : l ? 3 : 1) : i && (E.type === x.data || E.type === "tableDelimiterMarker" || E.type === "tableDelimiterFiller") ? (r = !1, a[2] === 0 && (s[1] !== 0 && (a[0] = a[1], d = Ma(
      h,
      t,
      s,
      i,
      void 0,
      d
    ), s = [0, 0, 0, 0]), a[2] = n)) : E.type === "tableCellDivider" && (r ? r = !1 : (s[1] !== 0 && (a[0] = a[1], d = Ma(
      h,
      t,
      s,
      i,
      void 0,
      d
    )), s = a, a = [s[1], n, 0, 0])) : E.type === "tableHead" ? (o = !0, u = n) : E.type === "tableRow" || E.type === "tableDelimiterRow" ? (u = n, s[1] !== 0 ? (a[0] = a[1], d = Ma(
      h,
      t,
      s,
      i,
      n,
      d
    )) : a[1] !== 0 && (d = Ma(h, t, a, i, n, d)), i = 0) : i && (E.type === x.data || E.type === "tableDelimiterMarker" || E.type === "tableDelimiterFiller") && (a[3] = n);
  }
  for (u !== 0 && (L(c, "expected table opening"), tp(h, t, u, c, l)), h.consume(t.events), n = -1; ++n < t.events.length; ) {
    const m = t.events[n];
    m[0] === "enter" && m[1].type === "table" && (m[1]._align = hH(t.events, n));
  }
  return e;
}
function Ma(e, t, n, r, i, s) {
  const a = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", o = "tableContent";
  n[0] !== 0 && (L(s, "expected previous cell enter"), s.end = Object.assign({}, hi(t.events, n[0])), e.add(n[0], 0, [["exit", s, t]]));
  const u = hi(t.events, n[1]);
  if (s = {
    type: a,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(n[1], 0, [["enter", s, t]]), n[2] !== 0) {
    const c = hi(t.events, n[2]), l = hi(t.events, n[3]), d = {
      type: o,
      start: Object.assign({}, c),
      end: Object.assign({}, l)
    };
    if (e.add(n[2], 0, [["enter", d, t]]), L(n[3] !== 0), r !== 2) {
      const h = t.events[n[2]], m = t.events[n[3]];
      if (h[1].end = Object.assign({}, m[1].end), h[1].type = x.chunkText, h[1].contentType = ue.contentTypeText, n[3] > n[2] + 1) {
        const E = n[2] + 1, g = n[3] - n[2] - 1;
        e.add(E, g, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", d, t]]);
  }
  return i !== void 0 && (s.end = Object.assign({}, hi(t.events, i)), e.add(i, 0, [["exit", s, t]]), s = void 0), s;
}
function tp(e, t, n, r, i) {
  const s = [], a = hi(t.events, n);
  i && (i.end = Object.assign({}, a), s.push(["exit", i, t])), r.end = Object.assign({}, a), s.push(["exit", r, t]), e.add(n + 1, 0, s);
}
function hi(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const bH = { name: "tasklistCheck", tokenize: _H };
function EH() {
  return {
    text: { [b.leftSquareBracket]: bH }
  };
}
function _H(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return L(u === b.leftSquareBracket, "expected `[`"), // Exit if there’s stuff before.
    r.previous !== b.eof || // Exit if not in the first content that is the first child of a list
    // item.
    !r._gfmTasklistFirstContentOfListItem ? n(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), s);
  }
  function s(u) {
    return rt(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), a) : u === b.uppercaseX || u === b.lowercaseX ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), a) : n(u);
  }
  function a(u) {
    return u === b.rightSquareBracket ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), o) : n(u);
  }
  function o(u) {
    return me(u) ? t(u) : ze(u) ? e.check({ tokenize: xH }, t, n)(u) : n(u);
  }
}
function xH(e, t, n) {
  return Ge(e, r, x.whitespace);
  function r(i) {
    return i === b.eof ? n(i) : t(i);
  }
}
function TH(e) {
  return r_([
    Y8(),
    nH(),
    lH(e),
    mH(),
    EH()
  ]);
}
const AH = {};
function Lx(e) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), n = e || AH, r = t.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), s = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), a = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(TH(n)), s.push(z8()), a.push(V8(n));
}
const on = ut(
  ({ children: e, tooltip: t, side: n = "bottom", className: r, ...i }, s) => /* @__PURE__ */ p.jsxDEV(XI, { children: [
    /* @__PURE__ */ p.jsxDEV(JI, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(Bt, { variant: "ghost", size: "icon", ...i, className: ve("size-6 p-1", r), ref: s, children: [
      e,
      /* @__PURE__ */ p.jsxDEV("span", { className: "sr-only", children: t }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/tooltip-icon-button.tsx",
        lineNumber: 20,
        columnNumber: 13
      }, void 0)
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/tooltip-icon-button.tsx",
      lineNumber: 18,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/tooltip-icon-button.tsx",
      lineNumber: 17,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(ZI, { side: n, children: t }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/tooltip-icon-button.tsx",
      lineNumber: 23,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/tooltip-icon-button.tsx",
    lineNumber: 16,
    columnNumber: 7
  }, void 0)
);
on.displayName = "TooltipIconButton";
const yH = {
  365: { unit: "months", value: 12 },
  730: { unit: "years", value: 2 },
  1095: { unit: "years", value: 3 }
}, ar = {
  territoryGrouped: {
    key: "zai.widget.territory-type.grouped",
    defaultValue: "Visão geral"
  },
  territoryOwned: {
    key: "zai.widget.territory-type.owned",
    defaultValue: "Owned"
  },
  territoryEarned: {
    key: "zai.widget.territory-type.earned",
    defaultValue: "Earned (UGC)"
  },
  territoryPaid: {
    key: "zai.widget.territory-type.paid",
    defaultValue: "Paid"
  },
  lastNDays: (e) => ({
    key: "zai.widget.upload-date.last-n-days",
    parameters: e,
    defaultValue: "Últimos {days} dias"
  }),
  lastNMonths: (e) => ({
    key: "zai.widget.upload-date.last-n-months",
    parameters: e,
    defaultValue: "Últimos {months} meses"
  }),
  lastNYears: (e) => ({
    key: "zai.widget.upload-date.last-n-years",
    parameters: e,
    defaultValue: "Últimos {years} anos"
  })
}, Mx = (e, t) => {
  switch (e) {
    case "earned":
      return t(ar.territoryEarned);
    case "paid":
      return t(ar.territoryPaid);
    case "selfContent":
    case "owned":
      return t(ar.territoryOwned);
    default:
      return t(ar.territoryGrouped);
  }
}, Bd = (e, t) => {
  const n = yH[e];
  return n?.unit === "years" ? t(ar.lastNYears({ years: n.value })) : n?.unit === "months" ? t(ar.lastNMonths({ months: n.value })) : e >= 60 && e % 30 === 0 ? t(ar.lastNMonths({ months: e / 30 })) : t(ar.lastNDays({ days: e }));
};
var Ga = { exports: {} }, NH = Ga.exports, np;
function Fd() {
  return np || (np = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(NH, (function() {
      var n = 1e3, r = 6e4, i = 36e5, s = "millisecond", a = "second", o = "minute", u = "hour", c = "day", l = "week", d = "month", h = "quarter", m = "year", E = "date", g = "Invalid Date", T = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, _ = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, A = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(H) {
        var z = ["th", "st", "nd", "rd"], W = H % 100;
        return "[" + H + (z[(W - 20) % 10] || z[W] || z[0]) + "]";
      } }, w = function(H, z, W) {
        var X = String(H);
        return !X || X.length >= z ? H : "" + Array(z + 1 - X.length).join(W) + H;
      }, M = { s: w, z: function(H) {
        var z = -H.utcOffset(), W = Math.abs(z), X = Math.floor(W / 60), G = W % 60;
        return (z <= 0 ? "+" : "-") + w(X, 2, "0") + ":" + w(G, 2, "0");
      }, m: function H(z, W) {
        if (z.date() < W.date()) return -H(W, z);
        var X = 12 * (W.year() - z.year()) + (W.month() - z.month()), G = z.clone().add(X, d), se = W - G < 0, N = z.clone().add(X + (se ? -1 : 1), d);
        return +(-(X + (W - G) / (se ? G - N : N - G)) || 0);
      }, a: function(H) {
        return H < 0 ? Math.ceil(H) || 0 : Math.floor(H);
      }, p: function(H) {
        return { M: d, y: m, w: l, d: c, D: E, h: u, m: o, s: a, ms: s, Q: h }[H] || String(H || "").toLowerCase().replace(/s$/, "");
      }, u: function(H) {
        return H === void 0;
      } }, F = "en", k = {};
      k[F] = A;
      var B = "$isDayjsObject", $ = function(H) {
        return H instanceof ae || !(!H || !H[B]);
      }, J = function H(z, W, X) {
        var G;
        if (!z) return F;
        if (typeof z == "string") {
          var se = z.toLowerCase();
          k[se] && (G = se), W && (k[se] = W, G = se);
          var N = z.split("-");
          if (!G && N.length > 1) return H(N[0]);
        } else {
          var ye = z.name;
          k[ye] = z, G = ye;
        }
        return !X && G && (F = G), G || !X && F;
      }, U = function(H, z) {
        if ($(H)) return H.clone();
        var W = typeof z == "object" ? z : {};
        return W.date = H, W.args = arguments, new ae(W);
      }, re = M;
      re.l = J, re.i = $, re.w = function(H, z) {
        return U(H, { locale: z.$L, utc: z.$u, x: z.$x, $offset: z.$offset });
      };
      var ae = (function() {
        function H(W) {
          this.$L = J(W.locale, null, !0), this.parse(W), this.$x = this.$x || W.x || {}, this[B] = !0;
        }
        var z = H.prototype;
        return z.parse = function(W) {
          this.$d = (function(X) {
            var G = X.date, se = X.utc;
            if (G === null) return /* @__PURE__ */ new Date(NaN);
            if (re.u(G)) return /* @__PURE__ */ new Date();
            if (G instanceof Date) return new Date(G);
            if (typeof G == "string" && !/Z$/i.test(G)) {
              var N = G.match(T);
              if (N) {
                var ye = N[2] - 1 || 0, Re = (N[7] || "0").substring(0, 3);
                return se ? new Date(Date.UTC(N[1], ye, N[3] || 1, N[4] || 0, N[5] || 0, N[6] || 0, Re)) : new Date(N[1], ye, N[3] || 1, N[4] || 0, N[5] || 0, N[6] || 0, Re);
              }
            }
            return new Date(G);
          })(W), this.init();
        }, z.init = function() {
          var W = this.$d;
          this.$y = W.getFullYear(), this.$M = W.getMonth(), this.$D = W.getDate(), this.$W = W.getDay(), this.$H = W.getHours(), this.$m = W.getMinutes(), this.$s = W.getSeconds(), this.$ms = W.getMilliseconds();
        }, z.$utils = function() {
          return re;
        }, z.isValid = function() {
          return this.$d.toString() !== g;
        }, z.isSame = function(W, X) {
          var G = U(W);
          return this.startOf(X) <= G && G <= this.endOf(X);
        }, z.isAfter = function(W, X) {
          return U(W) < this.startOf(X);
        }, z.isBefore = function(W, X) {
          return this.endOf(X) < U(W);
        }, z.$g = function(W, X, G) {
          return re.u(W) ? this[X] : this.set(G, W);
        }, z.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, z.valueOf = function() {
          return this.$d.getTime();
        }, z.startOf = function(W, X) {
          var G = this, se = !!re.u(X) || X, N = re.p(W), ye = function(Ne, _e) {
            var Se = re.w(G.$u ? Date.UTC(G.$y, _e, Ne) : new Date(G.$y, _e, Ne), G);
            return se ? Se : Se.endOf(c);
          }, Re = function(Ne, _e) {
            return re.w(G.toDate()[Ne].apply(G.toDate("s"), (se ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(_e)), G);
          }, D = this.$W, Ie = this.$M, De = this.$D, He = "set" + (this.$u ? "UTC" : "");
          switch (N) {
            case m:
              return se ? ye(1, 0) : ye(31, 11);
            case d:
              return se ? ye(1, Ie) : ye(0, Ie + 1);
            case l:
              var fe = this.$locale().weekStart || 0, Te = (D < fe ? D + 7 : D) - fe;
              return ye(se ? De - Te : De + (6 - Te), Ie);
            case c:
            case E:
              return Re(He + "Hours", 0);
            case u:
              return Re(He + "Minutes", 1);
            case o:
              return Re(He + "Seconds", 2);
            case a:
              return Re(He + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, z.endOf = function(W) {
          return this.startOf(W, !1);
        }, z.$set = function(W, X) {
          var G, se = re.p(W), N = "set" + (this.$u ? "UTC" : ""), ye = (G = {}, G[c] = N + "Date", G[E] = N + "Date", G[d] = N + "Month", G[m] = N + "FullYear", G[u] = N + "Hours", G[o] = N + "Minutes", G[a] = N + "Seconds", G[s] = N + "Milliseconds", G)[se], Re = se === c ? this.$D + (X - this.$W) : X;
          if (se === d || se === m) {
            var D = this.clone().set(E, 1);
            D.$d[ye](Re), D.init(), this.$d = D.set(E, Math.min(this.$D, D.daysInMonth())).$d;
          } else ye && this.$d[ye](Re);
          return this.init(), this;
        }, z.set = function(W, X) {
          return this.clone().$set(W, X);
        }, z.get = function(W) {
          return this[re.p(W)]();
        }, z.add = function(W, X) {
          var G, se = this;
          W = Number(W);
          var N = re.p(X), ye = function(Ie) {
            var De = U(se);
            return re.w(De.date(De.date() + Math.round(Ie * W)), se);
          };
          if (N === d) return this.set(d, this.$M + W);
          if (N === m) return this.set(m, this.$y + W);
          if (N === c) return ye(1);
          if (N === l) return ye(7);
          var Re = (G = {}, G[o] = r, G[u] = i, G[a] = n, G)[N] || 1, D = this.$d.getTime() + W * Re;
          return re.w(D, this);
        }, z.subtract = function(W, X) {
          return this.add(-1 * W, X);
        }, z.format = function(W) {
          var X = this, G = this.$locale();
          if (!this.isValid()) return G.invalidDate || g;
          var se = W || "YYYY-MM-DDTHH:mm:ssZ", N = re.z(this), ye = this.$H, Re = this.$m, D = this.$M, Ie = G.weekdays, De = G.months, He = G.meridiem, fe = function(_e, Se, Me, Ze) {
            return _e && (_e[Se] || _e(X, se)) || Me[Se].slice(0, Ze);
          }, Te = function(_e) {
            return re.s(ye % 12 || 12, _e, "0");
          }, Ne = He || function(_e, Se, Me) {
            var Ze = _e < 12 ? "AM" : "PM";
            return Me ? Ze.toLowerCase() : Ze;
          };
          return se.replace(_, (function(_e, Se) {
            return Se || (function(Me) {
              switch (Me) {
                case "YY":
                  return String(X.$y).slice(-2);
                case "YYYY":
                  return re.s(X.$y, 4, "0");
                case "M":
                  return D + 1;
                case "MM":
                  return re.s(D + 1, 2, "0");
                case "MMM":
                  return fe(G.monthsShort, D, De, 3);
                case "MMMM":
                  return fe(De, D);
                case "D":
                  return X.$D;
                case "DD":
                  return re.s(X.$D, 2, "0");
                case "d":
                  return String(X.$W);
                case "dd":
                  return fe(G.weekdaysMin, X.$W, Ie, 2);
                case "ddd":
                  return fe(G.weekdaysShort, X.$W, Ie, 3);
                case "dddd":
                  return Ie[X.$W];
                case "H":
                  return String(ye);
                case "HH":
                  return re.s(ye, 2, "0");
                case "h":
                  return Te(1);
                case "hh":
                  return Te(2);
                case "a":
                  return Ne(ye, Re, !0);
                case "A":
                  return Ne(ye, Re, !1);
                case "m":
                  return String(Re);
                case "mm":
                  return re.s(Re, 2, "0");
                case "s":
                  return String(X.$s);
                case "ss":
                  return re.s(X.$s, 2, "0");
                case "SSS":
                  return re.s(X.$ms, 3, "0");
                case "Z":
                  return N;
              }
              return null;
            })(_e) || N.replace(":", "");
          }));
        }, z.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, z.diff = function(W, X, G) {
          var se, N = this, ye = re.p(X), Re = U(W), D = (Re.utcOffset() - this.utcOffset()) * r, Ie = this - Re, De = function() {
            return re.m(N, Re);
          };
          switch (ye) {
            case m:
              se = De() / 12;
              break;
            case d:
              se = De();
              break;
            case h:
              se = De() / 3;
              break;
            case l:
              se = (Ie - D) / 6048e5;
              break;
            case c:
              se = (Ie - D) / 864e5;
              break;
            case u:
              se = Ie / i;
              break;
            case o:
              se = Ie / r;
              break;
            case a:
              se = Ie / n;
              break;
            default:
              se = Ie;
          }
          return G ? se : re.a(se);
        }, z.daysInMonth = function() {
          return this.endOf(d).$D;
        }, z.$locale = function() {
          return k[this.$L];
        }, z.locale = function(W, X) {
          if (!W) return this.$L;
          var G = this.clone(), se = J(W, X, !0);
          return se && (G.$L = se), G;
        }, z.clone = function() {
          return re.w(this.$d, this);
        }, z.toDate = function() {
          return new Date(this.valueOf());
        }, z.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, z.toISOString = function() {
          return this.$d.toISOString();
        }, z.toString = function() {
          return this.$d.toUTCString();
        }, H;
      })(), j = ae.prototype;
      return U.prototype = j, [["$ms", s], ["$s", a], ["$m", o], ["$H", u], ["$W", c], ["$M", d], ["$y", m], ["$D", E]].forEach((function(H) {
        j[H[1]] = function(z) {
          return this.$g(z, H[0], H[1]);
        };
      })), U.extend = function(H, z) {
        return H.$i || (H(z, ae, U), H.$i = !0), U;
      }, U.locale = J, U.isDayjs = $, U.unix = function(H) {
        return U(1e3 * H);
      }, U.en = k[F], U.Ls = k, U.p = {}, U;
    }));
  })(Ga)), Ga.exports;
}
var vH = Fd();
const Br = /* @__PURE__ */ pr(vH), wH = (e) => Ci[e] || Ci.grouped, CH = (e, t) => {
  const n = {
    quarter: "MMM/YYYY",
    month: "MMM/YYYY",
    week: "MMM, DD YYYY",
    day: "MMM, DD YYYY"
  };
  return t === "quarter" ? `${Br(e).utc().format("MMM")}-${Br(e).add(2, "months").utc().format(n.quarter)}` : Br(e).utc().format(n[t]);
}, SH = ({
  provider: e = "all",
  territoryType: t = "grouped",
  timeRangeInDays: n = 30
}) => {
  const r = ru.isEnabled("isNewPageBrandOverviewEnabled"), { workspaceId: i } = St(), s = Xr(), { t: a } = Je(), o = pe(() => {
    const M = Rn(
      mr[le.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE],
      {
        panelId: i,
        tab: wH(t)
      }
    ), F = HE({ provider: e, timeRangeInDays: n }).toString();
    return F ? `${M}?${F}` : M;
  }, [e, t, n, i]), [u, c] = we([]), [l, d] = we(!1), [h, m] = we(!1), E = de(async () => {
    if (i) {
      d(!0), m(!1);
      try {
        const M = await s.getBrandEngagementOverTimeData(
          {
            provider: e,
            territoryType: t,
            timeRangeInDays: n?.toString()
          },
          { isNewPageBrandOverviewEnabled: r }
        );
        c(M);
      } catch {
        m(!0), c([]);
      } finally {
        d(!1);
      }
    }
  }, [i, s, e, t, n, r]);
  Le(() => {
    E();
  }, [E]);
  const g = pe(() => u?.map((M) => {
    const F = M.metrics.map((k) => k.totalEngagement);
    return {
      name: M.name,
      color: M.color,
      series: F
    };
  }) || [], [u]), T = pe(() => !u || u.length === 0 ? [] : u[0]?.metrics?.map((M) => M.date) || [], [u]), _ = pe(() => {
    const M = Gc(n);
    return T.map((F) => CH(F, M));
  }, [T, n]), A = pe(
    () => g.length === 0 || g.flatMap((M) => M.series).every((M) => M === 0),
    [g]
  ), w = pe(() => {
    const M = ud[e], F = Mx(t, a), k = Bd(n, a);
    return [M, F, k].join(" · ");
  }, [e, t, n, a]);
  return {
    data: u,
    isLoading: l,
    isError: h,
    isEmpty: A,
    refetch: E,
    macroareaURL: o,
    chartEntities: g,
    chartLabels: _,
    subtitle: w
  };
}, rp = {
  chart: {
    key: "widget-error.chart.title",
    defaultValue: "O gráfico falhou ao carregar"
  },
  video: {
    key: "widget-error.video.title",
    defaultValue: "O vídeo falhou ao carregar"
  },
  creator: {
    key: "widget-error.creator.title",
    defaultValue: "O criador falhou ao carregar"
  },
  tryAgain: {
    key: "widget-error.try-again",
    defaultValue: "Tentar novamente"
  }
}, zi = ({ refetch: e, name: t }) => {
  const { t: n } = Je(), r = rp;
  return /* @__PURE__ */ p.jsxDEV("div", { className: "my-5 w-full flex flex-col items-center justify-center gap-4", children: [
    /* @__PURE__ */ p.jsxDEV("strong", { children: n(r[t]) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-error/index.tsx",
      lineNumber: 18,
      columnNumber: 7
    }, void 0),
    e && /* @__PURE__ */ p.jsxDEV(Bt, { variant: "highlight-border", onClick: e, children: n(rp.tryAgain) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-error/index.tsx",
      lineNumber: 20,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-error/index.tsx",
    lineNumber: 17,
    columnNumber: 5
  }, void 0);
}, Ux = Ot("dark"), zd = ({ theme: e, children: t }) => /* @__PURE__ */ p.jsxDEV(Ux.Provider, { value: e, children: t }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/contexts/theme/theme.provider.tsx",
  lineNumber: 5,
  columnNumber: 3
}, void 0), yr = () => Ct(Ux), ip = {
  accessMacroarea: {
    key: "brand-engagement-over-time.access-macroarea",
    defaultValue: "Acessar Engajamento"
  },
  noDataAvailable: {
    key: "brand-engagement-over-time.no-data-available",
    defaultValue: "Nenhum dado de engajamento disponível para o período selecionado"
  }
}, kH = () => /* @__PURE__ */ p.jsxDEV("div", { className: "w-full h-96 flex items-center justify-center", children: /* @__PURE__ */ p.jsxDEV("div", { className: "animate-pulse w-full h-96 bg-muted rounded-md" }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
  lineNumber: 14,
  columnNumber: 5
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
  lineNumber: 13,
  columnNumber: 3
}, void 0), IH = ({
  isError: e,
  isLoading: t,
  isEmpty: n,
  macroareaURL: r,
  refetch: i,
  chartEntities: s,
  chartLabels: a,
  subtitle: o
}) => {
  const { t: u } = Je(), c = yr();
  return /* @__PURE__ */ p.jsxDEV("div", { className: "my-5 w-full flex flex-col gap-6", children: [
    o && /* @__PURE__ */ p.jsxDEV("div", { className: "text-sm text-neutral-800 dark:text-white", children: o }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
      lineNumber: 33,
      columnNumber: 20
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(
      Jr,
      {
        isLoading: t,
        isError: e,
        loadingComponent: /* @__PURE__ */ p.jsxDEV(kH, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
          lineNumber: 37,
          columnNumber: 27
        }, void 0),
        errorComponent: /* @__PURE__ */ p.jsxDEV(zi, { name: "chart", refetch: i }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
          lineNumber: 38,
          columnNumber: 25
        }, void 0),
        isEmpty: n,
        emptyComponent: /* @__PURE__ */ p.jsxDEV("div", { className: "flex justify-center items-center h-96", children: /* @__PURE__ */ p.jsxDEV("p", { className: "text-center text-muted-foreground", children: u(ip.noDataAvailable) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
          lineNumber: 42,
          columnNumber: 13
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
          lineNumber: 41,
          columnNumber: 11
        }, void 0),
        children: /* @__PURE__ */ p.jsxDEV("div", { className: "w-full", children: /* @__PURE__ */ p.jsxDEV(
          bn.LineChart,
          {
            legend: { type: "default" },
            entities: s,
            xAxisLabels: a,
            tooltip: { type: "default", shared: !0, formatter: (l) => an(l, 2) },
            customOptions: {
              yAxis: {
                labels: {
                  formatter: function() {
                    return an(Number(this.value), 0);
                  }
                }
              }
            },
            theme: c,
            height: 600
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
            lineNumber: 47,
            columnNumber: 11
          },
          void 0
        ) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
          lineNumber: 46,
          columnNumber: 9
        }, void 0)
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
        lineNumber: 34,
        columnNumber: 7
      },
      void 0
    ),
    !e && /* @__PURE__ */ p.jsxDEV(Bt, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ p.jsxDEV("a", { href: r, target: "_blank", rel: "noopener noreferrer", children: u(ip.accessMacroarea) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
      lineNumber: 68,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
      lineNumber: 67,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/brand-engagement-over-time-widget.view.tsx",
    lineNumber: 32,
    columnNumber: 5
  }, void 0);
}, DH = (e = {}) => {
  const t = SH(e);
  return /* @__PURE__ */ p.jsxDEV(IH, { ...e, ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/brand-engagement-over-time-widget/index.tsx",
    lineNumber: 7,
    columnNumber: 10
  }, void 0);
}, RH = ({ creatorId: e, performanceInMonths: t = 1 }) => {
  const { workspaceId: n } = St(), r = Xr(), [i, s] = we(!1), [a, o] = we(!1), [u, c] = we(null), l = de(async () => {
    if (!(!e || !n))
      try {
        s(!0), o(!1);
        const d = await r.getCreatorData(e, { performanceInMonths: t });
        c(d);
      } catch {
        o(!0);
      } finally {
        s(!1);
      }
  }, [n, e, t, r]);
  return Le(() => {
    l();
  }, [l]), {
    isLoading: i,
    isError: a,
    data: u,
    fetch: l
  };
}, PH = [
  {
    NAME: "Afghanistan",
    ALPHA_2: "AF",
    ALPHA_3: "AFG",
    CODE: 4,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Åland Islands",
    ALPHA_2: "AX",
    ALPHA_3: "ALA",
    CODE: 248,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Albania",
    ALPHA_2: "AL",
    ALPHA_3: "ALB",
    CODE: 8,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Algeria",
    ALPHA_2: "DZ",
    ALPHA_3: "DZA",
    CODE: 12,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "American Samoa",
    ALPHA_2: "AS",
    ALPHA_3: "ASM",
    CODE: 16,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Andorra",
    ALPHA_2: "AD",
    ALPHA_3: "AND",
    CODE: 20,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Angola",
    ALPHA_2: "AO",
    ALPHA_3: "AGO",
    CODE: 24,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Anguilla",
    ALPHA_2: "AI",
    ALPHA_3: "AIA",
    CODE: 660,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Antarctica",
    ALPHA_2: "AQ",
    ALPHA_3: "ATA",
    CODE: 10,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Antigua And Barbuda",
    ALPHA_2: "AG",
    ALPHA_3: "ATG",
    CODE: 28,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Argentina",
    ALPHA_2: "AR",
    ALPHA_3: "ARG",
    CODE: 32,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Armenia",
    ALPHA_2: "AM",
    ALPHA_3: "ARM",
    CODE: 51,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Aruba",
    ALPHA_2: "AW",
    ALPHA_3: "ABW",
    CODE: 533,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Australia",
    ALPHA_2: "AU",
    ALPHA_3: "AUS",
    CODE: 36,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Austria",
    ALPHA_2: "AT",
    ALPHA_3: "AUT",
    CODE: 40,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Azerbaijan",
    ALPHA_2: "AZ",
    ALPHA_3: "AZE",
    CODE: 31,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bahamas",
    ALPHA_2: "BS",
    ALPHA_3: "BHS",
    CODE: 44,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bahrain",
    ALPHA_2: "BH",
    ALPHA_3: "BHR",
    CODE: 48,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bangladesh",
    ALPHA_2: "BD",
    ALPHA_3: "BGD",
    CODE: 50,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Barbados",
    ALPHA_2: "BB",
    ALPHA_3: "BRB",
    CODE: 52,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belarus",
    ALPHA_2: "BY",
    ALPHA_3: "BLR",
    CODE: 112,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belgium",
    ALPHA_2: "BE",
    ALPHA_3: "BEL",
    CODE: 56,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belize",
    ALPHA_2: "BZ",
    ALPHA_3: "BLZ",
    CODE: 84,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Benin",
    ALPHA_2: "BJ",
    ALPHA_3: "BEN",
    CODE: 204,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bermuda",
    ALPHA_2: "BM",
    ALPHA_3: "BMU",
    CODE: 60,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bhutan",
    ALPHA_2: "BT",
    ALPHA_3: "BTN",
    CODE: 64,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bolivia",
    ALPHA_2: "BO",
    ALPHA_3: "BOL",
    CODE: 68,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bonaire, Sint Eustatius and Saba",
    ALPHA_2: "BQ",
    ALPHA_3: "BES",
    CODE: 535,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bosnia And Herzegovina",
    ALPHA_2: "BA",
    ALPHA_3: "BIH",
    CODE: 70,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Botswana",
    ALPHA_2: "BW",
    ALPHA_3: "BWA",
    CODE: 72,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bouvet Island",
    ALPHA_2: "BV",
    ALPHA_3: "BVT",
    CODE: 74,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Brazil",
    ALPHA_2: "BR",
    ALPHA_3: "BRA",
    CODE: 76,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "British Indian Ocean Territory",
    ALPHA_2: "IO",
    ALPHA_3: "IOT",
    CODE: 86,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Brunei Darussalam",
    ALPHA_2: "BN",
    ALPHA_3: "BRN",
    CODE: 96,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bulgaria",
    ALPHA_2: "BG",
    ALPHA_3: "BGR",
    CODE: 100,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burkina Faso",
    ALPHA_2: "BF",
    ALPHA_3: "BFA",
    CODE: 854,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burundi",
    ALPHA_2: "BI",
    ALPHA_3: "BDI",
    CODE: 108,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cape Verde",
    ALPHA_2: "CV",
    ALPHA_3: "CPV",
    CODE: 132,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cambodia",
    ALPHA_2: "KH",
    ALPHA_3: "KHM",
    CODE: 116,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cameroon",
    ALPHA_2: "CM",
    ALPHA_3: "CMR",
    CODE: 120,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Canada",
    ALPHA_2: "CA",
    ALPHA_3: "CAN",
    CODE: 124,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cayman Islands",
    ALPHA_2: "KY",
    ALPHA_3: "CYM",
    CODE: 136,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Central African Republic",
    ALPHA_2: "CF",
    ALPHA_3: "CAF",
    CODE: 140,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Chad",
    ALPHA_2: "TD",
    ALPHA_3: "TCD",
    CODE: 148,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Chile",
    ALPHA_2: "CL",
    ALPHA_3: "CHL",
    CODE: 152,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "China",
    ALPHA_2: "CN",
    ALPHA_3: "CHN",
    CODE: 156,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Christmas Island",
    ALPHA_2: "CX",
    ALPHA_3: "CXR",
    CODE: 162,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cocos (keeling) Islands",
    ALPHA_2: "CC",
    ALPHA_3: "CCK",
    CODE: 166,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Colombia",
    ALPHA_2: "CO",
    ALPHA_3: "COL",
    CODE: 170,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Comoros",
    ALPHA_2: "KM",
    ALPHA_3: "COM",
    CODE: 174,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Congo",
    ALPHA_2: "CG",
    ALPHA_3: "COG",
    CODE: 178,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Congo, The Democratic Republic Of The",
    ALPHA_2: "CD",
    ALPHA_3: "COD",
    CODE: 180,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cook Islands",
    ALPHA_2: "CK",
    ALPHA_3: "COK",
    CODE: 184,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Costa Rica",
    ALPHA_2: "CR",
    ALPHA_3: "CRI",
    CODE: 188,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "CÔte D'ivoire",
    ALPHA_2: "CI",
    ALPHA_3: "CIV",
    CODE: 384,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Croatia",
    ALPHA_2: "HR",
    ALPHA_3: "HRV",
    CODE: 191,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cuba",
    ALPHA_2: "CU",
    ALPHA_3: "CUB",
    CODE: 192,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Curaçao",
    ALPHA_2: "CW",
    ALPHA_3: "CUW",
    CODE: 531,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cyprus",
    ALPHA_2: "CY",
    ALPHA_3: "CYP",
    CODE: 196,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Czech Republic",
    ALPHA_2: "CZ",
    ALPHA_3: "CZE",
    CODE: 203,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Denmark",
    ALPHA_2: "DK",
    ALPHA_3: "DNK",
    CODE: 208,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Djibouti",
    ALPHA_2: "DJ",
    ALPHA_3: "DJI",
    CODE: 262,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Dominica",
    ALPHA_2: "DM",
    ALPHA_3: "DMA",
    CODE: 212,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Dominican Republic",
    ALPHA_2: "DO",
    ALPHA_3: "DOM",
    CODE: 214,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ecuador",
    ALPHA_2: "EC",
    ALPHA_3: "ECU",
    CODE: 218,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Egypt",
    ALPHA_2: "EG",
    ALPHA_3: "EGY",
    CODE: 818,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "El Salvador",
    ALPHA_2: "SV",
    ALPHA_3: "SLV",
    CODE: 222,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Equatorial Guinea",
    ALPHA_2: "GQ",
    ALPHA_3: "GNQ",
    CODE: 226,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Eritrea",
    ALPHA_2: "ER",
    ALPHA_3: "ERI",
    CODE: 232,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Estonia",
    ALPHA_2: "EE",
    ALPHA_3: "EST",
    CODE: 233,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Swaziland",
    ALPHA_2: "SZ",
    ALPHA_3: "SWZ",
    CODE: 748,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ethiopia",
    ALPHA_2: "ET",
    ALPHA_3: "ETH",
    CODE: 231,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Falkland Islands (malvinas)",
    ALPHA_2: "FK",
    ALPHA_3: "FLK",
    CODE: 238,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Faroe Islands",
    ALPHA_2: "FO",
    ALPHA_3: "FRO",
    CODE: 234,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Fiji",
    ALPHA_2: "FJ",
    ALPHA_3: "FJI",
    CODE: 242,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Finland",
    ALPHA_2: "FI",
    ALPHA_3: "FIN",
    CODE: 246,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "France",
    ALPHA_2: "FR",
    ALPHA_3: "FRA",
    CODE: 250,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Guiana",
    ALPHA_2: "GF",
    ALPHA_3: "GUF",
    CODE: 254,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Polynesia",
    ALPHA_2: "PF",
    ALPHA_3: "PYF",
    CODE: 258,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Southern Territories",
    ALPHA_2: "TF",
    ALPHA_3: "ATF",
    CODE: 260,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Gabon",
    ALPHA_2: "GA",
    ALPHA_3: "GAB",
    CODE: 266,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "The Gambia",
    ALPHA_2: "GM",
    ALPHA_3: "GMB",
    CODE: 270,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Georgia",
    ALPHA_2: "GE",
    ALPHA_3: "GEO",
    CODE: 268,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Germany",
    ALPHA_2: "DE",
    ALPHA_3: "DEU",
    CODE: 276,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ghana",
    ALPHA_2: "GH",
    ALPHA_3: "GHA",
    CODE: 288,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Gibraltar",
    ALPHA_2: "GI",
    ALPHA_3: "GIB",
    CODE: 292,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Greece",
    ALPHA_2: "GR",
    ALPHA_3: "GRC",
    CODE: 300,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Greenland",
    ALPHA_2: "GL",
    ALPHA_3: "GRL",
    CODE: 304,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Grenada",
    ALPHA_2: "GD",
    ALPHA_3: "GRD",
    CODE: 308,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guadeloupe",
    ALPHA_2: "GP",
    ALPHA_3: "GLP",
    CODE: 312,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guam",
    ALPHA_2: "GU",
    ALPHA_3: "GUM",
    CODE: 316,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guatemala",
    ALPHA_2: "GT",
    ALPHA_3: "GTM",
    CODE: 320,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guernsey",
    ALPHA_2: "GG",
    ALPHA_3: "GGY",
    CODE: 831,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guinea",
    ALPHA_2: "GN",
    ALPHA_3: "GIN",
    CODE: 324,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guinea-Bissau",
    ALPHA_2: "GW",
    ALPHA_3: "GNB",
    CODE: 624,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guyana",
    ALPHA_2: "GY",
    ALPHA_3: "GUY",
    CODE: 328,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Haiti",
    ALPHA_2: "HT",
    ALPHA_3: "HTI",
    CODE: 332,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Heard Island And Mcdonald Islands",
    ALPHA_2: "HM",
    ALPHA_3: "HMD",
    CODE: 334,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Vatican City",
    ALPHA_2: "VA",
    ALPHA_3: "VAT",
    CODE: 336,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Honduras",
    ALPHA_2: "HN",
    ALPHA_3: "HND",
    CODE: 340,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Hong Kong",
    ALPHA_2: "HK",
    ALPHA_3: "HKG",
    CODE: 344,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Hungary",
    ALPHA_2: "HU",
    ALPHA_3: "HUN",
    CODE: 348,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iceland",
    ALPHA_2: "IS",
    ALPHA_3: "ISL",
    CODE: 352,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "India",
    ALPHA_2: "IN",
    ALPHA_3: "IND",
    CODE: 356,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Indonesia",
    ALPHA_2: "ID",
    ALPHA_3: "IDN",
    CODE: 360,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iran",
    ALPHA_2: "IR",
    ALPHA_3: "IRN",
    CODE: 364,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iraq",
    ALPHA_2: "IQ",
    ALPHA_3: "IRQ",
    CODE: 368,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ireland",
    ALPHA_2: "IE",
    ALPHA_3: "IRL",
    CODE: 372,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Isle Of Man",
    ALPHA_2: "IM",
    ALPHA_3: "IMN",
    CODE: 833,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Israel",
    ALPHA_2: "IL",
    ALPHA_3: "ISR",
    CODE: 376,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Italy",
    ALPHA_2: "IT",
    ALPHA_3: "ITA",
    CODE: 380,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jamaica",
    ALPHA_2: "JM",
    ALPHA_3: "JAM",
    CODE: 388,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Japan",
    ALPHA_2: "JP",
    ALPHA_3: "JPN",
    CODE: 392,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jersey",
    ALPHA_2: "JE",
    ALPHA_3: "JEY",
    CODE: 832,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jordan",
    ALPHA_2: "JO",
    ALPHA_3: "JOR",
    CODE: 400,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kazakhstan",
    ALPHA_2: "KZ",
    ALPHA_3: "KAZ",
    CODE: 398,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kenya",
    ALPHA_2: "KE",
    ALPHA_3: "KEN",
    CODE: 404,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kiribati",
    ALPHA_2: "KI",
    ALPHA_3: "KIR",
    CODE: 296,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "North Korea",
    ALPHA_2: "KP",
    ALPHA_3: "PRK",
    CODE: 408,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Korea",
    ALPHA_2: "KR",
    ALPHA_3: "KOR",
    CODE: 410,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kuwait",
    ALPHA_2: "KW",
    ALPHA_3: "KWT",
    CODE: 414,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kyrgyzstan",
    ALPHA_2: "KG",
    ALPHA_3: "KGZ",
    CODE: 417,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lao People's Democratic Republic",
    ALPHA_2: "LA",
    ALPHA_3: "LAO",
    CODE: 418,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Latvia",
    ALPHA_2: "LV",
    ALPHA_3: "LVA",
    CODE: 428,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lebanon",
    ALPHA_2: "LB",
    ALPHA_3: "LBN",
    CODE: 422,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lesotho",
    ALPHA_2: "LS",
    ALPHA_3: "LSO",
    CODE: 426,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Liberia",
    ALPHA_2: "LR",
    ALPHA_3: "LBR",
    CODE: 430,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Libya",
    ALPHA_2: "LY",
    ALPHA_3: "LBY",
    CODE: 434,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Liechtenstein",
    ALPHA_2: "LI",
    ALPHA_3: "LIE",
    CODE: 438,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lithuania",
    ALPHA_2: "LT",
    ALPHA_3: "LTU",
    CODE: 440,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Luxembourg",
    ALPHA_2: "LU",
    ALPHA_3: "LUX",
    CODE: 442,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Macao",
    ALPHA_2: "MO",
    ALPHA_3: "MAC",
    CODE: 446,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Republic of Macedonia",
    ALPHA_2: "MK",
    ALPHA_3: "MKD",
    CODE: 807,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Madagascar",
    ALPHA_2: "MG",
    ALPHA_3: "MDG",
    CODE: 450,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malawi",
    ALPHA_2: "MW",
    ALPHA_3: "MWI",
    CODE: 454,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malaysia",
    ALPHA_2: "MY",
    ALPHA_3: "MYS",
    CODE: 458,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Maldives",
    ALPHA_2: "MV",
    ALPHA_3: "MDV",
    CODE: 462,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mali",
    ALPHA_2: "ML",
    ALPHA_3: "MLI",
    CODE: 466,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malta",
    ALPHA_2: "MT",
    ALPHA_3: "MLT",
    CODE: 470,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Marshall Islands",
    ALPHA_2: "MH",
    ALPHA_3: "MHL",
    CODE: 584,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Martinique",
    ALPHA_2: "MQ",
    ALPHA_3: "MTQ",
    CODE: 474,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mauritania",
    ALPHA_2: "MR",
    ALPHA_3: "MRT",
    CODE: 478,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mauritius",
    ALPHA_2: "MU",
    ALPHA_3: "MUS",
    CODE: 480,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mayotte",
    ALPHA_2: "YT",
    ALPHA_3: "MYT",
    CODE: 175,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mexico",
    ALPHA_2: "MX",
    ALPHA_3: "MEX",
    CODE: 484,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Micronesia, Federated States Of",
    ALPHA_2: "FM",
    ALPHA_3: "FSM",
    CODE: 583,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Moldova",
    ALPHA_2: "MD",
    ALPHA_3: "MDA",
    CODE: 498,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Monaco",
    ALPHA_2: "MC",
    ALPHA_3: "MCO",
    CODE: 492,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mongolia",
    ALPHA_2: "MN",
    ALPHA_3: "MNG",
    CODE: 496,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Montenegro",
    ALPHA_2: "ME",
    ALPHA_3: "MNE",
    CODE: 499,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Montserrat",
    ALPHA_2: "MS",
    ALPHA_3: "MSR",
    CODE: 500,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Morocco",
    ALPHA_2: "MA",
    ALPHA_3: "MAR",
    CODE: 504,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mozambique",
    ALPHA_2: "MZ",
    ALPHA_3: "MOZ",
    CODE: 508,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burma",
    ALPHA_2: "MM",
    ALPHA_3: "MMR",
    CODE: 104,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Namibia",
    ALPHA_2: "NA",
    ALPHA_3: "NAM",
    CODE: 516,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nauru",
    ALPHA_2: "NR",
    ALPHA_3: "NRU",
    CODE: 520,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nepal",
    ALPHA_2: "NP",
    ALPHA_3: "NPL",
    CODE: 524,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Netherlands",
    ALPHA_2: "NL",
    ALPHA_3: "NLD",
    CODE: 528,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "New Caledonia",
    ALPHA_2: "NC",
    ALPHA_3: "NCL",
    CODE: 540,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "New Zealand",
    ALPHA_2: "NZ",
    ALPHA_3: "NZL",
    CODE: 554,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nicaragua",
    ALPHA_2: "NI",
    ALPHA_3: "NIC",
    CODE: 558,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Niger",
    ALPHA_2: "NE",
    ALPHA_3: "NER",
    CODE: 562,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nigeria",
    ALPHA_2: "NG",
    ALPHA_3: "NGA",
    CODE: 566,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Niue",
    ALPHA_2: "NU",
    ALPHA_3: "NIU",
    CODE: 570,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Norfolk Island",
    ALPHA_2: "NF",
    ALPHA_3: "NFK",
    CODE: 574,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Northern Mariana Islands",
    ALPHA_2: "MP",
    ALPHA_3: "MNP",
    CODE: 580,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Norway",
    ALPHA_2: "NO",
    ALPHA_3: "NOR",
    CODE: 578,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Oman",
    ALPHA_2: "OM",
    ALPHA_3: "OMN",
    CODE: 512,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Pakistan",
    ALPHA_2: "PK",
    ALPHA_3: "PAK",
    CODE: 586,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Palau",
    ALPHA_2: "PW",
    ALPHA_3: "PLW",
    CODE: 585,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Palestinian Territory",
    ALPHA_2: "PS",
    ALPHA_3: "PSE",
    CODE: 275,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Panama",
    ALPHA_2: "PA",
    ALPHA_3: "PAN",
    CODE: 591,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Papua New Guinea",
    ALPHA_2: "PG",
    ALPHA_3: "PNG",
    CODE: 598,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Paraguay",
    ALPHA_2: "PY",
    ALPHA_3: "PRY",
    CODE: 600,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Peru",
    ALPHA_2: "PE",
    ALPHA_3: "PER",
    CODE: 604,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Philippines",
    ALPHA_2: "PH",
    ALPHA_3: "PHL",
    CODE: 608,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Pitcairn",
    ALPHA_2: "PN",
    ALPHA_3: "PCN",
    CODE: 612,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Poland",
    ALPHA_2: "PL",
    ALPHA_3: "POL",
    CODE: 616,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Portugal",
    ALPHA_2: "PT",
    ALPHA_3: "PRT",
    CODE: 620,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Puerto Rico",
    ALPHA_2: "PR",
    ALPHA_3: "PRI",
    CODE: 630,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Qatar",
    ALPHA_2: "QA",
    ALPHA_3: "QAT",
    CODE: 634,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "RÉunion",
    ALPHA_2: "RE",
    ALPHA_3: "REU",
    CODE: 638,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Romania",
    ALPHA_2: "RO",
    ALPHA_3: "ROU",
    CODE: 642,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Russian Federation",
    ALPHA_2: "RU",
    ALPHA_3: "RUS",
    CODE: 643,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Rwanda",
    ALPHA_2: "RW",
    ALPHA_3: "RWA",
    CODE: 646,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Barthélemy",
    ALPHA_2: "BL",
    ALPHA_3: "BLM",
    CODE: 652,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Helena",
    ALPHA_2: "SH",
    ALPHA_3: "SHN",
    CODE: 654,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Kitts And Nevis",
    ALPHA_2: "KN",
    ALPHA_3: "KNA",
    CODE: 659,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Lucia",
    ALPHA_2: "LC",
    ALPHA_3: "LCA",
    CODE: 662,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Martin (French part)",
    ALPHA_2: "MF",
    ALPHA_3: "MAF",
    CODE: 663,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Pierre And Miquelon",
    ALPHA_2: "PM",
    ALPHA_3: "SPM",
    CODE: 666,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Vincent and the Grenadines",
    ALPHA_2: "VC",
    ALPHA_3: "VCT",
    CODE: 670,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Samoa",
    ALPHA_2: "WS",
    ALPHA_3: "WSM",
    CODE: 882,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "San Marino",
    ALPHA_2: "SM",
    ALPHA_3: "SMR",
    CODE: 674,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sao Tome And Principe",
    ALPHA_2: "ST",
    ALPHA_3: "STP",
    CODE: 678,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saudi Arabia",
    ALPHA_2: "SA",
    ALPHA_3: "SAU",
    CODE: 682,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Senegal",
    ALPHA_2: "SN",
    ALPHA_3: "SEN",
    CODE: 686,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Serbia",
    ALPHA_2: "RS",
    ALPHA_3: "SRB",
    CODE: 688,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Seychelles",
    ALPHA_2: "SC",
    ALPHA_3: "SYC",
    CODE: 690,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sierra Leone",
    ALPHA_2: "SL",
    ALPHA_3: "SLE",
    CODE: 694,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Singapore",
    ALPHA_2: "SG",
    ALPHA_3: "SGP",
    CODE: 702,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sint Maarten (Dutch part)",
    ALPHA_2: "SX",
    ALPHA_3: "SXM",
    CODE: 534,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Slovakia",
    ALPHA_2: "SK",
    ALPHA_3: "SVK",
    CODE: 703,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Slovenia",
    ALPHA_2: "SI",
    ALPHA_3: "SVN",
    CODE: 705,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Solomon Islands",
    ALPHA_2: "SB",
    ALPHA_3: "SLB",
    CODE: 90,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Somalia",
    ALPHA_2: "SO",
    ALPHA_3: "SOM",
    CODE: 706,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Africa",
    ALPHA_2: "ZA",
    ALPHA_3: "ZAF",
    CODE: 710,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Georgia And The South Sandwich Islands",
    ALPHA_2: "GS",
    ALPHA_3: "SGS",
    CODE: 239,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Sudan",
    ALPHA_2: "SS",
    ALPHA_3: "SSD",
    CODE: 728,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Spain",
    ALPHA_2: "ES",
    ALPHA_3: "ESP",
    CODE: 724,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sri Lanka",
    ALPHA_2: "LK",
    ALPHA_3: "LKA",
    CODE: 144,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sudan",
    ALPHA_2: "SD",
    ALPHA_3: "SDN",
    CODE: 729,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Suriname",
    ALPHA_2: "SR",
    ALPHA_3: "SUR",
    CODE: 740,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Svalbard And Jan Mayen",
    ALPHA_2: "SJ",
    ALPHA_3: "SJM",
    CODE: 744,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sweden",
    ALPHA_2: "SE",
    ALPHA_3: "SWE",
    CODE: 752,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Switzerland",
    ALPHA_2: "CH",
    ALPHA_3: "CHE",
    CODE: 756,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Syrian Arab Republic",
    ALPHA_2: "SY",
    ALPHA_3: "SYR",
    CODE: 760,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Taiwan",
    ALPHA_2: "TW",
    ALPHA_3: "TWN",
    CODE: 158,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tajikistan",
    ALPHA_2: "TJ",
    ALPHA_3: "TJK",
    CODE: 762,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tanzania, United Republic Of",
    ALPHA_2: "TZ",
    ALPHA_3: "TZA",
    CODE: 834,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Thailand",
    ALPHA_2: "TH",
    ALPHA_3: "THA",
    CODE: 764,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "East Timor",
    ALPHA_2: "TL",
    ALPHA_3: "TLS",
    CODE: 626,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Togo",
    ALPHA_2: "TG",
    ALPHA_3: "TGO",
    CODE: 768,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tokelau",
    ALPHA_2: "TK",
    ALPHA_3: "TKL",
    CODE: 772,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tonga",
    ALPHA_2: "TO",
    ALPHA_3: "TON",
    CODE: 776,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Trinidad And Tobago",
    ALPHA_2: "TT",
    ALPHA_3: "TTO",
    CODE: 780,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tunisia",
    ALPHA_2: "TN",
    ALPHA_3: "TUN",
    CODE: 788,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turkey",
    ALPHA_2: "TR",
    ALPHA_3: "TUR",
    CODE: 792,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turkmenistan",
    ALPHA_2: "TM",
    ALPHA_3: "TKM",
    CODE: 795,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turks And Caicos Islands",
    ALPHA_2: "TC",
    ALPHA_3: "TCA",
    CODE: 796,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tuvalu",
    ALPHA_2: "TV",
    ALPHA_3: "TUV",
    CODE: 798,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uganda",
    ALPHA_2: "UG",
    ALPHA_3: "UGA",
    CODE: 800,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ukraine",
    ALPHA_2: "UA",
    ALPHA_3: "UKR",
    CODE: 804,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United Arab Emirates",
    ALPHA_2: "AE",
    ALPHA_3: "ARE",
    CODE: 784,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United Kingdom",
    ALPHA_2: "GB",
    ALPHA_3: "GBR",
    CODE: 826,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United States",
    ALPHA_2: "US",
    ALPHA_3: "USA",
    CODE: 840,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United States Minor Outlying Islands",
    ALPHA_2: "UM",
    ALPHA_3: "UMI",
    CODE: 581,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uruguay",
    ALPHA_2: "UY",
    ALPHA_3: "URY",
    CODE: 858,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uzbekistan",
    ALPHA_2: "UZ",
    ALPHA_3: "UZB",
    CODE: 860,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Vanuatu",
    ALPHA_2: "VU",
    ALPHA_3: "VUT",
    CODE: 548,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Venezuela",
    ALPHA_2: "VE",
    ALPHA_3: "VEN",
    CODE: 862,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Viet Nam",
    ALPHA_2: "VN",
    ALPHA_3: "VNM",
    CODE: 704,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "British Virgin Islands",
    ALPHA_2: "VG",
    ALPHA_3: "VGB",
    CODE: 92,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Virgin Islands, U.s.",
    ALPHA_2: "VI",
    ALPHA_3: "VIR",
    CODE: 850,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Wallis And Futuna",
    ALPHA_2: "WF",
    ALPHA_3: "WLF",
    CODE: 876,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Western Sahara",
    ALPHA_2: "EH",
    ALPHA_3: "ESH",
    CODE: 732,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Yemen",
    ALPHA_2: "YE",
    ALPHA_3: "YEM",
    CODE: 887,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Zambia",
    ALPHA_2: "ZM",
    ALPHA_3: "ZMB",
    CODE: 894,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Zimbabwe",
    ALPHA_2: "ZW",
    ALPHA_3: "ZWE",
    CODE: 716,
    HAS_AUDIENCE: !0
  }
], OH = ({ countryCode: e }) => {
  const t = e?.toUpperCase();
  return PH.find(
    (r) => r.ALPHA_2 === t || r.ALPHA_3 === t || r.NAME.toUpperCase() === t
  );
}, sp = {
  subscribers: {
    key: "creator-widget.subscribers",
    defaultValue: "Inscritos"
  },
  engagement: {
    key: "creator-widget.engagement",
    defaultValue: "Engajamento/Vídeo"
  }
}, LH = ({ creator: e, workspaceId: t, t: n }) => ({
  data: pe(() => {
    if (!e || !t) return;
    const i = Rn(mr[le.CREATOR], {
      id: e.id,
      provider: e.provider
    }), s = e.performance?.analytics;
    return {
      title: e.title,
      hasTrendTag: e.isTrending,
      creatorUrl: i,
      provider: e.provider,
      thumbnail: {
        imageUrl: e.thumbnail ?? ""
      },
      description: OH({ countryCode: e.country ?? "" })?.NAME,
      metrics: {
        data: [
          { title: n(sp.subscribers), value: an(e.subscribers) },
          {
            title: n(sp.engagement),
            value: an(s?.avgEngagement ?? 0),
            variation: s?.avgEngagementVariation && s.avgEngagementVariation !== 0 ? {
              value: `${Math.abs(s.avgEngagementVariation * 100).toFixed(1)}%`,
              sign: s.avgEngagementVariation > 0 ? "positive" : "negative"
            } : void 0
          }
        ]
      }
    };
  }, [t, e, n])
}), MH = () => /* @__PURE__ */ p.jsxDEV("div", { className: "flex w-full h-full gap-4", children: [
  /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-[6px] w-[100px] h-full min-h-[112px] shrink-0" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
    lineNumber: 8,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col w-full h-[100%] gap-6", children: [
    /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
      lineNumber: 10,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("div", { className: "flex w-full gap-6", children: [
      /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col gap-2 w-[40%]", children: [
        /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
          lineNumber: 13,
          columnNumber: 13
        }, void 0),
        /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-[6px] w-[80%] h-[10px]" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
          lineNumber: 14,
          columnNumber: 13
        }, void 0)
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
        lineNumber: 12,
        columnNumber: 11
      }, void 0),
      /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col gap-2 w-[40%]", children: [
        /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
          lineNumber: 17,
          columnNumber: 13
        }, void 0),
        /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-[6px] w-[80%] h-[10px]" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
          lineNumber: 18,
          columnNumber: 13
        }, void 0)
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
        lineNumber: 16,
        columnNumber: 11
      }, void 0)
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
      lineNumber: 11,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
    lineNumber: 9,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.skeleton.tsx",
  lineNumber: 7,
  columnNumber: 5
}, void 0), UH = Ce(MH), HH = ({ data: e, refetch: t, showError: n, showLoading: r, theme: i }) => /* @__PURE__ */ p.jsxDEV("div", { className: "w-[324px] min-h-[112px] mt-[20px] mb-[40px] px-4 flex float-left", children: /* @__PURE__ */ p.jsxDEV(
  Jr,
  {
    isLoading: r,
    isError: n,
    loadingComponent: /* @__PURE__ */ p.jsxDEV(UH, {}, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.view.tsx",
      lineNumber: 16,
      columnNumber: 25
    }, void 0),
    errorComponent: /* @__PURE__ */ p.jsxDEV(zi, { name: "creator", refetch: t }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.view.tsx",
      lineNumber: 17,
      columnNumber: 23
    }, void 0),
    children: e && /* @__PURE__ */ p.jsxDEV(
      bn.CreatorCardDefault,
      {
        ...e,
        theme: i,
        thumbnail: {
          ...e.thumbnail,
          IconProvider: /* @__PURE__ */ p.jsxDEV(
            bn.Icon,
            {
              name: qc[e.provider],
              width: 24,
              height: qc[e.provider] === "youtube" ? 17 : 24
            },
            void 0,
            !1,
            {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.view.tsx",
              lineNumber: 26,
              columnNumber: 15
            },
            void 0
          )
        }
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.view.tsx",
        lineNumber: 20,
        columnNumber: 9
      },
      void 0
    )
  },
  void 0,
  !1,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.view.tsx",
    lineNumber: 13,
    columnNumber: 5
  },
  void 0
) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/creator-widget.view.tsx",
  lineNumber: 12,
  columnNumber: 3
}, void 0), jH = Ce(HH), BH = ({ creatorId: e, performanceInMonths: t }) => {
  const { workspaceId: n } = St(), r = yr(), { t: i } = Je(), {
    data: s,
    fetch: a,
    isError: o,
    isLoading: u
  } = RH({
    creatorId: e,
    performanceInMonths: t
  }), c = LH({
    workspaceId: n,
    creator: s,
    t: i
  });
  return /* @__PURE__ */ p.jsxDEV(
    jH,
    {
      ...c,
      theme: r,
      showError: o,
      showLoading: u,
      refetch: a
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/creator-widget/index.tsx",
      lineNumber: 35,
      columnNumber: 5
    },
    void 0
  );
}, FH = Ce(BH), zH = ({ postId: e }) => {
  const { workspaceId: t } = St(), n = Xr(), [r, i] = we(!1), [s, a] = we(!1), [o, u] = we(null), c = de(async () => {
    const l = `/api/workspace/${t}/posts/${e}`;
    if (!(!e || !t))
      try {
        i(!0), a(!1);
        const d = await n.getPostData(e);
        u(d);
      } catch (d) {
        console.error({
          log: "Zai Chat - Error to fetch post from backend",
          query: { name: l, variables: { postId: e } },
          error: d
        }), a(!0);
      } finally {
        i(!1);
      }
  }, [t, e, n]);
  return Le(() => {
    c();
  }, [c]), {
    isLoading: r,
    isError: s,
    data: o,
    fetch: c
  };
};
var qa = { exports: {} }, VH = qa.exports, ap;
function WH() {
  return ap || (ap = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(VH, (function() {
      return function(n, r, i) {
        n = n || {};
        var s = r.prototype, a = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function o(c, l, d, h) {
          return s.fromToBase(c, l, d, h);
        }
        i.en.relativeTime = a, s.fromToBase = function(c, l, d, h, m) {
          for (var E, g, T, _ = d.$locale().relativeTime || a, A = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], w = A.length, M = 0; M < w; M += 1) {
            var F = A[M];
            F.d && (E = h ? i(c).diff(d, F.d, !0) : d.diff(c, F.d, !0));
            var k = (n.rounding || Math.round)(Math.abs(E));
            if (T = E > 0, k <= F.r || !F.r) {
              k <= 1 && M > 0 && (F = A[M - 1]);
              var B = _[F.l];
              m && (k = m("" + k)), g = typeof B == "string" ? B.replace("%d", k) : B(k, l, F.l, T);
              break;
            }
          }
          if (l) return g;
          var $ = T ? _.future : _.past;
          return typeof $ == "function" ? $(g) : $.replace("%s", g);
        }, s.to = function(c, l) {
          return o(c, l, this, !0);
        }, s.from = function(c, l) {
          return o(c, l, this);
        };
        var u = function(c) {
          return c.$u ? i.utc() : i();
        };
        s.toNow = function(c) {
          return this.to(u(this), c);
        }, s.fromNow = function(c) {
          return this.from(u(this), c);
        };
      };
    }));
  })(qa)), qa.exports;
}
var $H = WH();
const YH = /* @__PURE__ */ pr($H);
var Ka = { exports: {} }, GH = Ka.exports, op;
function qH() {
  return op || (op = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(GH, (function() {
      var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, i = /([+-]|\d\d)/g;
      return function(s, a, o) {
        var u = a.prototype;
        o.utc = function(g) {
          var T = { date: g, utc: !0, args: arguments };
          return new a(T);
        }, u.utc = function(g) {
          var T = o(this.toDate(), { locale: this.$L, utc: !0 });
          return g ? T.add(this.utcOffset(), n) : T;
        }, u.local = function() {
          return o(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var c = u.parse;
        u.parse = function(g) {
          g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), c.call(this, g);
        };
        var l = u.init;
        u.init = function() {
          if (this.$u) {
            var g = this.$d;
            this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
          } else l.call(this);
        };
        var d = u.utcOffset;
        u.utcOffset = function(g, T) {
          var _ = this.$utils().u;
          if (_(g)) return this.$u ? 0 : _(this.$offset) ? d.call(this) : this.$offset;
          if (typeof g == "string" && (g = (function(F) {
            F === void 0 && (F = "");
            var k = F.match(r);
            if (!k) return null;
            var B = ("" + k[0]).match(i) || ["-", 0, 0], $ = B[0], J = 60 * +B[1] + +B[2];
            return J === 0 ? 0 : $ === "+" ? J : -J;
          })(g), g === null)) return this;
          var A = Math.abs(g) <= 16 ? 60 * g : g;
          if (A === 0) return this.utc(T);
          var w = this.clone();
          if (T) return w.$offset = A, w.$u = !1, w;
          var M = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (w = this.local().add(A + M, n)).$offset = A, w.$x.$localOffset = M, w;
        };
        var h = u.format;
        u.format = function(g) {
          var T = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return h.call(this, T);
        }, u.valueOf = function() {
          var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * g;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var m = u.toDate;
        u.toDate = function(g) {
          return g === "s" && this.$offset ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : m.call(this);
        };
        var E = u.diff;
        u.diff = function(g, T, _) {
          if (g && this.$u === g.$u) return E.call(this, g, T, _);
          var A = this.local(), w = o(g).local();
          return E.call(A, w, T, _);
        };
      };
    }));
  })(Ka)), Ka.exports;
}
var KH = qH();
const QH = /* @__PURE__ */ pr(KH);
var Qa = { exports: {} }, XH = Qa.exports, up;
function JH() {
  return up || (up = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(XH, (function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
        var r = ["th", "st", "nd", "rd"], i = n % 100;
        return "[" + n + (r[(i - 20) % 10] || r[i] || r[0]) + "]";
      } };
    }));
  })(Qa)), Qa.exports;
}
JH();
var Xa = { exports: {} }, ZH = Xa.exports, cp;
function ej() {
  return cp || (cp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r(Fd());
    })(ZH, (function(n) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var i = r(n), s = { name: "pt-br", weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"), weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"), weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"), months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"), monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"), ordinal: function(a) {
        return a + "º";
      }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY [às] HH:mm", LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm" }, relativeTime: { future: "em %s", past: "há %s", s: "poucos segundos", m: "um minuto", mm: "%d minutos", h: "uma hora", hh: "%d horas", d: "um dia", dd: "%d dias", M: "um mês", MM: "%d meses", y: "um ano", yy: "%d anos" } };
      return i.default.locale(s, null, !0), s;
    }));
  })(Xa)), Xa.exports;
}
ej();
var Ja = { exports: {} }, tj = Ja.exports, lp;
function nj() {
  return lp || (lp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r(Fd());
    })(tj, (function(n) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var i = r(n), s = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(a) {
        return a + "º";
      } };
      return i.default.locale(s, null, !0), s;
    }));
  })(Ja)), Ja.exports;
}
nj();
Br.extend(YH);
Br.extend(QH);
const Wd = class Wd {
  static formatDate(t, n = "MMM YYYY") {
    return Br(t).format(n);
  }
};
Wd.getFormattedRelativeTime = (t, n) => Br(t).locale(n.toLowerCase()).fromNow();
let cr = Wd;
const rj = ({ post: e, workspaceId: t, currentLanguage: n }) => ({
  data: pe(() => {
    if (!e || !t) return;
    const i = Rn(mr[le.POST], {
      id: e.id,
      provider: e.provider,
      panelId: t
    });
    return {
      creatorUrl: e?.creator?.id && e?.creator?.provider ? Rn(mr[le.CREATOR], {
        id: e?.creator?.id,
        provider: e?.creator?.provider
      }) : void 0,
      videoUrl: i,
      provider: e?.provider,
      thumbnail: {
        imageUrl: e?.thumbnail ?? ""
      },
      description: e?.title,
      metrics: {
        data: [
          { title: "Views", value: an(e?.views) },
          { title: "Likes", value: an(e?.likes) }
        ]
      },
      creator: {
        title: e?.creator?.title,
        description: cr.getFormattedRelativeTime(e?.publishedAt, n),
        thumbnail: e?.creator?.thumbnail ?? ""
      }
    };
  }, [t, e, n])
}), ij = () => /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col w-full h-[312px] gap-4", children: [
  /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-lg w-[100%] h-[100%]" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.skeleton.tsx",
    lineNumber: 8,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-lg w-[80%] h-4" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.skeleton.tsx",
    lineNumber: 9,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-lg w-[50%] h-4" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.skeleton.tsx",
    lineNumber: 10,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.skeleton.tsx",
  lineNumber: 7,
  columnNumber: 5
}, void 0), sj = Ce(ij), aj = ({ data: e, refetch: t, showError: n, showLoading: r, theme: i }) => /* @__PURE__ */ p.jsxDEV("div", { className: "w-[324px] min-h-[312px] mt-[20px] mb-[40px] px-4 flex float-left", children: /* @__PURE__ */ p.jsxDEV(
  Jr,
  {
    isLoading: r,
    isError: n,
    loadingComponent: /* @__PURE__ */ p.jsxDEV(sj, {}, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.view.tsx",
      lineNumber: 17,
      columnNumber: 27
    }, void 0),
    errorComponent: /* @__PURE__ */ p.jsxDEV(zi, { name: "video", refetch: t }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.view.tsx",
      lineNumber: 18,
      columnNumber: 25
    }, void 0),
    children: e && /* @__PURE__ */ p.jsxDEV(
      bn.VideoCardDefault,
      {
        ...e,
        theme: i,
        thumbnail: {
          ...e.thumbnail,
          IconProvider: /* @__PURE__ */ p.jsxDEV(bn.Icon, { name: qc[e.provider], width: 30, height: 30 }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.view.tsx",
            lineNumber: 26,
            columnNumber: 29
          }, void 0)
        }
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.view.tsx",
        lineNumber: 21,
        columnNumber: 11
      },
      void 0
    )
  },
  void 0,
  !1,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.view.tsx",
    lineNumber: 14,
    columnNumber: 7
  },
  void 0
) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/post-widget.view.tsx",
  lineNumber: 13,
  columnNumber: 5
}, void 0), oj = Ce(aj), uj = ({ postId: e }) => {
  const { workspaceId: t } = St(), n = yr(), { language: r } = Qs(), {
    data: i,
    fetch: s,
    isError: a,
    isLoading: o
  } = zH({
    postId: e
  }), u = rj({
    workspaceId: t,
    post: i,
    currentLanguage: r
  });
  return /* @__PURE__ */ p.jsxDEV(oj, { ...u, theme: n, showError: a, showLoading: o, refetch: s }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/post-widget/index.tsx",
    lineNumber: 34,
    columnNumber: 5
  }, void 0);
}, cj = Ce(uj), Fr = {
  categoryInfo: (e) => ({
    key: "share-of-attention-widget.category-info",
    parameters: e,
    defaultValue: "Categoria: {category} - País: {country} - Período: {period}"
  }),
  accessMacroarea: {
    key: "share-of-attention-widget.access-macroarea",
    defaultValue: "Acessar SoA"
  },
  emptyText: {
    key: "share-of-attention-widget.empty-text",
    defaultValue: "Dados insuficientes para exibir o gráfico no momento"
  },
  columnChart: {
    key: "share-of-attention-widget.column-chart",
    defaultValue: "Gráfico de Colunas"
  },
  lineChart: {
    key: "share-of-attention-widget.line-chart",
    defaultValue: "Gráfico de Linhas"
  },
  quarter: (e) => ({
    key: "share-of-attention-widget.quarter",
    parameters: e,
    defaultValue: "{quarter}º Trimestre"
  }),
  halfYear: (e) => ({
    key: "share-of-attention-widget.half-year",
    parameters: e,
    defaultValue: "{semester}º Semestre"
  })
}, lj = () => Intl.DateTimeFormat().resolvedOptions().timeZone, Hx = (e, t) => {
  const n = Math.ceil((e.getUTCMonth() + 1) / 3);
  return t ? t(Fr.quarter({ quarter: n })) : `${n}º Trimestre`;
}, jx = (e, t) => {
  const n = e.getUTCMonth() + 1 <= 6 ? 1 : 2;
  return t ? t(Fr.halfYear({ semester: n })) : `${n}º Semestre`;
}, dj = (e, t, n = {}) => {
  const { timezone: r = lj(), locale: i = "en-US", translate: s } = n, a = new Date(e), o = {
    timeZone: r
  };
  switch (t) {
    case "monthly":
      return new Intl.DateTimeFormat(i, {
        ...o,
        month: "short"
      }).format(a);
    case "daily":
      return new Intl.DateTimeFormat("en-GB", {
        ...o,
        day: "2-digit",
        month: "2-digit"
      }).format(a);
    case "full":
      return new Intl.DateTimeFormat(i, {
        ...o,
        year: "numeric",
        month: "short",
        day: "numeric"
      }).format(a);
    case "quarterly":
      return Hx(a, s);
    case "halfYearly":
      return jx(a, s);
    default:
      return e;
  }
}, fj = (e, t, n = "en-US", r) => dj(e, t, { timezone: "UTC", locale: n, translate: r }), dp = (e, t, n) => {
  const r = new Date(e);
  switch (t) {
    case "monthly":
      return new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        month: "short",
        year: "numeric"
      }).format(r);
    case "daily":
    case "weekly":
      return new Intl.DateTimeFormat("en-GB", {
        timeZone: "UTC",
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }).format(r);
    case "quarterly":
      return Hx(r, n);
    case "halfYearly":
      return jx(r, n);
    default:
      return e;
  }
}, hj = ({
  period: e = "monthly",
  year: t = (/* @__PURE__ */ new Date()).getFullYear()
} = {}) => {
  const n = ru.isEnabled("isSOAV3WithZaiEnabled"), { t: r } = Je(), { workspaceId: i } = St(), s = Xr(), a = Rn(mr[le.SHARE_OF_ATTENTION_V2], {
    panelId: i
  }), [o, u] = we(null), [c, l] = we(!1), [d, h] = we(!1), [m, E] = we("column"), g = de(async () => {
    if (i) {
      l(!0), h(!1);
      try {
        const k = await s.getShareOfAttentionData(
          {
            period: e,
            year: t.toString()
          },
          { isSOAV3WithZaiEnabled: n }
        );
        u(k);
      } catch {
        h(!0), u(null);
      } finally {
        l(!1);
      }
    }
  }, [i, e, t, s, n]);
  Le(() => {
    g();
  }, [g]);
  const T = pe(() => !o?.brands || o.brands.length === 0 ? [] : [...new Set(o.brands.flatMap((k) => k.scores.map((B) => B.date)))].sort(
    (k, B) => k.localeCompare(B)
  ), [o?.brands]), _ = pe(() => o?.brands ? o.brands.map((k) => {
    const B = new Map(k.scores.map(($) => [$.date, $.value]));
    return {
      name: k.name,
      color: k.color,
      series: T.map(($) => B.get($) ?? 0)
    };
  }) : [], [o, T]), A = pe(() => T.map((k) => fj(k, e, "en-US", r)), [T, e, r]), w = pe(() => {
    if (!o?.category || T.length === 0) return "";
    const k = T[0], B = T[T.length - 1], $ = `${dp(k, e, r)} - ${dp(B, e, r)}`;
    return r(
      Fr.categoryInfo({
        category: o.category.name,
        country: o.category.country,
        period: $
      })
    );
  }, [T, o?.category, e, r]), M = pe(
    () => _.flatMap((k) => k.series).every((k) => k === 0),
    [_]
  ), F = pe(() => [
    { value: "column", label: r(Fr.columnChart) },
    { value: "line", label: r(Fr.lineChart) }
  ], [r]);
  return {
    data: o,
    isLoading: c,
    isError: d,
    isEmpty: M,
    refetch: g,
    chartEntities: _,
    chartLabels: A,
    categoryInfo: w,
    macroareaURL: a,
    chartType: m,
    onChartTypeChange: E,
    chartTypeOptions: F
  };
};
function mj({ ...e }) {
  return /* @__PURE__ */ p.jsxDEV(SS, { "data-slot": "select", ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
    lineNumber: 9,
    columnNumber: 10
  }, this);
}
function pj({ ...e }) {
  return /* @__PURE__ */ p.jsxDEV(IS, { "data-slot": "select-value", ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
    lineNumber: 17,
    columnNumber: 10
  }, this);
}
function gj({
  className: e,
  size: t = "default",
  children: n,
  ...r
}) {
  return /* @__PURE__ */ p.jsxDEV(
    kS,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: ve(
        "border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ p.jsxDEV(DS, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(qb, { className: "size-4 opacity-50" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
          lineNumber: 40,
          columnNumber: 9
        }, this) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
          lineNumber: 39,
          columnNumber: 7
        }, this)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
      lineNumber: 29,
      columnNumber: 5
    },
    this
  );
}
function bj({
  className: e,
  children: t,
  position: n = "popper",
  align: r = "center",
  ...i
}) {
  const s = tu();
  return /* @__PURE__ */ p.jsxDEV(RS, { container: s ?? void 0, children: /* @__PURE__ */ p.jsxDEV(
    PS,
    {
      "data-slot": "select-content",
      className: ve(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      align: r,
      ...i,
      children: [
        /* @__PURE__ */ p.jsxDEV(_j, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
          lineNumber: 68,
          columnNumber: 9
        }, this),
        /* @__PURE__ */ p.jsxDEV(
          OS,
          {
            className: ve(
              "p-1",
              n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
            lineNumber: 69,
            columnNumber: 9
          },
          this
        ),
        /* @__PURE__ */ p.jsxDEV(xj, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
          lineNumber: 78,
          columnNumber: 9
        }, this)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
      lineNumber: 56,
      columnNumber: 7
    },
    this
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
    lineNumber: 55,
    columnNumber: 5
  }, this);
}
function Ej({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ p.jsxDEV(
    LS,
    {
      "data-slot": "select-item",
      className: ve(
        "focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ p.jsxDEV("span", { className: "absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ p.jsxDEV(US, { children: /* @__PURE__ */ p.jsxDEV(eu, { className: "size-4" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
          lineNumber: 106,
          columnNumber: 11
        }, this) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
          lineNumber: 105,
          columnNumber: 9
        }, this) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
          lineNumber: 104,
          columnNumber: 7
        }, this),
        /* @__PURE__ */ p.jsxDEV(MS, { children: t }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
          lineNumber: 109,
          columnNumber: 7
        }, this)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
      lineNumber: 96,
      columnNumber: 5
    },
    this
  );
}
function _j({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsxDEV(
    HS,
    {
      "data-slot": "select-scroll-up-button",
      className: ve("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ p.jsxDEV(p2, { className: "size-4" }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
        lineNumber: 131,
        columnNumber: 7
      }, this)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
      lineNumber: 126,
      columnNumber: 5
    },
    this
  );
}
function xj({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p.jsxDEV(
    jS,
    {
      "data-slot": "select-scroll-down-button",
      className: ve("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ p.jsxDEV(qb, { className: "size-4" }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
        lineNumber: 146,
        columnNumber: 7
      }, this)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/ui/select.tsx",
      lineNumber: 141,
      columnNumber: 5
    },
    this
  );
}
const Tj = () => /* @__PURE__ */ p.jsxDEV("div", { className: "flex justify-between items-end gap-2 px-4 h-112 w-full", children: Array.from({ length: 13 }).map((e, t) => /* @__PURE__ */ p.jsxDEV(
  Vt,
  {
    className: "bg-gray-600 rounded-lg flex-1 h-full"
  },
  `share-of-attention-widget-skeleton-item-${t}`,
  !1,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
    lineNumber: 16,
    columnNumber: 7
  },
  void 0
)) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
  lineNumber: 14,
  columnNumber: 3
}, void 0), Aj = ({
  categoryInfo: e,
  chartEntities: t,
  chartLabels: n,
  chartType: r,
  chartTypeOptions: i,
  isError: s,
  isEmpty: a,
  isLoading: o,
  macroareaURL: u,
  refetch: c,
  onChartTypeChange: l
}) => {
  const { t: d } = Je(), h = yr();
  return /* @__PURE__ */ p.jsxDEV("div", { className: "w-full flex flex-col gap-5", children: [
    /* @__PURE__ */ p.jsxDEV("div", { className: "text-sm text-neutral-800 dark:text-white", children: e }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
      lineNumber: 44,
      columnNumber: 7
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("div", { className: "flex gap-2.5 justify-end items-center", children: [
      /* @__PURE__ */ p.jsxDEV(mj, { value: r, onValueChange: l, "aria-label": "Select Chart Type", children: [
        /* @__PURE__ */ p.jsxDEV(gj, { className: "w-[180px] bg-secondary text-secondary-foreground hover:bg-secondary/80 border border-foreground/50", children: /* @__PURE__ */ p.jsxDEV(pj, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
          lineNumber: 48,
          columnNumber: 13
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
          lineNumber: 47,
          columnNumber: 11
        }, void 0),
        /* @__PURE__ */ p.jsxDEV(bj, { children: i.map((m) => /* @__PURE__ */ p.jsxDEV(Ej, { value: m.value, children: m.label }, m.value, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
          lineNumber: 52,
          columnNumber: 15
        }, void 0)) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
          lineNumber: 50,
          columnNumber: 11
        }, void 0)
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
        lineNumber: 46,
        columnNumber: 9
      }, void 0),
      !s && /* @__PURE__ */ p.jsxDEV(Bt, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ p.jsxDEV("a", { href: u, target: "_blank", rel: "noopener noreferrer", children: d(Fr.accessMacroarea) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
        lineNumber: 60,
        columnNumber: 13
      }, void 0) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
        lineNumber: 59,
        columnNumber: 11
      }, void 0)
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
      lineNumber: 45,
      columnNumber: 7
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(
      Jr,
      {
        isLoading: o,
        isError: s,
        isEmpty: a,
        loadingComponent: /* @__PURE__ */ p.jsxDEV(Tj, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
          lineNumber: 71,
          columnNumber: 27
        }, void 0),
        errorComponent: /* @__PURE__ */ p.jsxDEV(zi, { name: "chart", refetch: c }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
          lineNumber: 72,
          columnNumber: 25
        }, void 0),
        emptyComponent: /* @__PURE__ */ p.jsxDEV("p", { className: "text-neutral-500 font-bold text-center", children: d(Fr.emptyText) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
          lineNumber: 73,
          columnNumber: 25
        }, void 0),
        children: r === "column" ? /* @__PURE__ */ p.jsxDEV(
          bn.ColumnsChart,
          {
            isStacked: !0,
            theme: h,
            entities: t,
            xAxisLabels: n,
            yAxisOptions: { min: 0, max: 100, labelFormatType: "percent" },
            tooltip: { type: "default", valueFormatType: "percent", props: { followPointer: !0 } },
            legend: { type: "default", toggleHideDisabled: !0 },
            scrollablePlotArea: { minWidth: n.length > 10 ? 1300 : void 0 },
            height: 600
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
            lineNumber: 76,
            columnNumber: 11
          },
          void 0
        ) : /* @__PURE__ */ p.jsxDEV(
          bn.LineChart,
          {
            legend: { type: "default" },
            entities: t,
            xAxisLabels: n,
            tooltip: { type: "default", valueFormatType: "percent" },
            yAxisOptions: { labelFormatType: "percent" },
            theme: h,
            height: 600
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
            lineNumber: 88,
            columnNumber: 11
          },
          void 0
        )
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
        lineNumber: 67,
        columnNumber: 7
      },
      void 0
    )
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/share-of-attention-widget.view.tsx",
    lineNumber: 43,
    columnNumber: 5
  }, void 0);
}, bc = (e) => {
  const t = hj(e);
  return /* @__PURE__ */ p.jsxDEV(Aj, { ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/share-of-attention-widget/index.tsx",
    lineNumber: 7,
    columnNumber: 10
  }, void 0);
};
function Ec(e, t) {
  return {
    id: `${e.name}-${e.color}`,
    name: e.name,
    y: t,
    x: an(t, 2),
    color: e.color
  };
}
const yj = ({
  provider: e = "all",
  territoryType: t = "grouped",
  timeRangeInDays: n = 30
}) => {
  const { workspaceId: r } = St(), i = Xr(), { t: s } = Je(), a = pe(() => {
    const _ = Rn(
      mr[le.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS],
      {
        panelId: r,
        tab: Ci[t] || Ci.grouped
      }
    ), A = HE({ provider: e, timeRangeInDays: n }).toString();
    return A ? `${_}?${A}` : _;
  }, [e, t, n, r]), [o, u] = we([]), [c, l] = we(!1), [d, h] = we(!1), m = de(async () => {
    if (r) {
      l(!0), h(!1);
      try {
        const _ = ru.isEnabled("isNewPageBrandOverviewEnabled"), A = await i.getSharesData(
          {
            provider: e?.toString(),
            territoryType: t,
            timeRangeInDays: n?.toString()
          },
          { isNewPageBrandOverviewEnabled: _ }
        );
        u(A);
      } catch {
        h(!0), u([]);
      } finally {
        l(!1);
      }
    }
  }, [r, e, t, n, i]);
  Le(() => {
    m();
  }, [m]);
  const E = pe(() => o.reduce(
    (_, A) => ({
      engagement: _.engagement + A.totalEngagement,
      views: _.views + A.totalViews,
      content: _.content + A.totalPosts
    }),
    { engagement: 0, views: 0, content: 0 }
  ), [o]), g = pe(() => {
    const _ = o.reduce(
      (A, w) => (A.engagement.push(Ec(w, w.totalEngagement)), A.views.push(Ec(w, w.totalViews)), A.content.push(Ec(w, w.totalPosts)), A),
      { engagement: [], views: [], content: [] }
    );
    return _.engagement.sort((A, w) => w.y - A.y), _.views.sort((A, w) => w.y - A.y), _.content.sort((A, w) => w.y - A.y), _;
  }, [o]), T = pe(() => {
    const _ = ud[e], A = Mx(t, s), w = Bd(n, s);
    return [_, A, w].join(" · ");
  }, [e, t, n, s]);
  return {
    data: o,
    isLoading: c,
    isError: d,
    refetch: m,
    chartEntities: g,
    totals: E,
    macroareaURL: a,
    subtitle: T
  };
}, Pr = {
  accessMacroarea: {
    key: "shares-widget.access-macroarea",
    defaultValue: "Acessar visão geral"
  },
  shareOfEngagement: {
    key: "shares-widget.share-of-engagement",
    defaultValue: "Share de engajamento"
  },
  shareOfViews: {
    key: "shares-widget.share-of-views",
    defaultValue: "Share de visualizações"
  },
  shareOfContent: {
    key: "shares-widget.share-of-content",
    defaultValue: "Share de conteúdo"
  },
  total: {
    key: "shares-widget.total",
    defaultValue: "Total"
  }
}, Nj = () => /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col w-full py-5 ", children: [
  /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col md:flex-row justify-between items-center gap-8", children: Array.from({ length: 3 }).map((e, t) => /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col items-center flex-1", children: /* @__PURE__ */ p.jsxDEV("div", { className: "mb-4", children: /* @__PURE__ */ p.jsxDEV(bD, { index: t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
    lineNumber: 20,
    columnNumber: 13
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
    lineNumber: 19,
    columnNumber: 11
  }, void 0) }, `shares-widget-skeleton-${t}`, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
    lineNumber: 18,
    columnNumber: 9
  }, void 0)) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
    lineNumber: 16,
    columnNumber: 5
  }, void 0),
  /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-wrap justify-center items-center gap-8 mt-4", children: Array.from({ length: 4 }).map((e, t) => /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-lg w-24 h-4" }, t, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
    lineNumber: 28,
    columnNumber: 9
  }, void 0)) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
    lineNumber: 26,
    columnNumber: 5
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
  lineNumber: 15,
  columnNumber: 3
}, void 0), _c = ({
  totalTitle: e,
  totalValue: t,
  theme: n
}) => {
  const r = n === "dark" ? "#FFFFFF" : "#000000";
  return `
    <div style="text-align: center; line-height: 18px;">
      <span style="font-size: 12px; color: ${r};">${e}</span><br/>
      <span style="font-size: 16px; font-weight: 700; color: ${r};">${t}</span>
    </div>
  `;
}, vj = ({
  isLoading: e,
  isError: t,
  chartEntities: n,
  totals: r,
  macroareaURL: i,
  refetch: s,
  subtitle: a
}) => {
  const { t: o } = Je(), u = yr(), { engagement: c, content: l, views: d } = n;
  return /* @__PURE__ */ p.jsxDEV("div", { className: "my-5 w-full flex flex-col gap-6", children: [
    a && /* @__PURE__ */ p.jsxDEV("div", { className: "text-sm text-neutral-800 dark:text-white", children: a }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
      lineNumber: 68,
      columnNumber: 20
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(
      Jr,
      {
        isLoading: e,
        isError: t,
        loadingComponent: /* @__PURE__ */ p.jsxDEV(Nj, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
          lineNumber: 72,
          columnNumber: 27
        }, void 0),
        errorComponent: /* @__PURE__ */ p.jsxDEV(zi, { name: "chart", refetch: s }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
          lineNumber: 73,
          columnNumber: 25
        }, void 0),
        children: /* @__PURE__ */ p.jsxDEV(
          bn.SyncMultipleDonut,
          {
            theme: u,
            syncOptions: ["highlight", "tooltip"],
            chartsGroup: [
              {
                id: "share-of-engagement-widget",
                titleOptions: {
                  text: o(Pr.shareOfEngagement)
                },
                entities: c,
                centerHtmlContent: _c({
                  totalTitle: o(Pr.total),
                  totalValue: an(r.engagement, 1),
                  theme: u
                })
              },
              {
                id: "share-of-views-widget",
                titleOptions: {
                  text: o(Pr.shareOfViews)
                },
                entities: d,
                centerHtmlContent: _c({
                  totalTitle: o(Pr.total),
                  totalValue: an(r.views, 1),
                  theme: u
                })
              },
              {
                id: "share-of-content-widget",
                titleOptions: {
                  text: o(Pr.shareOfContent)
                },
                entities: l,
                centerHtmlContent: _c({
                  totalTitle: o(Pr.total),
                  totalValue: an(r.content, 1),
                  theme: u
                })
              }
            ],
            yAxisOptions: { labelFormatType: "percent" },
            tooltip: { type: "inline", valueFormatType: "percent", props: { followPointer: !1 } },
            hasLegend: !0,
            dataLabels: { filter: { operator: ">", property: "percentage", value: 6 }, style: { fontSize: "12px" } },
            height: "120%"
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
            lineNumber: 75,
            columnNumber: 9
          },
          void 0
        )
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
        lineNumber: 69,
        columnNumber: 7
      },
      void 0
    ),
    !t && /* @__PURE__ */ p.jsxDEV(Bt, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ p.jsxDEV("a", { href: i, target: "_blank", rel: "noopener noreferrer", children: o(Pr.accessMacroarea) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
      lineNumber: 125,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
      lineNumber: 124,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/shares-widget.view.tsx",
    lineNumber: 67,
    columnNumber: 5
  }, void 0);
}, wj = (e) => {
  const t = yj(e);
  return /* @__PURE__ */ p.jsxDEV(vj, { ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/shares-widget/index.tsx",
    lineNumber: 7,
    columnNumber: 10
  }, void 0);
}, dl = {
  emptyText: {
    key: "zai.widget.territory-relevance.empty-text",
    defaultValue: "Nenhum dado de relevância encontrado para este período"
  },
  accessMacroarea: {
    key: "zai.widget.territory-relevance.access-macroarea",
    defaultValue: "Acessar relevância"
  },
  relevanceIndex: {
    key: "zai.widget.territory-relevance.relevance-index",
    defaultValue: "Relevância"
  }
}, Cj = ({
  territoryId: e,
  timeRange: t = "30"
} = {}) => {
  const { t: n } = Je(), { workspaceId: r } = St(), i = Xr(), [s, a] = we(null), [o, u] = we(!1), [c, l] = we(!1), d = pe(() => {
    if (!e || !r) return "";
    const _ = SE(r, e, "performance"), A = md(t);
    return A ? `${_}?uploadDate=${A}` : _;
  }, [e, r, t]), h = de(async () => {
    if (!(!e || !r)) {
      u(!0), l(!1);
      try {
        const _ = await i.getTerritoryRelevanceData({
          territoryId: e,
          timeRange: t
        });
        a(_);
      } catch {
        l(!0), a(null);
      } finally {
        u(!1);
      }
    }
  }, [e, t, r, i]);
  Le(() => {
    h();
  }, [h]);
  const m = pe(() => s?.sparkline ? [
    {
      name: n(dl.relevanceIndex),
      color: Qe.winnin,
      series: s.sparkline.map((_) => _.value)
    }
  ] : [], [s, n]), E = pe(() => s?.sparkline ? s.sparkline.map((_) => cr.formatDate(_.date, "MMM, DD YYYY")) : [], [s]), g = pe(() => m.length === 0 || m.flatMap((_) => _.series).every((_) => _ === 0), [m]), T = pe(() => {
    if (!t) return "";
    if (t.includes(":")) {
      const [A, w] = t.split(":");
      return `${cr.formatDate(A, "DD/MM/YYYY")} - ${cr.formatDate(w, "DD/MM/YYYY")}`;
    }
    const _ = Number(t);
    return isNaN(_) ? "" : Bd(_, n);
  }, [t, n]);
  return {
    isLoading: o,
    isError: c,
    isEmpty: g,
    refetch: h,
    chartEntities: m,
    chartLabels: E,
    macroareaURL: d,
    subtitle: T
  };
}, Sj = () => /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col gap-4 h-96 w-full", children: [
  /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-lg h-8 w-3/4" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
    lineNumber: 15,
    columnNumber: 5
  }, void 0),
  /* @__PURE__ */ p.jsxDEV(Vt, { className: "bg-gray-600 rounded-lg flex-1 w-full" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
    lineNumber: 16,
    columnNumber: 5
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
  lineNumber: 14,
  columnNumber: 3
}, void 0), kj = ({
  chartEntities: e,
  chartLabels: t,
  isError: n,
  isEmpty: r,
  isLoading: i,
  macroareaURL: s,
  refetch: a,
  subtitle: o
}) => {
  const { t: u } = Je(), c = yr();
  return /* @__PURE__ */ p.jsxDEV("div", { className: "w-full flex flex-col gap-6", children: [
    o && /* @__PURE__ */ p.jsxDEV("div", { className: "text-sm text-neutral-800 dark:text-white", children: o }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
      lineNumber: 35,
      columnNumber: 20
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(
      Jr,
      {
        isLoading: i,
        isError: n,
        isEmpty: r,
        loadingComponent: /* @__PURE__ */ p.jsxDEV(Sj, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
          lineNumber: 40,
          columnNumber: 27
        }, void 0),
        errorComponent: /* @__PURE__ */ p.jsxDEV(zi, { name: "chart", refetch: a }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
          lineNumber: 41,
          columnNumber: 25
        }, void 0),
        emptyComponent: /* @__PURE__ */ p.jsxDEV("p", { className: "text-neutral-500 font-bold text-center", children: u(dl.emptyText) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
          lineNumber: 42,
          columnNumber: 25
        }, void 0),
        children: /* @__PURE__ */ p.jsxDEV(
          bn.LineChart,
          {
            legend: { type: "default", toggleHideDisabled: !0 },
            entities: e,
            xAxisLabels: t,
            tooltip: {
              type: "default",
              valueFormatType: "default",
              formatter: (l) => an(l, 2)
            },
            yAxisOptions: { labelFormatType: "default" },
            customOptions: {
              yAxis: {
                labels: {
                  formatter: function({ value: l }) {
                    return an(Number(l), 0);
                  }
                }
              }
            },
            theme: c,
            height: 400
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
            lineNumber: 44,
            columnNumber: 9
          },
          void 0
        )
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
        lineNumber: 36,
        columnNumber: 7
      },
      void 0
    ),
    !n && s && /* @__PURE__ */ p.jsxDEV(Bt, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ p.jsxDEV("a", { href: s, target: "_blank", rel: "noopener noreferrer", children: u(dl.accessMacroarea) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
      lineNumber: 69,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
      lineNumber: 68,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/territory-relevance-widget.view.tsx",
    lineNumber: 34,
    columnNumber: 5
  }, void 0);
}, Ij = (e) => {
  const t = Cj(e);
  return /* @__PURE__ */ p.jsxDEV(kj, { ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/territory-relevance-widget/index.tsx",
    lineNumber: 7,
    columnNumber: 10
  }, void 0);
}, Dj = ({ type: e, uri: t }) => {
  if (e === "share-of-attention") {
    const n = Tt(t, {
      path: bt.SHARE_OF_ATTENTION,
      exact: !0
    });
    if (n?.params) {
      const a = n.params;
      return /* @__PURE__ */ p.jsxDEV(bc, { ...a }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
        lineNumber: 24,
        columnNumber: 14
      }, void 0);
    }
    const r = Tt(t, {
      path: bt.SHARE_OF_ATTENTION_V3,
      exact: !0
    });
    if (r?.params) {
      const a = r.params;
      return /* @__PURE__ */ p.jsxDEV(bc, { ...a }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
        lineNumber: 33,
        columnNumber: 14
      }, void 0);
    }
    const s = Tt(t, {
      path: bt.SHARE_OF_ATTENTION_V2,
      exact: !0
    })?.params;
    return /* @__PURE__ */ p.jsxDEV(bc, { ...s }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
      lineNumber: 41,
      columnNumber: 12
    }, void 0);
  }
  if (e === "shares") {
    let n = Tt(t, {
      path: bt.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2,
      exact: !0
    });
    n || (n = Tt(t, {
      path: bt.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS,
      exact: !0
    }));
    const r = n?.params, i = r?.territoryType ? r : { ...r, territoryType: "grouped" };
    return /* @__PURE__ */ p.jsxDEV(wj, { ...i }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
      lineNumber: 62,
      columnNumber: 12
    }, void 0);
  }
  if (e === "territory-performance") {
    const r = Tt(t, {
      path: bt.GET_TERRITORY_PERFORMANCE_RESOURCE,
      exact: !0
    })?.params, i = r?.territoryId?.split(".")?.[0]?.trim(), s = r?.territoryId?.split(".")?.[1]?.trim();
    return !!!(i && i in cd) || !s ? null : /* @__PURE__ */ p.jsxDEV(Ij, { ...r }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
      lineNumber: 79,
      columnNumber: 12
    }, void 0);
  }
  if (e === "brand-engagement-over-time") {
    const r = Tt(t, {
      path: bt.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE,
      exact: !0
    })?.params;
    return /* @__PURE__ */ p.jsxDEV(DH, { ...r }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
      lineNumber: 88,
      columnNumber: 12
    }, void 0);
  }
  if (e === "post") {
    const r = Tt(t, {
      path: bt.POST,
      exact: !0
    })?.params, i = `${r?.provider}:${r?.id}`;
    return !r?.provider || !r?.id ? null : /* @__PURE__ */ p.jsxDEV(cj, { postId: i }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
      lineNumber: 102,
      columnNumber: 12
    }, void 0);
  }
  if (e === "creator") {
    const r = Tt(t, {
      path: bt.CREATOR,
      exact: !0
    })?.params, i = `${r?.provider}:${r?.id}`;
    return !r?.provider || !r?.id ? null : /* @__PURE__ */ p.jsxDEV(FH, { creatorId: i, performanceInMonths: 1 }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
      lineNumber: 116,
      columnNumber: 12
    }, void 0);
  }
  return /* @__PURE__ */ p.jsxDEV("div", { className: "my-5 text-red-500", children: /* @__PURE__ */ p.jsxDEV("p", { children: "Widget type not recognized" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
    lineNumber: 121,
    columnNumber: 7
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/widget-handler/index.tsx",
    lineNumber: 120,
    columnNumber: 5
  }, void 0);
}, Rj = () => {
  const { language: e } = Qs(), t = yr();
  return /* @__PURE__ */ p.jsxDEV(
    r6,
    {
      remarkPlugins: [Lx],
      rehypePlugins: [dx],
      className: ve("aui-md pseudo-element-after-first-running", `theme-${t}`, { [e]: !!e }),
      components: Fx
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 29,
      columnNumber: 5
    },
    void 0
  );
};
Ce(Rj);
const Pj = ({ text: e, status: t }) => {
  const { language: n } = Qs(), r = yr();
  return /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      "data-status": t?.type,
      className: ve("aui-md pseudo-element-after-first-running", `theme-${r}`, { [n]: !!n }),
      children: /* @__PURE__ */ p.jsxDEV(v_, { remarkPlugins: [Lx], rehypePlugins: [dx], components: Fx, children: e }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
        lineNumber: 60,
        columnNumber: 7
      }, void 0)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 56,
      columnNumber: 5
    },
    void 0
  );
}, Bx = Ce(Pj), Oj = ({ language: e, code: t }) => {
  const { isCopied: n, copyToClipboard: r } = Lj(), i = () => {
    !t || n || r(t);
  };
  return /* @__PURE__ */ p.jsxDEV("div", { className: "flex items-center justify-between gap-4 rounded-t-lg bg-zinc-100 dark:bg-zinc-900 px-4 py-2 text-sm font-semibold text-foreground", children: [
    /* @__PURE__ */ p.jsxDEV("span", { className: "lowercase [&>span]:text-xs", children: e }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 78,
      columnNumber: 7
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(on, { tooltip: "Copy", onClick: i, children: [
      !n && /* @__PURE__ */ p.jsxDEV(Zl, {}, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
        lineNumber: 80,
        columnNumber: 23
      }, void 0),
      n && /* @__PURE__ */ p.jsxDEV(eu, {}, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
        lineNumber: 81,
        columnNumber: 22
      }, void 0)
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 79,
      columnNumber: 7
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 77,
    columnNumber: 5
  }, void 0);
}, Lj = ({
  copiedDuration: e = 3e3
} = {}) => {
  const [t, n] = we(!1);
  return { isCopied: t, copyToClipboard: (i) => {
    i && navigator.clipboard.writeText(i).then(() => {
      n(!0), setTimeout(() => n(!1), e);
    });
  } };
}, Fx = FM({
  h1: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "h1",
    {
      className: ve("mb-8 scroll-m-20 text-4xl font-extrabold tracking-tight last:mb-0 clear-left", e),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 108,
      columnNumber: 5
    },
    void 0
  ),
  h2: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "h2",
    {
      className: ve(
        "mb-4 mt-8 scroll-m-20 text-3xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 114,
      columnNumber: 5
    },
    void 0
  ),
  h3: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "h3",
    {
      className: ve(
        "mb-4 mt-6 scroll-m-20 text-2xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 123,
      columnNumber: 5
    },
    void 0
  ),
  h4: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "h4",
    {
      className: ve(
        "mb-4 mt-6 scroll-m-20 text-xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 132,
      columnNumber: 5
    },
    void 0
  ),
  h5: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("h5", { className: ve("my-4 text-lg font-semibold first:mt-0 last:mb-0 clear-left", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 141,
    columnNumber: 5
  }, void 0),
  h6: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("h6", { className: ve("my-4 font-semibold first:mt-0 last:mb-0 clear-left", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 144,
    columnNumber: 5
  }, void 0),
  p: ({ className: e, ...t }) => (
    // Prevent elements be a descendant of <p>
    /* @__PURE__ */ p.jsxDEV("div", { className: ve("mb-5 mt-5 leading-7 first:mt-0 last:mb-0 clear-left", e), ...t }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 148,
      columnNumber: 5
    }, void 0)
  ),
  a: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "a",
    {
      target: "_blank",
      rel: "noopener noreferrer",
      className: ve(
        `
            text-primary
            font-medium
            text-sm
            py-0.5
            px-1.5
            border
            border-neutral-200
            dark:border-neutral-500
            bg-white
            dark:bg-neutral-800
            rounded-full
            whitespace-nowrap
            inline-flex
            items-center
            gap-0.5
            max-w-36
            hover:border-neutral-300
            dark:hover:border-neutral-400
            hover:bg-neutral-50
            dark:hover:bg-neutral-700
            hover:[&>span]:inline-flex
            clear-left
            `,
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ p.jsxDEV("span", { className: "truncate", children: t.children }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
          lineNumber: 184,
          columnNumber: 9
        }, void 0),
        /* @__PURE__ */ p.jsxDEV("span", { className: "hidden", children: /* @__PURE__ */ p.jsxDEV(T2, { size: 16 }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
          lineNumber: 186,
          columnNumber: 11
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
          lineNumber: 185,
          columnNumber: 9
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 152,
      columnNumber: 7
    },
    void 0
  ),
  blockquote: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("blockquote", { className: ve("border-l-2 pl-6 italic clear-left", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 192,
    columnNumber: 5
  }, void 0),
  ul: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("ul", { className: ve("my-5 ml-6 list-disc [&>li]:mt-2 clear-left", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 195,
    columnNumber: 5
  }, void 0),
  ol: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("ol", { className: ve("my-5 ml-6 list-decimal [&>li]:mt-2 clear-left", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 198,
    columnNumber: 5
  }, void 0),
  li: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("li", { className: ve("clear-left", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 200,
    columnNumber: 36
  }, void 0),
  hr: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("hr", { className: ve("my-5 border-b clear-left", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 201,
    columnNumber: 36
  }, void 0),
  table: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("div", { className: "overflow-x-auto clear-left", children: /* @__PURE__ */ p.jsxDEV("table", { className: ve("my-5 w-full border-separate border-spacing-0 overflow-y-auto", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 204,
    columnNumber: 7
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 203,
    columnNumber: 5
  }, void 0),
  th: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "th",
    {
      className: ve(
        "bg-muted px-4 py-2 text-left font-bold first:rounded-tl-lg last:rounded-tr-lg [&[align=center]]:text-center [&[align=right]]:text-right",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 208,
      columnNumber: 5
    },
    void 0
  ),
  td: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "td",
    {
      className: ve(
        "border-b border-l px-4 py-2 text-left last:border-r [&[align=center]]:text-center [&[align=right]]:text-right",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 217,
      columnNumber: 5
    },
    void 0
  ),
  tr: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "tr",
    {
      className: ve(
        "m-0 border-b p-0 first:border-t [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 226,
      columnNumber: 5
    },
    void 0
  ),
  sup: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV("sup", { className: ve("[&>a]:text-xs [&>a]:no-underline clear-left", e), ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
    lineNumber: 235,
    columnNumber: 5
  }, void 0),
  pre: ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
    "pre",
    {
      className: ve(
        "overflow-x-auto rounded-b-lg bg-zinc-100 dark:bg-black p-4 text-foreground dark:text-white clear-left",
        e
      ),
      ...t
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 238,
      columnNumber: 5
    },
    void 0
  ),
  code: function({ className: t, ...n }) {
    const r = w_();
    return /* @__PURE__ */ p.jsxDEV("code", { className: ve(!r && "bg-muted rounded border font-semibold clear-left", t), ...n }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 249,
      columnNumber: 7
    }, this);
  },
  embed: (e) => {
    const t = e["data-type"], n = e["data-uri"];
    return /* @__PURE__ */ p.jsxDEV(Dj, { type: t, uri: n }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/assistant-ui/markdown-text.tsx",
      lineNumber: 255,
      columnNumber: 12
    }, void 0);
  },
  CodeHeader: Oj
}), No = class No {
};
No.formatSoaDataUniverse = ({
  country: t,
  category: n,
  startDate: r,
  endDate: i
}) => {
  const s = [];
  return t && s.push(`Country: ${t}`), n && s.push(`Category: ${n}`), r && i && s.push(`Period: ${r} - ${i}`), s.length ? `Share of Attention - ${s.join(", ")}` : "";
}, No.formatBrandSchema = ({
  brandName: t,
  provider: n,
  timeRangeInDays: r
}) => {
  const i = [];
  t && i.push(`${t}`);
  const s = ud[n];
  return s && i.push(`${s}`), r && i.push(`Last ${r} days`), i.length ? `Brand (Engagement, Content, Views) - ${i.join(", ")}` : "";
};
let Ao = No;
const Mj = () => {
  const e = oe((k) => k?.message?.content), t = oe((k) => k?.message?.status?.type), n = pe(() => e?.filter((k) => k.type === "tool-call") || [], [e]), r = n?.some((k) => Ca.SHARE_OF_ATTENTION.some((B) => Tt(k?.argsText, { path: B, exact: !0 }) !== null)), i = n?.some((k) => Ca.BRAND.some((B) => Tt(k?.argsText, { path: B, exact: !0 }) !== null)), s = n?.find((k) => Ca.SHARE_OF_ATTENTION.some((B) => Tt(k?.argsText, { path: B, exact: !0 }) !== null)), a = n?.find((k) => Ca.BRAND.some((B) => Tt(k?.argsText, { path: B, exact: !0 }) !== null)), o = s?.result?.[0]?.data, u = s?.argsText ? Tt(s?.argsText, {
    path: le.SHARE_OF_ATTENTION
  }) : null, c = o?.category, l = u?.params?.period, d = {
    daily: "dailySOA",
    weekly: "weeklySOA",
    monthly: "monthlySOA"
  }, h = d[l] || d.monthly, m = o?.myBrand?.[h] || [], E = m?.[0], g = m?.[m.length - 1], T = a?.result?.[0]?.data?.getWorkspace?.workspaceBrand?.name, _ = a?.argsText ? Tt(a?.argsText, {
    path: le.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS
  }) : null, A = E?.date ? cr.formatDate(E.date) : "", w = g?.date ? cr.formatDate(g.date) : "", M = r ? Ao.formatSoaDataUniverse({
    country: c?.country,
    category: c?.name,
    startDate: A,
    endDate: w
  }) : "", F = i ? Ao.formatBrandSchema({
    brandName: T,
    provider: _?.params?.provider,
    timeRangeInDays: _?.params?.timeRangeInDays
  }) : "";
  return pe(
    () => ({
      hasSoaToolCall: r,
      hasBrandToolCall: i,
      soaDataUniverse: M,
      brandDataUniverse: F,
      statusType: t
    }),
    [F, i, r, M, t]
  );
}, Uj = ({
  hasSoaToolCall: e,
  hasBrandToolCall: t,
  soaDataUniverse: n,
  brandDataUniverse: r,
  statusType: i
}) => {
  const s = e && n, a = t && r;
  return !s && !a || i !== "complete" ? null : /* @__PURE__ */ p.jsxDEV("div", { className: "my-4 text-base text-muted-foreground", children: [
    /* @__PURE__ */ p.jsxDEV("p", { children: "Data Universe:" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/data-universe/data-universe.view.tsx",
      lineNumber: 19,
      columnNumber: 7
    }, void 0),
    s && /* @__PURE__ */ p.jsxDEV("p", { children: n }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/data-universe/data-universe.view.tsx",
      lineNumber: 20,
      columnNumber: 37
    }, void 0),
    a && /* @__PURE__ */ p.jsxDEV("p", { children: r }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/data-universe/data-universe.view.tsx",
      lineNumber: 21,
      columnNumber: 39
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/data-universe/data-universe.view.tsx",
    lineNumber: 18,
    columnNumber: 5
  }, void 0);
}, Hj = () => {
  const e = Mj();
  return /* @__PURE__ */ p.jsxDEV(Uj, { ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/data-universe/index.tsx",
    lineNumber: 8,
    columnNumber: 10
  }, void 0);
}, zx = Ce(Hj), Ua = {
  dialogTitle: {
    key: "feedback-custom-dialog.title",
    defaultValue: "O que deu errado na sua experiência?"
  },
  dialogTextareaFeedback: {
    key: "feedback-custom-dialog.textarea-feedback",
    defaultValue: "(Opcional) Insira seu feedback aqui..."
  },
  dialogSendButton: {
    key: "feedback-custom-dialog.send-button",
    defaultValue: "Enviar"
  },
  dialogCancelButton: {
    key: "feedback-custom-dialog.cancel-button",
    defaultValue: "Cancelar"
  }
}, jj = Ce(({ onClose: e, onSend: t, t: n }) => /* @__PURE__ */ p.jsxDEV("div", { className: "feedback-custom-dialog fixed top-0 left-0 w-full h-full z-50 p-4 flex items-center justify-center", children: [
  /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      onClick: e,
      className: "feedback-custom-dialog-overlay absolute top-0 left-0 w-full h-full bg-black opacity-50"
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
      lineNumber: 9,
      columnNumber: 7
    },
    void 0
  ),
  /* @__PURE__ */ p.jsxDEV("div", { className: "feedback-custom-dialog-content relative bg-[#2E2E2E] max-w-[650px] w-full  border border-[#F1F4FA1A] p-8 flex flex-col gap-8 rounded-lg", children: [
    /* @__PURE__ */ p.jsxDEV("h2", { className: "font-semibold text-3xl", children: n(Ua.dialogTitle) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
      lineNumber: 15,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("form", { onSubmit: t, className: "feedback-custom-dialog-form flex flex-col gap-8", children: [
      /* @__PURE__ */ p.jsxDEV("div", { className: "feedback-custom-dialog-form-row", children: /* @__PURE__ */ p.jsxDEV(
        "textarea",
        {
          name: "textarea-feedback",
          id: "textarea-feedback",
          placeholder: n(Ua.dialogTextareaFeedback),
          className: "w-full h-[109px] resize-none p-2 border bg-[#363636] border-[#E1E5ED1A] rounded-sm text-sm text-white placeholder-white"
        },
        void 0,
        !1,
        {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
          lineNumber: 18,
          columnNumber: 13
        },
        void 0
      ) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
        lineNumber: 17,
        columnNumber: 11
      }, void 0),
      /* @__PURE__ */ p.jsxDEV("div", { className: "feedback-custom-dialog-form-actions flex align-center justify-end gap-4", children: [
        /* @__PURE__ */ p.jsxDEV(
          "button",
          {
            type: "button",
            onClick: e,
            className: "feedback-custom-dialog-form-action-cancel py-2 px-4 rounded-sm text-sm text-white cursor-pointer",
            children: n(Ua.dialogCancelButton)
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
            lineNumber: 26,
            columnNumber: 13
          },
          void 0
        ),
        /* @__PURE__ */ p.jsxDEV(
          "button",
          {
            type: "submit",
            className: "feedback-custom-dialog-form-action-send py-2 px-4 rounded-sm bg-white text-sm text-black cursor-pointer",
            children: n(Ua.dialogSendButton)
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
            lineNumber: 33,
            columnNumber: 13
          },
          void 0
        )
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
        lineNumber: 25,
        columnNumber: 11
      }, void 0)
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
      lineNumber: 16,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
    lineNumber: 14,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom-dialog.tsx",
  lineNumber: 8,
  columnNumber: 5
}, void 0)), Bj = ({ type: e, workspaceId: t, threadId: n, hasDialog: r }) => {
  const [i, s] = we(!1), a = st(null), o = e === "positive" ? "Like" : "Dislike", u = de(
    ({ message: E } = {}) => {
      const g = {
        workspaceId: t,
        thread: n,
        feedback: e
      };
      E && (g.message = E), Lr.track(Or.feedback, g);
    },
    [n, e, t]
  ), c = ({ active: E, element: g }) => {
    if (g.disabled = E, !E) {
      g.classList.add("text-[#4C5567]", "hover:text-[#4C5567]"), g.classList.remove("text-[#D0B2FF]", "hover:text-[#D0B2FF]", "hover:text-accent-foreground");
      return;
    }
    g.classList.add("text-[#D0B2FF]", "hover:text-[#D0B2FF]"), g.classList.remove("hover:text-accent-foreground", "disabled:opacity-50");
  }, l = () => {
    const E = a.current, g = document.querySelector(
      `[data-feedback-button-type="${e === "positive" ? "negative" : "positive"}"]`
    );
    return {
      currentButton: E,
      oppositeButton: g
    };
  };
  return {
    buttonRef: a,
    handleClick: () => {
      const { currentButton: E, oppositeButton: g } = l();
      if (r) {
        s(!0);
        return;
      }
      g && c({ active: !1, element: g }), c({ active: !0, element: E }), u();
    },
    tooltipMessage: o,
    showDialog: i,
    onDialogClose: () => s(!1),
    onDialogSend: (E) => {
      E.preventDefault();
      const { currentButton: g, oppositeButton: T } = l(), A = new FormData(E.currentTarget).get("textarea-feedback").trim();
      T && c({ active: !1, element: T }), c({ active: !0, element: g }), u({ message: A }), s(!1);
    }
  };
}, Vx = ut(
  ({
    IconComponent: e,
    TooltipIconButtonComponent: t,
    DialogComponent: n,
    tooltipMessage: r,
    type: i,
    showDialog: s,
    handleClick: a,
    onDialogClose: o,
    onDialogSend: u,
    t: c
  }, l) => /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxDEV(
      t,
      {
        ref: l,
        tooltip: r,
        onClick: a,
        "data-feedback-button-type": i,
        children: /* @__PURE__ */ p.jsxDEV(e, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom.view.tsx",
          lineNumber: 28,
          columnNumber: 9
        }, void 0)
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom.view.tsx",
        lineNumber: 22,
        columnNumber: 7
      },
      void 0
    ),
    s && /* @__PURE__ */ p.jsxDEV(n, { t: c, onClose: o, onSend: u }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom.view.tsx",
      lineNumber: 30,
      columnNumber: 22
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/feedback-custom.view.tsx",
    lineNumber: 21,
    columnNumber: 5
  }, void 0)
);
Vx.displayName = "FeedbackCustomView";
const Fj = Ce(Vx), fp = Ce(({ type: e, hasDialog: t = !1 }) => {
  const { workspaceId: n } = St(), r = oe((u) => u?.threadListItem?.remoteId), { t: i } = Je(), { buttonRef: s, ...a } = Bj({
    type: e,
    hasDialog: t,
    threadId: r,
    workspaceId: n
  }), o = e === "positive" ? M2 : O2;
  return /* @__PURE__ */ p.jsxDEV(
    Fj,
    {
      ...a,
      ref: s,
      TooltipIconButtonComponent: on,
      IconComponent: o,
      DialogComponent: jj,
      type: e,
      t: i
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/feedback-custom/index.tsx",
      lineNumber: 29,
      columnNumber: 5
    },
    void 0
  );
}), zj = {
  analyze: gD,
  plan: _D,
  execute_step: ED,
  validate_step: TD,
  synthesize: vh,
  // `clarify` is never rendered (filtered out at accumulation time); mapped to
  // synthesize as a defensive fallback so the type stays exhaustive.
  clarify: vh
}, Vj = {
  thinking: {
    key: "zai.progress-steps.thinking",
    defaultValue: "Pensando..."
  }
}, Wj = () => {
  const { t: e } = Je(), t = oe((o) => o?.message?.content), n = oe((o) => o?.message?.status), i = oe((o) => o?.message?.metadata?.custom)?.zaiProgress, s = pe(() => {
    const o = t?.findLast((c) => c.type === "text"), u = !!o && (o.text?.trim().length ?? 0) > 0;
    return n?.type === "running" && !u;
  }, [t, n?.type]), a = pe(() => i?.entries?.length ? i.entries.map((o) => ({
    id: o.key,
    node: o.node,
    text: o.text,
    icon: zj[o.node],
    state: o.key === i.activeKey ? "active" : "done"
  })) : [], [i?.activeKey, i?.entries]);
  return {
    isVisible: s,
    header: e(Vj.thinking),
    steps: a
  };
}, $j = () => {
  const { workspaceId: e } = St(), t = oe((r) => r?.message?.content);
  return pe(() => {
    const r = t?.filter((a) => a.type === "tool-call");
    return !r || r.length === 0 ? [] : r.map((a) => {
      const o = a?.argsText;
      if (!o) return null;
      for (const u of Object.values(le)) {
        const c = Tt(o, { path: u, exact: !0 });
        if (c) {
          const l = mr[u];
          if (!l)
            return null;
          const d = { ...c.params };
          if (d.territoryId) {
            const [g, T] = d.territoryId.split("."), _ = cd[g];
            d.territoryType = _, d.entityId = T, delete d.territoryId;
          }
          const h = DD(l), m = {};
          h.includes("panelId") && e && (m.panelId = e);
          for (const g of h)
            if (g === "tab" && d.territoryType && d.territoryType in Ci ? m.tab = Ci[d.territoryType] : g !== "panelId" && d[g] && (m[g] = d[g]), !m[g])
              return null;
          const E = Rn(l, m);
          return {
            uri: o,
            href: E,
            path: u,
            params: c.params
          };
        }
      }
      return null;
    }).filter((a) => a !== null).reduce(
      (a, o) => {
        const u = o?.uri;
        return a.ids?.includes(u) ? a : {
          ids: [...a.ids, u],
          sources: [...a.sources, o]
        };
      },
      {
        ids: [],
        sources: []
      }
    ).sources;
  }, [t, e]);
}, Yj = () => {
  const { language: e } = Qs(), t = dd(), [n, r] = we(!1), [i, s] = we(!1), [a, o] = we([]), u = de(async () => {
    try {
      r(!0), s(!1);
      const c = await t.getPrePrompts(e || "en");
      o(c);
    } catch {
      s(!0);
    } finally {
      r(!1);
    }
  }, [e, t]);
  return Le(() => {
    u();
  }, [u]), {
    isLoading: n,
    isError: i,
    data: a
  };
}, Gj = (e, t, n = 18) => {
  const [r, i] = we(t ? "" : e);
  return Le(() => {
    if (!t) {
      i(e);
      return;
    }
    i("");
    let s = 0;
    const a = setInterval(() => {
      s += 1, i(e.slice(0, s)), s >= e.length && clearInterval(a);
    }, n);
    return () => clearInterval(a);
  }, [e, t, n]), r;
}, qj = ({ step: e }) => {
  const t = e.icon, n = e.state === "active", r = Gj(e.text, n);
  return /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      className: ve("flex items-start gap-2 text-sm", n ? "text-foreground font-bold" : "text-muted-foreground"),
      children: [
        /* @__PURE__ */ p.jsxDEV(t, { className: ve("size-5 shrink-0", n && "text-purple-600 dark:text-purple-300") }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/progress-steps/progress-steps.view.tsx",
          lineNumber: 15,
          columnNumber: 7
        }, void 0),
        /* @__PURE__ */ p.jsxDEV("span", { className: "leading-6", children: r }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/progress-steps/progress-steps.view.tsx",
          lineNumber: 16,
          columnNumber: 7
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/progress-steps/progress-steps.view.tsx",
      lineNumber: 12,
      columnNumber: 5
    },
    void 0
  );
}, Kj = ({ isVisible: e, header: t, steps: n }) => e ? /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col gap-4 my-3", role: "status", "aria-live": "polite", "aria-atomic": "true", children: [
  /* @__PURE__ */ p.jsxDEV("p", { className: "animate-pulse font-bold text-sm text-foreground", children: t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/progress-steps/progress-steps.view.tsx",
    lineNumber: 26,
    columnNumber: 7
  }, void 0),
  n.length > 0 && /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-col gap-4", children: n.map((r) => /* @__PURE__ */ p.jsxDEV(qj, { step: r }, r.id, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/progress-steps/progress-steps.view.tsx",
    lineNumber: 31,
    columnNumber: 13
  }, void 0)) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/progress-steps/progress-steps.view.tsx",
    lineNumber: 29,
    columnNumber: 9
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/progress-steps/progress-steps.view.tsx",
  lineNumber: 25,
  columnNumber: 5
}, void 0) : null, Wx = Ce(() => {
  const e = Wj();
  return /* @__PURE__ */ p.jsxDEV(Kj, { ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/progress-steps/index.tsx",
    lineNumber: 8,
    columnNumber: 10
  }, void 0);
}), Qj = () => {
  const e = $j();
  return {
    sources: pe(() => {
      const n = e.reduce(
        (r, i) => (i && (r[i.href] || (r[i.href] = i)), r),
        {}
      );
      return Object.values(n);
    }, [e])
  };
};
function Xj(e, t = 50) {
  if (e?.length <= t) return e;
  const n = Math.floor(t / 2);
  return `${e?.slice(0, n)}...${e?.slice(-n)}`;
}
const Jj = ({ sources: e }) => !e || e.length <= 0 ? null : /* @__PURE__ */ p.jsxDEV(rd, { children: [
  /* @__PURE__ */ p.jsxDEV(id, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(
    Bt,
    {
      variant: "outline",
      className: `
            text-primary
            font-medium
            text-sm
            py-0.5
            pr-2
            pl-1.5
            border
            border-neutral-300
            bg-neutral-100
            rounded-full
            whitespace-nowrap
            inline-flex
            items-center
            max-w-36
            hover:border-neutral-400
            hover:bg-neutral-200
            hover:[&>span]:inline-flex
            h-auto
          `,
      children: [
        /* @__PURE__ */ p.jsxDEV(y2, { size: 16 }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
          lineNumber: 40,
          columnNumber: 11
        }, void 0),
        "Sources"
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
      lineNumber: 17,
      columnNumber: 9
    },
    void 0
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
    lineNumber: 16,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV(
    sd,
    {
      side: "top",
      align: "start",
      className: "border rounded-xl border-neutral-200 dark:border-neutral-500 bg-white dark:bg-neutral-800 w-fit max-w-xl",
      children: [
        /* @__PURE__ */ p.jsxDEV("h4", { className: "text-sm text-muted-foreground mb-2", children: "Sources" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
          lineNumber: 49,
          columnNumber: 9
        }, void 0),
        /* @__PURE__ */ p.jsxDEV("div", { className: "max-h-60 overflow-y-auto", children: e.map((t, n) => /* @__PURE__ */ p.jsxDEV(
          "a",
          {
            href: t.href,
            className: "flex items-center gap-1 hover:underline visited:text-purple-300",
            target: "_blank",
            rel: "noopener noreferrer",
            title: t.href,
            children: [
              /* @__PURE__ */ p.jsxDEV(v2, { className: "shrink-0", size: 16 }, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
                lineNumber: 61,
                columnNumber: 15
              }, void 0),
              /* @__PURE__ */ p.jsxDEV("span", { className: "truncate", children: Xj(t.href) }, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
                lineNumber: 62,
                columnNumber: 15
              }, void 0)
            ]
          },
          `source-item-${t.href}-${n}`,
          !0,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
            lineNumber: 53,
            columnNumber: 13
          },
          void 0
        )) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
          lineNumber: 51,
          columnNumber: 9
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
      lineNumber: 44,
      columnNumber: 7
    },
    void 0
  )
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/sources.view.tsx",
  lineNumber: 15,
  columnNumber: 5
}, void 0), $x = () => {
  const e = Qj();
  return /* @__PURE__ */ p.jsxDEV(Jj, { ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/sources/index.tsx",
    lineNumber: 6,
    columnNumber: 10
  }, void 0);
}, Yx = (e) => Object.values(le).find((n) => Tt(e, { path: n, exact: !0 }) !== null) || null, Zj = {
  default: {
    key: "zai.tool.default.reasoning",
    defaultValue: "Processando informações"
  }
}, hp = {
  my_brand: {
    key: "zai.tool.my-brand.reasoning",
    defaultValue: "Buscando informações da sua marca"
  },
  my_competitors: {
    key: "zai.tool.my-competitors.reasoning",
    defaultValue: "Buscando marcas concorrentes"
  },
  share_of_engagement: {
    key: "zai.tool.share-of-engagement-content-and-views.reasoning",
    defaultValue: "Analisando o engajamento da sua marca"
  },
  key_findings: {
    key: "zai.tool.key-findings.reasoning",
    defaultValue: "Coletando insights principais da sua marca"
  },
  share_of_attention: {
    key: "zai.tool.share-of-attention.reasoning",
    defaultValue: "Acessando o Share of Attention"
  },
  trending_territories: {
    key: "zai.tool.trending-territories.reasoning",
    defaultValue: "Identificando territórios em alta"
  },
  territory_resource: {
    key: "zai.tool.territory-resource.reasoning",
    defaultValue: "Carregando informações do território"
  },
  territory_tags: {
    key: "zai.tool.territory-tags.reasoning",
    defaultValue: "Buscando principais tags do território"
  },
  territory_niches: {
    key: "zai.tool.territory-niches.reasoning",
    defaultValue: "Identificando nichos do território"
  },
  territory_formats: {
    key: "zai.tool.territory-formats.reasoning",
    defaultValue: "Analisando formatos mais utilizados"
  },
  territory_creators: {
    key: "zai.tool.territory-creators.reasoning",
    defaultValue: "Buscando criadores relevantes no território"
  },
  territory_videos: {
    key: "zai.tool.territory-videos.reasoning",
    defaultValue: "Carregando vídeos do território"
  },
  territory_performance: {
    key: "zai.tool.territory-performance.reasoning",
    defaultValue: "Extraindo métricas do território"
  },
  territory_affinities: {
    key: "zai.tool.territory-affinities.reasoning",
    defaultValue: "Calculando afinidade com o território"
  },
  territory_audience: {
    key: "zai.tool.territory-audience.reasoning",
    defaultValue: "Analisando o público do território"
  },
  deep_analysis: {
    key: "zai.tool.deep-analysis.reasoning",
    defaultValue: "Realizando análise aprofundada do território"
  }
}, mp = {
  my_brand: {
    key: "zai.tool.my-brand.resolved",
    defaultValue: "Informações da sua marca foram avaliadas"
  },
  my_competitors: {
    key: "zai.tool.my-competitors.resolved",
    defaultValue: "Marcas concorrentes interpretadas"
  },
  share_of_engagement: {
    key: "zai.tool.share-of-engagement-content-and-views.resolved",
    defaultValue: "Análise de engajamento concluída com sucesso"
  },
  key_findings: {
    key: "zai.tool.key-findings.resolved",
    defaultValue: "Insights principais coletados"
  },
  share_of_attention: {
    key: "zai.tool.share-of-attention.resolved",
    defaultValue: "Acessei o Share of Attention"
  },
  trending_territories: {
    key: "zai.tool.trending-territories.resolved",
    defaultValue: "Territórios em alta identificados"
  },
  territory_resource: {
    key: "zai.tool.territory-resource.resolved",
    defaultValue: "Informações do território carregadas"
  },
  territory_tags: {
    key: "zai.tool.territory-tags.resolved",
    defaultValue: "Tags principais carregadas"
  },
  territory_niches: {
    key: "zai.tool.territory-niches.resolved",
    defaultValue: "Nichos identificados"
  },
  territory_formats: {
    key: "zai.tool.territory-formats.resolved",
    defaultValue: "Formatos analisados"
  },
  territory_creators: {
    key: "zai.tool.territory-creators.resolved",
    defaultValue: "Criadores relevantes encontrados"
  },
  territory_videos: {
    key: "zai.tool.territory-videos.resolved",
    defaultValue: "Vídeos carregados"
  },
  territory_performance: {
    key: "zai.tool.territory-performance.resolved",
    defaultValue: "Métricas extraídas com sucesso"
  },
  territory_affinities: {
    key: "zai.tool.territory-affinities.resolved",
    defaultValue: "Afinidade calculada"
  },
  territory_audience: {
    key: "zai.tool.territory-audience.resolved",
    defaultValue: "Público analisado"
  },
  deep_analysis: {
    key: "zai.tool.deep-analysis.resolved",
    defaultValue: "Análise aprofundada concluída"
  }
}, eB = {
  [le.GET_MY_BRAND]: "my_brand",
  [le.GET_MY_COMPETITORS]: "my_competitors",
  [le.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]: "share_of_engagement",
  [le.GET_KEY_FINDINGS]: "key_findings",
  [le.SHARE_OF_ATTENTION]: "share_of_attention",
  [le.SHARE_OF_ATTENTION_V2]: "share_of_attention",
  [le.GET_TRENDING_TERRITORIES]: "trending_territories",
  [le.GET_TERRITORY_RESOURCE]: "territory_resource",
  [le.GET_TERRITORY_TAGS_RESOURCE]: "territory_tags",
  [le.GET_TERRITORY_NICHES_RESOURCE]: "territory_niches",
  [le.GET_TERRITORY_FORMATS_RESOURCE]: "territory_formats",
  [le.GET_TERRITORY_CREATORS_RESOURCE]: "territory_creators",
  [le.GET_TERRITORY_VIDEOS_RESOURCE]: "territory_videos",
  [le.GET_TERRITORY_PERFORMANCE_RESOURCE]: "territory_performance",
  [le.GET_TERRITORY_AFFINITIES_RESOURCE]: "territory_affinities",
  [le.GET_TERRITORY_AUDIENCE_RESOURCE]: "territory_audience",
  [le.DEEP_ANALYSIS_RESOURCE]: "deep_analysis"
}, tB = () => {
  const { t: e } = Je(), t = oe((r) => r?.message?.content);
  return pe(() => {
    const r = t?.filter((i) => i.type === "tool-call");
    return r?.length ? r.map((i) => {
      const s = Yx(i.argsText || "");
      if (!s) return i;
      const a = eB[s] || "default", o = hp[a] ? e(hp[a]) : e(Zj.default), u = mp[a] ? e(mp[a]) : void 0;
      return {
        ...i,
        toolUri: s,
        reasoningText: o,
        resolvedText: u
      };
    }) : [];
  }, [t, e]);
}, pp = {
  checkedSources: {
    key: "zai.tool-group.checked-sources",
    defaultValue: "Chequei as fontes de dados"
  },
  processingUnknownTool: {
    key: "zai.tool-group.processing-unknown-tool",
    defaultValue: "Processando informações"
  }
}, nB = () => {
  const { t: e } = Je(), t = tB(), n = oe((c) => c?.message?.content), r = oe((c) => c?.message?.status), i = t.length > 0, s = pe(() => {
    const c = n?.findLast((d) => d.type === "text");
    return c && c.text?.trim().length > 0 ? !1 : r?.type === "running";
  }, [n, r?.type]), a = t?.filter((c) => Yx(c.argsText || "") !== null), o = a && a.length > 0 ? a[a.length - 1] : void 0;
  return { title: pe(() => s ? o?.reasoningText || o?.argsText || e(pp.processingUnknownTool) : e(pp.checkedSources), [e, s, o?.reasoningText, o?.argsText]), toolCalls: a, isRunning: s, hasToolCalls: i };
}, rB = ({ isRunning: e, toolCalls: t }) => {
  const n = e ? t?.slice(0, -1) : t, r = pe(() => n ? Array.from(new Map(n.map((s) => [s.toolUri, s])).values()) : [], [n?.length]);
  return {
    checkedToolsCount: r ? r.length : 0,
    uniqueToolCalls: r
  };
}, iB = {
  thought: {
    key: "zai.checked-tools.thought",
    defaultValue: "Pensamento"
  }
}, sB = ({ uniqueToolCalls: e, checkedToolsCount: t }) => {
  const { t: n } = Je();
  return /* @__PURE__ */ p.jsxDEV(rd, { children: [
    /* @__PURE__ */ p.jsxDEV(id, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(
      Bt,
      {
        variant: "outline",
        disabled: t === 0,
        className: `
            text-primary
            font-normal
            text-base
            py-0.5
            pr-2
            pl-1.5
            border
            border-neutral-200
            bg-white
            rounded-full
            whitespace-nowrap
            inline-flex
            gap-1
            items-center
            max-w-36
            hover:border-neutral-300
            hover:bg-neutral-50
            hover:[&>span]:inline-flex
            h-auto
          `,
        children: [
          /* @__PURE__ */ p.jsxDEV(mh, { className: "size-5 text-purple-600 dark:text-purple-300" }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
            lineNumber: 41,
            columnNumber: 11
          }, void 0),
          t
        ]
      },
      void 0,
      !0,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
        lineNumber: 16,
        columnNumber: 9
      },
      void 0
    ) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
      lineNumber: 15,
      columnNumber: 7
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(
      sd,
      {
        side: "top",
        align: "start",
        className: "border rounded-xl border-neutral-200 dark:border-neutral-500 bg-white dark:bg-neutral-800 w-fit max-w-xl",
        children: [
          /* @__PURE__ */ p.jsxDEV("h4", { className: "text-sm text-muted-foreground mb-2", children: n(iB.thought) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
            lineNumber: 50,
            columnNumber: 9
          }, void 0),
          /* @__PURE__ */ p.jsxDEV("div", { className: "max-h-60 overflow-y-auto", children: e.map((r) => /* @__PURE__ */ p.jsxDEV(
            "div",
            {
              className: "flex items-center gap-2 my-3 text-purple-600 dark:text-purple-300",
              children: [
                /* @__PURE__ */ p.jsxDEV(mh, { size: 20 }, void 0, !1, {
                  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
                  lineNumber: 58,
                  columnNumber: 15
                }, void 0),
                /* @__PURE__ */ p.jsxDEV("p", { children: r.resolvedText }, void 0, !1, {
                  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
                  lineNumber: 59,
                  columnNumber: 15
                }, void 0)
              ]
            },
            `reasoning-text-${r.toolCallId}`,
            !0,
            {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
              lineNumber: 54,
              columnNumber: 13
            },
            void 0
          )) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
            lineNumber: 52,
            columnNumber: 9
          }, void 0)
        ]
      },
      void 0,
      !0,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
        lineNumber: 45,
        columnNumber: 7
      },
      void 0
    )
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/checked-tools.view.tsx",
    lineNumber: 14,
    columnNumber: 5
  }, void 0);
}, aB = (e) => {
  const t = rB(e);
  return /* @__PURE__ */ p.jsxDEV(sB, { ...t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/checked-tools/index.tsx",
    lineNumber: 7,
    columnNumber: 10
  }, void 0);
}, oB = ({ title: e, isRunning: t, toolCalls: n, hasToolCalls: r }) => r ? /* @__PURE__ */ p.jsxDEV("div", { className: "flex items-center gap-2 my-3 text-purple-600 dark:text-purple-300", children: [
  t && /* @__PURE__ */ p.jsxDEV("span", { className: "animate-spin size-5 border-2 border-purple-600 dark:border-purple-300 rounded-full border-t-transparent" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/tool-group/tool-group.view.tsx",
    lineNumber: 11,
    columnNumber: 9
  }, void 0),
  /* @__PURE__ */ p.jsxDEV("p", { children: e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/tool-group/tool-group.view.tsx",
    lineNumber: 14,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV(aB, { toolCalls: n, isRunning: t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/tool-group/tool-group.view.tsx",
    lineNumber: 16,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/tool-group/tool-group.view.tsx",
  lineNumber: 9,
  columnNumber: 5
}, void 0) : null, uB = () => {
  const e = nB();
  return /* @__PURE__ */ p.jsxDEV(oB, { ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/tool-group/index.tsx",
    lineNumber: 8,
    columnNumber: 10
  }, void 0);
}, Gx = Ce(uB), Vd = ({ className: e, ...t }) => /* @__PURE__ */ p.jsxDEV(
  wb,
  {
    hideWhenSingleBranch: !0,
    className: ve("text-muted-foreground inline-flex items-center text-xs", e),
    ...t,
    children: [
      /* @__PURE__ */ p.jsxDEV(lk, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(on, { tooltip: "Previous", children: /* @__PURE__ */ p.jsxDEV(Kb, {}, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
        lineNumber: 17,
        columnNumber: 11
      }, void 0) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
        lineNumber: 16,
        columnNumber: 9
      }, void 0) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
        lineNumber: 15,
        columnNumber: 7
      }, void 0),
      /* @__PURE__ */ p.jsxDEV("span", { className: "font-medium", children: [
        /* @__PURE__ */ p.jsxDEV(vb, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
          lineNumber: 21,
          columnNumber: 9
        }, void 0),
        " / ",
        /* @__PURE__ */ p.jsxDEV(Nb, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
          lineNumber: 21,
          columnNumber: 44
        }, void 0)
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
        lineNumber: 20,
        columnNumber: 7
      }, void 0),
      /* @__PURE__ */ p.jsxDEV(uk, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(on, { tooltip: "Next", children: /* @__PURE__ */ p.jsxDEV(h2, {}, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
        lineNumber: 25,
        columnNumber: 11
      }, void 0) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
        lineNumber: 24,
        columnNumber: 9
      }, void 0) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
        lineNumber: 23,
        columnNumber: 7
      }, void 0)
    ]
  },
  void 0,
  !0,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/branch-picker.tsx",
    lineNumber: 10,
    columnNumber: 5
  },
  void 0
), cB = () => /* @__PURE__ */ p.jsxDEV("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", width: "16", height: "16", children: /* @__PURE__ */ p.jsxDEV("rect", { width: "10", height: "10", x: "3", y: "3", rx: "2" }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
  lineNumber: 14,
  columnNumber: 7
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
  lineNumber: 13,
  columnNumber: 5
}, void 0), gp = (e) => /* @__PURE__ */ p.jsxDEV(
  on,
  {
    variant: "default",
    side: "top",
    className: `
        my-3
        size-8
        p-2
        transition-opacity
        ease-in
        text-white
        bg-gradient-to-br
        from-purple-600
        to-violet-900
        hover:from-purple-700
        hover:to-purple-900
      `,
    ...e
  },
  void 0,
  !1,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 21,
    columnNumber: 5
  },
  void 0
), lB = () => /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: [
  /* @__PURE__ */ p.jsxDEV(Ps, { running: !1, children: /* @__PURE__ */ p.jsxDEV(Sb, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(gp, { tooltip: "Send", children: /* @__PURE__ */ p.jsxDEV(R2, {}, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 48,
    columnNumber: 13
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 47,
    columnNumber: 11
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 46,
    columnNumber: 9
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 45,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV(Ps, { running: !0, children: /* @__PURE__ */ p.jsxDEV(Ib, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(gp, { tooltip: "Cancel", children: /* @__PURE__ */ p.jsxDEV(cB, {}, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 55,
    columnNumber: 13
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 54,
    columnNumber: 11
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 53,
    columnNumber: 9
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
    lineNumber: 52,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
  lineNumber: 44,
  columnNumber: 5
}, void 0), qx = () => {
  const { t: e } = Je();
  return /* @__PURE__ */ p.jsxDEV(
    Gl,
    {
      className: `
        focus-within:border-ring/20
        flex
        w-full
        flex-wrap
        items-center
        rounded-2xl
        border
        bg-white
        dark:bg-neutral-800
        px-3
        shadow-sm
        transition-colors
        ease-in
      `,
      children: [
        /* @__PURE__ */ p.jsxDEV("div", { className: "flex items-center my-3", children: /* @__PURE__ */ p.jsxDEV(AE, { className: "size-7 text-neutral-500 dark:text-[#FFFFFF80]" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
          lineNumber: 85,
          columnNumber: 9
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
          lineNumber: 84,
          columnNumber: 7
        }, void 0),
        /* @__PURE__ */ p.jsxDEV(
          Kl,
          {
            rows: 1,
            autoFocus: !0,
            placeholder: e(en.placeholder),
            className: `
          placeholder:text-muted-foreground
          max-h-40
          flex-grow
          resize-none
          border-none
          bg-transparent
          px-2
          py-4
          text-sm
          outline-none
          focus:ring-0
          disabled:cursor-not-allowed
        `
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
            lineNumber: 87,
            columnNumber: 7
          },
          void 0
        ),
        /* @__PURE__ */ p.jsxDEV(lB, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
          lineNumber: 106,
          columnNumber: 7
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/composer.tsx",
      lineNumber: 67,
      columnNumber: 5
    },
    void 0
  );
}, Kx = () => /* @__PURE__ */ p.jsxDEV(Gl, { className: "bg-muted my-4 flex w-full max-w-[var(--thread-max-width)] flex-col gap-2 rounded-xl", children: [
  /* @__PURE__ */ p.jsxDEV(Kl, { className: "text-foreground flex h-8 w-full resize-none bg-transparent p-4 pb-0 outline-none" }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/edit-composer.tsx",
    lineNumber: 9,
    columnNumber: 7
  }, void 0),
  /* @__PURE__ */ p.jsxDEV("div", { className: "mx-3 mb-3 flex items-center justify-center gap-2 self-end", children: [
    /* @__PURE__ */ p.jsxDEV(Ib, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(Bt, { variant: "ghost", children: "Cancel" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/edit-composer.tsx",
      lineNumber: 13,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/edit-composer.tsx",
      lineNumber: 12,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(Sb, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(Bt, { children: "Send" }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/edit-composer.tsx",
      lineNumber: 16,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/edit-composer.tsx",
      lineNumber: 15,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/edit-composer.tsx",
    lineNumber: 11,
    columnNumber: 7
  }, void 0)
] }, void 0, !0, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/edit-composer.tsx",
  lineNumber: 8,
  columnNumber: 5
}, void 0), dB = () => /* @__PURE__ */ p.jsxDEV(
  Mo,
  {
    hideWhenRunning: !0,
    autohide: "not-last",
    className: "flex flex-col items-end col-start-1 row-start-2 mr-3 mt-2.5",
    children: /* @__PURE__ */ p.jsxDEV(MN, { asChild: !0 }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/user-message.tsx",
      lineNumber: 13,
      columnNumber: 7
    }, void 0)
  },
  void 0,
  !1,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/user-message.tsx",
    lineNumber: 8,
    columnNumber: 5
  },
  void 0
), Qx = () => /* @__PURE__ */ p.jsxDEV(
  Jo,
  {
    className: `
        flex
        justify-end
        gap-y-2
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
    children: [
      /* @__PURE__ */ p.jsxDEV(dB, {}, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/user-message.tsx",
        lineNumber: 30,
        columnNumber: 7
      }, void 0),
      /* @__PURE__ */ p.jsxDEV(
        "div",
        {
          className: `
          bg-muted
          text-foreground
          max-w-[min(calc(var(--thread-max-width)*0.8),70%)]
          break-words
          rounded-lg
          py-2
          px-3
        `,
          children: /* @__PURE__ */ p.jsxDEV(Zo, {}, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/user-message.tsx",
            lineNumber: 43,
            columnNumber: 9
          }, void 0)
        },
        void 0,
        !1,
        {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/user-message.tsx",
          lineNumber: 32,
          columnNumber: 7
        },
        void 0
      ),
      /* @__PURE__ */ p.jsxDEV(Vd, { className: "col-span-full col-start-1 row-start-3 -mr-1 justify-end" }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/user-message.tsx",
        lineNumber: 46,
        columnNumber: 7
      }, void 0)
    ]
  },
  void 0,
  !0,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/shared/user-message.tsx",
    lineNumber: 20,
    columnNumber: 5
  },
  void 0
), Xx = ({ className: e }) => {
  const t = oe((a) => a?.thread?.isLoading), { t: n } = Je(), { isLoading: r, data: i } = Yj(), s = t || r;
  return /* @__PURE__ */ p.jsxDEV(
    Xl,
    {
      className: ve("box-border flex h-full flex-col overflow-hidden rounded-xl", e),
      style: {
        "--thread-max-width": "42rem"
      },
      children: /* @__PURE__ */ p.jsxDEV(Jl, { className: "flex h-full flex-col items-center overflow-y-scroll scroll-smooth px-4 pt-8 mb-19", children: [
        s && /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-grow items-center justify-center", children: n(en.loading) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 44,
          columnNumber: 25
        }, void 0),
        !s && /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: [
          /* @__PURE__ */ p.jsxDEV(mB, { suggestions: i }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 48,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV(fB, {}, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 50,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV(Ps, { empty: !1, children: /* @__PURE__ */ p.jsxDEV("div", { className: "min-h-8 flex-grow" }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 53,
            columnNumber: 15
          }, void 0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 52,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV("div", { className: "absolute self-center-safe bottom-0 mt-3 flex w-full max-w-[var(--thread-max-width)] flex-col items-center justify-end rounded-t-lg bg-inherit px-4 pb-9 z-[10]", children: [
            /* @__PURE__ */ p.jsxDEV(hB, {}, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
              lineNumber: 57,
              columnNumber: 15
            }, void 0),
            /* @__PURE__ */ p.jsxDEV(qx, {}, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
              lineNumber: 58,
              columnNumber: 15
            }, void 0)
          ] }, void 0, !0, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 56,
            columnNumber: 13
          }, void 0)
        ] }, void 0, !0, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 47,
          columnNumber: 11
        }, void 0)
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
        lineNumber: 43,
        columnNumber: 7
      }, void 0)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 37,
      columnNumber: 5
    },
    void 0
  );
}, fB = () => {
  const e = oe((r) => r?.thread?.messages?.length), [t, n] = we(!1);
  return xi(() => {
    n(!0);
  }, []), !t || e === 0 ? null : /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: Array.from({ length: e }, (r, i) => /* @__PURE__ */ p.jsxDEV(
    vl,
    {
      index: i,
      components: {
        UserMessage: Qx,
        EditComposer: Kx,
        AssistantMessage: bB
      }
    },
    i,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 83,
      columnNumber: 11
    },
    void 0
  )) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
    lineNumber: 80,
    columnNumber: 5
  }, void 0);
}, hB = () => {
  const { t: e } = Je();
  return /* @__PURE__ */ p.jsxDEV(zb, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(
    on,
    {
      tooltip: e(en.scrollToBottom),
      variant: "outline",
      side: "top",
      className: "absolute -top-8 rounded-full disabled:invisible",
      children: /* @__PURE__ */ p.jsxDEV(Gb, {}, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
        lineNumber: 109,
        columnNumber: 9
      }, void 0)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 103,
      columnNumber: 7
    },
    void 0
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
    lineNumber: 102,
    columnNumber: 5
  }, void 0);
}, mB = ({ suggestions: e }) => {
  const { t } = Je();
  return /* @__PURE__ */ p.jsxDEV(Bb, { children: /* @__PURE__ */ p.jsxDEV("div", { className: "flex w-full max-w-[var(--thread-max-width)] flex-grow flex-col justify-center gap-9", children: [
    /* @__PURE__ */ p.jsxDEV("div", { className: "flex w-full flex-col items-center justify-center", children: /* @__PURE__ */ p.jsxDEV("p", { className: "mt-4 font-semibold text-3xl", children: t(en.welcomeMessage) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 122,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 121,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(pB, { suggestions: e }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 124,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
    lineNumber: 120,
    columnNumber: 7
  }, void 0) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
    lineNumber: 119,
    columnNumber: 5
  }, void 0);
}, pB = ({ suggestions: e }) => /* @__PURE__ */ p.jsxDEV("div", { className: "mt-3 flex w-full items-stretch justify-center gap-4 flex-wrap", children: e.map((t, n) => /* @__PURE__ */ p.jsxDEV(
  gB,
  {
    id: t.id,
    prompt: t.text,
    method: "replace",
    autoSend: !0,
    children: t.text
  },
  `thread-welcome-suggestion-item-${n}`,
  !1,
  {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
    lineNumber: 134,
    columnNumber: 9
  },
  void 0
)) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
  lineNumber: 132,
  columnNumber: 5
}, void 0), gB = ({ id: e, prompt: t, method: n = "replace", autoSend: r = !1, children: i }) => {
  const { setIsPrePrompt: s } = Mi(), { setQuickPromptId: a } = ad();
  return /* @__PURE__ */ p.jsxDEV(
    Xk,
    {
      onClick: () => {
        s(!0), a(e ? String(e) : null);
      },
      prompt: t,
      method: n,
      autoSend: r,
      asChild: !0,
      children: /* @__PURE__ */ p.jsxDEV(Bt, { variant: "purple-gradient", size: "lg", className: "h-11 rounded-xl font-normal", children: [
        /* @__PURE__ */ p.jsxDEV(xD, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 174,
          columnNumber: 9
        }, void 0),
        i
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
        lineNumber: 173,
        columnNumber: 7
      }, void 0)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 159,
      columnNumber: 5
    },
    void 0
  );
}, bB = () => {
  const { t: e } = Je(), t = oe((n) => n?.message?.status?.type === "complete");
  return /* @__PURE__ */ p.jsxDEV(
    Jo,
    {
      className: `
        grid
        grid-cols-[auto_auto_1fr]
        grid-rows-[auto_1fr]
        relative
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
      children: [
        /* @__PURE__ */ p.jsxDEV(
          "div",
          {
            className: `
          text-foreground
          max-w-[var(--thread-max-width)]
          break-words
          leading-7
          col-span-2
          col-start-2
          row-start-1
          my-1.5
        `,
            children: [
              /* @__PURE__ */ p.jsxDEV(Wx, {}, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
                lineNumber: 209,
                columnNumber: 9
              }, void 0),
              /* @__PURE__ */ p.jsxDEV(Gx, {}, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
                lineNumber: 211,
                columnNumber: 9
              }, void 0),
              /* @__PURE__ */ p.jsxDEV(
                Zo,
                {
                  components: {
                    Text: Bx,
                    ToolGroup: () => null,
                    tools: {
                      Fallback: void 0
                    }
                  }
                },
                void 0,
                !1,
                {
                  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
                  lineNumber: 213,
                  columnNumber: 9
                },
                void 0
              ),
              t && /* @__PURE__ */ p.jsxDEV(zx, {}, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
                lineNumber: 223,
                columnNumber: 24
              }, void 0),
              /* @__PURE__ */ p.jsxDEV(Ql, { children: /* @__PURE__ */ p.jsxDEV("div", { className: "rounded-lg p-2 text-sm bg-red-500/10 border border-red-500/20", children: /* @__PURE__ */ p.jsxDEV("p", { children: e(en.somethingWentWrong) }, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
                lineNumber: 227,
                columnNumber: 13
              }, void 0) }, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
                lineNumber: 226,
                columnNumber: 11
              }, void 0) }, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
                lineNumber: 225,
                columnNumber: 9
              }, void 0)
            ]
          },
          void 0,
          !0,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 197,
            columnNumber: 7
          },
          void 0
        ),
        /* @__PURE__ */ p.jsxDEV(EB, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 232,
          columnNumber: 7
        }, void 0),
        /* @__PURE__ */ p.jsxDEV(Vd, { className: "col-start-2 row-start-2 -ml-2 mr-2" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 234,
          columnNumber: 7
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 186,
      columnNumber: 5
    },
    void 0
  );
}, EB = () => {
  const { t: e } = Je();
  return /* @__PURE__ */ p.jsxDEV(
    Mo,
    {
      hideWhenRunning: !0,
      autohide: "never",
      autohideFloat: "single-branch",
      className: "items-center text-neutral-200 flex gap-1 col-start-3 row-start-2 -ml-1 data-[floating]:bg-background data-[floating]:absolute data-[floating]:rounded-md data-[floating]:border data-[floating]:p-1 data-[floating]:shadow-sm",
      children: [
        /* @__PURE__ */ p.jsxDEV(dn, { hasContent: !0, children: /* @__PURE__ */ p.jsxDEV(pd, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(on, { tooltip: e(en.copy), children: [
          /* @__PURE__ */ p.jsxDEV(dn, { copied: !0, children: /* @__PURE__ */ p.jsxDEV(eu, {}, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 253,
            columnNumber: 15
          }, void 0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 252,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV(dn, { copied: !1, children: /* @__PURE__ */ p.jsxDEV(Zl, {}, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 256,
            columnNumber: 15
          }, void 0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 255,
            columnNumber: 13
          }, void 0)
        ] }, void 0, !0, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 251,
          columnNumber: 11
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 250,
          columnNumber: 9
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 249,
          columnNumber: 7
        }, void 0),
        /* @__PURE__ */ p.jsxDEV(dn, { last: !0, children: [
          /* @__PURE__ */ p.jsxDEV(Rg, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(on, { tooltip: "Refresh", children: /* @__PURE__ */ p.jsxDEV(Qb, {}, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 265,
            columnNumber: 13
          }, void 0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 264,
            columnNumber: 11
          }, void 0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 263,
            columnNumber: 9
          }, void 0),
          /* @__PURE__ */ p.jsxDEV(dn, { hasContent: !0, children: [
            /* @__PURE__ */ p.jsxDEV(Og, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(fp, { type: "positive" }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
              lineNumber: 271,
              columnNumber: 13
            }, void 0) }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
              lineNumber: 270,
              columnNumber: 11
            }, void 0),
            /* @__PURE__ */ p.jsxDEV(Lg, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(fp, { type: "negative", hasDialog: !0 }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
              lineNumber: 275,
              columnNumber: 13
            }, void 0) }, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
              lineNumber: 274,
              columnNumber: 11
            }, void 0)
          ] }, void 0, !0, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
            lineNumber: 269,
            columnNumber: 9
          }, void 0)
        ] }, void 0, !0, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 262,
          columnNumber: 7
        }, void 0),
        /* @__PURE__ */ p.jsxDEV($x, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
          lineNumber: 280,
          columnNumber: 7
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/thread/index.tsx",
      lineNumber: 243,
      columnNumber: 5
    },
    void 0
  );
}, Fn = {
  threadId: "thread_id",
  threadPrompt: "thread_prompt",
  threadPromptPage: "thread_prompt_page",
  quickPromptId: "quick_prompt_id"
}, _B = ({ children: e }) => {
  const t = oe((B) => B?.threadListItem?.remoteId), n = oe((B) => B?.threads?.threadIds), r = oe((B) => B?.threads?.isLoading), i = oe((B) => B?.thread?.isLoading), s = Ve(), a = Ep(), { search: o, pathname: u } = p1(), c = pe(() => new URLSearchParams(o), [o]), l = c.get(Fn.threadId), d = c.get(Fn.threadPrompt), h = c.get(Fn.threadPromptPage), m = c.get(Fn.quickPromptId), E = st(!0), { setIsPrePrompt: g, setPage: T } = Mi(), { setQuickPromptId: _ } = ad(), [A, w] = we(!1), M = de(() => {
    const B = `${u}?${c.toString()}`;
    a.replace(B);
  }, [a, c, u]), F = de(() => {
    c.delete(Fn.threadPrompt), c.delete(Fn.threadPromptPage), c.delete(Fn.quickPromptId);
  }, [c]), k = de(async () => {
    if (d)
      return new Promise((B) => {
        h && T({ page: h }), m && _(m), g(!0), E.current = !1, s.threads().switchToNewThread(), setTimeout(() => {
          s.thread().append({
            role: "user",
            content: [{ type: "text", text: d }]
          }), setTimeout(B, 100);
        }, 100);
      });
  }, [h, m, d, g, s, T, _]);
  return Le(() => {
    !r && !n.length || w(!0);
  }, [r, n]), Le(() => {
    i || !t || t === l || d || (E.current = !1, c.set(Fn.threadId, t), M());
  }, [t, i, l, c, u, M, d]), Le(() => {
    const B = n.find(($) => $ === l);
    !E.current || !l || !s || !B || d || (E.current = !1, s.threads().switchToThread(B));
  }, [s, l, n, d]), Le(() => {
    !s || r || !A || !d || k().then(() => {
      F(), M();
    }).catch((B) => {
      console.error("INITIAL PROMPT BY URL", B);
    });
  }, [
    s,
    A,
    k,
    r,
    d,
    u,
    c,
    F,
    M
  ]), /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/threadUrlObserve/index.tsx",
    lineNumber: 122,
    columnNumber: 10
  }, void 0);
}, xB = Ce(_B), TB = "zai-chat:modal-upload-open", AB = "zai-chat:modal-info-open", bp = "zai-chat:file-count-refetch", yB = () => {
  const e = st(null), t = de(() => {
    window.dispatchEvent(new CustomEvent(TB));
  }, []), n = de(() => {
    window.dispatchEvent(new CustomEvent(AB));
  }, []);
  return Le(() => {
    const r = () => {
      e.current?.refetch();
    };
    return window.addEventListener(bp, r), () => {
      window.removeEventListener(bp, r);
    };
  }, []), {
    handleModalUploadOpen: t,
    handleModalInfoOpen: n,
    fileUploadRef: e
  };
};
function pF({ isZaiRagEnabled: e }) {
  const { assistantUiIsReady: t } = St(), { handleModalUploadOpen: n, handleModalInfoOpen: r, fileUploadRef: i } = yB(), { setOrigin: s } = Mi();
  return Le(() => {
    s({ origin: "center-stage" });
  }, [s]), /* @__PURE__ */ p.jsxDEV("main", { id: "zai-chat-center-stage", className: "zai-chat-package dark", style: { height: "100%" }, children: /* @__PURE__ */ p.jsxDEV(zd, { theme: "dark", children: /* @__PURE__ */ p.jsxDEV(nd, { theme: "dark", children: t && /* @__PURE__ */ p.jsxDEV(xB, { children: /* @__PURE__ */ p.jsxDEV(
    uD,
    {
      className: "h-full min-h-0 relative",
      style: {
        "--sidebar-width": "calc(328px + 2rem)"
      },
      children: [
        /* @__PURE__ */ p.jsxDEV(AD, { isZaiRagEnabled: e }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
          lineNumber: 38,
          columnNumber: 17
        }, this),
        e && /* @__PURE__ */ p.jsxDEV("div", { className: "absolute bottom-0 px-4 pb-4", style: { width: "var(--sidebar-width)" }, children: /* @__PURE__ */ p.jsxDEV(
          BE,
          {
            onButtonClick: n,
            onInfoClick: r,
            ref: i
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
            lineNumber: 41,
            columnNumber: 21
          },
          this
        ) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
          lineNumber: 40,
          columnNumber: 19
        }, this),
        /* @__PURE__ */ p.jsxDEV(lD, { className: "bg-transparent", children: /* @__PURE__ */ p.jsxDEV("div", { className: "grid h-full p-4 pl-0", children: /* @__PURE__ */ p.jsxDEV(nu, { children: /* @__PURE__ */ p.jsxDEV(Xx, { className: "bg-background" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
          lineNumber: 51,
          columnNumber: 23
        }, this) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
          lineNumber: 50,
          columnNumber: 21
        }, this) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
          lineNumber: 49,
          columnNumber: 19
        }, this) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
          lineNumber: 48,
          columnNumber: 17
        }, this)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
      lineNumber: 30,
      columnNumber: 15
    },
    this
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
    lineNumber: 29,
    columnNumber: 13
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
    lineNumber: 27,
    columnNumber: 9
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
    lineNumber: 26,
    columnNumber: 7
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/center-stage/index.tsx",
    lineNumber: 25,
    columnNumber: 5
  }, this);
}
const NB = Ce(({ isOpen: e, children: t }) => /* @__PURE__ */ p.jsxDEV("div", { className: "aside-modal-view-container", "data-open": e, "aria-hidden": !e, children: t }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/aside-modal/aside-modal.view.tsx",
  lineNumber: 8,
  columnNumber: 5
}, void 0)), vB = Ce(({ children: e, isOpen: t }) => /* @__PURE__ */ p.jsxDEV(NB, { isOpen: t, children: e }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/aside-modal/index.tsx",
  lineNumber: 7,
  columnNumber: 10
}, void 0)), wB = Ce(({ handleClick: e, Icon: t }) => /* @__PURE__ */ p.jsxDEV("button", { className: "button-arrow", onClick: e, children: /* @__PURE__ */ p.jsxDEV(t, { width: 28, height: 28 }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-arrow/button-arrow.view.tsx",
  lineNumber: 7,
  columnNumber: 5
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-arrow/button-arrow.view.tsx",
  lineNumber: 6,
  columnNumber: 3
}, void 0)), CB = Ce(({ handleClick: e }) => /* @__PURE__ */ p.jsxDEV(wB, { handleClick: e, Icon: Kb }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-arrow/index.tsx",
  lineNumber: 10,
  columnNumber: 3
}, void 0)), SB = Ce(({ handleClick: e, Icon: t }) => /* @__PURE__ */ p.jsxDEV("button", { className: "button-expand", onClick: e, children: /* @__PURE__ */ p.jsxDEV(t, {}, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-expand/button-expand.view.tsx",
  lineNumber: 7,
  columnNumber: 5
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-expand/button-expand.view.tsx",
  lineNumber: 6,
  columnNumber: 3
}, void 0)), kB = Ce(({ handleClick: e }) => /* @__PURE__ */ p.jsxDEV(SB, { handleClick: e, Icon: C2 }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-expand/index.tsx",
  lineNumber: 10,
  columnNumber: 3
}, void 0)), IB = Ce(({ handleClick: e, Icon: t }) => /* @__PURE__ */ p.jsxDEV("button", { className: "menu-hamburger", onClick: e, children: /* @__PURE__ */ p.jsxDEV(t, {}, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-hamburger/button-hamburger.view.tsx",
  lineNumber: 7,
  columnNumber: 5
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-hamburger/button-hamburger.view.tsx",
  lineNumber: 6,
  columnNumber: 3
}, void 0)), DB = Ce(({ handleClick: e }) => /* @__PURE__ */ p.jsxDEV(IB, { handleClick: e, Icon: o2 }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-hamburger/index.tsx",
  lineNumber: 10,
  columnNumber: 3
}, void 0)), RB = Ce(({ handleClick: e, Icon: t }) => /* @__PURE__ */ p.jsxDEV("button", { className: "button-x", onClick: e, children: /* @__PURE__ */ p.jsxDEV(t, { width: 28, height: 28 }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-x/button-x.view.tsx",
  lineNumber: 7,
  columnNumber: 5
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-x/button-x.view.tsx",
  lineNumber: 6,
  columnNumber: 3
}, void 0)), PB = Ce(({ handleClick: e }) => /* @__PURE__ */ p.jsxDEV(RB, { handleClick: e, Icon: Xb }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/button-x/index.tsx",
  lineNumber: 9,
  columnNumber: 65
}, void 0)), OB = Ce(
  ({ handleButtonMenuClick: e, handleItemClick: t, CloseComponent: n }) => /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxDEV("div", { className: "side-modal-aside-header", children: /* @__PURE__ */ p.jsxDEV(n, { handleClick: () => e({ isOpen: !1 }) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-aside-content.tsx",
      lineNumber: 12,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-aside-content.tsx",
      lineNumber: 11,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("div", { className: "side-modal-aside-content", children: /* @__PURE__ */ p.jsxDEV(_E, { handleItemClick: t }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-aside-content.tsx",
      lineNumber: 15,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-aside-content.tsx",
      lineNumber: 14,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-aside-content.tsx",
    lineNumber: 10,
    columnNumber: 7
  }, void 0)
), LB = () => /* @__PURE__ */ p.jsxDEV(nu, { children: /* @__PURE__ */ p.jsxDEV(Xx, {}, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-content.tsx",
  lineNumber: 9,
  columnNumber: 7
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-content.tsx",
  lineNumber: 8,
  columnNumber: 5
}, void 0), MB = Ce(LB), UB = Ce(
  ({
    handleButtonCloseClick: e,
    handleButtonMenuClick: t,
    handleButtonRedirectClick: n,
    LogoComponent: r,
    MenuComponent: i,
    CloseComponent: s,
    RedirectComponent: a
  }) => /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxDEV("div", { className: "side-modal-view-header-box-left", children: /* @__PURE__ */ p.jsxDEV(i, { handleClick: () => t({ isOpen: !0 }) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-header.tsx",
      lineNumber: 18,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-header.tsx",
      lineNumber: 17,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("div", { className: "side-modal-view-header-box-middle", children: /* @__PURE__ */ p.jsxDEV(r, {}, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-header.tsx",
      lineNumber: 21,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-header.tsx",
      lineNumber: 20,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("div", { className: "side-modal-view-header-box-right", children: [
      /* @__PURE__ */ p.jsxDEV(a, { handleClick: n }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-header.tsx",
        lineNumber: 24,
        columnNumber: 11
      }, void 0),
      /* @__PURE__ */ p.jsxDEV(s, { handleClick: e }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-header.tsx",
        lineNumber: 25,
        columnNumber: 11
      }, void 0)
    ] }, void 0, !0, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-header.tsx",
      lineNumber: 23,
      columnNumber: 9
    }, void 0)
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat-header.tsx",
    lineNumber: 16,
    columnNumber: 7
  }, void 0)
), HB = ({
  isAsideModalOpen: e,
  setIsAsideModalOpen: t,
  threadId: n,
  mixpanelSetOrigin: r
}) => {
  const i = Ep(), [s, a] = we({
    isAsideContentOpen: !1
  });
  Le(() => {
    e && (Lr.track(Or.sideChatOpen), r({ origin: "side-chat" }));
  }, [e, r]);
  const o = de(
    ({ isOpen: d }) => a((h) => ({ ...h, isAsideContentOpen: d })),
    []
  ), u = de(() => {
    Lr.track(Or.sideChatClose), t(!1);
  }, [t]), c = de(
    () => i.push(`/zai${n ? `?${Fn.threadId}=${n}` : ""}`),
    [i, n]
  ), l = de(
    () => a((d) => ({ ...d, isAsideContentOpen: !1 })),
    [a]
  );
  return {
    sideChatStates: s,
    handles: {
      sideChat: {
        handleButtonMenuClick: o,
        handleButtonCloseClick: u,
        handleButtonRedirectClick: c,
        handleThreadListItemClick: l
      }
    }
  };
}, jB = Ce(
  ({
    ContentComponent: e,
    AsideContentComponent: t,
    AsideCloseComponent: n,
    HeaderComponent: r,
    HeaderLogoComponent: i,
    HeaderMenuComponent: s,
    HeaderCloseComponent: a,
    HeaderRedirectComponent: o,
    ...u
  }) => /* @__PURE__ */ p.jsxDEV("div", { className: "side-modal-view-container", children: [
    /* @__PURE__ */ p.jsxDEV("div", { className: "side-modal-view-header", children: /* @__PURE__ */ p.jsxDEV(
      r,
      {
        handleButtonCloseClick: u.handleButtonCloseClick,
        handleButtonMenuClick: u.handleButtonMenuClick,
        handleButtonRedirectClick: u.handleButtonRedirectClick,
        LogoComponent: i,
        MenuComponent: s,
        CloseComponent: a,
        RedirectComponent: o
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat.view.tsx",
        lineNumber: 20,
        columnNumber: 11
      },
      void 0
    ) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat.view.tsx",
      lineNumber: 19,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV("div", { className: "side-modal-view-content h-full flex flex-col overflow-y-scroll", children: /* @__PURE__ */ p.jsxDEV(e, {}, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat.view.tsx",
      lineNumber: 31,
      columnNumber: 11
    }, void 0) }, void 0, !1, {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat.view.tsx",
      lineNumber: 30,
      columnNumber: 9
    }, void 0),
    /* @__PURE__ */ p.jsxDEV(
      "div",
      {
        className: "side-modal-view-aside",
        "data-open": u.isAsideContentOpen,
        "aria-hidden": !u.isAsideContentOpen,
        children: /* @__PURE__ */ p.jsxDEV(
          t,
          {
            handleButtonMenuClick: u.handleButtonMenuClick,
            handleItemClick: u.handleThreadListItemClick,
            CloseComponent: n
          },
          void 0,
          !1,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat.view.tsx",
            lineNumber: 38,
            columnNumber: 11
          },
          void 0
        )
      },
      void 0,
      !1,
      {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat.view.tsx",
        lineNumber: 33,
        columnNumber: 9
      },
      void 0
    )
  ] }, void 0, !0, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/side-chat.view.tsx",
    lineNumber: 18,
    columnNumber: 7
  }, void 0)
), BB = Ce(({ isAsideModalOpen: e, setIsAsideModalOpen: t }) => {
  const n = oe((s) => s?.threadListItem?.remoteId), { setOrigin: r } = Mi(), i = HB({
    isAsideModalOpen: e,
    setIsAsideModalOpen: t,
    threadId: n,
    mixpanelSetOrigin: r
  });
  return /* @__PURE__ */ p.jsxDEV(vB, { isOpen: e, children: /* @__PURE__ */ p.jsxDEV(
    jB,
    {
      ...i.handles.sideChat,
      ...i.sideChatStates,
      HeaderComponent: UB,
      HeaderLogoComponent: yE,
      HeaderMenuComponent: DB,
      HeaderCloseComponent: PB,
      HeaderRedirectComponent: kB,
      ContentComponent: MB,
      AsideContentComponent: OB,
      AsideCloseComponent: CB
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/index.tsx",
      lineNumber: 34,
      columnNumber: 7
    },
    void 0
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/index.tsx",
    lineNumber: 33,
    columnNumber: 5
  }, void 0);
});
function gF({ isOpen: e, onOpenChange: t }) {
  const { assistantUiIsReady: n } = St();
  return /* @__PURE__ */ p.jsxDEV("main", { className: "zai-chat-package dark", children: /* @__PURE__ */ p.jsxDEV(zd, { theme: "dark", children: /* @__PURE__ */ p.jsxDEV(nd, { theme: "dark", children: n && /* @__PURE__ */ p.jsxDEV(BB, { isAsideModalOpen: e, setIsAsideModalOpen: t }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/zai-side-chat.tsx",
    lineNumber: 19,
    columnNumber: 34
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/zai-side-chat.tsx",
    lineNumber: 18,
    columnNumber: 9
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/zai-side-chat.tsx",
    lineNumber: 17,
    columnNumber: 7
  }, this) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/side-chat/zai-side-chat.tsx",
    lineNumber: 16,
    columnNumber: 5
  }, this);
}
const Ha = 100, FB = (e) => {
  const {
    contextKey: t,
    threadPrompt: n,
    skipResponseInteraction: r,
    mixpanelSetOrigin: i,
    mixpanelSetIsProactiveMessage: s,
    currentAssistUiThreadId: a,
    currentSectionThreadId: o,
    setCurrentSectionThreadId: u,
    getLastSentPrompt: c,
    setLastSentPrompt: l,
    assistRuntime: d
  } = e, [h, m] = we(!1), [E, g] = we(!1), T = st(!1), _ = pe(
    () => n !== c(t),
    [t, c, n]
  );
  return Le(() => {
    !h || !a || u({ contextKey: t, id: a });
  }, [t, h, a, u]), Le(() => {
    if (T.current && !_ || (T.current = !0, i({ origin: t }), g(!0), !_ && a && o && a === o))
      return;
    if (!_ && o) {
      d.threads().switchToThread(o);
      return;
    }
    if (_ && o) {
      s(!0), d.threads().switchToThread(o);
      let w;
      const M = setTimeout(() => {
        d.thread().cancelRun(), w = setTimeout(() => {
          d.thread().append({
            role: "user",
            content: [{ type: "text", text: n }],
            runConfig: { custom: { skipResponseInteraction: r } }
          }), l({ contextKey: t, prompt: n });
        }, Ha);
      }, Ha);
      return () => {
        clearTimeout(M), clearTimeout(w);
      };
    }
    d.threads().switchToNewThread();
    const A = setTimeout(() => {
      s(!0), d.thread().append({
        role: "user",
        content: [{ type: "text", text: n }],
        runConfig: { custom: { skipResponseInteraction: r } }
      }), l({ contextKey: t, prompt: n }), setTimeout(() => m(!0), Ha);
    }, Ha);
    return () => clearTimeout(A);
  }, [
    t,
    n,
    r,
    a,
    o,
    _,
    i,
    s,
    d,
    l
  ]), {
    shouldRender: E
  };
}, zB = {
  promptTitle: {
    key: "zai.section.heading-title",
    defaultValue: "Conversa com assistente..."
  }
}, VB = 1, WB = ({ className: e, welcomeMessage: t }) => {
  const n = oe((i) => i?.thread?.isLoading), { t: r } = Je();
  return /* @__PURE__ */ p.jsxDEV(
    Xl,
    {
      className: ve("box-border flex h-full flex-col overflow-hidden rounded-xl relative", e),
      style: { "--thread-max-width": "100%" },
      children: /* @__PURE__ */ p.jsxDEV(Jl, { className: "flex h-full flex-col items-center overflow-y-scroll scroll-smooth px-4 pt-8 mb-32", children: [
        n && /* @__PURE__ */ p.jsxDEV("div", { className: "flex flex-grow items-center justify-center", children: t || r(en.loading) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 35,
          columnNumber: 11
        }, void 0),
        !n && /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: [
          /* @__PURE__ */ p.jsxDEV("h3", { className: "text-lg font-semibold mb-3 w-full", children: t || r(zB.promptTitle) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 42,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV($B, {}, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 43,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV(Ps, { empty: !1, children: /* @__PURE__ */ p.jsxDEV("div", { className: "min-h-8 flex-grow" }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 46,
            columnNumber: 15
          }, void 0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 45,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV("div", { className: "fixed self-center-safe bottom-0 flex w-full max-w-[68rem] flex-col items-center justify-end rounded-t-lg bg-inherit px-4 pb-7 z-[10]", children: [
            /* @__PURE__ */ p.jsxDEV(YB, {}, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
              lineNumber: 50,
              columnNumber: 15
            }, void 0),
            /* @__PURE__ */ p.jsxDEV(qx, {}, void 0, !1, {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
              lineNumber: 51,
              columnNumber: 15
            }, void 0)
          ] }, void 0, !0, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 49,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV(
            "div",
            {
              "aria-hidden": "true",
              className: "fixed bottom-0 left-0 right-0 h-30 bg-gradient-to-t from-background via-background/80 to-transparent pointer-events-none z-[5]"
            },
            void 0,
            !1,
            {
              fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
              lineNumber: 54,
              columnNumber: 13
            },
            void 0
          )
        ] }, void 0, !0, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 41,
          columnNumber: 11
        }, void 0)
      ] }, void 0, !0, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
        lineNumber: 33,
        columnNumber: 7
      }, void 0)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
      lineNumber: 29,
      columnNumber: 5
    },
    void 0
  );
}, $B = () => {
  const e = oe((r) => r?.thread?.messages?.length), [t, n] = we(!1);
  return xi(() => {
    n(!0);
  }, []), !t || e === 0 ? null : /* @__PURE__ */ p.jsxDEV(p.Fragment, { children: Array.from({ length: e }, (r, i) => i < VB ? null : /* @__PURE__ */ p.jsxDEV(
    vl,
    {
      index: i,
      components: {
        UserMessage: Qx,
        EditComposer: Kx,
        AssistantMessage: GB
      }
    },
    i,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
      lineNumber: 80,
      columnNumber: 11
    },
    void 0
  )) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
    lineNumber: 76,
    columnNumber: 5
  }, void 0);
}, YB = () => {
  const { t: e } = Je();
  return /* @__PURE__ */ p.jsxDEV(zb, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(
    on,
    {
      tooltip: e(en.scrollToBottom),
      variant: "outline",
      side: "top",
      className: "absolute -top-8 rounded-full disabled:invisible",
      children: /* @__PURE__ */ p.jsxDEV(Gb, {}, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
        lineNumber: 106,
        columnNumber: 9
      }, void 0)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
      lineNumber: 100,
      columnNumber: 7
    },
    void 0
  ) }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
    lineNumber: 99,
    columnNumber: 5
  }, void 0);
}, GB = () => {
  const { t: e } = Je(), t = oe((n) => n?.message?.status?.type === "complete");
  return /* @__PURE__ */ p.jsxDEV(
    Jo,
    {
      className: `
        grid
        grid-cols-[auto_auto_1fr]
        grid-rows-[auto_1fr]
        relative
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
      children: [
        /* @__PURE__ */ p.jsxDEV(
          "div",
          {
            className: `
          text-foreground
          max-w-[var(--thread-max-width)]
          break-words
          leading-7
          col-span-2
          col-start-2
          row-start-1
          my-1.5
        `,
            children: [
              /* @__PURE__ */ p.jsxDEV(Wx, {}, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
                lineNumber: 140,
                columnNumber: 9
              }, void 0),
              /* @__PURE__ */ p.jsxDEV(Gx, {}, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
                lineNumber: 142,
                columnNumber: 9
              }, void 0),
              /* @__PURE__ */ p.jsxDEV(
                Zo,
                {
                  components: {
                    Text: Bx,
                    ToolGroup: () => null,
                    tools: {
                      Fallback: void 0
                    }
                  }
                },
                void 0,
                !1,
                {
                  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
                  lineNumber: 144,
                  columnNumber: 9
                },
                void 0
              ),
              t && /* @__PURE__ */ p.jsxDEV(zx, {}, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
                lineNumber: 154,
                columnNumber: 24
              }, void 0),
              /* @__PURE__ */ p.jsxDEV(Ql, { children: /* @__PURE__ */ p.jsxDEV("div", { className: "rounded-lg p-2 text-sm bg-red-500/10 border border-red-500/20", children: /* @__PURE__ */ p.jsxDEV("p", { children: e(en.somethingWentWrong) }, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
                lineNumber: 158,
                columnNumber: 13
              }, void 0) }, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
                lineNumber: 157,
                columnNumber: 11
              }, void 0) }, void 0, !1, {
                fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
                lineNumber: 156,
                columnNumber: 9
              }, void 0)
            ]
          },
          void 0,
          !0,
          {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 128,
            columnNumber: 7
          },
          void 0
        ),
        /* @__PURE__ */ p.jsxDEV(qB, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 163,
          columnNumber: 7
        }, void 0),
        /* @__PURE__ */ p.jsxDEV(Vd, { className: "col-start-2 row-start-2 -ml-2 mr-2" }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 165,
          columnNumber: 7
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
      lineNumber: 117,
      columnNumber: 5
    },
    void 0
  );
}, qB = () => {
  const { t: e } = Je();
  return /* @__PURE__ */ p.jsxDEV(
    Mo,
    {
      hideWhenRunning: !0,
      autohide: "never",
      autohideFloat: "single-branch",
      className: "items-center text-muted-foreground flex gap-1 col-start-3 row-start-2 -ml-1 data-[floating]:bg-background data-[floating]:absolute data-[floating]:rounded-md data-[floating]:border data-[floating]:p-1 data-[floating]:shadow-sm",
      children: [
        /* @__PURE__ */ p.jsxDEV(dn, { hasContent: !0, children: /* @__PURE__ */ p.jsxDEV(pd, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(on, { tooltip: e(en.copy), children: [
          /* @__PURE__ */ p.jsxDEV(dn, { copied: !0, children: /* @__PURE__ */ p.jsxDEV(eu, {}, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 184,
            columnNumber: 15
          }, void 0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 183,
            columnNumber: 13
          }, void 0),
          /* @__PURE__ */ p.jsxDEV(dn, { copied: !1, children: /* @__PURE__ */ p.jsxDEV(Zl, {}, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 187,
            columnNumber: 15
          }, void 0) }, void 0, !1, {
            fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
            lineNumber: 186,
            columnNumber: 13
          }, void 0)
        ] }, void 0, !0, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 182,
          columnNumber: 11
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 181,
          columnNumber: 9
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 180,
          columnNumber: 7
        }, void 0),
        /* @__PURE__ */ p.jsxDEV(dn, { last: !0, children: /* @__PURE__ */ p.jsxDEV(Rg, { asChild: !0, children: /* @__PURE__ */ p.jsxDEV(on, { tooltip: "Refresh", children: /* @__PURE__ */ p.jsxDEV(Qb, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 196,
          columnNumber: 13
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 195,
          columnNumber: 11
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 194,
          columnNumber: 9
        }, void 0) }, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 193,
          columnNumber: 7
        }, void 0),
        /* @__PURE__ */ p.jsxDEV($x, {}, void 0, !1, {
          fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
          lineNumber: 201,
          columnNumber: 7
        }, void 0)
      ]
    },
    void 0,
    !0,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/section-thread/index.tsx",
      lineNumber: 174,
      columnNumber: 5
    },
    void 0
  );
}, KB = (e) => /* @__PURE__ */ p.jsxDEV(nu, { children: /* @__PURE__ */ p.jsxDEV(WB, { welcomeMessage: e.welcomeMessage }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-chat-section/zai-chat-section.view.tsx",
  lineNumber: 9,
  columnNumber: 7
}, void 0) }, void 0, !1, {
  fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-chat-section/zai-chat-section.view.tsx",
  lineNumber: 8,
  columnNumber: 5
}, void 0), QB = ({
  contextKey: e,
  threadPrompt: t,
  theme: n = "light",
  welcomeMessage: r,
  skipResponseInteraction: i
}) => {
  const { setOrigin: s, setIsProactiveMessage: a } = Mi(), o = Ve(), u = oe((E) => E?.threadListItem?.remoteId), { getCurrentThreadId: c, setCurrentThreadId: l, getLastPrompt: d, setLastPrompt: h } = EE(), { shouldRender: m } = FB({
    contextKey: e,
    threadPrompt: t,
    skipResponseInteraction: i,
    mixpanelSetOrigin: s,
    mixpanelSetIsProactiveMessage: a,
    currentAssistUiThreadId: u,
    currentSectionThreadId: c(e),
    setCurrentSectionThreadId: l,
    getLastSentPrompt: d,
    setLastSentPrompt: h,
    assistRuntime: o
  });
  return m ? /* @__PURE__ */ p.jsxDEV(
    "div",
    {
      className: `zai-chat-package ${n}`,
      style: { flex: 1, minHeight: 0, width: "100%", display: "flex", flexDirection: "column", position: "relative" },
      children: /* @__PURE__ */ p.jsxDEV(zd, { theme: n, children: /* @__PURE__ */ p.jsxDEV(nd, { theme: n, children: /* @__PURE__ */ p.jsxDEV(KB, { welcomeMessage: r }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-chat-section/index.tsx",
        lineNumber: 50,
        columnNumber: 11
      }, void 0) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-chat-section/index.tsx",
        lineNumber: 49,
        columnNumber: 9
      }, void 0) }, void 0, !1, {
        fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-chat-section/index.tsx",
        lineNumber: 48,
        columnNumber: 7
      }, void 0)
    },
    void 0,
    !1,
    {
      fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-chat-section/index.tsx",
      lineNumber: 44,
      columnNumber: 5
    },
    void 0
  ) : null;
}, bF = (e) => {
  const { assistantUiIsReady: t } = St();
  return t ? /* @__PURE__ */ p.jsxDEV(QB, { ...e }, void 0, !1, {
    fileName: "/Users/vinicius.miasato/Winnin/winnin/projects/repos/frontend_insights/packages/zai-chat/src/components/zai-chat-section/index.tsx",
    lineNumber: 62,
    columnNumber: 10
  }, void 0) : null;
};
export {
  bp as ZAI_CHAT_FILE_COUNT_REFETCH_EVENT,
  AB as ZAI_CHAT_MODAL_INFO_OPEN_EVENT,
  TB as ZAI_CHAT_MODAL_UPLOAD_OPEN_EVENT,
  mF as ZaiChatAccessProvider,
  pF as ZaiChatCenterStage,
  bF as ZaiChatSection,
  gF as ZaiChatSideChat
};
//# sourceMappingURL=index.js.map
